/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * Används för för anläggningsgrupp
 */
export enum TEDARAnlGruppANVANDS_FOREnum {
  ANLAGGNINGSTILLGANGAR = "ANLAGGNINGSTILLGANGAR",
  FORBRUKNINGSINVENTARIER = "FORBRUKNINGSINVENTARIER",
  KYRKLIGA_INVENTARIER = "KYRKLIGA_INVENTARIER",
}

/**
 * Avstämning  mellan anläggningstillgångar och investeringskonton för anläggningsgrupp
 */
export enum TEDARAnlGruppAVST_INVKONTOEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Internränta, urvalsprincip för urval investeringsrader
 */
export enum TEDARAnlGruppInvUrvalINTRANTA_URVALEnum {
  ANGE_URVAL_I_FORVAG = "ANGE_URVAL_I_FORVAG",
  ANGE_URVAL_VID_BERAKNING = "ANGE_URVAL_VID_BERAKNING",
  BERAKNA_INTERNRANTA_PA_ALLT = "BERAKNA_INTERNRANTA_PA_ALLT",
  BERAKNA_INTE_INTERNRANTA = "BERAKNA_INTE_INTERNRANTA",
  ENDAST_BEGR_VERKSAMHET_OCH_SKATTEPLIKTIG_VERKSAMHET = "ENDAST_BEGR_VERKSAMHET_OCH_SKATTEPLIKTIG_VERKSAMHET",
}

/**
 * Registrera belopp för åtgärdskod
 */
export enum TEDARAtgardskodREG_BELOPPEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Avyttr/utrangeringstyp för investeringshändelse
 */
export enum TEDARAvrakningAVYTTR_UTRANG_TYPEnum {
  ENDAST_INVESTERINGEN = "ENDAST_INVESTERINGEN",
  HELA_ANLAGGNINGSTILLGANGEN = "HELA_ANLAGGNINGSTILLGANGEN",
}

/**
 * Avräkningstyp för investeringshändelse
 */
export enum TEDARAvrakningTypEnum {
  BOKFAVSKR = "BOKFAVSKR",
  BOKFAVYTTR = "BOKFAVYTTR",
  BOKFNEDSKR = "BOKFNEDSKR",
  DELNING = "DELNING",
  OMKLASSAVR = "OMKLASSAVR",
  OVERFORD = "OVERFORD",
  REGAVSKR = "REGAVSKR",
  REGAVYTTR = "REGAVYTTR",
  REGNEDSKR = "REGNEDSKR",
}

/**
 * Anläggningstillgång (J/N) för huvudrubrik
 */
export enum TEDARHuvudRubrikANLAGGNTILLGEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Registrering av åtgärder för huvudrubrik
 */
export enum TEDARHuvudRubrikATGARDEREnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Status för investeringsrad
 */
export enum TEDARInvesteringsradSTATUSEnum {
  AKTIVERAD_PAG__INVESTERING = "AKTIVERAD_PAG__INVESTERING",
  ATERFORD = "ATERFORD",
  FORBRUKNINGSINVENTARIE = "FORBRUKNINGSINVENTARIE",
  FRAN_AKTIVERING = "FRAN_AKTIVERING",
  FRAN_OMBOKFORD_PAG__INVESTERING = "FRAN_OMBOKFORD_PAG__INVESTERING",
  MAKULERAD = "MAKULERAD",
  OMBOKFORD_INVESTERINGSRAD = "OMBOKFORD_INVESTERINGSRAD",
  OMBOKFORD_PAG__INVESTERING = "OMBOKFORD_PAG__INVESTERING",
}

/**
 * Typ för investeringsrad
 */
export enum TEDARInvesteringsradTypEnum {
  KONTINVRAD = "KONTINVRAD",
  PROJINVRAD = "PROJINVRAD",
  REGINVRAD = "REGINVRAD",
}

/**
 * Används i Anläggningsredovisning för område/Byggnad/Rum
 */
export enum TEDARPlatsANVANDS_I_AREnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Fastighetstyp för område/Byggnad/Rum
 */
export enum TEDARPlatsFASTIGHETSTYPEnum {
  ADMINISTRATIONSBYGGNAD = "ADMINISTRATIONSBYGGNAD",
  ANDAKTSRUM = "ANDAKTSRUM",
  BARHUS = "BARHUS",
  BEGRAVNINGSPLATS = "BEGRAVNINGSPLATS",
  BISATTNINGSRUM = "BISATTNINGSRUM",
  BOSTADSHUS = "BOSTADSHUS",
  BYGDEGARD_BYSTUGA = "BYGDEGARD_BYSTUGA",
  CEREMONIRUM_CEREMONIHALL = "CEREMONIRUM_CEREMONIHALL",
  CYKELPARKERING = "CYKELPARKERING",
  FLERBOSTADSHUS = "FLERBOSTADSHUS",
  FORRADSBYGGNAD = "FORRADSBYGGNAD",
  FORSAMLINGSHEM = "FORSAMLINGSHEM",
  FORSKOLEBYGGNAD = "FORSKOLEBYGGNAD",
  FRIGGEBOD = "FRIGGEBOD",
  GARAGE = "GARAGE",
  GRAVKOR_MAUSOLEUM = "GRAVKOR_MAUSOLEUM",
  HOTELL = "HOTELL",
  JORDBRUKSMARK = "JORDBRUKSMARK",
  JORDKALLARE = "JORDKALLARE",
  KALLSORTERINGSHUS = "KALLSORTERINGSHUS",
  KLOCKSTAPEL = "KLOCKSTAPEL",
  KOLUMBARIUM = "KOLUMBARIUM",
  KREMATORIUM = "KREMATORIUM",
  KURSGARD = "KURSGARD",
  KYRKA_KAPELL = "KYRKA_KAPELL",
  KYRKOGARDSMUR = "KYRKOGARDSMUR",
  KYRKORUM_KYRKSAL_KAPELLRUM = "KYRKORUM_KYRKSAL_KAPELLRUM",
  KYRKSTUGA = "KYRKSTUGA",
  KYRKTOMT = "KYRKTOMT",
  LAGERGARD = "LAGERGARD",
  LEKPLATS = "LEKPLATS",
  LEKSTUGA = "LEKSTUGA",
  MUSEUM = "MUSEUM",
  OMKOPPLINGSSTATION = "OMKOPPLINGSSTATION",
  ORDENSLOKAL = "ORDENSLOKAL",
  PARKERINGSPLATS = "PARKERINGSPLATS",
  PARKMARK = "PARKMARK",
  PERSONALBYGGNAD = "PERSONALBYGGNAD",
  PRASTGARD = "PRASTGARD",
  RADIOMAST = "RADIOMAST",
  RESTAURANG = "RESTAURANG",
  SAMLINGSLOKAL = "SAMLINGSLOKAL",
  SKARMTAK = "SKARMTAK",
  SKOGSMARK = "SKOGSMARK",
  SKOLBYGGNAD = "SKOLBYGGNAD",
  SKOLGARD = "SKOLGARD",
  SKORSTENSANLAGGNING = "SKORSTENSANLAGGNING",
  SKYDDSBYGGNAD = "SKYDDSBYGGNAD",
  STIFTSGARD = "STIFTSGARD",
  TEKNIKBOD = "TEKNIKBOD",
  TOALETT = "TOALETT",
  TRADGARD = "TRADGARD",
  VAKTMASTERI = "VAKTMASTERI",
  VANDRARHEM = "VANDRARHEM",
  VATTEN = "VATTEN",
  VAXTHUS = "VAXTHUS",
  VERKSTAD = "VERKSTAD",
}

/**
 * Typ av plats för område/Byggnad/Rum
 */
export enum TEDARPlatsTypEnum {
  BYGGNAD = "BYGGNAD",
  OMRADE = "OMRADE",
  RUM = "RUM",
}

/**
 * Hantera skattemässiga värden för rubrik
 */
export enum TEDARRubrikSKATTEMASSIGEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Avyttringstyp för skattemässig investeringshändelse
 */
export enum TEDARSKVAvrakningAVYTTR_UTRANG_TYPEnum {
  ENDAST_INVESTERINGEN = "ENDAST_INVESTERINGEN",
  HELA_ANLAGGNINGSTILLGANGEN = "HELA_ANLAGGNINGSTILLGANGEN",
}

/**
 * Typ för skattemässig investeringshändelse
 */
export enum TEDARSKVAvrakningTypEnum {
  SKVDELNING = "SKVDELNING",
  SKVNORMALAVSKR = "SKVNORMALAVSKR",
  SKVREGAVSKR = "SKVREGAVSKR",
  SKVREGAVYTTR = "SKVREGAVYTTR",
  SKVREGKORRIGERING = "SKVREGKORRIGERING",
  SKVREGNEDSKR = "SKVREGNEDSKR",
  SKVREGUTRANG = "SKVREGUTRANG",
}

/**
 * Anläggningstillgång (J/N) för anläggningstillgång/Inventarie
 */
export enum TEDARTillgangANLAGGNTILLGEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Ändrad i för anläggningstillgång/Inventarie
 */
export enum TEDARTillgangANLKATDATA1_ANDRAD_FRANEnum {
  ANLAGGNINGSREGISTRET = "ANLAGGNINGSREGISTRET",
  WEBINVENTERINGEN = "WEBINVENTERINGEN",
}

/**
 * Ändrad i för anläggningstillgång/Inventarie
 */
export enum TEDARTillgangANLKATDATA2_ANDRAD_FRANEnum {
  ANLAGGNINGSREGISTRET = "ANLAGGNINGSREGISTRET",
  WEBINVENTERINGEN = "WEBINVENTERINGEN",
}

/**
 * Ändrad i för anläggningstillgång/Inventarie
 */
export enum TEDARTillgangANLKATDATA3_ANDRAD_FRANEnum {
  ANLAGGNINGSREGISTRET = "ANLAGGNINGSREGISTRET",
  WEBINVENTERINGEN = "WEBINVENTERINGEN",
}

/**
 * Ändrad i för anläggningstillgång/Inventarie
 */
export enum TEDARTillgangANLKATDATA4_ANDRAD_FRANEnum {
  ANLAGGNINGSREGISTRET = "ANLAGGNINGSREGISTRET",
  WEBINVENTERINGEN = "WEBINVENTERINGEN",
}

/**
 * Ändrad i för anläggningstillgång/Inventarie
 */
export enum TEDARTillgangANLKATDATA5_ANDRAD_FRANEnum {
  ANLAGGNINGSREGISTRET = "ANLAGGNINGSREGISTRET",
  WEBINVENTERINGEN = "WEBINVENTERINGEN",
}

/**
 * Ändrad i för anläggningstillgång/Inventarie
 */
export enum TEDARTillgangANLKATDATA6_ANDRAD_FRANEnum {
  ANLAGGNINGSREGISTRET = "ANLAGGNINGSREGISTRET",
  WEBINVENTERINGEN = "WEBINVENTERINGEN",
}

/**
 * Ändrad i för anläggningstillgång/Inventarie
 */
export enum TEDARTillgangANLKATDATA7_ANDRAD_FRANEnum {
  ANLAGGNINGSREGISTRET = "ANLAGGNINGSREGISTRET",
  WEBINVENTERINGEN = "WEBINVENTERINGEN",
}

/**
 * Ändrad i för anläggningstillgång/Inventarie
 */
export enum TEDARTillgangANLKATDATA8_ANDRAD_FRANEnum {
  ANLAGGNINGSREGISTRET = "ANLAGGNINGSREGISTRET",
  WEBINVENTERINGEN = "WEBINVENTERINGEN",
}

/**
 * Ändrad i för aRTillgangBlob
 */
export enum TEDARTillgangBlobBESKR_ANDRAD_FRANEnum {
  ANLAGGNINGSREGISTRET = "ANLAGGNINGSREGISTRET",
  WEBINVENTERINGEN = "WEBINVENTERINGEN",
}

/**
 * Typ av ändring för anläggningstillgång, logg
 */
export enum TEDARTillgangLoggANDRINGSTYPEnum {
  AVSKRIVNINGSTID = "AVSKRIVNINGSTID",
  BYTE_INVESTERINGSKONTO = "BYTE_INVESTERINGSKONTO",
  HANTERA_SKATTEMASSIGA_VARDEN = "HANTERA_SKATTEMASSIGA_VARDEN",
  INVESTERING_FLYTTAD = "INVESTERING_FLYTTAD",
  SAMMANSLAGNING = "SAMMANSLAGNING",
  SKATTEMASSIG_AVSKRIVNINGSTID = "SKATTEMASSIG_AVSKRIVNINGSTID",
  SKATTEMASSIG_INGAENDE_AVSKRIVNINGSTID = "SKATTEMASSIG_INGAENDE_AVSKRIVNINGSTID",
}

/**
 * Avskrivningstyp för investering
 */
export enum TEDARUpprakningAVSKRIVNTYPEnum {
  AVSKRIVS_EJ = "AVSKRIVS_EJ",
  KOSTNADSFORD = "KOSTNADSFORD",
  NORMAL_AVSKRIVNING = "NORMAL_AVSKRIVNING",
}

/**
 * Ändrad i för investering
 */
export enum TEDARUpprakningBESKR_ANDRAD_FRANEnum {
  ANLAGGNINGSREGISTRET = "ANLAGGNINGSREGISTRET",
  WEBINVENTERINGEN = "WEBINVENTERINGEN",
}

/**
 * Hantera skattemässiga värden för investering
 */
export enum TEDARUpprakningSKV_SKATTEMASSIGA_VARDENEnum {
  EJ_DEFINIERAT = "EJ_DEFINIERAT",
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Uppräkningstyp för investering
 */
export enum TEDARUpprakningTypEnum {
  DELADINVESTERING = "DELADINVESTERING",
  INGINVESTERING = "INGINVESTERING",
  INVESTERING = "INVESTERING",
  OMKLASSUPPR = "OMKLASSUPPR",
  SAMMANSLAGENINVESTERING = "SAMMANSLAGENINVESTERING",
  UPPSKRIVNING = "UPPSKRIVNING",
}

/**
 * Typ av testkund
 */
export enum TEDAvenyDatabaseTestkundTypeEnum {
  BETA = "BETA",
  NORMAL = "NORMAL",
  RELEASE = "RELEASE",
  TEST = "TEST",
}

/**
 * Typ av avenydatabas
 */
export enum TEDAvenyDatabaseTypeEnum {
  AUTOTESTS = "AUTOTESTS",
  AVENYSTDBASPF = "AVENYSTDBASPF",
  AVENYSTDPASTFORSAML = "AVENYSTDPASTFORSAML",
  GASBAS = "GASBAS",
  GASBASSTIFTELSE = "GASBASSTIFTELSE",
  GASLOKALKUND = "GASLOKALKUND",
  GASNORMAL = "GASNORMAL",
  GASPASTFORSAMLHIST = "GASPASTFORSAMLHIST",
  GASSTIFTELSE = "GASSTIFTELSE",
  GASSTIFTELSEHIST = "GASSTIFTELSEHIST",
  GASSTIFTELSELOKKUND = "GASSTIFTELSELOKKUND",
  GASUTB = "GASUTB",
  GASUTBSTIFTELSE = "GASUTBSTIFTELSE",
  KONVERTERING = "KONVERTERING",
  OVR = "OVR",
  OVRBOLAG = "OVRBOLAG",
  OVRHIST = "OVRHIST",
  OVRPASTFORSAML = "OVRPASTFORSAML",
  OVRPASTFORSHIST = "OVRPASTFORSHIST",
  OVRPLT = "OVRPLT",
  OVRSTIFT = "OVRSTIFT",
  OVRSTIFTBAS = "OVRSTIFTBAS",
  OVRSTIFTELSE = "OVRSTIFTELSE",
  OVRSTIFTELSEHIST = "OVRSTIFTELSEHIST",
  OVRUTB = "OVRUTB",
}

/**
 * Anmälnings status för deltagare
 */
export enum TEDBOAktDeltagarANMALAN_STATUSEnum {
  ANMALAN_AVVISAD = "ANMALAN_AVVISAD",
  ANMALAN_BEKRAFTAD = "ANMALAN_BEKRAFTAD",
  AVANMALD = "AVANMALD",
  DEFINITIVT_AVANMALD = "DEFINITIVT_AVANMALD",
  PRELIMINART_ANMALD = "PRELIMINART_ANMALD",
}

/**
 * Status för deltagare
 */
export enum TEDBOAktDeltagarSTATUSEnum {
  EJ_FAKTURERAD = "EJ_FAKTURERAD",
  FAKTURERAD = "FAKTURERAD",
}

/**
 * Anmälan kräver personnummer för aktivitet
 */
export enum TEDBOAktivitetANM_KRAV_PERSNREnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Beställartyp för aktivitet
 */
export enum TEDBOAktivitetBESTALLARE_TYPEnum {
  ANHORIG = "ANHORIG",
  ANNAN_ORGANISATION = "ANNAN_ORGANISATION",
  ANNAN_PERSON = "ANNAN_PERSON",
  BEGRAVNINGSBYRA = "BEGRAVNINGSBYRA",
  PERSON_1 = "PERSON_1",
  PERSON_2 = "PERSON_2",
  VARDNADSHAVARE_1 = "VARDNADSHAVARE_1",
  VARDNADSHAVARE_2 = "VARDNADSHAVARE_2",
}

/**
 * Enskilt dop för aktivitet
 */
export enum TEDBOAktivitetENSKILT_DOPEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Fakturera deltagare för aktivitet
 */
export enum TEDBOAktivitetFAKTDELTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Ingår i predikotur för aktivitet
 */
export enum TEDBOAktivitetINGAR_PREDIKOTUREnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Kremering/Jordbegravning för aktivitet
 */
export enum TEDBOAktivitetKREMERINGEnum {
  JORDBEGRAVNING = "JORDBEGRAVNING",
  KREMERING = "KREMERING",
}

/**
 * Status för order per aktivitet
 */
export enum TEDBOAktivitetOrderSTATUSEnum {
  EJ_FAKTURERAD = "EJ_FAKTURERAD",
  FAKTURERAD = "FAKTURERAD",
}

/**
 * Publiceringsstatus för aktivitet
 */
export enum TEDBOAktivitetPUBL_STATUSEnum {
  AVVAKTA = "AVVAKTA",
  PUBLICERAS = "PUBLICERAS",
  PUBLICERAS_EJ = "PUBLICERAS_EJ",
  PUBLICERAS_FOR_ANMALNING = "PUBLICERAS_FOR_ANMALNING",
  SKAPAD = "SKAPAD",
}

/**
 * Redan kremerad för aktivitet
 */
export enum TEDBOAktivitetREDAN_KREMERADEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Intern spridningstyp för aktivitet
 */
export enum TEDBOAktivitetSKK_SPRIDNINGSTYP_INTERNEnum {
  INOMKYRKLIG = "INOMKYRKLIG",
  INTERN = "INTERN",
  SEMIINTERN = "SEMIINTERN",
}

/**
 * Statistik status för aktivitet
 */
export enum TEDBOAktivitetStatistikStatusEnum {
  DET_AR_MINDRE_AN_7_DAGAR_KVAR_ATT_RAPPORTERA_STATISTIK_PA_AKTIVITETEN = "DET_AR_MINDRE_AN_7_DAGAR_KVAR_ATT_RAPPORTERA_STATISTIK_PA_AKTIVITETEN",
  MISSLYCKAD_EXPORT__KONTROLLERA_BOKNINGEN = "MISSLYCKAD_EXPORT__KONTROLLERA_BOKNINGEN",
  SISTA_RAPPORTERINGSDAG_HAR_PASSERAT = "SISTA_RAPPORTERINGSDAG_HAR_PASSERAT",
  SKA_RAPPORTERAS = "SKA_RAPPORTERAS",
  STATISTIK_EXPORTERAD = "STATISTIK_EXPORTERAD",
  STATISTIK_RAPPORTERAD = "STATISTIK_RAPPORTERAD",
}

/**
 * Aktivitetstyp för aktivitet
 */
export enum TEDBOAktivitetTypEnum {
  AKTOVRIGT = "AKTOVRIGT",
  BEGRAVNING = "BEGRAVNING",
  DOP = "DOP",
  GRAVSATTNING = "GRAVSATTNING",
  GUDSTJANST = "GUDSTJANST",
  KONFIRMATION = "KONFIRMATION",
  LOKALUTHYRNING = "LOKALUTHYRNING",
  OUTLOOK = "OUTLOOK",
  PLANERING = "PLANERING",
  SNABBOKNING = "SNABBOKNING",
  VIGSEL = "VIGSEL",
}

/**
 * Vigselordning för aktivitet
 */
export enum TEDBOAktivitetVIGSELORDNINGEnum {
  ANNAN_ORDNING = "ANNAN_ORDNING",
  SVENSKA_KYRKANS_ORDNING = "SVENSKA_KYRKANS_ORDNING",
  VALSIGNELSE_OVER_INGANGET_AKTENSKAP = "VALSIGNELSE_OVER_INGANGET_AKTENSKAP",
  VALSIGNELSE_OVER_REGISTRERAT_PARTNERSKAP = "VALSIGNELSE_OVER_REGISTRERAT_PARTNERSKAP",
}

/**
 * Web beställning för aktivitet
 */
export enum TEDBOAktivitetWEB_PUBL_STATUSEnum {
  BESTALLD = "BESTALLD",
  KOMPLETTERA = "KOMPLETTERA",
  MOTTAGEN = "MOTTAGEN",
  PUBLICERAD = "PUBLICERAD",
  PUBLICERAS_EJ = "PUBLICERAS_EJ",
}

/**
 * Aktiv för aktivitetstyp
 */
export enum TEDBOAktivitetstypAKTIVEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Anhöriga närvarande (gravsättning) för aktivitetstyp
 */
export enum TEDBOAktivitetstypAN_NARVARANDEEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Sätta om utskriftsstatus för aktivitetstyp
 */
export enum TEDBOAktivitetstypSKRIVAUTPANYTTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Stora tecken på titelraden för aktivitetstyp
 */
export enum TEDBOAktivitetstypSTORSTIL_TITELEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Varna jordbegravning/kremering för aktivitetstyp
 */
export enum TEDBOAktivitetstypVARNA_JORD_KREMEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Typ av clearing för begravningsordning
 */
export enum TEDBOBegravningstypCLEARINGSTYPEnum {
  BEGRAVNINGSCLEARING = "BEGRAVNINGSCLEARING",
  EJ_CLEARING = "EJ_CLEARING",
}

/**
 * Typ för bevakning
 */
export enum TEDBOBevakningTypEnum {
  ANVANDARE = "ANVANDARE",
  BOKNGRUPP = "BOKNGRUPP",
}

/**
 * Direktkremation beställd för bisättningsjournal
 */
export enum TEDBOBisattningBEST_DIREKTKREMATIONEnum {
  AKT_MED_URNA = "AKT_MED_URNA",
  INGEN_CEREMONI = "INGEN_CEREMONI",
  KREMERING_EFTER_CEREMONI = "KREMERING_EFTER_CEREMONI",
}

/**
 * Kremering för bisättningsjournal
 */
export enum TEDBOBisattningKREMERINGEnum {
  JORDBEGRAVNING = "JORDBEGRAVNING",
  KREMERING = "KREMERING",
  OBESTAMD = "OBESTAMD",
}

/**
 * Typ för bisättningsjournal kontakt
 */
export enum TEDBOBisattningKontaktTypEnum {
  BISATTNINGSKONTAKTANHORIG = "BISATTNINGSKONTAKTANHORIG",
  BISATTNINGSKONTAKTANNAN = "BISATTNINGSKONTAKTANNAN",
  BISATTNINGSKONTAKTBYRA = "BISATTNINGSKONTAKTBYRA",
  BISATTNINGSKONTAKTORG = "BISATTNINGSKONTAKTORG",
  BISATTNINGSKONTAKTPERSON = "BISATTNINGSKONTAKTPERSON",
  BISATTNINGSKONTAKTTRANSPORTOR = "BISATTNINGSKONTAKTTRANSPORTOR",
  BISATTNINGSKONTAKTTRANSPORTORPERSON = "BISATTNINGSKONTAKTTRANSPORTORPERSON",
}

/**
 * Status för kremationsbeställning
 */
export enum TEDBOBisattningKremBestSTATUSEnum {
  BESTALLD = "BESTALLD",
  MOTTAGEN = "MOTTAGEN",
  REFUSERAD = "REFUSERAD",
}

/**
 * Implantat med batteri för bisättningsjournal
 */
export enum TEDBOBisattningPACEMAKEREnum {
  FINNS = "FINNS",
  FINNS_EJ = "FINNS_EJ",
}

/**
 * Typ av händelse för bisättningshändelse
 */
export enum TEDBOBisattningshandelseTypEnum {
  BISATTNINGSHANDELSEAVS = "BISATTNINGSHANDELSEAVS",
  BISATTNINGSHANDELSEBEST = "BISATTNINGSHANDELSEBEST",
  BISATTNINGSHANDELSEIN = "BISATTNINGSHANDELSEIN",
  BISATTNINGSHANDELSEREG = "BISATTNINGSHANDELSEREG",
  BISATTNINGSHANDELSETOM = "BISATTNINGSHANDELSETOM",
  BISATTNINGSHANDELSEUT = "BISATTNINGSHANDELSEUT",
}

/**
 * Gravsättningstyp för beställning
 */
export enum TEDBOBoknBestallningGRAVSATTNINGS_TYPEnum {
  ASKGRAVLUND = "ASKGRAVLUND",
  ASKGRAVPLATS = "ASKGRAVPLATS",
  EJ_BESTAMD = "EJ_BESTAMD",
  EJ_GRAVPLATS = "EJ_GRAVPLATS",
  JORDBEGRAVNING = "JORDBEGRAVNING",
  KREMERING = "KREMERING",
  MINNESLUND = "MINNESLUND",
  URNSATTNING = "URNSATTNING",
}

/**
 * Kod (typ av bokning) för bokningsrubrik
 */
export enum TEDBOBokningsrubrikKODEnum {
  ENDAGSBOKNING = "ENDAGSBOKNING",
  FLERDAGSBOKNING = "FLERDAGSBOKNING",
  UPPREPAD_BOKNING__DATUM_OCH_TIDSINTERVALL_ = "UPPREPAD_BOKNING__DATUM_OCH_TIDSINTERVALL_",
}

/**
 * Aktuella priser för fakturaunderlag
 */
export enum TEDBOFaktOmgAKTUELLAPRISEREnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Faktureringssätt för fakturaunderlag
 */
export enum TEDBOFaktOmgFAKTURERINGSSATTEnum {
  FAKTURA = "FAKTURA",
  KOB = "KOB",
}

/**
 * Val av förfallodatum för fakturaunderlag
 */
export enum TEDBOFaktOmgFORFALLOTYPEnum {
  ANGE_FORFALLODATUM = "ANGE_FORFALLODATUM",
  ENLIGT_BETALNINGSVILLKOR = "ENLIGT_BETALNINGSVILLKOR",
}

/**
 * Förrättningstyp för fakturaunderlag
 */
export enum TEDBOFaktOmgFORRATTNINGSTYPEnum {
  BEGRAVNING = "BEGRAVNING",
  DOP = "DOP",
  KONFIRMATION = "KONFIRMATION",
  OVRIGT = "OVRIGT",
  STATLIG_CLEARING = "STATLIG_CLEARING",
  VIGSEL = "VIGSEL",
}

/**
 * Kod för fakturaunderlagsrad
 */
export enum TEDBOFaktOmgOrdradRADKODEnum {
  BOKNINGSRUBRIK = "BOKNINGSRUBRIK",
  FRISTAENDE = "FRISTAENDE",
}

/**
 * Typ för fakturaunderlagsrad
 */
export enum TEDBOFaktOmgOrdradTypEnum {
  FAKTOMGARTIKEL = "FAKTOMGARTIKEL",
  FAKTOMGTEXT = "FAKTOMGTEXT",
}

/**
 * Status för fakturaunderlag
 */
export enum TEDBOFaktOmgSTATUSEnum {
  EJ_ORDER_SKAPAD = "EJ_ORDER_SKAPAD",
  ORDER_SKAPAD = "ORDER_SKAPAD",
}

/**
 * Ansvarig för behörighet
 */
export enum TEDBOGruppBehorighetANSVARIGEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Typ av gruppanvändare för behörighet
 */
export enum TEDBOGruppBehorighetTypEnum {
  GRUPPBEHANVANDARE = "GRUPPBEHANVANDARE",
  GRUPPBEHGRUPP = "GRUPPBEHGRUPP",
  GRUPPBEHMEDLEM = "GRUPPBEHMEDLEM",
}

/**
 * Visa fullst. personnummer för grupp
 */
export enum TEDBOGruppOPVISA_PERSNREnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Huvudgudstjänst för gudstjänsttyp
 */
export enum TEDBOGudstjansttypHUVUDGUDSTJANSTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Ingår i predikotur för gudstjänsttyp
 */
export enum TEDBOGudstjansttypINGARPREDIKOTUREnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Närvarande för närvaro
 */
export enum TEDBONarvaroNARVARANDEEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Borttagen för resursrubrik
 */
export enum TEDBOResrubrikBORTTAGENEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Begravningslokal för resurs
 */
export enum TEDBOResursBEGRAVNINGSPLATSEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Bokningsbar för resurs
 */
export enum TEDBOResursBOKNINGSBAREnum {
  FRITT = "FRITT",
  NORMAL = "NORMAL",
  PRIVAT = "PRIVAT",
}

/**
 * Egen kyrkogård för resurs
 */
export enum TEDBOResursEGEN_KGARDEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * E-post på bokningsbekräftelsen för resurs
 */
export enum TEDBOResursEPOSTPAUTSKRIFTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Status för resurs
 */
export enum TEDBOResursSTATUSEnum {
  AKTUELL = "AKTUELL",
  EJ_AKTUELL = "EJ_AKTUELL",
  VISAS_EJ_I_KALENDERN = "VISAS_EJ_I_KALENDERN",
}

/**
 * Telefonnummer på bokningsbekräftelse för resurs
 */
export enum TEDBOResursTELEFONPAUTSKRIFTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Varning vid dubbelbokning för resurs
 */
export enum TEDBOResursVARNING_DUBBELBOKNINGEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Webbokningsbar för resurs
 */
export enum TEDBOResursWEBBOKNINGSBAREnum {
  FRITT = "FRITT",
  NORMAL = "NORMAL",
  PRIVAT = "PRIVAT",
  VISAS_EJ = "VISAS_EJ",
  WEBFRI = "WEBFRI",
}

/**
 * Avbokningsbekräftelse för aktivitetstyp (bokningsgrupp)
 */
export enum TEDBOTEDBOAkttypBokngruppAVBOKNINGSBEKRAFTELSEEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Kyrkliga helgdagar på bokningsbekräftelsen för aktivitetstyp (bokningsgrupp)
 */
export enum TEDBOTEDBOAkttypBokngruppKYRKLIGHELGUTSKRIFTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Signatur på bokningsbekräftelse för aktivitetstyp (bokningsgrupp)
 */
export enum TEDBOTEDBOAkttypBokngruppSIGNATUREnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Sluttid för aktivitetstyp (bokningsgrupp)
 */
export enum TEDBOTEDBOAkttypBokngruppSLUTTIDEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Statistikuppgift för aktivitetstyp (bokningsgrupp)
 */
export enum TEDBOTEDBOAkttypBokngruppSTATISTIKUPPGIFTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Typ av medlem för medlem
 */
export enum TEDBOTEDBOGruppmedlemOPTypEnum {
  GRUPPMEDLEMGRUPP = "GRUPPMEDLEMGRUPP",
  GRUPPMEDLEMOP = "GRUPPMEDLEMOP",
}

/**
 * Annonseras för verksamhetstyp
 */
export enum TEDBOVerksamhetstyperANNONSERASEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Logiskt borttagen för verksamhetstyp
 */
export enum TEDBOVerksamhetstyperBORTTAGENEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Statistikuppgift för verksamhetstyp
 */
export enum TEDBOVerksamhetstyperSTATISTIKUPPGIFTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Kombinerad, används för för kodbehörighet
 */
export enum TEDEKAnvKontobegrKOMBINERAD_ANVANDS_FOREnum {
  BALANS = "BALANS",
  BLANDAT = "BLANDAT",
  EJ_DEFINIERAT = "EJ_DEFINIERAT",
  HELA_HUVUDBOKEN = "HELA_HUVUDBOKEN",
  RESULTAT = "RESULTAT",
}

/**
 * Automatkontera vidare för automatkontering, mall
 */
export enum TEDEKAutomatkontMallAUTOMATKONTERA_VIDAREEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Radtyp för automatkontering, mall
 */
export enum TEDEKAutomatkontMallRADTYPEnum {
  INGAENDE_MOMS = "INGAENDE_MOMS",
  KORREKTIVKONTO__UTAN_MOMSKOD = "KORREKTIVKONTO__UTAN_MOMSKOD",
  OMSATTNINGSKONTO__MED_MOMSKOD = "OMSATTNINGSKONTO__MED_MOMSKOD",
  UTGAENDE_MOMS = "UTGAENDE_MOMS",
}

/**
 * Aktiv för automatkontering
 */
export enum TEDEKAutomatkonteringarAKTIVEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Används för för automatkontering
 */
export enum TEDEKAutomatkonteringarANVANDS_FOREnum {
  BOKFORT_VARDE = "BOKFORT_VARDE",
  BUDGET = "BUDGET",
}

/**
 * Fördelningstyp för automatkontering
 */
export enum TEDEKAutomatkonteringarFORDELNINGSTYPEnum {
  FORDELNING = "FORDELNING",
  PALAGG = "PALAGG",
}

/**
 * Fördela alltid 100 % för automatkontering
 */
export enum TEDEKAutomatkonteringarHUNDRA_PROCENTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Fördela för automatkontering
 */
export enum TEDEKAutomatkonteringarSALDO_FORDELAEnum {
  AKTUEL_BOKF_PERIOD = "AKTUEL_BOKF_PERIOD",
  HITTILLS_I_AR = "HITTILLS_I_AR",
}

/**
 * Typ för automatkontering
 */
export enum TEDEKAutomatkonteringarTypEnum {
  FORDELNINGSMALLAUTOMATKONTERING = "FORDELNINGSMALLAUTOMATKONTERING",
  INTERNFORDELNINGAUTOMATKONTERING = "INTERNFORDELNINGAUTOMATKONTERING",
  SALDOAUTOMATKONTERING = "SALDOAUTOMATKONTERING",
  TRANSAKTIONAUTOMATKONTERING = "TRANSAKTIONAUTOMATKONTERING",
  UTLANDSKMOMSAUTOMATKONTERING = "UTLANDSKMOMSAUTOMATKONTERING",
}

/**
 * Status för journal
 */
export enum TEDEKBokfjournalSTATUSEnum {
  BACKAD = "BACKAD",
  BOKFORINGSUNDERLAG_SKAPAT = "BOKFORINGSUNDERLAG_SKAPAT",
  DEFINITIVBOKFORD = "DEFINITIVBOKFORD",
  FELAKTIG_JOURNAL__SKALL_BACKAS = "FELAKTIG_JOURNAL__SKALL_BACKAS",
  KONVERTERAD = "KONVERTERAD",
  LAST = "LAST",
  SKAPAD = "SKAPAD",
}

/**
 * Typ för journal
 */
export enum TEDEKBokfjournalTypEnum {
  BOKFJOURNAL = "BOKFJOURNAL",
  ERBJUDANDEJOURNAL = "ERBJUDANDEJOURNAL",
  KONVJOURNAL = "KONVJOURNAL",
  PERIODJOURNAL = "PERIODJOURNAL",
}

/**
 * Motkontokod för verifikationsrad
 */
export enum TEDEKBokfkonteringMOTKONTO_KODEnum {
  ATERFORING_AV_AVSKRIVNINGAR = "ATERFORING_AV_AVSKRIVNINGAR",
  ATERFORING_AV_INVESTERINGAR = "ATERFORING_AV_INVESTERINGAR",
  ATERFORING_AV_NEDSKRIVNINGAR = "ATERFORING_AV_NEDSKRIVNINGAR",
  DEBETKONTO_VID_AVSKRIVNING = "DEBETKONTO_VID_AVSKRIVNING",
  INGAENDE_MOMSKONTO = "INGAENDE_MOMSKONTO",
  INTAKT_FRAN_FORSALJNING = "INTAKT_FRAN_FORSALJNING",
  INVESTERINGSKONTO_SOM_OMBOKFORS = "INVESTERINGSKONTO_SOM_OMBOKFORS",
  KREDITKONTO_VID_AVSKRIVNING = "KREDITKONTO_VID_AVSKRIVNING",
  LEVERANTORSSKULDER = "LEVERANTORSSKULDER",
  MOTKONTO_TILL_INTAKTSKONTO = "MOTKONTO_TILL_INTAKTSKONTO",
  PRELIMINARKONTO_VID_ANKOMSTREGISTRERING = "PRELIMINARKONTO_VID_ANKOMSTREGISTRERING",
  REALISATIONSVINST_FORLUST = "REALISATIONSVINST_FORLUST",
}

/**
 * Föregående status innan bokföring för bokföringsorder
 */
export enum TEDEKBokforderINNAN_BOKF_STATUSEnum {
  ATTESTERAD = "ATTESTERAD",
  ATTEST_ANVANDS_EJ = "ATTEST_ANVANDS_EJ",
  PA_VAG_TILL_BETALNING = "PA_VAG_TILL_BETALNING",
}

/**
 * Avsändartyp för bokföringsorder, meddelande
 */
export enum TEDEKBokforderMeddelandeAVSANDAR_TYPEnum {
  FRAN_ATTESTANT = "FRAN_ATTESTANT",
  FRAN_BESTALLARE = "FRAN_BESTALLARE",
  FRAN_EKONOM = "FRAN_EKONOM",
}

/**
 * Min bokf.order status för bokföringsorder
 */
export enum TEDEKBokforderMinBokforderStatusEnum {
  ATTESTERAD__ATTESTANT_ = "ATTESTERAD__ATTESTANT_",
  ATTESTERAD__BESTALLARE_ = "ATTESTERAD__BESTALLARE_",
  ATTESTERAD__HOS_ANNAN_ATTESTANT = "ATTESTERAD__HOS_ANNAN_ATTESTANT",
  ATTESTERAS__HOS_ATTESTANT = "ATTESTERAS__HOS_ATTESTANT",
  ATT_ATTESTERA = "ATT_ATTESTERA",
  ATT_KONTROLLATTESTERA = "ATT_KONTROLLATTESTERA",
  BORTTAGEN__BESTALLARE_ = "BORTTAGEN__BESTALLARE_",
  DEFINITIVBOKFORD__ATTESTANT_ = "DEFINITIVBOKFORD__ATTESTANT_",
  DEFINITIVBOKFORD__BESTALLARE_ = "DEFINITIVBOKFORD__BESTALLARE_",
  EJ_GODKAND_AV_ATTESTANT = "EJ_GODKAND_AV_ATTESTANT",
  KONTROLLATTESTERAD__ATTESTANT_ = "KONTROLLATTESTERAD__ATTESTANT_",
  PA_VAG_TILL_BETALNING = "PA_VAG_TILL_BETALNING",
  UTKAST = "UTKAST",
  VERIFIKATION_KORRIGERAD__ATTESTANT_ = "VERIFIKATION_KORRIGERAD__ATTESTANT_",
  VERIFIKATION_KORRIGERAD__BESTALLARE_ = "VERIFIKATION_KORRIGERAD__BESTALLARE_",
  VERIFIKATION_SKAPAD__ATTESTANT_ = "VERIFIKATION_SKAPAD__ATTESTANT_",
  VERIFIKATION_SKAPAD__BESTALLARE_ = "VERIFIKATION_SKAPAD__BESTALLARE_",
}

/**
 * Omföringstyp för bokföringsorder
 */
export enum TEDEKBokforderOMFORINGSTYPEnum {
  KOPIERA = "KOPIERA",
  OMBOKFOR = "OMBOKFOR",
  PERIODISERA = "PERIODISERA",
  UNDEFINED = "UNDEFINED",
  VAND = "VAND",
}

/**
 * Kontering, använd rad för bokföringsorder, rad
 */
export enum TEDEKBokforderRadKONT_USE_ROWEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Likvidsätt för bokföringsorder, rad
 */
export enum TEDEKBokforderRadLIKVIDSATTEnum {
  BANK_KONTANT = "BANK_KONTANT",
  KASSA_KONTANT = "KASSA_KONTANT",
  KORT = "KORT",
  SKAP_KONTANT = "SKAP_KONTANT",
  SWISH = "SWISH",
}

/**
 * Periodiseras för bokföringsorder, rad
 */
export enum TEDEKBokforderRadPERIODISERADEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Status för bokföringsorder
 */
export enum TEDEKBokforderSTATUSEnum {
  ATTESTERAD = "ATTESTERAD",
  ATTEST_ANVANDS_EJ = "ATTEST_ANVANDS_EJ",
  BORTTAGEN = "BORTTAGEN",
  EJ_GODKAND = "EJ_GODKAND",
  PA_VAG_TILL_BETALNING = "PA_VAG_TILL_BETALNING",
  SKAPAD = "SKAPAD",
  UTKAST = "UTKAST",
  VANTAR_PA_ATTEST = "VANTAR_PA_ATTEST",
  VERIFIKATION_SKAPAD = "VERIFIKATION_SKAPAD",
}

/**
 * Typ för bokföringsorder
 */
export enum TEDEKBokforderTYPEnum {
  BOKFORINGSORDER = "BOKFORINGSORDER",
  UTANORDNING = "UTANORDNING",
}

/**
 * Utbetalningskategori för bokföringsorder
 */
export enum TEDEKBokforderU_UTBETALNINGSKATEGORIEnum {
  BANKKONTO = "BANKKONTO",
  KONTANT = "KONTANT",
  PGBG = "PGBG",
  SWISH = "SWISH",
  TILLOGODO = "TILLOGODO",
}

/**
 * Variant för bokföringsorder
 */
export enum TEDEKBokforderVariantEnum {
  KOPIERA = "KOPIERA",
  MALL = "MALL",
  OMBOKFOR = "OMBOKFOR",
  PERIODISERA = "PERIODISERA",
  TOM = "TOM",
  UTANORDINGBANKONTO = "UTANORDINGBANKONTO",
  UTANORDINGKONTANT = "UTANORDINGKONTANT",
  UTANORDINGPGBG = "UTANORDINGPGBG",
  UTANORDNINGTILLGODO = "UTANORDNINGTILLGODO",
  VAND = "VAND",
}

/**
 * Föreslå bokföringsdatum för bokföringsmall, parameter
 */
export enum TEDEKBokforingsmallParamFORESLA_BOKFDATUMEnum {
  FORESLA_INTE = "FORESLA_INTE",
  NASTA_DAG = "NASTA_DAG",
  NASTKOMMANDE_VARDAG = "NASTKOMMANDE_VARDAG",
  SAMMA_DAG = "SAMMA_DAG",
}

/**
 * Datatyp för bokföringsmall, parameter
 */
export enum TEDEKBokforingsmallParamPARAM_DATATYPEnum {
  BELOPP = "BELOPP",
  DATUM__AAAA_MM_DD_ = "DATUM__AAAA_MM_DD_",
  DECIMALTAL = "DECIMALTAL",
  HELTAL = "HELTAL",
  TEXT = "TEXT",
}

/**
 * Debet/Kredit för bokföringsmall, rad
 */
export enum TEDEKBokforingsmallRadDEB_KREDEnum {
  DEBET = "DEBET",
  KREDIT = "KREDIT",
}

/**
 * @KONTO1@, användning för bokföringsmall, rad
 */
export enum TEDEKBokforingsmallRadMALL_TYP_1Enum {
  BANK_KONTANT = "BANK_KONTANT",
  KASSA_KONTANT = "KASSA_KONTANT",
  KORT = "KORT",
  SKAP_KONTANT = "SKAP_KONTANT",
  SWISH = "SWISH",
}

/**
 * @KONTO10@, villkor för bokföringsmall, rad
 */
export enum TEDEKBokforingsmallRadVILLKOR_10Enum {
  FAR_ANGES = "FAR_ANGES",
  FAR_EJ_ANGES = "FAR_EJ_ANGES",
  MASTE_ANGES = "MASTE_ANGES",
}

/**
 * @KONTO1@, villkor för bokföringsmall, rad
 */
export enum TEDEKBokforingsmallRadVILLKOR_1Enum {
  FAR_ANGES = "FAR_ANGES",
  FAR_EJ_ANGES = "FAR_EJ_ANGES",
  MASTE_ANGES = "MASTE_ANGES",
}

/**
 * @KONTO2@, villkor för bokföringsmall, rad
 */
export enum TEDEKBokforingsmallRadVILLKOR_2Enum {
  FAR_ANGES = "FAR_ANGES",
  FAR_EJ_ANGES = "FAR_EJ_ANGES",
  MASTE_ANGES = "MASTE_ANGES",
}

/**
 * @KONTO3@, villkor för bokföringsmall, rad
 */
export enum TEDEKBokforingsmallRadVILLKOR_3Enum {
  FAR_ANGES = "FAR_ANGES",
  FAR_EJ_ANGES = "FAR_EJ_ANGES",
  MASTE_ANGES = "MASTE_ANGES",
}

/**
 * @KONTO4@, villkor för bokföringsmall, rad
 */
export enum TEDEKBokforingsmallRadVILLKOR_4Enum {
  FAR_ANGES = "FAR_ANGES",
  FAR_EJ_ANGES = "FAR_EJ_ANGES",
  MASTE_ANGES = "MASTE_ANGES",
}

/**
 * @KONTO5@, villkor för bokföringsmall, rad
 */
export enum TEDEKBokforingsmallRadVILLKOR_5Enum {
  FAR_ANGES = "FAR_ANGES",
  FAR_EJ_ANGES = "FAR_EJ_ANGES",
  MASTE_ANGES = "MASTE_ANGES",
}

/**
 * @KONTO6@, villkor för bokföringsmall, rad
 */
export enum TEDEKBokforingsmallRadVILLKOR_6Enum {
  FAR_ANGES = "FAR_ANGES",
  FAR_EJ_ANGES = "FAR_EJ_ANGES",
  MASTE_ANGES = "MASTE_ANGES",
}

/**
 * @KONTO7@, villkor för bokföringsmall, rad
 */
export enum TEDEKBokforingsmallRadVILLKOR_7Enum {
  FAR_ANGES = "FAR_ANGES",
  FAR_EJ_ANGES = "FAR_EJ_ANGES",
  MASTE_ANGES = "MASTE_ANGES",
}

/**
 * @KONTO8@, villkor för bokföringsmall, rad
 */
export enum TEDEKBokforingsmallRadVILLKOR_8Enum {
  FAR_ANGES = "FAR_ANGES",
  FAR_EJ_ANGES = "FAR_EJ_ANGES",
  MASTE_ANGES = "MASTE_ANGES",
}

/**
 * @KONTO9@, villkor för bokföringsmall, rad
 */
export enum TEDEKBokforingsmallRadVILLKOR_9Enum {
  FAR_ANGES = "FAR_ANGES",
  FAR_EJ_ANGES = "FAR_EJ_ANGES",
  MASTE_ANGES = "MASTE_ANGES",
}

/**
 * Definitivbokförd för verifikation
 */
export enum TEDEKBokfverI_HUVUDBOKEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Verifikationskategori för verifikation
 */
export enum TEDEKBokfverVERKAT_KODEnum {
  AR_AKTIVERA_PAGAENDE_INVESTERINGAR = "AR_AKTIVERA_PAGAENDE_INVESTERINGAR",
  AR_AVYTTRING_UTRANGERING_OMKLASSIFICERING = "AR_AVYTTRING_UTRANGERING_OMKLASSIFICERING",
  AR_BOKFOR_AVSKRIVNINGAR = "AR_BOKFOR_AVSKRIVNINGAR",
  AR_BOKFOR_INTERNRANTA = "AR_BOKFOR_INTERNRANTA",
  AR_BYT_INVESTERINGSKONTO = "AR_BYT_INVESTERINGSKONTO",
  AR_MAKULERA_AKTIVERING_AV_PAG__INVESTERINGAR = "AR_MAKULERA_AKTIVERING_AV_PAG__INVESTERINGAR",
  AR_MAKULERA_OMBOKFORING_AV_PAG__INVESTERINGAR_INVESTERINGSRADER = "AR_MAKULERA_OMBOKFORING_AV_PAG__INVESTERINGAR_INVESTERINGSRADER",
  AR_MAKULERA_SENASTE_BOKFORDA_HANDELSEN = "AR_MAKULERA_SENASTE_BOKFORDA_HANDELSEN",
  AR_NEDSKRIVNING = "AR_NEDSKRIVNING",
  AR_OMBOKFOR_PAG__INVESTERINGAR_INVESTERINGSRADER = "AR_OMBOKFOR_PAG__INVESTERINGAR_INVESTERINGSRADER",
  AR_OMKLASSIFICERING = "AR_OMKLASSIFICERING",
  BJ_FAKTURERA_BISATTNINGAR = "BJ_FAKTURERA_BISATTNINGAR",
  BO_FAKTURERA_AKTIVITETER = "BO_FAKTURERA_AKTIVITETER",
  EK_AVSLUTA_PROJEKT = "EK_AVSLUTA_PROJEKT",
  EK_BOKFORINGSFIL_FRAN_KOB = "EK_BOKFORINGSFIL_FRAN_KOB",
  EK_BOKFOR_OMFORDELNING = "EK_BOKFOR_OMFORDELNING",
  EK_BOKFOR_OM_ANDAMALSBESTAMDA_MEDEL = "EK_BOKFOR_OM_ANDAMALSBESTAMDA_MEDEL",
  EK_BOKFOR_OM_LON = "EK_BOKFOR_OM_LON",
  EK_BOKFOR_OM_MOMSSKULD = "EK_BOKFOR_OM_MOMSSKULD",
  EK_IMPORT_ENLIGT_SIE = "EK_IMPORT_ENLIGT_SIE",
  EK_INLASNING_AV_LONEVERIFIKATIONER = "EK_INLASNING_AV_LONEVERIFIKATIONER",
  EK_INTERNFORDELNING_FRAN_LON = "EK_INTERNFORDELNING_FRAN_LON",
  EK_KOLLEKTFIL_FRAN_KOB = "EK_KOLLEKTFIL_FRAN_KOB",
  EK_PERIODISERA_VERIFIKATIONER = "EK_PERIODISERA_VERIFIKATIONER",
  EK_VERIFIKATIONSREGISTRERING = "EK_VERIFIKATIONSREGISTRERING",
  GA_AVRAKNA_AVRAKNINGSAVTAL = "GA_AVRAKNA_AVRAKNINGSAVTAL",
  GA_AVRAKNA_FASTTIDSAVTAL = "GA_AVRAKNA_FASTTIDSAVTAL",
  GA_FAKTURERA_GRAVSKOTSELAVTAL = "GA_FAKTURERA_GRAVSKOTSELAVTAL",
  GA_FAKTURERA_GRAVSKOTSLAR = "GA_FAKTURERA_GRAVSKOTSLAR",
  GA_JUSTERA_SALDO_PA_AVTAL = "GA_JUSTERA_SALDO_PA_AVTAL",
  GA_KREDITERA_GRAVSKOTSLAR = "GA_KREDITERA_GRAVSKOTSLAR",
  GA_SKAPA_BESTALLNINGSORDER = "GA_SKAPA_BESTALLNINGSORDER",
  GA_UPPRAKNA_FASTTIDSAVTAL = "GA_UPPRAKNA_FASTTIDSAVTAL",
  KJ_FAKTURERA_KREMATIONER = "KJ_FAKTURERA_KREMATIONER",
  KR_ATERREDOVISNING_FRAN_AGRESSO = "KR_ATERREDOVISNING_FRAN_AGRESSO",
  KR_BERAKNA_TILLGODORANTA = "KR_BERAKNA_TILLGODORANTA",
  KR_BETALNING_AV_BANKKONTOFAKTUROR = "KR_BETALNING_AV_BANKKONTOFAKTUROR",
  KR_BETALNING_AV_INTERNFAKTUROR = "KR_BETALNING_AV_INTERNFAKTUROR",
  KR_BOKFOR_KUNDFORLUST = "KR_BOKFOR_KUNDFORLUST",
  KR_INBETALNINGAR_BG_PG = "KR_INBETALNINGAR_BG_PG",
  KR_INBETALNINGAR_KOB_OCH_AUTOGIRO = "KR_INBETALNINGAR_KOB_OCH_AUTOGIRO",
  KR_INSATTNING_PA_AVTAL = "KR_INSATTNING_PA_AVTAL",
  KR_KRAVUTSKRIFT = "KR_KRAVUTSKRIFT",
  KR_KREDITERING = "KR_KREDITERING",
  KR_MAKULERING_JUSTERING_AV_FAKTURAHANDELSER = "KR_MAKULERING_JUSTERING_AV_FAKTURAHANDELSER",
  KR_MAKULERING_JUSTERING_AV_KONTOHANDELSER = "KR_MAKULERING_JUSTERING_AV_KONTOHANDELSER",
  KR_MANUELL_INBETALNING = "KR_MANUELL_INBETALNING",
  KR_UTBETALNING_AV_TILLGODOHAVANDE = "KR_UTBETALNING_AV_TILLGODOHAVANDE",
  LR_ANKOMSTREGISTRERING = "LR_ANKOMSTREGISTRERING",
  LR_ATERREDOVISNING_AV_UTBETALNINGAR = "LR_ATERREDOVISNING_AV_UTBETALNINGAR",
  LR_BOKFOR_UTBETALNINGSUPPDRAG = "LR_BOKFOR_UTBETALNINGSUPPDRAG",
  LR_DEFINITIVBOKNING = "LR_DEFINITIVBOKNING",
  LR_FAKTURABUNT = "LR_FAKTURABUNT",
  LR_JUSTERA_BELOPP_FOR_LEVERANTORSFAKTUROR = "LR_JUSTERA_BELOPP_FOR_LEVERANTORSFAKTUROR",
  LR_MAKULERA_FAKTURAHANDELSE = "LR_MAKULERA_FAKTURAHANDELSE",
  OF_DROJSMALSRANTEFAKTURERING = "OF_DROJSMALSRANTEFAKTURERING",
  OF_FAKTURERING = "OF_FAKTURERING",
  OF_IMPORTERA_ORDERUNDERLAG = "OF_IMPORTERA_ORDERUNDERLAG",
  OF_KREDITORDER = "OF_KREDITORDER",
  OF_ORDER = "OF_ORDER",
  TI_BOKFOR_TIDRAPPORTERINGAR = "TI_BOKFOR_TIDRAPPORTERINGAR",
  WEK_BOKFORINGSORDER = "WEK_BOKFORINGSORDER",
  WOF_WEBORDER = "WOF_WEBORDER",
}

/**
 * I huvudbok för budget
 */
export enum TEDEKBudgetI_HUVUDBOKEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Periodiserad för budget
 */
export enum TEDEKBudgetPERIODISERADEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Typ för rapportrad
 */
export enum TEDEKDimensionsradTypEnum {
  BALANSRESDIMENSIONSRAD = "BALANSRESDIMENSIONSRAD",
  BUDGETRAMDIMENSIONSRAD = "BUDGETRAMDIMENSIONSRAD",
  FETLINJEDIMENSIONSRAD = "FETLINJEDIMENSIONSRAD",
  LINJEDIMENSIONSRAD = "LINJEDIMENSIONSRAD",
  RAPPORTDIMENSIONSRAD = "RAPPORTDIMENSIONSRAD",
  SIDBRYTNINGDIMENSIONSRAD = "SIDBRYTNINGDIMENSIONSRAD",
  SUMMADIMENSIONSRAD = "SUMMADIMENSIONSRAD",
  TEXTDIMENSIONSRAD = "TEXTDIMENSIONSRAD",
}

/**
 * Har utgått - Används för (balans/resultat) för ekonomirapport
 */
export enum TEDEKEkonomirapportANVANDS_FOREnum {
  BALANS = "BALANS",
  BLANDAT = "BLANDAT",
  EJ_DEFINIERAT = "EJ_DEFINIERAT",
  HELA_HUVUDBOKEN = "HELA_HUVUDBOKEN",
  RESULTAT = "RESULTAT",
}

/**
 * Används i enhetstyp för ekonomirapport
 */
export enum TEDEKEkonomirapportANVANDS_IEnum {
  ALLA = "ALLA",
  PASTORAT = "PASTORAT",
  PASTORAT__GAS = "PASTORAT__GAS",
  PASTORAT__OVRIGA = "PASTORAT__OVRIGA",
  STIFT = "STIFT",
  STIFTELSE = "STIFTELSE",
}

/**
 * Avskiljare för kolumner för ekonomirapport
 */
export enum TEDEKEkonomirapportBELOPP_SEPARATOREnum {
  INGEN = "INGEN",
  LINJER = "LINJER",
  SKUGGNING = "SKUGGNING",
}

/**
 * Utskrift av belopp för ekonomirapport
 */
export enum TEDEKEkonomirapportBELOPP_UTSKRIFTEnum {
  ANNAN = "ANNAN",
  ENLIGT_RAD = "ENLIGT_RAD",
  STANDARD = "STANDARD",
}

/**
 * Används av kontoanalys för ekonomirapport
 */
export enum TEDEKEkonomirapportKONTOANALYSEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Standardrapport för ekonomirapport
 */
export enum TEDEKEkonomirapportSTD_RAPPORTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Utdelad till alla användare för ekonomirapport
 */
export enum TEDEKEkonomirapportUTDELAD_TILL_ALLAEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Krav, skickad med posttyp för fakturahändelse (Kund o Leverantör)
 */
export enum TEDEKFakturahandelseKRAV_SKICKAD_MED_POSTTYPEnum {
  A_POST = "A_POST",
  B_POST = "B_POST",
}

/**
 * Kravstatus, fakturaväxeln för fakturahändelse (Kund o Leverantör)
 */
export enum TEDEKFakturahandelseKRAV_STATUSEnum {
  FEL = "FEL",
  SKAPAD = "SKAPAD",
  SKICKAD_TILL_FAKURAVAXELN = "SKICKAD_TILL_FAKURAVAXELN",
}

/**
 * Reskontra eller konto för fakturahändelse (Kund o Leverantör)
 */
export enum TEDEKFakturahandelseRESKONTRA_KONTOEnum {
  KUNDRESKONTRA = "KUNDRESKONTRA",
  LEVERANTORSRESKONTRA = "LEVERANTORSRESKONTRA",
  TILLGODOHAVANDE_KUND = "TILLGODOHAVANDE_KUND",
  TILLGODOHAVANDE_LEVERANTORER = "TILLGODOHAVANDE_LEVERANTORER",
}

/**
 * Händelsetyp för fakturahändelse (Kund o Leverantör)
 */
export enum TEDEKFakturahandelseTypEnum {
  AUTOMATISKBETALNING = "AUTOMATISKBETALNING",
  AUTOMATISKINSATTNING = "AUTOMATISKINSATTNING",
  AVRAKNING = "AVRAKNING",
  AVRAKNINGJUST = "AVRAKNINGJUST",
  BELOPPSKORRIGERING = "BELOPPSKORRIGERING",
  BETALNINGBANKKONTO = "BETALNINGBANKKONTO",
  BETALNINGFRANKONTO = "BETALNINGFRANKONTO",
  BETALNINGINTERNFAKTURA = "BETALNINGINTERNFAKTURA",
  BETALNINGKREDITFAKTURA = "BETALNINGKREDITFAKTURA",
  BETALNINGKUNDAVTAL = "BETALNINGKUNDAVTAL",
  FAKTMAKGRAV = "FAKTMAKGRAV",
  FAKTURAJUSTERING = "FAKTURAJUSTERING",
  FAKTURAREGISTRERING = "FAKTURAREGISTRERING",
  GODKANDDIFFERENS = "GODKANDDIFFERENS",
  INBETALNING = "INBETALNING",
  INITIERING = "INITIERING",
  INKASSO = "INKASSO",
  INSATTNINGKREDITFAKTURA = "INSATTNINGKREDITFAKTURA",
  INSATTNINGRANTA = "INSATTNINGRANTA",
  KRAV = "KRAV",
  KREDITERING = "KREDITERING",
  KUNDFORLUST = "KUNDFORLUST",
  LRANKOMSTREGISTRERING = "LRANKOMSTREGISTRERING",
  LRBELOPPSJUSTERING = "LRBELOPPSJUSTERING",
  LRBETALNINGFRANKONTO = "LRBETALNINGFRANKONTO",
  LRBETALNINGMOTUPPDRAG = "LRBETALNINGMOTUPPDRAG",
  LRDEFINITIVBOKNING = "LRDEFINITIVBOKNING",
  LRDIREKTBETALNING = "LRDIREKTBETALNING",
  LRFAKTURAREGISTRERING = "LRFAKTURAREGISTRERING",
  LRGODKANDDIFFERENS = "LRGODKANDDIFFERENS",
  LRINSATTNINGKREDITFAKTURA = "LRINSATTNINGKREDITFAKTURA",
  LRMAKULERING = "LRMAKULERING",
  LRUTTAGMOTBETALNING = "LRUTTAGMOTBETALNING",
  LRVALUTADIFFERENS = "LRVALUTADIFFERENS",
  MANUELLBETALNING = "MANUELLBETALNING",
  SKULDUPPRAKNING = "SKULDUPPRAKNING",
  SKULDUPPRJUST = "SKULDUPPRJUST",
  UTBETALNING = "UTBETALNING",
  UTTAGMOTBETALNING = "UTTAGMOTBETALNING",
  UTTAGRANTA = "UTTAGRANTA",
}

/**
 * Grupperingstyp för ekonomirapport, Radnivå
 */
export enum TEDEKGrupperingGRUPPERINGSTYPEnum {
  FASTIGHETSNR = "FASTIGHETSNR",
  FASTIGHETSTYP = "FASTIGHETSTYP",
  HUVUDPROJEKT = "HUVUDPROJEKT",
  LEVERANTOR = "LEVERANTOR",
  MOMSKOD = "MOMSKOD",
  REDOVISNINGSGRUPP = "REDOVISNINGSGRUPP",
  REDOVISNINGSKLASS = "REDOVISNINGSKLASS",
  VERKSAMHETSNIVA = "VERKSAMHETSNIVA",
  VERKSAMHETSOMRADE = "VERKSAMHETSOMRADE",
}

/**
 * Inbetalningssätt för kollektfilrad
 */
export enum TEDEKKOBKollektFilRadINBETALNINGSSATTEnum {
  KONTANT = "KONTANT",
  KORT = "KORT",
  SWISH_1 = "SWISH_1",
  SWISH_2 = "SWISH_2",
}

/**
 * Transaktionstyp för kollektfilrad
 */
export enum TEDEKKOBKollektFilRadTRANSAKTIONS_TYPEnum {
  MAKULERING = "MAKULERING",
  NORMAL = "NORMAL",
}

/**
 * Inbetalningsmetod för kollektfilstillfälle
 */
export enum TEDEKKOBKollektFilTillfalleINBETALNINGSSATTEnum {
  KONTANT = "KONTANT",
  KORT = "KORT",
  SWISH_1 = "SWISH_1",
  SWISH_2 = "SWISH_2",
}

/**
 * Insamling, typkod för kollektfilstillfälle
 */
export enum TEDEKKOBKollektFilTillfalleINSAMLING_TYP_KODEnum {
  ANSLAG = "ANSLAG",
  GAVA = "GAVA",
  INSAMLINGSAKTIVITET = "INSAMLINGSAKTIVITET",
}

/**
 * Kollekt typkod för kollektfilstillfälle
 */
export enum TEDEKKOBKollektFilTillfalleKOLLEKT_TYP_KODEnum {
  FORSAMLINGSKOLLEKT__EGNA_VERKSAMHETEN_ = "FORSAMLINGSKOLLEKT__EGNA_VERKSAMHETEN_",
  FORSAMLINGSKOLLEKT__EXTERN_KONTAKT_ = "FORSAMLINGSKOLLEKT__EXTERN_KONTAKT_",
  FORSKOLLEKT__NATIONELL_ORG_ = "FORSKOLLEKT__NATIONELL_ORG_",
  RIKSKOLLEKT = "RIKSKOLLEKT",
  STIFTSKOLLEKT = "STIFTSKOLLEKT",
}

/**
 * Mottagare, typkod för kollektfilstillfälle
 */
export enum TEDEKKOBKollektFilTillfalleMOTTAGAR_TYP_KODEnum {
  ACT_SVENSKA_KYRKAN = "ACT_SVENSKA_KYRKAN",
  EGNA_VERKSAMHETEN = "EGNA_VERKSAMHETEN",
  EXTERN_KONTAKT = "EXTERN_KONTAKT",
  SVENSKA_KYRKAN_I_UTLANDET = "SVENSKA_KYRKAN_I_UTLANDET",
}

/**
 * Status för kollektfilstillfälle
 */
export enum TEDEKKOBKollektFilTillfalleSTATUSEnum {
  BACKAD = "BACKAD",
  BOKFORINGSAR_SAKNAS = "BOKFORINGSAR_SAKNAS",
  BOKFORINGSORDERNUMMERSERIE_SAKNAS = "BOKFORINGSORDERNUMMERSERIE_SAKNAS",
  BOKFORINGSPERIOD_LAST = "BOKFORINGSPERIOD_LAST",
  BOKFORINGSPERIOD_SAKNAS = "BOKFORINGSPERIOD_SAKNAS",
  FELAKTIG = "FELAKTIG",
  HANTERAD = "HANTERAD",
  INLAST = "INLAST",
  JOURNALNUMMERSERIE_SAKNAS = "JOURNALNUMMERSERIE_SAKNAS",
  KOMPLETTERA_BOKFORINGSGRUPP = "KOMPLETTERA_BOKFORINGSGRUPP",
  KOMPLETTERA_KOB_KONTO = "KOMPLETTERA_KOB_KONTO",
  KOMPLETTERA_TRANSAKTIONSTYPER = "KOMPLETTERA_TRANSAKTIONSTYPER",
  VERIFIKATIONSNUMMERSERIE_SAKNAS = "VERIFIKATIONSNUMMERSERIE_SAKNAS",
}

/**
 * Transaktions typ för kollektfilstillfälle
 */
export enum TEDEKKOBKollektFilTillfalleTRANSAKTIONS_TYPEnum {
  MAKULERING = "MAKULERING",
  NORMAL = "NORMAL",
}

/**
 * Filens typ för kollektfilstillfälle
 */
export enum TEDEKKOBKollektFilTillfalleTYPEnum {
  INSAMLING = "INSAMLING",
  KOLLEKT = "KOLLEKT",
}

/**
 * Redovisningsgrupp för kodbegrepp
 */
export enum TEDEKKontobegreppDEF_KI_TYPEnum {
  AVSKRIVNINGAR = "AVSKRIVNINGAR",
  FINANS = "FINANS",
  INTAKTER = "INTAKTER",
  INTERNA_INTAKTER = "INTERNA_INTAKTER",
  INTERNA_KOSTNADER = "INTERNA_KOSTNADER",
  INTERNA_SKULDER = "INTERNA_SKULDER",
  INTERNA_TILLGANGAR = "INTERNA_TILLGANGAR",
  KOSTNADER = "KOSTNADER",
  ODEFINIERAD = "ODEFINIERAD",
  PERSONALKOSTNADER = "PERSONALKOSTNADER",
  SKATTER = "SKATTER",
  SKULDER = "SKULDER",
  TILLGANGAR = "TILLGANGAR",
}

/**
 * Redovisningsklass för kodbegrepp
 */
export enum TEDEKKontobegreppDEF_REDOVISNTYPEnum {
  INTERNKONTO = "INTERNKONTO",
  ODEFINIERAT = "ODEFINIERAT",
  RESULTATKONTO = "RESULTATKONTO",
  STALLNINGSKONTO = "STALLNINGSKONTO",
}

/**
 * Kombination för kodbegreppkombination
 */
export enum TEDEKKontobegreppkombinationKOMBINATIONEnum {
  FAR_EJ_KOMBINERAS = "FAR_EJ_KOMBINERAS",
  FAR_KOMBINERAS = "FAR_KOMBINERAS",
  MASTE_KOMBINERAS = "MASTE_KOMBINERAS",
}

/**
 * Åtgärdsnivå för koddel
 */
export enum TEDEKKontodelATGARD_KATEnum {
  EJ_DEFINIERAD = "EJ_DEFINIERAD",
  LOKAL_ATGARDSNIVA = "LOKAL_ATGARDSNIVA",
  STANDARD_ATGARDSNIVA = "STANDARD_ATGARDSNIVA",
}

/**
 * Verksamhetsnivå för koddel
 */
export enum TEDEKKontodelKB_VERKSAMHETEnum {
  K101_VERKSAMHETSGEMENSAMT = "K101_VERKSAMHETSGEMENSAMT",
  K110_GUDSTJANSTER_OCH_KYRKLIGA_HANDLINGAR = "K110_GUDSTJANSTER_OCH_KYRKLIGA_HANDLINGAR",
  K140_UNDERVISNING = "K140_UNDERVISNING",
  K210_DIAKONAL_VERKSAMHET = "K210_DIAKONAL_VERKSAMHET",
  K260_MISSION = "K260_MISSION",
  K310_OVRIG_FORSAMLINGSVERKSAMHET = "K310_OVRIG_FORSAMLINGSVERKSAMHET",
  K360_SERVICEVERKSAMHET = "K360_SERVICEVERKSAMHET",
  K380_INOMKYRKLIGT_TILLHANDAHALLANDE = "K380_INOMKYRKLIGT_TILLHANDAHALLANDE",
  K410_SKATTEPLIKTIG_RORELSE = "K410_SKATTEPLIKTIG_RORELSE",
  K510_STRATEGISK_STYRNING = "K510_STRATEGISK_STYRNING",
  K580_VERKSAMHETSLEDNING = "K580_VERKSAMHETSLEDNING",
  K610_FORSAMLINGSADMINISTRATION_OCH_VERKSAMHETSSTOD = "K610_FORSAMLINGSADMINISTRATION_OCH_VERKSAMHETSSTOD",
  K630_GEMENSAMMA_KOSTNADER_OCH_ADMINISTRATION = "K630_GEMENSAMMA_KOSTNADER_OCH_ADMINISTRATION",
  K650_FASTIGHETER_OCH_LOKALER = "K650_FASTIGHETER_OCH_LOKALER",
  K690_FINANSIELLA_POSTER = "K690_FINANSIELLA_POSTER",
  K801_VERKSAMHETSGEMENSAMT = "K801_VERKSAMHETSGEMENSAMT",
  K810_ADMINISTRATION_OCH_LEDNING = "K810_ADMINISTRATION_OCH_LEDNING",
  K820_GRAVSATTNING_OCH_KYRKOGARDSSKOTSEL = "K820_GRAVSATTNING_OCH_KYRKOGARDSSKOTSEL",
  K840_KREMATORIUM = "K840_KREMATORIUM",
  K860_FASTIGHETER_OCH_MARK = "K860_FASTIGHETER_OCH_MARK",
  K890_INOMKYRKLIGT_TILLHANDAHALLANDE_INOM_BV = "K890_INOMKYRKLIGT_TILLHANDAHALLANDE_INOM_BV",
}

/**
 * Verksamhetsområde för koddel
 */
export enum TEDEKKontodelKB_VERKSOMREnum {
  K0_OVRIGT = "K0_OVRIGT",
  K1_GRUNDLAGGANDE_UPPGIFT = "K1_GRUNDLAGGANDE_UPPGIFT",
  K3_OVRIG_KYRKLIG_VERKSAMHET = "K3_OVRIG_KYRKLIG_VERKSAMHET",
  K5_STYRNING_OCH_LEDNING = "K5_STYRNING_OCH_LEDNING",
  K6_STODJANDE_VERKSAMHET = "K6_STODJANDE_VERKSAMHET",
  K7_OVRIGT = "K7_OVRIGT",
  K8_BEGRAVNINGSVERKSAMHET = "K8_BEGRAVNINGSVERKSAMHET",
  K9_OVRIGT = "K9_OVRIGT",
}

/**
 * Redovisningsgrupp för koddel
 */
export enum TEDEKKontodelKI_TYPEnum {
  AVSKRIVNINGAR = "AVSKRIVNINGAR",
  FINANS = "FINANS",
  INTAKTER = "INTAKTER",
  INTERNA_INTAKTER = "INTERNA_INTAKTER",
  INTERNA_KOSTNADER = "INTERNA_KOSTNADER",
  INTERNA_SKULDER = "INTERNA_SKULDER",
  INTERNA_TILLGANGAR = "INTERNA_TILLGANGAR",
  KOSTNADER = "KOSTNADER",
  ODEFINIERAD = "ODEFINIERAD",
  PERSONALKOSTNADER = "PERSONALKOSTNADER",
  SKATTER = "SKATTER",
  SKULDER = "SKULDER",
  TILLGANGAR = "TILLGANGAR",
}

/**
 * Kontotyp för koddel
 */
export enum TEDEKKontodelKONTOTYPEnum {
  INKOMSTER_INTAKTER = "INKOMSTER_INTAKTER",
  ODEFINIERAD = "ODEFINIERAD",
  SKULDER_EGET_KAPITAL = "SKULDER_EGET_KAPITAL",
  TILLGANGAR = "TILLGANGAR",
  UTGIFTER_KOSTNADER = "UTGIFTER_KOSTNADER",
}

/**
 * Redovisningsklass för koddel
 */
export enum TEDEKKontodelREDOVISN_TYPEnum {
  INTERNKONTO = "INTERNKONTO",
  ODEFINIERAT = "ODEFINIERAT",
  RESULTATKONTO = "RESULTATKONTO",
  STALLNINGSKONTO = "STALLNINGSKONTO",
}

/**
 * Standardkonto för koddel
 */
export enum TEDEKKontodelSTANDARDKONTOEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Verksamhetskategori för koddel
 */
export enum TEDEKKontodelVERKS_KATEnum {
  EJ_DEFINIERAD = "EJ_DEFINIERAD",
  FRIVILLIG_AKTIVITETSTNIVA = "FRIVILLIG_AKTIVITETSTNIVA",
  FRIVILLIG_DELVERKSAMHET = "FRIVILLIG_DELVERKSAMHET",
  OBLIGATORISK_GRUNDNIVA = "OBLIGATORISK_GRUNDNIVA",
}

/**
 * Används för för koddelsdefinition
 */
export enum TEDEKKontodeldefANVANDS_FOREnum {
  ANSVARSOMRADE = "ANSVARSOMRADE",
  ATGARD = "ATGARD",
  GAVOR = "GAVOR",
  OBJEKT = "OBJEKT",
}

/**
 * Beräknad för koddelsdefinition
 */
export enum TEDEKKontodeldefBERAKNADEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Kontoplanbyte, importsätt för koddelsdefinition
 */
export enum TEDEKKontodeldefKPLANBYTE_IMPORTSATTEnum {
  ENLIGT_KONTODEL = "ENLIGT_KONTODEL",
  ENLIGT_RECEPT = "ENLIGT_RECEPT",
  MANUELLT = "MANUELLT",
}

/**
 * Projekt för koddelsdefinition
 */
export enum TEDEKKontodeldefPROJEKTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Stiftelse för koddelsdefinition
 */
export enum TEDEKKontodeldefSTIFTELSEEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Verksamhet för koddelsdefinition
 */
export enum TEDEKKontodeldefVERKSAMHETEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Kombination för koddelkombination
 */
export enum TEDEKKontodelkombinationKOMBINATIONEnum {
  FAR_EJ_KOMBINERAS = "FAR_EJ_KOMBINERAS",
  FAR_KOMBINERAS = "FAR_KOMBINERAS",
  MASTE_KOMBINERAS = "MASTE_KOMBINERAS",
}

/**
 * Typ av kontoplan för kodplan
 */
export enum TEDEKKontoplanTYPEnum {
  EUBAS = "EUBAS",
  KYRKBAS = "KYRKBAS",
  STIFT = "STIFT",
  STIFTELSE = "STIFTELSE",
}

/**
 * Lokal användning för lokal kontoanvändning
 */
export enum TEDEKLokalKontoanvandningMALL_TYPEnum {
  BANK_KONTANT = "BANK_KONTANT",
  KASSA_KONTANT = "KASSA_KONTANT",
  KOB_KONTO = "KOB_KONTO",
  KORT = "KORT",
  SKAP_KONTANT = "SKAP_KONTANT",
  SWISH = "SWISH",
}

/**
 * Integrationstyp för löneart
 */
export enum TEDEKLoneartINTEGRATIONSTYPEnum {
  FLEX = "FLEX",
  HOGIA = "HOGIA",
  HRM_SYSTEMS = "HRM_SYSTEMS",
  VISMA_HR_PLUS = "VISMA_HR_PLUS",
}

/**
 * Används för för ekonomirapport används för
 */
export enum TEDEKRappAnvForANVANDS_FOREnum {
  BALANS = "BALANS",
  BLANDAT = "BLANDAT",
  HELA_HUVUDBOKEN = "HELA_HUVUDBOKEN",
  RESULTAT = "RESULTAT",
}

/**
 * Typ för ekonomirapport, Dimension
 */
export enum TEDEKRapportDimensionTypEnum {
  RAPPORTDIMENSIONBUDGETERINGLOPANDE = "RAPPORTDIMENSIONBUDGETERINGLOPANDE",
  RAPPORTDIMENSIONBUDGETERINGSMODELL = "RAPPORTDIMENSIONBUDGETERINGSMODELL",
  RAPPORTDIMENSIONBUDGETERINGSUNDERLAG = "RAPPORTDIMENSIONBUDGETERINGSUNDERLAG",
  RAPPORTDIMENSIONLOPANDE = "RAPPORTDIMENSIONLOPANDE",
  RAPPORTDIMENSIONRADDRIVEN = "RAPPORTDIMENSIONRADDRIVEN",
  RAPPORTDIMENSIONSAMMANSATT = "RAPPORTDIMENSIONSAMMANSATT",
}

/**
 * Bas för ekonomirapport, Kolumn
 */
export enum TEDEKRapportFaltBASEnum {
  KRONOR = "KRONOR",
  MILJONTALS_KRONOR = "MILJONTALS_KRONOR",
  TUSENTALS_KRONOR = "TUSENTALS_KRONOR",
}

/**
 * Urval budgettyp för ekonomirapport, Kolumn
 */
export enum TEDEKRapportFaltBUDGET_TYPEnum {
  ALLA = "ALLA",
  SPECIFIK_BUDGET = "SPECIFIK_BUDGET",
  SPECIFIK_BUDGETTYP = "SPECIFIK_BUDGETTYP",
}

/**
 * Fälttyp för ekonomirapport, Kolumn
 */
export enum TEDEKRapportFaltFALT_TYPEnum {
  ANTAL = "ANTAL",
  DEBET = "DEBET",
  KREDIT = "KREDIT",
  SALDO = "SALDO",
}

/**
 * Intervalltyp för ekonomirapport, Kolumn
 */
export enum TEDEKRapportFaltINTERVALL_TYPEnum {
  DATUM = "DATUM",
  PERIOD = "PERIOD",
}

/**
 * Resultattyp för ekonomirapport, Kolumn
 */
export enum TEDEKRapportFaltRESULTAT_TYPEnum {
  BELOPP = "BELOPP",
  PROCENT = "PROCENT",
}

/**
 * Kolumntyp för ekonomirapport, Kolumn
 */
export enum TEDEKRapportFaltTYPEnum {
  BERAKNAD = "BERAKNAD",
  ENKEL = "ENKEL",
  PROCENTUELL_FORDELNING = "PROCENTUELL_FORDELNING",
}

/**
 * Används för för ekonomirapport, Sidhuvud
 */
export enum TEDEKRapportHuvudANVANDS_FOREnum {
  BUDGET = "BUDGET",
  EKONOMI = "EKONOMI",
  TIDREDOVISNING = "TIDREDOVISNING",
}

/**
 * Format för ekonomirapport, Sidhuvud
 */
export enum TEDEKRapportHuvudFORMATEnum {
  LIGGANDE = "LIGGANDE",
  STAENDE = "STAENDE",
}

/**
 * Typ för sidhuvud, fält
 */
export enum TEDEKRapportHuvudFaltTypEnum {
  RAPPORTHUVUDBILDFALT = "RAPPORTHUVUDBILDFALT",
  RAPPORTHUVUDFORMFALT = "RAPPORTHUVUDFORMFALT",
  RAPPORTHUVUDTEXTFALT = "RAPPORTHUVUDTEXTFALT",
}

/**
 * Stående/Liggande för rapportmall
 */
export enum TEDEKRapportMallFORMATEnum {
  LIGGANDE_A4 = "LIGGANDE_A4",
  STAENDE_A4 = "STAENDE_A4",
}

/**
 * Layout för rapportmall
 */
export enum TEDEKRapportMallLAYOUTEnum {
  STANDARDLAYOUT = "STANDARDLAYOUT",
}

/**
 * Typ för kolumnspecifikation
 */
export enum TEDEKRapportfaltSpecTypEnum {
  RAPPORTFALTSPECFALT = "RAPPORTFALTSPECFALT",
  RAPPORTFALTSPECKONSTANT = "RAPPORTFALTSPECKONSTANT",
  RAPPORTFALTSPECOPERATOR = "RAPPORTFALTSPECOPERATOR",
}

/**
 * Distribueringssätt för rapportpaket
 */
export enum TEDEKRapportpaketDISTR_SATTEnum {
  E_POST = "E_POST",
  UTSKRIFT = "UTSKRIFT",
  WEBAVENY_EKONOMI = "WEBAVENY_EKONOMI",
}

/**
 * Sortering för rapportpaket
 */
export enum TEDEKRapportpaketMED_SORTERINGEnum {
  ETT_MAIL_PER_ANVANDARE = "ETT_MAIL_PER_ANVANDARE",
  ETT_MAIL_PER_RAPPORT = "ETT_MAIL_PER_RAPPORT",
  ETT_MAIL_PER_RAPPORT_ANVANDARE = "ETT_MAIL_PER_RAPPORT_ANVANDARE",
}

/**
 * Typ för rapportradsspecifikation
 */
export enum TEDEKRapportradsspecTypEnum {
  RAPPORTRADSPECCELLREF = "RAPPORTRADSPECCELLREF",
  RAPPORTRADSPECKONSTANT = "RAPPORTRADSPECKONSTANT",
  RAPPORTRADSPECOPERATOR = "RAPPORTRADSPECOPERATOR",
  RAPPORTRADSPECREFERENS = "RAPPORTRADSPECREFERENS",
  RAPPORTRADSPECURVAL = "RAPPORTRADSPECURVAL",
}

/**
 * Detaljnivå för utdelad rapport
 */
export enum TEDEKUtdeladRapportDETALJNIVA_BOKFEnum {
  JOURNAL = "JOURNAL",
  KONTERING = "KONTERING",
  VERIFIKATION = "VERIFIKATION",
}

/**
 * Budgetdetaljnivå för utdelad rapport
 */
export enum TEDEKUtdeladRapportDETALJNIVA_BUDGEnum {
  BUDGET = "BUDGET",
  KONTERING = "KONTERING",
  VERIFIKATION = "VERIFIKATION",
}

/**
 * Tillåt detaljrader för utdelad rapport
 */
export enum TEDEKUtdeladRapportDETALJRADEREnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Distribuera rapport detaljerad för utdelad rapport
 */
export enum TEDEKUtdeladRapportDISTRDETALJERADEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Typ för prenumerant
 */
export enum TEDEKUtdeladRapportPrenTYPEnum {
  ANVANDARE = "ANVANDARE",
  E_POSTADRESS = "E_POSTADRESS",
}

/**
 * Sidbrytning kan anges för utdelad rapport
 */
export enum TEDEKUtdeladRapportSIDBRYTNINGEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Utdelningstyp för utdelad rapport
 */
export enum TEDEKUtdeladRapportUTDELNINGSTYPEnum {
  EKONOMISK_ANALYS = "EKONOMISK_ANALYS",
  RAPPORT = "RAPPORT",
}

/**
 * Status för arbetsunderlag
 */
export enum TEDGAArbUndSTATUSEnum {
  BACKAD = "BACKAD",
  SKAPAD = "SKAPAD",
  UTSKRIVEN = "UTSKRIVEN",
}

/**
 * Typ av avtal för ej skuldfört avtal
 */
export enum TEDGAAvtalTYPEnum {
  ALLFRAMTIDSAVTAL = "ALLFRAMTIDSAVTAL",
  EJ_SKULDF__FASTTIDSAVTAL = "EJ_SKULDF__FASTTIDSAVTAL",
}

/**
 * Aktuell gravplats, Upplåtelsestatus för grav/Annan ort
 */
export enum TEDGAGravAktuellGravStatusEnum {
  EJ_UPPLATEN = "EJ_UPPLATEN",
  FINNS_EJ_MER = "FINNS_EJ_MER",
  KAN_EJ_UPPLATAS = "KAN_EJ_UPPLATAS",
  UPPLATEN = "UPPLATEN",
}

/**
 * Status för stenkontroll
 */
export enum TEDGAGravKontrollSTATUSEnum {
  EJ_ATGARDAD = "EJ_ATGARDAD",
  GODKAND = "GODKAND",
  NEDLAGD = "NEDLAGD",
  OVRIGT = "OVRIGT",
  STOTTAD = "STOTTAD",
}

/**
 * Gravplatstyp för grav/Annan ort
 */
export enum TEDGAGravTypEnum {
  ANNANORT = "ANNANORT",
  ASKGRAVLUND = "ASKGRAVLUND",
  GRAVPLATSAKTUELL = "GRAVPLATSAKTUELL",
  GRAVPLATSATERLAMNAD = "GRAVPLATSATERLAMNAD",
  GRAVPLATSATERTAGEN = "GRAVPLATSATERTAGEN",
  MINNESLUND = "MINNESLUND",
}

/**
 * Upplåtelsestatus för grav/Annan ort
 */
export enum TEDGAGravUPL_STATUSEnum {
  BEGRANSAD_GRAVRATT = "BEGRANSAD_GRAVRATT",
  EJ_UPPLATEN = "EJ_UPPLATEN",
  FINNS_EJ_MER = "FINNS_EJ_MER",
  KAN_EJ_UPPLATAS = "KAN_EJ_UPPLATAS",
  UPPLATEN = "UPPLATEN",
}

/**
 * Senaste vanvårdsmarkering för grav/Annan ort
 */
export enum TEDGAGravVanvardMarkeringEnum {
  GODKAND = "GODKAND",
  GRAVRATTEN_FORVERKAD = "GRAVRATTEN_FORVERKAD",
  VANVARD_1 = "VANVARD_1",
  VANVARD_2 = "VANVARD_2",
  VANVARD_3 = "VANVARD_3",
}

/**
 * Senaste inventering för gravanordning
 */
export enum TEDGAGravanordningStenStatusEnum {
  EJ_GODKAND = "EJ_GODKAND",
  GODKAND = "GODKAND",
}

/**
 * Orsak för gravrättshistorik
 */
export enum TEDGAGravrattHistORSAKEnum {
  ANDRING = "ANDRING",
  FORLANGNING = "FORLANGNING",
  FORNYELSE = "FORNYELSE",
  TIDIGASTE_UPPLATELSE = "TIDIGASTE_UPPLATELSE",
  UPPLATELSE = "UPPLATELSE",
}

/**
 * Malltyp för gravsatt
 */
export enum TEDGAGravsattMalltypEnum {
  KISTMALL = "KISTMALL",
  KOMBINATIONSMALL = "KOMBINATIONSMALL",
  URNMALL = "URNMALL",
}

/**
 * Typ för gravsatt
 */
export enum TEDGAGravsattTypEnum {
  GRAVSATTANNANORT = "GRAVSATTANNANORT",
  GRAVSATTASKGRAVLUND = "GRAVSATTASKGRAVLUND",
  GRAVSATTGRAVPLATS = "GRAVSATTGRAVPLATS",
  GRAVSATTMINNESLUND = "GRAVSATTMINNESLUND",
}

/**
 * Publiceras för gravsatt
 */
export enum TEDGAGravsattVISA_EJ_PA_FRAMSIDANEnum {
  EJ_KLAR = "EJ_KLAR",
  PUBLICERAS = "PUBLICERAS",
  PUBLICERAS_EJ = "PUBLICERAS_EJ",
  PUBLICERAS_OM_SKYDD_UPPHOR = "PUBLICERAS_OM_SKYDD_UPPHOR",
}

/**
 * Status för händelse
 */
export enum TEDGAHandelseKLAREnum {
  ARBETSUPPGIFT = "ARBETSUPPGIFT",
  ATERRAPPORTERING = "ATERRAPPORTERING",
  KLAR = "KLAR",
  NOTERING = "NOTERING",
  UTREDNING = "UTREDNING",
}

/**
 * Typ för händelse
 */
export enum TEDGAHandelseTypEnum {
  HANDELSERAD = "HANDELSERAD",
  MANUELL = "MANUELL",
  UTSKICK = "UTSKICK",
}

/**
 * Ärende status för kontakt
 */
export enum TEDGAKontaktARENDE_STATUSEnum {
  EJ_PABORJAD = "EJ_PABORJAD",
  GRI_SAKNAS = "GRI_SAKNAS",
  INVANTAR_SVAR = "INVANTAR_SVAR",
  OVERKLAGAT = "OVERKLAGAT",
  OVERSKRIDEN_TID = "OVERSKRIDEN_TID",
  SAKNAR_MOTTAGARE = "SAKNAR_MOTTAGARE",
  SLUTFORD = "SLUTFORD",
  SVAR__GRI_ANMALAN = "SVAR__GRI_ANMALAN",
  UTRED = "UTRED",
}

/**
 * Borttagen orsak för kontakt
 */
export enum TEDGAKontaktBORTTAGEN_ORSAKEnum {
  GRAV_ATERLAMNAD_ATERTAGEN = "GRAV_ATERLAMNAD_ATERTAGEN",
}

/**
 * Process status för kontakt
 */
export enum TEDGAKontaktPROCESS_STATUSEnum {
  EJ_SKICKAT__ANMALAN = "EJ_SKICKAT__ANMALAN",
  GRI_SAKNAS = "GRI_SAKNAS",
  SKICKAT__ANMALAN = "SKICKAT__ANMALAN",
  SKICKAT__GRAVBREV = "SKICKAT__GRAVBREV",
  SKICKAT__INFO_TILL_DODSBOET = "SKICKAT__INFO_TILL_DODSBOET",
  SKICKAT__PAMINNELSE = "SKICKAT__PAMINNELSE",
}

/**
 * Typ för kontakt
 */
export enum TEDGAKontaktTypEnum {
  BETALNINGSANSVARIG = "BETALNINGSANSVARIG",
  DODSBO = "DODSBO",
  GRAVRATTSINNEHAVARE = "GRAVRATTSINNEHAVARE",
  KONTAKTOVRIG = "KONTAKTOVRIG",
}

/**
 * Typ för mall
 */
export enum TEDGAMallTYPEnum {
  KISTMALL = "KISTMALL",
  URNMALL = "URNMALL",
}

/**
 * Status för orderomgång
 */
export enum TEDGAOrderOmgSTATUSEnum {
  BACKAD = "BACKAD",
  SKAPAD = "SKAPAD",
}

/**
 * Status för årsskötsel
 */
export enum TEDGAOrderOmgSkotselSTATUSEnum {
  BACKAD = "BACKAD",
  KREDITERAD = "KREDITERAD",
  SKAPAD = "SKAPAD",
}

/**
 * Klara för arbetsunderlag för skötsel
 */
export enum TEDGASkotselArbUndStatusEnum {
  EJ_AKTUELL = "EJ_AKTUELL",
  EJ_BETALD = "EJ_BETALD",
  EJ_FAKTURERAD = "EJ_FAKTURERAD",
  EJ_PA_ARB__UND_ = "EJ_PA_ARB__UND_",
  KLAR_FOR_UTSKRIFT = "KLAR_FOR_UTSKRIFT",
  SKAPAT = "SKAPAT",
  UTSKRIVET = "UTSKRIVET",
}

/**
 * Debiteringssätt för skötsel
 */
export enum TEDGASkotselDEB_SATTEnum {
  DEBITERAS = "DEBITERAS",
  DEBITERAS_EJ = "DEBITERAS_EJ",
  EJ_SKULDFORT_AVTAL = "EJ_SKULDFORT_AVTAL",
}

/**
 * Paket för skötsel
 */
export enum TEDGASkotselPAKETEnum {
  INGAR_I_PAKET = "INGAR_I_PAKET",
  PAKET = "PAKET",
}

/**
 * Senaste vanvårdsmarkering för vanvårdsmarkering
 */
export enum TEDGAVanvardLastMarkeringEnum {
  GODKAND = "GODKAND",
  GRAVRATTEN_FORVERKAD = "GRAVRATTEN_FORVERKAD",
  VANVARD_AR_1 = "VANVARD_AR_1",
  VANVARD_AR_2 = "VANVARD_AR_2",
  VANVARD_AR_3 = "VANVARD_AR_3",
}

/**
 * Vanvårdsmarkering för vanvårdsmarkering
 */
export enum TEDGAVanvardVANVARDSMARKERINGEnum {
  GODKAND = "GODKAND",
  GRAVRATTEN_FORVERKAD = "GRAVRATTEN_FORVERKAD",
  VANVARD_1 = "VANVARD_1",
  VANVARD_2 = "VANVARD_2",
  VANVARD_3 = "VANVARD_3",
}

/**
 * Gravsatt för kremationsjournal
 */
export enum TEDKJKremationGRAVSATTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Gravsättningstyp för kremationsjournal
 */
export enum TEDKJKremationGRAVTYPEnum {
  ASKA = "ASKA",
  ASKGRAVLUND = "ASKGRAVLUND",
  MINNESLUND = "MINNESLUND",
  NISCH = "NISCH",
  URNA = "URNA",
  URNKAMMARE = "URNKAMMARE",
}

/**
 * Aktiv för krematorium
 */
export enum TEDKJKrematoriumAKTIVEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, skickas till för betalningsorder
 */
export enum TEDKRBetalningsorderAUTOGIRO_VAGEnum {
  BANKGIROT = "BANKGIROT",
  POSTGIROT = "POSTGIROT",
}

/**
 * Återredovisning per grupp för betalningsorder
 */
export enum TEDKRBetalningsorderREDOVISA_PER_GRUPPEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Status för betalningsorder
 */
export enum TEDKRBetalningsorderSTATUSEnum {
  BACKAD = "BACKAD",
  SKAPAD = "SKAPAD",
}

/**
 * Autogiro, betalningsdag för faktura
 */
export enum TEDKRFakturaAUTOGIRO_BETALNINGSDAGEnum {
  A1 = "A1",
  A10 = "A10",
  A11 = "A11",
  A12 = "A12",
  A13 = "A13",
  A14 = "A14",
  A15 = "A15",
  A16 = "A16",
  A17 = "A17",
  A18 = "A18",
  A19 = "A19",
  A2 = "A2",
  A20 = "A20",
  A21 = "A21",
  A22 = "A22",
  A23 = "A23",
  A24 = "A24",
  A25 = "A25",
  A26 = "A26",
  A27 = "A27",
  A28 = "A28",
  A29 = "A29",
  A3 = "A3",
  A30 = "A30",
  A31 = "A31",
  A4 = "A4",
  A5 = "A5",
  A6 = "A6",
  A7 = "A7",
  A8 = "A8",
  A9 = "A9",
  ASISTA_BANKDAG = "ASISTA_BANKDAG",
}

/**
 * Autogiro, dragning oktober för faktura
 */
export enum TEDKRFakturaAUTOGIRO_BETMANAD_10Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning november för faktura
 */
export enum TEDKRFakturaAUTOGIRO_BETMANAD_11Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning december för faktura
 */
export enum TEDKRFakturaAUTOGIRO_BETMANAD_12Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning januari för faktura
 */
export enum TEDKRFakturaAUTOGIRO_BETMANAD_1Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning februari för faktura
 */
export enum TEDKRFakturaAUTOGIRO_BETMANAD_2Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning mars för faktura
 */
export enum TEDKRFakturaAUTOGIRO_BETMANAD_3Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning april för faktura
 */
export enum TEDKRFakturaAUTOGIRO_BETMANAD_4Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning maj för faktura
 */
export enum TEDKRFakturaAUTOGIRO_BETMANAD_5Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning juni för faktura
 */
export enum TEDKRFakturaAUTOGIRO_BETMANAD_6Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning juli för faktura
 */
export enum TEDKRFakturaAUTOGIRO_BETMANAD_7Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning augusti för faktura
 */
export enum TEDKRFakturaAUTOGIRO_BETMANAD_8Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning september för faktura
 */
export enum TEDKRFakturaAUTOGIRO_BETMANAD_9Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, periodicitet för faktura
 */
export enum TEDKRFakturaAUTOGIRO_PERIODICITETEnum {
  VARANNAN_MANAD = "VARANNAN_MANAD",
  VARJE_AR = "VARJE_AR",
  VARJE_MANAD = "VARJE_MANAD",
  VAR_FJARDE_MANAD = "VAR_FJARDE_MANAD",
  VAR_SJATTE_MANAD = "VAR_SJATTE_MANAD",
  VAR_TREDJE_MANAD = "VAR_TREDJE_MANAD",
}

/**
 * Autogiro, slutbetald innev. år för faktura
 */
export enum TEDKRFakturaAUTOGIRO_SLUTBETALASEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, skickas till för faktura
 */
export enum TEDKRFakturaAUTOGIRO_VAGEnum {
  BANKGIROT = "BANKGIROT",
  PLUSGIROT = "PLUSGIROT",
}

/**
 * Avityp för faktura
 */
export enum TEDKRFakturaAVITYPEnum {
  BANKGIRO = "BANKGIRO",
  BANKGIRO_OCR = "BANKGIRO_OCR",
  PLUSGIRO_OCR = "PLUSGIRO_OCR",
  UTAN_AVI = "UTAN_AVI",
  UTAN_AVI_OCR = "UTAN_AVI_OCR",
}

/**
 * Distributionssätt för faktura
 */
export enum TEDKRFakturaDISTRIBUTIONSSATTEnum {
  CENTRAL_UTSKRIFT = "CENTRAL_UTSKRIFT",
  E_FAKTURA_FORETAG = "E_FAKTURA_FORETAG",
  E_FAKTURA_PRIVAT = "E_FAKTURA_PRIVAT",
  PEPPOL = "PEPPOL",
}

/**
 * Distributionssätt, Kivra för faktura
 */
export enum TEDKRFakturaDISTRIBUTIONSSATT_KIVRAEnum {
  BREV = "BREV",
  FAKTURA = "FAKTURA",
}

/**
 * Räntefaktureras för faktura
 */
export enum TEDKRFakturaDROJ_RANTEFAKTURERASEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Extern kravstatus för faktura
 */
export enum TEDKRFakturaEXTERN_KRAVSTATUSEnum {
  AVSLUTAD__EJ_INDRIVEN = "AVSLUTAD__EJ_INDRIVEN",
  BETALD_TILL_BOLAGET_OCH_BORTTAGEN_HOS_INKASSO = "BETALD_TILL_BOLAGET_OCH_BORTTAGEN_HOS_INKASSO",
  BETALD_TILL_INKASSOBOLAGET = "BETALD_TILL_INKASSOBOLAGET",
  BOKFORD_SOM_KUNDFORLUST = "BOKFORD_SOM_KUNDFORLUST",
  FELAKTIGT_SAND_TILL_INKASSO = "FELAKTIGT_SAND_TILL_INKASSO",
  PA_ETT_KRAVFORSLAG = "PA_ETT_KRAVFORSLAG",
  SAND_TILL_INKASSO = "SAND_TILL_INKASSO",
}

/**
 * Extern påminnelsenivå för faktura
 */
export enum TEDKRFakturaEXTERN_PAMINNELSENIVAEnum {
  ANDRA_PAMINNELSE_SKICKAD = "ANDRA_PAMINNELSE_SKICKAD",
  ATERKALLATS_FRAN_INKASSO = "ATERKALLATS_FRAN_INKASSO",
  EFTERBEVAKNING_HOS_INKASSO = "EFTERBEVAKNING_HOS_INKASSO",
  FORSTA_PAMINNELSE_SKICKAD = "FORSTA_PAMINNELSE_SKICKAD",
  SAND_TILL_INKASSO = "SAND_TILL_INKASSO",
}

/**
 * Fakturatotal för faktura
 */
export enum TEDKRFakturaFAKTURATOTALEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Faktureringssätt för faktura
 */
export enum TEDKRFakturaFAKTURERINGSSATTEnum {
  AUTOGIRO = "AUTOGIRO",
  AVRAKNING_FRAN_KONTO = "AVRAKNING_FRAN_KONTO",
  BANKKONTO = "BANKKONTO",
  FAKTURA = "FAKTURA",
  KOB_FAKTURA = "KOB_FAKTURA",
  KONTOFAKTURA = "KONTOFAKTURA",
}

/**
 * Förfallodatum, flagga för faktura
 */
export enum TEDKRFakturaFORFALLODATUM_FLAGGAEnum {
  ANGIVET = "ANGIVET",
}

/**
 * Skicka krav för faktura
 */
export enum TEDKRFakturaKRAVUTSKRIFTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Moms för faktura
 */
export enum TEDKRFakturaMOMSEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Typ av order för faktura
 */
export enum TEDKRFakturaORDERTYPEnum {
  AVRAKNINGSAVTALSORDER = "AVRAKNINGSAVTALSORDER",
  BESTALLNINGSORDER = "BESTALLNINGSORDER",
  DIREKTORDER = "DIREKTORDER",
  ERBJUDANDE = "ERBJUDANDE",
  FASTTIDSAVTALSORDER = "FASTTIDSAVTALSORDER",
  FORE_DETTA_ERBJUDANDE = "FORE_DETTA_ERBJUDANDE",
  PERIODORDER = "PERIODORDER",
}

/**
 * Osäker fordran för faktura
 */
export enum TEDKRFakturaOSAKEREnum {
  OSAKER = "OSAKER",
  SAKER = "SAKER",
}

/**
 * Printlayout för faktura
 */
export enum TEDKRFakturaPRINTLAYOUTEnum {
  ERBJUDANDE = "ERBJUDANDE",
  FAKTURA = "FAKTURA",
}

/**
 * Printsätt för faktura
 */
export enum TEDKRFakturaPRINTSATTEnum {
  DIGITAL_BREVLADA__KIVRA_ = "DIGITAL_BREVLADA__KIVRA_",
  EGEN_UTSKRIFT = "EGEN_UTSKRIFT",
  EXPORT_TILL_AGRESSO = "EXPORT_TILL_AGRESSO",
  E_POST = "E_POST",
  SVENSKA_KYRKANS_FAKTURAVAXEL = "SVENSKA_KYRKANS_FAKTURAVAXEL",
  XML = "XML",
}

/**
 * Skickad med posttyp för faktura
 */
export enum TEDKRFakturaSKICKAD_MED_POSTTYPEnum {
  A_POST = "A_POST",
  B_POST = "B_POST",
}

/**
 * Status för faktura
 */
export enum TEDKRFakturaSTATUS_ELEKTRONISKFAKTURAEnum {
  BETALD = "BETALD",
  EJ_SKICKAD = "EJ_SKICKAD",
  FELAKTIG = "FELAKTIG",
  MOTTAGEN = "MOTTAGEN",
  OBETALD_FAKTURA_REVERSERAD = "OBETALD_FAKTURA_REVERSERAD",
  PAMINNELSE_SKICKAD = "PAMINNELSE_SKICKAD",
  PARKERAD = "PARKERAD",
  SKICKAD = "SKICKAD",
  SPARRAD = "SPARRAD",
}

/**
 * Typ för faktura
 */
export enum TEDKRFakturaTypEnum {
  DEBETFAKTURA = "DEBETFAKTURA",
  KREDITFAKTURA = "KREDITFAKTURA",
}

/**
 * Felkod för betalningsplan
 */
export enum TEDKRFakturabetalningFEL_KODEnum {
  FORNYAD_TACKNING = "FORNYAD_TACKNING",
  KONTOT_AVSLUTAT_ELLER_MAKULERAT_AV_BETALAREN = "KONTOT_AVSLUTAT_ELLER_MAKULERAT_AV_BETALAREN",
  TACKNING_SAKNAS = "TACKNING_SAKNAS",
  UPPDRAGET_EJ_UTFORT = "UPPDRAGET_EJ_UTFORT",
  UPPDRAGET_EJ_UTFORT__BETALARKONTO_AR_AVSLUTAT = "UPPDRAGET_EJ_UTFORT__BETALARKONTO_AR_AVSLUTAT",
  UPPDRAGET_EJ_UTFORT__MEN_GAR_TILL_OMFORSOK = "UPPDRAGET_EJ_UTFORT__MEN_GAR_TILL_OMFORSOK",
}

/**
 * Aviseringstyp för betalningsplan
 */
export enum TEDKRFakturabetalningSTATUSEnum {
  BETALD = "BETALD",
  BETALNING = "BETALNING",
  FELAKTIG = "FELAKTIG",
  MAKULERAD = "MAKULERAD",
  MAKULERING = "MAKULERING",
  UNDERKAND = "UNDERKAND",
}

/**
 * Typ för fakturarad
 */
export enum TEDKRFakturaradTYPEnum {
  ARTIKELRAD_MED_ANTAL = "ARTIKELRAD_MED_ANTAL",
  ARTIKELRAD_UTAN_ANTAL = "ARTIKELRAD_UTAN_ANTAL",
  ARTIKELRAD__EJ_MED_VID_ENDAST_FAKTURATOTAL_ = "ARTIKELRAD__EJ_MED_VID_ENDAST_FAKTURATOTAL_",
  DELSUMMA = "DELSUMMA",
  DELSUMMA_SAMLINGSFAKTURA = "DELSUMMA_SAMLINGSFAKTURA",
  F = "F",
  TEXTRAD = "TEXTRAD",
}

/**
 * Undertyp för fakturarad
 */
export enum TEDKRFakturaradUNDERTYPEnum {
  ADMINISTRATIONSAVGIFT = "ADMINISTRATIONSAVGIFT",
  AVRUNDNING = "AVRUNDNING",
  MOMS = "MOMS",
  ORDERRABATT = "ORDERRABATT",
  ORDERRAD = "ORDERRAD",
}

/**
 * Administrationsavgift kontofaktura för kund
 */
export enum TEDKRKundADMINAVGIFTKONTOFAKTURAEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, betalningsdag för kund
 */
export enum TEDKRKundAUTOGIRO_BETALNINGSDAGEnum {
  A1 = "A1",
  A10 = "A10",
  A11 = "A11",
  A12 = "A12",
  A13 = "A13",
  A14 = "A14",
  A15 = "A15",
  A16 = "A16",
  A17 = "A17",
  A18 = "A18",
  A19 = "A19",
  A2 = "A2",
  A20 = "A20",
  A21 = "A21",
  A22 = "A22",
  A23 = "A23",
  A24 = "A24",
  A25 = "A25",
  A26 = "A26",
  A27 = "A27",
  A28 = "A28",
  A29 = "A29",
  A3 = "A3",
  A30 = "A30",
  A31 = "A31",
  A4 = "A4",
  A5 = "A5",
  A6 = "A6",
  A7 = "A7",
  A8 = "A8",
  A9 = "A9",
  ASISTA_BANKDAG = "ASISTA_BANKDAG",
}

/**
 * Autogiro, dragning oktober för kund
 */
export enum TEDKRKundAUTOGIRO_BETMANAD_10Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning november för kund
 */
export enum TEDKRKundAUTOGIRO_BETMANAD_11Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning december för kund
 */
export enum TEDKRKundAUTOGIRO_BETMANAD_12Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning januari för kund
 */
export enum TEDKRKundAUTOGIRO_BETMANAD_1Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning februari för kund
 */
export enum TEDKRKundAUTOGIRO_BETMANAD_2Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning mars för kund
 */
export enum TEDKRKundAUTOGIRO_BETMANAD_3Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning april för kund
 */
export enum TEDKRKundAUTOGIRO_BETMANAD_4Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning maj för kund
 */
export enum TEDKRKundAUTOGIRO_BETMANAD_5Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning juni för kund
 */
export enum TEDKRKundAUTOGIRO_BETMANAD_6Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning juli för kund
 */
export enum TEDKRKundAUTOGIRO_BETMANAD_7Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning augusti för kund
 */
export enum TEDKRKundAUTOGIRO_BETMANAD_8Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning september för kund
 */
export enum TEDKRKundAUTOGIRO_BETMANAD_9Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, periodicitet för kund
 */
export enum TEDKRKundAUTOGIRO_PERIODICITETEnum {
  VARANNAN_MANAD = "VARANNAN_MANAD",
  VARJE_AR = "VARJE_AR",
  VARJE_MANAD = "VARJE_MANAD",
  VAR_FJARDE_MANAD = "VAR_FJARDE_MANAD",
  VAR_SJATTE_MANAD = "VAR_SJATTE_MANAD",
  VAR_TREDJE_MANAD = "VAR_TREDJE_MANAD",
}

/**
 * Autogiro, slutbetald innev. år för kund
 */
export enum TEDKRKundAUTOGIRO_SLUTBETALASEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, status för kund
 */
export enum TEDKRKundAUTOGIRO_STATUSEnum {
  AUTOGIRO_ANVANDS = "AUTOGIRO_ANVANDS",
  AUTOGIRO_ANVANDS_EJ = "AUTOGIRO_ANVANDS_EJ",
  BYTE_AV_KONTONR_REGISTRERAT = "BYTE_AV_KONTONR_REGISTRERAT",
  MAKULERING_AV_MEDGIVANDE_REGISTRERAT = "MAKULERING_AV_MEDGIVANDE_REGISTRERAT",
  NYTT_MEDGIVANDE_REGISTRERAT = "NYTT_MEDGIVANDE_REGISTRERAT",
}

/**
 * Autogiro, skickas till för kund
 */
export enum TEDKRKundAUTOGIRO_VAGEnum {
  BANKGIROT = "BANKGIROT",
  PLUSGIROT = "PLUSGIROT",
}

/**
 * Dröjsmålsränta (J/N) för kund
 */
export enum TEDKRKundDROJSMALSRANTEFAKTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Administrationsavgift för kund
 */
export enum TEDKRKundFAKTURERINGSAVGIFTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Faktureringssätt för kund
 */
export enum TEDKRKundFAKTURERINGSSATTEnum {
  AUTOGIRO = "AUTOGIRO",
  BANKKONTO = "BANKKONTO",
  FAKTURA = "FAKTURA",
  KOB = "KOB",
}

/**
 * Skriv ut bankkontofaktura (J/N) för kund
 */
export enum TEDKRKundFAKTUTSKRIFT_BANKKONTOEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Skriv ut avräkningsfaktura (J/N) för kund
 */
export enum TEDKRKundFAKTUTSKRIFT_KONTOFAKTURAEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Använd tillgodhavande för kund
 */
export enum TEDKRKundKREDITERA_TILLGODOHEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Mallkund (J/N) för kund
 */
export enum TEDKRKundMALLKUNDEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Moms för kund
 */
export enum TEDKRKundMOMSEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Moms på avräkning för kund
 */
export enum TEDKRKundMOMSPAKONTOFAKTURAEnum {
  FAKTURA = "FAKTURA",
  INGEN = "INGEN",
  KONTOFAKTUROR = "KONTOFAKTUROR",
}

/**
 * Skuldränta för kund
 */
export enum TEDKRKundRANTEFAKTURERASEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Kundtyp för kund
 */
export enum TEDKRKundTypEnum {
  AVTALKUND = "AVTALKUND",
  FAKTURAKUND = "FAKTURAKUND",
  KONTOKUND = "KONTOKUND",
}

/**
 * Status för kundfakturabunt
 */
export enum TEDKRKundfakturabuntSTATUSEnum {
  BACKAD = "BACKAD",
  DELVIS_HANTERAD = "DELVIS_HANTERAD",
  EJ_HANTERAD = "EJ_HANTERAD",
  FEL__KONTAKTA_ENIAC = "FEL__KONTAKTA_ENIAC",
  HANTERAD = "HANTERAD",
  SKICKAD = "SKICKAD",
  SKICKAD__EJ_KVITTERAD = "SKICKAD__EJ_KVITTERAD",
}

/**
 * Status för kundkategorins faktureringsgrupp
 */
export enum TEDKRKundkatFaktGruppSTATUSEnum {
  AVVIKANDE = "AVVIKANDE",
  NORMAL = "NORMAL",
}

/**
 * Intern (J/N) för kundkategori
 */
export enum TEDKRKundkategoriINTERNEnum {
  EXTERN = "EXTERN",
  INTERN = "INTERN",
}

/**
 * Ränteberäkningsmetod för kundkategori
 */
export enum TEDKRKundkategoriRANTEBERAKNMETODEnum {
  DAG_FOR_DAG_RANTA = "DAG_FOR_DAG_RANTA",
  INGEN_RANTEBERAKNING = "INGEN_RANTEBERAKNING",
  RANTA_PER_INGAENDE_SALDO = "RANTA_PER_INGAENDE_SALDO",
  RANTA_PER_UTGAENDE_SALDO = "RANTA_PER_UTGAENDE_SALDO",
}

/**
 * Standard för kundkategori
 */
export enum TEDKRKundkategoriSTANDARDEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Kundkategorityp för kundkategori
 */
export enum TEDKRKundkategoriTypEnum {
  AVTALKUNDKATEGORI = "AVTALKUNDKATEGORI",
  FAKTURAKUNDKATEGORI = "FAKTURAKUNDKATEGORI",
  KONTOKUNDKATEGORI = "KONTOKUNDKATEGORI",
}

/**
 * Borttagen för licens
 */
export enum TEDKRLicenserBORTTAGENEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Licenstyp för licens
 */
export enum TEDKRLicenserTypEnum {
  INKOPTLICENS = "INKOPTLICENS",
  KLIENT = "KLIENT",
  MENYSPARLICENS = "MENYSPARLICENS",
  OPTIONSLICENS = "OPTIONSLICENS",
  OVRIGLICENS = "OVRIGLICENS",
  PAKET = "PAKET",
}

/**
 * Autogiro, skickas till för medgivande
 */
export enum TEDKRMedgivandeAUTOGIRO_VAGEnum {
  BANKGIROT = "BANKGIROT",
  PLUSGIROT = "PLUSGIROT",
}

/**
 * Aviseringstyp för medgivande
 */
export enum TEDKRMedgivandeMEDDELANDEKODEnum {
  AVVISA_E_MEDGIVANDE_FRAN_BANKGIROT = "AVVISA_E_MEDGIVANDE_FRAN_BANKGIROT",
  BYTE_AV_BETALARKONTO = "BYTE_AV_BETALARKONTO",
  BYTE_AV_BETALARNUMMER = "BYTE_AV_BETALARNUMMER",
  E_MEDGIVANDE_FRAN_BANKGIROT = "E_MEDGIVANDE_FRAN_BANKGIROT",
  GODKANN_E_MEDGIVANDE_FRAN_BANKGIROT = "GODKANN_E_MEDGIVANDE_FRAN_BANKGIROT",
  MAKULERA_MEDGIVANDE = "MAKULERA_MEDGIVANDE",
  NYTT_MEDGIVANDE_AVVISAT_AV_BANKGIROT_PLUSGIROT = "NYTT_MEDGIVANDE_AVVISAT_AV_BANKGIROT_PLUSGIROT",
  NYTT_MEDGIVANDE_PER_BLANKETT = "NYTT_MEDGIVANDE_PER_BLANKETT",
}

/**
 * Typ för artikel
 */
export enum TEDLAArtikelTypEnum {
  AVGIFT = "AVGIFT",
  TJANST = "TJANST",
  VARA = "VARA",
}

/**
 * Används i Ekonomi för enhet
 */
export enum TEDLAEnhetEKEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Används i Order/Fakturering för enhet
 */
export enum TEDLAEnhetLAEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Används i Tidredovisning för enhet
 */
export enum TEDLAEnhetTIEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Används för internredovisning av timmar för enhet
 */
export enum TEDLAEnhetTI_INTRED_TIMEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Standard för prislista
 */
export enum TEDLAPrislistaSTANDARDEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Attesterar elektroniska fakturor för attestant
 */
export enum TEDLRAttestantELEKTRONISK_ATTESTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Frånvarande för attestant
 */
export enum TEDLRAttestantFRANVARANDEEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Kontobehörighet, typ för attestant
 */
export enum TEDLRAttestantKONTOINT_TYPEnum {
  ANGIVET_KONTOINTERVALL = "ANGIVET_KONTOINTERVALL",
}

/**
 * Används för för leverantörsfakturareferens
 */
export enum TEDLRAttestforslagANVANDS_FOREnum {
  ATTESTANTER = "ATTESTANTER",
  ATTESTANTER_OCH_KONTERING = "ATTESTANTER_OCH_KONTERING",
  KONTERING = "KONTERING",
}

/**
 * Används inte längre: Attesttyp för leverantörsfakturareferens
 */
export enum TEDLRAttestforslagATTESTTYPEnum {
  BESLUTSATTEST = "BESLUTSATTEST",
  MOTTAGNINGSATTEST = "MOTTAGNINGSATTEST",
}

/**
 * Typ för attestant
 */
export enum TEDLRAttestforslagDelAttestantTYPEnum {
  BESLUTSATTESTANT = "BESLUTSATTESTANT",
  MOTTAGNINGSATTESTANT = "MOTTAGNINGSATTESTANT",
}

/**
 * Giltig för för leverantörsfakturareferens
 */
export enum TEDLRAttestforslagGILTIG_FOREnum {
  KOB_FAKTUROR = "KOB_FAKTUROR",
  OVRIGA_FAKTUROR = "OVRIGA_FAKTUROR",
}

/**
 * Söktyp för referens för leverantörsfakturareferens
 */
export enum TEDLRAttestforslagREFERENS_SOKTYPEnum {
  BORJAR_PA = "BORJAR_PA",
  EXAKT = "EXAKT",
  FRITEXT = "FRITEXT",
}

/**
 * Avsändartyp för attestmeddelande
 */
export enum TEDLRAttestmeddelandeAVSANDAR_TYPEnum {
  ADMINISTRATOR = "ADMINISTRATOR",
  ATTESTANT = "ATTESTANT",
  EJ_DEFINIERAT = "EJ_DEFINIERAT",
}

/**
 * Mottagartyp för attestmeddelande
 */
export enum TEDLRAttestmeddelandeMOTTAGAR_TYPEnum {
  ADMINISTRATOR = "ADMINISTRATOR",
  ALLA = "ALLA",
  ATTESTANT = "ATTESTANT",
}

/**
 * Aktiv för attesträtt
 */
export enum TEDLRAttestrattAKTIVEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Ansvarig för attesträtt
 */
export enum TEDLRAttestrattANSVARIGEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Beslutsattest för attesträtt
 */
export enum TEDLRAttestrattBESLUT_ATTESTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Granskningsattest för attesträtt
 */
export enum TEDLRAttestrattGRANSKNING_ATTESTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Kontobehörighet enligt attestant för attesträtt
 */
export enum TEDLRAttestrattKONTOINT_ENL_ATTESTANTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Meddelande via e-post för attesträtt
 */
export enum TEDLRAttestrattMEDDELA_EPOSTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Mottagningsattest för attesträtt
 */
export enum TEDLRAttestrattMOTTAGN_ATTESTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Mottagningsattest, kontering för attesträtt
 */
export enum TEDLRAttestrattMOTTAGN_KONTERINGEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Mottagningsattest, skicka till utredning för attesträtt
 */
export enum TEDLRAttestrattMOTTAGN_REFUSERAEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Betalningsstatus för betalning
 */
export enum TEDLRBetalningSTATUSEnum {
  ANKOMSTREGISTRERAD = "ANKOMSTREGISTRERAD",
  BETALD = "BETALD",
  DEFINITIVBOKAD = "DEFINITIVBOKAD",
  MAKULERAD = "MAKULERAD",
  PA_VAG_TILL_BETALNING = "PA_VAG_TILL_BETALNING",
  SPARRAD = "SPARRAD",
}

/**
 * Status, elektronisk betalning för betalning
 */
export enum TEDLRBetalningSTATUS_ELEKTRONISK_BETALNINGEnum {
  BETALD = "BETALD",
  EJ_SKICKAD = "EJ_SKICKAD",
  FELAKTIG = "FELAKTIG",
  MOTTAGEN = "MOTTAGEN",
  SKICKAD = "SKICKAD",
}

/**
 * Utbetalning express för betalning
 */
export enum TEDLRBetalningUTB_EXPRESSEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Typ av utlandsbetalning för betalning
 */
export enum TEDLRBetalningUTLAND_BETSATT_TYPEnum {
  BBAN = "BBAN",
  IBAN = "IBAN",
}

/**
 * Redovisa per bokföringsgrupp för utbetalningsorder
 */
export enum TEDLRBetalningsuppdragREDOVISA_PER_GRUPPEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Status för utbetalningsorder
 */
export enum TEDLRBetalningsuppdragSTATUSEnum {
  BACKAD = "BACKAD",
  SKAPAD = "SKAPAD",
}

/**
 * Status, elektronisk betalning för utbetalningsorder
 */
export enum TEDLRBetalningsuppdragSTATUS_ELEKTRONISK_BETALNINGEnum {
  DELVIS_HANTERAD = "DELVIS_HANTERAD",
  EJ_HANTERAD = "EJ_HANTERAD",
  HANTERAD = "HANTERAD",
  SKICKAD = "SKICKAD",
  SKICKAD__EJ_KVITTERAD_PA_2_DAGAR = "SKICKAD__EJ_KVITTERAD_PA_2_DAGAR",
}

/**
 * AttestTyp för faktura attest
 */
export enum TEDLRFakturaAttestAttestTypEnum {
  BESLUTSATTEST = "BESLUTSATTEST",
  KONTROLLATTEST = "KONTROLLATTEST",
  MOTTAGNINGSATTEST = "MOTTAGNINGSATTEST",
}

/**
 * Atteststatus för faktura attest
 */
export enum TEDLRFakturaAttestSTATUSEnum {
  ATTESTERAD = "ATTESTERAD",
  HOS_CENTRAL_ADMINISTRATOR = "HOS_CENTRAL_ADMINISTRATOR",
  I_UTKORG = "I_UTKORG",
  UNDER_UTREDNING = "UNDER_UTREDNING",
  UTDELAD = "UTDELAD",
}

/**
 * Typ för faktura attest
 */
export enum TEDLRFakturaAttestTYPEnum {
  BESLUTSATTEST = "BESLUTSATTEST",
  MOTTAGNINGSATTEST = "MOTTAGNINGSATTEST",
}

/**
 * Detaljerad status för faktura
 */
export enum TEDLRFakturaDelATTEST_STATUSEnum {
  ATTESTERAD = "ATTESTERAD",
  BESLUTSATTESTERAS = "BESLUTSATTESTERAS",
  BETALD = "BETALD",
  DEFINITIVBOKAD = "DEFINITIVBOKAD",
  DELBETALD = "DELBETALD",
  EJ_UTDELAD_FOR_ATTEST = "EJ_UTDELAD_FOR_ATTEST",
  EJ_UTDELAD_FOR_BESLUTSATTEST = "EJ_UTDELAD_FOR_BESLUTSATTEST",
  FELAKTIG_BELOPPSATTEST = "FELAKTIG_BELOPPSATTEST",
  HOS_CENTRAL_ADMINISTRATOR = "HOS_CENTRAL_ADMINISTRATOR",
  I_UTKORG = "I_UTKORG",
  MAKULERAD = "MAKULERAD",
  MOTTAGNINGSATTESTERAS = "MOTTAGNINGSATTESTERAS",
  OTILLRACKLIG_ATTEST = "OTILLRACKLIG_ATTEST",
  PA_VAG_TILL_BETALNING = "PA_VAG_TILL_BETALNING",
  SPARRAD = "SPARRAD",
  STATUS_EJ_DEFINIERAD = "STATUS_EJ_DEFINIERAD",
  UNDER_UTREDNING = "UNDER_UTREDNING",
}

/**
 * Min fakturastatus för faktura
 */
export enum TEDLRFakturaDelAttestMinaStatusEnum {
  ATTESTERAD__BETALD = "ATTESTERAD__BETALD",
  ATTESTERAD__DEFINITIVBOKAD = "ATTESTERAD__DEFINITIVBOKAD",
  ATTESTERAD__DELBETALD = "ATTESTERAD__DELBETALD",
  ATTESTERAD__EJ_DEFINITIVBOKAD = "ATTESTERAD__EJ_DEFINITIVBOKAD",
  ATTESTERAD__HOS_ANNAN_ATTESTANT = "ATTESTERAD__HOS_ANNAN_ATTESTANT",
  ATTESTERAD__MAKULERAD = "ATTESTERAD__MAKULERAD",
  ATTESTERAD__PA_VAG_TILL_BETALNING = "ATTESTERAD__PA_VAG_TILL_BETALNING",
  ATTESTERAD__SPARRAD = "ATTESTERAD__SPARRAD",
  BESLUTSATTESTERAS = "BESLUTSATTESTERAS",
  EJ_ATTESTERAD__HOS_ANNAN_ATTESTANT = "EJ_ATTESTERAD__HOS_ANNAN_ATTESTANT",
  FELAKTIGA = "FELAKTIGA",
  KONTROLLATTESTERAS = "KONTROLLATTESTERAS",
  MOTTAGNINGSATTESTERAS = "MOTTAGNINGSATTESTERAS",
  UNDER_UTREDNING = "UNDER_UTREDNING",
}

/**
 * Format för fakturabild
 */
export enum TEDLRFakturabildFORMATEnum {
  BMP = "BMP",
  INV = "INV",
  INVOICE = "INVOICE",
  JPEG = "JPEG",
  JPG = "JPG",
  KOB = "KOB",
  SVEFAKTURA = "SVEFAKTURA",
  TIF = "TIF",
  TIFF = "TIFF",
  TIF_TIFF = "TIF_TIFF",
}

/**
 * Inläst, debet/kredit för fakturabild
 */
export enum TEDLRFakturabildINVOICE_DEBKREDEnum {
  DEBET = "DEBET",
  KREDIT = "KREDIT",
}

/**
 * Fakturan lagd åt sidan för fakturabild
 */
export enum TEDLRFakturabildLAGD_AT_SIDANEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Importtyp för fakturabunt
 */
export enum TEDLRFakturabuntIMPORTTYPEnum {
  BILDER = "BILDER",
  INVOICE_FAKTUROR = "INVOICE_FAKTUROR",
  KOB = "KOB",
  SVEFAKTUROR = "SVEFAKTUROR",
}

/**
 * Aktiv för fakturamottagningsväg
 */
export enum TEDLRFakturamottagningsvagAKTIVEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Importtyp för fakturamottagningsväg
 */
export enum TEDLRFakturamottagningsvagIMPORTTYPEnum {
  BILDER = "BILDER",
  INVOICE_FAKTUROR = "INVOICE_FAKTUROR",
  KOB = "KOB",
  SVEFAKTURA__SKANNADE_OCH_TOLKADE = "SVEFAKTURA__SKANNADE_OCH_TOLKADE",
}

/**
 * Registreras som förbrukningsinventarie för konteringsförslag
 */
export enum TEDLRKonteringsForslagFI_REGISTRERASEnum {
  EJ_ANGIVET = "EJ_ANGIVET",
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Moms för konteringsförslag
 */
export enum TEDLRKonteringsForslagMOMSEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Endast numeriska fakturanr för leverantörens betalningssätt
 */
export enum TEDLRLevBetsattNUMERISKA_FAKTURANREnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * OCR för leverantörens betalningssätt
 */
export enum TEDLRLevBetsattOCREnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Typ av kontonummer för leverantörens betalningssätt
 */
export enum TEDLRLevBetsattUTLAND_BETSATT_TYPEnum {
  BBAN = "BBAN",
  IBAN = "IBAN",
}

/**
 * Typ av ändring för leverantörsattest, logg
 */
export enum TEDLRLeverantorAttestLoggLOGGTYPEEnum {
  ANDRING = "ANDRING",
  BORTTAG = "BORTTAG",
  TILLAGG = "TILLAGG",
}

/**
 * Status för leverantörsattest
 */
export enum TEDLRLeverantorAttestSTATUSEnum {
  ATTESTERAD = "ATTESTERAD",
  EJ_GODKAND = "EJ_GODKAND",
  KORRIGERAD = "KORRIGERAD",
  SKA_ATTESTERAS = "SKA_ATTESTERAS",
}

/**
 * Använd referenstyp för leverantör
 */
export enum TEDLRLeverantorORDINARIE_REFERENS_TYPEnum {
  AVTAL_KONTRAKT = "AVTAL_KONTRAKT",
  BESTALLARREFERENS = "BESTALLARREFERENS",
  BESTALLARREFERENS_2 = "BESTALLARREFERENS_2",
  ER_KONTAKT = "ER_KONTAKT",
  FAKTURERINGSOBJEKT = "FAKTURERINGSOBJEKT",
}

/**
 * Status för leverantör
 */
export enum TEDLRLeverantorSTATUSEnum {
  AVSLUTAD = "AVSLUTAD",
  NORMAL = "NORMAL",
}

/**
 * Hantera tillgodohavande hos PlusGirot/Bankgirot för leverantör
 */
export enum TEDLRLeverantorTILLGODOH_HOS_BG_PGEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Fakturastatus, detaljerad för leverantörsfaktura
 */
export enum TEDLRLeverantorfakturaDetaljstatusEnum {
  ATTESTERAD = "ATTESTERAD",
  BESLUTSATTESTERAS = "BESLUTSATTESTERAS",
  BETALD = "BETALD",
  DEFINITIVBOKAD = "DEFINITIVBOKAD",
  DELBETALD = "DELBETALD",
  EJ_UTDELAD_FOR_ATTEST = "EJ_UTDELAD_FOR_ATTEST",
  EJ_UTDELAD_FOR_BESLUTSATTEST = "EJ_UTDELAD_FOR_BESLUTSATTEST",
  FELAKTIG_BELOPPSATTEST = "FELAKTIG_BELOPPSATTEST",
  HOS_CENTRAL_ADMINISTRATOR = "HOS_CENTRAL_ADMINISTRATOR",
  I_UTKORG = "I_UTKORG",
  MAKULERAD = "MAKULERAD",
  MOTTAGNINGSATTESTERAS = "MOTTAGNINGSATTESTERAS",
  OTILLRACKLIG_ATTEST = "OTILLRACKLIG_ATTEST",
  PA_VAG_TILL_BETALNING = "PA_VAG_TILL_BETALNING",
  SPARRAD = "SPARRAD",
  STATUS_EJ_DEFINIERAD = "STATUS_EJ_DEFINIERAD",
  UNDER_UTREDNING = "UNDER_UTREDNING",
}

/**
 * Elektronisk attest för leverantörsfaktura
 */
export enum TEDLRLeverantorfakturaELEKTRONISK_ATTESTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Fakturastatus för leverantörsfaktura
 */
export enum TEDLRLeverantorfakturaFakturastatusEnum {
  ANKOMSTREGISTRERAD = "ANKOMSTREGISTRERAD",
  BETALD = "BETALD",
  DEFINITIVBOKAD = "DEFINITIVBOKAD",
  DELBETALD = "DELBETALD",
  MAKULERAD = "MAKULERAD",
  PA_VAG_TILL_BETALNING = "PA_VAG_TILL_BETALNING",
}

/**
 * Momshantering för leverantörsfaktura
 */
export enum TEDLRLeverantorfakturaMOMSHANTERINGEnum {
  EJ_HANTERAT = "EJ_HANTERAT",
  SVENSK__ENLIGT_KODDEL = "SVENSK__ENLIGT_KODDEL",
  SVENSK__ENLIGT_LEVERANTOR = "SVENSK__ENLIGT_LEVERANTOR",
  UTLANDSK__ENLIGT_KODDEL = "UTLANDSK__ENLIGT_KODDEL",
  UTLANDSK__ENLIGT_LEVERANTOR = "UTLANDSK__ENLIGT_LEVERANTOR",
}

/**
 * Slutbetald för leverantörsfaktura
 */
export enum TEDLRLeverantorfakturaSLUTBETALDEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Spärrad (används ej) för leverantörsfaktura
 */
export enum TEDLRLeverantorfakturaSPARRADEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Status för leverantörsfaktura
 */
export enum TEDLRLeverantorfakturaSTATUSEnum {
  ANKOMSTREGISTRERAD = "ANKOMSTREGISTRERAD",
  DEFINITIVBOKAD = "DEFINITIVBOKAD",
  MAKULERAD = "MAKULERAD",
}

/**
 * Typ för leverantörsfaktura
 */
export enum TEDLRLeverantorfakturaTypEnum {
  DEBETFAKTURA = "DEBETFAKTURA",
  KREDITFAKTURA = "KREDITFAKTURA",
}

/**
 * Intern för leverantörskategorin
 */
export enum TEDLRLeverantorkatINTERNEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Typ av maskering (sekretess, skyddad eller spärrad)
 */
export enum TEDMaskType {
  SEKRETESS = "SEKRETESS",
  SKYDDAD = "SKYDDAD",
  SPARRAD = "SPARRAD",
}

/**
 * Autogiro, betalningsdag för order
 */
export enum TEDOFOrderAUTOGIRO_BETALNINGSDAGEnum {
  A1 = "A1",
  A10 = "A10",
  A11 = "A11",
  A12 = "A12",
  A13 = "A13",
  A14 = "A14",
  A15 = "A15",
  A16 = "A16",
  A17 = "A17",
  A18 = "A18",
  A19 = "A19",
  A2 = "A2",
  A20 = "A20",
  A21 = "A21",
  A22 = "A22",
  A23 = "A23",
  A24 = "A24",
  A25 = "A25",
  A26 = "A26",
  A27 = "A27",
  A28 = "A28",
  A29 = "A29",
  A3 = "A3",
  A30 = "A30",
  A31 = "A31",
  A4 = "A4",
  A5 = "A5",
  A6 = "A6",
  A7 = "A7",
  A8 = "A8",
  A9 = "A9",
  ASISTA_BANKDAG = "ASISTA_BANKDAG",
}

/**
 * Autogiro, dragning oktober för order
 */
export enum TEDOFOrderAUTOGIRO_BETMANAD_10Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning november för order
 */
export enum TEDOFOrderAUTOGIRO_BETMANAD_11Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning december för order
 */
export enum TEDOFOrderAUTOGIRO_BETMANAD_12Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning januari för order
 */
export enum TEDOFOrderAUTOGIRO_BETMANAD_1Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning februari för order
 */
export enum TEDOFOrderAUTOGIRO_BETMANAD_2Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning mars för order
 */
export enum TEDOFOrderAUTOGIRO_BETMANAD_3Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning april för order
 */
export enum TEDOFOrderAUTOGIRO_BETMANAD_4Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning maj för order
 */
export enum TEDOFOrderAUTOGIRO_BETMANAD_5Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning juni för order
 */
export enum TEDOFOrderAUTOGIRO_BETMANAD_6Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning juli för order
 */
export enum TEDOFOrderAUTOGIRO_BETMANAD_7Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning augusti för order
 */
export enum TEDOFOrderAUTOGIRO_BETMANAD_8Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, dragning september för order
 */
export enum TEDOFOrderAUTOGIRO_BETMANAD_9Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Periodicitet för order
 */
export enum TEDOFOrderAUTOGIRO_PERIODICITETEnum {
  VARANNAN_MANAD = "VARANNAN_MANAD",
  VARJE_AR = "VARJE_AR",
  VARJE_MANAD = "VARJE_MANAD",
  VAR_FJARDE_MANAD = "VAR_FJARDE_MANAD",
  VAR_SJATTE_MANAD = "VAR_SJATTE_MANAD",
  VAR_TREDJE_MANAD = "VAR_TREDJE_MANAD",
}

/**
 * Autogiro, slutbetald innev. år för order
 */
export enum TEDOFOrderAUTOGIRO_SLUTBETALASEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Autogiro, skickas till för order
 */
export enum TEDOFOrderAUTOGIRO_VAGEnum {
  BANKGIROT = "BANKGIROT",
  PLUSGIROT = "PLUSGIROT",
}

/**
 * Kopplad i rutin för orderBilaga
 */
export enum TEDOFOrderBilagaKOPPLAD_I_RUTINEnum {
  FAKTURERA_GRAVSKOTSEL = "FAKTURERA_GRAVSKOTSEL",
  FAKTURERING = "FAKTURERING",
  ORDER = "ORDER",
}

/**
 * Endast fakturatotal (J/N) för order
 */
export enum TEDOFOrderFAKTURATOTALEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Faktureringssätt för order
 */
export enum TEDOFOrderFAKTURERINGSSATTEnum {
  AUTOGIRO = "AUTOGIRO",
  AVRAKNING = "AVRAKNING",
  BANKKONTO = "BANKKONTO",
  FAKTURA = "FAKTURA",
  KOB = "KOB",
  KONTOFAKTURA = "KONTOFAKTURA",
}

/**
 * Clearing, förrättningstyp för order
 */
export enum TEDOFOrderFORRATTNINGSTYPEnum {
  BEGRAVNING = "BEGRAVNING",
  DOP = "DOP",
  KONFIRMATION = "KONFIRMATION",
  OVRIGT = "OVRIGT",
  STATLIG_CLEARING = "STATLIG_CLEARING",
  VIGSEL = "VIGSEL",
}

/**
 * Intern (J/N) för order
 */
export enum TEDOFOrderINTERNEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Kreditorder för order
 */
export enum TEDOFOrderKREDITORDEREnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Kredit. betalinstruktion för order
 */
export enum TEDOFOrderKREDIT_BETALINSTREnum {
  BETALA_DEBETFAKTURA = "BETALA_DEBETFAKTURA",
  KREDITFAKTURA = "KREDITFAKTURA",
  REST_UTBETALAS = "REST_UTBETALAS",
  TILLGODOHAVANDE = "TILLGODOHAVANDE",
  UTBETALAS = "UTBETALAS",
}

/**
 * Moms (J/N) för order
 */
export enum TEDOFOrderMOMSEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Ordererkännande utskrivet (J/N) för order
 */
export enum TEDOFOrderORDERERKANNANDEEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Samfaktureras (J/N) för order
 */
export enum TEDOFOrderSAMFAKTURERASEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Status för order
 */
export enum TEDOFOrderSTATUSEnum {
  DELFAKTURERAD = "DELFAKTURERAD",
  REGISTRERAD = "REGISTRERAD",
  SLUTFAKTURERAD = "SLUTFAKTURERAD",
}

/**
 * Ordertyp för order
 */
export enum TEDOFOrderTypEnum {
  AVRAKNINGKUNDAVTAL = "AVRAKNINGKUNDAVTAL",
  BESTORDER = "BESTORDER",
  DIREKTORDER = "DIREKTORDER",
  ERBJUDANDE = "ERBJUDANDE",
  PERIODORDERMALL = "PERIODORDERMALL",
}

/**
 * Fd status för orderrad
 */
export enum TEDOFOrderradFD_STATUSEnum {
  DELFAKTURERAD = "DELFAKTURERAD",
  FAKTURERAD = "FAKTURERAD",
  REGISTRERAD = "REGISTRERAD",
  RESTNOTERAD = "RESTNOTERAD",
  SLUTFAKTURERAD = "SLUTFAKTURERAD",
}

/**
 * Skrivstatus för orderrad
 */
export enum TEDOFOrderradSKRIVSTATUSEnum {
  FET_STIL = "FET_STIL",
}

/**
 * Status för orderrad
 */
export enum TEDOFOrderradSTATUSEnum {
  DELFAKTURERAD = "DELFAKTURERAD",
  FAKTURERAD = "FAKTURERAD",
  REGISTRERAD = "REGISTRERAD",
  RESTNOTERAD = "RESTNOTERAD",
  SLUTFAKTURERAD = "SLUTFAKTURERAD",
}

/**
 * Typ för orderrad
 */
export enum TEDOFOrderradTypEnum {
  ARTIKELRAD = "ARTIKELRAD",
  TEXTRAD = "TEXTRAD",
}

/**
 * Importtyp för orderunderlag
 */
export enum TEDOFOrderunderlagIMPORTTYPEnum {
  ENIAC_FORMAT = "ENIAC_FORMAT",
  SVEORDER = "SVEORDER",
}

/**
 * Status för orderunderlag
 */
export enum TEDOFOrderunderlagSTATUSEnum {
  BACKAD = "BACKAD",
  SKAPAD = "SKAPAD",
}

/**
 * Gravsättningstyp för avlidna
 */
export enum TEDOPAvlidenGRAVTYPEnum {
  ASKA = "ASKA",
  ASKGRAVLUND = "ASKGRAVLUND",
  ASKGRAVPLATS = "ASKGRAVPLATS",
  KISTA = "KISTA",
  KOLUMBARIUM = "KOLUMBARIUM",
  MINNESLUND = "MINNESLUND",
  NISCH = "NISCH",
  URNA = "URNA",
  URNKAMMARE = "URNKAMMARE",
}

/**
 * Kremering/Jordbegravning för avlidna
 */
export enum TEDOPAvlidenKREMERINGEnum {
  JORDBEGRAVNING = "JORDBEGRAVNING",
  KREMERING = "KREMERING",
  OBESTAMD = "OBESTAMD",
}

/**
 * Uppdateras automatiskt för adress/Lokal
 */
export enum TEDOPOrgPersLokAUTO_ADRESS_UPDATEnum {
  SKALL_INTE_UPPDATERAS = "SKALL_INTE_UPPDATERAS",
  SKALL_UPPDATERAS = "SKALL_UPPDATERAS",
}

/**
 * Borttagen orsak för adress/Lokal
 */
export enum TEDOPOrgPersLokBORTTAGEN_ORSAKEnum {
  AVLIDEN = "AVLIDEN",
  BORTTAGEN = "BORTTAGEN",
  SKYDDAD = "SKYDDAD",
}

/**
 * Döpt för adress/Lokal
 */
export enum TEDOPOrgPersLokDOPKODEnum {
  I_ANNAN_KRISTEN_KYRKAS_ORDNING = "I_ANNAN_KRISTEN_KYRKAS_ORDNING",
  I_SVENSKA_KYRKANS_ORDNING = "I_SVENSKA_KYRKANS_ORDNING",
  NEJ = "NEJ",
  UPPGIFT_SAKNAS = "UPPGIFT_SAKNAS",
}

/**
 * Fakturera pastoratet för adress/Lokal
 */
export enum TEDOPOrgPersLokFAKTURERA_SAMFALLIGHETEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Kategori för adress/Lokal
 */
export enum TEDOPOrgPersLokKATEGORIEnum {
  BEGRAVNINGSBYRA = "BEGRAVNINGSBYRA",
  INTERN = "INTERN",
  KYRKLIG_ENHET = "KYRKLIG_ENHET",
  STIFT = "STIFT",
}

/**
 * Konfirmerad för adress/Lokal
 */
export enum TEDOPOrgPersLokKONF_KODEnum {
  I_ANNAN_KRISTEN_KYRKAS_ORDNING = "I_ANNAN_KRISTEN_KYRKAS_ORDNING",
  I_SVENSKA_KYRKANS_ORDNING = "I_SVENSKA_KYRKANS_ORDNING",
  NEJ = "NEJ",
  UPPGIFT_SAKNAS = "UPPGIFT_SAKNAS",
}

/**
 * Lokaladress för adress/Lokal
 */
export enum TEDOPOrgPersLokLOKALADREnum {
  EXTERN = "EXTERN",
  LOKAL = "LOKAL",
}

/**
 * Medlemskod för adress/Lokal
 */
export enum TEDOPOrgPersLokMEDLEMSKODEnum {
  ANTECKNAD_I_AVVAKTAN_PA_DOP = "ANTECKNAD_I_AVVAKTAN_PA_DOP",
  ANTECKNAD_I_AVVAKTAN_PA_MEDDELANDE = "ANTECKNAD_I_AVVAKTAN_PA_MEDDELANDE",
  ANTECKNAD_VARDNADSHAVARE = "ANTECKNAD_VARDNADSHAVARE",
  BORTTAGEN_UPPGIFT_OM_ANTECKNAD = "BORTTAGEN_UPPGIFT_OM_ANTECKNAD",
  EJ_TILLHORIG_SVENSKA_KYRKAN = "EJ_TILLHORIG_SVENSKA_KYRKAN",
  TILLHORIG_SVENSKA_KYRKAN = "TILLHORIG_SVENSKA_KYRKAN",
  UPPGIFT_SAKNAS = "UPPGIFT_SAKNAS",
  UTTRADD_MEN_ANTECKNAD_PGA_KYRKOTILLHORIGT_BARN_ELLER_PGA_SAMTYCKE = "UTTRADD_MEN_ANTECKNAD_PGA_KYRKOTILLHORIGT_BARN_ELLER_PGA_SAMTYCKE",
  UTTRADD_P_G_A__UTVANDRING = "UTTRADD_P_G_A__UTVANDRING",
  UTTRADD_UR_SVENSKA_KYRKAN = "UTTRADD_UR_SVENSKA_KYRKAN",
}

/**
 * Regel för rensning för adress/Lokal
 */
export enum TEDOPOrgPersLokREGELEnum {
  DIREKT = "DIREKT",
  STANDARD = "STANDARD",
}

/**
 * Typ av adress för adress/Lokal
 */
export enum TEDOPOrgPersLokTypEnum {
  FORSAMLING = "FORSAMLING",
  LOKAL = "LOKAL",
  OVRIGORG = "OVRIGORG",
  PERSON = "PERSON",
  SAMFALLIGHET = "SAMFALLIGHET",
}

/**
 * Avser tvist för tvistehistorik
 */
export enum TEDOPTvistHistAVSEREnum {
  GRAVSATTNING = "GRAVSATTNING",
  KREMERING = "KREMERING",
  SAMTLIGA = "SAMTLIGA",
}

/**
 * Orsak för tvistehistorik
 */
export enum TEDOPTvistHistORSAKEnum {
  ANDRING = "ANDRING",
  BORTTAG = "BORTTAG",
  TILLAGG = "TILLAGG",
}

/**
 * Status för gallringslogg
 */
export enum TEDSYSAdranvGallrLoggSTATUSEnum {
  FEL = "FEL",
  OK = "OK",
}

/**
 * Gallringstyp för adressanvändning
 */
export enum TEDSYSAdressanvandningGALLRINGSTYPEnum {
  ANVANDARSTYRD = "ANVANDARSTYRD",
  GALLRAS_EJ = "GALLRAS_EJ",
  ODEFINIERAD = "ODEFINIERAD",
  PROGRAMSTYRD = "PROGRAMSTYRD",
}

/**
 * Kategori för adressanvändning kategori
 */
export enum TEDSYSAdressanvandningKategoriKATEGORIEnum {
  ADRESS = "ADRESS",
  KONTAKTUPPGIFTER = "KONTAKTUPPGIFTER",
  NAMN = "NAMN",
  PERSNR = "PERSNR",
  TILLHORIGHET = "TILLHORIGHET",
}

/**
 * ANVÄNDS INTE  Laglig grund för adressanvändning
 */
export enum TEDSYSAdressanvandningLAGLIG_GRUNDEnum {
  AVTAL = "AVTAL",
  INTRESSEAVVAGNING = "INTRESSEAVVAGNING",
  RATTSLIG_FORPLIKTELSE = "RATTSLIG_FORPLIKTELSE",
  SAMTYCKE = "SAMTYCKE",
}

/**
 * Lagringstyp för adressanvändning
 */
export enum TEDSYSAdressanvandningLAGRINGSTYPEnum {
  EJ_VALD = "EJ_VALD",
  STANDARD = "STANDARD",
  UTOKAD_LAGRINGSTID = "UTOKAD_LAGRINGSTID",
}

/**
 * Typ av rensning för adressanvändning
 */
export enum TEDSYSAdressanvandningRENSNINGSTYPEnum {
  AVIDENTIFIERA = "AVIDENTIFIERA",
  FORSTORA = "FORSTORA",
}

/**
 * Delprogram för adressanvändning
 */
export enum TEDSYSAdressanvandningSUBSYSTEMCODEEnum {
  ANLAGGNINGSREDOVISNING = "ANLAGGNINGSREDOVISNING",
  BOKNING = "BOKNING",
  DIARIUM = "DIARIUM",
  EKONOMI = "EKONOMI",
  GRAV = "GRAV",
  KREMATIONSJOURNAL = "KREMATIONSJOURNAL",
  KUNDRESKONTRA = "KUNDRESKONTRA",
  LEVERANTORSRESKONTRA = "LEVERANTORSRESKONTRA",
  MUSIK = "MUSIK",
  ORDER_FAKTURERING = "ORDER_FAKTURERING",
  SYSTEMADMINISTRATION = "SYSTEMADMINISTRATION",
  TIDREDOVISNING = "TIDREDOVISNING",
}

/**
 * Betalningsdag för autogiromall
 */
export enum TEDSYSAutogiroMallBETALNINGSDAGEnum {
  B1 = "B1",
  B10 = "B10",
  B11 = "B11",
  B12 = "B12",
  B13 = "B13",
  B14 = "B14",
  B15 = "B15",
  B16 = "B16",
  B17 = "B17",
  B18 = "B18",
  B19 = "B19",
  B2 = "B2",
  B20 = "B20",
  B21 = "B21",
  B22 = "B22",
  B23 = "B23",
  B24 = "B24",
  B25 = "B25",
  B26 = "B26",
  B27 = "B27",
  B28 = "B28",
  B29 = "B29",
  B3 = "B3",
  B30 = "B30",
  B31 = "B31",
  B4 = "B4",
  B5 = "B5",
  B6 = "B6",
  B7 = "B7",
  B8 = "B8",
  B9 = "B9",
  BSISTA_BANKDAG = "BSISTA_BANKDAG",
}

/**
 * Oktober för autogiromall
 */
export enum TEDSYSAutogiroMallBETMANAD_10Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * November för autogiromall
 */
export enum TEDSYSAutogiroMallBETMANAD_11Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * December för autogiromall
 */
export enum TEDSYSAutogiroMallBETMANAD_12Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Januari för autogiromall
 */
export enum TEDSYSAutogiroMallBETMANAD_1Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Februari för autogiromall
 */
export enum TEDSYSAutogiroMallBETMANAD_2Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Mars för autogiromall
 */
export enum TEDSYSAutogiroMallBETMANAD_3Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * April för autogiromall
 */
export enum TEDSYSAutogiroMallBETMANAD_4Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Maj för autogiromall
 */
export enum TEDSYSAutogiroMallBETMANAD_5Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Juni för autogiromall
 */
export enum TEDSYSAutogiroMallBETMANAD_6Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Juli för autogiromall
 */
export enum TEDSYSAutogiroMallBETMANAD_7Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Augusti för autogiromall
 */
export enum TEDSYSAutogiroMallBETMANAD_8Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * September för autogiromall
 */
export enum TEDSYSAutogiroMallBETMANAD_9Enum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Periodicitet för autogiromall
 */
export enum TEDSYSAutogiroMallPERIODICITETEnum {
  VARANNAN_MANAD = "VARANNAN_MANAD",
  VARJE_AR = "VARJE_AR",
  VARJE_MANAD = "VARJE_MANAD",
  VAR_FJARDE_MANAD = "VAR_FJARDE_MANAD",
  VAR_SJATTE_MANAD = "VAR_SJATTE_MANAD",
  VAR_TREDJE_MANAD = "VAR_TREDJE_MANAD",
}

/**
 * Slutbetalt innev. år för autogiromall
 */
export enum TEDSYSAutogiroMallSLUTBETALASEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Nationellt bankid för bank
 */
export enum TEDSYSBankNATIONAL_BANK_IDEnum {
  ATBLZ___NATIONELLT_BANKID_I_OSTERRIKE = "ATBLZ___NATIONELLT_BANKID_I_OSTERRIKE",
  AUBSB___NATIONELLT_BANKID_I_AUSTRALIEN = "AUBSB___NATIONELLT_BANKID_I_AUSTRALIEN",
  CACPA___NATIONELLT_BANKID_I_KANADA = "CACPA___NATIONELLT_BANKID_I_KANADA",
  CHBCC___NATIONELLT_BANKID_I_SCHWEIZ__UTAN_CHECKSIFFRA = "CHBCC___NATIONELLT_BANKID_I_SCHWEIZ__UTAN_CHECKSIFFRA",
  CHSIC___NATIONELLT_BANKID_I_SCHWEIZ__MED_CHECKSIFFRA = "CHSIC___NATIONELLT_BANKID_I_SCHWEIZ__MED_CHECKSIFFRA",
  CNAPS___NATIONELLT_BANKID_I_KINA = "CNAPS___NATIONELLT_BANKID_I_KINA",
  DEBLZ___NATIONELLT_BANKID_I_TYSKLAND = "DEBLZ___NATIONELLT_BANKID_I_TYSKLAND",
  ESNCC___NATIONELLT_BANKID_I_SPANIEN = "ESNCC___NATIONELLT_BANKID_I_SPANIEN",
  GBDSC___NATIONELLT_BANKID_I_UK = "GBDSC___NATIONELLT_BANKID_I_UK",
  GRBIC___NATIONELLT_BANKID_I_GREKLAND = "GRBIC___NATIONELLT_BANKID_I_GREKLAND",
  HKNCC___NATIONELLT_BANKID_I_HONG_KONG = "HKNCC___NATIONELLT_BANKID_I_HONG_KONG",
  IENCC___NATIONELLT_BANKID_I_IRLAND = "IENCC___NATIONELLT_BANKID_I_IRLAND",
  INFSC___NATIONELLT_BANKID_I_INDIEN = "INFSC___NATIONELLT_BANKID_I_INDIEN",
  ITNCC___NATIONELLT_BANKID_I_ITALIEN = "ITNCC___NATIONELLT_BANKID_I_ITALIEN",
  JPZGN__NATIONELLT_BANKID_I_JAPAN = "JPZGN__NATIONELLT_BANKID_I_JAPAN",
  NZNCC__NATIONELLT_BANKID_I_NYA_ZEALAND = "NZNCC__NATIONELLT_BANKID_I_NYA_ZEALAND",
  PLKNR___NATIONELLT_BANKID_I_POLEN = "PLKNR___NATIONELLT_BANKID_I_POLEN",
  PTNCC___NATIONELLT_BANKID_I_PORTUGAL = "PTNCC___NATIONELLT_BANKID_I_PORTUGAL",
  RUCBC___NATIONELLT_BANKID_I_RYSSLAND = "RUCBC___NATIONELLT_BANKID_I_RYSSLAND",
  SESBA___NATIONELLT_BANKID_I_SVERIGE = "SESBA___NATIONELLT_BANKID_I_SVERIGE",
  SGIBG___NATIONELLT_BANKID_I_SINGAPOR = "SGIBG___NATIONELLT_BANKID_I_SINGAPOR",
  THCBC___NATIONELLT_BANKID_I_THAILAND = "THCBC___NATIONELLT_BANKID_I_THAILAND",
  TWNCC___NATIONELLT_BANKID_I_TAIWAN = "TWNCC___NATIONELLT_BANKID_I_TAIWAN",
  USABA___NATIONELLT_BANKID_I_USA__FEDWIRE__NACHA_ = "USABA___NATIONELLT_BANKID_I_USA__FEDWIRE__NACHA_",
  USPID___BANK_ID_SOM_ANVANDS_AV_CHIPS_I_USA = "USPID___BANK_ID_SOM_ANVANDS_AV_CHIPS_I_USA",
  ZANCC___NATIONELLT_BANKID_I_SYDAFRICA = "ZANCC___NATIONELLT_BANKID_I_SYDAFRICA",
}

/**
 * Bankavtal för inbetalningssätt
 */
export enum TEDSYSBetalningssattBANKAVTALEnum {
  KONTO_HAR_HARD_OCR_KONTROLL_I_AVTAL_MED_SIN_BANK = "KONTO_HAR_HARD_OCR_KONTROLL_I_AVTAL_MED_SIN_BANK",
  KONTO_HAR_MJUK_OCR_KONTROLL_I_AVTAL_MED_SIN_BANK = "KONTO_HAR_MJUK_OCR_KONTROLL_I_AVTAL_MED_SIN_BANK",
}

/**
 * Kontotyp för inbetalningssätt
 */
export enum TEDSYSBetalningssattKONTOTYPEnum {
  BANKGIRO = "BANKGIRO",
  KOB = "KOB",
  KONTANT = "KONTANT",
  PLUSGIRO = "PLUSGIRO",
}

/**
 * Betalningssättyp för inbetalningssätt
 */
export enum TEDSYSBetalningssattTypEnum {
  INBETKUNDRESKONTRA = "INBETKUNDRESKONTRA",
}

/**
 * Fri leverans månad för betalningsvillkor
 */
export enum TEDSYSBetalningsvillkorFRILEVMANADEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Räntefaktureras för betalningsvillkor
 */
export enum TEDSYSBetalningsvillkorRANTEFAKTURERASEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Bokslutsperiod för bokföringsperiod
 */
export enum TEDSYSBokfPeriodBOKSLUTSPERIODEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Låst för bokföringsperiod
 */
export enum TEDSYSBokfPeriodLASTEnum {
  EJ_LAST = "EJ_LAST",
  LAST = "LAST",
}

/**
 * Arkivering, status kvittens för bokföringsår
 */
export enum TEDSYSBokfarEK_ARKIV_KVITTENS_STATUSEnum {
  EJ_MOTTAGEN = "EJ_MOTTAGEN",
  FELAKTIG = "FELAKTIG",
  MOTTAGEN = "MOTTAGEN",
}

/**
 * Arkivering, status för bokföringsår
 */
export enum TEDSYSBokfarEK_ARKIV_SKICKAT_STATUSEnum {
  ARKIVERAD_I_AVENY = "ARKIVERAD_I_AVENY",
  ARKIVERAD_I_SVENSKA_KYRKANS_E_ARKIV = "ARKIVERAD_I_SVENSKA_KYRKANS_E_ARKIV",
  EJ_ARKIVERAD = "EJ_ARKIVERAD",
  FELAKTIG = "FELAKTIG",
  SKICKAD_TILL_SVENSKA_KYRKANS_E_ARKIV = "SKICKAD_TILL_SVENSKA_KYRKANS_E_ARKIV",
}

/**
 * Ingåendebalans låst för bokföringsår
 */
export enum TEDSYSBokfarIB_LASTEnum {
  LAST = "LAST",
  OPPEN = "OPPEN",
}

/**
 * Bokföringsår låst för bokföringsår
 */
export enum TEDSYSBokfarLASTEnum {
  EJ_LAST = "EJ_LAST",
  LAST = "LAST",
}

/**
 * Giltig för typ för bokföringsgrupptyp
 */
export enum TEDSYSBokfgrupptypGILTIG_FOR_TYPEnum {
  BOKFORINGSGRUPP = "BOKFORINGSGRUPP",
  FAKTURERINGSGRUPP = "FAKTURERINGSGRUPP",
}

/**
 * Sökning i referensfält för fakturakod
 */
export enum TEDSYSFakturakodSOKTYPEnum {
  BORJAR_PA = "BORJAR_PA",
  EXAKT = "EXAKT",
  FRITEXT = "FRITEXT",
}

/**
 * Typ av utskrift för rapportlayout
 */
export enum TEDSYSFakturalayoutTypEnum {
  BREVLAYOUT = "BREVLAYOUT",
  KRAVUTSKRIFT = "KRAVUTSKRIFT",
  KREMBLANKETT = "KREMBLANKETT",
  LASERUTSKRIFT = "LASERUTSKRIFT",
  NASSJO = "NASSJO",
  POSTGIRO = "POSTGIRO",
}

/**
 * Avityp för extern utskrift för bokföringsgrupp
 */
export enum TEDSYSGruppAVITYPEnum {
  BANKGIRO = "BANKGIRO",
  BANKGIRO_OCR = "BANKGIRO_OCR",
  PLUSGIRO_OCR = "PLUSGIRO_OCR",
  UTAN_AVI = "UTAN_AVI",
  UTAN_AVI_OCR = "UTAN_AVI_OCR",
}

/**
 * Avrundningsvillkor för bokföringsgrupp
 */
export enum TEDSYSGruppAVRUNDNINGSVILLKOREnum {
  A1_00 = "A1_00",
  AINGEN_AVRUNDNING = "AINGEN_AVRUNDNING",
}

/**
 * Avräkningsmetod för bokföringsgrupp
 */
export enum TEDSYSGruppAVR_METODEnum {
  HALVAR = "HALVAR",
  HELAR = "HELAR",
  KVARTAL = "KVARTAL",
  MANAD = "MANAD",
}

/**
 * Elektronisk attest för bokföringsgrupp
 */
export enum TEDSYSGruppELEKTRONISK_ATTESTEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Faktureringssätt för bokföringsgrupp
 */
export enum TEDSYSGruppFAKTURERINGSSATTEnum {
  AUTOGIRO = "AUTOGIRO",
  BANKKONTO = "BANKKONTO",
  FAKTURA = "FAKTURA",
  KOB_FAKTURA = "KOB_FAKTURA",
}

/**
 * Integration med redovisning för bokföringsgrupp
 */
export enum TEDSYSGruppINTEGRATIONSTYPEnum {
  AVENY = "AVENY",
  BOKFORINGSUNDERLAG_TILL_ANNAT_SYSTEM = "BOKFORINGSUNDERLAG_TILL_ANNAT_SYSTEM",
  INGEN = "INGEN",
  LISTA = "LISTA",
  ORDERINTEGRATION = "ORDERINTEGRATION",
}

/**
 * Manuell fakturanummer på order för bokföringsgrupp
 */
export enum TEDSYSGruppMANUELLT_FAKTURANR_ORDEREnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Ordertyp att fakturera för bokföringsgrupp
 */
export enum TEDSYSGruppORDERTYPEnum {
  AVRAKNINGSAVTALSORDER = "AVRAKNINGSAVTALSORDER",
  BESTALLNINGSORDER = "BESTALLNINGSORDER",
  DIREKTORDER = "DIREKTORDER",
  ERBJUDANDE = "ERBJUDANDE",
  FASTTIDSAVTALSORDER = "FASTTIDSAVTALSORDER",
  PERIODMALL = "PERIODMALL",
}

/**
 * Ordinarie summeringsnivå för bokföringsgrupp
 */
export enum TEDSYSGruppORDINARIE_DETALJNIVAEnum {
  JOURNAL_DATUM = "JOURNAL_DATUM",
  VERIFIKATION = "VERIFIKATION",
  VERIFIKATIONSRAD = "VERIFIKATIONSRAD",
}

/**
 * Posttyp, faktura för bokföringsgrupp
 */
export enum TEDSYSGruppPOSTTYP_FAKTURAEnum {
  P1_A_KLASSBREV__A_POST_ = "P1_A_KLASSBREV__A_POST_",
  PEKONOMIBREV__B_POST_ = "PEKONOMIBREV__B_POST_",
}

/**
 * Posttyp, påminnelse för bokföringsgrupp
 */
export enum TEDSYSGruppPOSTTYP_PAMINNELSEEnum {
  P1_A_KLASSBREV__A_POST_ = "P1_A_KLASSBREV__A_POST_",
  PEKONOMIBREV__B_POST_ = "PEKONOMIBREV__B_POST_",
}

/**
 * Samfaktureras för bokföringsgrupp
 */
export enum TEDSYSGruppSAMFAKTURERASEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Faktureringsgrupp per skötselrad för bokföringsgrupp
 */
export enum TEDSYSGruppSKOTSELEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Typ för bokföringsgrupp
 */
export enum TEDSYSGruppTypEnum {
  BOKFGRUPP = "BOKFGRUPP",
  BOKFGRUPPFAKT = "BOKFGRUPPFAKT",
}

/**
 * Utländska adresser för bokföringsgrupp
 */
export enum TEDSYSGruppUTLADREnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Skriv ut på arbetsunderlag för bokföringsgrupp
 */
export enum TEDSYSGruppUTSKRIFT_ARBUNDEnum {
  ALLA_GRAVSKOTSLAR = "ALLA_GRAVSKOTSLAR",
  BETALDA_GRAVSKOTSLAR = "BETALDA_GRAVSKOTSLAR",
  FAKTURERADE_GRAVSKOTSLAR = "FAKTURERADE_GRAVSKOTSLAR",
  TA_EJ_MED_PA_ARBETSUNDERLAG = "TA_EJ_MED_PA_ARBETSUNDERLAG",
}

/**
 * Journalhantering för bokföringsgrupp, rutin
 */
export enum TEDSYSGruppVerkatJOURNALHANTERINGEnum {
  BOKFOR_DIREKT = "BOKFOR_DIREKT",
  FRAGA_VID_AVSLUT = "FRAGA_VID_AVSLUT",
  MANUELLT = "MANUELLT",
}

/**
 * Status för jobb
 */
export enum TEDSYSJobbSTATUSEnum {
  AVBRUTET = "AVBRUTET",
  FEL = "FEL",
  FEL__STARTAS_OM = "FEL__STARTAS_OM",
  INGET_ATT_GORA = "INGET_ATT_GORA",
  INITIERAT = "INITIERAT",
  KLART = "KLART",
  KORS = "KORS",
  PAUSAT = "PAUSAT",
  STARTAS = "STARTAS",
  VILANDE = "VILANDE",
}

/**
 * Förrättningstyp för kOB-clearingartikel
 */
export enum TEDSYSKOBArtikelFORRATTNINGSTYPEnum {
  BEGRAVNING = "BEGRAVNING",
  DOP = "DOP",
  KONFIRMATION = "KONFIRMATION",
  STATLIG_CLEARING = "STATLIG_CLEARING",
  VIGSEL = "VIGSEL",
}

/**
 * Artikeltyp för kOB-clearingartikel
 */
export enum TEDSYSKOBArtikelTYPEnum {
  AVGIFT = "AVGIFT",
  TJANST = "TJANST",
}

/**
 * Inkassolista för kravtext
 */
export enum TEDSYSKravTextINKASSOLISTAEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Repetera sista krav för kravrutin
 */
export enum TEDSYSKravrutinREPETERASISTAKRAVEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Standardnivå för lösenordskrav
 */
export enum TEDSYSLosenordskravIS_DEFAULT_LEVELEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Nummerserie låst för nummer
 */
export enum TEDSYSNummerLASTEnum {
  EJ_LAST = "EJ_LAST",
  LAST = "LAST",
}

/**
 * Årsbaserad/Ständig serie för nummerserie
 */
export enum TEDSYSNummerserieTypEnum {
  ARSBASERADNUMMERSERIE = "ARSBASERADNUMMERSERIE",
  STANDIGNUMMERSERIE = "STANDIGNUMMERSERIE",
}

/**
 * Försystem för ordermottagningsväg
 */
export enum TEDSYSOrdermottagningsvagFORSYSTEM_TYPEnum {
  BOKNING = "BOKNING",
  GRAV = "GRAV",
  KREMATIONSJOURNAL = "KREMATIONSJOURNAL",
  OVRIGT = "OVRIGT",
}

/**
 * Importtyp för ordermottagningsväg
 */
export enum TEDSYSOrdermottagningsvagIMPORTTYPEnum {
  ENIAC_FORMAT = "ENIAC_FORMAT",
  SVEORDER = "SVEORDER",
}

/**
 * Ändamål, källa för personkategori
 */
export enum TEDSYSPersonkategoriPERS_ANDAMAL_KALLAEnum {
  ANGE_EGET_SVAR = "ANGE_EGET_SVAR",
  ANVAND_ENIACS_FORSLAG_TILL_SVAR = "ANVAND_ENIACS_FORSLAG_TILL_SVAR",
  KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR = "KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR",
}

/**
 * Ändamål saknas, källa för personkategori
 */
export enum TEDSYSPersonkategoriPERS_EJ_ANDAMAL_KALLAEnum {
  ANGE_EGET_SVAR = "ANGE_EGET_SVAR",
  ANVAND_ENIACS_FORSLAG_TILL_SVAR = "ANVAND_ENIACS_FORSLAG_TILL_SVAR",
  KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR = "KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR",
}

/**
 * Laglig grund saknas, källa för personkategori
 */
export enum TEDSYSPersonkategoriPERS_EJ_LAGLIG_GRUND_KALLAEnum {
  ANGE_EGET_SVAR = "ANGE_EGET_SVAR",
  ANVAND_ENIACS_FORSLAG_TILL_SVAR = "ANVAND_ENIACS_FORSLAG_TILL_SVAR",
  KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR = "KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR",
}

/**
 * Fritextfält, källa för personkategori
 */
export enum TEDSYSPersonkategoriPERS_FRITEXTFALT_KALLAEnum {
  ANGE_EGET_SVAR = "ANGE_EGET_SVAR",
  ANVAND_ENIACS_FORSLAG_TILL_SVAR = "ANVAND_ENIACS_FORSLAG_TILL_SVAR",
  KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR = "KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR",
}

/**
 * Fritextfält syfte, källa för personkategori
 */
export enum TEDSYSPersonkategoriPERS_FRITEXTFALT_SYFTE_KALLAEnum {
  ANGE_EGET_SVAR = "ANGE_EGET_SVAR",
  ANVAND_ENIACS_FORSLAG_TILL_SVAR = "ANVAND_ENIACS_FORSLAG_TILL_SVAR",
  KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR = "KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR",
}

/**
 * Automatisk gallring, källa för personkategori
 */
export enum TEDSYSPersonkategoriPERS_GALLRING_AUTOMATIK_KALLAEnum {
  ANGE_EGET_SVAR = "ANGE_EGET_SVAR",
  ANVAND_ENIACS_FORSLAG_TILL_SVAR = "ANVAND_ENIACS_FORSLAG_TILL_SVAR",
  KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR = "KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR",
}

/**
 * Gallring beslut, källa för personkategori
 */
export enum TEDSYSPersonkategoriPERS_GALLRING_BESLUT_KALLAEnum {
  ANGE_EGET_SVAR = "ANGE_EGET_SVAR",
  ANVAND_ENIACS_FORSLAG_TILL_SVAR = "ANVAND_ENIACS_FORSLAG_TILL_SVAR",
  KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR = "KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR",
}

/**
 * Manuell gallring, källa för personkategori
 */
export enum TEDSYSPersonkategoriPERS_GALLRING_MANUELLT_KALLAEnum {
  ANGE_EGET_SVAR = "ANGE_EGET_SVAR",
  ANVAND_ENIACS_FORSLAG_TILL_SVAR = "ANVAND_ENIACS_FORSLAG_TILL_SVAR",
  KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR = "KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR",
}

/**
 * Inhämtning allmänna källor, källa för personkategori
 */
export enum TEDSYSPersonkategoriPERS_INHAMNTNING_EJ_REG_KALLAEnum {
  ANGE_EGET_SVAR = "ANGE_EGET_SVAR",
  ANVAND_ENIACS_FORSLAG_TILL_SVAR = "ANVAND_ENIACS_FORSLAG_TILL_SVAR",
  KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR = "KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR",
}

/**
 * Inhämtning från registrerad, källa för personkategori
 */
export enum TEDSYSPersonkategoriPERS_INHAMNTNING_REG_KALLAEnum {
  ANGE_EGET_SVAR = "ANGE_EGET_SVAR",
  ANVAND_ENIACS_FORSLAG_TILL_SVAR = "ANVAND_ENIACS_FORSLAG_TILL_SVAR",
  KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR = "KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR",
}

/**
 * Känsliga uppgifter (Ja/Nej), källa för personkategori
 */
export enum TEDSYSPersonkategoriPERS_KANSLIGA_UPPGIFTER_JA_NEJ_KALLAEnum {
  ANGE_EGET_SVAR = "ANGE_EGET_SVAR",
  ANVAND_ENIACS_FORSLAG_TILL_SVAR = "ANVAND_ENIACS_FORSLAG_TILL_SVAR",
  KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR = "KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR",
}

/**
 * Känsliga uppgifter, källa för personkategori
 */
export enum TEDSYSPersonkategoriPERS_KANSLIGA_UPPGIFTER_KALLAEnum {
  ANGE_EGET_SVAR = "ANGE_EGET_SVAR",
  ANVAND_ENIACS_FORSLAG_TILL_SVAR = "ANVAND_ENIACS_FORSLAG_TILL_SVAR",
  KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR = "KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR",
}

/**
 * Laglig grund, källa för personkategori
 */
export enum TEDSYSPersonkategoriPERS_LAGLIG_GRUND_KALLAEnum {
  ANGE_EGET_SVAR = "ANGE_EGET_SVAR",
  ANVAND_ENIACS_FORSLAG_TILL_SVAR = "ANVAND_ENIACS_FORSLAG_TILL_SVAR",
  KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR = "KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR",
}

/**
 * Personuppgifter, källa för personkategori
 */
export enum TEDSYSPersonkategoriPERS_PERSONUPPGIFTER_KALLAEnum {
  ANGE_EGET_SVAR = "ANGE_EGET_SVAR",
  ANVAND_ENIACS_FORSLAG_TILL_SVAR = "ANVAND_ENIACS_FORSLAG_TILL_SVAR",
  KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR = "KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR",
}

/**
 * Syfte, källa för personkategori
 */
export enum TEDSYSPersonkategoriPERS_SYFTE_KALLAEnum {
  ANGE_EGET_SVAR = "ANGE_EGET_SVAR",
  ANVAND_ENIACS_FORSLAG_TILL_SVAR = "ANVAND_ENIACS_FORSLAG_TILL_SVAR",
  KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR = "KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR",
}

/**
 * Utlämning, källa för personkategori
 */
export enum TEDSYSPersonkategoriPERS_UTLAMNING_KALLAEnum {
  ANGE_EGET_SVAR = "ANGE_EGET_SVAR",
  ANVAND_ENIACS_FORSLAG_TILL_SVAR = "ANVAND_ENIACS_FORSLAG_TILL_SVAR",
  KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR = "KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR",
}

/**
 * Utlämning planeras, källa för personkategori
 */
export enum TEDSYSPersonkategoriPERS_UTLAMNING_PLANERING_KALLAEnum {
  ANGE_EGET_SVAR = "ANGE_EGET_SVAR",
  ANVAND_ENIACS_FORSLAG_TILL_SVAR = "ANVAND_ENIACS_FORSLAG_TILL_SVAR",
  KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR = "KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR",
}

/**
 * ANVÄNDS INTE Status för personkategori
 */
export enum TEDSYSPersonkategoriSTATUSEnum {
  ATERSTAR = "ATERSTAR",
  KLAR = "KLAR",
  PRELIMINAR = "PRELIMINAR",
}

/**
 * Används för för räntetabell
 */
export enum TEDSYSRanteTabellANVANDSFOREnum {
  DROJSMALSRANTA = "DROJSMALSRANTA",
  INTERNRANTA = "INTERNRANTA",
  SKULDRANTA_AVRAKN_AVTAL = "SKULDRANTA_AVRAKN_AVTAL",
  SKULDUPPRAKNING_FASTTIDSAVTAL = "SKULDUPPRAKNING_FASTTIDSAVTAL",
  TILLGODORANTA_AVRAKN_AVTAL = "TILLGODORANTA_AVRAKN_AVTAL",
}

/**
 * Räntetabellstyp för räntetabell
 */
export enum TEDSYSRanteTabellTypEnum {
  BASRANTETABELL = "BASRANTETABELL",
  RELATIVRANTETABELL = "RELATIVRANTETABELL",
}

/**
 * Digital signering för rapport
 */
export enum TEDSYSReportNewDigitalSigneringEnum {
  FLERA = "FLERA",
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Sidfot för rapport
 */
export enum TEDSYSReportNewPageFooterOptionEnum {
  ALLA_SIDOR = "ALLA_SIDOR",
  EGEN_SIDFOT = "EGEN_SIDFOT",
  FORSTA_SIDAN = "FORSTA_SIDAN",
  INGEN_SIDFOT = "INGEN_SIDFOT",
}

/**
 * Sidhuvud för rapport
 */
export enum TEDSYSReportNewPageHeaderOptionEnum {
  ALLA_SIDOR = "ALLA_SIDOR",
  EGET_SIDHUVUD = "EGET_SIDHUVUD",
  FORSTA_SIDAN = "FORSTA_SIDAN",
  INGET_SIDHUVUD = "INGET_SIDHUVUD",
}

/**
 * Typ för parameter
 */
export enum TEDSYSReportNewParamTYPEnum {
  AVLIDEN = "AVLIDEN",
  CHECKBOX = "CHECKBOX",
  DATUM = "DATUM",
  GRAVPERSON = "GRAVPERSON",
  MEMO = "MEMO",
  TEXT = "TEXT",
  TID = "TID",
  VALBAR_TEXT = "VALBAR_TEXT",
}

/**
 * Rapporttyp för rapport
 */
export enum TEDSYSReportNewTypEnum {
  ETIKETTNEW = "ETIKETTNEW",
  EXCELREPORTNEW = "EXCELREPORTNEW",
  PDFREPORTNEW = "PDFREPORTNEW",
  WORDREPORTNEW = "WORDREPORTNEW",
}

/**
 * Synlighet för rapport
 */
export enum TEDSYSReportNewVISIBILITYEnum {
  GEMENSAM_RAPPORT = "GEMENSAM_RAPPORT",
  MIN_RAPPORT = "MIN_RAPPORT",
}

/**
 * Behörighetsnivå för rutinbehörighet
 */
export enum TEDSYSRutinBehorighetSECURITY_LEVELEnum {
  BEHORIG = "BEHORIG",
  EJ_BEHORIG = "EJ_BEHORIG",
  LASBEHORIGHET = "LASBEHORIGHET",
}

/**
 * Spärr, typ för rutin
 */
export enum TEDSYSRutinSPARR_TYPEnum {
  INGEN_SPARR = "INGEN_SPARR",
  SKRIVBEHORIGHET_SPARRAD = "SKRIVBEHORIGHET_SPARRAD",
  TILLGANG_TILL_RUTIN_SPARRAD = "TILLGANG_TILL_RUTIN_SPARRAD",
}

/**
 * Använd prefix för nummerserietyp
 */
export enum TEDSYSSerietypANVAND_PREFIXEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Årsbaserad för nummerserietyp
 */
export enum TEDSYSSerietypARS_BASERADEnum {
  ARSBASERAD = "ARSBASERAD",
  STANDIG = "STANDIG",
}

/**
 * Systemspråk för språk
 */
export enum TEDSYSSprakSYSTEMSPRAKEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Kodbehörighet, används för för urval
 */
export enum TEDSYSUrvalKODBEH_ANVANDS_FOREnum {
  BALANS = "BALANS",
  BLANDAT = "BLANDAT",
  EJ_DEFINIERAT = "EJ_DEFINIERAT",
  HELA_HUVUDBOKEN = "HELA_HUVUDBOKEN",
  RESULTAT = "RESULTAT",
}

/**
 * Kategori för urval
 */
export enum TEDSYSUrvalUSAGE_CODEEnum {
  INVENTERINGSANSVARIGA = "INVENTERINGSANSVARIGA",
  KODBEGRANSNING = "KODBEGRANSNING",
  KONTOURVAL = "KONTOURVAL",
}

/**
 * Id typ för användare
 */
export enum TEDSYSUserID_TYPEEnum {
  AVENYID = "AVENYID",
  GIP_KONTO = "GIP_KONTO",
  LOKALT_KONTO = "LOKALT_KONTO",
}

/**
 * Kodbegr enl arbetsställe för användare
 */
export enum TEDSYSUserKONTOBEGR_ENL_STALLEEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Licenstyp för användarlicens
 */
export enum TEDSYSUserLicenseLICENSTYPEnum {
  BEGRANSAD_LICENS = "BEGRANSAD_LICENS",
  FULLVARDIG_LICENS = "FULLVARDIG_LICENS",
  GRUNDLICENS = "GRUNDLICENS",
  GRUPPLICENS = "GRUPPLICENS",
  UTOKAD_LICENS = "UTOKAD_LICENS",
}

/**
 * Behörig till bokföringsgrupper för användare
 */
export enum TEDSYSUserMALLANV_STYRN_INST_1Enum {
  BEHORIGHET_ANGES_PER_ANVANDARE = "BEHORIGHET_ANGES_PER_ANVANDARE",
  BEHORIG_TILL_ALLA_TYPER = "BEHORIG_TILL_ALLA_TYPER",
  BEHORIG_TILL_ANGIVNA_TYPER = "BEHORIG_TILL_ANGIVNA_TYPER",
  EJ_BEHORIG = "EJ_BEHORIG",
}

/**
 * Behörig till faktureringsgrupper för användare
 */
export enum TEDSYSUserMALLANV_STYRN_INST_2Enum {
  BEHORIGHET_ANGES_PER_ANVANDARE = "BEHORIGHET_ANGES_PER_ANVANDARE",
  BEHORIG_TILL_ALLA_TYPER = "BEHORIG_TILL_ALLA_TYPER",
  BEHORIG_TILL_ANGIVNA_TYPER = "BEHORIG_TILL_ANGIVNA_TYPER",
  EJ_BEHORIG = "EJ_BEHORIG",
}

/**
 * Behörig till bokningsgrupper för användare
 */
export enum TEDSYSUserMALLANV_STYRN_INST_3Enum {
  BEHORIGHET_ANGES_PER_ANVANDARE = "BEHORIGHET_ANGES_PER_ANVANDARE",
  BEHORIG_TILL_ALLA_BOKNINGSGRUPPER = "BEHORIG_TILL_ALLA_BOKNINGSGRUPPER",
  EJ_BEHORIG = "EJ_BEHORIG",
}

/**
 * Behörig till diariegrupper för användare
 */
export enum TEDSYSUserMALLANV_STYRN_INST_4Enum {
  BEHORIGHET_ANGES_PER_ANVANDARE = "BEHORIGHET_ANGES_PER_ANVANDARE",
  BEHORIG_TILL_ALLA_DIARIEGRUPPER = "BEHORIG_TILL_ALLA_DIARIEGRUPPER",
  EJ_BEHORIG = "EJ_BEHORIG",
}

/**
 * Behörig till anläggningsgrupper för användare
 */
export enum TEDSYSUserMALLANV_STYRN_INST_5Enum {
  BEHORIGHET_ANGES_PER_ANVANDARE = "BEHORIGHET_ANGES_PER_ANVANDARE",
  BEHORIG_TILL_ALLA_ANLAGGNINGGRUPPER = "BEHORIG_TILL_ALLA_ANLAGGNINGGRUPPER",
  EJ_BEHORIG = "EJ_BEHORIG",
}

/**
 * Behörig till tidredovisningsgrupper för användare
 */
export enum TEDSYSUserMALLANV_STYRN_INST_6Enum {
  BEHORIGHET_ANGES_PER_ANVANDARE = "BEHORIGHET_ANGES_PER_ANVANDARE",
  BEHORIG_TILL_ALLA_TIDREDOVISNINGSGRUPPER = "BEHORIG_TILL_ALLA_TIDREDOVISNINGSGRUPPER",
  EJ_BEHORIG = "EJ_BEHORIG",
}

/**
 * Behörig till gåvogrupper för användare
 */
export enum TEDSYSUserMALLANV_STYRN_INST_7Enum {
  BEHORIGHET_ANGES_PER_ANVANDARE = "BEHORIGHET_ANGES_PER_ANVANDARE",
  BEHORIG_TILL_ALLA_GAVOGRUPPER = "BEHORIG_TILL_ALLA_GAVOGRUPPER",
  EJ_BEHORIG = "EJ_BEHORIG",
}

/**
 * Behörig till budgetgrupper för användare
 */
export enum TEDSYSUserMALLANV_STYRN_INST_8Enum {
  BEHORIGHET_ANGES_PER_ANVANDARE = "BEHORIGHET_ANGES_PER_ANVANDARE",
  BEHORIG_TILL_ALLA_BUDGETGRUPPER = "BEHORIG_TILL_ALLA_BUDGETGRUPPER",
  EJ_BEHORIG = "EJ_BEHORIG",
}

/**
 * Behörig till bisättningslokaler för användare
 */
export enum TEDSYSUserMALLANV_STYRN_INST_9Enum {
  BEHORIGHET_ANGES_PER_ANVANDARE = "BEHORIGHET_ANGES_PER_ANVANDARE",
  BEHORIG_TILL_ALLA_BISATTNINGSLOKALER = "BEHORIG_TILL_ALLA_BISATTNINGSLOKALER",
  EJ_BEHORIG = "EJ_BEHORIG",
}

/**
 * Kontrollera mot lösenordsregler för användare
 */
export enum TEDSYSUserPWD_CONSTRLEVEL_CHECKEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Kräv lösenordsbyte för användare
 */
export enum TEDSYSUserPWD_FORCE_CHANGEEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Byt lösenord, resultat
 */
export enum TEDSYSUserPwdResponse {
  ERROR = "ERROR",
  OK = "OK",
  TRY_AGAIN = "TRY_AGAIN",
}

/**
 * Systemadministratör för användare
 */
export enum TEDSYSUserSYSADMEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Betalningssättyp för utbetalningssätt
 */
export enum TEDSYSUtbetalningssattBETSATTEnum {
  BANKGIRO_MED_MEDDELANDE = "BANKGIRO_MED_MEDDELANDE",
  BANKGIRO_MED_OCR = "BANKGIRO_MED_OCR",
  BANKGIRO___BETALNING_TILL_PLUSGIRONUMMER = "BANKGIRO___BETALNING_TILL_PLUSGIRONUMMER",
  BANKGIRO___GIRERING_TILL_BANKGIROKONTO = "BANKGIRO___GIRERING_TILL_BANKGIROKONTO",
  BANKGIRO___KONTANTUTBETALNING = "BANKGIRO___KONTANTUTBETALNING",
  BANKGIRO___KONTOINSATTNING_MED_AVISERING = "BANKGIRO___KONTOINSATTNING_MED_AVISERING",
  BANKGIRO___KONTOINSATTNING_UTAN_AVISERING = "BANKGIRO___KONTOINSATTNING_UTAN_AVISERING",
  ISO_20022_UTLANDSBETALNINGAR = "ISO_20022_UTLANDSBETALNINGAR",
  KOB = "KOB",
  KONTANT_CHECK = "KONTANT_CHECK",
  KONTOINSATTNING = "KONTOINSATTNING",
  MANUELL_BETALNING = "MANUELL_BETALNING",
  PLUSGIRO_MED_MEDDELANDE = "PLUSGIRO_MED_MEDDELANDE",
  PLUSGIRO_MED_OCR = "PLUSGIRO_MED_OCR",
  PLUSGIRO___GIRERING_TILL_PLUSGIROKONTO = "PLUSGIRO___GIRERING_TILL_PLUSGIROKONTO",
  PLUSGIRO___KONTOINSATTNING_TILL_BANKKONTO = "PLUSGIRO___KONTOINSATTNING_TILL_BANKKONTO",
  PLUSGIRO___UTBETALNING_VIA_UTBETALNINGSKORT = "PLUSGIRO___UTBETALNING_VIA_UTBETALNINGSKORT",
  UTLAND__BANKGIRO___CHECK = "UTLAND__BANKGIRO___CHECK",
  UTLAND__BANKGIRO___SWIFT = "UTLAND__BANKGIRO___SWIFT",
  UTLAND__PLUSGIRO___CHECK = "UTLAND__PLUSGIRO___CHECK",
  UTLAND__PLUSGIRO___SWIFT = "UTLAND__PLUSGIRO___SWIFT",
}

/**
 * Registreras på leverantör för utbetalningssätt
 */
export enum TEDSYSUtbetalningssattREG_PA_LEVEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Använd valutaficka för utbetalningsväg
 */
export enum TEDSYSUtbetalningsvagANV_VALUTAFICKAEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Betalning av faktura för utbetalningsväg
 */
export enum TEDSYSUtbetalningsvagBETALNING_AV_FAKTURAEnum {
  ANGE_BETALNINGSDAG_VID_UTBETALNING = "ANGE_BETALNINGSDAG_VID_UTBETALNING",
  BETALA_PA_FORFALLODAG = "BETALA_PA_FORFALLODAG",
}

/**
 * Bank för utbetalningsväg
 */
export enum TEDSYSUtbetalningsvagBG_BANKEnum {
  SEB = "SEB",
  SWEDBANK = "SWEDBANK",
}

/**
 * Utbetalning skickas via för utbetalningsväg
 */
export enum TEDSYSUtbetalningsvagBIS_BANKEnum {
  DANSKE_BANK = "DANSKE_BANK",
  HANDELSBANKEN = "HANDELSBANKEN",
  NORDEA = "NORDEA",
  SEB = "SEB",
  SWEDBANK = "SWEDBANK",
}

/**
 * Typ för utbetalningsväg
 */
export enum TEDSYSUtbetalningsvagMEDIATYPEnum {
  BETALNINGAR__ISO_20022_ = "BETALNINGAR__ISO_20022_",
  FIL_TILL_BANKGIROT__INRIKES_OCH_UTRIKES_ = "FIL_TILL_BANKGIROT__INRIKES_OCH_UTRIKES_",
  FIL_TILL_KOB = "FIL_TILL_KOB",
  FIL_TILL_PLUSGIROT__INRIKES_ = "FIL_TILL_PLUSGIROT__INRIKES_",
  MANUELL_BETALNING = "MANUELL_BETALNING",
}

/**
 * Same day execution för utbetalningsväg
 */
export enum TEDSYSUtbetalningsvagSAME_DAY_EXECUTIONEnum {
  JA = "JA",
  NEJ = "NEJ",
}

/**
 * Teckenkodning för utbetalningsväg
 */
export enum TEDSYSUtbetalningsvagTECKENKODNINGEnum {
  CODEPAGE_850 = "CODEPAGE_850",
  ENLIGT_STANDARD = "ENLIGT_STANDARD",
  UTF_8 = "UTF_8",
  WINDOWS_1252__ISO8859_1_ = "WINDOWS_1252__ISO8859_1_",
}

/**
 * Fast kurs för valuta
 */
export enum TEDSYSValutaFASTKURSEnum {
  FAST = "FAST",
  FLYTANDE = "FLYTANDE",
}

/**
 * Avenyurval, villkorstyp
 */
export enum TEDSelectionConditionType {
  Boolean = "Boolean",
  Enum = "Enum",
  Extended = "Extended",
  Filter = "Filter",
  Value = "Value",
}

/**
 * Avenyurval, operatorer för utökat urval
 */
export enum TEDSelectionExtendedOperator {
  all = "all",
  exists = "exists",
  notexists = "notexists",
}

/**
 * Avenyurval, operatorer
 */
export enum TEDSelectionOperator {
  active = "active",
  contains = "contains",
  equals = "equals",
  greater = "greater",
  hasvalue = "hasvalue",
  interval = "interval",
  isnull = "isnull",
  less = "less",
  notcontains = "notcontains",
  notequals = "notequals",
  notgreater = "notgreater",
  notinterval = "notinterval",
  notless = "notless",
  notstarts = "notstarts",
  starts = "starts",
}

/**
 * Avenyurval, synlighet
 */
export enum TEDSelectionVisibility {
  dbstandard = "dbstandard",
  gemensamt = "gemensamt",
  grupp = "grupp",
  ingen = "ingen",
  privat = "privat",
  standard = "standard",
}

/**
 * Argument för att ändra gemensam utdelning för en analys
 */
export interface TEDGQInputAvenySetGemensamUtdelningArgs {
  analys_id: string;
  tillganglig_ek_analys?: boolean | null;
  user_default_ek_analys?: boolean | null;
  user_start_ek_analys?: boolean | null;
  grundurval_id?: string | null;
}

/**
 * Associerade värden vid tillägg av anläggningsgrupp
 */
export interface TEDInputARAnlGruppAddAssociationValues {
  AvskrkontoKred_Ref?: string | null;
  AvskrkontoKred_Values?: TEDInputEKKonteringsvardeAddValues | null;
  AvskrkontoDeb_Ref?: string | null;
  AvskrkontoDeb_Values?: TEDInputEKKonteringsvardeAddValues | null;
  InternRantaDeb_Ref?: string | null;
  InternRantaDeb_Values?: TEDInputEKKonteringsvardeAddValues | null;
  InternRantaKred_Ref?: string | null;
  InternRantaKred_Values?: TEDInputEKKonteringsvardeAddValues | null;
  HuvudRubrikAnlGrupp_Add_Values?: TEDInputARHuvudRubrikAnlGruppAddValues[] | null;
  InvradUrval_Add_Values?: TEDInputARAnlGruppInvUrvalAddValues[] | null;
}

/**
 * Värden vid tillägg av anläggningsgrupp
 */
export interface TEDInputARAnlGruppAddValues {
  BENAMNING?: string | null;
  AVST_INVKONTO?: TEDARAnlGruppAVST_INVKONTOEnum | null;
  IDKOD?: string | null;
  ANVANDS_FOR?: TEDARAnlGruppANVANDS_FOREnum | null;
  _Associations?: TEDInputARAnlGruppAddAssociationValues | null;
}

/**
 * Värden vid tillägg av urval investeringsrader
 */
export interface TEDInputARAnlGruppInvUrvalAddValues {
  VIEW_ID?: number | null;
  INTRANTA_URVAL: TEDARAnlGruppInvUrvalINTRANTA_URVALEnum;
  INTRANTA_VIEW_ID?: number | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av urval investeringsrader
 */
export interface TEDInputARAnlGruppInvUrvalDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av urval investeringsrader
 */
export interface TEDInputARAnlGruppInvUrvalUpdateValues {
  id: string;
  _version: number;
  VIEW_ID?: number | null;
  INTRANTA_URVAL?: TEDARAnlGruppInvUrvalINTRANTA_URVALEnum | null;
  INTRANTA_VIEW_ID?: number | null;
}

/**
 * Associerade värden vid ändring av anläggningsgrupp
 */
export interface TEDInputARAnlGruppUpdateAssociationValues {
  AvskrkontoKred_Ref?: string | null;
  AvskrkontoKred_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  AvskrkontoDeb_Ref?: string | null;
  AvskrkontoDeb_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  InternRantaDeb_Ref?: string | null;
  InternRantaDeb_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  InternRantaKred_Ref?: string | null;
  InternRantaKred_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  HuvudRubrikAnlGrupp_Add_Values?: TEDInputARHuvudRubrikAnlGruppAddValues[] | null;
  HuvudRubrikAnlGrupp_Update_Values?: TEDInputARHuvudRubrikAnlGruppUpdateValues[] | null;
  HuvudRubrikAnlGrupp_Delete_Values?: TEDInputARHuvudRubrikAnlGruppDeleteValues[] | null;
  InvradUrval_Add_Values?: TEDInputARAnlGruppInvUrvalAddValues[] | null;
  InvradUrval_Update_Values?: TEDInputARAnlGruppInvUrvalUpdateValues[] | null;
  InvradUrval_Delete_Values?: TEDInputARAnlGruppInvUrvalDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av anläggningsgrupp
 */
export interface TEDInputARAnlGruppUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  AVST_INVKONTO?: TEDARAnlGruppAVST_INVKONTOEnum | null;
  IDKOD?: string | null;
  ANVANDS_FOR?: TEDARAnlGruppANVANDS_FOREnum | null;
  _Associations?: TEDInputARAnlGruppUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av anläggningskategori
 */
export interface TEDInputARAnlKatAddAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputARAnlKatBlobAddValues | null;
  Tillgangar_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av anläggningskategori
 */
export interface TEDInputARAnlKatAddValues {
  AR_ANLKAT_ID: string;
  BENAMNING: string;
  LEDTEXT1?: string | null;
  LEDTEXT2?: string | null;
  LEDTEXT3?: string | null;
  LEDTEXT4?: string | null;
  LEDTEXT5?: string | null;
  LEDTEXT6?: string | null;
  LEDTEXT7?: string | null;
  LEDTEXT8?: string | null;
  NORMALAVSKRTID?: number | null;
  AKTIV?: boolean | null;
  _Associations?: TEDInputARAnlKatAddAssociationValues | null;
}

/**
 * Värden vid tillägg av aRAnlKatBlob
 */
export interface TEDInputARAnlKatBlobAddValues {
  BESKRIVNING?: string | null;
}

/**
 * Nya värden vid ändring av aRAnlKatBlob
 */
export interface TEDInputARAnlKatBlobUpdateValues {
  id: string;
  _version: number;
  BESKRIVNING?: string | null;
}

/**
 * Associerade värden vid ändring av anläggningskategori
 */
export interface TEDInputARAnlKatUpdateAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputARAnlKatBlobUpdateValues | null;
  Tillgangar_Add_Refs?: string[] | null;
  Tillgangar_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av anläggningskategori
 */
export interface TEDInputARAnlKatUpdateValues {
  id: string;
  _version: number;
  AR_ANLKAT_ID?: string | null;
  BENAMNING?: string | null;
  LEDTEXT1?: string | null;
  LEDTEXT2?: string | null;
  LEDTEXT3?: string | null;
  LEDTEXT4?: string | null;
  LEDTEXT5?: string | null;
  LEDTEXT6?: string | null;
  LEDTEXT7?: string | null;
  LEDTEXT8?: string | null;
  NORMALAVSKRTID?: number | null;
  AKTIV?: boolean | null;
  _Associations?: TEDInputARAnlKatUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av åtgärd
 */
export interface TEDInputARAtgardAddAssociationValues {
  Tillgang_Ref?: string | null;
  Tillgang_Values?: TEDInputARTillgangAddValues | null;
  Atgardskod_Ref?: string | null;
  Atgardskod_Values?: TEDInputARAtgardskodAddValues | null;
}

/**
 * Värden vid tillägg av åtgärd
 */
export interface TEDInputARAtgardAddValues {
  DATUM?: any | null;
  TEXT?: string | null;
  BELOPP?: any | null;
  _Associations: TEDInputARAtgardAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av åtgärd
 */
export interface TEDInputARAtgardDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av åtgärd
 */
export interface TEDInputARAtgardUpdateAssociationValues {
  Tillgang_Ref?: string | null;
  Tillgang_Values?: TEDInputARTillgangUpdateValues | null;
  Atgardskod_Ref?: string | null;
  Atgardskod_Values?: TEDInputARAtgardskodUpdateValues | null;
}

/**
 * Nya värden vid ändring av åtgärd
 */
export interface TEDInputARAtgardUpdateValues {
  id: string;
  _version: number;
  DATUM?: any | null;
  TEXT?: string | null;
  BELOPP?: any | null;
  _Associations?: TEDInputARAtgardUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av åtgärdskod
 */
export interface TEDInputARAtgardskodAddValues {
  KOD?: string | null;
  BENAMNING?: string | null;
  REG_BELOPP?: TEDARAtgardskodREG_BELOPPEnum | null;
}

/**
 * Nya värden vid ändring av åtgärdskod
 */
export interface TEDInputARAtgardskodUpdateValues {
  id: string;
  _version: number;
  KOD?: string | null;
  BENAMNING?: string | null;
  REG_BELOPP?: TEDARAtgardskodREG_BELOPPEnum | null;
}

/**
 * Associerade värden vid tillägg av investeringshändelse
 */
export interface TEDInputARAvrakningAddAssociationValues {
  Upprakning_Ref?: string | null;
  Upprakning_Values?: TEDInputARUpprakningAddValues | null;
  Tillgang_Ref?: string | null;
  Tillgang_Values?: TEDInputARTillgangAddValues | null;
}

/**
 * Värden vid tillägg av investeringshändelse
 */
export interface TEDInputARAvrakningAddValues {
  _typ: TEDARAvrakningTypEnum;
  BELOPP?: any | null;
  DATUM?: any | null;
  RUBRIK_ID?: number | null;
  AVSKRDIFF?: number | null;
  ANTECKNING?: string | null;
  KUNDNUMMER?: string | null;
  ORDERNUMMER?: string | null;
  UTRANGERAD?: boolean | null;
  FROM_DATUM?: any | null;
  TOM_DATUM?: any | null;
  JUST_AVSKR_BELOPP?: any | null;
  JUST_INV_BELOPP?: any | null;
  AVYTTR_UTRANG_TYP?: TEDARAvrakningAVYTTR_UTRANG_TYPEnum | null;
  _Associations?: TEDInputARAvrakningAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av investeringshändelse
 */
export interface TEDInputARAvrakningDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av investeringshändelse
 */
export interface TEDInputARAvrakningUpdateAssociationValues {
  Upprakning_Ref?: string | null;
  Upprakning_Values?: TEDInputARUpprakningUpdateValues | null;
  Tillgang_Ref?: string | null;
  Tillgang_Values?: TEDInputARTillgangUpdateValues | null;
}

/**
 * Nya värden vid ändring av investeringshändelse
 */
export interface TEDInputARAvrakningUpdateValues {
  id: string;
  _version: number;
  BELOPP?: any | null;
  DATUM?: any | null;
  RUBRIK_ID?: number | null;
  AVSKRDIFF?: number | null;
  ANTECKNING?: string | null;
  KUNDNUMMER?: string | null;
  ORDERNUMMER?: string | null;
  UTRANGERAD?: boolean | null;
  FROM_DATUM?: any | null;
  TOM_DATUM?: any | null;
  JUST_AVSKR_BELOPP?: any | null;
  JUST_INV_BELOPP?: any | null;
  AVYTTR_UTRANG_TYP?: TEDARAvrakningAVYTTR_UTRANG_TYPEnum | null;
  _Associations?: TEDInputARAvrakningUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av huvudrubrik
 */
export interface TEDInputARHuvudRubrikAddAssociationValues {
  HuvudRubrikAnlGrupp_Add_Refs?: string[] | null;
  HuvudRubrikRubrik_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av huvudrubrik
 */
export interface TEDInputARHuvudRubrikAddValues {
  BENAMNING?: string | null;
  ANLAGGNTILLG?: TEDARHuvudRubrikANLAGGNTILLGEnum | null;
  ATGARDER?: TEDARHuvudRubrikATGARDEREnum | null;
  IDKOD?: string | null;
  _Associations?: TEDInputARHuvudRubrikAddAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av huvudrubrik anl. grupp
 */
export interface TEDInputARHuvudRubrikAnlGruppAddAssociationValues {
  Huvudrubrik_Ref?: string | null;
  Huvudrubrik_Values?: TEDInputARHuvudRubrikAddValues | null;
  Nummerserie_Ref?: string | null;
  Nummerserie_Values?: TEDInputSYSNummerserieAddValues | null;
}

/**
 * Värden vid tillägg av huvudrubrik anl. grupp
 */
export interface TEDInputARHuvudRubrikAnlGruppAddValues {
  _Associations: TEDInputARHuvudRubrikAnlGruppAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av huvudrubrik anl. grupp
 */
export interface TEDInputARHuvudRubrikAnlGruppDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av huvudrubrik anl. grupp
 */
export interface TEDInputARHuvudRubrikAnlGruppUpdateAssociationValues {
  Huvudrubrik_Ref?: string | null;
  Huvudrubrik_Values?: TEDInputARHuvudRubrikUpdateValues | null;
  Nummerserie_Ref?: string | null;
  Nummerserie_Values?: TEDInputSYSNummerserieUpdateValues | null;
}

/**
 * Nya värden vid ändring av huvudrubrik anl. grupp
 */
export interface TEDInputARHuvudRubrikAnlGruppUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputARHuvudRubrikAnlGruppUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av huvudrubrik
 */
export interface TEDInputARHuvudRubrikUpdateAssociationValues {
  HuvudRubrikAnlGrupp_Add_Refs?: string[] | null;
  HuvudRubrikAnlGrupp_Delete_Refs?: string[] | null;
  HuvudRubrikRubrik_Add_Refs?: string[] | null;
  HuvudRubrikRubrik_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av huvudrubrik
 */
export interface TEDInputARHuvudRubrikUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  ANLAGGNTILLG?: TEDARHuvudRubrikANLAGGNTILLGEnum | null;
  ATGARDER?: TEDARHuvudRubrikATGARDEREnum | null;
  IDKOD?: string | null;
  _Associations?: TEDInputARHuvudRubrikUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av inventeringsansvariga
 */
export interface TEDInputARInvAnsvarigaAddAssociationValues {
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalAddValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
  InvOmgAnsvariga_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av inventeringsansvariga
 */
export interface TEDInputARInvAnsvarigaAddValues {
  _Associations: TEDInputARInvAnsvarigaAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av inventeringsansvariga
 */
export interface TEDInputARInvAnsvarigaDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av inventeringsansvariga
 */
export interface TEDInputARInvAnsvarigaUpdateAssociationValues {
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalUpdateValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
  InvOmgAnsvariga_Add_Refs?: string[] | null;
  InvOmgAnsvariga_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av inventeringsansvariga
 */
export interface TEDInputARInvAnsvarigaUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputARInvAnsvarigaUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av skattemässigt restvärde för investering
 */
export interface TEDInputARInvesteringSkattAddAssociationValues {
  Investering_Ref?: string | null;
  Investering_Values?: TEDInputARUpprakningAddValues | null;
  Tillgang_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av skattemässigt restvärde för investering
 */
export interface TEDInputARInvesteringSkattAddValues {
  ING_RESTVARDE?: any | null;
  INKOP?: any | null;
  FORSALJNING?: any | null;
  UTG_RESTVARDE?: any | null;
  INKOPS_AR?: any | null;
  PROCENT_SATS?: number | null;
  _Associations?: TEDInputARInvesteringSkattAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av skattemässigt restvärde för investering
 */
export interface TEDInputARInvesteringSkattDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av skattemässigt restvärde för investering
 */
export interface TEDInputARInvesteringSkattUpdateAssociationValues {
  Investering_Ref?: string | null;
  Investering_Values?: TEDInputARUpprakningUpdateValues | null;
  Tillgang_Add_Refs?: string[] | null;
  Tillgang_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av skattemässigt restvärde för investering
 */
export interface TEDInputARInvesteringSkattUpdateValues {
  id: string;
  _version: number;
  ING_RESTVARDE?: any | null;
  INKOP?: any | null;
  FORSALJNING?: any | null;
  UTG_RESTVARDE?: any | null;
  INKOPS_AR?: any | null;
  PROCENT_SATS?: number | null;
  _Associations?: TEDInputARInvesteringSkattUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av investeringsrad
 */
export interface TEDInputARInvesteringsradAddAssociationValues {
  Tillgang_Ref?: string | null;
  Tillgang_Values?: TEDInputARTillgangAddValues | null;
  Kontering_Ref?: string | null;
  Kontering_Values?: TEDInputEKBokfkonteringAddValues | null;
  BokfVer_Ref?: string | null;
  BokfVer_Values?: TEDInputEKBokfverAddValues | null;
  Investering_Ref?: string | null;
  Investering_Values?: TEDInputARUpprakningAddValues | null;
  Konteringsforslag_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av investeringsrad
 */
export interface TEDInputARInvesteringsradAddValues {
  _typ: TEDARInvesteringsradTypEnum;
  KNYT_DATUM?: any | null;
  KNYT_SIGN?: string | null;
  BOKF_DATUM?: any | null;
  MANUELL_VER_NR?: number | null;
  KONTOSTRANG?: string | null;
  LEV_NR?: string | null;
  LEV_NAMN?: string | null;
  FAKTURA_NR?: string | null;
  KONTERINGSTEXT?: string | null;
  BELOPP?: any | null;
  KPLAN_ID?: number | null;
  ORDNINGS_NR_1?: number | null;
  KONTOID_1?: number | null;
  ORDNINGS_NR_2?: number | null;
  KONTOID_2?: number | null;
  ORDNINGS_NR_3?: number | null;
  KONTOID_3?: number | null;
  ORDNINGS_NR_4?: number | null;
  KONTOID_4?: number | null;
  ORDNINGS_NR_5?: number | null;
  KONTOID_5?: number | null;
  ORDNINGS_NR_6?: number | null;
  KONTOID_6?: number | null;
  ORDNINGS_NR_7?: number | null;
  KONTOID_7?: number | null;
  ORDNINGS_NR_8?: number | null;
  KONTOID_8?: number | null;
  ORDNINGS_NR_9?: number | null;
  KONTOID_9?: number | null;
  ORDNINGS_NR_10?: number | null;
  KONTOID_10?: number | null;
  STATUS?: TEDARInvesteringsradSTATUSEnum | null;
  STATUS_DATUM?: any | null;
  INVRAD_ID?: number | null;
  _Associations?: TEDInputARInvesteringsradAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av investeringsrad
 */
export interface TEDInputARInvesteringsradUpdateAssociationValues {
  Tillgang_Ref?: string | null;
  Tillgang_Values?: TEDInputARTillgangUpdateValues | null;
  Kontering_Ref?: string | null;
  Kontering_Values?: TEDInputEKBokfkonteringUpdateValues | null;
  BokfVer_Ref?: string | null;
  BokfVer_Values?: TEDInputEKBokfverUpdateValues | null;
  Investering_Ref?: string | null;
  Investering_Values?: TEDInputARUpprakningUpdateValues | null;
  Konteringsforslag_Add_Refs?: string[] | null;
  Konteringsforslag_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av investeringsrad
 */
export interface TEDInputARInvesteringsradUpdateValues {
  id: string;
  _version: number;
  KNYT_DATUM?: any | null;
  KNYT_SIGN?: string | null;
  BOKF_DATUM?: any | null;
  MANUELL_VER_NR?: number | null;
  KONTOSTRANG?: string | null;
  LEV_NR?: string | null;
  LEV_NAMN?: string | null;
  FAKTURA_NR?: string | null;
  KONTERINGSTEXT?: string | null;
  BELOPP?: any | null;
  KPLAN_ID?: number | null;
  ORDNINGS_NR_1?: number | null;
  KONTOID_1?: number | null;
  ORDNINGS_NR_2?: number | null;
  KONTOID_2?: number | null;
  ORDNINGS_NR_3?: number | null;
  KONTOID_3?: number | null;
  ORDNINGS_NR_4?: number | null;
  KONTOID_4?: number | null;
  ORDNINGS_NR_5?: number | null;
  KONTOID_5?: number | null;
  ORDNINGS_NR_6?: number | null;
  KONTOID_6?: number | null;
  ORDNINGS_NR_7?: number | null;
  KONTOID_7?: number | null;
  ORDNINGS_NR_8?: number | null;
  KONTOID_8?: number | null;
  ORDNINGS_NR_9?: number | null;
  KONTOID_9?: number | null;
  ORDNINGS_NR_10?: number | null;
  KONTOID_10?: number | null;
  STATUS?: TEDARInvesteringsradSTATUSEnum | null;
  STATUS_DATUM?: any | null;
  INVRAD_ID?: number | null;
  _Associations?: TEDInputARInvesteringsradUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av komponenttyp
 */
export interface TEDInputARKomponentAddValues {
  BENAMNING?: string | null;
  AKTIV?: boolean | null;
}

/**
 * Nya värden vid ändring av komponenttyp
 */
export interface TEDInputARKomponentUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  AKTIV?: boolean | null;
}

/**
 * Associerade värden vid tillägg av område/Byggnad/Rum
 */
export interface TEDInputARPlatsAddAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputARPlatsBlobAddValues | null;
  Plats_Ref?: string | null;
  Plats_Values?: TEDInputARPlatsAddValues | null;
  AnlGrupp_Ref?: string | null;
  AnlGrupp_Values?: TEDInputARAnlGruppAddValues | null;
  Tillgangar_Add_Refs?: string[] | null;
  AvskrkontoKred_Add_Values?: TEDInputEKKonteringsvardeAddValues[] | null;
  AvskrkontoDeb_Add_Values?: TEDInputEKKonteringsvardeAddValues[] | null;
  InternRantaDeb_Add_Values?: TEDInputEKKonteringsvardeAddValues[] | null;
  InternRantaKred_Add_Values?: TEDInputEKKonteringsvardeAddValues[] | null;
}

/**
 * Värden vid tillägg av område/Byggnad/Rum
 */
export interface TEDInputARPlatsAddValues {
  _typ: TEDARPlatsTypEnum;
  BENAMNING: string;
  PLATS_KOD?: string | null;
  ANVANDS_I_AR?: TEDARPlatsANVANDS_I_AREnum | null;
  ANVANDS_I_EK?: boolean | null;
  FASTIGHETSBETECKNING?: string | null;
  AKTIV?: boolean | null;
  FASTIGHETSNUMMER?: string | null;
  FASTIGHETSTYP?: TEDARPlatsFASTIGHETSTYPEnum | null;
  _Associations?: TEDInputARPlatsAddAssociationValues | null;
}

/**
 * Värden vid tillägg av aRPlatsBlob
 */
export interface TEDInputARPlatsBlobAddValues {
  BESKRIVNING?: string | null;
}

/**
 * Nya värden vid ändring av aRPlatsBlob
 */
export interface TEDInputARPlatsBlobUpdateValues {
  id: string;
  _version: number;
  BESKRIVNING?: string | null;
}

/**
 * Associerade värden vid ändring av område/Byggnad/Rum
 */
export interface TEDInputARPlatsUpdateAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputARPlatsBlobUpdateValues | null;
  Plats_Ref?: string | null;
  Plats_Values?: TEDInputARPlatsUpdateValues | null;
  AnlGrupp_Ref?: string | null;
  AnlGrupp_Values?: TEDInputARAnlGruppUpdateValues | null;
  Tillgangar_Add_Refs?: string[] | null;
  Tillgangar_Delete_Refs?: string[] | null;
  AvskrkontoKred_Add_Values?: TEDInputEKKonteringsvardeAddValues[] | null;
  AvskrkontoKred_Update_Values?: TEDInputEKKonteringsvardeUpdateValues[] | null;
  AvskrkontoKred_Delete_Values?: TEDInputEKKonteringsvardeDeleteValues[] | null;
  AvskrkontoDeb_Add_Values?: TEDInputEKKonteringsvardeAddValues[] | null;
  AvskrkontoDeb_Update_Values?: TEDInputEKKonteringsvardeUpdateValues[] | null;
  AvskrkontoDeb_Delete_Values?: TEDInputEKKonteringsvardeDeleteValues[] | null;
  InternRantaDeb_Add_Values?: TEDInputEKKonteringsvardeAddValues[] | null;
  InternRantaDeb_Update_Values?: TEDInputEKKonteringsvardeUpdateValues[] | null;
  InternRantaDeb_Delete_Values?: TEDInputEKKonteringsvardeDeleteValues[] | null;
  InternRantaKred_Add_Values?: TEDInputEKKonteringsvardeAddValues[] | null;
  InternRantaKred_Update_Values?: TEDInputEKKonteringsvardeUpdateValues[] | null;
  InternRantaKred_Delete_Values?: TEDInputEKKonteringsvardeDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av område/Byggnad/Rum
 */
export interface TEDInputARPlatsUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  PLATS_KOD?: string | null;
  ANVANDS_I_AR?: TEDARPlatsANVANDS_I_AREnum | null;
  ANVANDS_I_EK?: boolean | null;
  FASTIGHETSBETECKNING?: string | null;
  AKTIV?: boolean | null;
  FASTIGHETSNUMMER?: string | null;
  FASTIGHETSTYP?: TEDARPlatsFASTIGHETSTYPEnum | null;
  _Associations?: TEDInputARPlatsUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av rubrik
 */
export interface TEDInputARRubrikAddAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputARRubrikBlobAddValues | null;
  AvskrkontoKred_Ref?: string | null;
  AvskrkontoKred_Values?: TEDInputEKKonteringsvardeAddValues | null;
  AvskrkontoDeb_Ref?: string | null;
  AvskrkontoDeb_Values?: TEDInputEKKonteringsvardeAddValues | null;
  InternRantaDeb_Ref?: string | null;
  InternRantaDeb_Values?: TEDInputEKKonteringsvardeAddValues | null;
  InternRantaKred_Ref?: string | null;
  InternRantaKred_Values?: TEDInputEKKonteringsvardeAddValues | null;
  HuvudRubrik_Ref?: string | null;
  HuvudRubrik_Values?: TEDInputARHuvudRubrikAddValues | null;
  Tillgangar_Add_Refs?: string[] | null;
  SkatteRestvarde_Add_Values?: TEDInputARRubrikSkattAddValues[] | null;
  AnlKategorier_Add_Values?: TEDInputARRubrikAnlKatAddValues[] | null;
  UrvalInvradRub_Add_Values?: TEDInputARRubrikInvUrvalAddValues[] | null;
}

/**
 * Värden vid tillägg av rubrik
 */
export interface TEDInputARRubrikAddValues {
  AR_RUBRIK_ID: string;
  ANLAGGNINGSTYP?: string | null;
  BENAMNING: string;
  SKATTEMASSIG?: TEDARRubrikSKATTEMASSIGEnum | null;
  AKTIV?: boolean | null;
  _Associations: TEDInputARRubrikAddAssociationValues;
}

/**
 * Värden vid tillägg av rubrik anläggningskategori
 */
export interface TEDInputARRubrikAnlKatAddValues {
  dummy?: number | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av rubrik anläggningskategori
 */
export interface TEDInputARRubrikAnlKatDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av rubrik anläggningskategori
 */
export interface TEDInputARRubrikAnlKatUpdateValues {
  id: string;
  _version: number;
  dummy?: number | null;
}

/**
 * Värden vid tillägg av aRRubrikBlob
 */
export interface TEDInputARRubrikBlobAddValues {
  BESKRIVNING?: string | null;
}

/**
 * Nya värden vid ändring av aRRubrikBlob
 */
export interface TEDInputARRubrikBlobUpdateValues {
  id: string;
  _version: number;
  BESKRIVNING?: string | null;
}

/**
 * Värden vid tillägg av urval invrader, rubrik
 */
export interface TEDInputARRubrikInvUrvalAddValues {
  VIEW_ID?: number | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av urval invrader, rubrik
 */
export interface TEDInputARRubrikInvUrvalDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av urval invrader, rubrik
 */
export interface TEDInputARRubrikInvUrvalUpdateValues {
  id: string;
  _version: number;
  VIEW_ID?: number | null;
}

/**
 * Associerade värden vid tillägg av skattemässiga restvärde
 */
export interface TEDInputARRubrikSkattAddAssociationValues {
  Rubrik_Ref?: string | null;
  Rubrik_Values?: TEDInputARRubrikAddValues | null;
}

/**
 * Värden vid tillägg av skattemässiga restvärde
 */
export interface TEDInputARRubrikSkattAddValues {
  ING_RESTVARDE?: any | null;
  INKOP?: any | null;
  FORSALJNING?: any | null;
  UTG_RESTVARDE?: any | null;
  SKATTEREGEL?: string | null;
  _Associations?: TEDInputARRubrikSkattAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av skattemässiga restvärde
 */
export interface TEDInputARRubrikSkattDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av skattemässiga restvärde
 */
export interface TEDInputARRubrikSkattUpdateAssociationValues {
  Rubrik_Ref?: string | null;
  Rubrik_Values?: TEDInputARRubrikUpdateValues | null;
}

/**
 * Nya värden vid ändring av skattemässiga restvärde
 */
export interface TEDInputARRubrikSkattUpdateValues {
  id: string;
  _version: number;
  ING_RESTVARDE?: any | null;
  INKOP?: any | null;
  FORSALJNING?: any | null;
  UTG_RESTVARDE?: any | null;
  SKATTEREGEL?: string | null;
  _Associations?: TEDInputARRubrikSkattUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av rubrik
 */
export interface TEDInputARRubrikUpdateAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputARRubrikBlobUpdateValues | null;
  AvskrkontoKred_Ref?: string | null;
  AvskrkontoKred_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  AvskrkontoDeb_Ref?: string | null;
  AvskrkontoDeb_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  InternRantaDeb_Ref?: string | null;
  InternRantaDeb_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  InternRantaKred_Ref?: string | null;
  InternRantaKred_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  HuvudRubrik_Ref?: string | null;
  HuvudRubrik_Values?: TEDInputARHuvudRubrikUpdateValues | null;
  Tillgangar_Add_Refs?: string[] | null;
  Tillgangar_Delete_Refs?: string[] | null;
  SkatteRestvarde_Add_Values?: TEDInputARRubrikSkattAddValues[] | null;
  SkatteRestvarde_Update_Values?: TEDInputARRubrikSkattUpdateValues[] | null;
  SkatteRestvarde_Delete_Values?: TEDInputARRubrikSkattDeleteValues[] | null;
  AnlKategorier_Add_Values?: TEDInputARRubrikAnlKatAddValues[] | null;
  AnlKategorier_Update_Values?: TEDInputARRubrikAnlKatUpdateValues[] | null;
  AnlKategorier_Delete_Values?: TEDInputARRubrikAnlKatDeleteValues[] | null;
  UrvalInvradRub_Add_Values?: TEDInputARRubrikInvUrvalAddValues[] | null;
  UrvalInvradRub_Update_Values?: TEDInputARRubrikInvUrvalUpdateValues[] | null;
  UrvalInvradRub_Delete_Values?: TEDInputARRubrikInvUrvalDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av rubrik
 */
export interface TEDInputARRubrikUpdateValues {
  id: string;
  _version: number;
  AR_RUBRIK_ID?: string | null;
  ANLAGGNINGSTYP?: string | null;
  BENAMNING?: string | null;
  SKATTEMASSIG?: TEDARRubrikSKATTEMASSIGEnum | null;
  AKTIV?: boolean | null;
  _Associations?: TEDInputARRubrikUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av skattemässig investeringshändelse
 */
export interface TEDInputARSKVAvrakningAddAssociationValues {
  Upprakning_Ref?: string | null;
  Upprakning_Values?: TEDInputARUpprakningAddValues | null;
}

/**
 * Värden vid tillägg av skattemässig investeringshändelse
 */
export interface TEDInputARSKVAvrakningAddValues {
  _typ: TEDARSKVAvrakningTypEnum;
  BELOPP?: any | null;
  DATUM?: any | null;
  FROM_DATUM?: any | null;
  TOM_DATUM?: any | null;
  AVYTTR_UTRANG_TYP?: TEDARSKVAvrakningAVYTTR_UTRANG_TYPEnum | null;
  AVSKRDIFF?: number | null;
  NOTERING?: string | null;
  JUST_AVSKR_BELOPP?: any | null;
  JUST_INV_BELOPP?: any | null;
  _Associations?: TEDInputARSKVAvrakningAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av skattemässig investeringshändelse
 */
export interface TEDInputARSKVAvrakningDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av skattemässig investeringshändelse
 */
export interface TEDInputARSKVAvrakningUpdateAssociationValues {
  Upprakning_Ref?: string | null;
  Upprakning_Values?: TEDInputARUpprakningUpdateValues | null;
}

/**
 * Nya värden vid ändring av skattemässig investeringshändelse
 */
export interface TEDInputARSKVAvrakningUpdateValues {
  id: string;
  _version: number;
  BELOPP?: any | null;
  DATUM?: any | null;
  FROM_DATUM?: any | null;
  TOM_DATUM?: any | null;
  AVYTTR_UTRANG_TYP?: TEDARSKVAvrakningAVYTTR_UTRANG_TYPEnum | null;
  AVSKRDIFF?: number | null;
  NOTERING?: string | null;
  JUST_AVSKR_BELOPP?: any | null;
  JUST_INV_BELOPP?: any | null;
  _Associations?: TEDInputARSKVAvrakningUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av anläggningstillgång/Inventarie
 */
export interface TEDInputARTillgangAddAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputARTillgangBlobAddValues | null;
  Plats_Ref?: string | null;
  Plats_Values?: TEDInputARPlatsAddValues | null;
  AnlKat_Ref?: string | null;
  AnlKat_Values?: TEDInputARAnlKatAddValues | null;
  Rubrik_Ref?: string | null;
  Rubrik_Values?: TEDInputARRubrikAddValues | null;
  AvskrkontoDeb_Ref?: string | null;
  AvskrkontoDeb_Values?: TEDInputEKKonteringsvardeAddValues | null;
  AvskrkontoKred_Ref?: string | null;
  AvskrkontoKred_Values?: TEDInputEKKonteringsvardeAddValues | null;
  InternrantekontoDeb_Ref?: string | null;
  InternrantekontoDeb_Values?: TEDInputEKKonteringsvardeAddValues | null;
  InternrantekontoKred_Ref?: string | null;
  InternrantekontoKred_Values?: TEDInputEKKonteringsvardeAddValues | null;
  AnlGrupp_Ref?: string | null;
  AnlGrupp_Values?: TEDInputARAnlGruppAddValues | null;
  Verksamhetskod_Ref?: string | null;
  Verksamhetskod_Values?: TEDInputARVerksamhetskodAddValues | null;
  Upprakningar_Add_Values?: TEDInputARUpprakningAddValues[] | null;
  Dokument_Add_Values?: TEDInputARTillgangOLEAddValues[] | null;
  Atgard_Add_Values?: TEDInputARAtgardAddValues[] | null;
  Logg_Add_Values?: TEDInputARTillgangLoggAddValues[] | null;
  Vardering_Add_Values?: TEDInputARTillgangVarderingAddValues[] | null;
  Fordelning_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av anläggningstillgång/Inventarie
 */
export interface TEDInputARTillgangAddValues {
  ANLAGGNINGS_NR?: string | null;
  BENAMNING: string;
  ANLKATDATA1?: string | null;
  ANLKATDATA2?: string | null;
  ANLKATDATA3?: string | null;
  ANLKATDATA4?: string | null;
  ANLKATDATA5?: string | null;
  ANLKATDATA6?: string | null;
  ANLKATDATA7?: string | null;
  ANLKATDATA8?: string | null;
  ANLAGGNTILLG?: TEDARTillgangANLAGGNTILLGEnum | null;
  ANSKAFFDATUM_FROM?: string | null;
  ANSKAFFDATUM_TOM?: string | null;
  INTERNRANTEBERAKNAS?: string | null;
  FORVALTNINGSFASTIGHET?: boolean | null;
  HISTORISKT_ID?: string | null;
  ANLKATDATA1_ANDRAD_SIGN?: string | null;
  ANLKATDATA2_ANDRAD_SIGN?: string | null;
  ANLKATDATA3_ANDRAD_SIGN?: string | null;
  ANLKATDATA4_ANDRAD_SIGN?: string | null;
  ANLKATDATA5_ANDRAD_SIGN?: string | null;
  ANLKATDATA6_ANDRAD_SIGN?: string | null;
  ANLKATDATA7_ANDRAD_SIGN?: string | null;
  ANLKATDATA8_ANDRAD_SIGN?: string | null;
  ANLKATDATA1_ANDRAD_DATUM?: any | null;
  ANLKATDATA2_ANDRAD_DATUM?: any | null;
  ANLKATDATA3_ANDRAD_DATUM?: any | null;
  ANLKATDATA4_ANDRAD_DATUM?: any | null;
  ANLKATDATA5_ANDRAD_DATUM?: any | null;
  ANLKATDATA6_ANDRAD_DATUM?: any | null;
  ANLKATDATA7_ANDRAD_DATUM?: any | null;
  ANLKATDATA8_ANDRAD_DATUM?: any | null;
  ANLKATDATA1_ANDRAD_FRAN: TEDARTillgangANLKATDATA1_ANDRAD_FRANEnum;
  ANLKATDATA2_ANDRAD_FRAN: TEDARTillgangANLKATDATA2_ANDRAD_FRANEnum;
  ANLKATDATA3_ANDRAD_FRAN: TEDARTillgangANLKATDATA3_ANDRAD_FRANEnum;
  ANLKATDATA4_ANDRAD_FRAN: TEDARTillgangANLKATDATA4_ANDRAD_FRANEnum;
  ANLKATDATA5_ANDRAD_FRAN: TEDARTillgangANLKATDATA5_ANDRAD_FRANEnum;
  ANLKATDATA6_ANDRAD_FRAN: TEDARTillgangANLKATDATA6_ANDRAD_FRANEnum;
  ANLKATDATA7_ANDRAD_FRAN: TEDARTillgangANLKATDATA7_ANDRAD_FRANEnum;
  ANLKATDATA8_ANDRAD_FRAN: TEDARTillgangANLKATDATA8_ANDRAD_FRANEnum;
  FI_KVARVARANDE?: boolean | null;
  _Associations: TEDInputARTillgangAddAssociationValues;
}

/**
 * Värden vid tillägg av aRTillgangBlob
 */
export interface TEDInputARTillgangBlobAddValues {
  BESKRIVNING?: string | null;
  BILD?: string | null;
  LJUD?: string | null;
  BildSize?: number | null;
  LjudSize?: number | null;
  BILDANTECKNING?: string | null;
  BILDDATUM?: any | null;
  BESKR_ANDRAD_DATUM?: any | null;
  BESKR_ANDRAD_SIGN?: string | null;
  BESKR_ANDRAD_FRAN: TEDARTillgangBlobBESKR_ANDRAD_FRANEnum;
}

/**
 * Nya värden vid ändring av aRTillgangBlob
 */
export interface TEDInputARTillgangBlobUpdateValues {
  id: string;
  _version: number;
  BESKRIVNING?: string | null;
  BILD?: string | null;
  LJUD?: string | null;
  BildSize?: number | null;
  LjudSize?: number | null;
  BILDANTECKNING?: string | null;
  BILDDATUM?: any | null;
  BESKR_ANDRAD_DATUM?: any | null;
  BESKR_ANDRAD_SIGN?: string | null;
  BESKR_ANDRAD_FRAN?: TEDARTillgangBlobBESKR_ANDRAD_FRANEnum | null;
}

/**
 * Associerade värden vid tillägg av anläggningstillgång, logg
 */
export interface TEDInputARTillgangLoggAddAssociationValues {
  FranRubrik_Ref?: string | null;
  FranRubrik_Values?: TEDInputARRubrikAddValues | null;
  TillRubrik_Ref?: string | null;
  TillRubrik_Values?: TEDInputARRubrikAddValues | null;
  Investering_Ref?: string | null;
  Investering_Values?: TEDInputARUpprakningAddValues | null;
  FlyttadFran_Ref?: string | null;
  FlyttadFran_Values?: TEDInputARTillgangAddValues | null;
}

/**
 * Värden vid tillägg av anläggningstillgång, logg
 */
export interface TEDInputARTillgangLoggAddValues {
  LOPNR?: number | null;
  ANDRINGSTYP: TEDARTillgangLoggANDRINGSTYPEnum;
  EXTERN_LOGGTEXT?: string | null;
  INTERN_LOGGTEXT?: string | null;
  SIGNATUR?: string | null;
  DATUM?: any | null;
  TID?: any | null;
  BR_BOKF_DATUM?: any | null;
  BR_BOKF_AR?: any | null;
  BR_VER_NR?: number | null;
  BR_SKV_ANSKAFFN?: any | null;
  BR_SKV_AVSKRIVN?: any | null;
  BR_SKV_NEDSKRIVN?: any | null;
  _Associations?: TEDInputARTillgangLoggAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av anläggningstillgång, logg
 */
export interface TEDInputARTillgangLoggDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av anläggningstillgång, logg
 */
export interface TEDInputARTillgangLoggUpdateAssociationValues {
  FranRubrik_Ref?: string | null;
  FranRubrik_Values?: TEDInputARRubrikUpdateValues | null;
  TillRubrik_Ref?: string | null;
  TillRubrik_Values?: TEDInputARRubrikUpdateValues | null;
  Investering_Ref?: string | null;
  Investering_Values?: TEDInputARUpprakningUpdateValues | null;
  FlyttadFran_Ref?: string | null;
  FlyttadFran_Values?: TEDInputARTillgangUpdateValues | null;
}

/**
 * Nya värden vid ändring av anläggningstillgång, logg
 */
export interface TEDInputARTillgangLoggUpdateValues {
  id: string;
  _version: number;
  LOPNR?: number | null;
  ANDRINGSTYP?: TEDARTillgangLoggANDRINGSTYPEnum | null;
  EXTERN_LOGGTEXT?: string | null;
  INTERN_LOGGTEXT?: string | null;
  SIGNATUR?: string | null;
  DATUM?: any | null;
  TID?: any | null;
  BR_BOKF_DATUM?: any | null;
  BR_BOKF_AR?: any | null;
  BR_VER_NR?: number | null;
  BR_SKV_ANSKAFFN?: any | null;
  BR_SKV_AVSKRIVN?: any | null;
  BR_SKV_NEDSKRIVN?: any | null;
  _Associations?: TEDInputARTillgangLoggUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av dokument
 */
export interface TEDInputARTillgangOLEAddAssociationValues {
  Tillgang_Ref?: string | null;
  Tillgang_Values?: TEDInputARTillgangAddValues | null;
}

/**
 * Värden vid tillägg av dokument
 */
export interface TEDInputARTillgangOLEAddValues {
  BESKRIVNING?: string | null;
  EXTENSION?: string | null;
  OLECLASSNAME?: string | null;
  BINARDATA?: string | null;
  BinarDataSize?: number | null;
  DATATYPE?: string | null;
  AVSER_BOKFAR?: any | null;
  _Associations?: TEDInputARTillgangOLEAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av dokument
 */
export interface TEDInputARTillgangOLEDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av dokument
 */
export interface TEDInputARTillgangOLEUpdateAssociationValues {
  Tillgang_Ref?: string | null;
  Tillgang_Values?: TEDInputARTillgangUpdateValues | null;
}

/**
 * Nya värden vid ändring av dokument
 */
export interface TEDInputARTillgangOLEUpdateValues {
  id: string;
  _version: number;
  BESKRIVNING?: string | null;
  EXTENSION?: string | null;
  OLECLASSNAME?: string | null;
  BINARDATA?: string | null;
  BinarDataSize?: number | null;
  DATATYPE?: string | null;
  AVSER_BOKFAR?: any | null;
  _Associations?: TEDInputARTillgangOLEUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av anläggningstillgång/Inventarie
 */
export interface TEDInputARTillgangUpdateAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputARTillgangBlobUpdateValues | null;
  Plats_Ref?: string | null;
  Plats_Values?: TEDInputARPlatsUpdateValues | null;
  AnlKat_Ref?: string | null;
  AnlKat_Values?: TEDInputARAnlKatUpdateValues | null;
  Rubrik_Ref?: string | null;
  Rubrik_Values?: TEDInputARRubrikUpdateValues | null;
  AvskrkontoDeb_Ref?: string | null;
  AvskrkontoDeb_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  AvskrkontoKred_Ref?: string | null;
  AvskrkontoKred_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  InternrantekontoDeb_Ref?: string | null;
  InternrantekontoDeb_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  InternrantekontoKred_Ref?: string | null;
  InternrantekontoKred_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  AnlGrupp_Ref?: string | null;
  AnlGrupp_Values?: TEDInputARAnlGruppUpdateValues | null;
  Verksamhetskod_Ref?: string | null;
  Verksamhetskod_Values?: TEDInputARVerksamhetskodUpdateValues | null;
  Upprakningar_Add_Values?: TEDInputARUpprakningAddValues[] | null;
  Upprakningar_Update_Values?: TEDInputARUpprakningUpdateValues[] | null;
  Upprakningar_Delete_Values?: TEDInputARUpprakningDeleteValues[] | null;
  Dokument_Add_Values?: TEDInputARTillgangOLEAddValues[] | null;
  Dokument_Update_Values?: TEDInputARTillgangOLEUpdateValues[] | null;
  Dokument_Delete_Values?: TEDInputARTillgangOLEDeleteValues[] | null;
  Atgard_Add_Values?: TEDInputARAtgardAddValues[] | null;
  Atgard_Update_Values?: TEDInputARAtgardUpdateValues[] | null;
  Atgard_Delete_Values?: TEDInputARAtgardDeleteValues[] | null;
  Logg_Add_Values?: TEDInputARTillgangLoggAddValues[] | null;
  Logg_Update_Values?: TEDInputARTillgangLoggUpdateValues[] | null;
  Logg_Delete_Values?: TEDInputARTillgangLoggDeleteValues[] | null;
  Vardering_Add_Values?: TEDInputARTillgangVarderingAddValues[] | null;
  Vardering_Update_Values?: TEDInputARTillgangVarderingUpdateValues[] | null;
  Vardering_Delete_Values?: TEDInputARTillgangVarderingDeleteValues[] | null;
  Fordelning_Add_Refs?: string[] | null;
  Fordelning_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av anläggningstillgång/Inventarie
 */
export interface TEDInputARTillgangUpdateValues {
  id: string;
  _version: number;
  ANLAGGNINGS_NR?: string | null;
  BENAMNING?: string | null;
  ANLKATDATA1?: string | null;
  ANLKATDATA2?: string | null;
  ANLKATDATA3?: string | null;
  ANLKATDATA4?: string | null;
  ANLKATDATA5?: string | null;
  ANLKATDATA6?: string | null;
  ANLKATDATA7?: string | null;
  ANLKATDATA8?: string | null;
  ANLAGGNTILLG?: TEDARTillgangANLAGGNTILLGEnum | null;
  ANSKAFFDATUM_FROM?: string | null;
  ANSKAFFDATUM_TOM?: string | null;
  INTERNRANTEBERAKNAS?: string | null;
  FORVALTNINGSFASTIGHET?: boolean | null;
  HISTORISKT_ID?: string | null;
  ANLKATDATA1_ANDRAD_SIGN?: string | null;
  ANLKATDATA2_ANDRAD_SIGN?: string | null;
  ANLKATDATA3_ANDRAD_SIGN?: string | null;
  ANLKATDATA4_ANDRAD_SIGN?: string | null;
  ANLKATDATA5_ANDRAD_SIGN?: string | null;
  ANLKATDATA6_ANDRAD_SIGN?: string | null;
  ANLKATDATA7_ANDRAD_SIGN?: string | null;
  ANLKATDATA8_ANDRAD_SIGN?: string | null;
  ANLKATDATA1_ANDRAD_DATUM?: any | null;
  ANLKATDATA2_ANDRAD_DATUM?: any | null;
  ANLKATDATA3_ANDRAD_DATUM?: any | null;
  ANLKATDATA4_ANDRAD_DATUM?: any | null;
  ANLKATDATA5_ANDRAD_DATUM?: any | null;
  ANLKATDATA6_ANDRAD_DATUM?: any | null;
  ANLKATDATA7_ANDRAD_DATUM?: any | null;
  ANLKATDATA8_ANDRAD_DATUM?: any | null;
  ANLKATDATA1_ANDRAD_FRAN?: TEDARTillgangANLKATDATA1_ANDRAD_FRANEnum | null;
  ANLKATDATA2_ANDRAD_FRAN?: TEDARTillgangANLKATDATA2_ANDRAD_FRANEnum | null;
  ANLKATDATA3_ANDRAD_FRAN?: TEDARTillgangANLKATDATA3_ANDRAD_FRANEnum | null;
  ANLKATDATA4_ANDRAD_FRAN?: TEDARTillgangANLKATDATA4_ANDRAD_FRANEnum | null;
  ANLKATDATA5_ANDRAD_FRAN?: TEDARTillgangANLKATDATA5_ANDRAD_FRANEnum | null;
  ANLKATDATA6_ANDRAD_FRAN?: TEDARTillgangANLKATDATA6_ANDRAD_FRANEnum | null;
  ANLKATDATA7_ANDRAD_FRAN?: TEDARTillgangANLKATDATA7_ANDRAD_FRANEnum | null;
  ANLKATDATA8_ANDRAD_FRAN?: TEDARTillgangANLKATDATA8_ANDRAD_FRANEnum | null;
  FI_KVARVARANDE?: boolean | null;
  _Associations?: TEDInputARTillgangUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av värdering
 */
export interface TEDInputARTillgangVarderingAddAssociationValues {
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
}

/**
 * Värden vid tillägg av värdering
 */
export interface TEDInputARTillgangVarderingAddValues {
  VARDE_DATUM?: any | null;
  VARDE?: any | null;
  NOTERING?: string | null;
  DATUM?: any | null;
  _Associations?: TEDInputARTillgangVarderingAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av värdering
 */
export interface TEDInputARTillgangVarderingDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av värdering
 */
export interface TEDInputARTillgangVarderingUpdateAssociationValues {
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
}

/**
 * Nya värden vid ändring av värdering
 */
export interface TEDInputARTillgangVarderingUpdateValues {
  id: string;
  _version: number;
  VARDE_DATUM?: any | null;
  VARDE?: any | null;
  NOTERING?: string | null;
  DATUM?: any | null;
  _Associations?: TEDInputARTillgangVarderingUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av bild
 */
export interface TEDInputARUpprBlobAddValues {
  BILD?: string | null;
  BILDSIZE?: number | null;
  BILDSTRETCH?: string | null;
  BILDANTECKNING?: string | null;
  BILDDATUM?: any | null;
  BILD_ANDRAD?: any | null;
  BILD_ANDRAD_SIGN?: string | null;
  BILD_WEBAVENY?: string | null;
}

/**
 * Nya värden vid ändring av bild
 */
export interface TEDInputARUpprBlobUpdateValues {
  id: string;
  _version: number;
  BILD?: string | null;
  BILDSIZE?: number | null;
  BILDSTRETCH?: string | null;
  BILDANTECKNING?: string | null;
  BILDDATUM?: any | null;
  BILD_ANDRAD?: any | null;
  BILD_ANDRAD_SIGN?: string | null;
  BILD_WEBAVENY?: string | null;
}

/**
 * Associerade värden vid tillägg av investering
 */
export interface TEDInputARUpprakningAddAssociationValues {
  Tillgang_Ref?: string | null;
  Tillgang_Values?: TEDInputARTillgangAddValues | null;
  Inkopskonto_Ref?: string | null;
  Inkopskonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Verksamhetskod_Ref?: string | null;
  Verksamhetskod_Values?: TEDInputARVerksamhetskodAddValues | null;
  Komponent_Ref?: string | null;
  Komponent_Values?: TEDInputARKomponentAddValues | null;
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputARUpprBlobAddValues | null;
  Avrakningar_Add_Values?: TEDInputARAvrakningAddValues[] | null;
  InvesteringSkatt_Add_Values?: TEDInputARInvesteringSkattAddValues[] | null;
  Investeringsrader_Add_Refs?: string[] | null;
  Logg_Add_Values?: TEDInputARTillgangLoggAddValues[] | null;
  SKVAvrakningar_Add_Values?: TEDInputARSKVAvrakningAddValues[] | null;
}

/**
 * Värden vid tillägg av investering
 */
export interface TEDInputARUpprakningAddValues {
  _typ: TEDARUpprakningTypEnum;
  BENAMNING?: string | null;
  DATUM?: any | null;
  AVSKRMAN?: number | null;
  BELOPP?: any | null;
  BESKRIVNING?: string | null;
  VERNR?: string | null;
  AVSKRIVNTYP?: TEDARUpprakningAVSKRIVNTYPEnum | null;
  FAKTURA?: string | null;
  LEV?: string | null;
  ANTECKNING?: string | null;
  ING_RESTVARDE?: any | null;
  ING_DATUM?: any | null;
  ING_AVSKRMAN?: number | null;
  ING_AVSKRDATUM?: any | null;
  REF_DELNING_TILLGANG_ID?: number | null;
  REF_DELNING_UPPR_LOPNR?: number | null;
  REF_DELNING_LOPNR?: number | null;
  STATLIGT_STOD?: any | null;
  ING_STATLIGT_STOD?: any | null;
  PLANERAS_ATT_SALJAS?: boolean | null;
  PLANERAT_RESTVARDE?: any | null;
  EJ_INTERNRANTA?: boolean | null;
  REF_OVERFORD_TILLGANG_ID?: number | null;
  REF_OVERFORD_UPPR_LOPNR?: number | null;
  BESKR_ANDRAD_DATUM?: any | null;
  BESKR_ANDRAD_SIGN?: string | null;
  BESKR_ANDRAD_FRAN: TEDARUpprakningBESKR_ANDRAD_FRANEnum;
  ING_NEDSKRIVNING?: any | null;
  OVERSTYR_KLASSIFICERING?: string | null;
  SKV_DATUM?: any | null;
  SKV_AVSKRMAN?: number | null;
  SKV_BELOPP?: any | null;
  SKV_ING_DATUM?: any | null;
  SKV_ING_AVSKRMAN?: number | null;
  SKV_ING_RESTVARDE?: any | null;
  SKV_ING_NEDSKRIVNING?: any | null;
  SKV_NOTERING?: string | null;
  SKV_SKATTEMASSIGA_VARDEN?: TEDARUpprakningSKV_SKATTEMASSIGA_VARDENEnum | null;
  SKV_REF_DELNING_LOPNR?: number | null;
  _Associations?: TEDInputARUpprakningAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av investering
 */
export interface TEDInputARUpprakningDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av investering
 */
export interface TEDInputARUpprakningUpdateAssociationValues {
  Tillgang_Ref?: string | null;
  Tillgang_Values?: TEDInputARTillgangUpdateValues | null;
  Inkopskonto_Ref?: string | null;
  Inkopskonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Verksamhetskod_Ref?: string | null;
  Verksamhetskod_Values?: TEDInputARVerksamhetskodUpdateValues | null;
  Komponent_Ref?: string | null;
  Komponent_Values?: TEDInputARKomponentUpdateValues | null;
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputARUpprBlobUpdateValues | null;
  Avrakningar_Add_Values?: TEDInputARAvrakningAddValues[] | null;
  Avrakningar_Update_Values?: TEDInputARAvrakningUpdateValues[] | null;
  Avrakningar_Delete_Values?: TEDInputARAvrakningDeleteValues[] | null;
  InvesteringSkatt_Add_Values?: TEDInputARInvesteringSkattAddValues[] | null;
  InvesteringSkatt_Update_Values?: TEDInputARInvesteringSkattUpdateValues[] | null;
  InvesteringSkatt_Delete_Values?: TEDInputARInvesteringSkattDeleteValues[] | null;
  Investeringsrader_Add_Refs?: string[] | null;
  Investeringsrader_Delete_Refs?: string[] | null;
  Logg_Add_Values?: TEDInputARTillgangLoggAddValues[] | null;
  Logg_Update_Values?: TEDInputARTillgangLoggUpdateValues[] | null;
  Logg_Delete_Values?: TEDInputARTillgangLoggDeleteValues[] | null;
  SKVAvrakningar_Add_Values?: TEDInputARSKVAvrakningAddValues[] | null;
  SKVAvrakningar_Update_Values?: TEDInputARSKVAvrakningUpdateValues[] | null;
  SKVAvrakningar_Delete_Values?: TEDInputARSKVAvrakningDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av investering
 */
export interface TEDInputARUpprakningUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  DATUM?: any | null;
  AVSKRMAN?: number | null;
  BELOPP?: any | null;
  BESKRIVNING?: string | null;
  VERNR?: string | null;
  AVSKRIVNTYP?: TEDARUpprakningAVSKRIVNTYPEnum | null;
  FAKTURA?: string | null;
  LEV?: string | null;
  ANTECKNING?: string | null;
  ING_RESTVARDE?: any | null;
  ING_DATUM?: any | null;
  ING_AVSKRMAN?: number | null;
  ING_AVSKRDATUM?: any | null;
  REF_DELNING_TILLGANG_ID?: number | null;
  REF_DELNING_UPPR_LOPNR?: number | null;
  REF_DELNING_LOPNR?: number | null;
  STATLIGT_STOD?: any | null;
  ING_STATLIGT_STOD?: any | null;
  PLANERAS_ATT_SALJAS?: boolean | null;
  PLANERAT_RESTVARDE?: any | null;
  EJ_INTERNRANTA?: boolean | null;
  REF_OVERFORD_TILLGANG_ID?: number | null;
  REF_OVERFORD_UPPR_LOPNR?: number | null;
  BESKR_ANDRAD_DATUM?: any | null;
  BESKR_ANDRAD_SIGN?: string | null;
  BESKR_ANDRAD_FRAN?: TEDARUpprakningBESKR_ANDRAD_FRANEnum | null;
  ING_NEDSKRIVNING?: any | null;
  OVERSTYR_KLASSIFICERING?: string | null;
  SKV_DATUM?: any | null;
  SKV_AVSKRMAN?: number | null;
  SKV_BELOPP?: any | null;
  SKV_ING_DATUM?: any | null;
  SKV_ING_AVSKRMAN?: number | null;
  SKV_ING_RESTVARDE?: any | null;
  SKV_ING_NEDSKRIVNING?: any | null;
  SKV_NOTERING?: string | null;
  SKV_SKATTEMASSIGA_VARDEN?: TEDARUpprakningSKV_SKATTEMASSIGA_VARDENEnum | null;
  SKV_REF_DELNING_LOPNR?: number | null;
  _Associations?: TEDInputARUpprakningUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av verksamhetskod
 */
export interface TEDInputARVerksamhetskodAddAssociationValues {
  AvskrkontoKred_Ref?: string | null;
  AvskrkontoKred_Values?: TEDInputEKKonteringsvardeAddValues | null;
  AvskrkontoDeb_Ref?: string | null;
  AvskrkontoDeb_Values?: TEDInputEKKonteringsvardeAddValues | null;
  InternRantaDeb_Ref?: string | null;
  InternRantaDeb_Values?: TEDInputEKKonteringsvardeAddValues | null;
  InternRantaKred_Ref?: string | null;
  InternRantaKred_Values?: TEDInputEKKonteringsvardeAddValues | null;
}

/**
 * Värden vid tillägg av verksamhetskod
 */
export interface TEDInputARVerksamhetskodAddValues {
  KOD?: string | null;
  BENAMNING?: string | null;
  _Associations?: TEDInputARVerksamhetskodAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av verksamhetskod
 */
export interface TEDInputARVerksamhetskodUpdateAssociationValues {
  AvskrkontoKred_Ref?: string | null;
  AvskrkontoKred_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  AvskrkontoDeb_Ref?: string | null;
  AvskrkontoDeb_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  InternRantaDeb_Ref?: string | null;
  InternRantaDeb_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  InternRantaKred_Ref?: string | null;
  InternRantaKred_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
}

/**
 * Nya värden vid ändring av verksamhetskod
 */
export interface TEDInputARVerksamhetskodUpdateValues {
  id: string;
  _version: number;
  KOD?: string | null;
  BENAMNING?: string | null;
  _Associations?: TEDInputARVerksamhetskodUpdateAssociationValues | null;
}

/**
 * Övriga val för en analys
 */
export interface TEDInputAvenyAnalysOptions {
  enhet: string;
  antal_decimaler: number;
  visa_jamforelse: boolean;
  endast_bokfort: boolean;
  summerings_mode: string;
  exkludera_personalkostnader: boolean;
  visa_summering: boolean;
  expand_to_index: number;
}

/**
 * Information om en ekonomisk analys
 */
export interface TEDInputAvenyEKAnalys {
  id?: string | null;
  name: string;
  typ?: TEDEKRapportDimensionTypEnum | null;
  rubrik?: string | null;
  kategori?: string | null;
  standard_belopp_bas?: string | null;
  standard_belopp_antal_decimaler?: number | null;
  endast_bokfort?: boolean | null;
  force_helarsjamforelse?: boolean | null;
  anvands_for?: (string | null)[] | null;
  columns?: TEDInputAvenyEKAnalysColumn[] | null;
  sums?: TEDInputAvenyEKAnalysSum[] | null;
  egen_analys?: boolean | null;
}

/**
 * Information om en analyskolumn
 */
export interface TEDInputAvenyEKAnalysColumn {
  LOPNR?: number | null;
  ORDNINGS_NR?: number | null;
  FALTKOD?: string | null;
  INTERN?: boolean | null;
  RESULTAT_TYP?: string | null;
  FALT_TYP?: number | null;
  INTERVALL_TYP?: number | null;
  BAS?: string | null;
  ANTAL_DECIMALER?: number | null;
  VAND_TECKEN?: boolean | null;
  BENAMNING?: string | null;
  BENAMNING2?: string | null;
  CODE_CAPTION?: string | null;
  QUERY_TYP?: string | null;
  BUDGETTYP?: string | null;
  BUDGETBENAMNING?: string | null;
  FROM_AR?: number | null;
  FROM_AR_RELATIV?: boolean | null;
  TOM_AR?: number | null;
  TOM_AR_RELATIV?: boolean | null;
  FROM_PER?: number | null;
  FROM_PER_RELATIV?: boolean | null;
  TOM_PER?: number | null;
  TOM_PER_RELATIV?: boolean | null;
  ENHET_ID?: number | null;
  RULLANDE?: boolean | null;
  HIDE_COLUMN?: boolean | null;
  FORCE_CALCULATE?: boolean | null;
  SPECIFIKATION?: string | null;
}

/**
 * Information om en rad och kolumner för en löpande ekonomisk analys
 */
export interface TEDInputAvenyEKAnalysLopande {
  columns: TEDInputAvenyEKAnalysColumn[];
  sums: TEDInputAvenyEKAnalysSum[];
  sumvalues: (string | null)[];
  endast_bokfort?: boolean | null;
  force_helarsjamforelse?: boolean | null;
}

/**
 * Information om ett summeringsbegrepp
 */
export interface TEDInputAvenyEKAnalysSum {
  LOPNR?: number | null;
  Namn?: string | null;
  ORDNINGS_NR_KONTODEL?: number | null;
  STARTPOS?: number | null;
  SLUTPOS?: number | null;
  GRUPPERINGSTYP?: string | null;
  DOLJ_NIVA?: boolean | null;
  SIDBRYTNING?: boolean | null;
  BENAMNING_FLERA_RADER?: boolean | null;
  BENAMNING_BLANK?: string | null;
  DELSUMMA?: boolean | null;
  SKRIV_DELSUMMA?: boolean | null;
  Typ?: string | null;
}

/**
 * Intervall för en analys
 */
export interface TEDInputAvenyEKPartialTimeInterval {
  fromYear?: number | null;
  toYear?: number | null;
  fromMonth?: number | null;
  toMonth?: number | null;
  fromDay?: number | null;
  toDay?: number | null;
}

/**
 * Intervall för en analys
 */
export interface TEDInputAvenyEKTimeInterval {
  fromYear: number;
  toYear: number;
  fromMonth: number;
  toMonth: number;
  fromDay?: number | null;
  toDay?: number | null;
}

/**
 * Associerade värden vid tillägg av aktivitetens ålderintervall
 */
export interface TEDInputBOAktAlderindelningAddAssociationValues {
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetAddValues | null;
  Aldersindelning_Ref?: string | null;
  Aldersindelning_Values?: TEDInputBOAldersindelningAddValues | null;
}

/**
 * Värden vid tillägg av aktivitetens ålderintervall
 */
export interface TEDInputBOAktAlderindelningAddValues {
  ANTAL?: number | null;
  _Associations?: TEDInputBOAktAlderindelningAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av aktivitetens ålderintervall
 */
export interface TEDInputBOAktAlderindelningDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av aktivitetens ålderintervall
 */
export interface TEDInputBOAktAlderindelningUpdateAssociationValues {
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetUpdateValues | null;
  Aldersindelning_Ref?: string | null;
  Aldersindelning_Values?: TEDInputBOAldersindelningUpdateValues | null;
}

/**
 * Nya värden vid ändring av aktivitetens ålderintervall
 */
export interface TEDInputBOAktAlderindelningUpdateValues {
  id: string;
  _version: number;
  ANTAL?: number | null;
  _Associations?: TEDInputBOAktAlderindelningUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av deltagare
 */
export interface TEDInputBOAktDeltagarAddAssociationValues {
  OP_Ref?: string | null;
  OP_Values?: TEDInputOPOrgPersLokAddValues | null;
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetAddValues | null;
  Prislista_Ref?: string | null;
  Prislista_Values?: TEDInputLAPrislistaAddValues | null;
  Kund_Ref?: string | null;
  Kund_Values?: TEDInputKRKundAddValues | null;
  AktOrder_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av deltagare
 */
export interface TEDInputBOAktDeltagarAddValues {
  ANMALNINGSDATUM?: any | null;
  ANMALNINGSTID?: any | null;
  STATUS?: TEDBOAktDeltagarSTATUSEnum | null;
  BESKRIVNING?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  ANMALAN_STATUS?: TEDBOAktDeltagarANMALAN_STATUSEnum | null;
  FAKT_VARDNADSHAVARE?: boolean | null;
  _Associations: TEDInputBOAktDeltagarAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av deltagare
 */
export interface TEDInputBOAktDeltagarDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av deltagare
 */
export interface TEDInputBOAktDeltagarUpdateAssociationValues {
  OP_Ref?: string | null;
  OP_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetUpdateValues | null;
  Prislista_Ref?: string | null;
  Prislista_Values?: TEDInputLAPrislistaUpdateValues | null;
  Kund_Ref?: string | null;
  Kund_Values?: TEDInputKRKundUpdateValues | null;
  AktOrder_Add_Refs?: string[] | null;
  AktOrder_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av deltagare
 */
export interface TEDInputBOAktDeltagarUpdateValues {
  id: string;
  _version: number;
  ANMALNINGSDATUM?: any | null;
  ANMALNINGSTID?: any | null;
  STATUS?: TEDBOAktDeltagarSTATUSEnum | null;
  BESKRIVNING?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  ANMALAN_STATUS?: TEDBOAktDeltagarANMALAN_STATUSEnum | null;
  FAKT_VARDNADSHAVARE?: boolean | null;
  _Associations?: TEDInputBOAktDeltagarUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av digital visning
 */
export interface TEDInputBOAktDigitalaVisningarAddValues {
  VISNINGAR_TOTAL?: number | null;
  VISNINGAR_FACEBOOK?: number | null;
  VISNINGAR_YOUTUBE?: number | null;
  VISNINGAR_VIMEO?: number | null;
  VISNINGAR_OVRIG?: number | null;
}

/**
 * Nya värden vid ändring av digital visning
 */
export interface TEDInputBOAktDigitalaVisningarUpdateValues {
  id: string;
  _version: number;
  VISNINGAR_TOTAL?: number | null;
  VISNINGAR_FACEBOOK?: number | null;
  VISNINGAR_YOUTUBE?: number | null;
  VISNINGAR_VIMEO?: number | null;
  VISNINGAR_OVRIG?: number | null;
}

/**
 * Associerade värden vid tillägg av kategori för en aktivitet
 */
export interface TEDInputBOAktKategoriAddAssociationValues {
  Aktivitetskategori_Ref?: string | null;
  Aktivitetskategori_Values?: TEDInputBOKategoriAddValues | null;
}

/**
 * Värden vid tillägg av kategori för en aktivitet
 */
export interface TEDInputBOAktKategoriAddValues {
  _Associations: TEDInputBOAktKategoriAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kategori för en aktivitet
 */
export interface TEDInputBOAktKategoriDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kategori för en aktivitet
 */
export interface TEDInputBOAktKategoriUpdateAssociationValues {
  Aktivitetskategori_Ref?: string | null;
  Aktivitetskategori_Values?: TEDInputBOKategoriUpdateValues | null;
}

/**
 * Nya värden vid ändring av kategori för en aktivitet
 */
export interface TEDInputBOAktKategoriUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputBOAktKategoriUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kursdeltagare
 */
export interface TEDInputBOAktKontaktAddAssociationValues {
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetAddValues | null;
  LookUpOrg_Ref?: string | null;
  LookUpOrg_Values?: TEDInputOPOrgPersLokAddValues | null;
  Kontakt_Ref?: string | null;
  Kontakt_Values?: TEDInputOPKontaktAddValues | null;
  Kund_Ref?: string | null;
  Kund_Values?: TEDInputKRKundAddValues | null;
}

/**
 * Värden vid tillägg av kursdeltagare
 */
export interface TEDInputBOAktKontaktAddValues {
  PRIS?: any | null;
  ANMARKNING?: string | null;
  ALLERGI?: string | null;
  _Associations: TEDInputBOAktKontaktAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kursdeltagare
 */
export interface TEDInputBOAktKontaktDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kursdeltagare
 */
export interface TEDInputBOAktKontaktUpdateAssociationValues {
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetUpdateValues | null;
  LookUpOrg_Ref?: string | null;
  LookUpOrg_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Kontakt_Ref?: string | null;
  Kontakt_Values?: TEDInputOPKontaktUpdateValues | null;
  Kund_Ref?: string | null;
  Kund_Values?: TEDInputKRKundUpdateValues | null;
}

/**
 * Nya värden vid ändring av kursdeltagare
 */
export interface TEDInputBOAktKontaktUpdateValues {
  id: string;
  _version: number;
  PRIS?: any | null;
  ANMARKNING?: string | null;
  ALLERGI?: string | null;
  _Associations?: TEDInputBOAktKontaktUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av planering
 */
export interface TEDInputBOAktPlanAddAssociationValues {
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
  Verksamhetstyp_Ref?: string | null;
  Verksamhetstyp_Values?: TEDInputBOVerksamhetstyperAddValues | null;
  GudstjanstTyp_Ref?: string | null;
  GudstjanstTyp_Values?: TEDInputBOGudstjansttypAddValues | null;
  Resurser_Add_Values?: TEDInputBOAktPlanResAddValues[] | null;
}

/**
 * Värden vid tillägg av planering
 */
export interface TEDInputBOAktPlanAddValues {
  FRANDATUM?: any | null;
  FRANTID?: any | null;
  TILLDATUM?: any | null;
  TILLTID?: any | null;
  TITEL?: string | null;
  AKTIVITETSTYP?: string | null;
  GUDSTJANSTTYP_ID?: number | null;
  VERKSAMHETSTYP_ID?: number | null;
  ANTECKNING?: string | null;
  SKAPAD_DATUM?: any | null;
  SKAPAD_AV?: number | null;
  STATUS?: string | null;
  SKAPAD_AKTID?: number | null;
  _Associations?: TEDInputBOAktPlanAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av planering
 */
export interface TEDInputBOAktPlanDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid tillägg av planerad resurs
 */
export interface TEDInputBOAktPlanResAddAssociationValues {
  Resurs_Ref?: string | null;
  Resurs_Values?: TEDInputBOResursAddValues | null;
}

/**
 * Värden vid tillägg av planerad resurs
 */
export interface TEDInputBOAktPlanResAddValues {
  RESURS_ID?: number | null;
  _Associations: TEDInputBOAktPlanResAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av planerad resurs
 */
export interface TEDInputBOAktPlanResDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av planerad resurs
 */
export interface TEDInputBOAktPlanResUpdateAssociationValues {
  Resurs_Ref?: string | null;
  Resurs_Values?: TEDInputBOResursUpdateValues | null;
}

/**
 * Nya värden vid ändring av planerad resurs
 */
export interface TEDInputBOAktPlanResUpdateValues {
  id: string;
  _version: number;
  RESURS_ID?: number | null;
  _Associations?: TEDInputBOAktPlanResUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av planering
 */
export interface TEDInputBOAktPlanUpdateAssociationValues {
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
  Verksamhetstyp_Ref?: string | null;
  Verksamhetstyp_Values?: TEDInputBOVerksamhetstyperUpdateValues | null;
  GudstjanstTyp_Ref?: string | null;
  GudstjanstTyp_Values?: TEDInputBOGudstjansttypUpdateValues | null;
  Resurser_Add_Values?: TEDInputBOAktPlanResAddValues[] | null;
  Resurser_Update_Values?: TEDInputBOAktPlanResUpdateValues[] | null;
  Resurser_Delete_Values?: TEDInputBOAktPlanResDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av planering
 */
export interface TEDInputBOAktPlanUpdateValues {
  id: string;
  _version: number;
  FRANDATUM?: any | null;
  FRANTID?: any | null;
  TILLDATUM?: any | null;
  TILLTID?: any | null;
  TITEL?: string | null;
  AKTIVITETSTYP?: string | null;
  GUDSTJANSTTYP_ID?: number | null;
  VERKSAMHETSTYP_ID?: number | null;
  ANTECKNING?: string | null;
  SKAPAD_DATUM?: any | null;
  SKAPAD_AV?: number | null;
  STATUS?: string | null;
  SKAPAD_AKTID?: number | null;
  _Associations?: TEDInputBOAktPlanUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av aktivitet psalm
 */
export interface TEDInputBOAktPsalmerAddAssociationValues {
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetAddValues | null;
  Psalm_Ref?: string | null;
  Psalm_Values?: TEDInputBOPsalmAddValues | null;
}

/**
 * Värden vid tillägg av aktivitet psalm
 */
export interface TEDInputBOAktPsalmerAddValues {
  PSALMNR?: number | null;
  _Associations?: TEDInputBOAktPsalmerAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av aktivitet psalm
 */
export interface TEDInputBOAktPsalmerDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av aktivitet psalm
 */
export interface TEDInputBOAktPsalmerUpdateAssociationValues {
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetUpdateValues | null;
  Psalm_Ref?: string | null;
  Psalm_Values?: TEDInputBOPsalmUpdateValues | null;
}

/**
 * Nya värden vid ändring av aktivitet psalm
 */
export interface TEDInputBOAktPsalmerUpdateValues {
  id: string;
  _version: number;
  PSALMNR?: number | null;
  _Associations?: TEDInputBOAktPsalmerUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av resursrubrik på aktivitetstyp
 */
export interface TEDInputBOAktTypResrubrikAddAssociationValues {
  AktTyp_Ref?: string | null;
  AktTyp_Values?: TEDInputBOAktivitetstypAddValues | null;
  Resrubrik_Ref?: string | null;
  Resrubrik_Values?: TEDInputBOResrubrikAddValues | null;
  Bokningsgrupp_Ref?: string | null;
  Bokningsgrupp_Values?: TEDInputSYSBokngruppAddValues | null;
}

/**
 * Värden vid tillägg av resursrubrik på aktivitetstyp
 */
export interface TEDInputBOAktTypResrubrikAddValues {
  FRAN_TIDSDIFF?: number | null;
  TILL_TIDSDIFF?: number | null;
  VIEW_ID?: number | null;
  ANTALBEKR?: number | null;
  SKK_WEB_PUBLICERAS?: string | null;
  URVAL_ID?: number | null;
  EXTRA_BOOK_TIME_BEFORE_AKTIVITY?: number | null;
  EXTRA_BOOK_TIME_AFTER_AKTIVITY?: number | null;
  _Associations: TEDInputBOAktTypResrubrikAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av resursrubrik på aktivitetstyp
 */
export interface TEDInputBOAktTypResrubrikDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av resursrubrik på aktivitetstyp
 */
export interface TEDInputBOAktTypResrubrikUpdateAssociationValues {
  AktTyp_Ref?: string | null;
  AktTyp_Values?: TEDInputBOAktivitetstypUpdateValues | null;
  Resrubrik_Ref?: string | null;
  Resrubrik_Values?: TEDInputBOResrubrikUpdateValues | null;
  Bokningsgrupp_Ref?: string | null;
  Bokningsgrupp_Values?: TEDInputSYSBokngruppUpdateValues | null;
}

/**
 * Nya värden vid ändring av resursrubrik på aktivitetstyp
 */
export interface TEDInputBOAktTypResrubrikUpdateValues {
  id: string;
  _version: number;
  FRAN_TIDSDIFF?: number | null;
  TILL_TIDSDIFF?: number | null;
  VIEW_ID?: number | null;
  ANTALBEKR?: number | null;
  SKK_WEB_PUBLICERAS?: string | null;
  URVAL_ID?: number | null;
  EXTRA_BOOK_TIME_BEFORE_AKTIVITY?: number | null;
  EXTRA_BOOK_TIME_AFTER_AKTIVITY?: number | null;
  _Associations?: TEDInputBOAktTypResrubrikUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av aktivitet
 */
export interface TEDInputBOAktivitetAddAssociationValues {
  Bestallare_Ref?: string | null;
  Bestallare_Values?: TEDInputOPOrgPersLokAddValues | null;
  Bokningsgrupp_Ref?: string | null;
  Bokningsgrupp_Values?: TEDInputSYSBokngruppAddValues | null;
  Resurs1_Ref?: string | null;
  Resurs1_Values?: TEDInputBOBokningsrubrikAddValues | null;
  Resurs2_Ref?: string | null;
  Resurs2_Values?: TEDInputBOBokningsrubrikAddValues | null;
  Resurs3_Ref?: string | null;
  Resurs3_Values?: TEDInputBOBokningsrubrikAddValues | null;
  Resurs4_Ref?: string | null;
  Resurs4_Values?: TEDInputBOBokningsrubrikAddValues | null;
  Resurs5_Ref?: string | null;
  Resurs5_Values?: TEDInputBOBokningsrubrikAddValues | null;
  Resurs6_Ref?: string | null;
  Resurs6_Values?: TEDInputBOBokningsrubrikAddValues | null;
  PrelBestallare_Ref?: string | null;
  PrelBestallare_Values?: TEDInputSYSUserAddValues | null;
  Anhorig_Ref?: string | null;
  Anhorig_Values?: TEDInputOPOrgPersLokAddValues | null;
  Begrbyra_Ref?: string | null;
  Begrbyra_Values?: TEDInputOPOrgPersLokAddValues | null;
  KyrkogardAnnanOrt_Ref?: string | null;
  KyrkogardAnnanOrt_Values?: TEDInputBOResursAddValues | null;
  Begravningstyp_Ref?: string | null;
  Begravningstyp_Values?: TEDInputBOBegravningstypAddValues | null;
  Dopkandidat_Ref?: string | null;
  Dopkandidat_Values?: TEDInputOPOrgPersLokAddValues | null;
  Fader_Ref?: string | null;
  Fader_Values?: TEDInputOPOrgPersLokAddValues | null;
  Moder_Ref?: string | null;
  Moder_Values?: TEDInputOPOrgPersLokAddValues | null;
  Brudgum_Ref?: string | null;
  Brudgum_Values?: TEDInputOPOrgPersLokAddValues | null;
  Brud_Ref?: string | null;
  Brud_Values?: TEDInputOPOrgPersLokAddValues | null;
  GudstjanstTyp_Ref?: string | null;
  GudstjanstTyp_Values?: TEDInputBOGudstjansttypAddValues | null;
  Verksamhetstyp_Ref?: string | null;
  Verksamhetstyp_Values?: TEDInputBOVerksamhetstyperAddValues | null;
  Nyckelavhamtare_Ref?: string | null;
  Nyckelavhamtare_Values?: TEDInputOPOrgPersLokAddValues | null;
  BoknBestallning_Ref?: string | null;
  BoknBestallning_Values?: TEDInputBOBoknBestallningAddValues | null;
  Resurs7_Ref?: string | null;
  Resurs7_Values?: TEDInputBOBokningsrubrikAddValues | null;
  Resurs8_Ref?: string | null;
  Resurs8_Values?: TEDInputBOBokningsrubrikAddValues | null;
  Resurs9_Ref?: string | null;
  Resurs9_Values?: TEDInputBOBokningsrubrikAddValues | null;
  Resurs10_Ref?: string | null;
  Resurs10_Values?: TEDInputBOBokningsrubrikAddValues | null;
  Kalenderinfo_Ref?: string | null;
  Kalenderinfo_Values?: TEDInputBOAktivitetkalenderinfoAddValues | null;
  OldBoknBestallning_Ref?: string | null;
  OldBoknBestallning_Values?: TEDInputBOBoknBestallningAddValues | null;
  Avlidna_Ref?: string | null;
  Avlidna_Values?: TEDInputOPAvlidenAddValues | null;
  OpGrupp_Ref?: string | null;
  OpGrupp_Values?: TEDInputBOGruppOPAddValues | null;
  DigitalaVisningar_Ref?: string | null;
  DigitalaVisningar_Values?: TEDInputBOAktDigitalaVisningarAddValues | null;
  SKK_Ref?: string | null;
  SKK_Values?: TEDInputBOSKKAddValues | null;
  Forsamling_Ref?: string | null;
  Forsamling_Values?: TEDInputSYSStatistikinstallningarAddValues | null;
  SkickadStatistik_Ref?: string | null;
  SkickadStatistik_Values?: TEDInputBOSKSAddValues | null;
  AktBokRubrik_Add_Values?: TEDInputBOBokningsrubrikAddValues[] | null;
  AktResrubrik_Add_Values?: TEDInputBOAktivitetResrubrikAddValues[] | null;
  Faktomg_Add_Values?: TEDInputBOFaktOmgAddValues[] | null;
  KnutnaAktiviteter_Add_Refs?: string[] | null;
  Dokument_Add_Values?: TEDInputBOAktivitetDokAddValues[] | null;
  Aktivitetskategorier_Add_Values?: TEDInputBOAktKategoriAddValues[] | null;
  Bevakning_Add_Values?: TEDInputBOBevakningAddValues[] | null;
  Konfirmander_Add_Values?: TEDInputBOAktDeltagarAddValues[] | null;
  Deltagare_Add_Values?: TEDInputBOAktDeltagarAddValues[] | null;
  Kontakter_Add_Values?: TEDInputBOAktKontaktAddValues[] | null;
  AktAlderindelning_Add_Values?: TEDInputBOAktAlderindelningAddValues[] | null;
  Amnesomraden_Add_Values?: TEDInputBOSKKAktivitetAmnesomradeAddValues[] | null;
  Handelsetyper_Add_Values?: TEDInputBOAktivitetHandelsetypAddValues[] | null;
  BoknBestallningar_Add_Refs?: string[] | null;
  XBridge_Add_Refs?: string[] | null;
  RepeteradeAktiviteter_Add_Refs?: string[] | null;
  Utskick_Add_Refs?: string[] | null;
  AktPsalmer_Add_Values?: TEDInputBOAktPsalmerAddValues[] | null;
}

/**
 * Värden vid tillägg av aktivitet
 */
export interface TEDInputBOAktivitetAddValues {
  _typ: TEDBOAktivitetTypEnum;
  TITEL?: string | null;
  FRANDATUM?: any | null;
  FRANTID?: any | null;
  TILLDATUM?: any | null;
  TILLTID?: any | null;
  BOKNINGSNUMMER?: string | null;
  BOKNINGSNRINDEX?: number | null;
  TIDSTEXT?: string | null;
  BESKRIVNING?: string | null;
  BOKNINGSSIGNATUR?: string | null;
  BOKNINGSDATUM?: any | null;
  PRELBOKAD?: boolean | null;
  UTSKRIVEN?: boolean | null;
  AKTIVITETSGRUPP?: number | null;
  BESTALLARE_TYP?: TEDBOAktivitetBESTALLARE_TYPEnum | null;
  BESTALLARE_KONTAKT?: string | null;
  OTIMESTAMP?: number | null;
  WEBBOKAD?: boolean | null;
  ANTAL_BESOKARE?: number | null;
  STATISTIKUPPGIFT?: boolean | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  NOTERING2?: string | null;
  BEVAKNING?: boolean | null;
  BEVAKNING_DATUM?: any | null;
  BEVAKNING_TEXT?: string | null;
  REPAKTNR?: number | null;
  BESTALLARE_KONTAKT_INFO?: string | null;
  PUBL_STATUS?: TEDBOAktivitetPUBL_STATUSEnum | null;
  WEB_PUBL_STATUS?: TEDBOAktivitetWEB_PUBL_STATUSEnum | null;
  DOLJ_KALENDERTID?: boolean | null;
  AKTKAT_ANNONS?: string | null;
  SENAST_ANDRAD?: any | null;
  SENAST_ANDRAD_SIGNATUR?: string | null;
  MARKERAD_FAKTURERAD?: boolean | null;
  GRAVPLATS?: string | null;
  DODSDATUM?: string | null;
  RELATION?: string | null;
  KREMERING?: TEDBOAktivitetKREMERINGEnum | null;
  INTYG?: boolean | null;
  INTYG2?: boolean | null;
  BEGRBYRA_KONTAKT?: string | null;
  BEGRBYRA_KONTAKT_INFO?: string | null;
  REDAN_KREMERAD?: TEDBOAktivitetREDAN_KREMERADEnum | null;
  REDAN_GRAVSATT?: string | null;
  KREMERING_ANNAN_ORT?: boolean | null;
  JORDBEGRAVNING?: boolean | null;
  URNSATTNING?: boolean | null;
  MINNESLUND?: boolean | null;
  AN_NARVARANDE?: boolean | null;
  ENSKILT_DOP?: TEDBOAktivitetENSKILT_DOPEnum | null;
  VIGSELORDNING?: TEDBOAktivitetVIGSELORDNINGEnum | null;
  KOLLEKT?: string | null;
  ANTAL_KOMMUNIONER?: number | null;
  INGAR_PREDIKOTUR?: TEDBOAktivitetINGAR_PREDIKOTUREnum | null;
  HUVUDGUDSTJANST?: boolean | null;
  MAXANTDELT?: number | null;
  FAKTDELT?: TEDBOAktivitetFAKTDELTEnum | null;
  ANNONSERA?: boolean | null;
  SENASTE_ANM_DATUM?: any | null;
  ANM_KRAV_PERSNR?: TEDBOAktivitetANM_KRAV_PERSNREnum | null;
  LOKALUTHYR_INFO?: string | null;
  NYCKELNUMMER?: string | null;
  NYCKEL_UTLAMNINGSDATUM?: any | null;
  NYCKEL_ATERLAMNINGSDATUM?: any | null;
  NYCKEL_UTLAMNAD_SIGN?: string | null;
  NYCKEL_ATERLAMNAD_SIGN?: string | null;
  NYCKEL_NOTERING?: string | null;
  NYCKEL_AVHAMTARE_TYP?: string | null;
  ANDRAD?: boolean | null;
  SKK_ID?: number | null;
  SKKALENDER_ID?: string | null;
  SKK_SPRIDNINGSTYP_INTERN?: TEDBOAktivitetSKK_SPRIDNINGSTYP_INTERNEnum | null;
  SKK_SPRIDNINGSTYP_EXTERN?: boolean | null;
  SKK_KONTAKT_NAMN?: string | null;
  SKK_KONTAKT_TELEFON?: string | null;
  SKK_KONTAKT_SMTP?: string | null;
  SKK_URL1_TITEL?: string | null;
  SKK_URL1?: string | null;
  SKK_URL1_DIGITALT_MOTE?: boolean | null;
  SKK_URL2_TITEL?: string | null;
  SKK_URL2?: string | null;
  SKK_URL3_TITEL?: string | null;
  SKK_URL3?: string | null;
  SKK_PUBL_STATUS_INTERN?: boolean | null;
  SKK_SENAST_EXPORTERAD_TID?: any | null;
  SKK_SENAST_EXPORTERAD_DATUM?: any | null;
  SKK_SLUTTID?: string | null;
  XB_SENAST_EXPORTERAD?: any | null;
  AKT_MED_URNA?: boolean | null;
  XB_UNIQUE_THREAD_VALUE?: string | null;
  SKK_UNIQUE_THREAD_VALUE?: string | null;
  ASKGRAVLUND?: boolean | null;
  BEGRBYRA_NARVARAR?: boolean | null;
  INTYG_GRAVS?: any | null;
  INTYG_KREM?: any | null;
  INTYG_ML?: any | null;
  INTYG_GRAVOPPNING?: any | null;
  ANTAL_DOP?: number | null;
  ANTAL_VIGSLAR?: number | null;
  ANTAL_LEDIGA_DOP?: number | null;
  ANTAL_LEDIGA_VIGSLAR?: number | null;
  ANTAL_BARN?: number | null;
  GRUPP_ID?: number | null;
  FAKTURERAS?: boolean | null;
  ANTAL_TILLFALLEN?: number | null;
  FORSAMLINGS_ID?: number | null;
  NOTERING_PUBL_GUDSTJANST?: string | null;
  SEKRETESSMARKERAD?: string | null;
  _Associations: TEDInputBOAktivitetAddAssociationValues;
}

/**
 * Associerade värden vid tillägg av dokument
 */
export interface TEDInputBOAktivitetDokAddAssociationValues {
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetAddValues | null;
}

/**
 * Värden vid tillägg av dokument
 */
export interface TEDInputBOAktivitetDokAddValues {
  BESKRIVNING?: string | null;
  EXTENSION?: string | null;
  OLECLASSNAME?: string | null;
  BINARDATA?: string | null;
  BINARDATASIZE?: number | null;
  DATATYPE?: string | null;
  _Associations?: TEDInputBOAktivitetDokAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av dokument
 */
export interface TEDInputBOAktivitetDokDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av dokument
 */
export interface TEDInputBOAktivitetDokUpdateAssociationValues {
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetUpdateValues | null;
}

/**
 * Nya värden vid ändring av dokument
 */
export interface TEDInputBOAktivitetDokUpdateValues {
  id: string;
  _version: number;
  BESKRIVNING?: string | null;
  EXTENSION?: string | null;
  OLECLASSNAME?: string | null;
  BINARDATA?: string | null;
  BINARDATASIZE?: number | null;
  DATATYPE?: string | null;
  _Associations?: TEDInputBOAktivitetDokUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av bOAktivitetHandelsetyp
 */
export interface TEDInputBOAktivitetHandelsetypAddAssociationValues {
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetAddValues | null;
  Handelsetyp_Ref?: string | null;
  Handelsetyp_Values?: TEDInputBOSKKHandelsetypAddValues | null;
}

/**
 * Värden vid tillägg av bOAktivitetHandelsetyp
 */
export interface TEDInputBOAktivitetHandelsetypAddValues {
  _Associations: TEDInputBOAktivitetHandelsetypAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av bOAktivitetHandelsetyp
 */
export interface TEDInputBOAktivitetHandelsetypDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av bOAktivitetHandelsetyp
 */
export interface TEDInputBOAktivitetHandelsetypUpdateAssociationValues {
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetUpdateValues | null;
  Handelsetyp_Ref?: string | null;
  Handelsetyp_Values?: TEDInputBOSKKHandelsetypUpdateValues | null;
}

/**
 * Nya värden vid ändring av bOAktivitetHandelsetyp
 */
export interface TEDInputBOAktivitetHandelsetypUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputBOAktivitetHandelsetypUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av mottagare utskick
 */
export interface TEDInputBOAktivitetMottagareAddAssociationValues {
  Handelse_Ref?: string | null;
  Handelse_Values?: TEDInputGAHandelseAddValues | null;
  Kontakt_Ref?: string | null;
  Kontakt_Values?: TEDInputBOBisattningKontaktAddValues | null;
}

/**
 * Värden vid tillägg av mottagare utskick
 */
export interface TEDInputBOAktivitetMottagareAddValues {
  HANDELSE_ID?: number | null;
  AKT_ID?: number | null;
  OPID?: number | null;
  _Associations: TEDInputBOAktivitetMottagareAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av mottagare utskick
 */
export interface TEDInputBOAktivitetMottagareDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av mottagare utskick
 */
export interface TEDInputBOAktivitetMottagareUpdateAssociationValues {
  Handelse_Ref?: string | null;
  Handelse_Values?: TEDInputGAHandelseUpdateValues | null;
  Kontakt_Ref?: string | null;
  Kontakt_Values?: TEDInputBOBisattningKontaktUpdateValues | null;
}

/**
 * Nya värden vid ändring av mottagare utskick
 */
export interface TEDInputBOAktivitetMottagareUpdateValues {
  id: string;
  _version: number;
  HANDELSE_ID?: number | null;
  AKT_ID?: number | null;
  OPID?: number | null;
  _Associations?: TEDInputBOAktivitetMottagareUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av order per aktivitet
 */
export interface TEDInputBOAktivitetOrderAddAssociationValues {
  Faktomg_Ref?: string | null;
  Faktomg_Values?: TEDInputBOFaktOmgAddValues | null;
  Order_Ref?: string | null;
  Order_Values?: TEDInputOFOrderAddValues | null;
  Deltagare_Ref?: string | null;
  Deltagare_Values?: TEDInputBOAktDeltagarAddValues | null;
}

/**
 * Värden vid tillägg av order per aktivitet
 */
export interface TEDInputBOAktivitetOrderAddValues {
  OP_ID?: number | null;
  STATUS?: TEDBOAktivitetOrderSTATUSEnum | null;
  VARREFERENS?: string | null;
  _Associations: TEDInputBOAktivitetOrderAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av order per aktivitet
 */
export interface TEDInputBOAktivitetOrderDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av order per aktivitet
 */
export interface TEDInputBOAktivitetOrderUpdateAssociationValues {
  Faktomg_Ref?: string | null;
  Faktomg_Values?: TEDInputBOFaktOmgUpdateValues | null;
  Order_Ref?: string | null;
  Order_Values?: TEDInputOFOrderUpdateValues | null;
  Deltagare_Ref?: string | null;
  Deltagare_Values?: TEDInputBOAktDeltagarUpdateValues | null;
}

/**
 * Nya värden vid ändring av order per aktivitet
 */
export interface TEDInputBOAktivitetOrderUpdateValues {
  id: string;
  _version: number;
  OP_ID?: number | null;
  STATUS?: TEDBOAktivitetOrderSTATUSEnum | null;
  VARREFERENS?: string | null;
  _Associations?: TEDInputBOAktivitetOrderUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av resursrubrik per aktivitet
 */
export interface TEDInputBOAktivitetResrubrikAddAssociationValues {
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetAddValues | null;
  Resrubrik_Ref?: string | null;
  Resrubrik_Values?: TEDInputBOResrubrikAddValues | null;
  Bokningsrubrik_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av resursrubrik per aktivitet
 */
export interface TEDInputBOAktivitetResrubrikAddValues {
  _Associations?: TEDInputBOAktivitetResrubrikAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av resursrubrik per aktivitet
 */
export interface TEDInputBOAktivitetResrubrikDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av resursrubrik per aktivitet
 */
export interface TEDInputBOAktivitetResrubrikUpdateAssociationValues {
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetUpdateValues | null;
  Resrubrik_Ref?: string | null;
  Resrubrik_Values?: TEDInputBOResrubrikUpdateValues | null;
  Bokningsrubrik_Add_Refs?: string[] | null;
  Bokningsrubrik_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av resursrubrik per aktivitet
 */
export interface TEDInputBOAktivitetResrubrikUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputBOAktivitetResrubrikUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av aktivitet
 */
export interface TEDInputBOAktivitetUpdateAssociationValues {
  Bestallare_Ref?: string | null;
  Bestallare_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Bokningsgrupp_Ref?: string | null;
  Bokningsgrupp_Values?: TEDInputSYSBokngruppUpdateValues | null;
  Resurs1_Ref?: string | null;
  Resurs1_Values?: TEDInputBOBokningsrubrikUpdateValues | null;
  Resurs2_Ref?: string | null;
  Resurs2_Values?: TEDInputBOBokningsrubrikUpdateValues | null;
  Resurs3_Ref?: string | null;
  Resurs3_Values?: TEDInputBOBokningsrubrikUpdateValues | null;
  Resurs4_Ref?: string | null;
  Resurs4_Values?: TEDInputBOBokningsrubrikUpdateValues | null;
  Resurs5_Ref?: string | null;
  Resurs5_Values?: TEDInputBOBokningsrubrikUpdateValues | null;
  Resurs6_Ref?: string | null;
  Resurs6_Values?: TEDInputBOBokningsrubrikUpdateValues | null;
  PrelBestallare_Ref?: string | null;
  PrelBestallare_Values?: TEDInputSYSUserUpdateValues | null;
  Anhorig_Ref?: string | null;
  Anhorig_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Begrbyra_Ref?: string | null;
  Begrbyra_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  KyrkogardAnnanOrt_Ref?: string | null;
  KyrkogardAnnanOrt_Values?: TEDInputBOResursUpdateValues | null;
  Begravningstyp_Ref?: string | null;
  Begravningstyp_Values?: TEDInputBOBegravningstypUpdateValues | null;
  Dopkandidat_Ref?: string | null;
  Dopkandidat_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Fader_Ref?: string | null;
  Fader_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Moder_Ref?: string | null;
  Moder_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Brudgum_Ref?: string | null;
  Brudgum_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Brud_Ref?: string | null;
  Brud_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  GudstjanstTyp_Ref?: string | null;
  GudstjanstTyp_Values?: TEDInputBOGudstjansttypUpdateValues | null;
  Verksamhetstyp_Ref?: string | null;
  Verksamhetstyp_Values?: TEDInputBOVerksamhetstyperUpdateValues | null;
  Nyckelavhamtare_Ref?: string | null;
  Nyckelavhamtare_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  BoknBestallning_Ref?: string | null;
  BoknBestallning_Values?: TEDInputBOBoknBestallningUpdateValues | null;
  Resurs7_Ref?: string | null;
  Resurs7_Values?: TEDInputBOBokningsrubrikUpdateValues | null;
  Resurs8_Ref?: string | null;
  Resurs8_Values?: TEDInputBOBokningsrubrikUpdateValues | null;
  Resurs9_Ref?: string | null;
  Resurs9_Values?: TEDInputBOBokningsrubrikUpdateValues | null;
  Resurs10_Ref?: string | null;
  Resurs10_Values?: TEDInputBOBokningsrubrikUpdateValues | null;
  Kalenderinfo_Ref?: string | null;
  Kalenderinfo_Values?: TEDInputBOAktivitetkalenderinfoUpdateValues | null;
  OldBoknBestallning_Ref?: string | null;
  OldBoknBestallning_Values?: TEDInputBOBoknBestallningUpdateValues | null;
  Avlidna_Ref?: string | null;
  Avlidna_Values?: TEDInputOPAvlidenUpdateValues | null;
  OpGrupp_Ref?: string | null;
  OpGrupp_Values?: TEDInputBOGruppOPUpdateValues | null;
  DigitalaVisningar_Ref?: string | null;
  DigitalaVisningar_Values?: TEDInputBOAktDigitalaVisningarUpdateValues | null;
  SKK_Ref?: string | null;
  SKK_Values?: TEDInputBOSKKUpdateValues | null;
  Forsamling_Ref?: string | null;
  Forsamling_Values?: TEDInputSYSStatistikinstallningarUpdateValues | null;
  SkickadStatistik_Ref?: string | null;
  SkickadStatistik_Values?: TEDInputBOSKSUpdateValues | null;
  AktBokRubrik_Add_Values?: TEDInputBOBokningsrubrikAddValues[] | null;
  AktBokRubrik_Update_Values?: TEDInputBOBokningsrubrikUpdateValues[] | null;
  AktBokRubrik_Delete_Values?: TEDInputBOBokningsrubrikDeleteValues[] | null;
  AktResrubrik_Add_Values?: TEDInputBOAktivitetResrubrikAddValues[] | null;
  AktResrubrik_Update_Values?: TEDInputBOAktivitetResrubrikUpdateValues[] | null;
  AktResrubrik_Delete_Values?: TEDInputBOAktivitetResrubrikDeleteValues[] | null;
  Faktomg_Add_Values?: TEDInputBOFaktOmgAddValues[] | null;
  Faktomg_Update_Values?: TEDInputBOFaktOmgUpdateValues[] | null;
  Faktomg_Delete_Values?: TEDInputBOFaktOmgDeleteValues[] | null;
  KnutnaAktiviteter_Add_Refs?: string[] | null;
  KnutnaAktiviteter_Delete_Refs?: string[] | null;
  Dokument_Add_Values?: TEDInputBOAktivitetDokAddValues[] | null;
  Dokument_Update_Values?: TEDInputBOAktivitetDokUpdateValues[] | null;
  Dokument_Delete_Values?: TEDInputBOAktivitetDokDeleteValues[] | null;
  Aktivitetskategorier_Add_Values?: TEDInputBOAktKategoriAddValues[] | null;
  Aktivitetskategorier_Update_Values?: TEDInputBOAktKategoriUpdateValues[] | null;
  Aktivitetskategorier_Delete_Values?: TEDInputBOAktKategoriDeleteValues[] | null;
  Bevakning_Add_Values?: TEDInputBOBevakningAddValues[] | null;
  Bevakning_Update_Values?: TEDInputBOBevakningUpdateValues[] | null;
  Bevakning_Delete_Values?: TEDInputBOBevakningDeleteValues[] | null;
  Konfirmander_Add_Values?: TEDInputBOAktDeltagarAddValues[] | null;
  Konfirmander_Update_Values?: TEDInputBOAktDeltagarUpdateValues[] | null;
  Konfirmander_Delete_Values?: TEDInputBOAktDeltagarDeleteValues[] | null;
  Konfirmander_Undelete?: TEDInputBOAktDeltagarDeleteValues[] | null;
  Deltagare_Add_Values?: TEDInputBOAktDeltagarAddValues[] | null;
  Deltagare_Update_Values?: TEDInputBOAktDeltagarUpdateValues[] | null;
  Deltagare_Delete_Values?: TEDInputBOAktDeltagarDeleteValues[] | null;
  Deltagare_Undelete?: TEDInputBOAktDeltagarDeleteValues[] | null;
  Kontakter_Add_Values?: TEDInputBOAktKontaktAddValues[] | null;
  Kontakter_Update_Values?: TEDInputBOAktKontaktUpdateValues[] | null;
  Kontakter_Delete_Values?: TEDInputBOAktKontaktDeleteValues[] | null;
  AktAlderindelning_Add_Values?: TEDInputBOAktAlderindelningAddValues[] | null;
  AktAlderindelning_Update_Values?: TEDInputBOAktAlderindelningUpdateValues[] | null;
  AktAlderindelning_Delete_Values?: TEDInputBOAktAlderindelningDeleteValues[] | null;
  Amnesomraden_Add_Values?: TEDInputBOSKKAktivitetAmnesomradeAddValues[] | null;
  Amnesomraden_Update_Values?: TEDInputBOSKKAktivitetAmnesomradeUpdateValues[] | null;
  Amnesomraden_Delete_Values?: TEDInputBOSKKAktivitetAmnesomradeDeleteValues[] | null;
  Handelsetyper_Add_Values?: TEDInputBOAktivitetHandelsetypAddValues[] | null;
  Handelsetyper_Update_Values?: TEDInputBOAktivitetHandelsetypUpdateValues[] | null;
  Handelsetyper_Delete_Values?: TEDInputBOAktivitetHandelsetypDeleteValues[] | null;
  BoknBestallningar_Add_Refs?: string[] | null;
  BoknBestallningar_Delete_Refs?: string[] | null;
  XBridge_Add_Refs?: string[] | null;
  XBridge_Delete_Refs?: string[] | null;
  RepeteradeAktiviteter_Add_Refs?: string[] | null;
  RepeteradeAktiviteter_Delete_Refs?: string[] | null;
  Utskick_Add_Refs?: string[] | null;
  Utskick_Delete_Refs?: string[] | null;
  AktPsalmer_Add_Values?: TEDInputBOAktPsalmerAddValues[] | null;
  AktPsalmer_Update_Values?: TEDInputBOAktPsalmerUpdateValues[] | null;
  AktPsalmer_Delete_Values?: TEDInputBOAktPsalmerDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av aktivitet
 */
export interface TEDInputBOAktivitetUpdateValues {
  id: string;
  _version: number;
  TITEL?: string | null;
  FRANDATUM?: any | null;
  FRANTID?: any | null;
  TILLDATUM?: any | null;
  TILLTID?: any | null;
  BOKNINGSNUMMER?: string | null;
  BOKNINGSNRINDEX?: number | null;
  TIDSTEXT?: string | null;
  BESKRIVNING?: string | null;
  BOKNINGSSIGNATUR?: string | null;
  BOKNINGSDATUM?: any | null;
  PRELBOKAD?: boolean | null;
  UTSKRIVEN?: boolean | null;
  AKTIVITETSGRUPP?: number | null;
  BESTALLARE_TYP?: TEDBOAktivitetBESTALLARE_TYPEnum | null;
  BESTALLARE_KONTAKT?: string | null;
  OTIMESTAMP?: number | null;
  WEBBOKAD?: boolean | null;
  ANTAL_BESOKARE?: number | null;
  STATISTIKUPPGIFT?: boolean | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  NOTERING2?: string | null;
  BEVAKNING?: boolean | null;
  BEVAKNING_DATUM?: any | null;
  BEVAKNING_TEXT?: string | null;
  REPAKTNR?: number | null;
  BESTALLARE_KONTAKT_INFO?: string | null;
  PUBL_STATUS?: TEDBOAktivitetPUBL_STATUSEnum | null;
  WEB_PUBL_STATUS?: TEDBOAktivitetWEB_PUBL_STATUSEnum | null;
  DOLJ_KALENDERTID?: boolean | null;
  AKTKAT_ANNONS?: string | null;
  SENAST_ANDRAD?: any | null;
  SENAST_ANDRAD_SIGNATUR?: string | null;
  MARKERAD_FAKTURERAD?: boolean | null;
  GRAVPLATS?: string | null;
  DODSDATUM?: string | null;
  RELATION?: string | null;
  KREMERING?: TEDBOAktivitetKREMERINGEnum | null;
  INTYG?: boolean | null;
  INTYG2?: boolean | null;
  BEGRBYRA_KONTAKT?: string | null;
  BEGRBYRA_KONTAKT_INFO?: string | null;
  REDAN_KREMERAD?: TEDBOAktivitetREDAN_KREMERADEnum | null;
  REDAN_GRAVSATT?: string | null;
  KREMERING_ANNAN_ORT?: boolean | null;
  JORDBEGRAVNING?: boolean | null;
  URNSATTNING?: boolean | null;
  MINNESLUND?: boolean | null;
  AN_NARVARANDE?: boolean | null;
  ENSKILT_DOP?: TEDBOAktivitetENSKILT_DOPEnum | null;
  VIGSELORDNING?: TEDBOAktivitetVIGSELORDNINGEnum | null;
  KOLLEKT?: string | null;
  ANTAL_KOMMUNIONER?: number | null;
  INGAR_PREDIKOTUR?: TEDBOAktivitetINGAR_PREDIKOTUREnum | null;
  HUVUDGUDSTJANST?: boolean | null;
  MAXANTDELT?: number | null;
  FAKTDELT?: TEDBOAktivitetFAKTDELTEnum | null;
  ANNONSERA?: boolean | null;
  SENASTE_ANM_DATUM?: any | null;
  ANM_KRAV_PERSNR?: TEDBOAktivitetANM_KRAV_PERSNREnum | null;
  LOKALUTHYR_INFO?: string | null;
  NYCKELNUMMER?: string | null;
  NYCKEL_UTLAMNINGSDATUM?: any | null;
  NYCKEL_ATERLAMNINGSDATUM?: any | null;
  NYCKEL_UTLAMNAD_SIGN?: string | null;
  NYCKEL_ATERLAMNAD_SIGN?: string | null;
  NYCKEL_NOTERING?: string | null;
  NYCKEL_AVHAMTARE_TYP?: string | null;
  ANDRAD?: boolean | null;
  SKK_ID?: number | null;
  SKKALENDER_ID?: string | null;
  SKK_SPRIDNINGSTYP_INTERN?: TEDBOAktivitetSKK_SPRIDNINGSTYP_INTERNEnum | null;
  SKK_SPRIDNINGSTYP_EXTERN?: boolean | null;
  SKK_KONTAKT_NAMN?: string | null;
  SKK_KONTAKT_TELEFON?: string | null;
  SKK_KONTAKT_SMTP?: string | null;
  SKK_URL1_TITEL?: string | null;
  SKK_URL1?: string | null;
  SKK_URL1_DIGITALT_MOTE?: boolean | null;
  SKK_URL2_TITEL?: string | null;
  SKK_URL2?: string | null;
  SKK_URL3_TITEL?: string | null;
  SKK_URL3?: string | null;
  SKK_PUBL_STATUS_INTERN?: boolean | null;
  SKK_SENAST_EXPORTERAD_TID?: any | null;
  SKK_SENAST_EXPORTERAD_DATUM?: any | null;
  SKK_SLUTTID?: string | null;
  XB_SENAST_EXPORTERAD?: any | null;
  AKT_MED_URNA?: boolean | null;
  XB_UNIQUE_THREAD_VALUE?: string | null;
  SKK_UNIQUE_THREAD_VALUE?: string | null;
  ASKGRAVLUND?: boolean | null;
  BEGRBYRA_NARVARAR?: boolean | null;
  INTYG_GRAVS?: any | null;
  INTYG_KREM?: any | null;
  INTYG_ML?: any | null;
  INTYG_GRAVOPPNING?: any | null;
  ANTAL_DOP?: number | null;
  ANTAL_VIGSLAR?: number | null;
  ANTAL_LEDIGA_DOP?: number | null;
  ANTAL_LEDIGA_VIGSLAR?: number | null;
  ANTAL_BARN?: number | null;
  GRUPP_ID?: number | null;
  FAKTURERAS?: boolean | null;
  ANTAL_TILLFALLEN?: number | null;
  FORSAMLINGS_ID?: number | null;
  NOTERING_PUBL_GUDSTJANST?: string | null;
  SEKRETESSMARKERAD?: string | null;
  _Associations?: TEDInputBOAktivitetUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av kalenderinfo
 */
export interface TEDInputBOAktivitetkalenderinfoAddValues {
  RESINFO?: string | null;
  KNUTAKTINFO?: string | null;
}

/**
 * Nya värden vid ändring av kalenderinfo
 */
export interface TEDInputBOAktivitetkalenderinfoUpdateValues {
  id: string;
  _version: number;
  RESINFO?: string | null;
  KNUTAKTINFO?: string | null;
}

/**
 * Associerade värden vid tillägg av aktivitetstyp
 */
export interface TEDInputBOAktivitetstypAddAssociationValues {
  AkttypNrSerie_Ref?: string | null;
  AkttypNrSerie_Values?: TEDInputSYSNummerserieAddValues | null;
  AktTypBoknGrupp_Ref?: string | null;
  AktTypBoknGrupp_Values?: TEDInputBOTEDBOAkttypBokngruppAddValues | null;
  Begravningstyp_Ref?: string | null;
  Begravningstyp_Values?: TEDInputBOBegravningstypAddValues | null;
  AkttypAkt_Add_Refs?: string[] | null;
  AktTypResrubrik_Add_Values?: TEDInputBOAktTypResrubrikAddValues[] | null;
  Resursplanering_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av aktivitetstyp
 */
export interface TEDInputBOAktivitetstypAddValues {
  NAMN: string;
  AKTIV: TEDBOAktivitetstypAKTIVEnum;
  SORTERINGSORDNING?: number | null;
  DOBESTBEKR?: number | null;
  VIBESTBEKR?: number | null;
  GRBESTBEKR?: number | null;
  BEBESTBEKR?: number | null;
  OVBESTBEKR?: number | null;
  ANBEKRBE?: number | null;
  ANBEKRGR?: number | null;
  MODERBEKR?: number | null;
  FADERBEKR?: number | null;
  BRUDBEKR?: number | null;
  BRUDGUMBEKR?: number | null;
  BEGRBYRABEKRGR?: number | null;
  BEGRBYRABEKRBG?: number | null;
  DOINTERNBEKR?: number | null;
  VIINTERNBEKR?: number | null;
  GRINTERNBEKR?: number | null;
  BEINTERNBEKR?: number | null;
  GUINTERNBEKR?: number | null;
  SNINTERNBEKR?: number | null;
  OVINTERNBEKR?: number | null;
  BOKBEKRNOTERINGAR?: string | null;
  SKRIVAUTPANYTT: TEDBOAktivitetstypSKRIVAUTPANYTTEnum;
  ANTALBLANKRADEROVR?: number | null;
  PAMINNELSETID?: number | null;
  STORSTIL_TITEL?: TEDBOAktivitetstypSTORSTIL_TITELEnum | null;
  AN_NARVARANDE: TEDBOAktivitetstypAN_NARVARANDEEnum;
  BOKNINGSBEKRAFTELSETEXT?: string | null;
  BEVAKNING_DATUM?: any | null;
  DELT_ANMALAN_TEXT?: string | null;
  DELT_BEKRAFTAD_TEXT?: string | null;
  DELT_AVVISAD_TEXT?: string | null;
  VARNA_JORD_KREM: TEDBOAktivitetstypVARNA_JORD_KREMEnum;
  MEDLEMSKOD?: string | null;
  PUBLICERINGSDAGAR?: number | null;
  BEKRAFTELSE_TIMMAR?: number | null;
  TABORT_WEBPUBL?: string | null;
  IGNORERA_ANTAL_BEKR?: string | null;
  TID_BESTALLNINGAR?: number | null;
  BEGRBYRA_NARVARAR?: boolean | null;
  KOPIERA_NOTERING2?: string | null;
  KOPIERA_BESKRIVNING?: string | null;
  AktivitetsFarg?: string | null;
  BO_GDPR_CLEARING?: number | null;
  BO_GDPR_OVRIGT?: number | null;
  TURNOFF_PHONE?: boolean | null;
  VISA_SLUTTID?: boolean | null;
  _Associations?: TEDInputBOAktivitetstypAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av aktivitetstyp
 */
export interface TEDInputBOAktivitetstypUpdateAssociationValues {
  AkttypNrSerie_Ref?: string | null;
  AkttypNrSerie_Values?: TEDInputSYSNummerserieUpdateValues | null;
  AktTypBoknGrupp_Ref?: string | null;
  AktTypBoknGrupp_Values?: TEDInputBOTEDBOAkttypBokngruppUpdateValues | null;
  Begravningstyp_Ref?: string | null;
  Begravningstyp_Values?: TEDInputBOBegravningstypUpdateValues | null;
  AkttypAkt_Add_Refs?: string[] | null;
  AkttypAkt_Delete_Refs?: string[] | null;
  AktTypResrubrik_Add_Values?: TEDInputBOAktTypResrubrikAddValues[] | null;
  AktTypResrubrik_Update_Values?: TEDInputBOAktTypResrubrikUpdateValues[] | null;
  AktTypResrubrik_Delete_Values?: TEDInputBOAktTypResrubrikDeleteValues[] | null;
  Resursplanering_Add_Refs?: string[] | null;
  Resursplanering_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av aktivitetstyp
 */
export interface TEDInputBOAktivitetstypUpdateValues {
  id: string;
  _version: number;
  NAMN?: string | null;
  AKTIV?: TEDBOAktivitetstypAKTIVEnum | null;
  SORTERINGSORDNING?: number | null;
  DOBESTBEKR?: number | null;
  VIBESTBEKR?: number | null;
  GRBESTBEKR?: number | null;
  BEBESTBEKR?: number | null;
  OVBESTBEKR?: number | null;
  ANBEKRBE?: number | null;
  ANBEKRGR?: number | null;
  MODERBEKR?: number | null;
  FADERBEKR?: number | null;
  BRUDBEKR?: number | null;
  BRUDGUMBEKR?: number | null;
  BEGRBYRABEKRGR?: number | null;
  BEGRBYRABEKRBG?: number | null;
  DOINTERNBEKR?: number | null;
  VIINTERNBEKR?: number | null;
  GRINTERNBEKR?: number | null;
  BEINTERNBEKR?: number | null;
  GUINTERNBEKR?: number | null;
  SNINTERNBEKR?: number | null;
  OVINTERNBEKR?: number | null;
  BOKBEKRNOTERINGAR?: string | null;
  SKRIVAUTPANYTT?: TEDBOAktivitetstypSKRIVAUTPANYTTEnum | null;
  ANTALBLANKRADEROVR?: number | null;
  PAMINNELSETID?: number | null;
  STORSTIL_TITEL?: TEDBOAktivitetstypSTORSTIL_TITELEnum | null;
  AN_NARVARANDE?: TEDBOAktivitetstypAN_NARVARANDEEnum | null;
  BOKNINGSBEKRAFTELSETEXT?: string | null;
  BEVAKNING_DATUM?: any | null;
  DELT_ANMALAN_TEXT?: string | null;
  DELT_BEKRAFTAD_TEXT?: string | null;
  DELT_AVVISAD_TEXT?: string | null;
  VARNA_JORD_KREM?: TEDBOAktivitetstypVARNA_JORD_KREMEnum | null;
  MEDLEMSKOD?: string | null;
  PUBLICERINGSDAGAR?: number | null;
  BEKRAFTELSE_TIMMAR?: number | null;
  TABORT_WEBPUBL?: string | null;
  IGNORERA_ANTAL_BEKR?: string | null;
  TID_BESTALLNINGAR?: number | null;
  BEGRBYRA_NARVARAR?: boolean | null;
  KOPIERA_NOTERING2?: string | null;
  KOPIERA_BESKRIVNING?: string | null;
  AktivitetsFarg?: string | null;
  BO_GDPR_CLEARING?: number | null;
  BO_GDPR_OVRIGT?: number | null;
  TURNOFF_PHONE?: boolean | null;
  VISA_SLUTTID?: boolean | null;
  _Associations?: TEDInputBOAktivitetstypUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av åldersindelning
 */
export interface TEDInputBOAldersindelningAddValues {
  KOD?: string | null;
  BENAMNING?: string | null;
  FRANDATUM?: any | null;
  TILLDATUM?: any | null;
}

/**
 * Nya värden vid ändring av åldersindelning
 */
export interface TEDInputBOAldersindelningUpdateValues {
  id: string;
  _version: number;
  KOD?: string | null;
  BENAMNING?: string | null;
  FRANDATUM?: any | null;
  TILLDATUM?: any | null;
}

/**
 * Associerade värden vid tillägg av arbetspass
 */
export interface TEDInputBOArbetspassAddAssociationValues {
  ArbetspassRes_Ref?: string | null;
  ArbetspassRes_Values?: TEDInputBOResursAddValues | null;
}

/**
 * Värden vid tillägg av arbetspass
 */
export interface TEDInputBOArbetspassAddValues {
  STARTAR?: number | null;
  STARTVECKA?: number | null;
  ANTALVECKOR?: number | null;
  ARBETSPASS1?: string | null;
  ARBETSPASS2?: string | null;
  ARBETSPASS3?: string | null;
  ARBETSPASS4?: string | null;
  _Associations?: TEDInputBOArbetspassAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av arbetspass
 */
export interface TEDInputBOArbetspassUpdateAssociationValues {
  ArbetspassRes_Ref?: string | null;
  ArbetspassRes_Values?: TEDInputBOResursUpdateValues | null;
}

/**
 * Nya värden vid ändring av arbetspass
 */
export interface TEDInputBOArbetspassUpdateValues {
  id: string;
  _version: number;
  STARTAR?: number | null;
  STARTVECKA?: number | null;
  ANTALVECKOR?: number | null;
  ARBETSPASS1?: string | null;
  ARBETSPASS2?: string | null;
  ARBETSPASS3?: string | null;
  ARBETSPASS4?: string | null;
  _Associations?: TEDInputBOArbetspassUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av arbetstid
 */
export interface TEDInputBOArbetstidAddAssociationValues {
  ArbetstidRes_Ref?: string | null;
  ArbetstidRes_Values?: TEDInputBOResursAddValues | null;
}

/**
 * Värden vid tillägg av arbetstid
 */
export interface TEDInputBOArbetstidAddValues {
  STARTAR?: number | null;
  STARTVECKA?: number | null;
  ANTALVECKOR?: number | null;
  ARBETSTID1?: string | null;
  ARBETSTID2?: string | null;
  ARBETSTID3?: string | null;
  ARBETSTID4?: string | null;
  _Associations?: TEDInputBOArbetstidAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av arbetstid
 */
export interface TEDInputBOArbetstidUpdateAssociationValues {
  ArbetstidRes_Ref?: string | null;
  ArbetstidRes_Values?: TEDInputBOResursUpdateValues | null;
}

/**
 * Nya värden vid ändring av arbetstid
 */
export interface TEDInputBOArbetstidUpdateValues {
  id: string;
  _version: number;
  STARTAR?: number | null;
  STARTVECKA?: number | null;
  ANTALVECKOR?: number | null;
  ARBETSTID1?: string | null;
  ARBETSTID2?: string | null;
  ARBETSTID3?: string | null;
  ARBETSTID4?: string | null;
  _Associations?: TEDInputBOArbetstidUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av begravningsordning
 */
export interface TEDInputBOBegravningstypAddValues {
  KOD: string;
  BENAMNING: string;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  CLEARINGSTYP: TEDBOBegravningstypCLEARINGSTYPEnum;
}

/**
 * Nya värden vid ändring av begravningsordning
 */
export interface TEDInputBOBegravningstypUpdateValues {
  id: string;
  _version: number;
  KOD?: string | null;
  BENAMNING?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  CLEARINGSTYP?: TEDBOBegravningstypCLEARINGSTYPEnum | null;
}

/**
 * Associerade värden vid tillägg av bevakning
 */
export interface TEDInputBOBevakningAddAssociationValues {
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetAddValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
  Bokningsgrupp_Ref?: string | null;
  Bokningsgrupp_Values?: TEDInputSYSBokngruppAddValues | null;
}

/**
 * Värden vid tillägg av bevakning
 */
export interface TEDInputBOBevakningAddValues {
  _typ: TEDBOBevakningTypEnum;
  GRUPP_ID?: number | null;
  _Associations?: TEDInputBOBevakningAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av bevakning
 */
export interface TEDInputBOBevakningDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av bevakning
 */
export interface TEDInputBOBevakningUpdateAssociationValues {
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetUpdateValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
  Bokningsgrupp_Ref?: string | null;
  Bokningsgrupp_Values?: TEDInputSYSBokngruppUpdateValues | null;
}

/**
 * Nya värden vid ändring av bevakning
 */
export interface TEDInputBOBevakningUpdateValues {
  id: string;
  _version: number;
  GRUPP_ID?: number | null;
  _Associations?: TEDInputBOBevakningUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av bOBisattningActiveX
 */
export interface TEDInputBOBisattningActiveXAddValues {
  BISATTNINGSJOURNAL_ID?: number | null;
  LOPNR?: number | null;
  BESKRIVNING?: string | null;
  FILNAMN?: string | null;
  SENAST_ANDRAD?: any | null;
  DATA?: string | null;
  DATASIZE?: number | null;
  DATATYPE?: string | null;
  EXTENSION?: string | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av bOBisattningActiveX
 */
export interface TEDInputBOBisattningActiveXDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av bOBisattningActiveX
 */
export interface TEDInputBOBisattningActiveXUpdateValues {
  id: string;
  _version: number;
  BISATTNINGSJOURNAL_ID?: number | null;
  LOPNR?: number | null;
  BESKRIVNING?: string | null;
  FILNAMN?: string | null;
  SENAST_ANDRAD?: any | null;
  DATA?: string | null;
  DATASIZE?: number | null;
  DATATYPE?: string | null;
  EXTENSION?: string | null;
}

/**
 * Associerade värden vid tillägg av bisättningsjournal
 */
export interface TEDInputBOBisattningAddAssociationValues {
  Begravningsbyra_Ref?: string | null;
  Begravningsbyra_Values?: TEDInputOPOrgPersLokAddValues | null;
  Kremation_Ref?: string | null;
  Kremation_Values?: TEDInputKJKremationAddValues | null;
  Begravning2_Ref?: string | null;
  Begravning2_Values?: TEDInputBOAktivitetAddValues | null;
  Gravsattning2_Ref?: string | null;
  Gravsattning2_Values?: TEDInputBOAktivitetAddValues | null;
  Bisattning_Ref?: string | null;
  Bisattning_Values?: TEDInputBOBisattningAddValues | null;
  Begravning_Ref?: string | null;
  Begravning_Values?: TEDInputBOAktivitetAddValues | null;
  Gravsattning_Ref?: string | null;
  Gravsattning_Values?: TEDInputBOAktivitetAddValues | null;
  Anhorig_Ref?: string | null;
  Anhorig_Values?: TEDInputOPOrgPersLokAddValues | null;
  Transportor_Ref?: string | null;
  Transportor_Values?: TEDInputOPOrgPersLokAddValues | null;
  Avlidna_Ref?: string | null;
  Avlidna_Values?: TEDInputOPAvlidenAddValues | null;
  SenasteHandelse_Ref?: string | null;
  SenasteHandelse_Values?: TEDInputBOBisattningshandelseAddValues | null;
  SenasteHandelse2_Ref?: string | null;
  SenasteHandelse2_Values?: TEDInputBOBisattningshandelseAddValues | null;
  BegravningsbyraKontakt_Ref?: string | null;
  BegravningsbyraKontakt_Values?: TEDInputBOBisattningKontaktAddValues | null;
  Bestallning_Ref?: string | null;
  Bestallning_Values?: TEDInputBOBisattningBestallningAddValues | null;
  Handelse_Add_Values?: TEDInputBOBisattningshandelseAddValues[] | null;
  Kontakter_Add_Values?: TEDInputBOBisattningKontaktAddValues[] | null;
  Dokument_Add_Values?: TEDInputBOBisattningActiveXAddValues[] | null;
  BisattningOrder_Add_Refs?: string[] | null;
  Utskick_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av bisättningsjournal
 */
export interface TEDInputBOBisattningAddValues {
  JOURNALNR?: string | null;
  BEGRBYRA_ID?: number | null;
  KREM_ID?: number | null;
  BEGR_ANNAN_ORT?: string | null;
  GRAVS_ANNAN_ORT?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  KREMERING?: TEDBOBisattningKREMERINGEnum | null;
  DODSDATUM?: string | null;
  BEGRBYRA_KONTAKT?: string | null;
  BEGRBYRA_KONTAKT_INFO?: string | null;
  SPARRAD?: boolean | null;
  FOSTERNUMMER?: string | null;
  FOSTER?: boolean | null;
  BORTTAGEN_SIGNATUR?: string | null;
  TOMURNA?: boolean | null;
  PLASTURNA?: boolean | null;
  BEGR_ANNAN_ORT_DATUM?: any | null;
  AKT_URNA?: boolean | null;
  TYP_KISTA?: string | null;
  TYP_URNA?: string | null;
  AKTNUMMER?: string | null;
  EXTRA_STOR_KISTA?: boolean | null;
  KISTMATT?: string | null;
  NOTERINGAR?: string | null;
  BEGR_ANNAN_ORT_TID?: any | null;
  GRAVS_ANNAN_ORT_TID?: any | null;
  GRAVS_ANNAN_ORT_DATUM?: any | null;
  OWNER_ID?: number | null;
  PACEMAKER?: TEDBOBisattningPACEMAKEREnum | null;
  VIKT?: string | null;
  MARKERAD_FAKTURERAD?: boolean | null;
  TOMURNA_PLACERING?: string | null;
  INTYG_KREM?: any | null;
  INTYG_GRAVS?: any | null;
  NOTERING2?: string | null;
  BEST_DIREKTKREMATION?: TEDBOBisattningBEST_DIREKTKREMATIONEnum | null;
  BEST_KREMATORIUM?: string | null;
  BEST_KREM_DATUM?: any | null;
  GIM?: string | null;
  INTYG_ML?: any | null;
  INTYG_DIREKT?: any | null;
  INTYG_GRAVOPPNING?: any | null;
  KREMERING_ANNAN_ORT?: boolean | null;
  GRAVPLATSNR?: string | null;
  TUTSKRIVEN_DATUM?: any | null;
  ANTALDAGAR_START?: any | null;
  ANTALDAGAR_SLUT?: any | null;
  SEKRETESSMARKERAD?: string | null;
  _Associations: TEDInputBOBisattningAddAssociationValues;
}

/**
 * Värden vid tillägg av bisättningsjournal Beställning
 */
export interface TEDInputBOBisattningBestallningAddValues {
  ID?: number | null;
  JOURNALNR?: string | null;
  AVLIDEN_ID?: number | null;
  BEGRBYRA_ID?: number | null;
  DIREKTARE?: boolean | null;
  BEGR_AKT_ID?: number | null;
  GRAVS_AKT_ID?: number | null;
  KREM_ID?: number | null;
  BEGR_ANNAN_ORT?: string | null;
  BEGR_ANNAN_ORT_DATUM?: any | null;
  GRAVS_ANNAN_ORT?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  KREMERING?: string | null;
  DODSDATUM?: string | null;
  BEGRBYRA_KONTAKT?: string | null;
  BEGRBYRA_KONTAKT_INFO?: string | null;
  SPARRAD?: string | null;
  FOSTERNUMMER?: string | null;
  FOSTER?: string | null;
  TOMURNA?: string | null;
  PLASTURNA?: string | null;
  AKT_URNA?: boolean | null;
  TYP_KISTA?: string | null;
  TYP_URNA?: string | null;
  AKTNUMMER?: string | null;
  EXTRA_STOR_KISTA?: boolean | null;
  KISTMATT?: string | null;
  NOTERINGAR?: string | null;
  BEGR_ANNAN_ORT_TID?: any | null;
  GRAVS_ANNAN_ORT_DATUM?: any | null;
  GRAVS_ANNAN_ORT_TID?: any | null;
  BEST_DIREKTKREMATION?: string | null;
  BEST_KREM_DATUM?: any | null;
  BEST_KREMATORIUM?: string | null;
  BESTALLNING_KREM?: any | null;
  GRAVSATTNINGSORT_ID?: number | null;
  INTYG_GRAVS?: any | null;
  INTYG_KREM?: any | null;
  MARKERAD_FAKTURERAD?: string | null;
  NOTERING2?: string | null;
  OWNER_ID?: number | null;
  PACEMAKER?: string | null;
  TOMURNA_PLACERING?: string | null;
  VIKT?: string | null;
}

/**
 * Nya värden vid ändring av bisättningsjournal Beställning
 */
export interface TEDInputBOBisattningBestallningUpdateValues {
  id: string;
  _version: number;
  ID?: number | null;
  JOURNALNR?: string | null;
  AVLIDEN_ID?: number | null;
  BEGRBYRA_ID?: number | null;
  DIREKTARE?: boolean | null;
  BEGR_AKT_ID?: number | null;
  GRAVS_AKT_ID?: number | null;
  KREM_ID?: number | null;
  BEGR_ANNAN_ORT?: string | null;
  BEGR_ANNAN_ORT_DATUM?: any | null;
  GRAVS_ANNAN_ORT?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  KREMERING?: string | null;
  DODSDATUM?: string | null;
  BEGRBYRA_KONTAKT?: string | null;
  BEGRBYRA_KONTAKT_INFO?: string | null;
  SPARRAD?: string | null;
  FOSTERNUMMER?: string | null;
  FOSTER?: string | null;
  TOMURNA?: string | null;
  PLASTURNA?: string | null;
  AKT_URNA?: boolean | null;
  TYP_KISTA?: string | null;
  TYP_URNA?: string | null;
  AKTNUMMER?: string | null;
  EXTRA_STOR_KISTA?: boolean | null;
  KISTMATT?: string | null;
  NOTERINGAR?: string | null;
  BEGR_ANNAN_ORT_TID?: any | null;
  GRAVS_ANNAN_ORT_DATUM?: any | null;
  GRAVS_ANNAN_ORT_TID?: any | null;
  BEST_DIREKTKREMATION?: string | null;
  BEST_KREM_DATUM?: any | null;
  BEST_KREMATORIUM?: string | null;
  BESTALLNING_KREM?: any | null;
  GRAVSATTNINGSORT_ID?: number | null;
  INTYG_GRAVS?: any | null;
  INTYG_KREM?: any | null;
  MARKERAD_FAKTURERAD?: string | null;
  NOTERING2?: string | null;
  OWNER_ID?: number | null;
  PACEMAKER?: string | null;
  TOMURNA_PLACERING?: string | null;
  VIKT?: string | null;
}

/**
 * Associerade värden vid tillägg av bisättningsjournal kontakt
 */
export interface TEDInputBOBisattningKontaktAddAssociationValues {
  Bisattning_Ref?: string | null;
  Bisattning_Values?: TEDInputBOBisattningAddValues | null;
  OrgPers_Ref?: string | null;
  OrgPers_Values?: TEDInputOPOrgPersLokAddValues | null;
  OrgPers2_Ref?: string | null;
  OrgPers2_Values?: TEDInputOPOrgPersLokAddValues | null;
}

/**
 * Värden vid tillägg av bisättningsjournal kontakt
 */
export interface TEDInputBOBisattningKontaktAddValues {
  _typ: TEDBOBisattningKontaktTypEnum;
  FRANDATUM?: any | null;
  KONTAKTPERSON?: string | null;
  RELATION?: string | null;
  STATUS?: string | null;
  BESTALLARE?: boolean | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  _Associations?: TEDInputBOBisattningKontaktAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av bisättningsjournal kontakt
 */
export interface TEDInputBOBisattningKontaktDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av bisättningsjournal kontakt
 */
export interface TEDInputBOBisattningKontaktUpdateAssociationValues {
  Bisattning_Ref?: string | null;
  Bisattning_Values?: TEDInputBOBisattningUpdateValues | null;
  OrgPers_Ref?: string | null;
  OrgPers_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  OrgPers2_Ref?: string | null;
  OrgPers2_Values?: TEDInputOPOrgPersLokUpdateValues | null;
}

/**
 * Nya värden vid ändring av bisättningsjournal kontakt
 */
export interface TEDInputBOBisattningKontaktUpdateValues {
  id: string;
  _version: number;
  FRANDATUM?: any | null;
  KONTAKTPERSON?: string | null;
  RELATION?: string | null;
  STATUS?: string | null;
  BESTALLARE?: boolean | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  _Associations?: TEDInputBOBisattningKontaktUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kremationsbeställning
 */
export interface TEDInputBOBisattningKremBestAddAssociationValues {
  Avliden_Ref?: string | null;
  Avliden_Values?: TEDInputOPOrgPersLokAddValues | null;
  Begravningsbyra_Ref?: string | null;
  Begravningsbyra_Values?: TEDInputOPOrgPersLokAddValues | null;
  Bestallare_Ref?: string | null;
  Bestallare_Values?: TEDInputOPOrgPersLokAddValues | null;
  Krematorium_Ref?: string | null;
  Krematorium_Values?: TEDInputKJKrematoriumAddValues | null;
  Mottagare_Ref?: string | null;
  Mottagare_Values?: TEDInputSYSUserAddValues | null;
  Bisattning_Ref?: string | null;
  Bisattning_Values?: TEDInputBOBisattningAddValues | null;
  Dokument_Add_Values?: TEDInputBOKremBestDokAddValues[] | null;
  Kontakter_Add_Values?: TEDInputBOBisattningKontaktAddValues[] | null;
}

/**
 * Värden vid tillägg av kremationsbeställning
 */
export interface TEDInputBOBisattningKremBestAddValues {
  STATUS?: TEDBOBisattningKremBestSTATUSEnum | null;
  BEST_DATUMTID?: any | null;
  KONTAKT_LOPNR?: number | null;
  DODSDATUM?: string | null;
  AKT_MED_URNA?: boolean | null;
  KREM_ANNAT?: string | null;
  MOTTAG_DATUMTID?: any | null;
  BISATTNING_ID?: number | null;
  TYP_URNA?: string | null;
  DIREKTARE?: boolean | null;
  KONTAKT_NAMN?: string | null;
  TYP_KISTA?: string | null;
  NARVARA?: boolean | null;
  AVVIKANDE_STR?: boolean | null;
  KONTAKT_ANHORIG_ID?: number | null;
  KONTAKT_BEGRBYRA_ID?: number | null;
  KONTAKT_OVRIG_PERS?: number | null;
  KONTAKT_OVRIG_ORG?: number | null;
  ANHORIG_HAMTAR?: boolean | null;
  NOTERING?: string | null;
  RELATION?: string | null;
  BEGR_DATUM_TID?: string | null;
  BEGR_PLATS?: string | null;
  GRAVS_DATUM_TID?: string | null;
  GRAVS_PLATS?: string | null;
  ARENDE_NR?: string | null;
  _Associations?: TEDInputBOBisattningKremBestAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av kremationsbeställning
 */
export interface TEDInputBOBisattningKremBestUpdateAssociationValues {
  Avliden_Ref?: string | null;
  Avliden_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Begravningsbyra_Ref?: string | null;
  Begravningsbyra_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Bestallare_Ref?: string | null;
  Bestallare_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Krematorium_Ref?: string | null;
  Krematorium_Values?: TEDInputKJKrematoriumUpdateValues | null;
  Mottagare_Ref?: string | null;
  Mottagare_Values?: TEDInputSYSUserUpdateValues | null;
  Bisattning_Ref?: string | null;
  Bisattning_Values?: TEDInputBOBisattningUpdateValues | null;
  Dokument_Add_Values?: TEDInputBOKremBestDokAddValues[] | null;
  Dokument_Update_Values?: TEDInputBOKremBestDokUpdateValues[] | null;
  Dokument_Delete_Values?: TEDInputBOKremBestDokDeleteValues[] | null;
  Kontakter_Add_Values?: TEDInputBOBisattningKontaktAddValues[] | null;
  Kontakter_Update_Values?: TEDInputBOBisattningKontaktUpdateValues[] | null;
  Kontakter_Delete_Values?: TEDInputBOBisattningKontaktDeleteValues[] | null;
  Kontakter_Undelete?: TEDInputBOBisattningKontaktDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av kremationsbeställning
 */
export interface TEDInputBOBisattningKremBestUpdateValues {
  id: string;
  _version: number;
  STATUS?: TEDBOBisattningKremBestSTATUSEnum | null;
  BEST_DATUMTID?: any | null;
  KONTAKT_LOPNR?: number | null;
  DODSDATUM?: string | null;
  AKT_MED_URNA?: boolean | null;
  KREM_ANNAT?: string | null;
  MOTTAG_DATUMTID?: any | null;
  BISATTNING_ID?: number | null;
  TYP_URNA?: string | null;
  DIREKTARE?: boolean | null;
  KONTAKT_NAMN?: string | null;
  TYP_KISTA?: string | null;
  NARVARA?: boolean | null;
  AVVIKANDE_STR?: boolean | null;
  KONTAKT_ANHORIG_ID?: number | null;
  KONTAKT_BEGRBYRA_ID?: number | null;
  KONTAKT_OVRIG_PERS?: number | null;
  KONTAKT_OVRIG_ORG?: number | null;
  ANHORIG_HAMTAR?: boolean | null;
  NOTERING?: string | null;
  RELATION?: string | null;
  BEGR_DATUM_TID?: string | null;
  BEGR_PLATS?: string | null;
  GRAVS_DATUM_TID?: string | null;
  GRAVS_PLATS?: string | null;
  ARENDE_NR?: string | null;
  _Associations?: TEDInputBOBisattningKremBestUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av mottagare utskick
 */
export interface TEDInputBOBisattningMottagareAddAssociationValues {
  Handelse_Ref?: string | null;
  Handelse_Values?: TEDInputGAHandelseAddValues | null;
  Kontakt_Ref?: string | null;
  Kontakt_Values?: TEDInputBOBisattningKontaktAddValues | null;
}

/**
 * Värden vid tillägg av mottagare utskick
 */
export interface TEDInputBOBisattningMottagareAddValues {
  HANDELSE_ID?: number | null;
  BISATTNINGSJOURNAL_ID?: number | null;
  LOPNR?: number | null;
  _Associations: TEDInputBOBisattningMottagareAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av mottagare utskick
 */
export interface TEDInputBOBisattningMottagareDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av mottagare utskick
 */
export interface TEDInputBOBisattningMottagareUpdateAssociationValues {
  Handelse_Ref?: string | null;
  Handelse_Values?: TEDInputGAHandelseUpdateValues | null;
  Kontakt_Ref?: string | null;
  Kontakt_Values?: TEDInputBOBisattningKontaktUpdateValues | null;
}

/**
 * Nya värden vid ändring av mottagare utskick
 */
export interface TEDInputBOBisattningMottagareUpdateValues {
  id: string;
  _version: number;
  HANDELSE_ID?: number | null;
  BISATTNINGSJOURNAL_ID?: number | null;
  LOPNR?: number | null;
  _Associations?: TEDInputBOBisattningMottagareUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av bisättningsjournal
 */
export interface TEDInputBOBisattningUpdateAssociationValues {
  Begravningsbyra_Ref?: string | null;
  Begravningsbyra_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Kremation_Ref?: string | null;
  Kremation_Values?: TEDInputKJKremationUpdateValues | null;
  Begravning2_Ref?: string | null;
  Begravning2_Values?: TEDInputBOAktivitetUpdateValues | null;
  Gravsattning2_Ref?: string | null;
  Gravsattning2_Values?: TEDInputBOAktivitetUpdateValues | null;
  Bisattning_Ref?: string | null;
  Bisattning_Values?: TEDInputBOBisattningUpdateValues | null;
  Begravning_Ref?: string | null;
  Begravning_Values?: TEDInputBOAktivitetUpdateValues | null;
  Gravsattning_Ref?: string | null;
  Gravsattning_Values?: TEDInputBOAktivitetUpdateValues | null;
  Anhorig_Ref?: string | null;
  Anhorig_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Transportor_Ref?: string | null;
  Transportor_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Avlidna_Ref?: string | null;
  Avlidna_Values?: TEDInputOPAvlidenUpdateValues | null;
  SenasteHandelse_Ref?: string | null;
  SenasteHandelse_Values?: TEDInputBOBisattningshandelseUpdateValues | null;
  SenasteHandelse2_Ref?: string | null;
  SenasteHandelse2_Values?: TEDInputBOBisattningshandelseUpdateValues | null;
  BegravningsbyraKontakt_Ref?: string | null;
  BegravningsbyraKontakt_Values?: TEDInputBOBisattningKontaktUpdateValues | null;
  Bestallning_Ref?: string | null;
  Bestallning_Values?: TEDInputBOBisattningBestallningUpdateValues | null;
  Handelse_Add_Values?: TEDInputBOBisattningshandelseAddValues[] | null;
  Handelse_Update_Values?: TEDInputBOBisattningshandelseUpdateValues[] | null;
  Handelse_Delete_Values?: TEDInputBOBisattningshandelseDeleteValues[] | null;
  Handelse_Undelete?: TEDInputBOBisattningshandelseDeleteValues[] | null;
  Kontakter_Add_Values?: TEDInputBOBisattningKontaktAddValues[] | null;
  Kontakter_Update_Values?: TEDInputBOBisattningKontaktUpdateValues[] | null;
  Kontakter_Delete_Values?: TEDInputBOBisattningKontaktDeleteValues[] | null;
  Kontakter_Undelete?: TEDInputBOBisattningKontaktDeleteValues[] | null;
  Dokument_Add_Values?: TEDInputBOBisattningActiveXAddValues[] | null;
  Dokument_Update_Values?: TEDInputBOBisattningActiveXUpdateValues[] | null;
  Dokument_Delete_Values?: TEDInputBOBisattningActiveXDeleteValues[] | null;
  BisattningOrder_Add_Refs?: string[] | null;
  BisattningOrder_Delete_Refs?: string[] | null;
  Utskick_Add_Refs?: string[] | null;
  Utskick_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av bisättningsjournal
 */
export interface TEDInputBOBisattningUpdateValues {
  id: string;
  _version: number;
  JOURNALNR?: string | null;
  BEGRBYRA_ID?: number | null;
  KREM_ID?: number | null;
  BEGR_ANNAN_ORT?: string | null;
  GRAVS_ANNAN_ORT?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  KREMERING?: TEDBOBisattningKREMERINGEnum | null;
  DODSDATUM?: string | null;
  BEGRBYRA_KONTAKT?: string | null;
  BEGRBYRA_KONTAKT_INFO?: string | null;
  SPARRAD?: boolean | null;
  FOSTERNUMMER?: string | null;
  FOSTER?: boolean | null;
  BORTTAGEN_SIGNATUR?: string | null;
  TOMURNA?: boolean | null;
  PLASTURNA?: boolean | null;
  BEGR_ANNAN_ORT_DATUM?: any | null;
  AKT_URNA?: boolean | null;
  TYP_KISTA?: string | null;
  TYP_URNA?: string | null;
  AKTNUMMER?: string | null;
  EXTRA_STOR_KISTA?: boolean | null;
  KISTMATT?: string | null;
  NOTERINGAR?: string | null;
  BEGR_ANNAN_ORT_TID?: any | null;
  GRAVS_ANNAN_ORT_TID?: any | null;
  GRAVS_ANNAN_ORT_DATUM?: any | null;
  OWNER_ID?: number | null;
  PACEMAKER?: TEDBOBisattningPACEMAKEREnum | null;
  VIKT?: string | null;
  MARKERAD_FAKTURERAD?: boolean | null;
  TOMURNA_PLACERING?: string | null;
  INTYG_KREM?: any | null;
  INTYG_GRAVS?: any | null;
  NOTERING2?: string | null;
  BEST_DIREKTKREMATION?: TEDBOBisattningBEST_DIREKTKREMATIONEnum | null;
  BEST_KREMATORIUM?: string | null;
  BEST_KREM_DATUM?: any | null;
  GIM?: string | null;
  INTYG_ML?: any | null;
  INTYG_DIREKT?: any | null;
  INTYG_GRAVOPPNING?: any | null;
  KREMERING_ANNAN_ORT?: boolean | null;
  GRAVPLATSNR?: string | null;
  TUTSKRIVEN_DATUM?: any | null;
  ANTALDAGAR_START?: any | null;
  ANTALDAGAR_SLUT?: any | null;
  SEKRETESSMARKERAD?: string | null;
  _Associations?: TEDInputBOBisattningUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av bisättningshändelse
 */
export interface TEDInputBOBisattningshandelseAddAssociationValues {
  Bisattningstyp_Ref?: string | null;
  Bisattningstyp_Values?: TEDInputBOBisattningstypAddValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
  Lokal_Ref?: string | null;
  Lokal_Values?: TEDInputBOBisattningslokalAddValues | null;
  Utcheckingsstatus_Ref?: string | null;
  Utcheckingsstatus_Values?: TEDInputBOUtcheckningsstatusAddValues | null;
  Tillbakalokal_Ref?: string | null;
  Tillbakalokal_Values?: TEDInputBOBisattningslokalAddValues | null;
  Placering_Ref?: string | null;
  Placering_Values?: TEDInputBOBisattningsposAddValues | null;
  Journal_Ref?: string | null;
  Journal_Values?: TEDInputBOBisattningAddValues | null;
  UtcheckningsstatusUrna_Ref?: string | null;
  UtcheckningsstatusUrna_Values?: TEDInputBOUtcheckningsstatusUrnaAddValues | null;
  UtcheckningsstatusStoft_Ref?: string | null;
  UtcheckningsstatusStoft_Values?: TEDInputBOUtcheckningsstatusStoftAddValues | null;
  UtcheckadKremation_Ref?: string | null;
  UtcheckadKremation_Values?: TEDInputKJKremationAddValues | null;
}

/**
 * Värden vid tillägg av bisättningshändelse
 */
export interface TEDInputBOBisattningshandelseAddValues {
  _typ: TEDBOBisattningshandelseTypEnum;
  BISATTNINGSTYP_ID?: number | null;
  DATUM?: any | null;
  KONTAKTPERSON?: string | null;
  ANTECKNING?: string | null;
  BERAKNAT_AVHAMTNINGS_DATUM?: any | null;
  PLACERING_EJ_MALL?: string | null;
  TILLBAKA?: boolean | null;
  TILLBAKADATUM?: any | null;
  TILLBAKATID?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN?: string | null;
  TYP_KISTA_URNA?: string | null;
  TRANSPORTOR?: string | null;
  AVHAMTARE?: string | null;
  _Associations: TEDInputBOBisattningshandelseAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av bisättningshändelse
 */
export interface TEDInputBOBisattningshandelseDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av bisättningshändelse
 */
export interface TEDInputBOBisattningshandelseUpdateAssociationValues {
  Bisattningstyp_Ref?: string | null;
  Bisattningstyp_Values?: TEDInputBOBisattningstypUpdateValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
  Lokal_Ref?: string | null;
  Lokal_Values?: TEDInputBOBisattningslokalUpdateValues | null;
  Utcheckingsstatus_Ref?: string | null;
  Utcheckingsstatus_Values?: TEDInputBOUtcheckningsstatusUpdateValues | null;
  Tillbakalokal_Ref?: string | null;
  Tillbakalokal_Values?: TEDInputBOBisattningslokalUpdateValues | null;
  Placering_Ref?: string | null;
  Placering_Values?: TEDInputBOBisattningsposUpdateValues | null;
  Journal_Ref?: string | null;
  Journal_Values?: TEDInputBOBisattningUpdateValues | null;
  UtcheckningsstatusUrna_Ref?: string | null;
  UtcheckningsstatusUrna_Values?: TEDInputBOUtcheckningsstatusUrnaUpdateValues | null;
  UtcheckningsstatusStoft_Ref?: string | null;
  UtcheckningsstatusStoft_Values?: TEDInputBOUtcheckningsstatusStoftUpdateValues | null;
  UtcheckadKremation_Ref?: string | null;
  UtcheckadKremation_Values?: TEDInputKJKremationUpdateValues | null;
}

/**
 * Nya värden vid ändring av bisättningshändelse
 */
export interface TEDInputBOBisattningshandelseUpdateValues {
  id: string;
  _version: number;
  BISATTNINGSTYP_ID?: number | null;
  DATUM?: any | null;
  KONTAKTPERSON?: string | null;
  ANTECKNING?: string | null;
  BERAKNAT_AVHAMTNINGS_DATUM?: any | null;
  PLACERING_EJ_MALL?: string | null;
  TILLBAKA?: boolean | null;
  TILLBAKADATUM?: any | null;
  TILLBAKATID?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN?: string | null;
  TYP_KISTA_URNA?: string | null;
  TRANSPORTOR?: string | null;
  AVHAMTARE?: string | null;
  _Associations?: TEDInputBOBisattningshandelseUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av bisättningslokal
 */
export interface TEDInputBOBisattningslokalAddAssociationValues {
  Rum_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av bisättningslokal
 */
export interface TEDInputBOBisattningslokalAddValues {
  BENAMNING?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  MAX_ANTAL_KISTOR?: number | null;
  _Associations?: TEDInputBOBisattningslokalAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av bisättningslokal
 */
export interface TEDInputBOBisattningslokalUpdateAssociationValues {
  Rum_Add_Refs?: string[] | null;
  Rum_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av bisättningslokal
 */
export interface TEDInputBOBisattningslokalUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  MAX_ANTAL_KISTOR?: number | null;
  _Associations?: TEDInputBOBisattningslokalUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av bisättningsposition
 */
export interface TEDInputBOBisattningsposAddAssociationValues {
  Del_Ref?: string | null;
  Del_Values?: TEDInputBOBisattningsrumdelAddValues | null;
}

/**
 * Värden vid tillägg av bisättningsposition
 */
export interface TEDInputBOBisattningsposAddValues {
  DEL_ID?: number | null;
  RAD?: number | null;
  KOLUMN?: number | null;
  BENAMNING?: string | null;
  ORDNING?: number | null;
  _Associations: TEDInputBOBisattningsposAddAssociationValues;
}

/**
 * Associerade värden vid ändring av bisättningsposition
 */
export interface TEDInputBOBisattningsposUpdateAssociationValues {
  Del_Ref?: string | null;
  Del_Values?: TEDInputBOBisattningsrumdelUpdateValues | null;
}

/**
 * Nya värden vid ändring av bisättningsposition
 */
export interface TEDInputBOBisattningsposUpdateValues {
  id: string;
  _version: number;
  DEL_ID?: number | null;
  RAD?: number | null;
  KOLUMN?: number | null;
  BENAMNING?: string | null;
  ORDNING?: number | null;
  _Associations?: TEDInputBOBisattningsposUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av bisättningsrum
 */
export interface TEDInputBOBisattningsrumAddAssociationValues {
  Resurs_Ref?: string | null;
  Resurs_Values?: TEDInputBOResursAddValues | null;
  Del_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av bisättningsrum
 */
export interface TEDInputBOBisattningsrumAddValues {
  LOKAL_ID?: number | null;
  BENAMNING?: string | null;
  STANGS_TI?: any | null;
  PRIORITET?: number | null;
  AUTOPLACERING?: boolean | null;
  FULL_BENAMNING?: boolean | null;
  TYP?: string | null;
  _Associations?: TEDInputBOBisattningsrumAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av bisättningsrum
 */
export interface TEDInputBOBisattningsrumUpdateAssociationValues {
  Resurs_Ref?: string | null;
  Resurs_Values?: TEDInputBOResursUpdateValues | null;
  Del_Add_Refs?: string[] | null;
  Del_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av bisättningsrum
 */
export interface TEDInputBOBisattningsrumUpdateValues {
  id: string;
  _version: number;
  LOKAL_ID?: number | null;
  BENAMNING?: string | null;
  STANGS_TI?: any | null;
  PRIORITET?: number | null;
  AUTOPLACERING?: boolean | null;
  FULL_BENAMNING?: boolean | null;
  TYP?: string | null;
  _Associations?: TEDInputBOBisattningsrumUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av bisättningsdel
 */
export interface TEDInputBOBisattningsrumdelAddAssociationValues {
  Rum_Ref?: string | null;
  Rum_Values?: TEDInputBOBisattningsrumAddValues | null;
  Pos_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av bisättningsdel
 */
export interface TEDInputBOBisattningsrumdelAddValues {
  RUM_ID?: number | null;
  BENAMNING?: string | null;
  RADER?: number | null;
  KOLUMNER?: number | null;
  MAX_KISTOR?: number | null;
  MAX_URNOR?: number | null;
  TYP?: string | null;
  FULL_BENAMNING?: boolean | null;
  _Associations: TEDInputBOBisattningsrumdelAddAssociationValues;
}

/**
 * Associerade värden vid ändring av bisättningsdel
 */
export interface TEDInputBOBisattningsrumdelUpdateAssociationValues {
  Rum_Ref?: string | null;
  Rum_Values?: TEDInputBOBisattningsrumUpdateValues | null;
  Pos_Add_Refs?: string[] | null;
  Pos_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av bisättningsdel
 */
export interface TEDInputBOBisattningsrumdelUpdateValues {
  id: string;
  _version: number;
  RUM_ID?: number | null;
  BENAMNING?: string | null;
  RADER?: number | null;
  KOLUMNER?: number | null;
  MAX_KISTOR?: number | null;
  MAX_URNOR?: number | null;
  TYP?: string | null;
  FULL_BENAMNING?: boolean | null;
  _Associations?: TEDInputBOBisattningsrumdelUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av bisättningstyp
 */
export interface TEDInputBOBisattningstypAddValues {
  BENAMNING?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  AKTIV?: boolean | null;
  Etikett?: string | null;
}

/**
 * Nya värden vid ändring av bisättningstyp
 */
export interface TEDInputBOBisattningstypUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  AKTIV?: boolean | null;
  Etikett?: string | null;
}

/**
 * Associerade värden vid tillägg av beställning
 */
export interface TEDInputBOBoknBestallningAddAssociationValues {
  Avliden_Ref?: string | null;
  Avliden_Values?: TEDInputOPOrgPersLokAddValues | null;
  Anhorig_Ref?: string | null;
  Anhorig_Values?: TEDInputOPOrgPersLokAddValues | null;
  Begravningstyp_Ref?: string | null;
  Begravningstyp_Values?: TEDInputBOBegravningstypAddValues | null;
  Kyrkogard_Ref?: string | null;
  Kyrkogard_Values?: TEDInputGAKGardAddValues | null;
  Kvarter_Ref?: string | null;
  Kvarter_Values?: TEDInputGAKvarterAddValues | null;
  Avdelning_Ref?: string | null;
  Avdelning_Values?: TEDInputGAAvdelningAddValues | null;
  Begravningsbyra_Ref?: string | null;
  Begravningsbyra_Values?: TEDInputOPOrgPersLokAddValues | null;
  Bestallare_Ref?: string | null;
  Bestallare_Values?: TEDInputOPOrgPersLokAddValues | null;
  Mottagare_Ref?: string | null;
  Mottagare_Values?: TEDInputSYSUserAddValues | null;
  Krematorium_Ref?: string | null;
  Krematorium_Values?: TEDInputKJKrematoriumAddValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
}

/**
 * Värden vid tillägg av beställning
 */
export interface TEDInputBOBoknBestallningAddValues {
  KONTAKT_LOPNR?: number | null;
  GRAVPLATS?: string | null;
  GRAVNUMMER?: string | null;
  DODSDATUM?: string | null;
  GRAVSATTNINGS_TYP?: TEDBOBoknBestallningGRAVSATTNINGS_TYPEnum | null;
  RELATION?: string | null;
  AKT_NR?: string | null;
  NOTERING?: string | null;
  BEST_DATUM: any;
  BEST_TID: any;
  AKT_MED_URNA?: boolean | null;
  INTYG_GRAVS?: any | null;
  INTYG_ML?: any | null;
  BEGRBYRA_NARVARAR?: boolean | null;
  KREM_ANNAT?: string | null;
  KREM_URNMATERIAL?: string | null;
  KREM_ANH_DELTAR?: boolean | null;
  TVIST?: boolean | null;
  INTYG_GRAVOPPNING?: any | null;
  _Associations: TEDInputBOBoknBestallningAddAssociationValues;
}

/**
 * Associerade värden vid ändring av beställning
 */
export interface TEDInputBOBoknBestallningUpdateAssociationValues {
  Avliden_Ref?: string | null;
  Avliden_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Anhorig_Ref?: string | null;
  Anhorig_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Begravningstyp_Ref?: string | null;
  Begravningstyp_Values?: TEDInputBOBegravningstypUpdateValues | null;
  Kyrkogard_Ref?: string | null;
  Kyrkogard_Values?: TEDInputGAKGardUpdateValues | null;
  Kvarter_Ref?: string | null;
  Kvarter_Values?: TEDInputGAKvarterUpdateValues | null;
  Avdelning_Ref?: string | null;
  Avdelning_Values?: TEDInputGAAvdelningUpdateValues | null;
  Begravningsbyra_Ref?: string | null;
  Begravningsbyra_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Bestallare_Ref?: string | null;
  Bestallare_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Mottagare_Ref?: string | null;
  Mottagare_Values?: TEDInputSYSUserUpdateValues | null;
  Krematorium_Ref?: string | null;
  Krematorium_Values?: TEDInputKJKrematoriumUpdateValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
}

/**
 * Nya värden vid ändring av beställning
 */
export interface TEDInputBOBoknBestallningUpdateValues {
  id: string;
  _version: number;
  KONTAKT_LOPNR?: number | null;
  GRAVPLATS?: string | null;
  GRAVNUMMER?: string | null;
  DODSDATUM?: string | null;
  GRAVSATTNINGS_TYP?: TEDBOBoknBestallningGRAVSATTNINGS_TYPEnum | null;
  RELATION?: string | null;
  AKT_NR?: string | null;
  NOTERING?: string | null;
  BEST_DATUM?: any | null;
  BEST_TID?: any | null;
  AKT_MED_URNA?: boolean | null;
  INTYG_GRAVS?: any | null;
  INTYG_ML?: any | null;
  BEGRBYRA_NARVARAR?: boolean | null;
  KREM_ANNAT?: string | null;
  KREM_URNMATERIAL?: string | null;
  KREM_ANH_DELTAR?: boolean | null;
  TVIST?: boolean | null;
  INTYG_GRAVOPPNING?: any | null;
  _Associations?: TEDInputBOBoknBestallningUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av bokningsgrupp av resurser
 */
export interface TEDInputBOBoknGruppResursAddAssociationValues {
  Resurs_Ref?: string | null;
  Resurs_Values?: TEDInputBOResursAddValues | null;
  Bokningsgrupp_Ref?: string | null;
  Bokningsgrupp_Values?: TEDInputSYSBokngruppAddValues | null;
}

/**
 * Värden vid tillägg av bokningsgrupp av resurser
 */
export interface TEDInputBOBoknGruppResursAddValues {
  _Associations: TEDInputBOBoknGruppResursAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av bokningsgrupp av resurser
 */
export interface TEDInputBOBoknGruppResursDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av bokningsgrupp av resurser
 */
export interface TEDInputBOBoknGruppResursUpdateAssociationValues {
  Resurs_Ref?: string | null;
  Resurs_Values?: TEDInputBOResursUpdateValues | null;
  Bokningsgrupp_Ref?: string | null;
  Bokningsgrupp_Values?: TEDInputSYSBokngruppUpdateValues | null;
}

/**
 * Nya värden vid ändring av bokningsgrupp av resurser
 */
export interface TEDInputBOBoknGruppResursUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputBOBoknGruppResursUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av bokning
 */
export interface TEDInputBOBokningAddAssociationValues {
  BoknRub_Ref?: string | null;
  BoknRub_Values?: TEDInputBOBokningsrubrikAddValues | null;
  BokAkt_Ref?: string | null;
  BokAkt_Values?: TEDInputBOAktivitetAddValues | null;
  Rubrik1_Ref?: string | null;
  Rubrik1_Values?: TEDInputBOBokningsrubrikAddValues | null;
}

/**
 * Värden vid tillägg av bokning
 */
export interface TEDInputBOBokningAddValues {
  DATUM?: any | null;
  FRANTID?: any | null;
  TILLTID?: any | null;
  _Associations: TEDInputBOBokningAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av bokning
 */
export interface TEDInputBOBokningDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av bokning
 */
export interface TEDInputBOBokningUpdateAssociationValues {
  BoknRub_Ref?: string | null;
  BoknRub_Values?: TEDInputBOBokningsrubrikUpdateValues | null;
  BokAkt_Ref?: string | null;
  BokAkt_Values?: TEDInputBOAktivitetUpdateValues | null;
  Rubrik1_Ref?: string | null;
  Rubrik1_Values?: TEDInputBOBokningsrubrikUpdateValues | null;
}

/**
 * Nya värden vid ändring av bokning
 */
export interface TEDInputBOBokningUpdateValues {
  id: string;
  _version: number;
  DATUM?: any | null;
  FRANTID?: any | null;
  TILLTID?: any | null;
  _Associations?: TEDInputBOBokningUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av bokningsrubrik
 */
export interface TEDInputBOBokningsrubrikAddAssociationValues {
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetAddValues | null;
  Resurs_Ref?: string | null;
  Resurs_Values?: TEDInputBOResursAddValues | null;
  AktResRubrik_Ref?: string | null;
  AktResRubrik_Values?: TEDInputBOAktivitetResrubrikAddValues | null;
  Bokningar_Add_Values?: TEDInputBOBokningAddValues[] | null;
  FaktOmgRad_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av bokningsrubrik
 */
export interface TEDInputBOBokningsrubrikAddValues {
  RESURS_NAMN: string;
  AKTRESRUB_AKT_ID?: number | null;
  AKTRESRUB_POSNR?: number | null;
  KOD?: TEDBOBokningsrubrikKODEnum | null;
  FRANDATUM?: any | null;
  TILLDATUM?: any | null;
  FRANTID?: any | null;
  TILLTID?: any | null;
  TIDSTEXT?: string | null;
  OUTLOOK_PAMINNELSE?: number | null;
  XB_ID?: string | null;
  XB_VER?: string | null;
  XB_EMAIL?: string | null;
  XB_SENT_TIME?: any | null;
  VARME_STANDARD?: number | null;
  _Associations?: TEDInputBOBokningsrubrikAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av bokningsrubrik
 */
export interface TEDInputBOBokningsrubrikDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av bokningsrubrik
 */
export interface TEDInputBOBokningsrubrikUpdateAssociationValues {
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetUpdateValues | null;
  Resurs_Ref?: string | null;
  Resurs_Values?: TEDInputBOResursUpdateValues | null;
  AktResRubrik_Ref?: string | null;
  AktResRubrik_Values?: TEDInputBOAktivitetResrubrikUpdateValues | null;
  Bokningar_Add_Values?: TEDInputBOBokningAddValues[] | null;
  Bokningar_Update_Values?: TEDInputBOBokningUpdateValues[] | null;
  Bokningar_Delete_Values?: TEDInputBOBokningDeleteValues[] | null;
  FaktOmgRad_Add_Refs?: string[] | null;
  FaktOmgRad_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av bokningsrubrik
 */
export interface TEDInputBOBokningsrubrikUpdateValues {
  id: string;
  _version: number;
  RESURS_NAMN?: string | null;
  AKTRESRUB_AKT_ID?: number | null;
  AKTRESRUB_POSNR?: number | null;
  KOD?: TEDBOBokningsrubrikKODEnum | null;
  FRANDATUM?: any | null;
  TILLDATUM?: any | null;
  FRANTID?: any | null;
  TILLTID?: any | null;
  TIDSTEXT?: string | null;
  OUTLOOK_PAMINNELSE?: number | null;
  XB_ID?: string | null;
  XB_VER?: string | null;
  XB_EMAIL?: string | null;
  XB_SENT_TIME?: any | null;
  VARME_STANDARD?: number | null;
  _Associations?: TEDInputBOBokningsrubrikUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av fakturaunderlag
 */
export interface TEDInputBOFaktOmgAddAssociationValues {
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetAddValues | null;
  Prislista_Ref?: string | null;
  Prislista_Values?: TEDInputLAPrislistaAddValues | null;
  Kund_Ref?: string | null;
  Kund_Values?: TEDInputKRKundAddValues | null;
  Faktureringsgrupp_Ref?: string | null;
  Faktureringsgrupp_Values?: TEDInputSYSGruppAddValues | null;
  FaktOmgOrdrad_Add_Values?: TEDInputBOFaktOmgOrdradAddValues[] | null;
  AktOrder_Add_Values?: TEDInputBOAktivitetOrderAddValues[] | null;
}

/**
 * Värden vid tillägg av fakturaunderlag
 */
export interface TEDInputBOFaktOmgAddValues {
  BENAMNING?: string | null;
  TEXT?: string | null;
  STATUS?: TEDBOFaktOmgSTATUSEnum | null;
  BEVAKNDAT?: any | null;
  VARREFERENS?: string | null;
  AKTUELLAPRISER?: TEDBOFaktOmgAKTUELLAPRISEREnum | null;
  KUNDREFERENS?: string | null;
  CLEARING?: string | null;
  SKAPAD_DATUM?: any | null;
  SKAPAD_SIGNATUR?: string | null;
  FORRATTNINGSTYP?: TEDBOFaktOmgFORRATTNINGSTYPEnum | null;
  FAKTURERINGSSATT: TEDBOFaktOmgFAKTURERINGSSATTEnum;
  FAKTDELT?: boolean | null;
  FAKT_DODSBO?: boolean | null;
  FORFALLOTYP?: TEDBOFaktOmgFORFALLOTYPEnum | null;
  FORFALLODATUM?: any | null;
  _Associations: TEDInputBOFaktOmgAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av fakturaunderlag
 */
export interface TEDInputBOFaktOmgDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid tillägg av fakturaunderlagsrad
 */
export interface TEDInputBOFaktOmgOrdradAddAssociationValues {
  Faktomg_Ref?: string | null;
  Faktomg_Values?: TEDInputBOFaktOmgAddValues | null;
  Bokningsrubrik_Ref?: string | null;
  Bokningsrubrik_Values?: TEDInputBOBokningsrubrikAddValues | null;
  Fakturatext_Ref?: string | null;
  Fakturatext_Values?: TEDInputLAFakturatextAddValues | null;
  Artikel_Ref?: string | null;
  Artikel_Values?: TEDInputLAArtikelAddValues | null;
  Kontering_Add_Values?: TEDInputBOFaktOmgOrdradKonteringAddValues[] | null;
}

/**
 * Värden vid tillägg av fakturaunderlagsrad
 */
export interface TEDInputBOFaktOmgOrdradAddValues {
  _typ: TEDBOFaktOmgOrdradTypEnum;
  ORDNNR?: number | null;
  BENAMNING?: string | null;
  RADKOD?: TEDBOFaktOmgOrdradRADKODEnum | null;
  ANTAL?: number | null;
  APRIS?: any | null;
  RABATT?: number | null;
  _Associations?: TEDInputBOFaktOmgOrdradAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av fakturaunderlagsrad
 */
export interface TEDInputBOFaktOmgOrdradDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid tillägg av konteringsrad
 */
export interface TEDInputBOFaktOmgOrdradKonteringAddAssociationValues {
  FaktOmgRad_Ref?: string | null;
  FaktOmgRad_Values?: TEDInputBOFaktOmgOrdradAddValues | null;
}

/**
 * Värden vid tillägg av konteringsrad
 */
export interface TEDInputBOFaktOmgOrdradKonteringAddValues {
  KPLAN_ID?: number | null;
  ORDNINGS_NR_1?: number | null;
  KONTOID_1?: number | null;
  ORDNINGS_NR_2?: number | null;
  KONTOID_2?: number | null;
  ORDNINGS_NR_3?: number | null;
  KONTOID_3?: number | null;
  ORDNINGS_NR_4?: number | null;
  KONTOID_4?: number | null;
  ORDNINGS_NR_5?: number | null;
  KONTOID_5?: number | null;
  ORDNINGS_NR_6?: number | null;
  KONTOID_6?: number | null;
  ORDNINGS_NR_7?: number | null;
  KONTOID_7?: number | null;
  ORDNINGS_NR_8?: number | null;
  KONTOID_8?: number | null;
  ORDNINGS_NR_9?: number | null;
  KONTOID_9?: number | null;
  ORDNINGS_NR_10?: number | null;
  KONTOID_10?: number | null;
  PROCENT?: number | null;
  _Associations?: TEDInputBOFaktOmgOrdradKonteringAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av konteringsrad
 */
export interface TEDInputBOFaktOmgOrdradKonteringDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av konteringsrad
 */
export interface TEDInputBOFaktOmgOrdradKonteringUpdateAssociationValues {
  FaktOmgRad_Ref?: string | null;
  FaktOmgRad_Values?: TEDInputBOFaktOmgOrdradUpdateValues | null;
}

/**
 * Nya värden vid ändring av konteringsrad
 */
export interface TEDInputBOFaktOmgOrdradKonteringUpdateValues {
  id: string;
  _version: number;
  KPLAN_ID?: number | null;
  ORDNINGS_NR_1?: number | null;
  KONTOID_1?: number | null;
  ORDNINGS_NR_2?: number | null;
  KONTOID_2?: number | null;
  ORDNINGS_NR_3?: number | null;
  KONTOID_3?: number | null;
  ORDNINGS_NR_4?: number | null;
  KONTOID_4?: number | null;
  ORDNINGS_NR_5?: number | null;
  KONTOID_5?: number | null;
  ORDNINGS_NR_6?: number | null;
  KONTOID_6?: number | null;
  ORDNINGS_NR_7?: number | null;
  KONTOID_7?: number | null;
  ORDNINGS_NR_8?: number | null;
  KONTOID_8?: number | null;
  ORDNINGS_NR_9?: number | null;
  KONTOID_9?: number | null;
  ORDNINGS_NR_10?: number | null;
  KONTOID_10?: number | null;
  PROCENT?: number | null;
  _Associations?: TEDInputBOFaktOmgOrdradKonteringUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av fakturaunderlagsrad
 */
export interface TEDInputBOFaktOmgOrdradUpdateAssociationValues {
  Faktomg_Ref?: string | null;
  Faktomg_Values?: TEDInputBOFaktOmgUpdateValues | null;
  Bokningsrubrik_Ref?: string | null;
  Bokningsrubrik_Values?: TEDInputBOBokningsrubrikUpdateValues | null;
  Fakturatext_Ref?: string | null;
  Fakturatext_Values?: TEDInputLAFakturatextUpdateValues | null;
  Artikel_Ref?: string | null;
  Artikel_Values?: TEDInputLAArtikelUpdateValues | null;
  Kontering_Add_Values?: TEDInputBOFaktOmgOrdradKonteringAddValues[] | null;
  Kontering_Update_Values?: TEDInputBOFaktOmgOrdradKonteringUpdateValues[] | null;
  Kontering_Delete_Values?: TEDInputBOFaktOmgOrdradKonteringDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av fakturaunderlagsrad
 */
export interface TEDInputBOFaktOmgOrdradUpdateValues {
  id: string;
  _version: number;
  ORDNNR?: number | null;
  BENAMNING?: string | null;
  RADKOD?: TEDBOFaktOmgOrdradRADKODEnum | null;
  ANTAL?: number | null;
  APRIS?: any | null;
  RABATT?: number | null;
  _Associations?: TEDInputBOFaktOmgOrdradUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av fakturaunderlag
 */
export interface TEDInputBOFaktOmgUpdateAssociationValues {
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetUpdateValues | null;
  Prislista_Ref?: string | null;
  Prislista_Values?: TEDInputLAPrislistaUpdateValues | null;
  Kund_Ref?: string | null;
  Kund_Values?: TEDInputKRKundUpdateValues | null;
  Faktureringsgrupp_Ref?: string | null;
  Faktureringsgrupp_Values?: TEDInputSYSGruppUpdateValues | null;
  FaktOmgOrdrad_Add_Values?: TEDInputBOFaktOmgOrdradAddValues[] | null;
  FaktOmgOrdrad_Update_Values?: TEDInputBOFaktOmgOrdradUpdateValues[] | null;
  FaktOmgOrdrad_Delete_Values?: TEDInputBOFaktOmgOrdradDeleteValues[] | null;
  AktOrder_Add_Values?: TEDInputBOAktivitetOrderAddValues[] | null;
  AktOrder_Update_Values?: TEDInputBOAktivitetOrderUpdateValues[] | null;
  AktOrder_Delete_Values?: TEDInputBOAktivitetOrderDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av fakturaunderlag
 */
export interface TEDInputBOFaktOmgUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  TEXT?: string | null;
  STATUS?: TEDBOFaktOmgSTATUSEnum | null;
  BEVAKNDAT?: any | null;
  VARREFERENS?: string | null;
  AKTUELLAPRISER?: TEDBOFaktOmgAKTUELLAPRISEREnum | null;
  KUNDREFERENS?: string | null;
  CLEARING?: string | null;
  SKAPAD_DATUM?: any | null;
  SKAPAD_SIGNATUR?: string | null;
  FORRATTNINGSTYP?: TEDBOFaktOmgFORRATTNINGSTYPEnum | null;
  FAKTURERINGSSATT?: TEDBOFaktOmgFAKTURERINGSSATTEnum | null;
  FAKTDELT?: boolean | null;
  FAKT_DODSBO?: boolean | null;
  FORFALLOTYP?: TEDBOFaktOmgFORFALLOTYPEnum | null;
  FORFALLODATUM?: any | null;
  _Associations?: TEDInputBOFaktOmgUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av åldersindelning
 */
export interface TEDInputBOGruppAldersindelningAddAssociationValues {
  Alder_Ref?: string | null;
  Alder_Values?: TEDInputBOAldersindelningAddValues | null;
}

/**
 * Värden vid tillägg av åldersindelning
 */
export interface TEDInputBOGruppAldersindelningAddValues {
  GRUPP_ID?: number | null;
  ALDER_ID?: number | null;
  ANTAL?: number | null;
  _Associations: TEDInputBOGruppAldersindelningAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av åldersindelning
 */
export interface TEDInputBOGruppAldersindelningDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av åldersindelning
 */
export interface TEDInputBOGruppAldersindelningUpdateAssociationValues {
  Alder_Ref?: string | null;
  Alder_Values?: TEDInputBOAldersindelningUpdateValues | null;
}

/**
 * Nya värden vid ändring av åldersindelning
 */
export interface TEDInputBOGruppAldersindelningUpdateValues {
  id: string;
  _version: number;
  GRUPP_ID?: number | null;
  ALDER_ID?: number | null;
  ANTAL?: number | null;
  _Associations?: TEDInputBOGruppAldersindelningUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av behörighet
 */
export interface TEDInputBOGruppBehorighetAddAssociationValues {
  Grupp_Ref?: string | null;
  Grupp_Values?: TEDInputBOGruppOPAddValues | null;
  BehAnvandare_Ref?: string | null;
  BehAnvandare_Values?: TEDInputSYSUserAddValues | null;
  BehGrupp_Ref?: string | null;
  BehGrupp_Values?: TEDInputBOGruppOPAddValues | null;
  BehMedlem_Ref?: string | null;
  BehMedlem_Values?: TEDInputBOTEDBOGruppmedlemOPAddValues | null;
}

/**
 * Värden vid tillägg av behörighet
 */
export interface TEDInputBOGruppBehorighetAddValues {
  _typ: TEDBOGruppBehorighetTypEnum;
  ANSVARIG: TEDBOGruppBehorighetANSVARIGEnum;
  BEH_NARVARO?: string | null;
  BEH_ANDRA?: string | null;
  BEH_UTSKICK?: string | null;
  _Associations?: TEDInputBOGruppBehorighetAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av behörighet
 */
export interface TEDInputBOGruppBehorighetDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av behörighet
 */
export interface TEDInputBOGruppBehorighetUpdateAssociationValues {
  Grupp_Ref?: string | null;
  Grupp_Values?: TEDInputBOGruppOPUpdateValues | null;
  BehAnvandare_Ref?: string | null;
  BehAnvandare_Values?: TEDInputSYSUserUpdateValues | null;
  BehGrupp_Ref?: string | null;
  BehGrupp_Values?: TEDInputBOGruppOPUpdateValues | null;
  BehMedlem_Ref?: string | null;
  BehMedlem_Values?: TEDInputBOTEDBOGruppmedlemOPUpdateValues | null;
}

/**
 * Nya värden vid ändring av behörighet
 */
export interface TEDInputBOGruppBehorighetUpdateValues {
  id: string;
  _version: number;
  ANSVARIG?: TEDBOGruppBehorighetANSVARIGEnum | null;
  BEH_NARVARO?: string | null;
  BEH_ANDRA?: string | null;
  BEH_UTSKICK?: string | null;
  _Associations?: TEDInputBOGruppBehorighetUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av grupp
 */
export interface TEDInputBOGruppOPAddAssociationValues {
  Verksamhetstyp_Ref?: string | null;
  Verksamhetstyp_Values?: TEDInputBOVerksamhetstyperAddValues | null;
  Forsamling_Ref?: string | null;
  Forsamling_Values?: TEDInputSYSStatistikinstallningarAddValues | null;
  GruppmedlemOP_Add_Values?: TEDInputBOTEDBOGruppmedlemOPAddValues[] | null;
  Sammankomster_Add_Values?: TEDInputBOSammankomstAddValues[] | null;
  Ansvariga_Add_Values?: TEDInputBOGruppBehorighetAddValues[] | null;
  Aldersindelningar_Add_Values?: TEDInputBOGruppAldersindelningAddValues[] | null;
}

/**
 * Värden vid tillägg av grupp
 */
export interface TEDInputBOGruppOPAddValues {
  BENAMNING: string;
  BESKRIVNING?: string | null;
  DATUM?: any | null;
  SIGNATUR?: string | null;
  GILTIG_FROM?: any | null;
  GILTIG_TOM?: any | null;
  KATEGORI?: string | null;
  GRUPP_LEDARE?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  VISA_PERSNR?: TEDBOGruppOPVISA_PERSNREnum | null;
  STATI_ANTAL?: number | null;
  ENHETSID?: number | null;
  _Associations?: TEDInputBOGruppOPAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av grupp
 */
export interface TEDInputBOGruppOPUpdateAssociationValues {
  Verksamhetstyp_Ref?: string | null;
  Verksamhetstyp_Values?: TEDInputBOVerksamhetstyperUpdateValues | null;
  Forsamling_Ref?: string | null;
  Forsamling_Values?: TEDInputSYSStatistikinstallningarUpdateValues | null;
  GruppmedlemOP_Add_Values?: TEDInputBOTEDBOGruppmedlemOPAddValues[] | null;
  GruppmedlemOP_Update_Values?: TEDInputBOTEDBOGruppmedlemOPUpdateValues[] | null;
  GruppmedlemOP_Delete_Values?: TEDInputBOTEDBOGruppmedlemOPDeleteValues[] | null;
  GruppmedlemOP_Undelete?: TEDInputBOTEDBOGruppmedlemOPDeleteValues[] | null;
  Sammankomster_Add_Values?: TEDInputBOSammankomstAddValues[] | null;
  Sammankomster_Update_Values?: TEDInputBOSammankomstUpdateValues[] | null;
  Sammankomster_Delete_Values?: TEDInputBOSammankomstDeleteValues[] | null;
  Ansvariga_Add_Values?: TEDInputBOGruppBehorighetAddValues[] | null;
  Ansvariga_Update_Values?: TEDInputBOGruppBehorighetUpdateValues[] | null;
  Ansvariga_Delete_Values?: TEDInputBOGruppBehorighetDeleteValues[] | null;
  Aldersindelningar_Add_Values?: TEDInputBOGruppAldersindelningAddValues[] | null;
  Aldersindelningar_Update_Values?: TEDInputBOGruppAldersindelningUpdateValues[] | null;
  Aldersindelningar_Delete_Values?: TEDInputBOGruppAldersindelningDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av grupp
 */
export interface TEDInputBOGruppOPUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  BESKRIVNING?: string | null;
  DATUM?: any | null;
  SIGNATUR?: string | null;
  GILTIG_FROM?: any | null;
  GILTIG_TOM?: any | null;
  KATEGORI?: string | null;
  GRUPP_LEDARE?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  VISA_PERSNR?: TEDBOGruppOPVISA_PERSNREnum | null;
  STATI_ANTAL?: number | null;
  ENHETSID?: number | null;
  _Associations?: TEDInputBOGruppOPUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av gudstjänsttyp
 */
export interface TEDInputBOGudstjansttypAddAssociationValues {
  Aktivitetskategorier_Add_Values?: TEDInputBOGudstjtypKategoriAddValues[] | null;
  Amnesomraden_Add_Values?: TEDInputBOGudstjansttypAmnesomradeAddValues[] | null;
  Handelsetyper_Add_Values?: TEDInputBOGudstjansttypHandelsetypAddValues[] | null;
}

/**
 * Värden vid tillägg av gudstjänsttyp
 */
export interface TEDInputBOGudstjansttypAddValues {
  FORK?: string | null;
  NAMN?: string | null;
  HUVUDGUDSTJANST?: TEDBOGudstjansttypHUVUDGUDSTJANSTEnum | null;
  INGARPREDIKOTUR: TEDBOGudstjansttypINGARPREDIKOTUREnum;
  NYTT_NAMN?: string | null;
  CATEGORY?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  SK_STATISTIK_GRUPP?: number | null;
  PRIO_ORDNING?: number | null;
  _Associations?: TEDInputBOGudstjansttypAddAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av gudstjänsttypens ämnesområde
 */
export interface TEDInputBOGudstjansttypAmnesomradeAddAssociationValues {
  Amnesomrade_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av gudstjänsttypens ämnesområde
 */
export interface TEDInputBOGudstjansttypAmnesomradeAddValues {
  _Associations?: TEDInputBOGudstjansttypAmnesomradeAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av gudstjänsttypens ämnesområde
 */
export interface TEDInputBOGudstjansttypAmnesomradeDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av gudstjänsttypens ämnesområde
 */
export interface TEDInputBOGudstjansttypAmnesomradeUpdateAssociationValues {
  Amnesomrade_Add_Refs?: string[] | null;
  Amnesomrade_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av gudstjänsttypens ämnesområde
 */
export interface TEDInputBOGudstjansttypAmnesomradeUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputBOGudstjansttypAmnesomradeUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av gudstjänst händelsetyp
 */
export interface TEDInputBOGudstjansttypHandelsetypAddAssociationValues {
  Handelsetyp_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av gudstjänst händelsetyp
 */
export interface TEDInputBOGudstjansttypHandelsetypAddValues {
  _Associations?: TEDInputBOGudstjansttypHandelsetypAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av gudstjänst händelsetyp
 */
export interface TEDInputBOGudstjansttypHandelsetypDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av gudstjänst händelsetyp
 */
export interface TEDInputBOGudstjansttypHandelsetypUpdateAssociationValues {
  Handelsetyp_Add_Refs?: string[] | null;
  Handelsetyp_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av gudstjänst händelsetyp
 */
export interface TEDInputBOGudstjansttypHandelsetypUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputBOGudstjansttypHandelsetypUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av gudstjänsttyp
 */
export interface TEDInputBOGudstjansttypUpdateAssociationValues {
  Aktivitetskategorier_Add_Values?: TEDInputBOGudstjtypKategoriAddValues[] | null;
  Aktivitetskategorier_Update_Values?: TEDInputBOGudstjtypKategoriUpdateValues[] | null;
  Aktivitetskategorier_Delete_Values?: TEDInputBOGudstjtypKategoriDeleteValues[] | null;
  Amnesomraden_Add_Values?: TEDInputBOGudstjansttypAmnesomradeAddValues[] | null;
  Amnesomraden_Update_Values?: TEDInputBOGudstjansttypAmnesomradeUpdateValues[] | null;
  Amnesomraden_Delete_Values?: TEDInputBOGudstjansttypAmnesomradeDeleteValues[] | null;
  Handelsetyper_Add_Values?: TEDInputBOGudstjansttypHandelsetypAddValues[] | null;
  Handelsetyper_Update_Values?: TEDInputBOGudstjansttypHandelsetypUpdateValues[] | null;
  Handelsetyper_Delete_Values?: TEDInputBOGudstjansttypHandelsetypDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av gudstjänsttyp
 */
export interface TEDInputBOGudstjansttypUpdateValues {
  id: string;
  _version: number;
  FORK?: string | null;
  NAMN?: string | null;
  HUVUDGUDSTJANST?: TEDBOGudstjansttypHUVUDGUDSTJANSTEnum | null;
  INGARPREDIKOTUR?: TEDBOGudstjansttypINGARPREDIKOTUREnum | null;
  NYTT_NAMN?: string | null;
  CATEGORY?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  SK_STATISTIK_GRUPP?: number | null;
  PRIO_ORDNING?: number | null;
  _Associations?: TEDInputBOGudstjansttypUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kategori för en gudstjänsttyp
 */
export interface TEDInputBOGudstjtypKategoriAddAssociationValues {
  Aktivitetskategori_Ref?: string | null;
  Aktivitetskategori_Values?: TEDInputBOKategoriAddValues | null;
}

/**
 * Värden vid tillägg av kategori för en gudstjänsttyp
 */
export interface TEDInputBOGudstjtypKategoriAddValues {
  _Associations: TEDInputBOGudstjtypKategoriAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kategori för en gudstjänsttyp
 */
export interface TEDInputBOGudstjtypKategoriDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kategori för en gudstjänsttyp
 */
export interface TEDInputBOGudstjtypKategoriUpdateAssociationValues {
  Aktivitetskategori_Ref?: string | null;
  Aktivitetskategori_Values?: TEDInputBOKategoriUpdateValues | null;
}

/**
 * Nya värden vid ändring av kategori för en gudstjänsttyp
 */
export interface TEDInputBOGudstjtypKategoriUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputBOGudstjtypKategoriUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av inkluderad resurstyp
 */
export interface TEDInputBOInkluderadRestypAddAssociationValues {
  Resurstyp_Ref?: string | null;
  Resurstyp_Values?: TEDInputBOResurstypAddValues | null;
}

/**
 * Värden vid tillägg av inkluderad resurstyp
 */
export interface TEDInputBOInkluderadRestypAddValues {
  ID?: number | null;
  PARENTID?: number | null;
  _Associations: TEDInputBOInkluderadRestypAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av inkluderad resurstyp
 */
export interface TEDInputBOInkluderadRestypDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av inkluderad resurstyp
 */
export interface TEDInputBOInkluderadRestypUpdateAssociationValues {
  Resurstyp_Ref?: string | null;
  Resurstyp_Values?: TEDInputBOResurstypUpdateValues | null;
}

/**
 * Nya värden vid ändring av inkluderad resurstyp
 */
export interface TEDInputBOInkluderadRestypUpdateValues {
  id: string;
  _version: number;
  ID?: number | null;
  PARENTID?: number | null;
  _Associations?: TEDInputBOInkluderadRestypUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av framsidan kategori
 */
export interface TEDInputBOKategoriAddValues {
  KOD: string;
  BENAMNING: string;
  BORTTAGEN?: string | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
}

/**
 * Nya värden vid ändring av framsidan kategori
 */
export interface TEDInputBOKategoriUpdateValues {
  id: string;
  _version: number;
  KOD?: string | null;
  BENAMNING?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
}

/**
 * Värden vid tillägg av dokument
 */
export interface TEDInputBOKremBestDokAddValues {
  BestID?: number | null;
  LOPNR?: number | null;
  BESKRIVNING?: string | null;
  FILNAMN?: string | null;
  SENAST_ANDRAD?: any | null;
  DATA?: string | null;
  DATASIZE?: number | null;
  DATATYPE?: string | null;
  EXTENSION?: string | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av dokument
 */
export interface TEDInputBOKremBestDokDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av dokument
 */
export interface TEDInputBOKremBestDokUpdateValues {
  id: string;
  _version: number;
  BestID?: number | null;
  LOPNR?: number | null;
  BESKRIVNING?: string | null;
  FILNAMN?: string | null;
  SENAST_ANDRAD?: any | null;
  DATA?: string | null;
  DATASIZE?: number | null;
  DATATYPE?: string | null;
  EXTENSION?: string | null;
}

/**
 * Associerade värden vid tillägg av närvaro
 */
export interface TEDInputBONarvaroAddAssociationValues {
  Sammankomst_Ref?: string | null;
  Sammankomst_Values?: TEDInputBOSammankomstAddValues | null;
  Medlem_Ref?: string | null;
  Medlem_Values?: TEDInputBOTEDBOGruppmedlemOPAddValues | null;
  Grupp_Ref?: string | null;
  Grupp_Values?: TEDInputBOGruppOPAddValues | null;
}

/**
 * Värden vid tillägg av närvaro
 */
export interface TEDInputBONarvaroAddValues {
  NARVARANDE?: TEDBONarvaroNARVARANDEEnum | null;
  NOTERING?: string | null;
  _Associations?: TEDInputBONarvaroAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av närvaro
 */
export interface TEDInputBONarvaroDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av närvaro
 */
export interface TEDInputBONarvaroUpdateAssociationValues {
  Sammankomst_Ref?: string | null;
  Sammankomst_Values?: TEDInputBOSammankomstUpdateValues | null;
  Medlem_Ref?: string | null;
  Medlem_Values?: TEDInputBOTEDBOGruppmedlemOPUpdateValues | null;
  Grupp_Ref?: string | null;
  Grupp_Values?: TEDInputBOGruppOPUpdateValues | null;
}

/**
 * Nya värden vid ändring av närvaro
 */
export interface TEDInputBONarvaroUpdateValues {
  id: string;
  _version: number;
  NARVARANDE?: TEDBONarvaroNARVARANDEEnum | null;
  NOTERING?: string | null;
  _Associations?: TEDInputBONarvaroUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av psalm
 */
export interface TEDInputBOPsalmAddValues {
  TITEL?: string | null;
  NUMMER?: string | null;
  EXTID?: number | null;
}

/**
 * Nya värden vid ändring av psalm
 */
export interface TEDInputBOPsalmUpdateValues {
  id: string;
  _version: number;
  TITEL?: string | null;
  NUMMER?: string | null;
  EXTID?: number | null;
}

export interface TEDInputBORepAkt {
  Typ: string;
  BokGrupp: string;
  Boknr: string;
  Rubrik?: string | null;
  AktID?: string | null;
  KnytGruppID?: number | null;
  DatumFran: any;
  DatumTill: any;
  Dag?: string | null;
  KortDag?: string | null;
  Vald?: boolean | null;
  Aktrubriker?: TEDInputBORepAktRubrik[] | null;
  Bokningsrubriker?: TEDInputBORepBokRubrik[] | null;
  Resurser?: TEDInputBORepResurs[] | null;
  KnutnaAktiviteter?: TEDInputBORepAkt[] | null;
}

export interface TEDInputBORepAktRubrik {
  ResRubrikID: string;
  PosNR: number;
}

export interface TEDInputBORepBokRubrik {
  RestypID: string;
  Rubrik?: string | null;
  RubrikID: string;
  PosNR: number;
  Resurs?: TEDInputBORepResurs | null;
}

export interface TEDInputBORepInstallningar {
  Tjanstgoring?: boolean | null;
  Knutna?: boolean | null;
  BokaHelg?: boolean | null;
  BokaUpptagen?: boolean | null;
  NyTid?: boolean | null;
  NyFran?: any | null;
  NyTill?: any | null;
  Period: number;
  Veckodagar?: TEDInputBORepVeckodagar | null;
  DatumFran: any;
  DatumTill: any;
  Prelbokad?: boolean | null;
  Noteringar?: string | null;
}

export interface TEDInputBORepResurs {
  resurs?: string | null;
  resursIDText?: string | null;
  resursID?: string | null;
  DatumFran: any;
  DatumTill: any;
  Vald?: boolean | null;
  XBResursEmail?: string | null;
  XBSynk?: boolean | null;
  ResBokad?: string | null;
  Planerad?: string | null;
  XBridge?: string | null;
  FlexLedig?: string | null;
  VarmeStandard?: number | null;
  varning_dubbelbokning?: string | null;
}

export interface TEDInputBORepVeckodagar {
  Man?: boolean | null;
  Tis?: boolean | null;
  Ons?: boolean | null;
  Tor?: boolean | null;
  Fre?: boolean | null;
  Lor?: boolean | null;
  Son?: boolean | null;
}

/**
 * Associerade värden vid tillägg av resursrubrik
 */
export interface TEDInputBOResrubrikAddAssociationValues {
  TillatResTyp_Ref?: string | null;
  TillatResTyp_Values?: TEDInputBOResurstypAddValues | null;
  ForeslRestyp_Ref?: string | null;
  ForeslRestyp_Values?: TEDInputBOResurstypAddValues | null;
  AktTypResrubrik_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av resursrubrik
 */
export interface TEDInputBOResrubrikAddValues {
  KOD: string;
  RUBRIK: string;
  BORTTAGEN: TEDBOResrubrikBORTTAGENEnum;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  _Associations: TEDInputBOResrubrikAddAssociationValues;
}

/**
 * Associerade värden vid ändring av resursrubrik
 */
export interface TEDInputBOResrubrikUpdateAssociationValues {
  TillatResTyp_Ref?: string | null;
  TillatResTyp_Values?: TEDInputBOResurstypUpdateValues | null;
  ForeslRestyp_Ref?: string | null;
  ForeslRestyp_Values?: TEDInputBOResurstypUpdateValues | null;
  AktTypResrubrik_Add_Refs?: string[] | null;
  AktTypResrubrik_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av resursrubrik
 */
export interface TEDInputBOResrubrikUpdateValues {
  id: string;
  _version: number;
  KOD?: string | null;
  RUBRIK?: string | null;
  BORTTAGEN?: TEDBOResrubrikBORTTAGENEnum | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  _Associations?: TEDInputBOResrubrikUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av resurs
 */
export interface TEDInputBOResursAddAssociationValues {
  ResArbetstider_Ref?: string | null;
  ResArbetstider_Values?: TEDInputBOArbetstidAddValues | null;
  ResRestyp_Ref?: string | null;
  ResRestyp_Values?: TEDInputBOResurstypAddValues | null;
  OPL_Ref?: string | null;
  OPL_Values?: TEDInputOPOrgPersLokAddValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
  AktTyp_Ref?: string | null;
  AktTyp_Values?: TEDInputBOAktivitetstypAddValues | null;
  Artikel_Ref?: string | null;
  Artikel_Values?: TEDInputLAArtikelAddValues | null;
  ResArbetspass_Ref?: string | null;
  ResArbetspass_Values?: TEDInputBOArbetspassAddValues | null;
  Kyrkogard_Ref?: string | null;
  Kyrkogard_Values?: TEDInputGAKGardAddValues | null;
  Intaktskonto_Ref?: string | null;
  Intaktskonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Forsamling_Ref?: string | null;
  Forsamling_Values?: TEDInputSYSStatistikinstallningarAddValues | null;
  Bokningsrubrik_Add_Refs?: string[] | null;
  BokGruppResurs_Add_Values?: TEDInputBOBoknGruppResursAddValues[] | null;
  Resursplanering_Add_Refs?: string[] | null;
  Dokument_Add_Values?: TEDInputBOResursDokAddValues[] | null;
  ResArt_Add_Refs?: string[] | null;
  Resurstyper_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av resurs
 */
export interface TEDInputBOResursAddValues {
  BO_RESURS_ID?: string | null;
  BO_RESURS_NAMN?: string | null;
  BESKRIVNING?: string | null;
  BOKNINGSBAR?: TEDBOResursBOKNINGSBAREnum | null;
  STATUS?: TEDBOResursSTATUSEnum | null;
  VARNING_DUBBELBOKNING?: TEDBOResursVARNING_DUBBELBOKNINGEnum | null;
  TELEFONPAUTSKRIFT?: TEDBOResursTELEFONPAUTSKRIFTEnum | null;
  WINDOWSSIGNATUR?: string | null;
  BEGRAVNINGSPLATS?: TEDBOResursBEGRAVNINGSPLATSEnum | null;
  EGEN_KGARD?: TEDBOResursEGEN_KGARDEnum | null;
  VECKOR_INNAN?: number | null;
  VECKOR_EFTER?: number | null;
  WEBBOKNINGSBAR?: TEDBOResursWEBBOKNINGSBAREnum | null;
  SYNKRIKTNING?: string | null;
  LOKALUTHYR_INFO?: string | null;
  MAILBOXES?: string | null;
  EPOSTPAUTSKRIFT?: TEDBOResursEPOSTPAUTSKRIFTEnum | null;
  BOKBAR_AKTIVITET?: boolean | null;
  AUTOSYNK?: boolean | null;
  SYNKA_DOK?: boolean | null;
  SYNKA_TEXT?: boolean | null;
  RESURSNAMN_EXTERN?: string | null;
  SKK_PLACE_ID?: number | null;
  SKK_ORG_ID?: number | null;
  PRIO_ORDNING?: number | null;
  SKK_PUBLIK_WEB?: string | null;
  SKK_ORG_WSSURL?: string | null;
  ADRESSPAUTSKRIFT?: string | null;
  SKK_REGION_ID?: number | null;
  XB_RESURS_ID?: string | null;
  XB_SYNK?: boolean | null;
  XB_ERROR?: string | null;
  DOPLOKAL?: boolean | null;
  VIGSELLOKAL?: boolean | null;
  WEBB_LINK?: string | null;
  WEBB_INFO?: string | null;
  WEBB_IMGLINK?: string | null;
  STATUS_DATUM?: any | null;
  GALLRAD?: string | null;
  GALLRAD_DATUM?: any | null;
  FORSAMLINGS_ID?: string | null;
  ANSTALLNINGSNUMMER?: number | null;
  SKK_API22_PLACE_ID?: string | null;
  SKK_API22_PLACE_NAME?: string | null;
  _Associations: TEDInputBOResursAddAssociationValues;
}

/**
 * Värden vid tillägg av dokument
 */
export interface TEDInputBOResursDokAddValues {
  BESKRIVNING?: string | null;
  EXTENSION?: string | null;
  OLECLASSNAME?: string | null;
  BINARDATA?: string | null;
  BINARDATASIZE?: number | null;
  DATATYPE?: string | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av dokument
 */
export interface TEDInputBOResursDokDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av dokument
 */
export interface TEDInputBOResursDokUpdateValues {
  id: string;
  _version: number;
  BESKRIVNING?: string | null;
  EXTENSION?: string | null;
  OLECLASSNAME?: string | null;
  BINARDATA?: string | null;
  BINARDATASIZE?: number | null;
  DATATYPE?: string | null;
}

/**
 * Associerade värden vid ändring av resurs
 */
export interface TEDInputBOResursUpdateAssociationValues {
  ResArbetstider_Ref?: string | null;
  ResArbetstider_Values?: TEDInputBOArbetstidUpdateValues | null;
  ResRestyp_Ref?: string | null;
  ResRestyp_Values?: TEDInputBOResurstypUpdateValues | null;
  OPL_Ref?: string | null;
  OPL_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
  AktTyp_Ref?: string | null;
  AktTyp_Values?: TEDInputBOAktivitetstypUpdateValues | null;
  Artikel_Ref?: string | null;
  Artikel_Values?: TEDInputLAArtikelUpdateValues | null;
  ResArbetspass_Ref?: string | null;
  ResArbetspass_Values?: TEDInputBOArbetspassUpdateValues | null;
  Kyrkogard_Ref?: string | null;
  Kyrkogard_Values?: TEDInputGAKGardUpdateValues | null;
  Intaktskonto_Ref?: string | null;
  Intaktskonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Forsamling_Ref?: string | null;
  Forsamling_Values?: TEDInputSYSStatistikinstallningarUpdateValues | null;
  Bokningsrubrik_Add_Refs?: string[] | null;
  Bokningsrubrik_Delete_Refs?: string[] | null;
  BokGruppResurs_Add_Values?: TEDInputBOBoknGruppResursAddValues[] | null;
  BokGruppResurs_Update_Values?: TEDInputBOBoknGruppResursUpdateValues[] | null;
  BokGruppResurs_Delete_Values?: TEDInputBOBoknGruppResursDeleteValues[] | null;
  Resursplanering_Add_Refs?: string[] | null;
  Resursplanering_Delete_Refs?: string[] | null;
  Dokument_Add_Values?: TEDInputBOResursDokAddValues[] | null;
  Dokument_Update_Values?: TEDInputBOResursDokUpdateValues[] | null;
  Dokument_Delete_Values?: TEDInputBOResursDokDeleteValues[] | null;
  ResArt_Add_Refs?: string[] | null;
  ResArt_Delete_Refs?: string[] | null;
  Resurstyper_Add_Refs?: string[] | null;
  Resurstyper_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av resurs
 */
export interface TEDInputBOResursUpdateValues {
  id: string;
  _version: number;
  BO_RESURS_ID?: string | null;
  BO_RESURS_NAMN?: string | null;
  BESKRIVNING?: string | null;
  BOKNINGSBAR?: TEDBOResursBOKNINGSBAREnum | null;
  STATUS?: TEDBOResursSTATUSEnum | null;
  VARNING_DUBBELBOKNING?: TEDBOResursVARNING_DUBBELBOKNINGEnum | null;
  TELEFONPAUTSKRIFT?: TEDBOResursTELEFONPAUTSKRIFTEnum | null;
  WINDOWSSIGNATUR?: string | null;
  BEGRAVNINGSPLATS?: TEDBOResursBEGRAVNINGSPLATSEnum | null;
  EGEN_KGARD?: TEDBOResursEGEN_KGARDEnum | null;
  VECKOR_INNAN?: number | null;
  VECKOR_EFTER?: number | null;
  WEBBOKNINGSBAR?: TEDBOResursWEBBOKNINGSBAREnum | null;
  SYNKRIKTNING?: string | null;
  LOKALUTHYR_INFO?: string | null;
  MAILBOXES?: string | null;
  EPOSTPAUTSKRIFT?: TEDBOResursEPOSTPAUTSKRIFTEnum | null;
  BOKBAR_AKTIVITET?: boolean | null;
  AUTOSYNK?: boolean | null;
  SYNKA_DOK?: boolean | null;
  SYNKA_TEXT?: boolean | null;
  RESURSNAMN_EXTERN?: string | null;
  SKK_PLACE_ID?: number | null;
  SKK_ORG_ID?: number | null;
  PRIO_ORDNING?: number | null;
  SKK_PUBLIK_WEB?: string | null;
  SKK_ORG_WSSURL?: string | null;
  ADRESSPAUTSKRIFT?: string | null;
  SKK_REGION_ID?: number | null;
  XB_RESURS_ID?: string | null;
  XB_SYNK?: boolean | null;
  XB_ERROR?: string | null;
  DOPLOKAL?: boolean | null;
  VIGSELLOKAL?: boolean | null;
  WEBB_LINK?: string | null;
  WEBB_INFO?: string | null;
  WEBB_IMGLINK?: string | null;
  STATUS_DATUM?: any | null;
  GALLRAD?: string | null;
  GALLRAD_DATUM?: any | null;
  FORSAMLINGS_ID?: string | null;
  ANSTALLNINGSNUMMER?: number | null;
  SKK_API22_PLACE_ID?: string | null;
  SKK_API22_PLACE_NAME?: string | null;
  _Associations?: TEDInputBOResursUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av resurstyp
 */
export interface TEDInputBOResurstypAddAssociationValues {
  RestypRes_Add_Refs?: string[] | null;
  InkluderadResTyp_Add_Values?: TEDInputBOInkluderadRestypAddValues[] | null;
}

/**
 * Värden vid tillägg av resurstyp
 */
export interface TEDInputBOResurstypAddValues {
  BO_RESURSTYP_NAMN: string;
  FORALDRATYP?: string | null;
  KYRKOGARD?: boolean | null;
  MUSIKER?: boolean | null;
  PRAST?: boolean | null;
  PRIO_ORDNING?: number | null;
  PLATS?: boolean | null;
  KYLRUM?: boolean | null;
  _Associations?: TEDInputBOResurstypAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av resurstyp
 */
export interface TEDInputBOResurstypUpdateAssociationValues {
  RestypRes_Add_Refs?: string[] | null;
  RestypRes_Delete_Refs?: string[] | null;
  InkluderadResTyp_Add_Values?: TEDInputBOInkluderadRestypAddValues[] | null;
  InkluderadResTyp_Update_Values?: TEDInputBOInkluderadRestypUpdateValues[] | null;
  InkluderadResTyp_Delete_Values?: TEDInputBOInkluderadRestypDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av resurstyp
 */
export interface TEDInputBOResurstypUpdateValues {
  id: string;
  _version: number;
  BO_RESURSTYP_NAMN?: string | null;
  FORALDRATYP?: string | null;
  KYRKOGARD?: boolean | null;
  MUSIKER?: boolean | null;
  PRAST?: boolean | null;
  PRIO_ORDNING?: number | null;
  PLATS?: boolean | null;
  KYLRUM?: boolean | null;
  _Associations?: TEDInputBOResurstypUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av aktivitet
 */
export interface TEDInputBOSKKAddValues {
  AKT_ID?: number | null;
  SKK_ID?: string | null;
  BOKNINGSNUMMER?: string | null;
  SENAST_SKICKAD?: any | null;
  SENAST_SKICKAD_FEL?: string | null;
}

/**
 * Associerade värden vid tillägg av ämnesområdei för en aktivitet
 */
export interface TEDInputBOSKKAktivitetAmnesomradeAddAssociationValues {
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetAddValues | null;
  Amnesomrade_Ref?: string | null;
  Amnesomrade_Values?: TEDInputBOSKKAmnesomradenAddValues | null;
}

/**
 * Värden vid tillägg av ämnesområdei för en aktivitet
 */
export interface TEDInputBOSKKAktivitetAmnesomradeAddValues {
  _Associations: TEDInputBOSKKAktivitetAmnesomradeAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av ämnesområdei för en aktivitet
 */
export interface TEDInputBOSKKAktivitetAmnesomradeDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av ämnesområdei för en aktivitet
 */
export interface TEDInputBOSKKAktivitetAmnesomradeUpdateAssociationValues {
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetUpdateValues | null;
  Amnesomrade_Ref?: string | null;
  Amnesomrade_Values?: TEDInputBOSKKAmnesomradenUpdateValues | null;
}

/**
 * Nya värden vid ändring av ämnesområdei för en aktivitet
 */
export interface TEDInputBOSKKAktivitetAmnesomradeUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputBOSKKAktivitetAmnesomradeUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av ämnesområde
 */
export interface TEDInputBOSKKAmnesomradenAddValues {
  HEADLINE?: string | null;
  DESCRIPTION?: string | null;
  COUNT?: number | null;
  ORG_ID?: number | null;
  SKK_REGION_ID?: number | null;
  SKK_API22_EXT_ID?: string | null;
}

/**
 * Nya värden vid ändring av ämnesområde
 */
export interface TEDInputBOSKKAmnesomradenUpdateValues {
  id: string;
  _version: number;
  HEADLINE?: string | null;
  DESCRIPTION?: string | null;
  COUNT?: number | null;
  ORG_ID?: number | null;
  SKK_REGION_ID?: number | null;
  SKK_API22_EXT_ID?: string | null;
}

/**
 * Värden vid tillägg av händelsetyp
 */
export interface TEDInputBOSKKHandelsetypAddValues {
  KATEGORI_ID?: number | null;
  BENAMNING?: string | null;
  FORKORT?: string | null;
}

/**
 * Nya värden vid ändring av händelsetyp
 */
export interface TEDInputBOSKKHandelsetypUpdateValues {
  id: string;
  _version: number;
  KATEGORI_ID?: number | null;
  BENAMNING?: string | null;
  FORKORT?: string | null;
}

/**
 * Nya värden vid ändring av aktivitet
 */
export interface TEDInputBOSKKUpdateValues {
  id: string;
  _version: number;
  AKT_ID?: number | null;
  SKK_ID?: string | null;
  BOKNINGSNUMMER?: string | null;
  SENAST_SKICKAD?: any | null;
  SENAST_SKICKAD_FEL?: string | null;
}

/**
 * Värden vid tillägg av exporterad statistik
 */
export interface TEDInputBOSKSAddValues {
  AKT_ID?: number | null;
  EXTERNAL_KEY?: string | null;
  SENAST_SKICKAD_OK?: any | null;
  SENAST_SKICKAD_ERR?: any | null;
  SENAST_ERRMSG?: string | null;
  BOKNINGSNUMMER?: string | null;
}

/**
 * Nya värden vid ändring av exporterad statistik
 */
export interface TEDInputBOSKSUpdateValues {
  id: string;
  _version: number;
  AKT_ID?: number | null;
  EXTERNAL_KEY?: string | null;
  SENAST_SKICKAD_OK?: any | null;
  SENAST_SKICKAD_ERR?: any | null;
  SENAST_ERRMSG?: string | null;
  BOKNINGSNUMMER?: string | null;
}

/**
 * Associerade värden vid tillägg av sammankomst
 */
export interface TEDInputBOSammankomstAddAssociationValues {
  Grupp_Ref?: string | null;
  Grupp_Values?: TEDInputBOGruppOPAddValues | null;
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetAddValues | null;
  Narvaro_Add_Values?: TEDInputBONarvaroAddValues[] | null;
}

/**
 * Värden vid tillägg av sammankomst
 */
export interface TEDInputBOSammankomstAddValues {
  DATUM: any;
  FRAN_TID?: any | null;
  TILL_TID?: any | null;
  BENAMNING: string;
  NOTERING?: string | null;
  _Associations?: TEDInputBOSammankomstAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av sammankomst
 */
export interface TEDInputBOSammankomstDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av sammankomst
 */
export interface TEDInputBOSammankomstUpdateAssociationValues {
  Grupp_Ref?: string | null;
  Grupp_Values?: TEDInputBOGruppOPUpdateValues | null;
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetUpdateValues | null;
  Narvaro_Add_Values?: TEDInputBONarvaroAddValues[] | null;
  Narvaro_Update_Values?: TEDInputBONarvaroUpdateValues[] | null;
  Narvaro_Delete_Values?: TEDInputBONarvaroDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av sammankomst
 */
export interface TEDInputBOSammankomstUpdateValues {
  id: string;
  _version: number;
  DATUM?: any | null;
  FRAN_TID?: any | null;
  TILL_TID?: any | null;
  BENAMNING?: string | null;
  NOTERING?: string | null;
  _Associations?: TEDInputBOSammankomstUpdateAssociationValues | null;
}

export interface TEDInputBOStatistikAlderAntal {
  alderfran: number;
  aldertill: number;
  antal?: number | null;
}

export interface TEDInputBOStatistikAlderAntalKod {
  antal?: number | null;
  kod: string;
}

export interface TEDInputBOStatistikAntal {
  antal?: number | null;
  kommunioner?: number | null;
  grupp?: number | null;
  barn?: number | null;
  tillfallen?: number | null;
  AlderIndelat?: TEDInputBOStatistikAlderAntal[] | null;
  AlderIndelatKod?: TEDInputBOStatistikAlderAntalKod[] | null;
}

export interface TEDInputBOStatistikDigital {
  visningarTotal?: number | null;
  facebook?: number | null;
  youtube?: number | null;
  vimeo?: number | null;
  ovrigt?: number | null;
}

/**
 * Associerade värden vid tillägg av aktivitetstyp (bokningsgrupp)
 */
export interface TEDInputBOTEDBOAkttypBokngruppAddAssociationValues {
  Akttyp_Ref?: string | null;
  Akttyp_Values?: TEDInputBOAktivitetstypAddValues | null;
  Bokningsgrupp_Ref?: string | null;
  Bokningsgrupp_Values?: TEDInputSYSBokngruppAddValues | null;
}

/**
 * Värden vid tillägg av aktivitetstyp (bokningsgrupp)
 */
export interface TEDInputBOTEDBOAkttypBokngruppAddValues {
  KYRKLIGHELGUTSKRIFT: TEDBOTEDBOAkttypBokngruppKYRKLIGHELGUTSKRIFTEnum;
  SLUTTID?: TEDBOTEDBOAkttypBokngruppSLUTTIDEnum | null;
  SIGNATUR: TEDBOTEDBOAkttypBokngruppSIGNATUREnum;
  STATISTIKUPPGIFT: TEDBOTEDBOAkttypBokngruppSTATISTIKUPPGIFTEnum;
  AVBOKNINGSBEKRAFTELSE: TEDBOTEDBOAkttypBokngruppAVBOKNINGSBEKRAFTELSEEnum;
  AKTTYP_BOKNBAR?: string | null;
  BEVAKNINGSDAGAR?: number | null;
  VARNA_JORD_KREM?: string | null;
  _Associations: TEDInputBOTEDBOAkttypBokngruppAddAssociationValues;
}

/**
 * Associerade värden vid ändring av aktivitetstyp (bokningsgrupp)
 */
export interface TEDInputBOTEDBOAkttypBokngruppUpdateAssociationValues {
  Akttyp_Ref?: string | null;
  Akttyp_Values?: TEDInputBOAktivitetstypUpdateValues | null;
  Bokningsgrupp_Ref?: string | null;
  Bokningsgrupp_Values?: TEDInputSYSBokngruppUpdateValues | null;
}

/**
 * Nya värden vid ändring av aktivitetstyp (bokningsgrupp)
 */
export interface TEDInputBOTEDBOAkttypBokngruppUpdateValues {
  id: string;
  _version: number;
  KYRKLIGHELGUTSKRIFT?: TEDBOTEDBOAkttypBokngruppKYRKLIGHELGUTSKRIFTEnum | null;
  SLUTTID?: TEDBOTEDBOAkttypBokngruppSLUTTIDEnum | null;
  SIGNATUR?: TEDBOTEDBOAkttypBokngruppSIGNATUREnum | null;
  STATISTIKUPPGIFT?: TEDBOTEDBOAkttypBokngruppSTATISTIKUPPGIFTEnum | null;
  AVBOKNINGSBEKRAFTELSE?: TEDBOTEDBOAkttypBokngruppAVBOKNINGSBEKRAFTELSEEnum | null;
  AKTTYP_BOKNBAR?: string | null;
  BEVAKNINGSDAGAR?: number | null;
  VARNA_JORD_KREM?: string | null;
  _Associations?: TEDInputBOTEDBOAkttypBokngruppUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av bOTEDBOBisattningOrder
 */
export interface TEDInputBOTEDBOBisattningOrderAddAssociationValues {
  NormalOrder_Ref?: string | null;
  NormalOrder_Values?: TEDInputOFOrderAddValues | null;
}

/**
 * Värden vid tillägg av bOTEDBOBisattningOrder
 */
export interface TEDInputBOTEDBOBisattningOrderAddValues {
  BISATTNINGSJOURNAL_ID?: number | null;
  LOPNR?: number | null;
  _Associations: TEDInputBOTEDBOBisattningOrderAddAssociationValues;
}

/**
 * Associerade värden vid ändring av bOTEDBOBisattningOrder
 */
export interface TEDInputBOTEDBOBisattningOrderUpdateAssociationValues {
  NormalOrder_Ref?: string | null;
  NormalOrder_Values?: TEDInputOFOrderUpdateValues | null;
}

/**
 * Nya värden vid ändring av bOTEDBOBisattningOrder
 */
export interface TEDInputBOTEDBOBisattningOrderUpdateValues {
  id: string;
  _version: number;
  BISATTNINGSJOURNAL_ID?: number | null;
  LOPNR?: number | null;
  _Associations?: TEDInputBOTEDBOBisattningOrderUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av medlem
 */
export interface TEDInputBOTEDBOGruppmedlemOPAddAssociationValues {
  GruppOP_Ref?: string | null;
  GruppOP_Values?: TEDInputBOGruppOPAddValues | null;
  Person_Ref?: string | null;
  Person_Values?: TEDInputOPOrgPersLokAddValues | null;
  MedlGrupp_Ref?: string | null;
  MedlGrupp_Values?: TEDInputBOGruppOPAddValues | null;
  Narvaro_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av medlem
 */
export interface TEDInputBOTEDBOGruppmedlemOPAddValues {
  _typ: TEDBOTEDBOGruppmedlemOPTypEnum;
  BESKRIVNING?: string | null;
  ANMALNINGSDATUM?: any | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  _Associations?: TEDInputBOTEDBOGruppmedlemOPAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av medlem
 */
export interface TEDInputBOTEDBOGruppmedlemOPDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av medlem
 */
export interface TEDInputBOTEDBOGruppmedlemOPUpdateAssociationValues {
  GruppOP_Ref?: string | null;
  GruppOP_Values?: TEDInputBOGruppOPUpdateValues | null;
  Person_Ref?: string | null;
  Person_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  MedlGrupp_Ref?: string | null;
  MedlGrupp_Values?: TEDInputBOGruppOPUpdateValues | null;
  Narvaro_Add_Refs?: string[] | null;
  Narvaro_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av medlem
 */
export interface TEDInputBOTEDBOGruppmedlemOPUpdateValues {
  id: string;
  _version: number;
  BESKRIVNING?: string | null;
  ANMALNINGSDATUM?: any | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  _Associations?: TEDInputBOTEDBOGruppmedlemOPUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av utcheckningsstatus
 */
export interface TEDInputBOUtcheckningsstatusAddAssociationValues {
  Lokal_Ref?: string | null;
  Lokal_Values?: TEDInputBOBisattningslokalAddValues | null;
}

/**
 * Värden vid tillägg av utcheckningsstatus
 */
export interface TEDInputBOUtcheckningsstatusAddValues {
  BENAMNING?: string | null;
  TILLBAKA?: boolean | null;
  BLOCKERA_VID_TVIST?: boolean | null;
  BLOCKERA_TVIST_GRAVS?: boolean | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN?: string | null;
  STATUSTYP?: string | null;
  PERSONAL?: boolean | null;
  AVHAMTAD_KREMJOURNAL?: boolean | null;
  _Associations?: TEDInputBOUtcheckningsstatusAddAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av utcheckningsstatus
 */
export interface TEDInputBOUtcheckningsstatusStoftAddAssociationValues {
  Lokal_Ref?: string | null;
  Lokal_Values?: TEDInputBOBisattningslokalAddValues | null;
}

/**
 * Värden vid tillägg av utcheckningsstatus
 */
export interface TEDInputBOUtcheckningsstatusStoftAddValues {
  BENAMNING?: string | null;
  TILLBAKA?: boolean | null;
  BLOCKERA_VID_TVIST?: boolean | null;
  BLOCKERA_TVIST_GRAVS?: boolean | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN?: string | null;
  STATUSTYP?: string | null;
  PERSONAL?: boolean | null;
  AVHAMTAD_KREMJOURNAL?: string | null;
  _Associations?: TEDInputBOUtcheckningsstatusStoftAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av utcheckningsstatus
 */
export interface TEDInputBOUtcheckningsstatusStoftUpdateAssociationValues {
  Lokal_Ref?: string | null;
  Lokal_Values?: TEDInputBOBisattningslokalUpdateValues | null;
}

/**
 * Nya värden vid ändring av utcheckningsstatus
 */
export interface TEDInputBOUtcheckningsstatusStoftUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  TILLBAKA?: boolean | null;
  BLOCKERA_VID_TVIST?: boolean | null;
  BLOCKERA_TVIST_GRAVS?: boolean | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN?: string | null;
  STATUSTYP?: string | null;
  PERSONAL?: boolean | null;
  AVHAMTAD_KREMJOURNAL?: string | null;
  _Associations?: TEDInputBOUtcheckningsstatusStoftUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av utcheckningsstatus
 */
export interface TEDInputBOUtcheckningsstatusUpdateAssociationValues {
  Lokal_Ref?: string | null;
  Lokal_Values?: TEDInputBOBisattningslokalUpdateValues | null;
}

/**
 * Nya värden vid ändring av utcheckningsstatus
 */
export interface TEDInputBOUtcheckningsstatusUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  TILLBAKA?: boolean | null;
  BLOCKERA_VID_TVIST?: boolean | null;
  BLOCKERA_TVIST_GRAVS?: boolean | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN?: string | null;
  STATUSTYP?: string | null;
  PERSONAL?: boolean | null;
  AVHAMTAD_KREMJOURNAL?: boolean | null;
  _Associations?: TEDInputBOUtcheckningsstatusUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av bOUtcheckningsstatusUrna
 */
export interface TEDInputBOUtcheckningsstatusUrnaAddAssociationValues {
  Lokal_Ref?: string | null;
  Lokal_Values?: TEDInputBOBisattningslokalAddValues | null;
}

/**
 * Värden vid tillägg av bOUtcheckningsstatusUrna
 */
export interface TEDInputBOUtcheckningsstatusUrnaAddValues {
  BENAMNING?: string | null;
  TILLBAKA?: boolean | null;
  BLOCKERA_VID_TVIST?: boolean | null;
  BLOCKERA_TVIST_GRAVS?: boolean | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN?: string | null;
  STATUSTYP?: string | null;
  PERSONAL?: boolean | null;
  AVHAMTAD_KREMJOURNAL?: string | null;
  _Associations?: TEDInputBOUtcheckningsstatusUrnaAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av bOUtcheckningsstatusUrna
 */
export interface TEDInputBOUtcheckningsstatusUrnaUpdateAssociationValues {
  Lokal_Ref?: string | null;
  Lokal_Values?: TEDInputBOBisattningslokalUpdateValues | null;
}

/**
 * Nya värden vid ändring av bOUtcheckningsstatusUrna
 */
export interface TEDInputBOUtcheckningsstatusUrnaUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  TILLBAKA?: boolean | null;
  BLOCKERA_VID_TVIST?: boolean | null;
  BLOCKERA_TVIST_GRAVS?: boolean | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN?: string | null;
  STATUSTYP?: string | null;
  PERSONAL?: boolean | null;
  AVHAMTAD_KREMJOURNAL?: string | null;
  _Associations?: TEDInputBOUtcheckningsstatusUrnaUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av verksamhetstyp
 */
export interface TEDInputBOVerksamhetstyperAddAssociationValues {
  Aktivitetskategorier_Add_Values?: TEDInputBOVerkstypKategoriAddValues[] | null;
  VerktypBoknGrupp_Add_Values?: TEDInputBOVerktypBoknGruppAddValues[] | null;
  Handelsetyper_Add_Values?: TEDInputBOVerkstypHandelsetypAddValues[] | null;
  Amnesomraden_Add_Values?: TEDInputBOVerkstypAmnesomradeAddValues[] | null;
}

/**
 * Värden vid tillägg av verksamhetstyp
 */
export interface TEDInputBOVerksamhetstyperAddValues {
  KOD: string;
  BENAMNING: string;
  STATISTIKUPPGIFT?: TEDBOVerksamhetstyperSTATISTIKUPPGIFTEnum | null;
  ANNONSERAS?: TEDBOVerksamhetstyperANNONSERASEnum | null;
  BORTTAGEN?: TEDBOVerksamhetstyperBORTTAGENEnum | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  ALDERINDELAS?: boolean | null;
  CATEGORY?: string | null;
  SK_STATISTIK_GRUPP?: number | null;
  AVENYSTANDARD?: boolean | null;
  ARSBASERAD?: boolean | null;
  _Associations?: TEDInputBOVerksamhetstyperAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av verksamhetstyp
 */
export interface TEDInputBOVerksamhetstyperUpdateAssociationValues {
  Aktivitetskategorier_Add_Values?: TEDInputBOVerkstypKategoriAddValues[] | null;
  Aktivitetskategorier_Update_Values?: TEDInputBOVerkstypKategoriUpdateValues[] | null;
  Aktivitetskategorier_Delete_Values?: TEDInputBOVerkstypKategoriDeleteValues[] | null;
  VerktypBoknGrupp_Add_Values?: TEDInputBOVerktypBoknGruppAddValues[] | null;
  VerktypBoknGrupp_Update_Values?: TEDInputBOVerktypBoknGruppUpdateValues[] | null;
  VerktypBoknGrupp_Delete_Values?: TEDInputBOVerktypBoknGruppDeleteValues[] | null;
  Handelsetyper_Add_Values?: TEDInputBOVerkstypHandelsetypAddValues[] | null;
  Handelsetyper_Update_Values?: TEDInputBOVerkstypHandelsetypUpdateValues[] | null;
  Handelsetyper_Delete_Values?: TEDInputBOVerkstypHandelsetypDeleteValues[] | null;
  Amnesomraden_Add_Values?: TEDInputBOVerkstypAmnesomradeAddValues[] | null;
  Amnesomraden_Update_Values?: TEDInputBOVerkstypAmnesomradeUpdateValues[] | null;
  Amnesomraden_Delete_Values?: TEDInputBOVerkstypAmnesomradeDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av verksamhetstyp
 */
export interface TEDInputBOVerksamhetstyperUpdateValues {
  id: string;
  _version: number;
  KOD?: string | null;
  BENAMNING?: string | null;
  STATISTIKUPPGIFT?: TEDBOVerksamhetstyperSTATISTIKUPPGIFTEnum | null;
  ANNONSERAS?: TEDBOVerksamhetstyperANNONSERASEnum | null;
  BORTTAGEN?: TEDBOVerksamhetstyperBORTTAGENEnum | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  ALDERINDELAS?: boolean | null;
  CATEGORY?: string | null;
  SK_STATISTIK_GRUPP?: number | null;
  AVENYSTANDARD?: boolean | null;
  ARSBASERAD?: boolean | null;
  _Associations?: TEDInputBOVerksamhetstyperUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av verksamhetstypens ämnesområde
 */
export interface TEDInputBOVerkstypAmnesomradeAddAssociationValues {
  Amnesomrade_Ref?: string | null;
  Amnesomrade_Values?: TEDInputBOSKKAmnesomradenAddValues | null;
}

/**
 * Värden vid tillägg av verksamhetstypens ämnesområde
 */
export interface TEDInputBOVerkstypAmnesomradeAddValues {
  _Associations: TEDInputBOVerkstypAmnesomradeAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av verksamhetstypens ämnesområde
 */
export interface TEDInputBOVerkstypAmnesomradeDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av verksamhetstypens ämnesområde
 */
export interface TEDInputBOVerkstypAmnesomradeUpdateAssociationValues {
  Amnesomrade_Ref?: string | null;
  Amnesomrade_Values?: TEDInputBOSKKAmnesomradenUpdateValues | null;
}

/**
 * Nya värden vid ändring av verksamhetstypens ämnesområde
 */
export interface TEDInputBOVerkstypAmnesomradeUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputBOVerkstypAmnesomradeUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av bOVerkstypHandelsetyp
 */
export interface TEDInputBOVerkstypHandelsetypAddAssociationValues {
  Handelsetyp_Ref?: string | null;
  Handelsetyp_Values?: TEDInputBOSKKHandelsetypAddValues | null;
}

/**
 * Värden vid tillägg av bOVerkstypHandelsetyp
 */
export interface TEDInputBOVerkstypHandelsetypAddValues {
  _Associations: TEDInputBOVerkstypHandelsetypAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av bOVerkstypHandelsetyp
 */
export interface TEDInputBOVerkstypHandelsetypDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av bOVerkstypHandelsetyp
 */
export interface TEDInputBOVerkstypHandelsetypUpdateAssociationValues {
  Handelsetyp_Ref?: string | null;
  Handelsetyp_Values?: TEDInputBOSKKHandelsetypUpdateValues | null;
}

/**
 * Nya värden vid ändring av bOVerkstypHandelsetyp
 */
export interface TEDInputBOVerkstypHandelsetypUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputBOVerkstypHandelsetypUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kategori för en verksamhetstyp
 */
export interface TEDInputBOVerkstypKategoriAddAssociationValues {
  Aktivitetskategori_Ref?: string | null;
  Aktivitetskategori_Values?: TEDInputBOKategoriAddValues | null;
}

/**
 * Värden vid tillägg av kategori för en verksamhetstyp
 */
export interface TEDInputBOVerkstypKategoriAddValues {
  _Associations: TEDInputBOVerkstypKategoriAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kategori för en verksamhetstyp
 */
export interface TEDInputBOVerkstypKategoriDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kategori för en verksamhetstyp
 */
export interface TEDInputBOVerkstypKategoriUpdateAssociationValues {
  Aktivitetskategori_Ref?: string | null;
  Aktivitetskategori_Values?: TEDInputBOKategoriUpdateValues | null;
}

/**
 * Nya värden vid ändring av kategori för en verksamhetstyp
 */
export interface TEDInputBOVerkstypKategoriUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputBOVerkstypKategoriUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av verksamhetens bokningsgrupp
 */
export interface TEDInputBOVerktypBoknGruppAddAssociationValues {
  Verksamhetstyp_Ref?: string | null;
  Verksamhetstyp_Values?: TEDInputBOVerksamhetstyperAddValues | null;
  Bokningsgrupp_Ref?: string | null;
  Bokningsgrupp_Values?: TEDInputSYSBokngruppAddValues | null;
}

/**
 * Värden vid tillägg av verksamhetens bokningsgrupp
 */
export interface TEDInputBOVerktypBoknGruppAddValues {
  _Associations?: TEDInputBOVerktypBoknGruppAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av verksamhetens bokningsgrupp
 */
export interface TEDInputBOVerktypBoknGruppDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av verksamhetens bokningsgrupp
 */
export interface TEDInputBOVerktypBoknGruppUpdateAssociationValues {
  Verksamhetstyp_Ref?: string | null;
  Verksamhetstyp_Values?: TEDInputBOVerksamhetstyperUpdateValues | null;
  Bokningsgrupp_Ref?: string | null;
  Bokningsgrupp_Values?: TEDInputSYSBokngruppUpdateValues | null;
}

/**
 * Nya värden vid ändring av verksamhetens bokningsgrupp
 */
export interface TEDInputBOVerktypBoknGruppUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputBOVerktypBoknGruppUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kodbehörighet
 */
export interface TEDInputEKAnvKontobegrAddAssociationValues {
  Kontoplan_Ref?: string | null;
  Kontoplan_Values?: TEDInputEKKontoplanAddValues | null;
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalAddValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
  Attestratt_Ref?: string | null;
  Attestratt_Values?: TEDInputLRAttestrattAddValues | null;
  Kontrollattestratt_Ref?: string | null;
  Kontrollattestratt_Values?: TEDInputLRAttestrattAddValues | null;
  MinaUtdelningar_Add_Refs?: string[] | null;
  MinaFavoritUtdelningar_Add_Refs?: string[] | null;
  AnvForAnalyser_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av kodbehörighet
 */
export interface TEDInputEKAnvKontobegrAddValues {
  FOR_ANALYS?: boolean | null;
  FOR_RAPPORT?: boolean | null;
  ATTEST_TYP?: string | null;
  BESLUT_MAXBELOPP?: any | null;
  KONTROLL_BELOPP?: any | null;
  FOR_BUDGET?: boolean | null;
  FOR_BOKFORDER?: boolean | null;
  KOMBINERAD?: boolean | null;
  KOMBINERAD_ANVANDS_FOR?: TEDEKAnvKontobegrKOMBINERAD_ANVANDS_FOREnum | null;
  KOMBINERAD_VISA?: boolean | null;
  FOR_UTANORDNING?: boolean | null;
  UTANORDNING_KONTROLL?: boolean | null;
  UTANORDNING_KA_MAXBELOPP?: any | null;
  UTANORDNING_KONTROLLBELOPP?: any | null;
  _Associations: TEDInputEKAnvKontobegrAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kodbehörighet
 */
export interface TEDInputEKAnvKontobegrDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kodbehörighet
 */
export interface TEDInputEKAnvKontobegrUpdateAssociationValues {
  Kontoplan_Ref?: string | null;
  Kontoplan_Values?: TEDInputEKKontoplanUpdateValues | null;
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalUpdateValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
  Attestratt_Ref?: string | null;
  Attestratt_Values?: TEDInputLRAttestrattUpdateValues | null;
  Kontrollattestratt_Ref?: string | null;
  Kontrollattestratt_Values?: TEDInputLRAttestrattUpdateValues | null;
  MinaUtdelningar_Add_Refs?: string[] | null;
  MinaUtdelningar_Delete_Refs?: string[] | null;
  MinaFavoritUtdelningar_Add_Refs?: string[] | null;
  MinaFavoritUtdelningar_Delete_Refs?: string[] | null;
  AnvForAnalyser_Add_Refs?: string[] | null;
  AnvForAnalyser_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av kodbehörighet
 */
export interface TEDInputEKAnvKontobegrUpdateValues {
  id: string;
  _version: number;
  FOR_ANALYS?: boolean | null;
  FOR_RAPPORT?: boolean | null;
  ATTEST_TYP?: string | null;
  BESLUT_MAXBELOPP?: any | null;
  KONTROLL_BELOPP?: any | null;
  FOR_BUDGET?: boolean | null;
  FOR_BOKFORDER?: boolean | null;
  KOMBINERAD?: boolean | null;
  KOMBINERAD_ANVANDS_FOR?: TEDEKAnvKontobegrKOMBINERAD_ANVANDS_FOREnum | null;
  KOMBINERAD_VISA?: boolean | null;
  FOR_UTANORDNING?: boolean | null;
  UTANORDNING_KONTROLL?: boolean | null;
  UTANORDNING_KA_MAXBELOPP?: any | null;
  UTANORDNING_KONTROLLBELOPP?: any | null;
  _Associations?: TEDInputEKAnvKontobegrUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kodbegränsning
 */
export interface TEDInputEKAnvKontourvalAddAssociationValues {
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalAddValues | null;
  Kontoplan_Ref?: string | null;
  Kontoplan_Values?: TEDInputEKKontoplanAddValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
}

/**
 * Värden vid tillägg av kodbegränsning
 */
export interface TEDInputEKAnvKontourvalAddValues {
  URVAL_ID?: number | null;
  KONV_TO_VIEW_ID?: number | null;
  _Associations: TEDInputEKAnvKontourvalAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kodbegränsning
 */
export interface TEDInputEKAnvKontourvalDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kodbegränsning
 */
export interface TEDInputEKAnvKontourvalUpdateAssociationValues {
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalUpdateValues | null;
  Kontoplan_Ref?: string | null;
  Kontoplan_Values?: TEDInputEKKontoplanUpdateValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
}

/**
 * Nya värden vid ändring av kodbegränsning
 */
export interface TEDInputEKAnvKontourvalUpdateValues {
  id: string;
  _version: number;
  URVAL_ID?: number | null;
  KONV_TO_VIEW_ID?: number | null;
  _Associations?: TEDInputEKAnvKontourvalUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av användarens ekonomirapport
 */
export interface TEDInputEKAnvRapportAddAssociationValues {
  UtdeladEkonomirapport_Ref?: string | null;
  UtdeladEkonomirapport_Values?: TEDInputEKUtdeladRapportAddValues | null;
}

/**
 * Värden vid tillägg av användarens ekonomirapport
 */
export interface TEDInputEKAnvRapportAddValues {
  VIEW_ID?: number | null;
  _Associations: TEDInputEKAnvRapportAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av användarens ekonomirapport
 */
export interface TEDInputEKAnvRapportDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av användarens ekonomirapport
 */
export interface TEDInputEKAnvRapportUpdateAssociationValues {
  UtdeladEkonomirapport_Ref?: string | null;
  UtdeladEkonomirapport_Values?: TEDInputEKUtdeladRapportUpdateValues | null;
}

/**
 * Nya värden vid ändring av användarens ekonomirapport
 */
export interface TEDInputEKAnvRapportUpdateValues {
  id: string;
  _version: number;
  VIEW_ID?: number | null;
  _Associations?: TEDInputEKAnvRapportUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av automatkontering, giltighet
 */
export interface TEDInputEKAutomatkontGiltighetAddAssociationValues {
  Automatkontering_Ref?: string | null;
  Automatkontering_Values?: TEDInputEKAutomatkonteringarAddValues | null;
  Fordelnrapport_Ref?: string | null;
  Fordelnrapport_Values?: TEDInputEKEkonomirapportAddValues | null;
  Urval_Add_Values?: TEDInputEKAutomatkontUrvalAddValues[] | null;
  Mall_Add_Values?: TEDInputEKAutomatkontMallAddValues[] | null;
  OmfordelningLogg_Add_Values?: TEDInputEKOmfordelningLoggAddValues[] | null;
}

/**
 * Värden vid tillägg av automatkontering, giltighet
 */
export interface TEDInputEKAutomatkontGiltighetAddValues {
  RUBRIK?: string | null;
  FROM_BOKFDATUM?: any | null;
  TOM_BOKFDATUM?: any | null;
  REG_DATUM?: any | null;
  REG_ANV_ID?: number | null;
  FORDELN_RAPPORT_IDKOD?: string | null;
  EXKLUDERA_BASKONTON?: string | null;
  _Associations?: TEDInputEKAutomatkontGiltighetAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av automatkontering, giltighet
 */
export interface TEDInputEKAutomatkontGiltighetDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av automatkontering, giltighet
 */
export interface TEDInputEKAutomatkontGiltighetUpdateAssociationValues {
  Automatkontering_Ref?: string | null;
  Automatkontering_Values?: TEDInputEKAutomatkonteringarUpdateValues | null;
  Fordelnrapport_Ref?: string | null;
  Fordelnrapport_Values?: TEDInputEKEkonomirapportUpdateValues | null;
  Urval_Add_Values?: TEDInputEKAutomatkontUrvalAddValues[] | null;
  Urval_Update_Values?: TEDInputEKAutomatkontUrvalUpdateValues[] | null;
  Urval_Delete_Values?: TEDInputEKAutomatkontUrvalDeleteValues[] | null;
  Mall_Add_Values?: TEDInputEKAutomatkontMallAddValues[] | null;
  Mall_Update_Values?: TEDInputEKAutomatkontMallUpdateValues[] | null;
  Mall_Delete_Values?: TEDInputEKAutomatkontMallDeleteValues[] | null;
  OmfordelningLogg_Add_Values?: TEDInputEKOmfordelningLoggAddValues[] | null;
  OmfordelningLogg_Update_Values?: TEDInputEKOmfordelningLoggUpdateValues[] | null;
  OmfordelningLogg_Delete_Values?: TEDInputEKOmfordelningLoggDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av automatkontering, giltighet
 */
export interface TEDInputEKAutomatkontGiltighetUpdateValues {
  id: string;
  _version: number;
  RUBRIK?: string | null;
  FROM_BOKFDATUM?: any | null;
  TOM_BOKFDATUM?: any | null;
  REG_DATUM?: any | null;
  REG_ANV_ID?: number | null;
  FORDELN_RAPPORT_IDKOD?: string | null;
  EXKLUDERA_BASKONTON?: string | null;
  _Associations?: TEDInputEKAutomatkontGiltighetUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av automatkontering, mall
 */
export interface TEDInputEKAutomatkontMallAddAssociationValues {
  Giltighet_Ref?: string | null;
  Giltighet_Values?: TEDInputEKAutomatkontGiltighetAddValues | null;
  Rapportrad_Ref?: string | null;
  Rapportrad_Values?: TEDInputEKDimensionsradAddValues | null;
}

/**
 * Värden vid tillägg av automatkontering, mall
 */
export interface TEDInputEKAutomatkontMallAddValues {
  KONTODEL_1?: string | null;
  KONTODEL_2?: string | null;
  KONTODEL_3?: string | null;
  KONTODEL_4?: string | null;
  KONTODEL_5?: string | null;
  KONTODEL_6?: string | null;
  KONTODEL_7?: string | null;
  KONTODEL_8?: string | null;
  KONTODEL_9?: string | null;
  KONTODEL_10?: string | null;
  PROCENTSATS?: number | null;
  MOTKONTODEL_1?: string | null;
  MOTKONTODEL_2?: string | null;
  MOTKONTODEL_3?: string | null;
  MOTKONTODEL_4?: string | null;
  MOTKONTODEL_5?: string | null;
  MOTKONTODEL_6?: string | null;
  MOTKONTODEL_7?: string | null;
  MOTKONTODEL_8?: string | null;
  MOTKONTODEL_9?: string | null;
  MOTKONTODEL_10?: string | null;
  AUTOMATKONTERA_VIDARE?: TEDEKAutomatkontMallAUTOMATKONTERA_VIDAREEnum | null;
  BELOPP?: any | null;
  RADTYP?: TEDEKAutomatkontMallRADTYPEnum | null;
  FORDELN_RAPPORT_IDKOD_LOPNR?: number | null;
  _Associations?: TEDInputEKAutomatkontMallAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av automatkontering, mall
 */
export interface TEDInputEKAutomatkontMallDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av automatkontering, mall
 */
export interface TEDInputEKAutomatkontMallUpdateAssociationValues {
  Giltighet_Ref?: string | null;
  Giltighet_Values?: TEDInputEKAutomatkontGiltighetUpdateValues | null;
  Rapportrad_Ref?: string | null;
  Rapportrad_Values?: TEDInputEKDimensionsradUpdateValues | null;
}

/**
 * Nya värden vid ändring av automatkontering, mall
 */
export interface TEDInputEKAutomatkontMallUpdateValues {
  id: string;
  _version: number;
  KONTODEL_1?: string | null;
  KONTODEL_2?: string | null;
  KONTODEL_3?: string | null;
  KONTODEL_4?: string | null;
  KONTODEL_5?: string | null;
  KONTODEL_6?: string | null;
  KONTODEL_7?: string | null;
  KONTODEL_8?: string | null;
  KONTODEL_9?: string | null;
  KONTODEL_10?: string | null;
  PROCENTSATS?: number | null;
  MOTKONTODEL_1?: string | null;
  MOTKONTODEL_2?: string | null;
  MOTKONTODEL_3?: string | null;
  MOTKONTODEL_4?: string | null;
  MOTKONTODEL_5?: string | null;
  MOTKONTODEL_6?: string | null;
  MOTKONTODEL_7?: string | null;
  MOTKONTODEL_8?: string | null;
  MOTKONTODEL_9?: string | null;
  MOTKONTODEL_10?: string | null;
  AUTOMATKONTERA_VIDARE?: TEDEKAutomatkontMallAUTOMATKONTERA_VIDAREEnum | null;
  BELOPP?: any | null;
  RADTYP?: TEDEKAutomatkontMallRADTYPEnum | null;
  FORDELN_RAPPORT_IDKOD_LOPNR?: number | null;
  _Associations?: TEDInputEKAutomatkontMallUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av automatkontering, urval
 */
export interface TEDInputEKAutomatkontUrvalAddAssociationValues {
  Giltighet_Ref?: string | null;
  Giltighet_Values?: TEDInputEKAutomatkontGiltighetAddValues | null;
}

/**
 * Värden vid tillägg av automatkontering, urval
 */
export interface TEDInputEKAutomatkontUrvalAddValues {
  FROM_KONTODEL_1?: string | null;
  TOM_KONTODEL_1?: string | null;
  FROM_KONTODEL_2?: string | null;
  TOM_KONTODEL_2?: string | null;
  FROM_KONTODEL_3?: string | null;
  TOM_KONTODEL_3?: string | null;
  FROM_KONTODEL_4?: string | null;
  TOM_KONTODEL_4?: string | null;
  FROM_KONTODEL_5?: string | null;
  TOM_KONTODEL_5?: string | null;
  FROM_KONTODEL_6?: string | null;
  TOM_KONTODEL_6?: string | null;
  FROM_KONTODEL_7?: string | null;
  TOM_KONTODEL_7?: string | null;
  FROM_KONTODEL_8?: string | null;
  TOM_KONTODEL_8?: string | null;
  FROM_KONTODEL_9?: string | null;
  TOM_KONTODEL_9?: string | null;
  FROM_KONTODEL_10?: string | null;
  TOM_KONTODEL_10?: string | null;
  _Associations?: TEDInputEKAutomatkontUrvalAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av automatkontering, urval
 */
export interface TEDInputEKAutomatkontUrvalDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av automatkontering, urval
 */
export interface TEDInputEKAutomatkontUrvalUpdateAssociationValues {
  Giltighet_Ref?: string | null;
  Giltighet_Values?: TEDInputEKAutomatkontGiltighetUpdateValues | null;
}

/**
 * Nya värden vid ändring av automatkontering, urval
 */
export interface TEDInputEKAutomatkontUrvalUpdateValues {
  id: string;
  _version: number;
  FROM_KONTODEL_1?: string | null;
  TOM_KONTODEL_1?: string | null;
  FROM_KONTODEL_2?: string | null;
  TOM_KONTODEL_2?: string | null;
  FROM_KONTODEL_3?: string | null;
  TOM_KONTODEL_3?: string | null;
  FROM_KONTODEL_4?: string | null;
  TOM_KONTODEL_4?: string | null;
  FROM_KONTODEL_5?: string | null;
  TOM_KONTODEL_5?: string | null;
  FROM_KONTODEL_6?: string | null;
  TOM_KONTODEL_6?: string | null;
  FROM_KONTODEL_7?: string | null;
  TOM_KONTODEL_7?: string | null;
  FROM_KONTODEL_8?: string | null;
  TOM_KONTODEL_8?: string | null;
  FROM_KONTODEL_9?: string | null;
  TOM_KONTODEL_9?: string | null;
  FROM_KONTODEL_10?: string | null;
  TOM_KONTODEL_10?: string | null;
  _Associations?: TEDInputEKAutomatkontUrvalUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av automatkontering
 */
export interface TEDInputEKAutomatkonteringarAddAssociationValues {
  Giltighet_Add_Values?: TEDInputEKAutomatkontGiltighetAddValues[] | null;
  Logg_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av automatkontering
 */
export interface TEDInputEKAutomatkonteringarAddValues {
  _typ: TEDEKAutomatkonteringarTypEnum;
  KPLAN_ID?: number | null;
  BENAMNING?: string | null;
  AKTIV?: TEDEKAutomatkonteringarAKTIVEnum | null;
  ANVANDS_FOR?: TEDEKAutomatkonteringarANVANDS_FOREnum | null;
  PRIORITERING?: number | null;
  SALDO_FORDELA?: TEDEKAutomatkonteringarSALDO_FORDELAEnum | null;
  HUNDRA_PROCENT?: TEDEKAutomatkonteringarHUNDRA_PROCENTEnum | null;
  FORDELNINGSTYP?: TEDEKAutomatkonteringarFORDELNINGSTYPEnum | null;
  KPLAN_KONV_ID?: number | null;
  IDKOD?: string | null;
  FORDELN_MALL_AVSKR?: boolean | null;
  FORDELN_MALL_INTRANTA?: boolean | null;
  UTL_MOMS_SATS?: number | null;
  _Associations?: TEDInputEKAutomatkonteringarAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av automatkontering
 */
export interface TEDInputEKAutomatkonteringarUpdateAssociationValues {
  Giltighet_Add_Values?: TEDInputEKAutomatkontGiltighetAddValues[] | null;
  Giltighet_Update_Values?: TEDInputEKAutomatkontGiltighetUpdateValues[] | null;
  Giltighet_Delete_Values?: TEDInputEKAutomatkontGiltighetDeleteValues[] | null;
  Logg_Add_Refs?: string[] | null;
  Logg_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av automatkontering
 */
export interface TEDInputEKAutomatkonteringarUpdateValues {
  id: string;
  _version: number;
  KPLAN_ID?: number | null;
  BENAMNING?: string | null;
  AKTIV?: TEDEKAutomatkonteringarAKTIVEnum | null;
  ANVANDS_FOR?: TEDEKAutomatkonteringarANVANDS_FOREnum | null;
  PRIORITERING?: number | null;
  SALDO_FORDELA?: TEDEKAutomatkonteringarSALDO_FORDELAEnum | null;
  HUNDRA_PROCENT?: TEDEKAutomatkonteringarHUNDRA_PROCENTEnum | null;
  FORDELNINGSTYP?: TEDEKAutomatkonteringarFORDELNINGSTYPEnum | null;
  KPLAN_KONV_ID?: number | null;
  IDKOD?: string | null;
  FORDELN_MALL_AVSKR?: boolean | null;
  FORDELN_MALL_INTRANTA?: boolean | null;
  UTL_MOMS_SATS?: number | null;
  _Associations?: TEDInputEKAutomatkonteringarUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av avdragsrätt
 */
export interface TEDInputEKAvdragsrattAddAssociationValues {
  Koddel_Ref?: string | null;
  Koddel_Values?: TEDInputEKKontodelAddValues | null;
}

/**
 * Värden vid tillägg av avdragsrätt
 */
export interface TEDInputEKAvdragsrattAddValues {
  FRAN?: any | null;
  TILL?: any | null;
  PROCENT?: number | null;
  _Associations?: TEDInputEKAvdragsrattAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av avdragsrätt
 */
export interface TEDInputEKAvdragsrattDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av avdragsrätt
 */
export interface TEDInputEKAvdragsrattUpdateAssociationValues {
  Koddel_Ref?: string | null;
  Koddel_Values?: TEDInputEKKontodelUpdateValues | null;
}

/**
 * Nya värden vid ändring av avdragsrätt
 */
export interface TEDInputEKAvdragsrattUpdateValues {
  id: string;
  _version: number;
  FRAN?: any | null;
  TILL?: any | null;
  PROCENT?: number | null;
  _Associations?: TEDInputEKAvdragsrattUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av dokument
 */
export interface TEDInputEKBokfVerDokAddValues {
  BESKRIVNING?: string | null;
  EXTENSION?: string | null;
  OLECLASSNAME?: string | null;
  BINARDATA?: string | null;
  BINARDATASIZE?: number | null;
  DATATYPE?: string | null;
  FILNAMN?: string | null;
  SENAST_ANDRAD?: any | null;
  SENAST_ANDRAD_SIGNATUR?: string | null;
  VER_BILAGA_ID?: number | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av dokument
 */
export interface TEDInputEKBokfVerDokDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av dokument
 */
export interface TEDInputEKBokfVerDokUpdateValues {
  id: string;
  _version: number;
  BESKRIVNING?: string | null;
  EXTENSION?: string | null;
  OLECLASSNAME?: string | null;
  BINARDATA?: string | null;
  BINARDATASIZE?: number | null;
  DATATYPE?: string | null;
  FILNAMN?: string | null;
  SENAST_ANDRAD?: any | null;
  SENAST_ANDRAD_SIGNATUR?: string | null;
  VER_BILAGA_ID?: number | null;
}

/**
 * Värden vid tillägg av dokument
 */
export interface TEDInputEKBokfVerRemovedDokAddValues {
  BESKRIVNING?: string | null;
  BORRTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGN?: string | null;
  NOTERING?: string | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av dokument
 */
export interface TEDInputEKBokfVerRemovedDokDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av dokument
 */
export interface TEDInputEKBokfVerRemovedDokUpdateValues {
  id: string;
  _version: number;
  BESKRIVNING?: string | null;
  BORRTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGN?: string | null;
  NOTERING?: string | null;
}

/**
 * Associerade värden vid tillägg av journal
 */
export interface TEDInputEKBokfjournalAddAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputEKBokfjournalBlobAddValues | null;
  Bokfgrupp_Ref?: string | null;
  Bokfgrupp_Values?: TEDInputSYSGruppAddValues | null;
  Bokforingsperiod_Ref?: string | null;
  Bokforingsperiod_Values?: TEDInputSYSBokfPeriodAddValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
  SkapadAvAnvandare_Ref?: string | null;
  SkapadAvAnvandare_Values?: TEDInputSYSUserAddValues | null;
  Bokfverifikationer_Add_Values?: TEDInputEKBokfverAddValues[] | null;
  Buntar_Add_Values?: TEDInputEKBuntAddValues[] | null;
}

/**
 * Värden vid tillägg av journal
 */
export interface TEDInputEKBokfjournalAddValues {
  _typ: TEDEKBokfjournalTypEnum;
  JOURNAL_NR?: number | null;
  KPLAN_ID?: number | null;
  SUMMERAD?: boolean | null;
  OVERFORD_DATUM?: any | null;
  SKAPAD_DATUM?: any | null;
  BUNTAD?: boolean | null;
  TEXT?: string | null;
  STATUS?: TEDEKBokfjournalSTATUSEnum | null;
  BENAMNING?: string | null;
  INTEGRATIONSTYP?: string | null;
  OVERFORD_KLOCKSLAG?: any | null;
  JOURNALHANTERING?: string | null;
  _Associations: TEDInputEKBokfjournalAddAssociationValues;
}

/**
 * Värden vid tillägg av eKBokfjournalBlob
 */
export interface TEDInputEKBokfjournalBlobAddValues {
  NOTERING?: string | null;
}

/**
 * Nya värden vid ändring av eKBokfjournalBlob
 */
export interface TEDInputEKBokfjournalBlobUpdateValues {
  id: string;
  _version: number;
  NOTERING?: string | null;
}

/**
 * Associerade värden vid ändring av journal
 */
export interface TEDInputEKBokfjournalUpdateAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputEKBokfjournalBlobUpdateValues | null;
  Bokfgrupp_Ref?: string | null;
  Bokfgrupp_Values?: TEDInputSYSGruppUpdateValues | null;
  Bokforingsperiod_Ref?: string | null;
  Bokforingsperiod_Values?: TEDInputSYSBokfPeriodUpdateValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
  SkapadAvAnvandare_Ref?: string | null;
  SkapadAvAnvandare_Values?: TEDInputSYSUserUpdateValues | null;
  Bokfverifikationer_Add_Values?: TEDInputEKBokfverAddValues[] | null;
  Bokfverifikationer_Update_Values?: TEDInputEKBokfverUpdateValues[] | null;
  Bokfverifikationer_Delete_Values?: TEDInputEKBokfverDeleteValues[] | null;
  Buntar_Add_Values?: TEDInputEKBuntAddValues[] | null;
  Buntar_Update_Values?: TEDInputEKBuntUpdateValues[] | null;
  Buntar_Delete_Values?: TEDInputEKBuntDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av journal
 */
export interface TEDInputEKBokfjournalUpdateValues {
  id: string;
  _version: number;
  JOURNAL_NR?: number | null;
  KPLAN_ID?: number | null;
  SUMMERAD?: boolean | null;
  OVERFORD_DATUM?: any | null;
  SKAPAD_DATUM?: any | null;
  BUNTAD?: boolean | null;
  TEXT?: string | null;
  STATUS?: TEDEKBokfjournalSTATUSEnum | null;
  BENAMNING?: string | null;
  INTEGRATIONSTYP?: string | null;
  OVERFORD_KLOCKSLAG?: any | null;
  JOURNALHANTERING?: string | null;
  _Associations?: TEDInputEKBokfjournalUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av verifikationsrad
 */
export interface TEDInputEKBokfkonteringAddAssociationValues {
  Bokfver_Ref?: string | null;
  Bokfver_Values?: TEDInputEKBokfverAddValues | null;
  Kontodel1_Ref?: string | null;
  Kontodel1_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel2_Ref?: string | null;
  Kontodel2_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel3_Ref?: string | null;
  Kontodel3_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel4_Ref?: string | null;
  Kontodel4_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel5_Ref?: string | null;
  Kontodel5_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel6_Ref?: string | null;
  Kontodel6_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel7_Ref?: string | null;
  Kontodel7_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel8_Ref?: string | null;
  Kontodel8_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel9_Ref?: string | null;
  Kontodel9_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel10_Ref?: string | null;
  Kontodel10_Values?: TEDInputEKKontodelAddValues | null;
  Konteringskod_Ref?: string | null;
  Konteringskod_Values?: TEDInputSYSKonteringskodAddValues | null;
  Handelse_Ref?: string | null;
  Handelse_Values?: TEDInputEKFakturahandelseAddValues | null;
  Enhet_Ref?: string | null;
  Enhet_Values?: TEDInputLAEnhetAddValues | null;
  Automatkontering_Ref?: string | null;
  Automatkontering_Values?: TEDInputEKAutomatkonteringarAddValues | null;
  Ursprungskontering_Ref?: string | null;
  Ursprungskontering_Values?: TEDInputEKBokfkonteringAddValues | null;
  Bokfar_Ref?: string | null;
  Bokfar_Values?: TEDInputSYSBokfarAddValues | null;
  Loneart_Ref?: string | null;
  Loneart_Values?: TEDInputEKLoneartAddValues | null;
  Huvudprojekt_Ref?: string | null;
  Huvudprojekt_Values?: TEDInputEKHuvudprojektAddValues | null;
  Investeringsrad_Ref?: string | null;
  Investeringsrad_Values?: TEDInputARInvesteringsradAddValues | null;
}

/**
 * Värden vid tillägg av verifikationsrad
 */
export interface TEDInputEKBokfkonteringAddValues {
  DEBET: any;
  KREDIT: any;
  DEB_KRED?: string | null;
  AUTOMAT_LOPNR?: number | null;
  DEBET_VALUTA?: any | null;
  KREDIT_VALUTA?: any | null;
  MOTKONTO_KOD?: TEDEKBokfkonteringMOTKONTO_KODEnum | null;
  AUTOKONT_NIVA?: number | null;
  TEXT?: string | null;
  AUTOKONT_LOPNR?: number | null;
  AUTOMAT_DEBET?: any | null;
  AUTOMAT_KREDIT?: any | null;
  PERIODISERAD?: boolean | null;
  PROJEKT_AVSLUTAT_2?: boolean | null;
  PROJEKT_AVSLUTAT_3?: boolean | null;
  PROJEKT_AVSLUTAT_4?: boolean | null;
  PROJEKT_AVSLUTAT_5?: boolean | null;
  PROJEKT_AVSLUTAT_6?: boolean | null;
  PROJEKT_AVSLUTAT_7?: boolean | null;
  PROJEKT_AVSLUTAT_8?: boolean | null;
  PROJEKT_AVSLUTAT_9?: boolean | null;
  PROJEKT_AVSLUTAT_10?: boolean | null;
  EKOSTYR_DATUM?: any | null;
  BESTALLNINGS_NR?: string | null;
  TILLGANG_ID?: number | null;
  TILLGANG_UPPR_LOPNR?: number | null;
  TILLGANG_LOPNR?: number | null;
  PROJEKT_BOKF_AR?: any | null;
  PROJEKT_VER_NR?: number | null;
  INTRANTA_TILLGANG_ID?: number | null;
  INTRANTA_UPPR_LOPNR?: number | null;
  AVSLUTAT_MOT_PROJEKT?: boolean | null;
  PROJEKT_LOPNR?: number | null;
  ANTAL?: number | null;
  EXTERNT_ANSTNR?: string | null;
  AVSER_PERIOD?: number | null;
  LONEART?: number | null;
  BEFATTNINGSKOD?: string | null;
  SKICKAD_MOMSFILRAD_ID?: number | null;
  MOMS_BOKF_AR?: any | null;
  MOMS_BOKF_PER?: number | null;
  _Associations?: TEDInputEKBokfkonteringAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av verifikationsrad
 */
export interface TEDInputEKBokfkonteringDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av verifikationsrad
 */
export interface TEDInputEKBokfkonteringUpdateAssociationValues {
  Bokfver_Ref?: string | null;
  Bokfver_Values?: TEDInputEKBokfverUpdateValues | null;
  Kontodel1_Ref?: string | null;
  Kontodel1_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel2_Ref?: string | null;
  Kontodel2_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel3_Ref?: string | null;
  Kontodel3_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel4_Ref?: string | null;
  Kontodel4_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel5_Ref?: string | null;
  Kontodel5_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel6_Ref?: string | null;
  Kontodel6_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel7_Ref?: string | null;
  Kontodel7_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel8_Ref?: string | null;
  Kontodel8_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel9_Ref?: string | null;
  Kontodel9_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel10_Ref?: string | null;
  Kontodel10_Values?: TEDInputEKKontodelUpdateValues | null;
  Konteringskod_Ref?: string | null;
  Konteringskod_Values?: TEDInputSYSKonteringskodUpdateValues | null;
  Handelse_Ref?: string | null;
  Handelse_Values?: TEDInputEKFakturahandelseUpdateValues | null;
  Enhet_Ref?: string | null;
  Enhet_Values?: TEDInputLAEnhetUpdateValues | null;
  Automatkontering_Ref?: string | null;
  Automatkontering_Values?: TEDInputEKAutomatkonteringarUpdateValues | null;
  Ursprungskontering_Ref?: string | null;
  Ursprungskontering_Values?: TEDInputEKBokfkonteringUpdateValues | null;
  Bokfar_Ref?: string | null;
  Bokfar_Values?: TEDInputSYSBokfarUpdateValues | null;
  Loneart_Ref?: string | null;
  Loneart_Values?: TEDInputEKLoneartUpdateValues | null;
  Huvudprojekt_Ref?: string | null;
  Huvudprojekt_Values?: TEDInputEKHuvudprojektUpdateValues | null;
  Investeringsrad_Ref?: string | null;
  Investeringsrad_Values?: TEDInputARInvesteringsradUpdateValues | null;
}

/**
 * Nya värden vid ändring av verifikationsrad
 */
export interface TEDInputEKBokfkonteringUpdateValues {
  id: string;
  _version: number;
  DEBET?: any | null;
  KREDIT?: any | null;
  DEB_KRED?: string | null;
  AUTOMAT_LOPNR?: number | null;
  DEBET_VALUTA?: any | null;
  KREDIT_VALUTA?: any | null;
  MOTKONTO_KOD?: TEDEKBokfkonteringMOTKONTO_KODEnum | null;
  AUTOKONT_NIVA?: number | null;
  TEXT?: string | null;
  AUTOKONT_LOPNR?: number | null;
  AUTOMAT_DEBET?: any | null;
  AUTOMAT_KREDIT?: any | null;
  PERIODISERAD?: boolean | null;
  PROJEKT_AVSLUTAT_2?: boolean | null;
  PROJEKT_AVSLUTAT_3?: boolean | null;
  PROJEKT_AVSLUTAT_4?: boolean | null;
  PROJEKT_AVSLUTAT_5?: boolean | null;
  PROJEKT_AVSLUTAT_6?: boolean | null;
  PROJEKT_AVSLUTAT_7?: boolean | null;
  PROJEKT_AVSLUTAT_8?: boolean | null;
  PROJEKT_AVSLUTAT_9?: boolean | null;
  PROJEKT_AVSLUTAT_10?: boolean | null;
  EKOSTYR_DATUM?: any | null;
  BESTALLNINGS_NR?: string | null;
  TILLGANG_ID?: number | null;
  TILLGANG_UPPR_LOPNR?: number | null;
  TILLGANG_LOPNR?: number | null;
  PROJEKT_BOKF_AR?: any | null;
  PROJEKT_VER_NR?: number | null;
  INTRANTA_TILLGANG_ID?: number | null;
  INTRANTA_UPPR_LOPNR?: number | null;
  AVSLUTAT_MOT_PROJEKT?: boolean | null;
  PROJEKT_LOPNR?: number | null;
  ANTAL?: number | null;
  EXTERNT_ANSTNR?: string | null;
  AVSER_PERIOD?: number | null;
  LONEART?: number | null;
  BEFATTNINGSKOD?: string | null;
  SKICKAD_MOMSFILRAD_ID?: number | null;
  MOMS_BOKF_AR?: any | null;
  MOMS_BOKF_PER?: number | null;
  _Associations?: TEDInputEKBokfkonteringUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av bokföringsorder
 */
export interface TEDInputEKBokforderAddAssociationValues {
  Bestallare_Ref?: string | null;
  Bestallare_Values?: TEDInputSYSUserAddValues | null;
  Attestant_Ref?: string | null;
  Attestant_Values?: TEDInputSYSUserAddValues | null;
  VerSkapadAv_Ref?: string | null;
  VerSkapadAv_Values?: TEDInputSYSUserAddValues | null;
  Bokfgrupp_Ref?: string | null;
  Bokfgrupp_Values?: TEDInputSYSGruppAddValues | null;
  Bokfver_Ref?: string | null;
  Bokfver_Values?: TEDInputEKBokfverAddValues | null;
  RefBokfver_Ref?: string | null;
  RefBokfver_Values?: TEDInputEKBokfverAddValues | null;
  Bokforingsmall_Ref?: string | null;
  Bokforingsmall_Values?: TEDInputEKBokforingsmallAddValues | null;
  Utbetalningssatt_Ref?: string | null;
  Utbetalningssatt_Values?: TEDInputSYSUtbetalningssattAddValues | null;
  Kund_Ref?: string | null;
  Kund_Values?: TEDInputKRKundAddValues | null;
  Betalningsuppdrag_Ref?: string | null;
  Betalningsuppdrag_Values?: TEDInputLRBetalningsuppdragAddValues | null;
  Kollekttillfalle_Ref?: string | null;
  Kollekttillfalle_Values?: TEDInputEKKOBKollektFilTillfalleAddValues | null;
  Kontrollattestant_Ref?: string | null;
  Kontrollattestant_Values?: TEDInputSYSUserAddValues | null;
  ReservKontrollattestant_Ref?: string | null;
  ReservKontrollattestant_Values?: TEDInputSYSUserAddValues | null;
  Rader_Add_Values?: TEDInputEKBokforderRadAddValues[] | null;
  Dokument_Add_Values?: TEDInputEKBokforderDokumentAddValues[] | null;
  Meddelande_Add_Values?: TEDInputEKBokforderMeddelandeAddValues[] | null;
}

/**
 * Värden vid tillägg av bokföringsorder
 */
export interface TEDInputEKBokforderAddValues {
  STATUS: TEDEKBokforderSTATUSEnum;
  STATUS_DATUM?: any | null;
  BESTALLD_DATUM?: any | null;
  TEXT?: string | null;
  BOKF_DATUM?: any | null;
  ATTESTERAD_DATUM?: any | null;
  VER_SKAPAD_DATUM?: any | null;
  PAMINNELSE_SKICKAD_DATUM?: number | null;
  PARAMVALUES?: string | null;
  MALL_DATUM?: any | null;
  MALL_PLATS?: string | null;
  MALL_ANDAMAL?: string | null;
  MALL_IDENTIFIKATION?: string | null;
  MALL_LIKVIDSATT?: string | null;
  BEST_BOKF_DATUM?: any | null;
  VERKAT_KOD?: string | null;
  KOBFIL_ID?: number | null;
  OMFORINGSTYP?: TEDEKBokforderOMFORINGSTYPEnum | null;
  TYP?: TEDEKBokforderTYPEnum | null;
  U_BETALNINGSMOTTAGARE?: string | null;
  U_FRITEXT?: string | null;
  U_CLEARING_BANKKONTONUMMER?: string | null;
  U_BELOPP?: any | null;
  U_BANK?: string | null;
  U_BETSATT_ID?: number | null;
  U_UTBETALNINGSKATEGORI?: TEDEKBokforderU_UTBETALNINGSKATEGORIEnum | null;
  U_BANK_PLUSGIRONUMMER?: string | null;
  U_KUND_ID?: number | null;
  INNAN_BOKF_STATUS?: TEDEKBokforderINNAN_BOKF_STATUSEnum | null;
  KOLLEKTFIL_ID?: number | null;
  KONTROLLATTESTERAS_AV_ID?: number | null;
  KONTROLLATTESTERAD_DATUM?: any | null;
  PAMINNELSE_KONTROLL_SKICKAD_DATUM?: any | null;
  U_MEDDELANDE?: string | null;
  _Associations: TEDInputEKBokforderAddAssociationValues;
}

/**
 * Värden vid tillägg av dokument
 */
export interface TEDInputEKBokforderDokumentAddValues {
  BESKRIVNING?: string | null;
  EXTENSION?: string | null;
  OLECLASSNAME?: string | null;
  BINARDATA?: string | null;
  BINARDATASIZE?: number | null;
  DATATYPE?: string | null;
  FILNAMN?: string | null;
  SENAST_ANDRAD?: any | null;
  SENAST_ANDRAD_SIGNATUR?: string | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av dokument
 */
export interface TEDInputEKBokforderDokumentDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av dokument
 */
export interface TEDInputEKBokforderDokumentUpdateValues {
  id: string;
  _version: number;
  BESKRIVNING?: string | null;
  EXTENSION?: string | null;
  OLECLASSNAME?: string | null;
  BINARDATA?: string | null;
  BINARDATASIZE?: number | null;
  DATATYPE?: string | null;
  FILNAMN?: string | null;
  SENAST_ANDRAD?: any | null;
  SENAST_ANDRAD_SIGNATUR?: string | null;
}

/**
 * Associerade värden vid tillägg av bokföringsorder, meddelande
 */
export interface TEDInputEKBokforderMeddelandeAddAssociationValues {
  Attestant_Ref?: string | null;
  Attestant_Values?: TEDInputSYSUserAddValues | null;
  Ekonom_Ref?: string | null;
  Ekonom_Values?: TEDInputSYSUserAddValues | null;
  Bestallare_Ref?: string | null;
  Bestallare_Values?: TEDInputSYSUserAddValues | null;
  Avsandare_Ref?: string | null;
  Avsandare_Values?: TEDInputSYSUserAddValues | null;
}

/**
 * Värden vid tillägg av bokföringsorder, meddelande
 */
export interface TEDInputEKBokforderMeddelandeAddValues {
  DATUM?: any | null;
  TID?: any | null;
  AVSANDAR_TYP?: TEDEKBokforderMeddelandeAVSANDAR_TYPEnum | null;
  MEDDELANDE?: string | null;
  _Associations?: TEDInputEKBokforderMeddelandeAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av bokföringsorder, meddelande
 */
export interface TEDInputEKBokforderMeddelandeDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av bokföringsorder, meddelande
 */
export interface TEDInputEKBokforderMeddelandeUpdateAssociationValues {
  Attestant_Ref?: string | null;
  Attestant_Values?: TEDInputSYSUserUpdateValues | null;
  Ekonom_Ref?: string | null;
  Ekonom_Values?: TEDInputSYSUserUpdateValues | null;
  Bestallare_Ref?: string | null;
  Bestallare_Values?: TEDInputSYSUserUpdateValues | null;
  Avsandare_Ref?: string | null;
  Avsandare_Values?: TEDInputSYSUserUpdateValues | null;
}

/**
 * Nya värden vid ändring av bokföringsorder, meddelande
 */
export interface TEDInputEKBokforderMeddelandeUpdateValues {
  id: string;
  _version: number;
  DATUM?: any | null;
  TID?: any | null;
  AVSANDAR_TYP?: TEDEKBokforderMeddelandeAVSANDAR_TYPEnum | null;
  MEDDELANDE?: string | null;
  _Associations?: TEDInputEKBokforderMeddelandeUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av bokföringsorder, rad
 */
export interface TEDInputEKBokforderRadAddAssociationValues {
  Bokforder_Ref?: string | null;
  Bokforder_Values?: TEDInputEKBokforderAddValues | null;
  Kontodel1_Ref?: string | null;
  Kontodel1_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel2_Ref?: string | null;
  Kontodel2_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel3_Ref?: string | null;
  Kontodel3_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel4_Ref?: string | null;
  Kontodel4_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel5_Ref?: string | null;
  Kontodel5_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel6_Ref?: string | null;
  Kontodel6_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel7_Ref?: string | null;
  Kontodel7_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel8_Ref?: string | null;
  Kontodel8_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel9_Ref?: string | null;
  Kontodel9_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel10_Ref?: string | null;
  Kontodel10_Values?: TEDInputEKKontodelAddValues | null;
  Konteringskod_Ref?: string | null;
  Konteringskod_Values?: TEDInputSYSKonteringskodAddValues | null;
  Attestant_Ref?: string | null;
  Attestant_Values?: TEDInputSYSUserAddValues | null;
  Kodplan_Ref?: string | null;
  Kodplan_Values?: TEDInputEKKontoplanAddValues | null;
  Bokfkontering_Ref?: string | null;
  Bokfkontering_Values?: TEDInputEKBokfkonteringAddValues | null;
  Reserv_Ref?: string | null;
  Reserv_Values?: TEDInputSYSUserAddValues | null;
}

/**
 * Värden vid tillägg av bokföringsorder, rad
 */
export interface TEDInputEKBokforderRadAddValues {
  TEXT?: string | null;
  DEBET?: any | null;
  KREDIT?: any | null;
  PERIODISERAD?: TEDEKBokforderRadPERIODISERADEnum | null;
  PERIODISERAD_FROM_DATUM?: any | null;
  PERIODISERAD_TOM_DATUM?: any | null;
  ATTESTERAD_DATUM?: any | null;
  PAMINNELSE_SKICKAD_DATUM?: any | null;
  MALL_ID?: number | null;
  MALLRAD_LOPNR?: number | null;
  LIKVIDSATT?: TEDEKBokforderRadLIKVIDSATTEnum | null;
  KOBFIL_ID?: number | null;
  KOBFIL_RADNR?: number | null;
  REF_LOPNR?: number | null;
  KONT_BOKF_AR?: any | null;
  KONT_VER_NR?: number | null;
  KONT_LOPNR?: number | null;
  KONT_USE_ROW?: TEDEKBokforderRadKONT_USE_ROWEnum | null;
  KOLLEKTFIL_LOPNR?: number | null;
  URSPR_KODSTRANG?: string | null;
  _Associations: TEDInputEKBokforderRadAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av bokföringsorder, rad
 */
export interface TEDInputEKBokforderRadDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av bokföringsorder, rad
 */
export interface TEDInputEKBokforderRadUpdateAssociationValues {
  Bokforder_Ref?: string | null;
  Bokforder_Values?: TEDInputEKBokforderUpdateValues | null;
  Kontodel1_Ref?: string | null;
  Kontodel1_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel2_Ref?: string | null;
  Kontodel2_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel3_Ref?: string | null;
  Kontodel3_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel4_Ref?: string | null;
  Kontodel4_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel5_Ref?: string | null;
  Kontodel5_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel6_Ref?: string | null;
  Kontodel6_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel7_Ref?: string | null;
  Kontodel7_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel8_Ref?: string | null;
  Kontodel8_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel9_Ref?: string | null;
  Kontodel9_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel10_Ref?: string | null;
  Kontodel10_Values?: TEDInputEKKontodelUpdateValues | null;
  Konteringskod_Ref?: string | null;
  Konteringskod_Values?: TEDInputSYSKonteringskodUpdateValues | null;
  Attestant_Ref?: string | null;
  Attestant_Values?: TEDInputSYSUserUpdateValues | null;
  Kodplan_Ref?: string | null;
  Kodplan_Values?: TEDInputEKKontoplanUpdateValues | null;
  Bokfkontering_Ref?: string | null;
  Bokfkontering_Values?: TEDInputEKBokfkonteringUpdateValues | null;
  Reserv_Ref?: string | null;
  Reserv_Values?: TEDInputSYSUserUpdateValues | null;
}

/**
 * Nya värden vid ändring av bokföringsorder, rad
 */
export interface TEDInputEKBokforderRadUpdateValues {
  id: string;
  _version: number;
  TEXT?: string | null;
  DEBET?: any | null;
  KREDIT?: any | null;
  PERIODISERAD?: TEDEKBokforderRadPERIODISERADEnum | null;
  PERIODISERAD_FROM_DATUM?: any | null;
  PERIODISERAD_TOM_DATUM?: any | null;
  ATTESTERAD_DATUM?: any | null;
  PAMINNELSE_SKICKAD_DATUM?: any | null;
  MALL_ID?: number | null;
  MALLRAD_LOPNR?: number | null;
  LIKVIDSATT?: TEDEKBokforderRadLIKVIDSATTEnum | null;
  KOBFIL_ID?: number | null;
  KOBFIL_RADNR?: number | null;
  REF_LOPNR?: number | null;
  KONT_BOKF_AR?: any | null;
  KONT_VER_NR?: number | null;
  KONT_LOPNR?: number | null;
  KONT_USE_ROW?: TEDEKBokforderRadKONT_USE_ROWEnum | null;
  KOLLEKTFIL_LOPNR?: number | null;
  URSPR_KODSTRANG?: string | null;
  _Associations?: TEDInputEKBokforderRadUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av bokföringsorder
 */
export interface TEDInputEKBokforderUpdateAssociationValues {
  Bestallare_Ref?: string | null;
  Bestallare_Values?: TEDInputSYSUserUpdateValues | null;
  Attestant_Ref?: string | null;
  Attestant_Values?: TEDInputSYSUserUpdateValues | null;
  VerSkapadAv_Ref?: string | null;
  VerSkapadAv_Values?: TEDInputSYSUserUpdateValues | null;
  Bokfgrupp_Ref?: string | null;
  Bokfgrupp_Values?: TEDInputSYSGruppUpdateValues | null;
  Bokfver_Ref?: string | null;
  Bokfver_Values?: TEDInputEKBokfverUpdateValues | null;
  RefBokfver_Ref?: string | null;
  RefBokfver_Values?: TEDInputEKBokfverUpdateValues | null;
  Bokforingsmall_Ref?: string | null;
  Bokforingsmall_Values?: TEDInputEKBokforingsmallUpdateValues | null;
  Utbetalningssatt_Ref?: string | null;
  Utbetalningssatt_Values?: TEDInputSYSUtbetalningssattUpdateValues | null;
  Kund_Ref?: string | null;
  Kund_Values?: TEDInputKRKundUpdateValues | null;
  Betalningsuppdrag_Ref?: string | null;
  Betalningsuppdrag_Values?: TEDInputLRBetalningsuppdragUpdateValues | null;
  Kollekttillfalle_Ref?: string | null;
  Kollekttillfalle_Values?: TEDInputEKKOBKollektFilTillfalleUpdateValues | null;
  Kontrollattestant_Ref?: string | null;
  Kontrollattestant_Values?: TEDInputSYSUserUpdateValues | null;
  ReservKontrollattestant_Ref?: string | null;
  ReservKontrollattestant_Values?: TEDInputSYSUserUpdateValues | null;
  Rader_Add_Values?: TEDInputEKBokforderRadAddValues[] | null;
  Rader_Update_Values?: TEDInputEKBokforderRadUpdateValues[] | null;
  Rader_Delete_Values?: TEDInputEKBokforderRadDeleteValues[] | null;
  Dokument_Add_Values?: TEDInputEKBokforderDokumentAddValues[] | null;
  Dokument_Update_Values?: TEDInputEKBokforderDokumentUpdateValues[] | null;
  Dokument_Delete_Values?: TEDInputEKBokforderDokumentDeleteValues[] | null;
  Meddelande_Add_Values?: TEDInputEKBokforderMeddelandeAddValues[] | null;
  Meddelande_Update_Values?: TEDInputEKBokforderMeddelandeUpdateValues[] | null;
  Meddelande_Delete_Values?: TEDInputEKBokforderMeddelandeDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av bokföringsorder
 */
export interface TEDInputEKBokforderUpdateValues {
  id: string;
  _version: number;
  STATUS?: TEDEKBokforderSTATUSEnum | null;
  STATUS_DATUM?: any | null;
  BESTALLD_DATUM?: any | null;
  TEXT?: string | null;
  BOKF_DATUM?: any | null;
  ATTESTERAD_DATUM?: any | null;
  VER_SKAPAD_DATUM?: any | null;
  PAMINNELSE_SKICKAD_DATUM?: number | null;
  PARAMVALUES?: string | null;
  MALL_DATUM?: any | null;
  MALL_PLATS?: string | null;
  MALL_ANDAMAL?: string | null;
  MALL_IDENTIFIKATION?: string | null;
  MALL_LIKVIDSATT?: string | null;
  BEST_BOKF_DATUM?: any | null;
  VERKAT_KOD?: string | null;
  KOBFIL_ID?: number | null;
  OMFORINGSTYP?: TEDEKBokforderOMFORINGSTYPEnum | null;
  TYP?: TEDEKBokforderTYPEnum | null;
  U_BETALNINGSMOTTAGARE?: string | null;
  U_FRITEXT?: string | null;
  U_CLEARING_BANKKONTONUMMER?: string | null;
  U_BELOPP?: any | null;
  U_BANK?: string | null;
  U_BETSATT_ID?: number | null;
  U_UTBETALNINGSKATEGORI?: TEDEKBokforderU_UTBETALNINGSKATEGORIEnum | null;
  U_BANK_PLUSGIRONUMMER?: string | null;
  U_KUND_ID?: number | null;
  INNAN_BOKF_STATUS?: TEDEKBokforderINNAN_BOKF_STATUSEnum | null;
  KOLLEKTFIL_ID?: number | null;
  KONTROLLATTESTERAS_AV_ID?: number | null;
  KONTROLLATTESTERAD_DATUM?: any | null;
  PAMINNELSE_KONTROLL_SKICKAD_DATUM?: any | null;
  U_MEDDELANDE?: string | null;
  _Associations?: TEDInputEKBokforderUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av bokföringsmall
 */
export interface TEDInputEKBokforingsmallAddAssociationValues {
  Kodplan_Ref?: string | null;
  Kodplan_Values?: TEDInputEKKontoplanAddValues | null;
  Parametrar_Add_Values?: TEDInputEKBokforingsmallParamAddValues[] | null;
  Rader_Add_Values?: TEDInputEKBokforingsmallRadAddValues[] | null;
}

/**
 * Värden vid tillägg av bokföringsmall
 */
export interface TEDInputEKBokforingsmallAddValues {
  BENAMNING?: string | null;
  IDKOD?: string | null;
  TEXT?: string | null;
  AKTIV?: boolean | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  EXKLUDERA_BELOPP?: boolean | null;
  _Associations: TEDInputEKBokforingsmallAddAssociationValues;
}

/**
 * Värden vid tillägg av bokföringsmall, parameter
 */
export interface TEDInputEKBokforingsmallParamAddValues {
  PARAM_NAME?: string | null;
  PARAM_BENAMNING?: string | null;
  PARAM_DATATYP?: TEDEKBokforingsmallParamPARAM_DATATYPEnum | null;
  ORDNINGS_NR?: number | null;
  FORESLA_BOKFDATUM: TEDEKBokforingsmallParamFORESLA_BOKFDATUMEnum;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av bokföringsmall, parameter
 */
export interface TEDInputEKBokforingsmallParamDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av bokföringsmall, parameter
 */
export interface TEDInputEKBokforingsmallParamUpdateValues {
  id: string;
  _version: number;
  PARAM_NAME?: string | null;
  PARAM_BENAMNING?: string | null;
  PARAM_DATATYP?: TEDEKBokforingsmallParamPARAM_DATATYPEnum | null;
  ORDNINGS_NR?: number | null;
  FORESLA_BOKFDATUM?: TEDEKBokforingsmallParamFORESLA_BOKFDATUMEnum | null;
}

/**
 * Associerade värden vid tillägg av bokföringsmall, rad
 */
export interface TEDInputEKBokforingsmallRadAddAssociationValues {
  Kontodel1_Ref?: string | null;
  Kontodel1_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel2_Ref?: string | null;
  Kontodel2_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel3_Ref?: string | null;
  Kontodel3_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel4_Ref?: string | null;
  Kontodel4_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel5_Ref?: string | null;
  Kontodel5_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel6_Ref?: string | null;
  Kontodel6_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel7_Ref?: string | null;
  Kontodel7_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel8_Ref?: string | null;
  Kontodel8_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel9_Ref?: string | null;
  Kontodel9_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel10_Ref?: string | null;
  Kontodel10_Values?: TEDInputEKKontodelAddValues | null;
  Konteringskod_Ref?: string | null;
  Konteringskod_Values?: TEDInputSYSKonteringskodAddValues | null;
}

/**
 * Värden vid tillägg av bokföringsmall, rad
 */
export interface TEDInputEKBokforingsmallRadAddValues {
  KAN_ANDRAS_1?: boolean | null;
  VILLKOR_1?: TEDEKBokforingsmallRadVILLKOR_1Enum | null;
  GILTIG_INTERVALL_1?: string | null;
  MALL_TYP_1?: TEDEKBokforingsmallRadMALL_TYP_1Enum | null;
  KAN_ANDRAS_2?: boolean | null;
  VILLKOR_2?: TEDEKBokforingsmallRadVILLKOR_2Enum | null;
  GILTIG_INTERVALL_2?: string | null;
  KAN_ANDRAS_3?: boolean | null;
  VILLKOR_3?: TEDEKBokforingsmallRadVILLKOR_3Enum | null;
  GILTIG_INTERVALL_3?: string | null;
  KAN_ANDRAS_4?: boolean | null;
  VILLKOR_4?: TEDEKBokforingsmallRadVILLKOR_4Enum | null;
  GILTIG_INTERVALL_4?: string | null;
  KAN_ANDRAS_5?: boolean | null;
  VILLKOR_5?: TEDEKBokforingsmallRadVILLKOR_5Enum | null;
  GILTIG_INTERVALL_5?: string | null;
  KAN_ANDRAS_6?: boolean | null;
  VILLKOR_6?: TEDEKBokforingsmallRadVILLKOR_6Enum | null;
  GILTIG_INTERVALL_6?: string | null;
  KAN_ANDRAS_7?: boolean | null;
  VILLKOR_7?: TEDEKBokforingsmallRadVILLKOR_7Enum | null;
  GILTIG_INTERVALL_7?: string | null;
  KAN_ANDRAS_8?: boolean | null;
  VILLKOR_8?: TEDEKBokforingsmallRadVILLKOR_8Enum | null;
  GILTIG_INTERVALL_8?: string | null;
  KAN_ANDRAS_9?: boolean | null;
  VILLKOR_9?: TEDEKBokforingsmallRadVILLKOR_9Enum | null;
  GILTIG_INTERVALL_9?: string | null;
  KAN_ANDRAS_10?: boolean | null;
  VILLKOR_10?: TEDEKBokforingsmallRadVILLKOR_10Enum | null;
  GILTIG_INTERVALL_10?: string | null;
  DEB_KRED?: TEDEKBokforingsmallRadDEB_KREDEnum | null;
  ANDEL_PROCENT?: number | null;
  PERIODISERAS?: boolean | null;
  ORDNINGS_NR?: number | null;
  ANGE_PROCENTSATS?: boolean | null;
  KOMMENTAR?: string | null;
  _Associations?: TEDInputEKBokforingsmallRadAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av bokföringsmall, rad
 */
export interface TEDInputEKBokforingsmallRadDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av bokföringsmall, rad
 */
export interface TEDInputEKBokforingsmallRadUpdateAssociationValues {
  Kontodel1_Ref?: string | null;
  Kontodel1_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel2_Ref?: string | null;
  Kontodel2_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel3_Ref?: string | null;
  Kontodel3_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel4_Ref?: string | null;
  Kontodel4_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel5_Ref?: string | null;
  Kontodel5_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel6_Ref?: string | null;
  Kontodel6_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel7_Ref?: string | null;
  Kontodel7_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel8_Ref?: string | null;
  Kontodel8_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel9_Ref?: string | null;
  Kontodel9_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel10_Ref?: string | null;
  Kontodel10_Values?: TEDInputEKKontodelUpdateValues | null;
  Konteringskod_Ref?: string | null;
  Konteringskod_Values?: TEDInputSYSKonteringskodUpdateValues | null;
}

/**
 * Nya värden vid ändring av bokföringsmall, rad
 */
export interface TEDInputEKBokforingsmallRadUpdateValues {
  id: string;
  _version: number;
  KAN_ANDRAS_1?: boolean | null;
  VILLKOR_1?: TEDEKBokforingsmallRadVILLKOR_1Enum | null;
  GILTIG_INTERVALL_1?: string | null;
  MALL_TYP_1?: TEDEKBokforingsmallRadMALL_TYP_1Enum | null;
  KAN_ANDRAS_2?: boolean | null;
  VILLKOR_2?: TEDEKBokforingsmallRadVILLKOR_2Enum | null;
  GILTIG_INTERVALL_2?: string | null;
  KAN_ANDRAS_3?: boolean | null;
  VILLKOR_3?: TEDEKBokforingsmallRadVILLKOR_3Enum | null;
  GILTIG_INTERVALL_3?: string | null;
  KAN_ANDRAS_4?: boolean | null;
  VILLKOR_4?: TEDEKBokforingsmallRadVILLKOR_4Enum | null;
  GILTIG_INTERVALL_4?: string | null;
  KAN_ANDRAS_5?: boolean | null;
  VILLKOR_5?: TEDEKBokforingsmallRadVILLKOR_5Enum | null;
  GILTIG_INTERVALL_5?: string | null;
  KAN_ANDRAS_6?: boolean | null;
  VILLKOR_6?: TEDEKBokforingsmallRadVILLKOR_6Enum | null;
  GILTIG_INTERVALL_6?: string | null;
  KAN_ANDRAS_7?: boolean | null;
  VILLKOR_7?: TEDEKBokforingsmallRadVILLKOR_7Enum | null;
  GILTIG_INTERVALL_7?: string | null;
  KAN_ANDRAS_8?: boolean | null;
  VILLKOR_8?: TEDEKBokforingsmallRadVILLKOR_8Enum | null;
  GILTIG_INTERVALL_8?: string | null;
  KAN_ANDRAS_9?: boolean | null;
  VILLKOR_9?: TEDEKBokforingsmallRadVILLKOR_9Enum | null;
  GILTIG_INTERVALL_9?: string | null;
  KAN_ANDRAS_10?: boolean | null;
  VILLKOR_10?: TEDEKBokforingsmallRadVILLKOR_10Enum | null;
  GILTIG_INTERVALL_10?: string | null;
  DEB_KRED?: TEDEKBokforingsmallRadDEB_KREDEnum | null;
  ANDEL_PROCENT?: number | null;
  PERIODISERAS?: boolean | null;
  ORDNINGS_NR?: number | null;
  ANGE_PROCENTSATS?: boolean | null;
  KOMMENTAR?: string | null;
  _Associations?: TEDInputEKBokforingsmallRadUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av bokföringsmall
 */
export interface TEDInputEKBokforingsmallUpdateAssociationValues {
  Kodplan_Ref?: string | null;
  Kodplan_Values?: TEDInputEKKontoplanUpdateValues | null;
  Parametrar_Add_Values?: TEDInputEKBokforingsmallParamAddValues[] | null;
  Parametrar_Update_Values?: TEDInputEKBokforingsmallParamUpdateValues[] | null;
  Parametrar_Delete_Values?: TEDInputEKBokforingsmallParamDeleteValues[] | null;
  Rader_Add_Values?: TEDInputEKBokforingsmallRadAddValues[] | null;
  Rader_Update_Values?: TEDInputEKBokforingsmallRadUpdateValues[] | null;
  Rader_Delete_Values?: TEDInputEKBokforingsmallRadDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av bokföringsmall
 */
export interface TEDInputEKBokforingsmallUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  IDKOD?: string | null;
  TEXT?: string | null;
  AKTIV?: boolean | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  EXKLUDERA_BELOPP?: boolean | null;
  _Associations?: TEDInputEKBokforingsmallUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av verifikation
 */
export interface TEDInputEKBokfverAddAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputEKBokfverBlobAddValues | null;
  Bokforingsjournal_Ref?: string | null;
  Bokforingsjournal_Values?: TEDInputEKBokfjournalAddValues | null;
  Bokfgrupp_Ref?: string | null;
  Bokfgrupp_Values?: TEDInputSYSGruppAddValues | null;
  Period_Ref?: string | null;
  Period_Values?: TEDInputSYSBokfPeriodAddValues | null;
  Valuta_Ref?: string | null;
  Valuta_Values?: TEDInputSYSValutaAddValues | null;
  Ursprungsverifikation_Ref?: string | null;
  Ursprungsverifikation_Values?: TEDInputEKBokfverAddValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
  Bokforingsorder_Ref?: string | null;
  Bokforingsorder_Values?: TEDInputEKBokforderAddValues | null;
  Kodplan_Ref?: string | null;
  Kodplan_Values?: TEDInputEKKontoplanAddValues | null;
  Konteringar_Add_Values?: TEDInputEKBokfkonteringAddValues[] | null;
  Handelser_Add_Values?: TEDInputEKFakturahandelseAddValues[] | null;
  Dokument_Add_Values?: TEDInputEKBokfVerDokAddValues[] | null;
  RemovedDokument_Add_Values?: TEDInputEKBokfVerRemovedDokAddValues[] | null;
}

/**
 * Värden vid tillägg av verifikation
 */
export interface TEDInputEKBokfverAddValues {
  TEXT?: string | null;
  I_HUVUDBOK?: TEDEKBokfverI_HUVUDBOKEnum | null;
  DATUM?: any | null;
  REG_DATUM?: any | null;
  PERIODISERINGS_NR?: number | null;
  BUNT_ID?: number | null;
  HANVISNINGS_NR?: number | null;
  VERKAT_KOD: TEDEKBokfverVERKAT_KODEnum;
  BACKAD?: boolean | null;
  INTERN_VER?: boolean | null;
  MOMSOMFORING_FIL_ID?: number | null;
  TILLAT_SPARRADE_KONTON?: boolean | null;
  _Associations: TEDInputEKBokfverAddAssociationValues;
}

/**
 * Värden vid tillägg av eKBokfverBlob
 */
export interface TEDInputEKBokfverBlobAddValues {
  NOTERING?: string | null;
}

/**
 * Nya värden vid ändring av eKBokfverBlob
 */
export interface TEDInputEKBokfverBlobUpdateValues {
  id: string;
  _version: number;
  NOTERING?: string | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av verifikation
 */
export interface TEDInputEKBokfverDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av verifikation
 */
export interface TEDInputEKBokfverUpdateAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputEKBokfverBlobUpdateValues | null;
  Bokforingsjournal_Ref?: string | null;
  Bokforingsjournal_Values?: TEDInputEKBokfjournalUpdateValues | null;
  Bokfgrupp_Ref?: string | null;
  Bokfgrupp_Values?: TEDInputSYSGruppUpdateValues | null;
  Period_Ref?: string | null;
  Period_Values?: TEDInputSYSBokfPeriodUpdateValues | null;
  Valuta_Ref?: string | null;
  Valuta_Values?: TEDInputSYSValutaUpdateValues | null;
  Ursprungsverifikation_Ref?: string | null;
  Ursprungsverifikation_Values?: TEDInputEKBokfverUpdateValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
  Bokforingsorder_Ref?: string | null;
  Bokforingsorder_Values?: TEDInputEKBokforderUpdateValues | null;
  Kodplan_Ref?: string | null;
  Kodplan_Values?: TEDInputEKKontoplanUpdateValues | null;
  Konteringar_Add_Values?: TEDInputEKBokfkonteringAddValues[] | null;
  Konteringar_Update_Values?: TEDInputEKBokfkonteringUpdateValues[] | null;
  Konteringar_Delete_Values?: TEDInputEKBokfkonteringDeleteValues[] | null;
  Handelser_Add_Values?: TEDInputEKFakturahandelseAddValues[] | null;
  Handelser_Update_Values?: TEDInputEKFakturahandelseUpdateValues[] | null;
  Handelser_Delete_Values?: TEDInputEKFakturahandelseDeleteValues[] | null;
  Dokument_Add_Values?: TEDInputEKBokfVerDokAddValues[] | null;
  Dokument_Update_Values?: TEDInputEKBokfVerDokUpdateValues[] | null;
  Dokument_Delete_Values?: TEDInputEKBokfVerDokDeleteValues[] | null;
  RemovedDokument_Add_Values?: TEDInputEKBokfVerRemovedDokAddValues[] | null;
  RemovedDokument_Update_Values?: TEDInputEKBokfVerRemovedDokUpdateValues[] | null;
  RemovedDokument_Delete_Values?: TEDInputEKBokfVerRemovedDokDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av verifikation
 */
export interface TEDInputEKBokfverUpdateValues {
  id: string;
  _version: number;
  TEXT?: string | null;
  I_HUVUDBOK?: TEDEKBokfverI_HUVUDBOKEnum | null;
  DATUM?: any | null;
  REG_DATUM?: any | null;
  PERIODISERINGS_NR?: number | null;
  BUNT_ID?: number | null;
  HANVISNINGS_NR?: number | null;
  VERKAT_KOD?: TEDEKBokfverVERKAT_KODEnum | null;
  BACKAD?: boolean | null;
  INTERN_VER?: boolean | null;
  MOMSOMFORING_FIL_ID?: number | null;
  TILLAT_SPARRADE_KONTON?: boolean | null;
  _Associations?: TEDInputEKBokfverUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av bunt
 */
export interface TEDInputEKBuntAddAssociationValues {
  Journal_Ref?: string | null;
  Journal_Values?: TEDInputEKBokfjournalAddValues | null;
  Verifikationer_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av bunt
 */
export interface TEDInputEKBuntAddValues {
  TEXT?: string | null;
  BUNT_SUMMA?: any | null;
  _Associations?: TEDInputEKBuntAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av bunt
 */
export interface TEDInputEKBuntDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av bunt
 */
export interface TEDInputEKBuntUpdateAssociationValues {
  Journal_Ref?: string | null;
  Journal_Values?: TEDInputEKBokfjournalUpdateValues | null;
  Verifikationer_Add_Refs?: string[] | null;
  Verifikationer_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av bunt
 */
export interface TEDInputEKBuntUpdateValues {
  id: string;
  _version: number;
  TEXT?: string | null;
  BUNT_SUMMA?: any | null;
  _Associations?: TEDInputEKBuntUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av rapportrad
 */
export interface TEDInputEKDimensionsradAddAssociationValues {
  Radspec_Add_Values?: TEDInputEKRapportradsspecAddValues[] | null;
}

/**
 * Värden vid tillägg av rapportrad
 */
export interface TEDInputEKDimensionsradAddValues {
  _typ: TEDEKDimensionsradTypEnum;
  ORDNINGS_NR?: number | null;
  NIVA?: number | null;
  FONT_NAMN?: string | null;
  STORLEK?: number | null;
  BOLD?: boolean | null;
  ITALIC?: boolean | null;
  UNDERLINE?: boolean | null;
  STRIKE_OUT?: boolean | null;
  RAD_ID?: number | null;
  BENAMNING?: string | null;
  BELOPP_FONT_NAMN?: string | null;
  BELOPP_STORLEK?: number | null;
  BELOPP_BOLD?: boolean | null;
  BELOPP_ITALIC?: boolean | null;
  BELOPP_UNDERLINE?: boolean | null;
  BELOPP_STRIKE_OUT?: boolean | null;
  SKRIV_UT_NOLLBELOPP?: boolean | null;
  SKRIV_EJ_FALT?: string | null;
  SKRIV_EJ_RAD?: boolean | null;
  RAD_NOT?: string | null;
  SUMMERING?: string | null;
  DELSUMMA?: string | null;
  SM_KONTROLLERA_KONTODELAR?: string | null;
  _Associations?: TEDInputEKDimensionsradAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av rapportrad
 */
export interface TEDInputEKDimensionsradDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av rapportrad
 */
export interface TEDInputEKDimensionsradUpdateAssociationValues {
  Radspec_Add_Values?: TEDInputEKRapportradsspecAddValues[] | null;
  Radspec_Update_Values?: TEDInputEKRapportradsspecUpdateValues[] | null;
  Radspec_Delete_Values?: TEDInputEKRapportradsspecDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av rapportrad
 */
export interface TEDInputEKDimensionsradUpdateValues {
  id: string;
  _version: number;
  ORDNINGS_NR?: number | null;
  NIVA?: number | null;
  FONT_NAMN?: string | null;
  STORLEK?: number | null;
  BOLD?: boolean | null;
  ITALIC?: boolean | null;
  UNDERLINE?: boolean | null;
  STRIKE_OUT?: boolean | null;
  RAD_ID?: number | null;
  BENAMNING?: string | null;
  BELOPP_FONT_NAMN?: string | null;
  BELOPP_STORLEK?: number | null;
  BELOPP_BOLD?: boolean | null;
  BELOPP_ITALIC?: boolean | null;
  BELOPP_UNDERLINE?: boolean | null;
  BELOPP_STRIKE_OUT?: boolean | null;
  SKRIV_UT_NOLLBELOPP?: boolean | null;
  SKRIV_EJ_FALT?: string | null;
  SKRIV_EJ_RAD?: boolean | null;
  RAD_NOT?: string | null;
  SUMMERING?: string | null;
  DELSUMMA?: string | null;
  SM_KONTROLLERA_KONTODELAR?: string | null;
  _Associations?: TEDInputEKDimensionsradUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av ekonomirapport
 */
export interface TEDInputEKEkonomirapportAddAssociationValues {
  Rapportmall_Ref?: string | null;
  Rapportmall_Values?: TEDInputEKRapportMallAddValues | null;
  Sidhuvud_Ref?: string | null;
  Sidhuvud_Values?: TEDInputEKRapportHuvudAddValues | null;
  Kategori_Ref?: string | null;
  Kategori_Values?: TEDInputEKRapportkategoriAddValues | null;
  Dimensioner_Add_Values?: TEDInputEKRapportDimensionAddValues[] | null;
  Rapportfalt_Add_Values?: TEDInputEKRapportFaltAddValues[] | null;
  Urval_Add_Values?: TEDInputEKRapportUrvalAddValues[] | null;
  Utdelade_Add_Values?: TEDInputEKUtdeladRapportAddValues[] | null;
  AnvandsFor_Add_Values?: TEDInputEKRappAnvForAddValues[] | null;
}

/**
 * Värden vid tillägg av ekonomirapport
 */
export interface TEDInputEKEkonomirapportAddValues {
  BENAMNING?: string | null;
  KPLAN_ID?: number | null;
  SORTBEGREPP?: string | null;
  BELOPP_UTSKRIFT?: TEDEKEkonomirapportBELOPP_UTSKRIFTEnum | null;
  BELOPP_BOLD_ENL_RAD?: boolean | null;
  BELOPP_FONT_NAMN?: string | null;
  BELOPP_STORLEK?: number | null;
  BELOPP_BOLD?: boolean | null;
  BELOPP_ITALIC?: boolean | null;
  BELOPP_UNDERLINE?: boolean | null;
  BELOPP_STRIKE_OUT?: boolean | null;
  FORMAT?: string | null;
  BELOPP_SEPARATOR: TEDEKEkonomirapportBELOPP_SEPARATOREnum;
  RUBRIK?: string | null;
  KONTOSTRANG_DETALJRAD?: string | null;
  SKAPAD_DATUM?: any | null;
  ANDRAD_DATUM?: any | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  UTDELAD_TILL_ALLA?: TEDEKEkonomirapportUTDELAD_TILL_ALLAEnum | null;
  DOLJ_NOLLRADER?: string | null;
  SKRIV_NOT?: boolean | null;
  STD_RAPPORT?: TEDEKEkonomirapportSTD_RAPPORTEnum | null;
  LOPSALDO_DETALJRAD?: string | null;
  KONTOANALYS?: TEDEKEkonomirapportKONTOANALYSEnum | null;
  DOLJ_TOTALSUMMA?: string | null;
  BESKRIVNING?: string | null;
  KPLAN_KONV_ID?: number | null;
  JMFR_OVER_KONTOPLAN?: boolean | null;
  IDKOD?: string | null;
  ANVANDS_I?: TEDEKEkonomirapportANVANDS_IEnum | null;
  ANVANDS_FOR?: TEDEKEkonomirapportANVANDS_FOREnum | null;
  EGEN_ANALYS?: boolean | null;
  EGEN_ANALYS_USER_ID?: number | null;
  TILLGANGLIG_EK_ANALYS?: boolean | null;
  USER_DEFAULT_EK_ANALYS?: boolean | null;
  USER_START_EK_ANALYS?: boolean | null;
  EJ_RELEVANT_EK_ANALYS?: boolean | null;
  OBLIGATORISK_GAS?: string | null;
  OBLIGATORISK_EJ_GAS?: boolean | null;
  AI_PROMPT?: string | null;
  DETALJANALYS?: boolean | null;
  _Associations?: TEDInputEKEkonomirapportAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av ekonomirapport
 */
export interface TEDInputEKEkonomirapportUpdateAssociationValues {
  Rapportmall_Ref?: string | null;
  Rapportmall_Values?: TEDInputEKRapportMallUpdateValues | null;
  Sidhuvud_Ref?: string | null;
  Sidhuvud_Values?: TEDInputEKRapportHuvudUpdateValues | null;
  Kategori_Ref?: string | null;
  Kategori_Values?: TEDInputEKRapportkategoriUpdateValues | null;
  Dimensioner_Add_Values?: TEDInputEKRapportDimensionAddValues[] | null;
  Dimensioner_Update_Values?: TEDInputEKRapportDimensionUpdateValues[] | null;
  Dimensioner_Delete_Values?: TEDInputEKRapportDimensionDeleteValues[] | null;
  Rapportfalt_Add_Values?: TEDInputEKRapportFaltAddValues[] | null;
  Rapportfalt_Update_Values?: TEDInputEKRapportFaltUpdateValues[] | null;
  Rapportfalt_Delete_Values?: TEDInputEKRapportFaltDeleteValues[] | null;
  Urval_Add_Values?: TEDInputEKRapportUrvalAddValues[] | null;
  Urval_Update_Values?: TEDInputEKRapportUrvalUpdateValues[] | null;
  Urval_Delete_Values?: TEDInputEKRapportUrvalDeleteValues[] | null;
  Utdelade_Add_Values?: TEDInputEKUtdeladRapportAddValues[] | null;
  Utdelade_Update_Values?: TEDInputEKUtdeladRapportUpdateValues[] | null;
  Utdelade_Delete_Values?: TEDInputEKUtdeladRapportDeleteValues[] | null;
  AnvandsFor_Add_Values?: TEDInputEKRappAnvForAddValues[] | null;
  AnvandsFor_Update_Values?: TEDInputEKRappAnvForUpdateValues[] | null;
  AnvandsFor_Delete_Values?: TEDInputEKRappAnvForDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av ekonomirapport
 */
export interface TEDInputEKEkonomirapportUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  KPLAN_ID?: number | null;
  SORTBEGREPP?: string | null;
  BELOPP_UTSKRIFT?: TEDEKEkonomirapportBELOPP_UTSKRIFTEnum | null;
  BELOPP_BOLD_ENL_RAD?: boolean | null;
  BELOPP_FONT_NAMN?: string | null;
  BELOPP_STORLEK?: number | null;
  BELOPP_BOLD?: boolean | null;
  BELOPP_ITALIC?: boolean | null;
  BELOPP_UNDERLINE?: boolean | null;
  BELOPP_STRIKE_OUT?: boolean | null;
  FORMAT?: string | null;
  BELOPP_SEPARATOR?: TEDEKEkonomirapportBELOPP_SEPARATOREnum | null;
  RUBRIK?: string | null;
  KONTOSTRANG_DETALJRAD?: string | null;
  SKAPAD_DATUM?: any | null;
  ANDRAD_DATUM?: any | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  UTDELAD_TILL_ALLA?: TEDEKEkonomirapportUTDELAD_TILL_ALLAEnum | null;
  DOLJ_NOLLRADER?: string | null;
  SKRIV_NOT?: boolean | null;
  STD_RAPPORT?: TEDEKEkonomirapportSTD_RAPPORTEnum | null;
  LOPSALDO_DETALJRAD?: string | null;
  KONTOANALYS?: TEDEKEkonomirapportKONTOANALYSEnum | null;
  DOLJ_TOTALSUMMA?: string | null;
  BESKRIVNING?: string | null;
  KPLAN_KONV_ID?: number | null;
  JMFR_OVER_KONTOPLAN?: boolean | null;
  IDKOD?: string | null;
  ANVANDS_I?: TEDEKEkonomirapportANVANDS_IEnum | null;
  ANVANDS_FOR?: TEDEKEkonomirapportANVANDS_FOREnum | null;
  EGEN_ANALYS?: boolean | null;
  EGEN_ANALYS_USER_ID?: number | null;
  TILLGANGLIG_EK_ANALYS?: boolean | null;
  USER_DEFAULT_EK_ANALYS?: boolean | null;
  USER_START_EK_ANALYS?: boolean | null;
  EJ_RELEVANT_EK_ANALYS?: boolean | null;
  OBLIGATORISK_GAS?: string | null;
  OBLIGATORISK_EJ_GAS?: boolean | null;
  AI_PROMPT?: string | null;
  DETALJANALYS?: boolean | null;
  _Associations?: TEDInputEKEkonomirapportUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av fakturahändelse (Kund o Leverantör)
 */
export interface TEDInputEKFakturahandelseAddAssociationValues {
  Faktura_Ref?: string | null;
  Faktura_Values?: TEDInputKRFakturaAddValues | null;
  Kund_Ref?: string | null;
  Kund_Values?: TEDInputKRKundAddValues | null;
  Bokfgrupp_Ref?: string | null;
  Bokfgrupp_Values?: TEDInputSYSGruppAddValues | null;
  Leverantor_Ref?: string | null;
  Leverantor_Values?: TEDInputLRLeverantorAddValues | null;
  Levfaktura_Ref?: string | null;
  Levfaktura_Values?: TEDInputLRLeverantorfakturaAddValues | null;
  Kravtext_Ref?: string | null;
  Kravtext_Values?: TEDInputSYSKravTextAddValues | null;
  Kravomgang_Ref?: string | null;
  Kravomgang_Values?: TEDInputKRKravOmgangAddValues | null;
  Valuta_Ref?: string | null;
  Valuta_Values?: TEDInputSYSValutaAddValues | null;
  Bokfverifikationer_Ref?: string | null;
  Bokfverifikationer_Values?: TEDInputEKBokfverAddValues | null;
  Inbetalningssatt_Ref?: string | null;
  Inbetalningssatt_Values?: TEDInputSYSBetalningssattAddValues | null;
  FindVer_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av fakturahändelse (Kund o Leverantör)
 */
export interface TEDInputEKFakturahandelseAddValues {
  _typ: TEDEKFakturahandelseTypEnum;
  DATUM: any;
  TID: any;
  REG_ANV_ID?: number | null;
  RESKONTRA_KONTO: TEDEKFakturahandelseRESKONTRA_KONTOEnum;
  ANTECKNING?: string | null;
  BELOPP?: any | null;
  MOMS_BELOPP?: any | null;
  FORFALLO_DATUM?: any | null;
  BELOPP_I_VALUTA?: any | null;
  MOMS_I_VALUTA?: any | null;
  RUBRIK?: string | null;
  JUST_BOKF_GRUPP_ID?: number | null;
  JUST_HANDELSE_ID?: number | null;
  RANTA_FROM_DATUM?: any | null;
  RANTA_TOM_DATUM?: any | null;
  AVTAL_FR?: any | null;
  AVTAL_TI?: any | null;
  AVTAL_BELOPP?: any | null;
  AVTAL_UPPLAGGNINGS_DATUM?: any | null;
  AVTAL_AVRAKNAT_TOM?: any | null;
  AVTAL_UPPR_RANTESATS?: number | null;
  AVTAL_UPPR_AR?: any | null;
  KRAV_EXTERNPRINT?: boolean | null;
  KRAV_STATUS?: TEDEKFakturahandelseKRAV_STATUSEnum | null;
  KRAV_FELTEXT?: string | null;
  KRAV_SKICKAD_MED_POSTTYP?: TEDEKFakturahandelseKRAV_SKICKAD_MED_POSTTYPEnum | null;
  _Associations: TEDInputEKFakturahandelseAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av fakturahändelse (Kund o Leverantör)
 */
export interface TEDInputEKFakturahandelseDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av fakturahändelse (Kund o Leverantör)
 */
export interface TEDInputEKFakturahandelseUpdateAssociationValues {
  Faktura_Ref?: string | null;
  Faktura_Values?: TEDInputKRFakturaUpdateValues | null;
  Kund_Ref?: string | null;
  Kund_Values?: TEDInputKRKundUpdateValues | null;
  Bokfgrupp_Ref?: string | null;
  Bokfgrupp_Values?: TEDInputSYSGruppUpdateValues | null;
  Leverantor_Ref?: string | null;
  Leverantor_Values?: TEDInputLRLeverantorUpdateValues | null;
  Levfaktura_Ref?: string | null;
  Levfaktura_Values?: TEDInputLRLeverantorfakturaUpdateValues | null;
  Kravtext_Ref?: string | null;
  Kravtext_Values?: TEDInputSYSKravTextUpdateValues | null;
  Kravomgang_Ref?: string | null;
  Kravomgang_Values?: TEDInputKRKravOmgangUpdateValues | null;
  Valuta_Ref?: string | null;
  Valuta_Values?: TEDInputSYSValutaUpdateValues | null;
  Bokfverifikationer_Ref?: string | null;
  Bokfverifikationer_Values?: TEDInputEKBokfverUpdateValues | null;
  Inbetalningssatt_Ref?: string | null;
  Inbetalningssatt_Values?: TEDInputSYSBetalningssattUpdateValues | null;
  FindVer_Add_Refs?: string[] | null;
  FindVer_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av fakturahändelse (Kund o Leverantör)
 */
export interface TEDInputEKFakturahandelseUpdateValues {
  id: string;
  _version: number;
  DATUM?: any | null;
  TID?: any | null;
  REG_ANV_ID?: number | null;
  RESKONTRA_KONTO?: TEDEKFakturahandelseRESKONTRA_KONTOEnum | null;
  ANTECKNING?: string | null;
  BELOPP?: any | null;
  MOMS_BELOPP?: any | null;
  FORFALLO_DATUM?: any | null;
  BELOPP_I_VALUTA?: any | null;
  MOMS_I_VALUTA?: any | null;
  RUBRIK?: string | null;
  JUST_BOKF_GRUPP_ID?: number | null;
  JUST_HANDELSE_ID?: number | null;
  RANTA_FROM_DATUM?: any | null;
  RANTA_TOM_DATUM?: any | null;
  AVTAL_FR?: any | null;
  AVTAL_TI?: any | null;
  AVTAL_BELOPP?: any | null;
  AVTAL_UPPLAGGNINGS_DATUM?: any | null;
  AVTAL_AVRAKNAT_TOM?: any | null;
  AVTAL_UPPR_RANTESATS?: number | null;
  AVTAL_UPPR_AR?: any | null;
  KRAV_EXTERNPRINT?: boolean | null;
  KRAV_STATUS?: TEDEKFakturahandelseKRAV_STATUSEnum | null;
  KRAV_FELTEXT?: string | null;
  KRAV_SKICKAD_MED_POSTTYP?: TEDEKFakturahandelseKRAV_SKICKAD_MED_POSTTYPEnum | null;
  _Associations?: TEDInputEKFakturahandelseUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av ekonomirapport, Radnivå
 */
export interface TEDInputEKGrupperingAddValues {
  ORDNINGS_NR?: number | null;
  ORDNINGS_NR_KONTODEL?: number | null;
  STARTPOS?: number | null;
  SLUTPOS?: number | null;
  DOLJ_NIVA?: boolean | null;
  SIDBRYTNING?: boolean | null;
  BENAMNING_BLANK?: string | null;
  BENAMNING_ANTAL_POS?: number | null;
  BENAMNING_FLERA_RADER?: boolean | null;
  GRUPPERINGSTYP?: TEDEKGrupperingGRUPPERINGSTYPEnum | null;
  FONT_NAMN?: string | null;
  STORLEK?: number | null;
  BOLD?: string | null;
  ITALIC?: string | null;
  UNDERLINE?: string | null;
  STRIKE_OUT?: string | null;
  DIVERSE?: string | null;
  DELSUMMA?: boolean | null;
  SKRIV_DELSUMMA?: boolean | null;
  DELSUMMA_FORMAT?: string | null;
  DELSUMMA_FONT_NAMN?: string | null;
  DELSUMMA_STORLEK?: number | null;
  DELSUMMA_BOLD?: string | null;
  DELSUMMA_ITALIC?: string | null;
  DELSUMMA_UNDERLINE?: string | null;
  DELSUMMA_STRIKE_OUT?: string | null;
  SKRIV_EJ_FALT?: string | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av ekonomirapport, Radnivå
 */
export interface TEDInputEKGrupperingDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av ekonomirapport, Radnivå
 */
export interface TEDInputEKGrupperingUpdateValues {
  id: string;
  _version: number;
  ORDNINGS_NR?: number | null;
  ORDNINGS_NR_KONTODEL?: number | null;
  STARTPOS?: number | null;
  SLUTPOS?: number | null;
  DOLJ_NIVA?: boolean | null;
  SIDBRYTNING?: boolean | null;
  BENAMNING_BLANK?: string | null;
  BENAMNING_ANTAL_POS?: number | null;
  BENAMNING_FLERA_RADER?: boolean | null;
  GRUPPERINGSTYP?: TEDEKGrupperingGRUPPERINGSTYPEnum | null;
  FONT_NAMN?: string | null;
  STORLEK?: number | null;
  BOLD?: string | null;
  ITALIC?: string | null;
  UNDERLINE?: string | null;
  STRIKE_OUT?: string | null;
  DIVERSE?: string | null;
  DELSUMMA?: boolean | null;
  SKRIV_DELSUMMA?: boolean | null;
  DELSUMMA_FORMAT?: string | null;
  DELSUMMA_FONT_NAMN?: string | null;
  DELSUMMA_STORLEK?: number | null;
  DELSUMMA_BOLD?: string | null;
  DELSUMMA_ITALIC?: string | null;
  DELSUMMA_UNDERLINE?: string | null;
  DELSUMMA_STRIKE_OUT?: string | null;
  SKRIV_EJ_FALT?: string | null;
}

/**
 * Associerade värden vid tillägg av huvudprojekt
 */
export interface TEDInputEKHuvudprojektAddAssociationValues {
  Delprojekt_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av huvudprojekt
 */
export interface TEDInputEKHuvudprojektAddValues {
  KOD?: string | null;
  BENAMNING?: string | null;
  FRAN_DATUM?: any | null;
  TILL_DATUM?: any | null;
  _Associations?: TEDInputEKHuvudprojektAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av huvudprojekt
 */
export interface TEDInputEKHuvudprojektDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av huvudprojekt
 */
export interface TEDInputEKHuvudprojektUpdateAssociationValues {
  Delprojekt_Add_Refs?: string[] | null;
  Delprojekt_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av huvudprojekt
 */
export interface TEDInputEKHuvudprojektUpdateValues {
  id: string;
  _version: number;
  KOD?: string | null;
  BENAMNING?: string | null;
  FRAN_DATUM?: any | null;
  TILL_DATUM?: any | null;
  _Associations?: TEDInputEKHuvudprojektUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av kollekttillfälle, bankkontorad
 */
export interface TEDInputEKKOBKollektFilBankkontoradAddValues {
  GILTIGFRAN?: string | null;
  CLEARINGNUMMER?: string | null;
  BANKNAMN?: string | null;
  KONTONUMMER?: string | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kollekttillfälle, bankkontorad
 */
export interface TEDInputEKKOBKollektFilBankkontoradDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av kollekttillfälle, bankkontorad
 */
export interface TEDInputEKKOBKollektFilBankkontoradUpdateValues {
  id: string;
  _version: number;
  GILTIGFRAN?: string | null;
  CLEARINGNUMMER?: string | null;
  BANKNAMN?: string | null;
  KONTONUMMER?: string | null;
}

/**
 * Associerade värden vid tillägg av kollekttillfälle, mottagare
 */
export interface TEDInputEKKOBKollektFilMottagareAddAssociationValues {
  Bankkonto_Add_Values?: TEDInputEKKOBKollektFilBankkontoradAddValues[] | null;
}

/**
 * Värden vid tillägg av kollekttillfälle, mottagare
 */
export interface TEDInputEKKOBKollektFilMottagareAddValues {
  NAMN?: string | null;
  ORGNR?: string | null;
  BANKGIRO?: string | null;
  PLUSGIRO?: string | null;
  UTLANDSKONTAKT?: string | null;
  BIC?: string | null;
  IBAN?: string | null;
  BANKNAMN?: string | null;
  BANKADRESS?: string | null;
  PROCENTFORDELNING?: string | null;
  _Associations?: TEDInputEKKOBKollektFilMottagareAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kollekttillfälle, mottagare
 */
export interface TEDInputEKKOBKollektFilMottagareDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kollekttillfälle, mottagare
 */
export interface TEDInputEKKOBKollektFilMottagareUpdateAssociationValues {
  Bankkonto_Add_Values?: TEDInputEKKOBKollektFilBankkontoradAddValues[] | null;
  Bankkonto_Update_Values?: TEDInputEKKOBKollektFilBankkontoradUpdateValues[] | null;
  Bankkonto_Delete_Values?: TEDInputEKKOBKollektFilBankkontoradDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av kollekttillfälle, mottagare
 */
export interface TEDInputEKKOBKollektFilMottagareUpdateValues {
  id: string;
  _version: number;
  NAMN?: string | null;
  ORGNR?: string | null;
  BANKGIRO?: string | null;
  PLUSGIRO?: string | null;
  UTLANDSKONTAKT?: string | null;
  BIC?: string | null;
  IBAN?: string | null;
  BANKNAMN?: string | null;
  BANKADRESS?: string | null;
  PROCENTFORDELNING?: string | null;
  _Associations?: TEDInputEKKOBKollektFilMottagareUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kollektfilrad
 */
export interface TEDInputEKKOBKollektFilRadAddAssociationValues {
  Tillfalle_Ref?: string | null;
  Tillfalle_Values?: TEDInputEKKOBKollektFilTillfalleAddValues | null;
}

/**
 * Värden vid tillägg av kollektfilrad
 */
export interface TEDInputEKKOBKollektFilRadAddValues {
  BELOPP?: any | null;
  FORSAMLING?: string | null;
  KOLLEKTSTALLE?: string | null;
  KOLLEKT_NR?: string | null;
  INBETALNINGSSATT?: TEDEKKOBKollektFilRadINBETALNINGSSATTEnum | null;
  INBETALNING_KONTONUMMER?: string | null;
  GUID?: string | null;
  TRANSAKTIONS_TYP: TEDEKKOBKollektFilRadTRANSAKTIONS_TYPEnum;
  _Associations?: TEDInputEKKOBKollektFilRadAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kollektfilrad
 */
export interface TEDInputEKKOBKollektFilRadDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kollektfilrad
 */
export interface TEDInputEKKOBKollektFilRadUpdateAssociationValues {
  Tillfalle_Ref?: string | null;
  Tillfalle_Values?: TEDInputEKKOBKollektFilTillfalleUpdateValues | null;
}

/**
 * Nya värden vid ändring av kollektfilrad
 */
export interface TEDInputEKKOBKollektFilRadUpdateValues {
  id: string;
  _version: number;
  BELOPP?: any | null;
  FORSAMLING?: string | null;
  KOLLEKTSTALLE?: string | null;
  KOLLEKT_NR?: string | null;
  INBETALNINGSSATT?: TEDEKKOBKollektFilRadINBETALNINGSSATTEnum | null;
  INBETALNING_KONTONUMMER?: string | null;
  GUID?: string | null;
  TRANSAKTIONS_TYP?: TEDEKKOBKollektFilRadTRANSAKTIONS_TYPEnum | null;
  _Associations?: TEDInputEKKOBKollektFilRadUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kollektfilstillfälle
 */
export interface TEDInputEKKOBKollektFilTillfalleAddAssociationValues {
  Belopprader_Add_Values?: TEDInputEKKOBKollektFilRadAddValues[] | null;
  Mottagare_Add_Values?: TEDInputEKKOBKollektFilMottagareAddValues[] | null;
}

/**
 * Värden vid tillägg av kollektfilstillfälle
 */
export interface TEDInputEKKOBKollektFilTillfalleAddValues {
  TILLFALLE_DATUM?: any | null;
  BOKF_DATUM?: any | null;
  TRANSAKTIONS_TYP?: TEDEKKOBKollektFilTillfalleTRANSAKTIONS_TYPEnum | null;
  KOLLEKT_TYP?: string | null;
  KOLLEKT_TYP_KOD?: TEDEKKOBKollektFilTillfalleKOLLEKT_TYP_KODEnum | null;
  KOLLEKT_ANDAMAL?: string | null;
  INSAMLING_TYP?: string | null;
  INSAMLING_TYP_KOD?: TEDEKKOBKollektFilTillfalleINSAMLING_TYP_KODEnum | null;
  MOTTAGAR_TYP?: string | null;
  MOTTAGAR_TYP_KOD?: TEDEKKOBKollektFilTillfalleMOTTAGAR_TYP_KODEnum | null;
  AKTIVITET_TYP?: string | null;
  GUID?: string | null;
  MOTTAGARE?: string | null;
  AVSANDARE?: string | null;
  INSAMLING_BELOPP?: any | null;
  INBETALNINGSSATT?: TEDEKKOBKollektFilTillfalleINBETALNINGSSATTEnum | null;
  INBETALNING_KONTONUMMER?: string | null;
  KOMMUNIKATIONSFIL_ID?: number | null;
  ORGNR?: string | null;
  ENHETSID?: number | null;
  ENHETSNAMN?: string | null;
  FILNAMN?: string | null;
  INLAST_DATUM?: any | null;
  INLAST_SIGNATUR?: string | null;
  STATUS: TEDEKKOBKollektFilTillfalleSTATUSEnum;
  STATUS_DATUM?: any | null;
  FELMEDDELANDE?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  TYP?: TEDEKKOBKollektFilTillfalleTYPEnum | null;
  ORONMARKNING?: string | null;
  _Associations?: TEDInputEKKOBKollektFilTillfalleAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av kollektfilstillfälle
 */
export interface TEDInputEKKOBKollektFilTillfalleUpdateAssociationValues {
  Belopprader_Add_Values?: TEDInputEKKOBKollektFilRadAddValues[] | null;
  Belopprader_Update_Values?: TEDInputEKKOBKollektFilRadUpdateValues[] | null;
  Belopprader_Delete_Values?: TEDInputEKKOBKollektFilRadDeleteValues[] | null;
  Mottagare_Add_Values?: TEDInputEKKOBKollektFilMottagareAddValues[] | null;
  Mottagare_Update_Values?: TEDInputEKKOBKollektFilMottagareUpdateValues[] | null;
  Mottagare_Delete_Values?: TEDInputEKKOBKollektFilMottagareDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av kollektfilstillfälle
 */
export interface TEDInputEKKOBKollektFilTillfalleUpdateValues {
  id: string;
  _version: number;
  TILLFALLE_DATUM?: any | null;
  BOKF_DATUM?: any | null;
  TRANSAKTIONS_TYP?: TEDEKKOBKollektFilTillfalleTRANSAKTIONS_TYPEnum | null;
  KOLLEKT_TYP?: string | null;
  KOLLEKT_TYP_KOD?: TEDEKKOBKollektFilTillfalleKOLLEKT_TYP_KODEnum | null;
  KOLLEKT_ANDAMAL?: string | null;
  INSAMLING_TYP?: string | null;
  INSAMLING_TYP_KOD?: TEDEKKOBKollektFilTillfalleINSAMLING_TYP_KODEnum | null;
  MOTTAGAR_TYP?: string | null;
  MOTTAGAR_TYP_KOD?: TEDEKKOBKollektFilTillfalleMOTTAGAR_TYP_KODEnum | null;
  AKTIVITET_TYP?: string | null;
  GUID?: string | null;
  MOTTAGARE?: string | null;
  AVSANDARE?: string | null;
  INSAMLING_BELOPP?: any | null;
  INBETALNINGSSATT?: TEDEKKOBKollektFilTillfalleINBETALNINGSSATTEnum | null;
  INBETALNING_KONTONUMMER?: string | null;
  KOMMUNIKATIONSFIL_ID?: number | null;
  ORGNR?: string | null;
  ENHETSID?: number | null;
  ENHETSNAMN?: string | null;
  FILNAMN?: string | null;
  INLAST_DATUM?: any | null;
  INLAST_SIGNATUR?: string | null;
  STATUS?: TEDEKKOBKollektFilTillfalleSTATUSEnum | null;
  STATUS_DATUM?: any | null;
  FELMEDDELANDE?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  TYP?: TEDEKKOBKollektFilTillfalleTYPEnum | null;
  ORONMARKNING?: string | null;
  _Associations?: TEDInputEKKOBKollektFilTillfalleUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av konteringsbegrepp
 */
export interface TEDInputEKKonteringsBegreppAddAssociationValues {
  Konteringsvarde_Add_Values?: TEDInputEKKonteringsvardeAddValues[] | null;
}

/**
 * Värden vid tillägg av konteringsbegrepp
 */
export interface TEDInputEKKonteringsBegreppAddValues {
  MALL_TYP?: string | null;
  BENAMNING?: string | null;
  BESKRIVNING?: string | null;
  DELSYSTEM_1?: string | null;
  KLASS_NAMN_1?: string | null;
  ATTRIBUT_1_1?: string | null;
  ATTRIBUT_1_2?: string | null;
  ATTRIBUT_1_3?: string | null;
  ATTRIBUT_1_4?: string | null;
  ATTRIBUT_1_5?: string | null;
  ID_ATTRIBUT_1?: string | null;
  DEL_AV_ATTRIBUT_1?: string | null;
  STARTPOSITION_1?: number | null;
  SLUTPOSITION_1?: number | null;
  DELSYSTEM_2?: string | null;
  KLASS_NAMN_2?: string | null;
  ATTRIBUT_2_1?: string | null;
  ATTRIBUT_2_2?: string | null;
  ATTRIBUT_2_3?: string | null;
  ATTRIBUT_2_4?: string | null;
  ATTRIBUT_2_5?: string | null;
  ID_ATTRIBUT_2?: string | null;
  DEL_AV_ATTRIBUT_2?: string | null;
  STARTPOSITION_2?: number | null;
  SLUTPOSITION_2?: number | null;
  DELSYSTEM_3?: string | null;
  KLASS_NAMN_3?: string | null;
  ATTRIBUT_3_1?: string | null;
  ATTRIBUT_3_2?: string | null;
  ATTRIBUT_3_3?: string | null;
  ATTRIBUT_3_4?: string | null;
  ATTRIBUT_3_5?: string | null;
  ID_ATTRIBUT_3?: string | null;
  DEL_AV_ATTRIBUT_3?: string | null;
  STARTPOSITION_3?: number | null;
  SLUTPOSITION_3?: number | null;
  PRIORITET?: number | null;
  ANVANDS?: string | null;
  GILTIG_TOM?: any | null;
  _Associations?: TEDInputEKKonteringsBegreppAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av konteringsbegrepp
 */
export interface TEDInputEKKonteringsBegreppUpdateAssociationValues {
  Konteringsvarde_Add_Values?: TEDInputEKKonteringsvardeAddValues[] | null;
  Konteringsvarde_Update_Values?: TEDInputEKKonteringsvardeUpdateValues[] | null;
  Konteringsvarde_Delete_Values?: TEDInputEKKonteringsvardeDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av konteringsbegrepp
 */
export interface TEDInputEKKonteringsBegreppUpdateValues {
  id: string;
  _version: number;
  MALL_TYP?: string | null;
  BENAMNING?: string | null;
  BESKRIVNING?: string | null;
  DELSYSTEM_1?: string | null;
  KLASS_NAMN_1?: string | null;
  ATTRIBUT_1_1?: string | null;
  ATTRIBUT_1_2?: string | null;
  ATTRIBUT_1_3?: string | null;
  ATTRIBUT_1_4?: string | null;
  ATTRIBUT_1_5?: string | null;
  ID_ATTRIBUT_1?: string | null;
  DEL_AV_ATTRIBUT_1?: string | null;
  STARTPOSITION_1?: number | null;
  SLUTPOSITION_1?: number | null;
  DELSYSTEM_2?: string | null;
  KLASS_NAMN_2?: string | null;
  ATTRIBUT_2_1?: string | null;
  ATTRIBUT_2_2?: string | null;
  ATTRIBUT_2_3?: string | null;
  ATTRIBUT_2_4?: string | null;
  ATTRIBUT_2_5?: string | null;
  ID_ATTRIBUT_2?: string | null;
  DEL_AV_ATTRIBUT_2?: string | null;
  STARTPOSITION_2?: number | null;
  SLUTPOSITION_2?: number | null;
  DELSYSTEM_3?: string | null;
  KLASS_NAMN_3?: string | null;
  ATTRIBUT_3_1?: string | null;
  ATTRIBUT_3_2?: string | null;
  ATTRIBUT_3_3?: string | null;
  ATTRIBUT_3_4?: string | null;
  ATTRIBUT_3_5?: string | null;
  ID_ATTRIBUT_3?: string | null;
  DEL_AV_ATTRIBUT_3?: string | null;
  STARTPOSITION_3?: number | null;
  SLUTPOSITION_3?: number | null;
  PRIORITET?: number | null;
  ANVANDS?: string | null;
  GILTIG_TOM?: any | null;
  _Associations?: TEDInputEKKonteringsBegreppUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av konteringsvärde
 */
export interface TEDInputEKKonteringsvardeAddAssociationValues {
  Konteringsbegrepp_Ref?: string | null;
  Konteringsbegrepp_Values?: TEDInputEKKonteringsBegreppAddValues | null;
  Kontodel1_Ref?: string | null;
  Kontodel1_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel2_Ref?: string | null;
  Kontodel2_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel3_Ref?: string | null;
  Kontodel3_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel4_Ref?: string | null;
  Kontodel4_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel5_Ref?: string | null;
  Kontodel5_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel6_Ref?: string | null;
  Kontodel6_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel7_Ref?: string | null;
  Kontodel7_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel8_Ref?: string | null;
  Kontodel8_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel9_Ref?: string | null;
  Kontodel9_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel10_Ref?: string | null;
  Kontodel10_Values?: TEDInputEKKontodelAddValues | null;
  kodplan_Ref?: string | null;
  kodplan_Values?: TEDInputEKKontoplanAddValues | null;
}

/**
 * Värden vid tillägg av konteringsvärde
 */
export interface TEDInputEKKonteringsvardeAddValues {
  VARDE_1_1?: string | null;
  VARDE_1_2?: string | null;
  VARDE_1_3?: string | null;
  VARDE_1_4?: string | null;
  VARDE_1_5?: string | null;
  VARDE_2_1?: string | null;
  VARDE_2_2?: string | null;
  VARDE_2_3?: string | null;
  VARDE_2_4?: string | null;
  VARDE_2_5?: string | null;
  VARDE_3_1?: string | null;
  VARDE_3_2?: string | null;
  VARDE_3_3?: string | null;
  VARDE_3_4?: string | null;
  VARDE_3_5?: string | null;
  PROCENT?: number | null;
  FROM_DATUM?: any | null;
  TOM_DATUM?: any | null;
  _Associations: TEDInputEKKonteringsvardeAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av konteringsvärde
 */
export interface TEDInputEKKonteringsvardeDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av konteringsvärde
 */
export interface TEDInputEKKonteringsvardeUpdateAssociationValues {
  Konteringsbegrepp_Ref?: string | null;
  Konteringsbegrepp_Values?: TEDInputEKKonteringsBegreppUpdateValues | null;
  Kontodel1_Ref?: string | null;
  Kontodel1_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel2_Ref?: string | null;
  Kontodel2_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel3_Ref?: string | null;
  Kontodel3_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel4_Ref?: string | null;
  Kontodel4_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel5_Ref?: string | null;
  Kontodel5_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel6_Ref?: string | null;
  Kontodel6_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel7_Ref?: string | null;
  Kontodel7_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel8_Ref?: string | null;
  Kontodel8_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel9_Ref?: string | null;
  Kontodel9_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel10_Ref?: string | null;
  Kontodel10_Values?: TEDInputEKKontodelUpdateValues | null;
  kodplan_Ref?: string | null;
  kodplan_Values?: TEDInputEKKontoplanUpdateValues | null;
}

/**
 * Nya värden vid ändring av konteringsvärde
 */
export interface TEDInputEKKonteringsvardeUpdateValues {
  id: string;
  _version: number;
  VARDE_1_1?: string | null;
  VARDE_1_2?: string | null;
  VARDE_1_3?: string | null;
  VARDE_1_4?: string | null;
  VARDE_1_5?: string | null;
  VARDE_2_1?: string | null;
  VARDE_2_2?: string | null;
  VARDE_2_3?: string | null;
  VARDE_2_4?: string | null;
  VARDE_2_5?: string | null;
  VARDE_3_1?: string | null;
  VARDE_3_2?: string | null;
  VARDE_3_3?: string | null;
  VARDE_3_4?: string | null;
  VARDE_3_5?: string | null;
  PROCENT?: number | null;
  FROM_DATUM?: any | null;
  TOM_DATUM?: any | null;
  _Associations?: TEDInputEKKonteringsvardeUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kontoanvändning
 */
export interface TEDInputEKKontoanvandningAddAssociationValues {
  Kontodel_Ref?: string | null;
  Kontodel_Values?: TEDInputEKKontodelAddValues | null;
}

/**
 * Värden vid tillägg av kontoanvändning
 */
export interface TEDInputEKKontoanvandningAddValues {
  _Associations?: TEDInputEKKontoanvandningAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kontoanvändning
 */
export interface TEDInputEKKontoanvandningDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kontoanvändning
 */
export interface TEDInputEKKontoanvandningUpdateAssociationValues {
  Kontodel_Ref?: string | null;
  Kontodel_Values?: TEDInputEKKontodelUpdateValues | null;
}

/**
 * Nya värden vid ändring av kontoanvändning
 */
export interface TEDInputEKKontoanvandningUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputEKKontoanvandningUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kodbegrepp
 */
export interface TEDInputEKKontobegreppAddAssociationValues {
  Kontobegreppdef_Ref?: string | null;
  Kontobegreppdef_Values?: TEDInputEKKontobegreppdefAddValues | null;
  Kombinationer_Add_Values?: TEDInputEKKontobegreppkombinationAddValues[] | null;
}

/**
 * Värden vid tillägg av kodbegrepp
 */
export interface TEDInputEKKontobegreppAddValues {
  BENAMNING: string;
  DEF_REDOVISNTYP?: TEDEKKontobegreppDEF_REDOVISNTYPEnum | null;
  DEF_KONTOTYP?: string | null;
  DEF_KI_TYP?: TEDEKKontobegreppDEF_KI_TYPEnum | null;
  DEF_MOMS_ID?: number | null;
  _Associations?: TEDInputEKKontobegreppAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kodbegrepp
 */
export interface TEDInputEKKontobegreppDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kodbegrepp
 */
export interface TEDInputEKKontobegreppUpdateAssociationValues {
  Kontobegreppdef_Ref?: string | null;
  Kontobegreppdef_Values?: TEDInputEKKontobegreppdefUpdateValues | null;
  Kombinationer_Add_Values?: TEDInputEKKontobegreppkombinationAddValues[] | null;
  Kombinationer_Update_Values?: TEDInputEKKontobegreppkombinationUpdateValues[] | null;
  Kombinationer_Delete_Values?: TEDInputEKKontobegreppkombinationDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av kodbegrepp
 */
export interface TEDInputEKKontobegreppUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  DEF_REDOVISNTYP?: TEDEKKontobegreppDEF_REDOVISNTYPEnum | null;
  DEF_KONTOTYP?: string | null;
  DEF_KI_TYP?: TEDEKKontobegreppDEF_KI_TYPEnum | null;
  DEF_MOMS_ID?: number | null;
  _Associations?: TEDInputEKKontobegreppUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kontobegreppsdefinition
 */
export interface TEDInputEKKontobegreppdefAddAssociationValues {
  Kontodeldef_Ref?: string | null;
  Kontodeldef_Values?: TEDInputEKKontodeldefAddValues | null;
  Kontoplan_Ref?: string | null;
  Kontoplan_Values?: TEDInputEKKontoplanAddValues | null;
  Kontobegrepp_Add_Values?: TEDInputEKKontobegreppAddValues[] | null;
}

/**
 * Värden vid tillägg av kontobegreppsdefinition
 */
export interface TEDInputEKKontobegreppdefAddValues {
  NAMN?: string | null;
  _Associations?: TEDInputEKKontobegreppdefAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kontobegreppsdefinition
 */
export interface TEDInputEKKontobegreppdefDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kontobegreppsdefinition
 */
export interface TEDInputEKKontobegreppdefUpdateAssociationValues {
  Kontodeldef_Ref?: string | null;
  Kontodeldef_Values?: TEDInputEKKontodeldefUpdateValues | null;
  Kontoplan_Ref?: string | null;
  Kontoplan_Values?: TEDInputEKKontoplanUpdateValues | null;
  Kontobegrepp_Add_Values?: TEDInputEKKontobegreppAddValues[] | null;
  Kontobegrepp_Update_Values?: TEDInputEKKontobegreppUpdateValues[] | null;
  Kontobegrepp_Delete_Values?: TEDInputEKKontobegreppDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av kontobegreppsdefinition
 */
export interface TEDInputEKKontobegreppdefUpdateValues {
  id: string;
  _version: number;
  NAMN?: string | null;
  _Associations?: TEDInputEKKontobegreppdefUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kodbegreppkombination
 */
export interface TEDInputEKKontobegreppkombinationAddAssociationValues {
  Kontobegrepp_Ref?: string | null;
  Kontobegrepp_Values?: TEDInputEKKontobegreppAddValues | null;
}

/**
 * Värden vid tillägg av kodbegreppkombination
 */
export interface TEDInputEKKontobegreppkombinationAddValues {
  KOMBINATION?: TEDEKKontobegreppkombinationKOMBINATIONEnum | null;
  _Associations?: TEDInputEKKontobegreppkombinationAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kodbegreppkombination
 */
export interface TEDInputEKKontobegreppkombinationDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kodbegreppkombination
 */
export interface TEDInputEKKontobegreppkombinationUpdateAssociationValues {
  Kontobegrepp_Ref?: string | null;
  Kontobegrepp_Values?: TEDInputEKKontobegreppUpdateValues | null;
}

/**
 * Nya värden vid ändring av kodbegreppkombination
 */
export interface TEDInputEKKontobegreppkombinationUpdateValues {
  id: string;
  _version: number;
  KOMBINATION?: TEDEKKontobegreppkombinationKOMBINATIONEnum | null;
  _Associations?: TEDInputEKKontobegreppkombinationUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av koddel
 */
export interface TEDInputEKKontodelAddAssociationValues {
  Kontodelsdef_Ref?: string | null;
  Kontodelsdef_Values?: TEDInputEKKontodeldefAddValues | null;
  Momskod_Ref?: string | null;
  Momskod_Values?: TEDInputEKMomskodAddValues | null;
  ProjDebKontodel_Ref?: string | null;
  ProjDebKontodel_Values?: TEDInputEKKonteringsvardeAddValues | null;
  ProjDebProjekt_Ref?: string | null;
  ProjDebProjekt_Values?: TEDInputEKKonteringsvardeAddValues | null;
  ProjKredKontodel_Ref?: string | null;
  ProjKredKontodel_Values?: TEDInputEKKonteringsvardeAddValues | null;
  ProjKredProjekt_Ref?: string | null;
  ProjKredProjekt_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Enhet_Ref?: string | null;
  Enhet_Values?: TEDInputLAEnhetAddValues | null;
  Bokfgrupp_Ref?: string | null;
  Bokfgrupp_Values?: TEDInputSYSGruppAddValues | null;
  Tillaggsinfo_Ref?: string | null;
  Tillaggsinfo_Values?: TEDInputEKTillaggsinfoAddValues | null;
  Fastighet_Ref?: string | null;
  Fastighet_Values?: TEDInputARPlatsAddValues | null;
  Huvudprojekt_Ref?: string | null;
  Huvudprojekt_Values?: TEDInputEKHuvudprojektAddValues | null;
  Konteringsvarde1_Add_Refs?: string[] | null;
  Konteringsvarde2_Add_Refs?: string[] | null;
  Konteringsvarde3_Add_Refs?: string[] | null;
  Konteringsvarde4_Add_Refs?: string[] | null;
  Konteringsvarde5_Add_Refs?: string[] | null;
  Konteringsvarde6_Add_Refs?: string[] | null;
  Konteringsvarde7_Add_Refs?: string[] | null;
  Konteringsvarde8_Add_Refs?: string[] | null;
  Konteringsvarde9_Add_Refs?: string[] | null;
  Konteringsvarde10_Add_Refs?: string[] | null;
  Kontoanvandning_Add_Values?: TEDInputEKKontoanvandningAddValues[] | null;
  Kontering1_Add_Refs?: string[] | null;
  Budgetkontering1_Add_Refs?: string[] | null;
  Ingbalans1_Add_Refs?: string[] | null;
  Konteringskoder_Add_Values?: TEDInputEKTEDEKKonteringskoderAddValues[] | null;
  Kombinationer_Add_Values?: TEDInputEKKontodelkombinationAddValues[] | null;
  Kombinationsvillkor_Add_Values?: TEDInputEKTEDEKKombinationsvillkorAddValues[] | null;
  Recept_Add_Values?: TEDInputEKKontodelReceptAddValues[] | null;
  LokalKontoanvandning_Add_Values?: TEDInputEKLokalKontoanvandningAddValues[] | null;
  Avdragsratt_Add_Values?: TEDInputEKAvdragsrattAddValues[] | null;
}

/**
 * Värden vid tillägg av koddel
 */
export interface TEDInputEKKontodelAddValues {
  KONTODEL?: string | null;
  BENAMNING?: string | null;
  REDOVISN_TYP?: TEDEKKontodelREDOVISN_TYPEnum | null;
  KONTOTYP?: TEDEKKontodelKONTOTYPEnum | null;
  KI_TYP?: TEDEKKontodelKI_TYPEnum | null;
  SRU_KOD?: number | null;
  BUDGETKONTO?: boolean | null;
  FRAN_DATUM?: any | null;
  TILL_DATUM?: any | null;
  INTERN_KONTO?: boolean | null;
  SPARRA_MANUELL?: boolean | null;
  PROJEKTBENAMNING?: string | null;
  PROJEKTANSVARIG?: string | null;
  PROJEKT_SUMMERA_AVSLUT?: boolean | null;
  ANTALSREDOVISNING?: boolean | null;
  STANDARDKONTO?: TEDEKKontodelSTANDARDKONTOEnum | null;
  KB_VERKSOMR?: TEDEKKontodelKB_VERKSOMREnum | null;
  KB_VERKSAMHET?: TEDEKKontodelKB_VERKSAMHETEnum | null;
  KPLANBYTE_RECEPT?: string | null;
  GASBAS_ID?: number | null;
  SPARR_ATTEST?: boolean | null;
  AKTIV?: boolean | null;
  EXP_TILL_LON?: boolean | null;
  EXP_TILL_TID?: boolean | null;
  SENAST_ANDRAD?: any | null;
  EXPORTERA_TILL_FLEX?: string | null;
  VERKS_KAT?: TEDEKKontodelVERKS_KATEnum | null;
  AKTNIVA_INTERVALL?: string | null;
  ERSATT_MED_KONTODEL?: string | null;
  ERSATT_DATUM?: any | null;
  RUBRIKKONTO?: boolean | null;
  LOKAL_EXP_TILL_FLEX?: boolean | null;
  LOKALT_ATGARD_INTERVALL?: string | null;
  ATGARD_KAT?: TEDEKKontodelATGARD_KATEnum | null;
  HUVUDPROJEKT_ID?: number | null;
  UNDANTAG_PERIODISERING?: boolean | null;
  _Associations?: TEDInputEKKontodelAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av koddel
 */
export interface TEDInputEKKontodelDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid tillägg av kontodelrecept
 */
export interface TEDInputEKKontodelReceptAddAssociationValues {
  Receptvarde_Add_Values?: TEDInputEKKontodelReceptvardeAddValues[] | null;
}

/**
 * Värden vid tillägg av kontodelrecept
 */
export interface TEDInputEKKontodelReceptAddValues {
  KPLAN_ID?: number | null;
  ORDNINGS_NR?: number | null;
  KONTO_ID?: number | null;
  ID?: number | null;
  FROM_DATUM?: any | null;
  TOM_DATUM?: any | null;
  _Associations?: TEDInputEKKontodelReceptAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kontodelrecept
 */
export interface TEDInputEKKontodelReceptDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kontodelrecept
 */
export interface TEDInputEKKontodelReceptUpdateAssociationValues {
  Receptvarde_Add_Values?: TEDInputEKKontodelReceptvardeAddValues[] | null;
  Receptvarde_Update_Values?: TEDInputEKKontodelReceptvardeUpdateValues[] | null;
  Receptvarde_Delete_Values?: TEDInputEKKontodelReceptvardeDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av kontodelrecept
 */
export interface TEDInputEKKontodelReceptUpdateValues {
  id: string;
  _version: number;
  KPLAN_ID?: number | null;
  ORDNINGS_NR?: number | null;
  KONTO_ID?: number | null;
  ID?: number | null;
  FROM_DATUM?: any | null;
  TOM_DATUM?: any | null;
  _Associations?: TEDInputEKKontodelReceptUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av receptvärde
 */
export interface TEDInputEKKontodelReceptvardeAddValues {
  KPLAN_ID?: number | null;
  ORDNINGS_NR?: number | null;
  KONTO_ID?: number | null;
  RECEPT_ID?: number | null;
  ID?: number | null;
  VARDE_ORDNINGS_NR?: number | null;
  VARDE_FROM?: string | null;
  VARDE_TOM?: string | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av receptvärde
 */
export interface TEDInputEKKontodelReceptvardeDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av receptvärde
 */
export interface TEDInputEKKontodelReceptvardeUpdateValues {
  id: string;
  _version: number;
  KPLAN_ID?: number | null;
  ORDNINGS_NR?: number | null;
  KONTO_ID?: number | null;
  RECEPT_ID?: number | null;
  ID?: number | null;
  VARDE_ORDNINGS_NR?: number | null;
  VARDE_FROM?: string | null;
  VARDE_TOM?: string | null;
}

/**
 * Associerade värden vid ändring av koddel
 */
export interface TEDInputEKKontodelUpdateAssociationValues {
  Kontodelsdef_Ref?: string | null;
  Kontodelsdef_Values?: TEDInputEKKontodeldefUpdateValues | null;
  Momskod_Ref?: string | null;
  Momskod_Values?: TEDInputEKMomskodUpdateValues | null;
  ProjDebKontodel_Ref?: string | null;
  ProjDebKontodel_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  ProjDebProjekt_Ref?: string | null;
  ProjDebProjekt_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  ProjKredKontodel_Ref?: string | null;
  ProjKredKontodel_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  ProjKredProjekt_Ref?: string | null;
  ProjKredProjekt_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Enhet_Ref?: string | null;
  Enhet_Values?: TEDInputLAEnhetUpdateValues | null;
  Bokfgrupp_Ref?: string | null;
  Bokfgrupp_Values?: TEDInputSYSGruppUpdateValues | null;
  Tillaggsinfo_Ref?: string | null;
  Tillaggsinfo_Values?: TEDInputEKTillaggsinfoUpdateValues | null;
  Fastighet_Ref?: string | null;
  Fastighet_Values?: TEDInputARPlatsUpdateValues | null;
  Huvudprojekt_Ref?: string | null;
  Huvudprojekt_Values?: TEDInputEKHuvudprojektUpdateValues | null;
  Konteringsvarde1_Add_Refs?: string[] | null;
  Konteringsvarde1_Delete_Refs?: string[] | null;
  Konteringsvarde2_Add_Refs?: string[] | null;
  Konteringsvarde2_Delete_Refs?: string[] | null;
  Konteringsvarde3_Add_Refs?: string[] | null;
  Konteringsvarde3_Delete_Refs?: string[] | null;
  Konteringsvarde4_Add_Refs?: string[] | null;
  Konteringsvarde4_Delete_Refs?: string[] | null;
  Konteringsvarde5_Add_Refs?: string[] | null;
  Konteringsvarde5_Delete_Refs?: string[] | null;
  Konteringsvarde6_Add_Refs?: string[] | null;
  Konteringsvarde6_Delete_Refs?: string[] | null;
  Konteringsvarde7_Add_Refs?: string[] | null;
  Konteringsvarde7_Delete_Refs?: string[] | null;
  Konteringsvarde8_Add_Refs?: string[] | null;
  Konteringsvarde8_Delete_Refs?: string[] | null;
  Konteringsvarde9_Add_Refs?: string[] | null;
  Konteringsvarde9_Delete_Refs?: string[] | null;
  Konteringsvarde10_Add_Refs?: string[] | null;
  Konteringsvarde10_Delete_Refs?: string[] | null;
  Kontoanvandning_Add_Values?: TEDInputEKKontoanvandningAddValues[] | null;
  Kontoanvandning_Update_Values?: TEDInputEKKontoanvandningUpdateValues[] | null;
  Kontoanvandning_Delete_Values?: TEDInputEKKontoanvandningDeleteValues[] | null;
  Kontering1_Add_Refs?: string[] | null;
  Kontering1_Delete_Refs?: string[] | null;
  Budgetkontering1_Add_Refs?: string[] | null;
  Budgetkontering1_Delete_Refs?: string[] | null;
  Ingbalans1_Add_Refs?: string[] | null;
  Ingbalans1_Delete_Refs?: string[] | null;
  Konteringskoder_Add_Values?: TEDInputEKTEDEKKonteringskoderAddValues[] | null;
  Konteringskoder_Update_Values?: TEDInputEKTEDEKKonteringskoderUpdateValues[] | null;
  Konteringskoder_Delete_Values?: TEDInputEKTEDEKKonteringskoderDeleteValues[] | null;
  Kombinationer_Add_Values?: TEDInputEKKontodelkombinationAddValues[] | null;
  Kombinationer_Update_Values?: TEDInputEKKontodelkombinationUpdateValues[] | null;
  Kombinationer_Delete_Values?: TEDInputEKKontodelkombinationDeleteValues[] | null;
  Kombinationsvillkor_Add_Values?: TEDInputEKTEDEKKombinationsvillkorAddValues[] | null;
  Kombinationsvillkor_Update_Values?: TEDInputEKTEDEKKombinationsvillkorUpdateValues[] | null;
  Kombinationsvillkor_Delete_Values?: TEDInputEKTEDEKKombinationsvillkorDeleteValues[] | null;
  Recept_Add_Values?: TEDInputEKKontodelReceptAddValues[] | null;
  Recept_Update_Values?: TEDInputEKKontodelReceptUpdateValues[] | null;
  Recept_Delete_Values?: TEDInputEKKontodelReceptDeleteValues[] | null;
  LokalKontoanvandning_Add_Values?: TEDInputEKLokalKontoanvandningAddValues[] | null;
  LokalKontoanvandning_Update_Values?: TEDInputEKLokalKontoanvandningUpdateValues[] | null;
  LokalKontoanvandning_Delete_Values?: TEDInputEKLokalKontoanvandningDeleteValues[] | null;
  Avdragsratt_Add_Values?: TEDInputEKAvdragsrattAddValues[] | null;
  Avdragsratt_Update_Values?: TEDInputEKAvdragsrattUpdateValues[] | null;
  Avdragsratt_Delete_Values?: TEDInputEKAvdragsrattDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av koddel
 */
export interface TEDInputEKKontodelUpdateValues {
  id: string;
  _version: number;
  KONTODEL?: string | null;
  BENAMNING?: string | null;
  REDOVISN_TYP?: TEDEKKontodelREDOVISN_TYPEnum | null;
  KONTOTYP?: TEDEKKontodelKONTOTYPEnum | null;
  KI_TYP?: TEDEKKontodelKI_TYPEnum | null;
  SRU_KOD?: number | null;
  BUDGETKONTO?: boolean | null;
  FRAN_DATUM?: any | null;
  TILL_DATUM?: any | null;
  INTERN_KONTO?: boolean | null;
  SPARRA_MANUELL?: boolean | null;
  PROJEKTBENAMNING?: string | null;
  PROJEKTANSVARIG?: string | null;
  PROJEKT_SUMMERA_AVSLUT?: boolean | null;
  ANTALSREDOVISNING?: boolean | null;
  STANDARDKONTO?: TEDEKKontodelSTANDARDKONTOEnum | null;
  KB_VERKSOMR?: TEDEKKontodelKB_VERKSOMREnum | null;
  KB_VERKSAMHET?: TEDEKKontodelKB_VERKSAMHETEnum | null;
  KPLANBYTE_RECEPT?: string | null;
  GASBAS_ID?: number | null;
  SPARR_ATTEST?: boolean | null;
  AKTIV?: boolean | null;
  EXP_TILL_LON?: boolean | null;
  EXP_TILL_TID?: boolean | null;
  SENAST_ANDRAD?: any | null;
  EXPORTERA_TILL_FLEX?: string | null;
  VERKS_KAT?: TEDEKKontodelVERKS_KATEnum | null;
  AKTNIVA_INTERVALL?: string | null;
  ERSATT_MED_KONTODEL?: string | null;
  ERSATT_DATUM?: any | null;
  RUBRIKKONTO?: boolean | null;
  LOKAL_EXP_TILL_FLEX?: boolean | null;
  LOKALT_ATGARD_INTERVALL?: string | null;
  ATGARD_KAT?: TEDEKKontodelATGARD_KATEnum | null;
  HUVUDPROJEKT_ID?: number | null;
  UNDANTAG_PERIODISERING?: boolean | null;
  _Associations?: TEDInputEKKontodelUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av koddelsdefinition
 */
export interface TEDInputEKKontodeldefAddAssociationValues {
  Kontoplan_Ref?: string | null;
  Kontoplan_Values?: TEDInputEKKontoplanAddValues | null;
  Kontodel_Add_Values?: TEDInputEKKontodelAddValues[] | null;
  Kontobegreppdef_Add_Values?: TEDInputEKKontobegreppdefAddValues[] | null;
  Huvudprojekt_Add_Values?: TEDInputEKHuvudprojektAddValues[] | null;
}

/**
 * Värden vid tillägg av koddelsdefinition
 */
export interface TEDInputEKKontodeldefAddValues {
  NAMN?: string | null;
  TYP?: string | null;
  ANTAL_POS?: number | null;
  PROJEKT?: TEDEKKontodeldefPROJEKTEnum | null;
  VERKSAMHET?: TEDEKKontodeldefVERKSAMHETEnum | null;
  KPLANBYTE_MOTSV_ORDNINGS_NR?: number | null;
  KPLANBYTE_IMPORTSATT?: TEDEKKontodeldefKPLANBYTE_IMPORTSATTEnum | null;
  STIFTELSE?: TEDEKKontodeldefSTIFTELSEEnum | null;
  BERAKNAD?: TEDEKKontodeldefBERAKNADEnum | null;
  BERAKNAS_FRAN_1?: string | null;
  BERAKNAS_FRAN_2?: string | null;
  BERAKNAS_FRAN_3?: string | null;
  BERAKNAS_FRAN_4?: string | null;
  BERAKNAS_FRAN_5?: string | null;
  BERAKNAS_FRAN_6?: string | null;
  BERAKNAS_FRAN_7?: string | null;
  BERAKNAS_FRAN_8?: string | null;
  BERAKNAS_FRAN_9?: string | null;
  BERAKNAS_FRAN_10?: string | null;
  ANVANDS_FOR?: TEDEKKontodeldefANVANDS_FOREnum | null;
  FASTIGHETSUPPFOLJNING?: boolean | null;
  ANVANDS_FOR_MOMS?: boolean | null;
  _Associations?: TEDInputEKKontodeldefAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av koddelsdefinition
 */
export interface TEDInputEKKontodeldefDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av koddelsdefinition
 */
export interface TEDInputEKKontodeldefUpdateAssociationValues {
  Kontoplan_Ref?: string | null;
  Kontoplan_Values?: TEDInputEKKontoplanUpdateValues | null;
  Kontodel_Add_Values?: TEDInputEKKontodelAddValues[] | null;
  Kontodel_Update_Values?: TEDInputEKKontodelUpdateValues[] | null;
  Kontodel_Delete_Values?: TEDInputEKKontodelDeleteValues[] | null;
  Kontobegreppdef_Add_Values?: TEDInputEKKontobegreppdefAddValues[] | null;
  Kontobegreppdef_Update_Values?: TEDInputEKKontobegreppdefUpdateValues[] | null;
  Kontobegreppdef_Delete_Values?: TEDInputEKKontobegreppdefDeleteValues[] | null;
  Huvudprojekt_Add_Values?: TEDInputEKHuvudprojektAddValues[] | null;
  Huvudprojekt_Update_Values?: TEDInputEKHuvudprojektUpdateValues[] | null;
  Huvudprojekt_Delete_Values?: TEDInputEKHuvudprojektDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av koddelsdefinition
 */
export interface TEDInputEKKontodeldefUpdateValues {
  id: string;
  _version: number;
  NAMN?: string | null;
  TYP?: string | null;
  ANTAL_POS?: number | null;
  PROJEKT?: TEDEKKontodeldefPROJEKTEnum | null;
  VERKSAMHET?: TEDEKKontodeldefVERKSAMHETEnum | null;
  KPLANBYTE_MOTSV_ORDNINGS_NR?: number | null;
  KPLANBYTE_IMPORTSATT?: TEDEKKontodeldefKPLANBYTE_IMPORTSATTEnum | null;
  STIFTELSE?: TEDEKKontodeldefSTIFTELSEEnum | null;
  BERAKNAD?: TEDEKKontodeldefBERAKNADEnum | null;
  BERAKNAS_FRAN_1?: string | null;
  BERAKNAS_FRAN_2?: string | null;
  BERAKNAS_FRAN_3?: string | null;
  BERAKNAS_FRAN_4?: string | null;
  BERAKNAS_FRAN_5?: string | null;
  BERAKNAS_FRAN_6?: string | null;
  BERAKNAS_FRAN_7?: string | null;
  BERAKNAS_FRAN_8?: string | null;
  BERAKNAS_FRAN_9?: string | null;
  BERAKNAS_FRAN_10?: string | null;
  ANVANDS_FOR?: TEDEKKontodeldefANVANDS_FOREnum | null;
  FASTIGHETSUPPFOLJNING?: boolean | null;
  ANVANDS_FOR_MOMS?: boolean | null;
  _Associations?: TEDInputEKKontodeldefUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av koddelkombination
 */
export interface TEDInputEKKontodelkombinationAddAssociationValues {
  Kontodel_Ref?: string | null;
  Kontodel_Values?: TEDInputEKKontodelAddValues | null;
  TillKontodelDef_Ref?: string | null;
  TillKontodelDef_Values?: TEDInputEKKontodeldefAddValues | null;
}

/**
 * Värden vid tillägg av koddelkombination
 */
export interface TEDInputEKKontodelkombinationAddValues {
  KOMBINATION?: TEDEKKontodelkombinationKOMBINATIONEnum | null;
  LOKALT_KRAV?: boolean | null;
  _Associations?: TEDInputEKKontodelkombinationAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av koddelkombination
 */
export interface TEDInputEKKontodelkombinationDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av koddelkombination
 */
export interface TEDInputEKKontodelkombinationUpdateAssociationValues {
  Kontodel_Ref?: string | null;
  Kontodel_Values?: TEDInputEKKontodelUpdateValues | null;
  TillKontodelDef_Ref?: string | null;
  TillKontodelDef_Values?: TEDInputEKKontodeldefUpdateValues | null;
}

/**
 * Nya värden vid ändring av koddelkombination
 */
export interface TEDInputEKKontodelkombinationUpdateValues {
  id: string;
  _version: number;
  KOMBINATION?: TEDEKKontodelkombinationKOMBINATIONEnum | null;
  LOKALT_KRAV?: boolean | null;
  _Associations?: TEDInputEKKontodelkombinationUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kodplan
 */
export interface TEDInputEKKontoplanAddAssociationValues {
  Kontodelsdef_Add_Values?: TEDInputEKKontodeldefAddValues[] | null;
}

/**
 * Värden vid tillägg av kodplan
 */
export interface TEDInputEKKontoplanAddValues {
  NAMN: string;
  FRAN_BOKF_AR: any;
  TILL_BOKF_AR: any;
  TI_PROJEKT?: number | null;
  TYP: TEDEKKontoplanTYPEnum;
  ANVPAGINVIB?: boolean | null;
  _Associations?: TEDInputEKKontoplanAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av kodplan
 */
export interface TEDInputEKKontoplanUpdateAssociationValues {
  Kontodelsdef_Add_Values?: TEDInputEKKontodeldefAddValues[] | null;
  Kontodelsdef_Update_Values?: TEDInputEKKontodeldefUpdateValues[] | null;
  Kontodelsdef_Delete_Values?: TEDInputEKKontodeldefDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av kodplan
 */
export interface TEDInputEKKontoplanUpdateValues {
  id: string;
  _version: number;
  NAMN?: string | null;
  FRAN_BOKF_AR?: any | null;
  TILL_BOKF_AR?: any | null;
  TI_PROJEKT?: number | null;
  TYP?: TEDEKKontoplanTYPEnum | null;
  ANVPAGINVIB?: boolean | null;
  _Associations?: TEDInputEKKontoplanUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av lokal kontoanvändning
 */
export interface TEDInputEKLokalKontoanvandningAddAssociationValues {
  Kontodel_Ref?: string | null;
  Kontodel_Values?: TEDInputEKKontodelAddValues | null;
}

/**
 * Värden vid tillägg av lokal kontoanvändning
 */
export interface TEDInputEKLokalKontoanvandningAddValues {
  _Associations?: TEDInputEKLokalKontoanvandningAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av lokal kontoanvändning
 */
export interface TEDInputEKLokalKontoanvandningDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av lokal kontoanvändning
 */
export interface TEDInputEKLokalKontoanvandningUpdateAssociationValues {
  Kontodel_Ref?: string | null;
  Kontodel_Values?: TEDInputEKKontodelUpdateValues | null;
}

/**
 * Nya värden vid ändring av lokal kontoanvändning
 */
export interface TEDInputEKLokalKontoanvandningUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputEKLokalKontoanvandningUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av löneart
 */
export interface TEDInputEKLoneartAddValues {
  KOD?: number | null;
  BENAMNING: string;
  LONEARTSGRUPP?: string | null;
  INTEGRATIONSTYP: TEDEKLoneartINTEGRATIONSTYPEnum;
  KOD_ALFA?: string | null;
}

/**
 * Nya värden vid ändring av löneart
 */
export interface TEDInputEKLoneartUpdateValues {
  id: string;
  _version: number;
  KOD?: number | null;
  BENAMNING?: string | null;
  LONEARTSGRUPP?: string | null;
  INTEGRATIONSTYP?: TEDEKLoneartINTEGRATIONSTYPEnum | null;
  KOD_ALFA?: string | null;
}

/**
 * Värden vid tillägg av momskod
 */
export interface TEDInputEKMomskodAddValues {
  MOMS_KOD?: string | null;
  BENAMNING?: string | null;
  UNDERLAG_BETALNING_SKV?: boolean | null;
}

/**
 * Nya värden vid ändring av momskod
 */
export interface TEDInputEKMomskodUpdateValues {
  id: string;
  _version: number;
  MOMS_KOD?: string | null;
  BENAMNING?: string | null;
  UNDERLAG_BETALNING_SKV?: boolean | null;
}

/**
 * Associerade värden vid tillägg av omfördelning, logg
 */
export interface TEDInputEKOmfordelningLoggAddAssociationValues {
  Bokfver_Ref?: string | null;
  Bokfver_Values?: TEDInputEKBokfverAddValues | null;
}

/**
 * Värden vid tillägg av omfördelning, logg
 */
export interface TEDInputEKOmfordelningLoggAddValues {
  DATUM?: any | null;
  SIGNATUR?: string | null;
  UNDERLAG_BOKF_AR?: any | null;
  UNDERLAG_BOKF_PER?: number | null;
  RAPP_BOKF_AR?: any | null;
  RAPP_BOKF_PER?: number | null;
  NOTERING?: string | null;
  _Associations?: TEDInputEKOmfordelningLoggAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av omfördelning, logg
 */
export interface TEDInputEKOmfordelningLoggDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av omfördelning, logg
 */
export interface TEDInputEKOmfordelningLoggUpdateAssociationValues {
  Bokfver_Ref?: string | null;
  Bokfver_Values?: TEDInputEKBokfverUpdateValues | null;
}

/**
 * Nya värden vid ändring av omfördelning, logg
 */
export interface TEDInputEKOmfordelningLoggUpdateValues {
  id: string;
  _version: number;
  DATUM?: any | null;
  SIGNATUR?: string | null;
  UNDERLAG_BOKF_AR?: any | null;
  UNDERLAG_BOKF_PER?: number | null;
  RAPP_BOKF_AR?: any | null;
  RAPP_BOKF_PER?: number | null;
  NOTERING?: string | null;
  _Associations?: TEDInputEKOmfordelningLoggUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av ekonomirapport används för
 */
export interface TEDInputEKRappAnvForAddValues {
  RAPPORT_ID?: number | null;
  LOPNR?: number | null;
  ANVANDS_FOR: TEDEKRappAnvForANVANDS_FOREnum;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av ekonomirapport används för
 */
export interface TEDInputEKRappAnvForDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av ekonomirapport används för
 */
export interface TEDInputEKRappAnvForUpdateValues {
  id: string;
  _version: number;
  RAPPORT_ID?: number | null;
  LOPNR?: number | null;
  ANVANDS_FOR?: TEDEKRappAnvForANVANDS_FOREnum | null;
}

/**
 * Associerade värden vid tillägg av ekonomirapport, Dimension
 */
export interface TEDInputEKRapportDimensionAddAssociationValues {
  Ekonomirapport_Ref?: string | null;
  Ekonomirapport_Values?: TEDInputEKEkonomirapportAddValues | null;
  Grupperingsbegrepp_Add_Values?: TEDInputEKGrupperingAddValues[] | null;
  Dimensionsrader_Add_Values?: TEDInputEKDimensionsradAddValues[] | null;
}

/**
 * Värden vid tillägg av ekonomirapport, Dimension
 */
export interface TEDInputEKRapportDimensionAddValues {
  _typ?: TEDEKRapportDimensionTypEnum | null;
  INDENTERA_NIVAER?: string | null;
  ANVAND_FARG?: boolean | null;
  SUMMA_FONT_NAMN?: string | null;
  SUMMA_STORLEK?: number | null;
  SUMMA_BOLD?: boolean | null;
  SUMMA_ITALIC?: boolean | null;
  SUMMA_UNDERLINE?: boolean | null;
  SUMMA_STRIKE_OUT?: boolean | null;
  DETALJ_FONT_NAMN?: string | null;
  DETALJ_STORLEK?: number | null;
  DETALJ_BOLD?: string | null;
  DETALJ_ITALIC?: boolean | null;
  DETALJ_UNDERLINE?: boolean | null;
  DETALJ_STRIKE_OUT?: boolean | null;
  BEN_FLERA_RADER?: boolean | null;
  BEN_BREDD?: number | null;
  _Associations?: TEDInputEKRapportDimensionAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av ekonomirapport, Dimension
 */
export interface TEDInputEKRapportDimensionDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av ekonomirapport, Dimension
 */
export interface TEDInputEKRapportDimensionUpdateAssociationValues {
  Ekonomirapport_Ref?: string | null;
  Ekonomirapport_Values?: TEDInputEKEkonomirapportUpdateValues | null;
  Grupperingsbegrepp_Add_Values?: TEDInputEKGrupperingAddValues[] | null;
  Grupperingsbegrepp_Update_Values?: TEDInputEKGrupperingUpdateValues[] | null;
  Grupperingsbegrepp_Delete_Values?: TEDInputEKGrupperingDeleteValues[] | null;
  Dimensionsrader_Add_Values?: TEDInputEKDimensionsradAddValues[] | null;
  Dimensionsrader_Update_Values?: TEDInputEKDimensionsradUpdateValues[] | null;
  Dimensionsrader_Delete_Values?: TEDInputEKDimensionsradDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av ekonomirapport, Dimension
 */
export interface TEDInputEKRapportDimensionUpdateValues {
  id: string;
  _version: number;
  INDENTERA_NIVAER?: string | null;
  ANVAND_FARG?: boolean | null;
  SUMMA_FONT_NAMN?: string | null;
  SUMMA_STORLEK?: number | null;
  SUMMA_BOLD?: boolean | null;
  SUMMA_ITALIC?: boolean | null;
  SUMMA_UNDERLINE?: boolean | null;
  SUMMA_STRIKE_OUT?: boolean | null;
  DETALJ_FONT_NAMN?: string | null;
  DETALJ_STORLEK?: number | null;
  DETALJ_BOLD?: string | null;
  DETALJ_ITALIC?: boolean | null;
  DETALJ_UNDERLINE?: boolean | null;
  DETALJ_STRIKE_OUT?: boolean | null;
  BEN_FLERA_RADER?: boolean | null;
  BEN_BREDD?: number | null;
  _Associations?: TEDInputEKRapportDimensionUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av ekonomirapport, Kolumn
 */
export interface TEDInputEKRapportFaltAddAssociationValues {
  Kolumnspecifikationer_Add_Values?: TEDInputEKRapportfaltSpecAddValues[] | null;
}

/**
 * Värden vid tillägg av ekonomirapport, Kolumn
 */
export interface TEDInputEKRapportFaltAddValues {
  ORDNINGS_NR?: number | null;
  BENAMNING?: string | null;
  SPECIFIKATION?: string | null;
  FALTKOD?: string | null;
  FROM_AR?: number | null;
  FROM_AR_RELATIV?: string | null;
  TOM_AR?: number | null;
  TOM_AR_RELATIV?: string | null;
  FROM_PER?: number | null;
  FROM_PER_RELATIV?: string | null;
  TOM_PER?: number | null;
  TOM_PER_RELATIV?: string | null;
  BUDGET_TYP?: TEDEKRapportFaltBUDGET_TYPEnum | null;
  BUDGET_BENAMNING?: string | null;
  FALT_TYP: TEDEKRapportFaltFALT_TYPEnum;
  VISA_FROM_TOM?: boolean | null;
  BAS?: TEDEKRapportFaltBASEnum | null;
  ANTAL_DECIMALER?: number | null;
  VAND_TECKEN?: boolean | null;
  BREDD_PROCENT?: number | null;
  BENAMNING2?: string | null;
  NOLLUNDERTRYCK?: boolean | null;
  FIELDID?: number | null;
  RUB_FONT_NAMN?: string | null;
  RUB_STORLEK?: number | null;
  RUB_BOLD?: boolean | null;
  RUB_ITALIC?: boolean | null;
  RUB_UNDERLINE?: boolean | null;
  SKRIV_UT?: boolean | null;
  BELOPP_FARG_NEGATIV?: number | null;
  INTERVALL_TYP: TEDEKRapportFaltINTERVALL_TYPEnum;
  BREDD_MM?: number | null;
  TYP?: TEDEKRapportFaltTYPEnum | null;
  RESULTAT_TYP: TEDEKRapportFaltRESULTAT_TYPEnum;
  ENHET_ID?: number | null;
  FORDELN_RADNIVA?: number | null;
  FORDELN_VISA_RADNIVA?: string | null;
  SKRIV_DETALJ?: boolean | null;
  RULLANDE?: boolean | null;
  _Associations?: TEDInputEKRapportFaltAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av ekonomirapport, Kolumn
 */
export interface TEDInputEKRapportFaltDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av ekonomirapport, Kolumn
 */
export interface TEDInputEKRapportFaltUpdateAssociationValues {
  Kolumnspecifikationer_Add_Values?: TEDInputEKRapportfaltSpecAddValues[] | null;
  Kolumnspecifikationer_Update_Values?: TEDInputEKRapportfaltSpecUpdateValues[] | null;
  Kolumnspecifikationer_Delete_Values?: TEDInputEKRapportfaltSpecDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av ekonomirapport, Kolumn
 */
export interface TEDInputEKRapportFaltUpdateValues {
  id: string;
  _version: number;
  ORDNINGS_NR?: number | null;
  BENAMNING?: string | null;
  SPECIFIKATION?: string | null;
  FALTKOD?: string | null;
  FROM_AR?: number | null;
  FROM_AR_RELATIV?: string | null;
  TOM_AR?: number | null;
  TOM_AR_RELATIV?: string | null;
  FROM_PER?: number | null;
  FROM_PER_RELATIV?: string | null;
  TOM_PER?: number | null;
  TOM_PER_RELATIV?: string | null;
  BUDGET_TYP?: TEDEKRapportFaltBUDGET_TYPEnum | null;
  BUDGET_BENAMNING?: string | null;
  FALT_TYP?: TEDEKRapportFaltFALT_TYPEnum | null;
  VISA_FROM_TOM?: boolean | null;
  BAS?: TEDEKRapportFaltBASEnum | null;
  ANTAL_DECIMALER?: number | null;
  VAND_TECKEN?: boolean | null;
  BREDD_PROCENT?: number | null;
  BENAMNING2?: string | null;
  NOLLUNDERTRYCK?: boolean | null;
  FIELDID?: number | null;
  RUB_FONT_NAMN?: string | null;
  RUB_STORLEK?: number | null;
  RUB_BOLD?: boolean | null;
  RUB_ITALIC?: boolean | null;
  RUB_UNDERLINE?: boolean | null;
  SKRIV_UT?: boolean | null;
  BELOPP_FARG_NEGATIV?: number | null;
  INTERVALL_TYP?: TEDEKRapportFaltINTERVALL_TYPEnum | null;
  BREDD_MM?: number | null;
  TYP?: TEDEKRapportFaltTYPEnum | null;
  RESULTAT_TYP?: TEDEKRapportFaltRESULTAT_TYPEnum | null;
  ENHET_ID?: number | null;
  FORDELN_RADNIVA?: number | null;
  FORDELN_VISA_RADNIVA?: string | null;
  SKRIV_DETALJ?: boolean | null;
  RULLANDE?: boolean | null;
  _Associations?: TEDInputEKRapportFaltUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av ekonomirapport, Sidhuvud
 */
export interface TEDInputEKRapportHuvudAddAssociationValues {
  Falt_Add_Values?: TEDInputEKRapportHuvudFaltAddValues[] | null;
}

/**
 * Värden vid tillägg av ekonomirapport, Sidhuvud
 */
export interface TEDInputEKRapportHuvudAddValues {
  BENAMNING?: string | null;
  FORMAT: TEDEKRapportHuvudFORMATEnum;
  HEIGHT?: number | null;
  ANVANDS_FOR?: TEDEKRapportHuvudANVANDS_FOREnum | null;
  _Associations?: TEDInputEKRapportHuvudAddAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av sidhuvud, fält
 */
export interface TEDInputEKRapportHuvudFaltAddAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputEKRapportHuvudFaltBlobAddValues | null;
}

/**
 * Värden vid tillägg av sidhuvud, fält
 */
export interface TEDInputEKRapportHuvudFaltAddValues {
  _typ: TEDEKRapportHuvudFaltTypEnum;
  SIZE_LEFT?: number | null;
  SIZE_TOP?: number | null;
  SIZE_WIDTH?: number | null;
  SIZE_HEIGHT?: number | null;
  TEXT_COLOR?: number | null;
  BACKGROUND_COLOR?: number | null;
  SHAPE?: number | null;
  FONT_NAMN?: string | null;
  STORLEK?: number | null;
  BOLD?: string | null;
  ITALIC?: string | null;
  UNDERLINE?: string | null;
  STRIKE_OUT?: string | null;
  AUTOSIZE?: string | null;
  AUTOSTRETCH?: string | null;
  FALTTEXT?: string | null;
  _Associations?: TEDInputEKRapportHuvudFaltAddAssociationValues | null;
}

/**
 * Värden vid tillägg av eKRapportHuvudFaltBlob
 */
export interface TEDInputEKRapportHuvudFaltBlobAddValues {
  BILD?: string | null;
  BILDSIZE?: number | null;
  BILDSTRETCH?: boolean | null;
}

/**
 * Nya värden vid ändring av eKRapportHuvudFaltBlob
 */
export interface TEDInputEKRapportHuvudFaltBlobUpdateValues {
  id: string;
  _version: number;
  BILD?: string | null;
  BILDSIZE?: number | null;
  BILDSTRETCH?: boolean | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av sidhuvud, fält
 */
export interface TEDInputEKRapportHuvudFaltDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av sidhuvud, fält
 */
export interface TEDInputEKRapportHuvudFaltUpdateAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputEKRapportHuvudFaltBlobUpdateValues | null;
}

/**
 * Nya värden vid ändring av sidhuvud, fält
 */
export interface TEDInputEKRapportHuvudFaltUpdateValues {
  id: string;
  _version: number;
  SIZE_LEFT?: number | null;
  SIZE_TOP?: number | null;
  SIZE_WIDTH?: number | null;
  SIZE_HEIGHT?: number | null;
  TEXT_COLOR?: number | null;
  BACKGROUND_COLOR?: number | null;
  SHAPE?: number | null;
  FONT_NAMN?: string | null;
  STORLEK?: number | null;
  BOLD?: string | null;
  ITALIC?: string | null;
  UNDERLINE?: string | null;
  STRIKE_OUT?: string | null;
  AUTOSIZE?: string | null;
  AUTOSTRETCH?: string | null;
  FALTTEXT?: string | null;
  _Associations?: TEDInputEKRapportHuvudFaltUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av ekonomirapport, Sidhuvud
 */
export interface TEDInputEKRapportHuvudUpdateAssociationValues {
  Falt_Add_Values?: TEDInputEKRapportHuvudFaltAddValues[] | null;
  Falt_Update_Values?: TEDInputEKRapportHuvudFaltUpdateValues[] | null;
  Falt_Delete_Values?: TEDInputEKRapportHuvudFaltDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av ekonomirapport, Sidhuvud
 */
export interface TEDInputEKRapportHuvudUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  FORMAT?: TEDEKRapportHuvudFORMATEnum | null;
  HEIGHT?: number | null;
  ANVANDS_FOR?: TEDEKRapportHuvudANVANDS_FOREnum | null;
  _Associations?: TEDInputEKRapportHuvudUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av rapportmall
 */
export interface TEDInputEKRapportMallAddAssociationValues {
  Niva_Ref?: string | null;
  Niva_Values?: TEDInputEKRapportMallNivaAddValues | null;
}

/**
 * Värden vid tillägg av rapportmall
 */
export interface TEDInputEKRapportMallAddValues {
  BENAMNING?: string | null;
  LAYOUT?: TEDEKRapportMallLAYOUTEnum | null;
  ANVAND_FARG?: boolean | null;
  INDENTERA?: boolean | null;
  FORMAT?: TEDEKRapportMallFORMATEnum | null;
  RUB_FONT_NAMN?: string | null;
  RUB_STORLEK?: number | null;
  RUB_BOLD?: boolean | null;
  RUB_ITALIC?: boolean | null;
  RUB_UNDERLINE?: boolean | null;
  RUB_STRIKE_OUT?: boolean | null;
  SUMMA_FONT_NAMN?: string | null;
  SUMMA_STORLEK?: number | null;
  SUMMA_BOLD?: boolean | null;
  SUMMA_ITALIC?: boolean | null;
  SUMMA_UNDERLINE?: boolean | null;
  SUMMA_STRIKE_OUT?: boolean | null;
  _Associations?: TEDInputEKRapportMallAddAssociationValues | null;
}

/**
 * Värden vid tillägg av rapportmall - nivå
 */
export interface TEDInputEKRapportMallNivaAddValues {
  FONT_NAMN: string;
  STORLEK: number;
  BOLD?: boolean | null;
  ITALIC?: boolean | null;
  UNDERLINE?: string | null;
  STRIKE_OUT?: string | null;
  DIVERSE?: string | null;
}

/**
 * Nya värden vid ändring av rapportmall - nivå
 */
export interface TEDInputEKRapportMallNivaUpdateValues {
  id: string;
  _version: number;
  FONT_NAMN?: string | null;
  STORLEK?: number | null;
  BOLD?: boolean | null;
  ITALIC?: boolean | null;
  UNDERLINE?: string | null;
  STRIKE_OUT?: string | null;
  DIVERSE?: string | null;
}

/**
 * Associerade värden vid ändring av rapportmall
 */
export interface TEDInputEKRapportMallUpdateAssociationValues {
  Niva_Ref?: string | null;
  Niva_Values?: TEDInputEKRapportMallNivaUpdateValues | null;
}

/**
 * Nya värden vid ändring av rapportmall
 */
export interface TEDInputEKRapportMallUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  LAYOUT?: TEDEKRapportMallLAYOUTEnum | null;
  ANVAND_FARG?: boolean | null;
  INDENTERA?: boolean | null;
  FORMAT?: TEDEKRapportMallFORMATEnum | null;
  RUB_FONT_NAMN?: string | null;
  RUB_STORLEK?: number | null;
  RUB_BOLD?: boolean | null;
  RUB_ITALIC?: boolean | null;
  RUB_UNDERLINE?: boolean | null;
  RUB_STRIKE_OUT?: boolean | null;
  SUMMA_FONT_NAMN?: string | null;
  SUMMA_STORLEK?: number | null;
  SUMMA_BOLD?: boolean | null;
  SUMMA_ITALIC?: boolean | null;
  SUMMA_UNDERLINE?: boolean | null;
  SUMMA_STRIKE_OUT?: boolean | null;
  _Associations?: TEDInputEKRapportMallUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av rapporturval
 */
export interface TEDInputEKRapportUrvalAddValues {
  VIEW_ID?: number | null;
  ANV_ID?: number | null;
  DATUM?: any | null;
  TID?: any | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av rapporturval
 */
export interface TEDInputEKRapportUrvalDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av rapporturval
 */
export interface TEDInputEKRapportUrvalUpdateValues {
  id: string;
  _version: number;
  VIEW_ID?: number | null;
  ANV_ID?: number | null;
  DATUM?: any | null;
  TID?: any | null;
}

/**
 * Värden vid tillägg av kolumnspecifikation
 */
export interface TEDInputEKRapportfaltSpecAddValues {
  _typ: TEDEKRapportfaltSpecTypEnum;
  REF_RAPPORT_ID?: number | null;
  REF_LOPNR?: number | null;
  OPERATOR?: string | null;
  CONSTANT?: number | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kolumnspecifikation
 */
export interface TEDInputEKRapportfaltSpecDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av kolumnspecifikation
 */
export interface TEDInputEKRapportfaltSpecUpdateValues {
  id: string;
  _version: number;
  REF_RAPPORT_ID?: number | null;
  REF_LOPNR?: number | null;
  OPERATOR?: string | null;
  CONSTANT?: number | null;
}

/**
 * Värden vid tillägg av rapportkategori
 */
export interface TEDInputEKRapportkategoriAddValues {
  BENAMNING: string;
}

/**
 * Nya värden vid ändring av rapportkategori
 */
export interface TEDInputEKRapportkategoriUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
}

/**
 * Associerade värden vid tillägg av rapportpaket
 */
export interface TEDInputEKRapportpaketAddAssociationValues {
  Logg_Add_Values?: TEDInputEKTEDEKRapportpaketLoggAddValues[] | null;
}

/**
 * Värden vid tillägg av rapportpaket
 */
export interface TEDInputEKRapportpaketAddValues {
  BENAMNING: string;
  MED_SORTERING?: TEDEKRapportpaketMED_SORTERINGEnum | null;
  MED_AMNE?: string | null;
  MED_MEDDELANDE?: string | null;
  MED_AVS_EMAIL?: string | null;
  MED_AVS_NAMN?: string | null;
  DISTR_SATT: TEDEKRapportpaketDISTR_SATTEnum;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  IDKOD?: string | null;
  _Associations?: TEDInputEKRapportpaketAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av rapportpaket
 */
export interface TEDInputEKRapportpaketUpdateAssociationValues {
  Logg_Add_Values?: TEDInputEKTEDEKRapportpaketLoggAddValues[] | null;
  Logg_Update_Values?: TEDInputEKTEDEKRapportpaketLoggUpdateValues[] | null;
  Logg_Delete_Values?: TEDInputEKTEDEKRapportpaketLoggDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av rapportpaket
 */
export interface TEDInputEKRapportpaketUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  MED_SORTERING?: TEDEKRapportpaketMED_SORTERINGEnum | null;
  MED_AMNE?: string | null;
  MED_MEDDELANDE?: string | null;
  MED_AVS_EMAIL?: string | null;
  MED_AVS_NAMN?: string | null;
  DISTR_SATT?: TEDEKRapportpaketDISTR_SATTEnum | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  IDKOD?: string | null;
  _Associations?: TEDInputEKRapportpaketUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av rapportradsspecifikation
 */
export interface TEDInputEKRapportradsspecAddAssociationValues {
  Dimensionsrad_Ref?: string | null;
  Dimensionsrad_Values?: TEDInputEKDimensionsradAddValues | null;
  Rapport_Ref?: string | null;
  Rapport_Values?: TEDInputEKEkonomirapportAddValues | null;
  Celler_Add_Values?: TEDInputEKTEDEKRapportradspecCellAddValues[] | null;
}

/**
 * Värden vid tillägg av rapportradsspecifikation
 */
export interface TEDInputEKRapportradsspecAddValues {
  _typ: TEDEKRapportradsspecTypEnum;
  VIEW_ID?: number | null;
  OPERATOR?: string | null;
  CONSTANT?: number | null;
  _Associations: TEDInputEKRapportradsspecAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av rapportradsspecifikation
 */
export interface TEDInputEKRapportradsspecDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av rapportradsspecifikation
 */
export interface TEDInputEKRapportradsspecUpdateAssociationValues {
  Dimensionsrad_Ref?: string | null;
  Dimensionsrad_Values?: TEDInputEKDimensionsradUpdateValues | null;
  Rapport_Ref?: string | null;
  Rapport_Values?: TEDInputEKEkonomirapportUpdateValues | null;
  Celler_Add_Values?: TEDInputEKTEDEKRapportradspecCellAddValues[] | null;
  Celler_Update_Values?: TEDInputEKTEDEKRapportradspecCellUpdateValues[] | null;
  Celler_Delete_Values?: TEDInputEKTEDEKRapportradspecCellDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av rapportradsspecifikation
 */
export interface TEDInputEKRapportradsspecUpdateValues {
  id: string;
  _version: number;
  VIEW_ID?: number | null;
  OPERATOR?: string | null;
  CONSTANT?: number | null;
  _Associations?: TEDInputEKRapportradsspecUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kontobegr, arbetsställe
 */
export interface TEDInputEKStalleKontourvalAddAssociationValues {
  Kontoplan_Ref?: string | null;
  Kontoplan_Values?: TEDInputEKKontoplanAddValues | null;
  Arbetsstalle_Ref?: string | null;
  Arbetsstalle_Values?: TEDInputSYSArbetsstalleAddValues | null;
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalAddValues | null;
}

/**
 * Värden vid tillägg av kontobegr, arbetsställe
 */
export interface TEDInputEKStalleKontourvalAddValues {
  URVAL_ID?: number | null;
  _Associations: TEDInputEKStalleKontourvalAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kontobegr, arbetsställe
 */
export interface TEDInputEKStalleKontourvalDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kontobegr, arbetsställe
 */
export interface TEDInputEKStalleKontourvalUpdateAssociationValues {
  Kontoplan_Ref?: string | null;
  Kontoplan_Values?: TEDInputEKKontoplanUpdateValues | null;
  Arbetsstalle_Ref?: string | null;
  Arbetsstalle_Values?: TEDInputSYSArbetsstalleUpdateValues | null;
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalUpdateValues | null;
}

/**
 * Nya värden vid ändring av kontobegr, arbetsställe
 */
export interface TEDInputEKStalleKontourvalUpdateValues {
  id: string;
  _version: number;
  URVAL_ID?: number | null;
  _Associations?: TEDInputEKStalleKontourvalUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kombinationsvillkor
 */
export interface TEDInputEKTEDEKKombinationsvillkorAddAssociationValues {
  Tillkontodel_Ref?: string | null;
  Tillkontodel_Values?: TEDInputEKKontodeldefAddValues | null;
}

/**
 * Värden vid tillägg av kombinationsvillkor
 */
export interface TEDInputEKTEDEKKombinationsvillkorAddValues {
  FROM_KONTODEL?: string | null;
  TOM_KONTODEL?: string | null;
  _Associations: TEDInputEKTEDEKKombinationsvillkorAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kombinationsvillkor
 */
export interface TEDInputEKTEDEKKombinationsvillkorDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kombinationsvillkor
 */
export interface TEDInputEKTEDEKKombinationsvillkorUpdateAssociationValues {
  Tillkontodel_Ref?: string | null;
  Tillkontodel_Values?: TEDInputEKKontodeldefUpdateValues | null;
}

/**
 * Nya värden vid ändring av kombinationsvillkor
 */
export interface TEDInputEKTEDEKKombinationsvillkorUpdateValues {
  id: string;
  _version: number;
  FROM_KONTODEL?: string | null;
  TOM_KONTODEL?: string | null;
  _Associations?: TEDInputEKTEDEKKombinationsvillkorUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av konteringskod
 */
export interface TEDInputEKTEDEKKonteringskoderAddAssociationValues {
  Konteringskod_Ref?: string | null;
  Konteringskod_Values?: TEDInputSYSKonteringskodAddValues | null;
}

/**
 * Värden vid tillägg av konteringskod
 */
export interface TEDInputEKTEDEKKonteringskoderAddValues {
  SORTERINGS_NR?: number | null;
  _Associations: TEDInputEKTEDEKKonteringskoderAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av konteringskod
 */
export interface TEDInputEKTEDEKKonteringskoderDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av konteringskod
 */
export interface TEDInputEKTEDEKKonteringskoderUpdateAssociationValues {
  Konteringskod_Ref?: string | null;
  Konteringskod_Values?: TEDInputSYSKonteringskodUpdateValues | null;
}

/**
 * Nya värden vid ändring av konteringskod
 */
export interface TEDInputEKTEDEKKonteringskoderUpdateValues {
  id: string;
  _version: number;
  SORTERINGS_NR?: number | null;
  _Associations?: TEDInputEKTEDEKKonteringskoderUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av logg för rapportpaket
 */
export interface TEDInputEKTEDEKRapportpaketLoggAddAssociationValues {
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
  Rapportpaket_Ref?: string | null;
  Rapportpaket_Values?: TEDInputEKRapportpaketAddValues | null;
}

/**
 * Värden vid tillägg av logg för rapportpaket
 */
export interface TEDInputEKTEDEKRapportpaketLoggAddValues {
  DATUM?: any | null;
  BOKF_AR?: any | null;
  BOKF_PER?: number | null;
  BOKFDATUM_FROM?: any | null;
  BOKFDATUM_TOM?: any | null;
  TID?: any | null;
  _Associations: TEDInputEKTEDEKRapportpaketLoggAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av logg för rapportpaket
 */
export interface TEDInputEKTEDEKRapportpaketLoggDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av logg för rapportpaket
 */
export interface TEDInputEKTEDEKRapportpaketLoggUpdateAssociationValues {
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
  Rapportpaket_Ref?: string | null;
  Rapportpaket_Values?: TEDInputEKRapportpaketUpdateValues | null;
}

/**
 * Nya värden vid ändring av logg för rapportpaket
 */
export interface TEDInputEKTEDEKRapportpaketLoggUpdateValues {
  id: string;
  _version: number;
  DATUM?: any | null;
  BOKF_AR?: any | null;
  BOKF_PER?: number | null;
  BOKFDATUM_FROM?: any | null;
  BOKFDATUM_TOM?: any | null;
  TID?: any | null;
  _Associations?: TEDInputEKTEDEKRapportpaketLoggUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av rapportvärde från cell
 */
export interface TEDInputEKTEDEKRapportradspecCellAddValues {
  REF_RAPPORT_ID?: number | null;
  REF_DIMENSION?: number | null;
  REF_LOPNR?: number | null;
  REF_FALT_LOPNR?: number | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av rapportvärde från cell
 */
export interface TEDInputEKTEDEKRapportradspecCellDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av rapportvärde från cell
 */
export interface TEDInputEKTEDEKRapportradspecCellUpdateValues {
  id: string;
  _version: number;
  REF_RAPPORT_ID?: number | null;
  REF_DIMENSION?: number | null;
  REF_LOPNR?: number | null;
  REF_FALT_LOPNR?: number | null;
}

/**
 * Associerade värden vid tillägg av rapportbehörighet
 */
export interface TEDInputEKTEDEKUtdeladRapportAnvAddAssociationValues {
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
  Rapport_Ref?: string | null;
  Rapport_Values?: TEDInputEKEkonomirapportAddValues | null;
}

/**
 * Värden vid tillägg av rapportbehörighet
 */
export interface TEDInputEKTEDEKUtdeladRapportAnvAddValues {
  _Associations: TEDInputEKTEDEKUtdeladRapportAnvAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av rapportbehörighet
 */
export interface TEDInputEKTEDEKUtdeladRapportAnvDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av rapportbehörighet
 */
export interface TEDInputEKTEDEKUtdeladRapportAnvUpdateAssociationValues {
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
  Rapport_Ref?: string | null;
  Rapport_Values?: TEDInputEKEkonomirapportUpdateValues | null;
}

/**
 * Nya värden vid ändring av rapportbehörighet
 */
export interface TEDInputEKTEDEKUtdeladRapportAnvUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputEKTEDEKUtdeladRapportAnvUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av tilläggsinfo
 */
export interface TEDInputEKTillaggsinfoAddAssociationValues {
  Falt_Add_Values?: TEDInputEKTillaggsinfoFaltAddValues[] | null;
  Kontodel_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av tilläggsinfo
 */
export interface TEDInputEKTillaggsinfoAddValues {
  BENAMNING: string;
  AKTIV?: boolean | null;
  _Associations?: TEDInputEKTillaggsinfoAddAssociationValues | null;
}

/**
 * Värden vid tillägg av tilläggsinfo, fält
 */
export interface TEDInputEKTillaggsinfoFaltAddValues {
  SORTORDER?: number | null;
  FIELD_NAME?: string | null;
  BENAMNING?: string | null;
  AKTIV?: boolean | null;
  OBLIGATORISK?: boolean | null;
  BESKRIVNING?: string | null;
  AKTIV_ENABLED?: boolean | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av tilläggsinfo, fält
 */
export interface TEDInputEKTillaggsinfoFaltDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av tilläggsinfo, fält
 */
export interface TEDInputEKTillaggsinfoFaltUpdateValues {
  id: string;
  _version: number;
  SORTORDER?: number | null;
  FIELD_NAME?: string | null;
  BENAMNING?: string | null;
  AKTIV?: boolean | null;
  OBLIGATORISK?: boolean | null;
  BESKRIVNING?: string | null;
  AKTIV_ENABLED?: boolean | null;
}

/**
 * Associerade värden vid ändring av tilläggsinfo
 */
export interface TEDInputEKTillaggsinfoUpdateAssociationValues {
  Falt_Add_Values?: TEDInputEKTillaggsinfoFaltAddValues[] | null;
  Falt_Update_Values?: TEDInputEKTillaggsinfoFaltUpdateValues[] | null;
  Falt_Delete_Values?: TEDInputEKTillaggsinfoFaltDeleteValues[] | null;
  Kontodel_Add_Refs?: string[] | null;
  Kontodel_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av tilläggsinfo
 */
export interface TEDInputEKTillaggsinfoUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  AKTIV?: boolean | null;
  _Associations?: TEDInputEKTillaggsinfoUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av utdelad rapport
 */
export interface TEDInputEKUtdeladRapportAddAssociationValues {
  Rapport_Ref?: string | null;
  Rapport_Values?: TEDInputEKEkonomirapportAddValues | null;
  Prenumeranter_Ref?: string | null;
  Prenumeranter_Values?: TEDInputEKUtdeladRapportPrenAddValues | null;
  Rapportpaket_Ref?: string | null;
  Rapportpaket_Values?: TEDInputEKRapportpaketAddValues | null;
  Grundurval_Ref?: string | null;
  Grundurval_Values?: TEDInputSYSUrvalAddValues | null;
  UtdeladTill_Add_Values?: TEDInputEKTEDEKUtdeladRapportAnvAddValues[] | null;
  AnvRapport_Add_Values?: TEDInputEKAnvRapportAddValues[] | null;
}

/**
 * Värden vid tillägg av utdelad rapport
 */
export interface TEDInputEKUtdeladRapportAddValues {
  VIEW_ID_2?: number | null;
  DETALJRADER?: TEDEKUtdeladRapportDETALJRADEREnum | null;
  DETALJFALT_BOKF?: number | null;
  DETALJFALT_BUDG?: number | null;
  DETALJNIVA_BOKF?: TEDEKUtdeladRapportDETALJNIVA_BOKFEnum | null;
  DETALJNIVA_BUDG?: TEDEKUtdeladRapportDETALJNIVA_BUDGEnum | null;
  BEHBEGR_TYP?: string | null;
  KOMP_URVAL?: boolean | null;
  SIDBRYTNING: TEDEKUtdeladRapportSIDBRYTNINGEnum;
  DISTRDETALJERAD?: TEDEKUtdeladRapportDISTRDETALJERADEnum | null;
  SKRIV_URVAL?: boolean | null;
  IDKOD?: string | null;
  UTDELNINGSTYP?: TEDEKUtdeladRapportUTDELNINGSTYPEnum | null;
  _Associations?: TEDInputEKUtdeladRapportAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av utdelad rapport
 */
export interface TEDInputEKUtdeladRapportDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid tillägg av prenumerant
 */
export interface TEDInputEKUtdeladRapportPrenAddAssociationValues {
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
}

/**
 * Värden vid tillägg av prenumerant
 */
export interface TEDInputEKUtdeladRapportPrenAddValues {
  TYP: TEDEKUtdeladRapportPrenTYPEnum;
  EXTERNANV_ID?: number | null;
  _Associations?: TEDInputEKUtdeladRapportPrenAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av prenumerant
 */
export interface TEDInputEKUtdeladRapportPrenUpdateAssociationValues {
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
}

/**
 * Nya värden vid ändring av prenumerant
 */
export interface TEDInputEKUtdeladRapportPrenUpdateValues {
  id: string;
  _version: number;
  TYP?: TEDEKUtdeladRapportPrenTYPEnum | null;
  EXTERNANV_ID?: number | null;
  _Associations?: TEDInputEKUtdeladRapportPrenUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av utdelad rapport
 */
export interface TEDInputEKUtdeladRapportUpdateAssociationValues {
  Rapport_Ref?: string | null;
  Rapport_Values?: TEDInputEKEkonomirapportUpdateValues | null;
  Prenumeranter_Ref?: string | null;
  Prenumeranter_Values?: TEDInputEKUtdeladRapportPrenUpdateValues | null;
  Rapportpaket_Ref?: string | null;
  Rapportpaket_Values?: TEDInputEKRapportpaketUpdateValues | null;
  Grundurval_Ref?: string | null;
  Grundurval_Values?: TEDInputSYSUrvalUpdateValues | null;
  UtdeladTill_Add_Values?: TEDInputEKTEDEKUtdeladRapportAnvAddValues[] | null;
  UtdeladTill_Update_Values?: TEDInputEKTEDEKUtdeladRapportAnvUpdateValues[] | null;
  UtdeladTill_Delete_Values?: TEDInputEKTEDEKUtdeladRapportAnvDeleteValues[] | null;
  AnvRapport_Add_Values?: TEDInputEKAnvRapportAddValues[] | null;
  AnvRapport_Update_Values?: TEDInputEKAnvRapportUpdateValues[] | null;
  AnvRapport_Delete_Values?: TEDInputEKAnvRapportDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av utdelad rapport
 */
export interface TEDInputEKUtdeladRapportUpdateValues {
  id: string;
  _version: number;
  VIEW_ID_2?: number | null;
  DETALJRADER?: TEDEKUtdeladRapportDETALJRADEREnum | null;
  DETALJFALT_BOKF?: number | null;
  DETALJFALT_BUDG?: number | null;
  DETALJNIVA_BOKF?: TEDEKUtdeladRapportDETALJNIVA_BOKFEnum | null;
  DETALJNIVA_BUDG?: TEDEKUtdeladRapportDETALJNIVA_BUDGEnum | null;
  BEHBEGR_TYP?: string | null;
  KOMP_URVAL?: boolean | null;
  SIDBRYTNING?: TEDEKUtdeladRapportSIDBRYTNINGEnum | null;
  DISTRDETALJERAD?: TEDEKUtdeladRapportDISTRDETALJERADEnum | null;
  SKRIV_URVAL?: boolean | null;
  IDKOD?: string | null;
  UTDELNINGSTYP?: TEDEKUtdeladRapportUTDELNINGSTYPEnum | null;
  _Associations?: TEDInputEKUtdeladRapportUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av arbetsunderlag
 */
export interface TEDInputGAArbUndAddAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputGAArbUndBlobAddValues | null;
  Distrikt_Ref?: string | null;
  Distrikt_Values?: TEDInputGADistriktAddValues | null;
  Arsskotsel_Add_Values?: TEDInputGAArbUndSkotselAddValues[] | null;
}

/**
 * Värden vid tillägg av arbetsunderlag
 */
export interface TEDInputGAArbUndAddValues {
  NUMMER?: number | null;
  RUBRIK?: string | null;
  STATUS?: TEDGAArbUndSTATUSEnum | null;
  DATUM_SKAPAD?: any | null;
  SIGN_SKAPAD?: string | null;
  DATUM_UTSKRIVEN?: any | null;
  SIGN_UTSKRIVEN?: string | null;
  DATUM_BACKAD?: any | null;
  SIGN_BACKAD?: string | null;
  _Associations?: TEDInputGAArbUndAddAssociationValues | null;
}

/**
 * Värden vid tillägg av gAArbUndBlob
 */
export interface TEDInputGAArbUndBlobAddValues {
  URVAL?: string | null;
}

/**
 * Nya värden vid ändring av gAArbUndBlob
 */
export interface TEDInputGAArbUndBlobUpdateValues {
  id: string;
  _version: number;
  URVAL?: string | null;
}

/**
 * Associerade värden vid tillägg av årsskötsel
 */
export interface TEDInputGAArbUndSkotselAddAssociationValues {
  Arbetsunderlag_Ref?: string | null;
  Arbetsunderlag_Values?: TEDInputGAArbUndAddValues | null;
  Skotsel_Ref?: string | null;
  Skotsel_Values?: TEDInputGASkotselAddValues | null;
  Grav_Ref?: string | null;
  Grav_Values?: TEDInputGAGravAddValues | null;
}

/**
 * Värden vid tillägg av årsskötsel
 */
export interface TEDInputGAArbUndSkotselAddValues {
  AR?: number | null;
  DATUMKOD?: number | null;
  MANAD?: number | null;
  DAG?: number | null;
  ANTAL?: number | null;
  UTSKRIFT_PL?: boolean | null;
  PAKET?: string | null;
  PAKET_INFO?: string | null;
  _Associations?: TEDInputGAArbUndSkotselAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av årsskötsel
 */
export interface TEDInputGAArbUndSkotselDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av årsskötsel
 */
export interface TEDInputGAArbUndSkotselUpdateAssociationValues {
  Arbetsunderlag_Ref?: string | null;
  Arbetsunderlag_Values?: TEDInputGAArbUndUpdateValues | null;
  Skotsel_Ref?: string | null;
  Skotsel_Values?: TEDInputGASkotselUpdateValues | null;
  Grav_Ref?: string | null;
  Grav_Values?: TEDInputGAGravUpdateValues | null;
}

/**
 * Nya värden vid ändring av årsskötsel
 */
export interface TEDInputGAArbUndSkotselUpdateValues {
  id: string;
  _version: number;
  AR?: number | null;
  DATUMKOD?: number | null;
  MANAD?: number | null;
  DAG?: number | null;
  ANTAL?: number | null;
  UTSKRIFT_PL?: boolean | null;
  PAKET?: string | null;
  PAKET_INFO?: string | null;
  _Associations?: TEDInputGAArbUndSkotselUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av arbetsunderlag
 */
export interface TEDInputGAArbUndUpdateAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputGAArbUndBlobUpdateValues | null;
  Distrikt_Ref?: string | null;
  Distrikt_Values?: TEDInputGADistriktUpdateValues | null;
  Arsskotsel_Add_Values?: TEDInputGAArbUndSkotselAddValues[] | null;
  Arsskotsel_Update_Values?: TEDInputGAArbUndSkotselUpdateValues[] | null;
  Arsskotsel_Delete_Values?: TEDInputGAArbUndSkotselDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av arbetsunderlag
 */
export interface TEDInputGAArbUndUpdateValues {
  id: string;
  _version: number;
  NUMMER?: number | null;
  RUBRIK?: string | null;
  STATUS?: TEDGAArbUndSTATUSEnum | null;
  DATUM_SKAPAD?: any | null;
  SIGN_SKAPAD?: string | null;
  DATUM_UTSKRIVEN?: any | null;
  SIGN_UTSKRIVEN?: string | null;
  DATUM_BACKAD?: any | null;
  SIGN_BACKAD?: string | null;
  _Associations?: TEDInputGAArbUndUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av avdelning
 */
export interface TEDInputGAAvdelningAddAssociationValues {
  Kvarter_Ref?: string | null;
  Kvarter_Values?: TEDInputGAKvarterAddValues | null;
  Gravar_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av avdelning
 */
export interface TEDInputGAAvdelningAddValues {
  AVDELNING: string;
  BENAMNING?: string | null;
  _Associations?: TEDInputGAAvdelningAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av avdelning
 */
export interface TEDInputGAAvdelningUpdateAssociationValues {
  Kvarter_Ref?: string | null;
  Kvarter_Values?: TEDInputGAKvarterUpdateValues | null;
  Gravar_Add_Refs?: string[] | null;
  Gravar_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av avdelning
 */
export interface TEDInputGAAvdelningUpdateValues {
  id: string;
  _version: number;
  AVDELNING?: string | null;
  BENAMNING?: string | null;
  _Associations?: TEDInputGAAvdelningUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av ej skuldfört avtal
 */
export interface TEDInputGAAvtalAddAssociationValues {
  Grav_Ref?: string | null;
  Grav_Values?: TEDInputGAGravAddValues | null;
  Skotslar_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av ej skuldfört avtal
 */
export interface TEDInputGAAvtalAddValues {
  TYP: TEDGAAvtalTYPEnum;
  AVTALSNR?: string | null;
  KAPITAL?: any | null;
  DATUM_FR?: any | null;
  DATUM_TI?: any | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_ORSAK?: string | null;
  _Associations?: TEDInputGAAvtalAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av ej skuldfört avtal
 */
export interface TEDInputGAAvtalDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av ej skuldfört avtal
 */
export interface TEDInputGAAvtalUpdateAssociationValues {
  Grav_Ref?: string | null;
  Grav_Values?: TEDInputGAGravUpdateValues | null;
  Skotslar_Add_Refs?: string[] | null;
  Skotslar_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av ej skuldfört avtal
 */
export interface TEDInputGAAvtalUpdateValues {
  id: string;
  _version: number;
  TYP?: TEDGAAvtalTYPEnum | null;
  AVTALSNR?: string | null;
  KAPITAL?: any | null;
  DATUM_FR?: any | null;
  DATUM_TI?: any | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_ORSAK?: string | null;
  _Associations?: TEDInputGAAvtalUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av distrikt
 */
export interface TEDInputGADistriktAddAssociationValues {
  ArbetsunderlagSerie_Ref?: string | null;
  ArbetsunderlagSerie_Values?: TEDInputSYSNummerserieAddValues | null;
  KGardar_Add_Refs?: string[] | null;
  Arbetsunderlag_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av distrikt
 */
export interface TEDInputGADistriktAddValues {
  DISTRIKT: string;
  BENAMNING?: string | null;
  _Associations?: TEDInputGADistriktAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av distrikt
 */
export interface TEDInputGADistriktUpdateAssociationValues {
  ArbetsunderlagSerie_Ref?: string | null;
  ArbetsunderlagSerie_Values?: TEDInputSYSNummerserieUpdateValues | null;
  KGardar_Add_Refs?: string[] | null;
  KGardar_Delete_Refs?: string[] | null;
  Arbetsunderlag_Add_Refs?: string[] | null;
  Arbetsunderlag_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av distrikt
 */
export interface TEDInputGADistriktUpdateValues {
  id: string;
  _version: number;
  DISTRIKT?: string | null;
  BENAMNING?: string | null;
  _Associations?: TEDInputGADistriktUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av gravrättsinnehavare
 */
export interface TEDInputGAGRIHistorikAddAssociationValues {
  Grav_Ref?: string | null;
  Grav_Values?: TEDInputGAGravAddValues | null;
}

/**
 * Värden vid tillägg av gravrättsinnehavare
 */
export interface TEDInputGAGRIHistorikAddValues {
  PERS_NR?: string | null;
  EFTERNAMN?: string | null;
  FORNAMN?: string | null;
  ADRESS?: string | null;
  LAND?: string | null;
  ANTECKNINGAR?: string | null;
  DATUM_FR?: any | null;
  DATUM_TI?: any | null;
  _Associations?: TEDInputGAGRIHistorikAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av gravrättsinnehavare
 */
export interface TEDInputGAGRIHistorikDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av gravrättsinnehavare
 */
export interface TEDInputGAGRIHistorikUpdateAssociationValues {
  Grav_Ref?: string | null;
  Grav_Values?: TEDInputGAGravUpdateValues | null;
}

/**
 * Nya värden vid ändring av gravrättsinnehavare
 */
export interface TEDInputGAGRIHistorikUpdateValues {
  id: string;
  _version: number;
  PERS_NR?: string | null;
  EFTERNAMN?: string | null;
  FORNAMN?: string | null;
  ADRESS?: string | null;
  LAND?: string | null;
  ANTECKNINGAR?: string | null;
  DATUM_FR?: any | null;
  DATUM_TI?: any | null;
  _Associations?: TEDInputGAGRIHistorikUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av dokument
 */
export interface TEDInputGAGravActiveXAddAssociationValues {
  Begravningsplats_Ref?: string | null;
  Begravningsplats_Values?: TEDInputGAGravAddValues | null;
}

/**
 * Värden vid tillägg av dokument
 */
export interface TEDInputGAGravActiveXAddValues {
  BESKRIVNING?: string | null;
  FILNAMN?: string | null;
  SENAST_ANDRAD?: any | null;
  DATA?: string | null;
  DATASIZE?: number | null;
  DATATYPE?: string | null;
  EXTENSION?: string | null;
  SIGNATUR?: string | null;
  _Associations?: TEDInputGAGravActiveXAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av dokument
 */
export interface TEDInputGAGravActiveXDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av dokument
 */
export interface TEDInputGAGravActiveXUpdateAssociationValues {
  Begravningsplats_Ref?: string | null;
  Begravningsplats_Values?: TEDInputGAGravUpdateValues | null;
}

/**
 * Nya värden vid ändring av dokument
 */
export interface TEDInputGAGravActiveXUpdateValues {
  id: string;
  _version: number;
  BESKRIVNING?: string | null;
  FILNAMN?: string | null;
  SENAST_ANDRAD?: any | null;
  DATA?: string | null;
  DATASIZE?: number | null;
  DATATYPE?: string | null;
  EXTENSION?: string | null;
  SIGNATUR?: string | null;
  _Associations?: TEDInputGAGravActiveXUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av grav/Annan ort
 */
export interface TEDInputGAGravAddAssociationValues {
  KGard_Ref?: string | null;
  KGard_Values?: TEDInputGAKGardAddValues | null;
  Kvarter_Ref?: string | null;
  Kvarter_Values?: TEDInputGAKvarterAddValues | null;
  Avdelning_Ref?: string | null;
  Avdelning_Values?: TEDInputGAAvdelningAddValues | null;
  Mall_Ref?: string | null;
  Mall_Values?: TEDInputGAMallAddValues | null;
  GravrInhOmbud_Ref?: string | null;
  GravrInhOmbud_Values?: TEDInputGAKontaktAddValues | null;
  AktuellGrav_Ref?: string | null;
  AktuellGrav_Values?: TEDInputGAGravAddValues | null;
  SenastGS_Ref?: string | null;
  SenastGS_Values?: TEDInputGAGravsattAddValues | null;
  AnordningYta_Ref?: string | null;
  AnordningYta_Values?: TEDInputGAGravYtaAddValues | null;
  AnordningKultur_Ref?: string | null;
  AnordningKultur_Values?: TEDInputGAGravKulturAddValues | null;
  SkotselKategori_Ref?: string | null;
  SkotselKategori_Values?: TEDInputGASkotselKategoriAddValues | null;
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputGAGravBlobAddValues | null;
  Gravsatta_Add_Values?: TEDInputGAGravsattAddValues[] | null;
  GravsattaFlyttade_Add_Values?: TEDInputGAGravsattFlyttadAddValues[] | null;
  Dokument_Add_Values?: TEDInputGAGravActiveXAddValues[] | null;
  Statuskoder_Add_Values?: TEDInputGAGravGravStatusAddValues[] | null;
  Kontakter_Add_Values?: TEDInputGAKontaktAddValues[] | null;
  BetAnsv_Add_Refs?: string[] | null;
  GravrInh_Add_Refs?: string[] | null;
  OvrKontakter_Add_Refs?: string[] | null;
  Avtal_Add_Values?: TEDInputGAAvtalAddValues[] | null;
  Skotslar_Add_Values?: TEDInputGASkotselAddValues[] | null;
  Djup_Add_Values?: TEDInputGAGravDjupAddValues[] | null;
  GRIHistorik_Add_Values?: TEDInputGAGRIHistorikAddValues[] | null;
  GravrattHist_Add_Values?: TEDInputGAGravrattHistAddValues[] | null;
  UplOmg_Add_Refs?: string[] | null;
  Handelser_Add_Values?: TEDInputGAHandelseAddValues[] | null;
  Vanvard_Add_Refs?: string[] | null;
  Anordningar_Add_Values?: TEDInputGAGravanordningAddValues[] | null;
  GiltigaSkotslar_Add_Refs?: string[] | null;
  Bilder_Add_Values?: TEDInputGAGravBlobAddValues[] | null;
  Dodsbo_Add_Values?: TEDInputGAKontaktAddValues[] | null;
}

/**
 * Värden vid tillägg av grav/Annan ort
 */
export interface TEDInputGAGravAddValues {
  _typ: TEDGAGravTypEnum;
  GRAVPLATS_ID?: number | null;
  GRAVNUMMER: string;
  GRAVNUMMER_FULLT?: string | null;
  GRAVNUMMER_NUMERISKT?: string | null;
  ANTECKNINGAR?: string | null;
  ANDRINGSDATUM?: any | null;
  ATERLAMNAD?: any | null;
  GRAVRATT_FR?: any | null;
  GRAVRATT_TI?: any | null;
  KANNETECKEN?: string | null;
  SLEK_B?: number | null;
  SLEK_L?: number | null;
  UPL_OMG?: number | null;
  UPL_STATUS?: TEDGAGravUPL_STATUSEnum | null;
  ANKULTURNOTERING?: string | null;
  BOKAD?: boolean | null;
  BOKAD_DATUM?: any | null;
  BOKAD_SIGNATUR?: string | null;
  MALL_ANMARKNING?: string | null;
  BILD_ID?: number | null;
  SEKRETESSMARKERAD?: string | null;
  _Associations: TEDInputGAGravAddAssociationValues;
}

/**
 * Associerade värden vid tillägg av bild
 */
export interface TEDInputGAGravBlobAddAssociationValues {
  Begravningsplats_Ref?: string | null;
  Begravningsplats_Values?: TEDInputGAGravAddValues | null;
  Anordning_Ref?: string | null;
  Anordning_Values?: TEDInputGAGravanordningAddValues | null;
  Kontroll_Ref?: string | null;
  Kontroll_Values?: TEDInputGAGravKontrollAddValues | null;
}

/**
 * Värden vid tillägg av bild
 */
export interface TEDInputGAGravBlobAddValues {
  GRAV_ID?: number | null;
  BILD?: string | null;
  BILDSIZE?: number | null;
  BILDSTRETCH?: string | null;
  BILDANTECKNING?: string | null;
  BILDDATUM?: any | null;
  BILD_ANDRAD?: any | null;
  BILD_ANDRAD_SIGN?: string | null;
  BILD_WEBAVENY?: boolean | null;
  TYP?: string | null;
  BILD_BENAMNING?: string | null;
  _Associations: TEDInputGAGravBlobAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av bild
 */
export interface TEDInputGAGravBlobDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av bild
 */
export interface TEDInputGAGravBlobUpdateAssociationValues {
  Begravningsplats_Ref?: string | null;
  Begravningsplats_Values?: TEDInputGAGravUpdateValues | null;
  Anordning_Ref?: string | null;
  Anordning_Values?: TEDInputGAGravanordningUpdateValues | null;
  Kontroll_Ref?: string | null;
  Kontroll_Values?: TEDInputGAGravKontrollUpdateValues | null;
}

/**
 * Nya värden vid ändring av bild
 */
export interface TEDInputGAGravBlobUpdateValues {
  id: string;
  _version: number;
  GRAV_ID?: number | null;
  BILD?: string | null;
  BILDSIZE?: number | null;
  BILDSTRETCH?: string | null;
  BILDANTECKNING?: string | null;
  BILDDATUM?: any | null;
  BILD_ANDRAD?: any | null;
  BILD_ANDRAD_SIGN?: string | null;
  BILD_WEBAVENY?: boolean | null;
  TYP?: string | null;
  BILD_BENAMNING?: string | null;
  _Associations?: TEDInputGAGravBlobUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av djup
 */
export interface TEDInputGAGravDjupAddAssociationValues {
  Grav_Ref?: string | null;
  Grav_Values?: TEDInputGAGravAddValues | null;
  Kistmall_Ref?: string | null;
  Kistmall_Values?: TEDInputGAMallAddValues | null;
  Urnmall_Ref?: string | null;
  Urnmall_Values?: TEDInputGAMallAddValues | null;
}

/**
 * Värden vid tillägg av djup
 */
export interface TEDInputGAGravDjupAddValues {
  MINDJUP?: number | null;
  MAXDJUP?: number | null;
  URNKAMMARE_PLAC?: string | null;
  _Associations?: TEDInputGAGravDjupAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av djup
 */
export interface TEDInputGAGravDjupDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av djup
 */
export interface TEDInputGAGravDjupUpdateAssociationValues {
  Grav_Ref?: string | null;
  Grav_Values?: TEDInputGAGravUpdateValues | null;
  Kistmall_Ref?: string | null;
  Kistmall_Values?: TEDInputGAMallUpdateValues | null;
  Urnmall_Ref?: string | null;
  Urnmall_Values?: TEDInputGAMallUpdateValues | null;
}

/**
 * Nya värden vid ändring av djup
 */
export interface TEDInputGAGravDjupUpdateValues {
  id: string;
  _version: number;
  MINDJUP?: number | null;
  MAXDJUP?: number | null;
  URNKAMMARE_PLAC?: string | null;
  _Associations?: TEDInputGAGravDjupUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av statuskod
 */
export interface TEDInputGAGravGravStatusAddAssociationValues {
  Grav_Ref?: string | null;
  Grav_Values?: TEDInputGAGravAddValues | null;
  Status_Ref?: string | null;
  Status_Values?: TEDInputGAGravStatusAddValues | null;
}

/**
 * Värden vid tillägg av statuskod
 */
export interface TEDInputGAGravGravStatusAddValues {
  _Associations: TEDInputGAGravGravStatusAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av statuskod
 */
export interface TEDInputGAGravGravStatusDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av statuskod
 */
export interface TEDInputGAGravGravStatusUpdateAssociationValues {
  Grav_Ref?: string | null;
  Grav_Values?: TEDInputGAGravUpdateValues | null;
  Status_Ref?: string | null;
  Status_Values?: TEDInputGAGravStatusUpdateValues | null;
}

/**
 * Nya värden vid ändring av statuskod
 */
export interface TEDInputGAGravGravStatusUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputGAGravGravStatusUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av ansvarig
 */
export interface TEDInputGAGravHandelseAnsvarigAddAssociationValues {
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
}

/**
 * Värden vid tillägg av ansvarig
 */
export interface TEDInputGAGravHandelseAnsvarigAddValues {
  ID?: number | null;
  EMAIL?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  ANSVARIG_NAMN?: string | null;
  _Associations?: TEDInputGAGravHandelseAnsvarigAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av ansvarig
 */
export interface TEDInputGAGravHandelseAnsvarigUpdateAssociationValues {
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
}

/**
 * Nya värden vid ändring av ansvarig
 */
export interface TEDInputGAGravHandelseAnsvarigUpdateValues {
  id: string;
  _version: number;
  ID?: number | null;
  EMAIL?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  ANSVARIG_NAMN?: string | null;
  _Associations?: TEDInputGAGravHandelseAnsvarigUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av stenkontroll
 */
export interface TEDInputGAGravKontrollAddAssociationValues {
  Begravningsplats_Ref?: string | null;
  Begravningsplats_Values?: TEDInputGAGravAddValues | null;
  Bild_Ref?: string | null;
  Bild_Values?: TEDInputGAGravBlobAddValues | null;
  Anordning_Ref?: string | null;
  Anordning_Values?: TEDInputGAGravanordningAddValues | null;
}

/**
 * Värden vid tillägg av stenkontroll
 */
export interface TEDInputGAGravKontrollAddValues {
  DATUM: any;
  STATUS?: TEDGAGravKontrollSTATUSEnum | null;
  LUTNING?: number | null;
  NOTERING?: string | null;
  SIGNATUR?: string | null;
  ANMARKNINGAR?: string | null;
  BILD_ID?: number | null;
  _Associations: TEDInputGAGravKontrollAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av stenkontroll
 */
export interface TEDInputGAGravKontrollDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av stenkontroll
 */
export interface TEDInputGAGravKontrollUpdateAssociationValues {
  Begravningsplats_Ref?: string | null;
  Begravningsplats_Values?: TEDInputGAGravUpdateValues | null;
  Bild_Ref?: string | null;
  Bild_Values?: TEDInputGAGravBlobUpdateValues | null;
  Anordning_Ref?: string | null;
  Anordning_Values?: TEDInputGAGravanordningUpdateValues | null;
}

/**
 * Nya värden vid ändring av stenkontroll
 */
export interface TEDInputGAGravKontrollUpdateValues {
  id: string;
  _version: number;
  DATUM?: any | null;
  STATUS?: TEDGAGravKontrollSTATUSEnum | null;
  LUTNING?: number | null;
  NOTERING?: string | null;
  SIGNATUR?: string | null;
  ANMARKNINGAR?: string | null;
  BILD_ID?: number | null;
  _Associations?: TEDInputGAGravKontrollUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av kulturvärde
 */
export interface TEDInputGAGravKulturAddValues {
  BENAMNING: string;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_ORSAK?: string | null;
  STANDARD?: boolean | null;
  AKTIV?: boolean | null;
}

/**
 * Nya värden vid ändring av kulturvärde
 */
export interface TEDInputGAGravKulturUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_ORSAK?: string | null;
  STANDARD?: boolean | null;
  AKTIV?: boolean | null;
}

/**
 * Värden vid tillägg av material
 */
export interface TEDInputGAGravMaterialAddValues {
  BENAMNING?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_ORSAK?: string | null;
}

/**
 * Nya värden vid ändring av material
 */
export interface TEDInputGAGravMaterialUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_ORSAK?: string | null;
}

/**
 * Värden vid tillägg av statuskod
 */
export interface TEDInputGAGravStatusAddValues {
  STATUS?: string | null;
  BENAMNING: string;
}

/**
 * Nya värden vid ändring av statuskod
 */
export interface TEDInputGAGravStatusUpdateValues {
  id: string;
  _version: number;
  STATUS?: string | null;
  BENAMNING?: string | null;
}

/**
 * Associerade värden vid ändring av grav/Annan ort
 */
export interface TEDInputGAGravUpdateAssociationValues {
  KGard_Ref?: string | null;
  KGard_Values?: TEDInputGAKGardUpdateValues | null;
  Kvarter_Ref?: string | null;
  Kvarter_Values?: TEDInputGAKvarterUpdateValues | null;
  Avdelning_Ref?: string | null;
  Avdelning_Values?: TEDInputGAAvdelningUpdateValues | null;
  Mall_Ref?: string | null;
  Mall_Values?: TEDInputGAMallUpdateValues | null;
  GravrInhOmbud_Ref?: string | null;
  GravrInhOmbud_Values?: TEDInputGAKontaktUpdateValues | null;
  AktuellGrav_Ref?: string | null;
  AktuellGrav_Values?: TEDInputGAGravUpdateValues | null;
  SenastGS_Ref?: string | null;
  SenastGS_Values?: TEDInputGAGravsattUpdateValues | null;
  AnordningYta_Ref?: string | null;
  AnordningYta_Values?: TEDInputGAGravYtaUpdateValues | null;
  AnordningKultur_Ref?: string | null;
  AnordningKultur_Values?: TEDInputGAGravKulturUpdateValues | null;
  SkotselKategori_Ref?: string | null;
  SkotselKategori_Values?: TEDInputGASkotselKategoriUpdateValues | null;
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputGAGravBlobUpdateValues | null;
  Gravsatta_Add_Values?: TEDInputGAGravsattAddValues[] | null;
  Gravsatta_Update_Values?: TEDInputGAGravsattUpdateValues[] | null;
  Gravsatta_Delete_Values?: TEDInputGAGravsattDeleteValues[] | null;
  GravsattaFlyttade_Add_Values?: TEDInputGAGravsattFlyttadAddValues[] | null;
  GravsattaFlyttade_Update_Values?: TEDInputGAGravsattFlyttadUpdateValues[] | null;
  GravsattaFlyttade_Delete_Values?: TEDInputGAGravsattFlyttadDeleteValues[] | null;
  Dokument_Add_Values?: TEDInputGAGravActiveXAddValues[] | null;
  Dokument_Update_Values?: TEDInputGAGravActiveXUpdateValues[] | null;
  Dokument_Delete_Values?: TEDInputGAGravActiveXDeleteValues[] | null;
  Statuskoder_Add_Values?: TEDInputGAGravGravStatusAddValues[] | null;
  Statuskoder_Update_Values?: TEDInputGAGravGravStatusUpdateValues[] | null;
  Statuskoder_Delete_Values?: TEDInputGAGravGravStatusDeleteValues[] | null;
  Kontakter_Add_Values?: TEDInputGAKontaktAddValues[] | null;
  Kontakter_Update_Values?: TEDInputGAKontaktUpdateValues[] | null;
  Kontakter_Delete_Values?: TEDInputGAKontaktDeleteValues[] | null;
  Kontakter_Undelete?: TEDInputGAKontaktDeleteValues[] | null;
  BetAnsv_Add_Refs?: string[] | null;
  BetAnsv_Delete_Refs?: string[] | null;
  GravrInh_Add_Refs?: string[] | null;
  GravrInh_Delete_Refs?: string[] | null;
  OvrKontakter_Add_Refs?: string[] | null;
  OvrKontakter_Delete_Refs?: string[] | null;
  Avtal_Add_Values?: TEDInputGAAvtalAddValues[] | null;
  Avtal_Update_Values?: TEDInputGAAvtalUpdateValues[] | null;
  Avtal_Delete_Values?: TEDInputGAAvtalDeleteValues[] | null;
  Avtal_Undelete?: TEDInputGAAvtalDeleteValues[] | null;
  Skotslar_Add_Values?: TEDInputGASkotselAddValues[] | null;
  Skotslar_Update_Values?: TEDInputGASkotselUpdateValues[] | null;
  Skotslar_Delete_Values?: TEDInputGASkotselDeleteValues[] | null;
  Djup_Add_Values?: TEDInputGAGravDjupAddValues[] | null;
  Djup_Update_Values?: TEDInputGAGravDjupUpdateValues[] | null;
  Djup_Delete_Values?: TEDInputGAGravDjupDeleteValues[] | null;
  GRIHistorik_Add_Values?: TEDInputGAGRIHistorikAddValues[] | null;
  GRIHistorik_Update_Values?: TEDInputGAGRIHistorikUpdateValues[] | null;
  GRIHistorik_Delete_Values?: TEDInputGAGRIHistorikDeleteValues[] | null;
  GravrattHist_Add_Values?: TEDInputGAGravrattHistAddValues[] | null;
  GravrattHist_Update_Values?: TEDInputGAGravrattHistUpdateValues[] | null;
  GravrattHist_Delete_Values?: TEDInputGAGravrattHistDeleteValues[] | null;
  UplOmg_Add_Refs?: string[] | null;
  UplOmg_Delete_Refs?: string[] | null;
  Handelser_Add_Values?: TEDInputGAHandelseAddValues[] | null;
  Handelser_Update_Values?: TEDInputGAHandelseUpdateValues[] | null;
  Handelser_Delete_Values?: TEDInputGAHandelseDeleteValues[] | null;
  Vanvard_Add_Refs?: string[] | null;
  Vanvard_Delete_Refs?: string[] | null;
  Anordningar_Add_Values?: TEDInputGAGravanordningAddValues[] | null;
  Anordningar_Update_Values?: TEDInputGAGravanordningUpdateValues[] | null;
  Anordningar_Delete_Values?: TEDInputGAGravanordningDeleteValues[] | null;
  Anordningar_Undelete?: TEDInputGAGravanordningDeleteValues[] | null;
  GiltigaSkotslar_Add_Refs?: string[] | null;
  GiltigaSkotslar_Delete_Refs?: string[] | null;
  Bilder_Add_Values?: TEDInputGAGravBlobAddValues[] | null;
  Bilder_Update_Values?: TEDInputGAGravBlobUpdateValues[] | null;
  Bilder_Delete_Values?: TEDInputGAGravBlobDeleteValues[] | null;
  Dodsbo_Add_Values?: TEDInputGAKontaktAddValues[] | null;
  Dodsbo_Update_Values?: TEDInputGAKontaktUpdateValues[] | null;
  Dodsbo_Delete_Values?: TEDInputGAKontaktDeleteValues[] | null;
  Dodsbo_Undelete?: TEDInputGAKontaktDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av grav/Annan ort
 */
export interface TEDInputGAGravUpdateValues {
  id: string;
  _version: number;
  GRAVPLATS_ID?: number | null;
  GRAVNUMMER?: string | null;
  GRAVNUMMER_FULLT?: string | null;
  GRAVNUMMER_NUMERISKT?: string | null;
  ANTECKNINGAR?: string | null;
  ANDRINGSDATUM?: any | null;
  ATERLAMNAD?: any | null;
  GRAVRATT_FR?: any | null;
  GRAVRATT_TI?: any | null;
  KANNETECKEN?: string | null;
  SLEK_B?: number | null;
  SLEK_L?: number | null;
  UPL_OMG?: number | null;
  UPL_STATUS?: TEDGAGravUPL_STATUSEnum | null;
  ANKULTURNOTERING?: string | null;
  BOKAD?: boolean | null;
  BOKAD_DATUM?: any | null;
  BOKAD_SIGNATUR?: string | null;
  MALL_ANMARKNING?: string | null;
  BILD_ID?: number | null;
  SEKRETESSMARKERAD?: string | null;
  _Associations?: TEDInputGAGravUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av ytbeläggning
 */
export interface TEDInputGAGravYtaAddValues {
  BENAMNING?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_ORSAK?: string | null;
}

/**
 * Nya värden vid ändring av ytbeläggning
 */
export interface TEDInputGAGravYtaUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_ORSAK?: string | null;
}

/**
 * Associerade värden vid tillägg av gravanordning
 */
export interface TEDInputGAGravanordningAddAssociationValues {
  AnordningMaterial_Ref?: string | null;
  AnordningMaterial_Values?: TEDInputGAGravMaterialAddValues | null;
  Stenhuggeri_Ref?: string | null;
  Stenhuggeri_Values?: TEDInputOPOrgPersLokAddValues | null;
  Begravningsplats_Ref?: string | null;
  Begravningsplats_Values?: TEDInputGAGravAddValues | null;
  SenasteKontroll_Ref?: string | null;
  SenasteKontroll_Values?: TEDInputGAGravKontrollAddValues | null;
  Bild_Ref?: string | null;
  Bild_Values?: TEDInputGAGravBlobAddValues | null;
  Stenkontroll_Add_Values?: TEDInputGAGravKontrollAddValues[] | null;
}

/**
 * Värden vid tillägg av gravanordning
 */
export interface TEDInputGAGravanordningAddValues {
  ANHOJD?: number | null;
  ANBESKRIVNING?: string | null;
  ANDATUM?: any | null;
  ANNAMN?: string | null;
  ANBESLUT?: string | null;
  ANBENAMNING?: string | null;
  ANNR?: number | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN?: string | null;
  NOTERING?: string | null;
  ANBREDD?: number | null;
  ANTJOCKLEK?: number | null;
  BILD_ID?: number | null;
  _Associations?: TEDInputGAGravanordningAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av gravanordning
 */
export interface TEDInputGAGravanordningDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av gravanordning
 */
export interface TEDInputGAGravanordningUpdateAssociationValues {
  AnordningMaterial_Ref?: string | null;
  AnordningMaterial_Values?: TEDInputGAGravMaterialUpdateValues | null;
  Stenhuggeri_Ref?: string | null;
  Stenhuggeri_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Begravningsplats_Ref?: string | null;
  Begravningsplats_Values?: TEDInputGAGravUpdateValues | null;
  SenasteKontroll_Ref?: string | null;
  SenasteKontroll_Values?: TEDInputGAGravKontrollUpdateValues | null;
  Bild_Ref?: string | null;
  Bild_Values?: TEDInputGAGravBlobUpdateValues | null;
  Stenkontroll_Add_Values?: TEDInputGAGravKontrollAddValues[] | null;
  Stenkontroll_Update_Values?: TEDInputGAGravKontrollUpdateValues[] | null;
  Stenkontroll_Delete_Values?: TEDInputGAGravKontrollDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av gravanordning
 */
export interface TEDInputGAGravanordningUpdateValues {
  id: string;
  _version: number;
  ANHOJD?: number | null;
  ANBESKRIVNING?: string | null;
  ANDATUM?: any | null;
  ANNAMN?: string | null;
  ANBESLUT?: string | null;
  ANBENAMNING?: string | null;
  ANNR?: number | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN?: string | null;
  NOTERING?: string | null;
  ANBREDD?: number | null;
  ANTJOCKLEK?: number | null;
  BILD_ID?: number | null;
  _Associations?: TEDInputGAGravanordningUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av gravrättshistorik
 */
export interface TEDInputGAGravrattHistAddAssociationValues {
  Gravplats_Ref?: string | null;
  Gravplats_Values?: TEDInputGAGravAddValues | null;
}

/**
 * Värden vid tillägg av gravrättshistorik
 */
export interface TEDInputGAGravrattHistAddValues {
  GILTIG_DATUM: any;
  AUTO?: string | null;
  GRAVRATT_FR?: any | null;
  GRAVRATT_TI?: any | null;
  ORSAK: TEDGAGravrattHistORSAKEnum;
  ANDRAD_DATUM: any;
  ANDRAD_SIGNATUR: string;
  ANTECKNING?: string | null;
  ANTAL_AR?: number | null;
  _Associations?: TEDInputGAGravrattHistAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av gravrättshistorik
 */
export interface TEDInputGAGravrattHistDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av gravrättshistorik
 */
export interface TEDInputGAGravrattHistUpdateAssociationValues {
  Gravplats_Ref?: string | null;
  Gravplats_Values?: TEDInputGAGravUpdateValues | null;
}

/**
 * Nya värden vid ändring av gravrättshistorik
 */
export interface TEDInputGAGravrattHistUpdateValues {
  id: string;
  _version: number;
  GILTIG_DATUM?: any | null;
  AUTO?: string | null;
  GRAVRATT_FR?: any | null;
  GRAVRATT_TI?: any | null;
  ORSAK?: TEDGAGravrattHistORSAKEnum | null;
  ANDRAD_DATUM?: any | null;
  ANDRAD_SIGNATUR?: string | null;
  ANTECKNING?: string | null;
  ANTAL_AR?: number | null;
  _Associations?: TEDInputGAGravrattHistUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av gravsatt
 */
export interface TEDInputGAGravsattAddAssociationValues {
  Begravningsplats_Ref?: string | null;
  Begravningsplats_Values?: TEDInputGAGravAddValues | null;
  CheckDjup_Ref?: string | null;
  CheckDjup_Values?: TEDInputGAGravDjupAddValues | null;
  Avlidna_Ref?: string | null;
  Avlidna_Values?: TEDInputOPAvlidenAddValues | null;
}

/**
 * Värden vid tillägg av gravsatt
 */
export interface TEDInputGAGravsattAddValues {
  _typ: TEDGAGravsattTypEnum;
  VISA_EJ_PA_FRAMSIDAN?: TEDGAGravsattVISA_EJ_PA_FRAMSIDANEnum | null;
  PUBLICERA_SIGNATUR?: string | null;
  PUBLICERA_DATUM?: any | null;
  PUBLICERA_NOTERING?: string | null;
  URNPLATS?: string | null;
  KISTPLATS?: string | null;
  PLAC_ANM?: string | null;
  GRAVS_ORT?: string | null;
  _Associations: TEDInputGAGravsattAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av gravsatt
 */
export interface TEDInputGAGravsattDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid tillägg av flyttad gravsatt
 */
export interface TEDInputGAGravsattFlyttadAddAssociationValues {
  Begravningsplats_Ref?: string | null;
  Begravningsplats_Values?: TEDInputGAGravAddValues | null;
  Avliden_Ref?: string | null;
  Avliden_Values?: TEDInputOPOrgPersLokAddValues | null;
}

/**
 * Värden vid tillägg av flyttad gravsatt
 */
export interface TEDInputGAGravsattFlyttadAddValues {
  P_ID?: number | null;
  DODSDATUM?: string | null;
  BEGR_DATUM?: string | null;
  GRAVS_DATUM?: string | null;
  NOTERING?: string | null;
  SIGNATUR?: string | null;
  FLYTTDATUM?: any | null;
  _Associations?: TEDInputGAGravsattFlyttadAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av flyttad gravsatt
 */
export interface TEDInputGAGravsattFlyttadDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av flyttad gravsatt
 */
export interface TEDInputGAGravsattFlyttadUpdateAssociationValues {
  Begravningsplats_Ref?: string | null;
  Begravningsplats_Values?: TEDInputGAGravUpdateValues | null;
  Avliden_Ref?: string | null;
  Avliden_Values?: TEDInputOPOrgPersLokUpdateValues | null;
}

/**
 * Nya värden vid ändring av flyttad gravsatt
 */
export interface TEDInputGAGravsattFlyttadUpdateValues {
  id: string;
  _version: number;
  P_ID?: number | null;
  DODSDATUM?: string | null;
  BEGR_DATUM?: string | null;
  GRAVS_DATUM?: string | null;
  NOTERING?: string | null;
  SIGNATUR?: string | null;
  FLYTTDATUM?: any | null;
  _Associations?: TEDInputGAGravsattFlyttadUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av gravsatt
 */
export interface TEDInputGAGravsattUpdateAssociationValues {
  Begravningsplats_Ref?: string | null;
  Begravningsplats_Values?: TEDInputGAGravUpdateValues | null;
  CheckDjup_Ref?: string | null;
  CheckDjup_Values?: TEDInputGAGravDjupUpdateValues | null;
  Avlidna_Ref?: string | null;
  Avlidna_Values?: TEDInputOPAvlidenUpdateValues | null;
}

/**
 * Nya värden vid ändring av gravsatt
 */
export interface TEDInputGAGravsattUpdateValues {
  id: string;
  _version: number;
  VISA_EJ_PA_FRAMSIDAN?: TEDGAGravsattVISA_EJ_PA_FRAMSIDANEnum | null;
  PUBLICERA_SIGNATUR?: string | null;
  PUBLICERA_DATUM?: any | null;
  PUBLICERA_NOTERING?: string | null;
  URNPLATS?: string | null;
  KISTPLATS?: string | null;
  PLAC_ANM?: string | null;
  GRAVS_ORT?: string | null;
  _Associations?: TEDInputGAGravsattUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av händelse
 */
export interface TEDInputGAHandelseAddAssociationValues {
  Parent_Ref?: string | null;
  Parent_Values?: TEDInputGAHandelseAddValues | null;
  Grav_Ref?: string | null;
  Grav_Values?: TEDInputGAGravAddValues | null;
  SystemHandelse_Ref?: string | null;
  SystemHandelse_Values?: TEDInputSysHandelseAddValues | null;
  Bisattning_Ref?: string | null;
  Bisattning_Values?: TEDInputBOBisattningAddValues | null;
  Ansvarig_Ref?: string | null;
  Ansvarig_Values?: TEDInputGAGravHandelseAnsvarigAddValues | null;
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetAddValues | null;
  Mottagare_Add_Values?: TEDInputGAHandelseMottagareAddValues[] | null;
  MottagareGrav_Add_Values?: TEDInputGAHandelseMottagareAddValues[] | null;
  Children_Add_Refs?: string[] | null;
  MottagareBisattning_Add_Values?: TEDInputBOBisattningMottagareAddValues[] | null;
  MottagareAktivitet_Add_Values?: TEDInputBOAktivitetMottagareAddValues[] | null;
}

/**
 * Värden vid tillägg av händelse
 */
export interface TEDInputGAHandelseAddValues {
  _typ: TEDGAHandelseTypEnum;
  SIGNATUR?: string | null;
  RUBRIK: string;
  TEXT?: string | null;
  DATA?: string | null;
  DATA_NAMN?: string | null;
  KLAR?: TEDGAHandelseKLAREnum | null;
  BEVAKNINGSDATUM?: any | null;
  STATUS_SIGNATUR?: string | null;
  STATUS_WEBAVENY?: boolean | null;
  ANSVARIG_ID?: number | null;
  _Associations?: TEDInputGAHandelseAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av händelse
 */
export interface TEDInputGAHandelseDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid tillägg av dödsbo händelse
 */
export interface TEDInputGAHandelseDodsboAddAssociationValues {
  Handelse_Ref?: string | null;
  Handelse_Values?: TEDInputGAHandelseAddValues | null;
}

/**
 * Värden vid tillägg av dödsbo händelse
 */
export interface TEDInputGAHandelseDodsboAddValues {
  _Associations: TEDInputGAHandelseDodsboAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av dödsbo händelse
 */
export interface TEDInputGAHandelseDodsboDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av dödsbo händelse
 */
export interface TEDInputGAHandelseDodsboUpdateAssociationValues {
  Handelse_Ref?: string | null;
  Handelse_Values?: TEDInputGAHandelseUpdateValues | null;
}

/**
 * Nya värden vid ändring av dödsbo händelse
 */
export interface TEDInputGAHandelseDodsboUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputGAHandelseDodsboUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av mottagare
 */
export interface TEDInputGAHandelseMottagareAddAssociationValues {
  Handelse_Ref?: string | null;
  Handelse_Values?: TEDInputGAHandelseAddValues | null;
  Kontakt_Ref?: string | null;
  Kontakt_Values?: TEDInputGAKontaktAddValues | null;
}

/**
 * Värden vid tillägg av mottagare
 */
export interface TEDInputGAHandelseMottagareAddValues {
  _Associations: TEDInputGAHandelseMottagareAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av mottagare
 */
export interface TEDInputGAHandelseMottagareDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av mottagare
 */
export interface TEDInputGAHandelseMottagareUpdateAssociationValues {
  Handelse_Ref?: string | null;
  Handelse_Values?: TEDInputGAHandelseUpdateValues | null;
  Kontakt_Ref?: string | null;
  Kontakt_Values?: TEDInputGAKontaktUpdateValues | null;
}

/**
 * Nya värden vid ändring av mottagare
 */
export interface TEDInputGAHandelseMottagareUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputGAHandelseMottagareUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av händelse
 */
export interface TEDInputGAHandelseUpdateAssociationValues {
  Parent_Ref?: string | null;
  Parent_Values?: TEDInputGAHandelseUpdateValues | null;
  Grav_Ref?: string | null;
  Grav_Values?: TEDInputGAGravUpdateValues | null;
  SystemHandelse_Ref?: string | null;
  SystemHandelse_Values?: TEDInputSysHandelseUpdateValues | null;
  Bisattning_Ref?: string | null;
  Bisattning_Values?: TEDInputBOBisattningUpdateValues | null;
  Ansvarig_Ref?: string | null;
  Ansvarig_Values?: TEDInputGAGravHandelseAnsvarigUpdateValues | null;
  Aktivitet_Ref?: string | null;
  Aktivitet_Values?: TEDInputBOAktivitetUpdateValues | null;
  Mottagare_Add_Values?: TEDInputGAHandelseMottagareAddValues[] | null;
  Mottagare_Update_Values?: TEDInputGAHandelseMottagareUpdateValues[] | null;
  Mottagare_Delete_Values?: TEDInputGAHandelseMottagareDeleteValues[] | null;
  MottagareGrav_Add_Values?: TEDInputGAHandelseMottagareAddValues[] | null;
  MottagareGrav_Update_Values?: TEDInputGAHandelseMottagareUpdateValues[] | null;
  MottagareGrav_Delete_Values?: TEDInputGAHandelseMottagareDeleteValues[] | null;
  Children_Add_Refs?: string[] | null;
  Children_Delete_Refs?: string[] | null;
  MottagareBisattning_Add_Values?: TEDInputBOBisattningMottagareAddValues[] | null;
  MottagareBisattning_Update_Values?: TEDInputBOBisattningMottagareUpdateValues[] | null;
  MottagareBisattning_Delete_Values?: TEDInputBOBisattningMottagareDeleteValues[] | null;
  MottagareAktivitet_Add_Values?: TEDInputBOAktivitetMottagareAddValues[] | null;
  MottagareAktivitet_Update_Values?: TEDInputBOAktivitetMottagareUpdateValues[] | null;
  MottagareAktivitet_Delete_Values?: TEDInputBOAktivitetMottagareDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av händelse
 */
export interface TEDInputGAHandelseUpdateValues {
  id: string;
  _version: number;
  SIGNATUR?: string | null;
  RUBRIK?: string | null;
  TEXT?: string | null;
  DATA?: string | null;
  DATA_NAMN?: string | null;
  KLAR?: TEDGAHandelseKLAREnum | null;
  BEVAKNINGSDATUM?: any | null;
  STATUS_SIGNATUR?: string | null;
  STATUS_WEBAVENY?: boolean | null;
  ANSVARIG_ID?: number | null;
  _Associations?: TEDInputGAHandelseUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kyrkogård
 */
export interface TEDInputGAKGardAddAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputGAKGardBlobAddValues | null;
  Distrikt_Ref?: string | null;
  Distrikt_Values?: TEDInputGADistriktAddValues | null;
  Intaktskonto_Ref?: string | null;
  Intaktskonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  NollaSaldo_Ref?: string | null;
  NollaSaldo_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Gravar_Add_Refs?: string[] | null;
  Kvarter_Add_Values?: TEDInputGAKvarterAddValues[] | null;
}

/**
 * Värden vid tillägg av kyrkogård
 */
export interface TEDInputGAKGardAddValues {
  KGARD: string;
  BENAMNING?: string | null;
  _Associations?: TEDInputGAKGardAddAssociationValues | null;
}

/**
 * Värden vid tillägg av gAKGardBlob
 */
export interface TEDInputGAKGardBlobAddValues {
  HTML_INFO?: string | null;
  LINK?: string | null;
}

/**
 * Nya värden vid ändring av gAKGardBlob
 */
export interface TEDInputGAKGardBlobUpdateValues {
  id: string;
  _version: number;
  HTML_INFO?: string | null;
  LINK?: string | null;
}

/**
 * Associerade värden vid ändring av kyrkogård
 */
export interface TEDInputGAKGardUpdateAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputGAKGardBlobUpdateValues | null;
  Distrikt_Ref?: string | null;
  Distrikt_Values?: TEDInputGADistriktUpdateValues | null;
  Intaktskonto_Ref?: string | null;
  Intaktskonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  NollaSaldo_Ref?: string | null;
  NollaSaldo_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Gravar_Add_Refs?: string[] | null;
  Gravar_Delete_Refs?: string[] | null;
  Kvarter_Add_Values?: TEDInputGAKvarterAddValues[] | null;
  Kvarter_Update_Values?: TEDInputGAKvarterUpdateValues[] | null;
  Kvarter_Delete_Values?: TEDInputGAKvarterDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av kyrkogård
 */
export interface TEDInputGAKGardUpdateValues {
  id: string;
  _version: number;
  KGARD?: string | null;
  BENAMNING?: string | null;
  _Associations?: TEDInputGAKGardUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kontakt
 */
export interface TEDInputGAKontaktAddAssociationValues {
  Grav_Ref?: string | null;
  Grav_Values?: TEDInputGAGravAddValues | null;
  OrgPers2_Ref?: string | null;
  OrgPers2_Values?: TEDInputOPOrgPersLokAddValues | null;
  OrgPers_Ref?: string | null;
  OrgPers_Values?: TEDInputOPOrgPersLokAddValues | null;
  GodMan_Ref?: string | null;
  GodMan_Values?: TEDInputOPOrgPersLokAddValues | null;
  Kund_Ref?: string | null;
  Kund_Values?: TEDInputKRKundAddValues | null;
  Avlidna_Ref?: string | null;
  Avlidna_Values?: TEDInputOPAvlidenAddValues | null;
  SenasteHandelseDodsbo_Ref?: string | null;
  SenasteHandelseDodsbo_Values?: TEDInputGAHandelseAddValues | null;
  Skotslar_Add_Refs?: string[] | null;
  Handelser_Add_Refs?: string[] | null;
  Handelserader_Add_Refs?: string[] | null;
  HandelserOP_Add_Refs?: string[] | null;
  OrderOmgOP_Add_Refs?: string[] | null;
  GiltigaSkotslar_Add_Refs?: string[] | null;
  HandelserDodsbo_Add_Values?: TEDInputGAHandelseDodsboAddValues[] | null;
  HandelserGrav_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av kontakt
 */
export interface TEDInputGAKontaktAddValues {
  _typ: TEDGAKontaktTypEnum;
  ANTECKNINGAR?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_ORSAK?: TEDGAKontaktBORTTAGEN_ORSAKEnum | null;
  KONTAKTPERSON?: boolean | null;
  STATUS?: string | null;
  FRANDATUM?: any | null;
  ForordnandeFinns?: boolean | null;
  KAMMARKOLLEGIETSARENDENR?: string | null;
  PROCESS_STATUS?: TEDGAKontaktPROCESS_STATUSEnum | null;
  ARENDE_STATUS?: TEDGAKontaktARENDE_STATUSEnum | null;
  DIARIENR_UTSE_GRI?: string | null;
  AKTIVA_DODSBO?: boolean | null;
  _Associations?: TEDInputGAKontaktAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kontakt
 */
export interface TEDInputGAKontaktDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kontakt
 */
export interface TEDInputGAKontaktUpdateAssociationValues {
  Grav_Ref?: string | null;
  Grav_Values?: TEDInputGAGravUpdateValues | null;
  OrgPers2_Ref?: string | null;
  OrgPers2_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  OrgPers_Ref?: string | null;
  OrgPers_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  GodMan_Ref?: string | null;
  GodMan_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Kund_Ref?: string | null;
  Kund_Values?: TEDInputKRKundUpdateValues | null;
  Avlidna_Ref?: string | null;
  Avlidna_Values?: TEDInputOPAvlidenUpdateValues | null;
  SenasteHandelseDodsbo_Ref?: string | null;
  SenasteHandelseDodsbo_Values?: TEDInputGAHandelseUpdateValues | null;
  Skotslar_Add_Refs?: string[] | null;
  Skotslar_Delete_Refs?: string[] | null;
  Handelser_Add_Refs?: string[] | null;
  Handelser_Delete_Refs?: string[] | null;
  Handelserader_Add_Refs?: string[] | null;
  Handelserader_Delete_Refs?: string[] | null;
  HandelserOP_Add_Refs?: string[] | null;
  HandelserOP_Delete_Refs?: string[] | null;
  OrderOmgOP_Add_Refs?: string[] | null;
  OrderOmgOP_Delete_Refs?: string[] | null;
  GiltigaSkotslar_Add_Refs?: string[] | null;
  GiltigaSkotslar_Delete_Refs?: string[] | null;
  HandelserDodsbo_Add_Values?: TEDInputGAHandelseDodsboAddValues[] | null;
  HandelserDodsbo_Update_Values?: TEDInputGAHandelseDodsboUpdateValues[] | null;
  HandelserDodsbo_Delete_Values?: TEDInputGAHandelseDodsboDeleteValues[] | null;
  HandelserGrav_Add_Refs?: string[] | null;
  HandelserGrav_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av kontakt
 */
export interface TEDInputGAKontaktUpdateValues {
  id: string;
  _version: number;
  ANTECKNINGAR?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_ORSAK?: TEDGAKontaktBORTTAGEN_ORSAKEnum | null;
  KONTAKTPERSON?: boolean | null;
  STATUS?: string | null;
  FRANDATUM?: any | null;
  ForordnandeFinns?: boolean | null;
  KAMMARKOLLEGIETSARENDENR?: string | null;
  PROCESS_STATUS?: TEDGAKontaktPROCESS_STATUSEnum | null;
  ARENDE_STATUS?: TEDGAKontaktARENDE_STATUSEnum | null;
  DIARIENR_UTSE_GRI?: string | null;
  AKTIVA_DODSBO?: boolean | null;
  _Associations?: TEDInputGAKontaktUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kvarter
 */
export interface TEDInputGAKvarterAddAssociationValues {
  KGard_Ref?: string | null;
  KGard_Values?: TEDInputGAKGardAddValues | null;
  Avdelningar_Add_Refs?: string[] | null;
  Gravar_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av kvarter
 */
export interface TEDInputGAKvarterAddValues {
  KVARTER: string;
  BENAMNING?: string | null;
  _Associations?: TEDInputGAKvarterAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kvarter
 */
export interface TEDInputGAKvarterDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kvarter
 */
export interface TEDInputGAKvarterUpdateAssociationValues {
  KGard_Ref?: string | null;
  KGard_Values?: TEDInputGAKGardUpdateValues | null;
  Avdelningar_Add_Refs?: string[] | null;
  Avdelningar_Delete_Refs?: string[] | null;
  Gravar_Add_Refs?: string[] | null;
  Gravar_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av kvarter
 */
export interface TEDInputGAKvarterUpdateValues {
  id: string;
  _version: number;
  KVARTER?: string | null;
  BENAMNING?: string | null;
  _Associations?: TEDInputGAKvarterUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av mall
 */
export interface TEDInputGAMallAddAssociationValues {
  GravMall_Add_Refs?: string[] | null;
  GravDjupK_Add_Refs?: string[] | null;
  GravDjupU_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av mall
 */
export interface TEDInputGAMallAddValues {
  TYP: TEDGAMallTYPEnum;
  KOD: string;
  BENAMNING: string;
  UTFORMNING: string;
  PLATSNAMN: string;
  ANVANDS?: boolean | null;
  _Associations?: TEDInputGAMallAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av mall
 */
export interface TEDInputGAMallUpdateAssociationValues {
  GravMall_Add_Refs?: string[] | null;
  GravMall_Delete_Refs?: string[] | null;
  GravDjupK_Add_Refs?: string[] | null;
  GravDjupK_Delete_Refs?: string[] | null;
  GravDjupU_Add_Refs?: string[] | null;
  GravDjupU_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av mall
 */
export interface TEDInputGAMallUpdateValues {
  id: string;
  _version: number;
  TYP?: TEDGAMallTYPEnum | null;
  KOD?: string | null;
  BENAMNING?: string | null;
  UTFORMNING?: string | null;
  PLATSNAMN?: string | null;
  ANVANDS?: boolean | null;
  _Associations?: TEDInputGAMallUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av orderomgång
 */
export interface TEDInputGAOrderOmgAddAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputGAOrderOmgBlobAddValues | null;
  Arsskotsel_Add_Values?: TEDInputGAOrderOmgSkotselAddValues[] | null;
}

/**
 * Värden vid tillägg av orderomgång
 */
export interface TEDInputGAOrderOmgAddValues {
  RUBRIK?: string | null;
  STATUS?: TEDGAOrderOmgSTATUSEnum | null;
  DATUM_SKAPAD?: any | null;
  SIGN_SKAPAD?: string | null;
  DATUM_BACKAD?: any | null;
  SIGN_BACKAD?: string | null;
  _Associations?: TEDInputGAOrderOmgAddAssociationValues | null;
}

/**
 * Värden vid tillägg av gAOrderOmgBlob
 */
export interface TEDInputGAOrderOmgBlobAddValues {
  URVAL?: string | null;
}

/**
 * Nya värden vid ändring av gAOrderOmgBlob
 */
export interface TEDInputGAOrderOmgBlobUpdateValues {
  id: string;
  _version: number;
  URVAL?: string | null;
}

/**
 * Associerade värden vid tillägg av årsskötsel
 */
export interface TEDInputGAOrderOmgSkotselAddAssociationValues {
  OrderOmg_Ref?: string | null;
  OrderOmg_Values?: TEDInputGAOrderOmgAddValues | null;
  Orderrad_Ref?: string | null;
  Orderrad_Values?: TEDInputOFOrderradAddValues | null;
  Skotsel_Ref?: string | null;
  Skotsel_Values?: TEDInputGASkotselAddValues | null;
}

/**
 * Värden vid tillägg av årsskötsel
 */
export interface TEDInputGAOrderOmgSkotselAddValues {
  ORDERNR?: string | null;
  GRAVNR?: string | null;
  AR?: number | null;
  DATUMKOD?: number | null;
  MANAD?: number | null;
  DAG?: number | null;
  ARTIKELNR?: string | null;
  BENAMNING?: string | null;
  ANTAL?: number | null;
  ANTALENHET?: string | null;
  DEB_SATT?: string | null;
  STATUS: TEDGAOrderOmgSkotselSTATUSEnum;
  URSP_AR_TI?: number | null;
  PAKET?: string | null;
  PAKET_INFO?: string | null;
  _Associations?: TEDInputGAOrderOmgSkotselAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av årsskötsel
 */
export interface TEDInputGAOrderOmgSkotselDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av årsskötsel
 */
export interface TEDInputGAOrderOmgSkotselUpdateAssociationValues {
  OrderOmg_Ref?: string | null;
  OrderOmg_Values?: TEDInputGAOrderOmgUpdateValues | null;
  Orderrad_Ref?: string | null;
  Orderrad_Values?: TEDInputOFOrderradUpdateValues | null;
  Skotsel_Ref?: string | null;
  Skotsel_Values?: TEDInputGASkotselUpdateValues | null;
}

/**
 * Nya värden vid ändring av årsskötsel
 */
export interface TEDInputGAOrderOmgSkotselUpdateValues {
  id: string;
  _version: number;
  ORDERNR?: string | null;
  GRAVNR?: string | null;
  AR?: number | null;
  DATUMKOD?: number | null;
  MANAD?: number | null;
  DAG?: number | null;
  ARTIKELNR?: string | null;
  BENAMNING?: string | null;
  ANTAL?: number | null;
  ANTALENHET?: string | null;
  DEB_SATT?: string | null;
  STATUS?: TEDGAOrderOmgSkotselSTATUSEnum | null;
  URSP_AR_TI?: number | null;
  PAKET?: string | null;
  PAKET_INFO?: string | null;
  _Associations?: TEDInputGAOrderOmgSkotselUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av orderomgång
 */
export interface TEDInputGAOrderOmgUpdateAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputGAOrderOmgBlobUpdateValues | null;
  Arsskotsel_Add_Values?: TEDInputGAOrderOmgSkotselAddValues[] | null;
  Arsskotsel_Update_Values?: TEDInputGAOrderOmgSkotselUpdateValues[] | null;
  Arsskotsel_Delete_Values?: TEDInputGAOrderOmgSkotselDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av orderomgång
 */
export interface TEDInputGAOrderOmgUpdateValues {
  id: string;
  _version: number;
  RUBRIK?: string | null;
  STATUS?: TEDGAOrderOmgSTATUSEnum | null;
  DATUM_SKAPAD?: any | null;
  SIGN_SKAPAD?: string | null;
  DATUM_BACKAD?: any | null;
  SIGN_BACKAD?: string | null;
  _Associations?: TEDInputGAOrderOmgUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av skötsel
 */
export interface TEDInputGASkotselAddAssociationValues {
  Grav_Ref?: string | null;
  Grav_Values?: TEDInputGAGravAddValues | null;
  Artikel_Ref?: string | null;
  Artikel_Values?: TEDInputLAArtikelAddValues | null;
  Avtal_Ref?: string | null;
  Avtal_Values?: TEDInputGAAvtalAddValues | null;
  Kontakt_Ref?: string | null;
  Kontakt_Values?: TEDInputGAKontaktAddValues | null;
  Faktureringsgrupp_Ref?: string | null;
  Faktureringsgrupp_Values?: TEDInputSYSGruppAddValues | null;
  Paket_Ref?: string | null;
  Paket_Values?: TEDInputGASkotselAddValues | null;
  ArsskotselOrderPerAr_Ref?: string | null;
  ArsskotselOrderPerAr_Values?: TEDInputGAOrderOmgSkotselAddValues | null;
  ArsskotselArbUndPerAr_Ref?: string | null;
  ArsskotselArbUndPerAr_Values?: TEDInputGAArbUndSkotselAddValues | null;
  ArsskotselOrder_Add_Refs?: string[] | null;
  ArsskotselArbUnd_Add_Refs?: string[] | null;
  PaketSkotslar_Add_Refs?: string[] | null;
  PaketArtiklar_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av skötsel
 */
export interface TEDInputGASkotselAddValues {
  BENAMNING?: string | null;
  AR_FR?: number | null;
  AR_TI?: number | null;
  AR_INTERVALL?: number | null;
  DATUMKOD?: number | null;
  MANAD?: number | null;
  DAG?: number | null;
  FAKT_OMG?: number | null;
  UTSKRIFT_PL?: boolean | null;
  ANTAL?: number | null;
  BELOPP?: any | null;
  DEB_SATT: TEDGASkotselDEB_SATTEnum;
  PAKET?: TEDGASkotselPAKETEnum | null;
  BESTALLNINGSDATUM?: any | null;
  AR_TI_OLD?: number | null;
  NOTERING_ARBETSUNDERLAG?: boolean | null;
  NOTERING_FAKTURA?: boolean | null;
  WEB_BEST?: boolean | null;
  _Associations?: TEDInputGASkotselAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av skötsel
 */
export interface TEDInputGASkotselDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid tillägg av beställningskategori
 */
export interface TEDInputGASkotselKategoriAddAssociationValues {
  KategoriArtiklar_Add_Values?: TEDInputGASkotselKategoriArtikelAddValues[] | null;
  KategoriGravar_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av beställningskategori
 */
export interface TEDInputGASkotselKategoriAddValues {
  BENAMNING?: string | null;
  BESKRIVNING?: string | null;
  EXTBESKRIVNING?: string | null;
  _Associations?: TEDInputGASkotselKategoriAddAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av gASkotselKategoriArtikel
 */
export interface TEDInputGASkotselKategoriArtikelAddAssociationValues {
  Artikel_Ref?: string | null;
  Artikel_Values?: TEDInputLAArtikelAddValues | null;
}

/**
 * Värden vid tillägg av gASkotselKategoriArtikel
 */
export interface TEDInputGASkotselKategoriArtikelAddValues {
  KATEGORIID?: number | null;
  SORTERINGSORDNING?: number | null;
  NAMN?: string | null;
  _Associations?: TEDInputGASkotselKategoriArtikelAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av gASkotselKategoriArtikel
 */
export interface TEDInputGASkotselKategoriArtikelDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av gASkotselKategoriArtikel
 */
export interface TEDInputGASkotselKategoriArtikelUpdateAssociationValues {
  Artikel_Ref?: string | null;
  Artikel_Values?: TEDInputLAArtikelUpdateValues | null;
}

/**
 * Nya värden vid ändring av gASkotselKategoriArtikel
 */
export interface TEDInputGASkotselKategoriArtikelUpdateValues {
  id: string;
  _version: number;
  KATEGORIID?: number | null;
  SORTERINGSORDNING?: number | null;
  NAMN?: string | null;
  _Associations?: TEDInputGASkotselKategoriArtikelUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av beställningskategori
 */
export interface TEDInputGASkotselKategoriUpdateAssociationValues {
  KategoriArtiklar_Add_Values?: TEDInputGASkotselKategoriArtikelAddValues[] | null;
  KategoriArtiklar_Update_Values?: TEDInputGASkotselKategoriArtikelUpdateValues[] | null;
  KategoriArtiklar_Delete_Values?: TEDInputGASkotselKategoriArtikelDeleteValues[] | null;
  KategoriGravar_Add_Refs?: string[] | null;
  KategoriGravar_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av beställningskategori
 */
export interface TEDInputGASkotselKategoriUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  BESKRIVNING?: string | null;
  EXTBESKRIVNING?: string | null;
  _Associations?: TEDInputGASkotselKategoriUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av skötsel
 */
export interface TEDInputGASkotselUpdateAssociationValues {
  Grav_Ref?: string | null;
  Grav_Values?: TEDInputGAGravUpdateValues | null;
  Artikel_Ref?: string | null;
  Artikel_Values?: TEDInputLAArtikelUpdateValues | null;
  Avtal_Ref?: string | null;
  Avtal_Values?: TEDInputGAAvtalUpdateValues | null;
  Kontakt_Ref?: string | null;
  Kontakt_Values?: TEDInputGAKontaktUpdateValues | null;
  Faktureringsgrupp_Ref?: string | null;
  Faktureringsgrupp_Values?: TEDInputSYSGruppUpdateValues | null;
  Paket_Ref?: string | null;
  Paket_Values?: TEDInputGASkotselUpdateValues | null;
  ArsskotselOrderPerAr_Ref?: string | null;
  ArsskotselOrderPerAr_Values?: TEDInputGAOrderOmgSkotselUpdateValues | null;
  ArsskotselArbUndPerAr_Ref?: string | null;
  ArsskotselArbUndPerAr_Values?: TEDInputGAArbUndSkotselUpdateValues | null;
  ArsskotselOrder_Add_Refs?: string[] | null;
  ArsskotselOrder_Delete_Refs?: string[] | null;
  ArsskotselArbUnd_Add_Refs?: string[] | null;
  ArsskotselArbUnd_Delete_Refs?: string[] | null;
  PaketSkotslar_Add_Refs?: string[] | null;
  PaketSkotslar_Delete_Refs?: string[] | null;
  PaketArtiklar_Add_Refs?: string[] | null;
  PaketArtiklar_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av skötsel
 */
export interface TEDInputGASkotselUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  AR_FR?: number | null;
  AR_TI?: number | null;
  AR_INTERVALL?: number | null;
  DATUMKOD?: number | null;
  MANAD?: number | null;
  DAG?: number | null;
  FAKT_OMG?: number | null;
  UTSKRIFT_PL?: boolean | null;
  ANTAL?: number | null;
  BELOPP?: any | null;
  DEB_SATT?: TEDGASkotselDEB_SATTEnum | null;
  PAKET?: TEDGASkotselPAKETEnum | null;
  BESTALLNINGSDATUM?: any | null;
  AR_TI_OLD?: number | null;
  NOTERING_ARBETSUNDERLAG?: boolean | null;
  NOTERING_FAKTURA?: boolean | null;
  WEB_BEST?: boolean | null;
  _Associations?: TEDInputGASkotselUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av dokument
 */
export interface TEDInputKJKremationActiveXAddValues {
  KREMATIONS_ID?: number | null;
  LOPNR?: number | null;
  BESKRIVNING?: string | null;
  FILNAMN?: string | null;
  SENAST_ANDRAD?: any | null;
  DATA?: string | null;
  DATASIZE?: number | null;
  DATATYPE?: string | null;
  EXTENSION?: string | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av dokument
 */
export interface TEDInputKJKremationActiveXDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av dokument
 */
export interface TEDInputKJKremationActiveXUpdateValues {
  id: string;
  _version: number;
  KREMATIONS_ID?: number | null;
  LOPNR?: number | null;
  BESKRIVNING?: string | null;
  FILNAMN?: string | null;
  SENAST_ANDRAD?: any | null;
  DATA?: string | null;
  DATASIZE?: number | null;
  DATATYPE?: string | null;
  EXTENSION?: string | null;
}

/**
 * Associerade värden vid tillägg av kremationsjournal
 */
export interface TEDInputKJKremationAddAssociationValues {
  Krematorium_Ref?: string | null;
  Krematorium_Values?: TEDInputKJKrematoriumAddValues | null;
  Begravningsplats_Ref?: string | null;
  Begravningsplats_Values?: TEDInputBOResursAddValues | null;
  Anhorig_Ref?: string | null;
  Anhorig_Values?: TEDInputOPOrgPersLokAddValues | null;
  Begravningsbyra_Ref?: string | null;
  Begravningsbyra_Values?: TEDInputOPOrgPersLokAddValues | null;
  Begravningsort_Ref?: string | null;
  Begravningsort_Values?: TEDInputOPOrgPersLokAddValues | null;
  Begravning_Ref?: string | null;
  Begravning_Values?: TEDInputBOAktivitetAddValues | null;
  Avlidna_Ref?: string | null;
  Avlidna_Values?: TEDInputOPAvlidenAddValues | null;
  UtcheckadBisattning_Ref?: string | null;
  UtcheckadBisattning_Values?: TEDInputBOBisattningAddValues | null;
  KremationOrder_Add_Refs?: string[] | null;
  Dokument_Add_Values?: TEDInputKJKremationActiveXAddValues[] | null;
}

/**
 * Värden vid tillägg av kremationsjournal
 */
export interface TEDInputKJKremationAddValues {
  AKT_MED_URNA?: boolean | null;
  AVHAMTARE?: string | null;
  AVHAMTDATUM?: any | null;
  BEGRAVDAT?: string | null;
  BEGRAVTID?: any | null;
  BEGRBYRA_KONTAKT?: string | null;
  BEGRBYRA_KONTAKT_INFO?: string | null;
  BEGRPLATS?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  DODSDATUM?: string | null;
  FOSTER?: boolean | null;
  FOSTERNUMMER?: string | null;
  GRAVPLATSNR?: string | null;
  GRAVSATT?: TEDKJKremationGRAVSATTEnum | null;
  GRAVSDATUM?: string | null;
  GRAVSTID?: any | null;
  GRAVTYP?: TEDKJKremationGRAVTYPEnum | null;
  INTYGSDATUM?: any | null;
  KGARD_ANNANORT_ID?: number | null;
  KGARDANNANORT?: string | null;
  KREMDATUM?: any | null;
  MARKERAD_FAKTURERAD?: boolean | null;
  NR?: number | null;
  PLANERAD_KREMDATUM?: any | null;
  RELATION?: string | null;
  SEKRETESSMARKERAD?: string | null;
  TVIST?: boolean | null;
  _Associations: TEDInputKJKremationAddAssociationValues;
}

/**
 * Associerade värden vid ändring av kremationsjournal
 */
export interface TEDInputKJKremationUpdateAssociationValues {
  Krematorium_Ref?: string | null;
  Krematorium_Values?: TEDInputKJKrematoriumUpdateValues | null;
  Begravningsplats_Ref?: string | null;
  Begravningsplats_Values?: TEDInputBOResursUpdateValues | null;
  Anhorig_Ref?: string | null;
  Anhorig_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Begravningsbyra_Ref?: string | null;
  Begravningsbyra_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Begravningsort_Ref?: string | null;
  Begravningsort_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Begravning_Ref?: string | null;
  Begravning_Values?: TEDInputBOAktivitetUpdateValues | null;
  Avlidna_Ref?: string | null;
  Avlidna_Values?: TEDInputOPAvlidenUpdateValues | null;
  UtcheckadBisattning_Ref?: string | null;
  UtcheckadBisattning_Values?: TEDInputBOBisattningUpdateValues | null;
  KremationOrder_Add_Refs?: string[] | null;
  KremationOrder_Delete_Refs?: string[] | null;
  Dokument_Add_Values?: TEDInputKJKremationActiveXAddValues[] | null;
  Dokument_Update_Values?: TEDInputKJKremationActiveXUpdateValues[] | null;
  Dokument_Delete_Values?: TEDInputKJKremationActiveXDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av kremationsjournal
 */
export interface TEDInputKJKremationUpdateValues {
  id: string;
  _version: number;
  AKT_MED_URNA?: boolean | null;
  AVHAMTARE?: string | null;
  AVHAMTDATUM?: any | null;
  BEGRAVDAT?: string | null;
  BEGRAVTID?: any | null;
  BEGRBYRA_KONTAKT?: string | null;
  BEGRBYRA_KONTAKT_INFO?: string | null;
  BEGRPLATS?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  DODSDATUM?: string | null;
  FOSTER?: boolean | null;
  FOSTERNUMMER?: string | null;
  GRAVPLATSNR?: string | null;
  GRAVSATT?: TEDKJKremationGRAVSATTEnum | null;
  GRAVSDATUM?: string | null;
  GRAVSTID?: any | null;
  GRAVTYP?: TEDKJKremationGRAVTYPEnum | null;
  INTYGSDATUM?: any | null;
  KGARD_ANNANORT_ID?: number | null;
  KGARDANNANORT?: string | null;
  KREMDATUM?: any | null;
  MARKERAD_FAKTURERAD?: boolean | null;
  NR?: number | null;
  PLANERAD_KREMDATUM?: any | null;
  RELATION?: string | null;
  SEKRETESSMARKERAD?: string | null;
  TVIST?: boolean | null;
  _Associations?: TEDInputKJKremationUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av krematorium
 */
export interface TEDInputKJKrematoriumAddAssociationValues {
  Kremationsnummerserie_Ref?: string | null;
  Kremationsnummerserie_Values?: TEDInputSYSNummerserieAddValues | null;
  Kremationsjournaler_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av krematorium
 */
export interface TEDInputKJKrematoriumAddValues {
  KREMATORIUM?: string | null;
  BENAMNING?: string | null;
  AKTIV?: TEDKJKrematoriumAKTIVEnum | null;
  _Associations?: TEDInputKJKrematoriumAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av krematorium
 */
export interface TEDInputKJKrematoriumUpdateAssociationValues {
  Kremationsnummerserie_Ref?: string | null;
  Kremationsnummerserie_Values?: TEDInputSYSNummerserieUpdateValues | null;
  Kremationsjournaler_Add_Refs?: string[] | null;
  Kremationsjournaler_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av krematorium
 */
export interface TEDInputKJKrematoriumUpdateValues {
  id: string;
  _version: number;
  KREMATORIUM?: string | null;
  BENAMNING?: string | null;
  AKTIV?: TEDKJKrematoriumAKTIVEnum | null;
  _Associations?: TEDInputKJKrematoriumUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kremationsorder
 */
export interface TEDInputKJTEDKJKremationOrderAddAssociationValues {
  Kremationsjournal_Ref?: string | null;
  Kremationsjournal_Values?: TEDInputKJKrematoriumAddValues | null;
  NormalOrder_Ref?: string | null;
  NormalOrder_Values?: TEDInputOFOrderAddValues | null;
}

/**
 * Värden vid tillägg av kremationsorder
 */
export interface TEDInputKJTEDKJKremationOrderAddValues {
  _Associations: TEDInputKJTEDKJKremationOrderAddAssociationValues;
}

/**
 * Associerade värden vid ändring av kremationsorder
 */
export interface TEDInputKJTEDKJKremationOrderUpdateAssociationValues {
  Kremationsjournal_Ref?: string | null;
  Kremationsjournal_Values?: TEDInputKJKrematoriumUpdateValues | null;
  NormalOrder_Ref?: string | null;
  NormalOrder_Values?: TEDInputOFOrderUpdateValues | null;
}

/**
 * Nya värden vid ändring av kremationsorder
 */
export interface TEDInputKJTEDKJKremationOrderUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputKJTEDKJKremationOrderUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av betalningsorder
 */
export interface TEDInputKRBetalningsorderAddAssociationValues {
  Betalningar_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av betalningsorder
 */
export interface TEDInputKRBetalningsorderAddValues {
  AUTOGIRO_VAG: TEDKRBetalningsorderAUTOGIRO_VAGEnum;
  REG_DATUM?: any | null;
  REG_ANV_ID?: number | null;
  FIL_PRODNUMMER?: number | null;
  FIL_PRODDATUM?: any | null;
  REDOVISA_PER_GRUPP?: TEDKRBetalningsorderREDOVISA_PER_GRUPPEnum | null;
  STATUS?: TEDKRBetalningsorderSTATUSEnum | null;
  _Associations?: TEDInputKRBetalningsorderAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av betalningsorder
 */
export interface TEDInputKRBetalningsorderUpdateAssociationValues {
  Betalningar_Add_Refs?: string[] | null;
  Betalningar_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av betalningsorder
 */
export interface TEDInputKRBetalningsorderUpdateValues {
  id: string;
  _version: number;
  AUTOGIRO_VAG?: TEDKRBetalningsorderAUTOGIRO_VAGEnum | null;
  REG_DATUM?: any | null;
  REG_ANV_ID?: number | null;
  FIL_PRODNUMMER?: number | null;
  FIL_PRODDATUM?: any | null;
  REDOVISA_PER_GRUPP?: TEDKRBetalningsorderREDOVISA_PER_GRUPPEnum | null;
  STATUS?: TEDKRBetalningsorderSTATUSEnum | null;
  _Associations?: TEDInputKRBetalningsorderUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av externprintbliaga
 */
export interface TEDInputKRExternprintbliagaAddValues {
  WEBSERVICE_ID?: string | null;
  SKICKAD?: boolean | null;
  BILAGA?: string | null;
  SIGN?: string | null;
  SOKVAG?: string | null;
  DATUM?: any | null;
  FELMEDDELANDE?: string | null;
  BILAGA_BLOB?: string | null;
}

/**
 * Nya värden vid ändring av externprintbliaga
 */
export interface TEDInputKRExternprintbliagaUpdateValues {
  id: string;
  _version: number;
  WEBSERVICE_ID?: string | null;
  SKICKAD?: boolean | null;
  BILAGA?: string | null;
  SIGN?: string | null;
  SOKVAG?: string | null;
  DATUM?: any | null;
  FELMEDDELANDE?: string | null;
  BILAGA_BLOB?: string | null;
}

/**
 * Associerade värden vid tillägg av faktura
 */
export interface TEDInputKRFakturaAddAssociationValues {
  Kund_Ref?: string | null;
  Kund_Values?: TEDInputKRKundAddValues | null;
  Faktureringsgrupp_Ref?: string | null;
  Faktureringsgrupp_Values?: TEDInputSYSGruppAddValues | null;
  Fakturaregistrering_Ref?: string | null;
  Fakturaregistrering_Values?: TEDInputEKFakturahandelseAddValues | null;
  Ordern_Ref?: string | null;
  Ordern_Values?: TEDInputOFOrderAddValues | null;
  Betalare_Ref?: string | null;
  Betalare_Values?: TEDInputKRKundAddValues | null;
  Land_Ref?: string | null;
  Land_Values?: TEDInputSYSLandAddValues | null;
  Levland_Ref?: string | null;
  Levland_Values?: TEDInputSYSLandAddValues | null;
  Bestallare_Ref?: string | null;
  Bestallare_Values?: TEDInputKRKundAddValues | null;
  Betalningsvillkor_Ref?: string | null;
  Betalningsvillkor_Values?: TEDInputSYSBetalningsvillkorAddValues | null;
  FaktureringsLand_Ref?: string | null;
  FaktureringsLand_Values?: TEDInputSYSLandAddValues | null;
  Bunt_Ref?: string | null;
  Bunt_Values?: TEDInputKRKundfakturabuntAddValues | null;
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputKRFakturaBildAddValues | null;
  Fakturarader_Add_Values?: TEDInputKRFakturaradAddValues[] | null;
  Fakturahandelser_Add_Values?: TEDInputEKFakturahandelseAddValues[] | null;
  Betalningar_Add_Values?: TEDInputKRFakturabetalningAddValues[] | null;
}

/**
 * Värden vid tillägg av faktura
 */
export interface TEDInputKRFakturaAddValues {
  _typ: TEDKRFakturaTypEnum;
  SLUTBETALD?: boolean | null;
  FAKTURA_NR?: number | null;
  NAMN?: string | null;
  CO?: string | null;
  ADRESS?: string | null;
  POSTNR?: string | null;
  ORT?: string | null;
  KUNDREFERENS?: string | null;
  VARREFERENS?: string | null;
  FAKTURARUBRIK?: string | null;
  FAKTURATOTAL?: TEDKRFakturaFAKTURATOTALEnum | null;
  ORDERDATUM?: any | null;
  ORDERNR?: string | null;
  MOMS: TEDKRFakturaMOMSEnum;
  DROJ_RANTEFAKTURERAS: TEDKRFakturaDROJ_RANTEFAKTURERASEnum;
  DROJ_RANTE_ORDER_ID?: number | null;
  DROJ_RANTE_ORDER_RAD?: number | null;
  KRAVUTSKRIFT?: TEDKRFakturaKRAVUTSKRIFTEnum | null;
  ORDERTYP: TEDKRFakturaORDERTYPEnum;
  FAKTURADATUM?: any | null;
  FAKTURERINGSSATT: TEDKRFakturaFAKTURERINGSSATTEnum;
  SUMMA_ATT_BETALA?: any | null;
  LEVNAMN?: string | null;
  LEVADRESS?: string | null;
  LEVCO?: string | null;
  LEVPOSTNR?: string | null;
  LEVORT?: string | null;
  AUTOGIRO_VAG?: TEDKRFakturaAUTOGIRO_VAGEnum | null;
  AUTOGIRO_ANTAL_DELBET?: number | null;
  AUTOGIRO_PERIODICITET?: TEDKRFakturaAUTOGIRO_PERIODICITETEnum | null;
  AUTOGIRO_BETALNINGSDAG?: TEDKRFakturaAUTOGIRO_BETALNINGSDAGEnum | null;
  AUTOGIRO_SLUTBETALAS?: TEDKRFakturaAUTOGIRO_SLUTBETALASEnum | null;
  AUTOGIRO_CLEARINGNR?: string | null;
  AUTOGIRO_KONTONR?: string | null;
  SAMFAKTURERAD?: boolean | null;
  RABATT?: number | null;
  AUTOGIRO_BETMANAD_1: TEDKRFakturaAUTOGIRO_BETMANAD_1Enum;
  AUTOGIRO_BETMANAD_2: TEDKRFakturaAUTOGIRO_BETMANAD_2Enum;
  AUTOGIRO_BETMANAD_3: TEDKRFakturaAUTOGIRO_BETMANAD_3Enum;
  AUTOGIRO_BETMANAD_4: TEDKRFakturaAUTOGIRO_BETMANAD_4Enum;
  AUTOGIRO_BETMANAD_5: TEDKRFakturaAUTOGIRO_BETMANAD_5Enum;
  AUTOGIRO_BETMANAD_6: TEDKRFakturaAUTOGIRO_BETMANAD_6Enum;
  AUTOGIRO_BETMANAD_7: TEDKRFakturaAUTOGIRO_BETMANAD_7Enum;
  AUTOGIRO_BETMANAD_8: TEDKRFakturaAUTOGIRO_BETMANAD_8Enum;
  AUTOGIRO_BETMANAD_9: TEDKRFakturaAUTOGIRO_BETMANAD_9Enum;
  AUTOGIRO_BETMANAD_10: TEDKRFakturaAUTOGIRO_BETMANAD_10Enum;
  AUTOGIRO_BETMANAD_11: TEDKRFakturaAUTOGIRO_BETMANAD_11Enum;
  AUTOGIRO_BETMANAD_12: TEDKRFakturaAUTOGIRO_BETMANAD_12Enum;
  AUTOGIRO_BETALARNR?: string | null;
  OSAKER?: TEDKRFakturaOSAKEREnum | null;
  RANTEORDER_ID?: number | null;
  STATUS_ELEKTRONISKFAKTURA?: TEDKRFakturaSTATUS_ELEKTRONISKFAKTURAEnum | null;
  FELTEXT?: string | null;
  FORFALLODATUM_FLAGGA: TEDKRFakturaFORFALLODATUM_FLAGGAEnum;
  FORFALLO_DATUM?: any | null;
  FROM_DATUM?: any | null;
  TOM_DATUM?: any | null;
  EFAKTURA_EXPORTERAD?: boolean | null;
  FAKTNR_OCR?: boolean | null;
  FAKTNAMN?: string | null;
  FAKTADRESS?: string | null;
  FAKTCO?: string | null;
  FAKTPOSTNR?: string | null;
  FAKTORT?: string | null;
  PRINTSATT?: TEDKRFakturaPRINTSATTEnum | null;
  DISTRIBUTIONSSATT?: TEDKRFakturaDISTRIBUTIONSSATTEnum | null;
  PRINTLAYOUT?: TEDKRFakturaPRINTLAYOUTEnum | null;
  AVITYP?: TEDKRFakturaAVITYPEnum | null;
  EXTERNT_FAKTURANR?: string | null;
  EXTERNT_VERNR?: string | null;
  EXTERNT_ORDERNR?: string | null;
  EXTERN_PAMINNELSENIVA?: TEDKRFakturaEXTERN_PAMINNELSENIVAEnum | null;
  EXTERNT_PAMINNELSEDATUM?: any | null;
  EXTERN_KRAVSTATUS?: TEDKRFakturaEXTERN_KRAVSTATUSEnum | null;
  SLUTBETALD_AV_TILLGODO?: boolean | null;
  AVSER_KGF?: boolean | null;
  SKICKAD_MED_POSTTYP?: TEDKRFakturaSKICKAD_MED_POSTTYPEnum | null;
  BEVAKNING_KVITTERAD?: boolean | null;
  BEVAKNING_KVITTERAD_DATUM?: any | null;
  BEVAKNING_KVITTERAD_SIGN?: string | null;
  DISTRIBUTIONSSATT_KIVRA?: TEDKRFakturaDISTRIBUTIONSSATT_KIVRAEnum | null;
  EPOST_MOTTAGARADRESS?: string | null;
  _Associations: TEDInputKRFakturaAddAssociationValues;
}

/**
 * Värden vid tillägg av fakturabild
 */
export interface TEDInputKRFakturaBildAddValues {
  KIVRA_FAKTURABILD?: string | null;
}

/**
 * Nya värden vid ändring av fakturabild
 */
export interface TEDInputKRFakturaBildUpdateValues {
  id: string;
  _version: number;
  KIVRA_FAKTURABILD?: string | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av faktura
 */
export interface TEDInputKRFakturaDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av faktura
 */
export interface TEDInputKRFakturaUpdateAssociationValues {
  Kund_Ref?: string | null;
  Kund_Values?: TEDInputKRKundUpdateValues | null;
  Faktureringsgrupp_Ref?: string | null;
  Faktureringsgrupp_Values?: TEDInputSYSGruppUpdateValues | null;
  Fakturaregistrering_Ref?: string | null;
  Fakturaregistrering_Values?: TEDInputEKFakturahandelseUpdateValues | null;
  Ordern_Ref?: string | null;
  Ordern_Values?: TEDInputOFOrderUpdateValues | null;
  Betalare_Ref?: string | null;
  Betalare_Values?: TEDInputKRKundUpdateValues | null;
  Land_Ref?: string | null;
  Land_Values?: TEDInputSYSLandUpdateValues | null;
  Levland_Ref?: string | null;
  Levland_Values?: TEDInputSYSLandUpdateValues | null;
  Bestallare_Ref?: string | null;
  Bestallare_Values?: TEDInputKRKundUpdateValues | null;
  Betalningsvillkor_Ref?: string | null;
  Betalningsvillkor_Values?: TEDInputSYSBetalningsvillkorUpdateValues | null;
  FaktureringsLand_Ref?: string | null;
  FaktureringsLand_Values?: TEDInputSYSLandUpdateValues | null;
  Bunt_Ref?: string | null;
  Bunt_Values?: TEDInputKRKundfakturabuntUpdateValues | null;
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputKRFakturaBildUpdateValues | null;
  Fakturarader_Add_Values?: TEDInputKRFakturaradAddValues[] | null;
  Fakturarader_Update_Values?: TEDInputKRFakturaradUpdateValues[] | null;
  Fakturarader_Delete_Values?: TEDInputKRFakturaradDeleteValues[] | null;
  Fakturahandelser_Add_Values?: TEDInputEKFakturahandelseAddValues[] | null;
  Fakturahandelser_Update_Values?: TEDInputEKFakturahandelseUpdateValues[] | null;
  Fakturahandelser_Delete_Values?: TEDInputEKFakturahandelseDeleteValues[] | null;
  Betalningar_Add_Values?: TEDInputKRFakturabetalningAddValues[] | null;
  Betalningar_Update_Values?: TEDInputKRFakturabetalningUpdateValues[] | null;
  Betalningar_Delete_Values?: TEDInputKRFakturabetalningDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av faktura
 */
export interface TEDInputKRFakturaUpdateValues {
  id: string;
  _version: number;
  SLUTBETALD?: boolean | null;
  FAKTURA_NR?: number | null;
  NAMN?: string | null;
  CO?: string | null;
  ADRESS?: string | null;
  POSTNR?: string | null;
  ORT?: string | null;
  KUNDREFERENS?: string | null;
  VARREFERENS?: string | null;
  FAKTURARUBRIK?: string | null;
  FAKTURATOTAL?: TEDKRFakturaFAKTURATOTALEnum | null;
  ORDERDATUM?: any | null;
  ORDERNR?: string | null;
  MOMS?: TEDKRFakturaMOMSEnum | null;
  DROJ_RANTEFAKTURERAS?: TEDKRFakturaDROJ_RANTEFAKTURERASEnum | null;
  DROJ_RANTE_ORDER_ID?: number | null;
  DROJ_RANTE_ORDER_RAD?: number | null;
  KRAVUTSKRIFT?: TEDKRFakturaKRAVUTSKRIFTEnum | null;
  ORDERTYP?: TEDKRFakturaORDERTYPEnum | null;
  FAKTURADATUM?: any | null;
  FAKTURERINGSSATT?: TEDKRFakturaFAKTURERINGSSATTEnum | null;
  SUMMA_ATT_BETALA?: any | null;
  LEVNAMN?: string | null;
  LEVADRESS?: string | null;
  LEVCO?: string | null;
  LEVPOSTNR?: string | null;
  LEVORT?: string | null;
  AUTOGIRO_VAG?: TEDKRFakturaAUTOGIRO_VAGEnum | null;
  AUTOGIRO_ANTAL_DELBET?: number | null;
  AUTOGIRO_PERIODICITET?: TEDKRFakturaAUTOGIRO_PERIODICITETEnum | null;
  AUTOGIRO_BETALNINGSDAG?: TEDKRFakturaAUTOGIRO_BETALNINGSDAGEnum | null;
  AUTOGIRO_SLUTBETALAS?: TEDKRFakturaAUTOGIRO_SLUTBETALASEnum | null;
  AUTOGIRO_CLEARINGNR?: string | null;
  AUTOGIRO_KONTONR?: string | null;
  SAMFAKTURERAD?: boolean | null;
  RABATT?: number | null;
  AUTOGIRO_BETMANAD_1?: TEDKRFakturaAUTOGIRO_BETMANAD_1Enum | null;
  AUTOGIRO_BETMANAD_2?: TEDKRFakturaAUTOGIRO_BETMANAD_2Enum | null;
  AUTOGIRO_BETMANAD_3?: TEDKRFakturaAUTOGIRO_BETMANAD_3Enum | null;
  AUTOGIRO_BETMANAD_4?: TEDKRFakturaAUTOGIRO_BETMANAD_4Enum | null;
  AUTOGIRO_BETMANAD_5?: TEDKRFakturaAUTOGIRO_BETMANAD_5Enum | null;
  AUTOGIRO_BETMANAD_6?: TEDKRFakturaAUTOGIRO_BETMANAD_6Enum | null;
  AUTOGIRO_BETMANAD_7?: TEDKRFakturaAUTOGIRO_BETMANAD_7Enum | null;
  AUTOGIRO_BETMANAD_8?: TEDKRFakturaAUTOGIRO_BETMANAD_8Enum | null;
  AUTOGIRO_BETMANAD_9?: TEDKRFakturaAUTOGIRO_BETMANAD_9Enum | null;
  AUTOGIRO_BETMANAD_10?: TEDKRFakturaAUTOGIRO_BETMANAD_10Enum | null;
  AUTOGIRO_BETMANAD_11?: TEDKRFakturaAUTOGIRO_BETMANAD_11Enum | null;
  AUTOGIRO_BETMANAD_12?: TEDKRFakturaAUTOGIRO_BETMANAD_12Enum | null;
  AUTOGIRO_BETALARNR?: string | null;
  OSAKER?: TEDKRFakturaOSAKEREnum | null;
  RANTEORDER_ID?: number | null;
  STATUS_ELEKTRONISKFAKTURA?: TEDKRFakturaSTATUS_ELEKTRONISKFAKTURAEnum | null;
  FELTEXT?: string | null;
  FORFALLODATUM_FLAGGA?: TEDKRFakturaFORFALLODATUM_FLAGGAEnum | null;
  FORFALLO_DATUM?: any | null;
  FROM_DATUM?: any | null;
  TOM_DATUM?: any | null;
  EFAKTURA_EXPORTERAD?: boolean | null;
  FAKTNR_OCR?: boolean | null;
  FAKTNAMN?: string | null;
  FAKTADRESS?: string | null;
  FAKTCO?: string | null;
  FAKTPOSTNR?: string | null;
  FAKTORT?: string | null;
  PRINTSATT?: TEDKRFakturaPRINTSATTEnum | null;
  DISTRIBUTIONSSATT?: TEDKRFakturaDISTRIBUTIONSSATTEnum | null;
  PRINTLAYOUT?: TEDKRFakturaPRINTLAYOUTEnum | null;
  AVITYP?: TEDKRFakturaAVITYPEnum | null;
  EXTERNT_FAKTURANR?: string | null;
  EXTERNT_VERNR?: string | null;
  EXTERNT_ORDERNR?: string | null;
  EXTERN_PAMINNELSENIVA?: TEDKRFakturaEXTERN_PAMINNELSENIVAEnum | null;
  EXTERNT_PAMINNELSEDATUM?: any | null;
  EXTERN_KRAVSTATUS?: TEDKRFakturaEXTERN_KRAVSTATUSEnum | null;
  SLUTBETALD_AV_TILLGODO?: boolean | null;
  AVSER_KGF?: boolean | null;
  SKICKAD_MED_POSTTYP?: TEDKRFakturaSKICKAD_MED_POSTTYPEnum | null;
  BEVAKNING_KVITTERAD?: boolean | null;
  BEVAKNING_KVITTERAD_DATUM?: any | null;
  BEVAKNING_KVITTERAD_SIGN?: string | null;
  DISTRIBUTIONSSATT_KIVRA?: TEDKRFakturaDISTRIBUTIONSSATT_KIVRAEnum | null;
  EPOST_MOTTAGARADRESS?: string | null;
  _Associations?: TEDInputKRFakturaUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av betalningsplan
 */
export interface TEDInputKRFakturabetalningAddAssociationValues {
  Faktura_Ref?: string | null;
  Faktura_Values?: TEDInputKRFakturaAddValues | null;
  Betalningsorder_Ref?: string | null;
  Betalningsorder_Values?: TEDInputKRBetalningsorderAddValues | null;
}

/**
 * Värden vid tillägg av betalningsplan
 */
export interface TEDInputKRFakturabetalningAddValues {
  STATUS: TEDKRFakturabetalningSTATUSEnum;
  BETALNINGSDATUM?: any | null;
  BELOPP?: any | null;
  ANTECKNING?: string | null;
  FEL_KOD?: TEDKRFakturabetalningFEL_KODEnum | null;
  FOREG_BETALNINGSORDER_ID?: number | null;
  HANDELSE_BOKF_GRUPP_ID?: number | null;
  HANDELSE_ID?: number | null;
  _Associations?: TEDInputKRFakturabetalningAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av betalningsplan
 */
export interface TEDInputKRFakturabetalningDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av betalningsplan
 */
export interface TEDInputKRFakturabetalningUpdateAssociationValues {
  Faktura_Ref?: string | null;
  Faktura_Values?: TEDInputKRFakturaUpdateValues | null;
  Betalningsorder_Ref?: string | null;
  Betalningsorder_Values?: TEDInputKRBetalningsorderUpdateValues | null;
}

/**
 * Nya värden vid ändring av betalningsplan
 */
export interface TEDInputKRFakturabetalningUpdateValues {
  id: string;
  _version: number;
  STATUS?: TEDKRFakturabetalningSTATUSEnum | null;
  BETALNINGSDATUM?: any | null;
  BELOPP?: any | null;
  ANTECKNING?: string | null;
  FEL_KOD?: TEDKRFakturabetalningFEL_KODEnum | null;
  FOREG_BETALNINGSORDER_ID?: number | null;
  HANDELSE_BOKF_GRUPP_ID?: number | null;
  HANDELSE_ID?: number | null;
  _Associations?: TEDInputKRFakturabetalningUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av fakturarad
 */
export interface TEDInputKRFakturaradAddAssociationValues {
  Faktura_Ref?: string | null;
  Faktura_Values?: TEDInputKRFakturaAddValues | null;
  Orderrad_Ref?: string | null;
  Orderrad_Values?: TEDInputOFOrderradAddValues | null;
  Ordern_Ref?: string | null;
  Ordern_Values?: TEDInputOFOrderAddValues | null;
  Moms_Ref?: string | null;
  Moms_Values?: TEDInputSYSMomsAddValues | null;
}

/**
 * Värden vid tillägg av fakturarad
 */
export interface TEDInputKRFakturaradAddValues {
  TYP: TEDKRFakturaradTYPEnum;
  BELOPP?: any | null;
  ANTAL?: number | null;
  ANTAL_FRANORDERRAD?: number | null;
  BENAMNING?: string | null;
  ARTIKELNR?: string | null;
  ENHET?: string | null;
  APRIS?: any | null;
  ENHET_ANTALDEC?: number | null;
  RABATT?: number | null;
  FROM_DATUM?: any | null;
  TOM_DATUM?: any | null;
  BENAMNING2?: string | null;
  DOLJ_BELOPP?: boolean | null;
  DOLJ_RAD?: boolean | null;
  UNDERTYP?: TEDKRFakturaradUNDERTYPEnum | null;
  MOMSBELAGT_BELOPP?: any | null;
  FAKTURATEXT?: string | null;
  _Associations?: TEDInputKRFakturaradAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av fakturarad
 */
export interface TEDInputKRFakturaradDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av fakturarad
 */
export interface TEDInputKRFakturaradUpdateAssociationValues {
  Faktura_Ref?: string | null;
  Faktura_Values?: TEDInputKRFakturaUpdateValues | null;
  Orderrad_Ref?: string | null;
  Orderrad_Values?: TEDInputOFOrderradUpdateValues | null;
  Ordern_Ref?: string | null;
  Ordern_Values?: TEDInputOFOrderUpdateValues | null;
  Moms_Ref?: string | null;
  Moms_Values?: TEDInputSYSMomsUpdateValues | null;
}

/**
 * Nya värden vid ändring av fakturarad
 */
export interface TEDInputKRFakturaradUpdateValues {
  id: string;
  _version: number;
  TYP?: TEDKRFakturaradTYPEnum | null;
  BELOPP?: any | null;
  ANTAL?: number | null;
  ANTAL_FRANORDERRAD?: number | null;
  BENAMNING?: string | null;
  ARTIKELNR?: string | null;
  ENHET?: string | null;
  APRIS?: any | null;
  ENHET_ANTALDEC?: number | null;
  RABATT?: number | null;
  FROM_DATUM?: any | null;
  TOM_DATUM?: any | null;
  BENAMNING2?: string | null;
  DOLJ_BELOPP?: boolean | null;
  DOLJ_RAD?: boolean | null;
  UNDERTYP?: TEDKRFakturaradUNDERTYPEnum | null;
  MOMSBELAGT_BELOPP?: any | null;
  FAKTURATEXT?: string | null;
  _Associations?: TEDInputKRFakturaradUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kravomgång
 */
export interface TEDInputKRKravOmgangAddAssociationValues {
  Faktureringsgrupp_Ref?: string | null;
  Faktureringsgrupp_Values?: TEDInputSYSGruppAddValues | null;
  Kravhandelse_Ref?: string | null;
  Kravhandelse_Values?: TEDInputEKFakturahandelseAddValues | null;
}

/**
 * Värden vid tillägg av kravomgång
 */
export interface TEDInputKRKravOmgangAddValues {
  KRAVOMGANG_NR?: number | null;
  DATUM?: any | null;
  TID?: any | null;
  SIGNATUR?: string | null;
  _Associations: TEDInputKRKravOmgangAddAssociationValues;
}

/**
 * Associerade värden vid ändring av kravomgång
 */
export interface TEDInputKRKravOmgangUpdateAssociationValues {
  Faktureringsgrupp_Ref?: string | null;
  Faktureringsgrupp_Values?: TEDInputSYSGruppUpdateValues | null;
  Kravhandelse_Ref?: string | null;
  Kravhandelse_Values?: TEDInputEKFakturahandelseUpdateValues | null;
}

/**
 * Nya värden vid ändring av kravomgång
 */
export interface TEDInputKRKravOmgangUpdateValues {
  id: string;
  _version: number;
  KRAVOMGANG_NR?: number | null;
  DATUM?: any | null;
  TID?: any | null;
  SIGNATUR?: string | null;
  _Associations?: TEDInputKRKravOmgangUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kund
 */
export interface TEDInputKRKundAddAssociationValues {
  KundKategori_Ref?: string | null;
  KundKategori_Values?: TEDInputKRKundkategoriAddValues | null;
  OrgPers_Ref?: string | null;
  OrgPers_Values?: TEDInputOPOrgPersLokAddValues | null;
  Valuta_Ref?: string | null;
  Valuta_Values?: TEDInputSYSValutaAddValues | null;
  Prislista_Ref?: string | null;
  Prislista_Values?: TEDInputLAPrislistaAddValues | null;
  Sprak_Ref?: string | null;
  Sprak_Values?: TEDInputSYSSprakAddValues | null;
  Leveransvillkor_Ref?: string | null;
  Leveransvillkor_Values?: TEDInputSYSLeveransvillkorAddValues | null;
  Betalningsvillkor_Ref?: string | null;
  Betalningsvillkor_Values?: TEDInputSYSBetalningsvillkorAddValues | null;
  Autogiromall_Ref?: string | null;
  Autogiromall_Values?: TEDInputSYSAutogiroMallAddValues | null;
  Bank_Ref?: string | null;
  Bank_Values?: TEDInputSYSBankAddValues | null;
  Fakturaformedlare_Ref?: string | null;
  Fakturaformedlare_Values?: TEDInputSYSFakturaformedlareAddValues | null;
  FaktureringsLand_Ref?: string | null;
  FaktureringsLand_Values?: TEDInputSYSLandAddValues | null;
  FornyadFran_Ref?: string | null;
  FornyadFran_Values?: TEDInputKRKundAddValues | null;
  FornyadSom_Ref?: string | null;
  FornyadSom_Values?: TEDInputKRKundAddValues | null;
  Handelse_Add_Values?: TEDInputEKFakturahandelseAddValues[] | null;
  Fakturor_Add_Values?: TEDInputKRFakturaAddValues[] | null;
  Bokfhandelse_Add_Refs?: string[] | null;
  Licenser_Add_Values?: TEDInputKRLicenserAddValues[] | null;
  FindBetalningsansvarig_Add_Refs?: string[] | null;
  GravKontakt_Add_Refs?: string[] | null;
  Medgivande_Add_Values?: TEDInputKRMedgivandeAddValues[] | null;
  Extrakund_Add_Refs?: string[] | null;
  PrisavtalKund_Add_Refs?: string[] | null;
  OrderEjFakt_Add_Refs?: string[] | null;
  Arbetsuppgift_Add_Refs?: string[] | null;
  Anslutning_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av kund
 */
export interface TEDInputKRKundAddValues {
  _typ: TEDKRKundTypEnum;
  KUNDNR_KONTONR?: string | null;
  MALLKUND?: TEDKRKundMALLKUNDEnum | null;
  MOMS?: TEDKRKundMOMSEnum | null;
  REGDATUM?: any | null;
  KUNDRABATT?: number | null;
  SPARRDATUM?: any | null;
  AVSLUTDATUM?: any | null;
  FAKTURERINGSAVGIFT?: TEDKRKundFAKTURERINGSAVGIFTEnum | null;
  SAMFAKTURERAS?: boolean | null;
  KREDITGRANS?: any | null;
  DROJSMALSRANTEFAKT?: TEDKRKundDROJSMALSRANTEFAKTEnum | null;
  REFERENS?: string | null;
  BETALARE_ID?: number | null;
  LEVERANTORSNUMMER?: string | null;
  RANTEFAKTURERAS?: TEDKRKundRANTEFAKTURERASEnum | null;
  RANTEBERAKNAS?: boolean | null;
  UPPLAGGNINGS_DATUM?: any | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  AUTOGIRO_VAG?: TEDKRKundAUTOGIRO_VAGEnum | null;
  AUTOGIRO_STATUS?: TEDKRKundAUTOGIRO_STATUSEnum | null;
  AUTOGIRO_FROM_DATUM?: any | null;
  AUTOGIRO_CLEARINGNR?: string | null;
  AUTOGIRO_KONTONR?: string | null;
  AUTOGIRO_MAXBELOPP?: any | null;
  AUTOGIRO_ANTAL_DELBET?: number | null;
  AUTOGIRO_PERIODICITET?: TEDKRKundAUTOGIRO_PERIODICITETEnum | null;
  AUTOGIRO_BETALNINGSDAG?: TEDKRKundAUTOGIRO_BETALNINGSDAGEnum | null;
  AUTOGIRO_SLUTBETALAS: TEDKRKundAUTOGIRO_SLUTBETALASEnum;
  AUTOGIRO_FOREG_CLEARINGNR?: string | null;
  AUTOGIRO_FOREG_KONTONR?: string | null;
  AUTOGIRO_BETMANAD_1: TEDKRKundAUTOGIRO_BETMANAD_1Enum;
  AUTOGIRO_BETMANAD_2: TEDKRKundAUTOGIRO_BETMANAD_2Enum;
  AUTOGIRO_BETMANAD_3: TEDKRKundAUTOGIRO_BETMANAD_3Enum;
  AUTOGIRO_BETMANAD_4: TEDKRKundAUTOGIRO_BETMANAD_4Enum;
  AUTOGIRO_BETMANAD_5: TEDKRKundAUTOGIRO_BETMANAD_5Enum;
  AUTOGIRO_BETMANAD_6: TEDKRKundAUTOGIRO_BETMANAD_6Enum;
  AUTOGIRO_BETMANAD_7: TEDKRKundAUTOGIRO_BETMANAD_7Enum;
  AUTOGIRO_BETMANAD_8: TEDKRKundAUTOGIRO_BETMANAD_8Enum;
  AUTOGIRO_BETMANAD_12: TEDKRKundAUTOGIRO_BETMANAD_12Enum;
  AUTOGIRO_BETMANAD_9: TEDKRKundAUTOGIRO_BETMANAD_9Enum;
  AUTOGIRO_BETMANAD_11: TEDKRKundAUTOGIRO_BETMANAD_11Enum;
  AUTOGIRO_BETALARNR?: string | null;
  AUTOGIRO_FOREG_BETALARNR?: string | null;
  AUTOGIRO_BETMANAD_10: TEDKRKundAUTOGIRO_BETMANAD_10Enum;
  FAKTUTSKRIFT_BANKKONTO?: TEDKRKundFAKTUTSKRIFT_BANKKONTOEnum | null;
  KREDITERA_TILLGODOH?: TEDKRKundKREDITERA_TILLGODOHEnum | null;
  BANKKONTONUMMER?: string | null;
  FAKTURERINGSSATT?: TEDKRKundFAKTURERINGSSATTEnum | null;
  AVTAL_FR?: any | null;
  AVTAL_TI?: any | null;
  AVTAL_MANADER?: number | null;
  URSPRUNGS_BELOPP?: any | null;
  MOMSPAKONTOFAKTURA?: TEDKRKundMOMSPAKONTOFAKTURAEnum | null;
  ADMINAVGIFTKONTOFAKTURA?: TEDKRKundADMINAVGIFTKONTOFAKTURAEnum | null;
  FAKTUTSKRIFT_KONTOFAKTURA?: TEDKRKundFAKTUTSKRIFT_KONTOFAKTURAEnum | null;
  AVTALSBELOPP?: any | null;
  FAKTNAMN?: string | null;
  FAKTADRESS?: string | null;
  FAKTCO?: string | null;
  FAKTPOSTNR?: string | null;
  FAKTORT?: string | null;
  REFERENS_KRAVS?: boolean | null;
  REFERENS_MEDDELANDE?: string | null;
  VANLEV?: string | null;
  GLNNR?: string | null;
  FORNYAD_DATUM?: any | null;
  FORNYAD_SIGN?: string | null;
  FORNYAD_MANUELLT?: boolean | null;
  ANVAND_EFAKT_FORETAG?: boolean | null;
  EFAKT_ID?: string | null;
  FAKTMOTTAG_BANK?: string | null;
  ANVAND_EFAKT_PRIVAT?: boolean | null;
  EFAKT_KUNDNR?: string | null;
  EFAKT_KONTROLLSIFFRA?: string | null;
  MOTPART?: string | null;
  EXTERNT_KUNDNR?: string | null;
  EFAKTMOTTAG_PERSNR?: string | null;
  BERAKNAT_BELOPP?: any | null;
  ANVAND_KUNDFAKTBUNT_XML?: boolean | null;
  EFAKT_ANMAL_DATUM?: any | null;
  PEPPOL?: boolean | null;
  KIVRA?: boolean | null;
  FAKTUROR_VIA_EPOST?: boolean | null;
  _Associations: TEDInputKRKundAddAssociationValues;
}

/**
 * Associerade värden vid ändring av kund
 */
export interface TEDInputKRKundUpdateAssociationValues {
  KundKategori_Ref?: string | null;
  KundKategori_Values?: TEDInputKRKundkategoriUpdateValues | null;
  OrgPers_Ref?: string | null;
  OrgPers_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Valuta_Ref?: string | null;
  Valuta_Values?: TEDInputSYSValutaUpdateValues | null;
  Prislista_Ref?: string | null;
  Prislista_Values?: TEDInputLAPrislistaUpdateValues | null;
  Sprak_Ref?: string | null;
  Sprak_Values?: TEDInputSYSSprakUpdateValues | null;
  Leveransvillkor_Ref?: string | null;
  Leveransvillkor_Values?: TEDInputSYSLeveransvillkorUpdateValues | null;
  Betalningsvillkor_Ref?: string | null;
  Betalningsvillkor_Values?: TEDInputSYSBetalningsvillkorUpdateValues | null;
  Autogiromall_Ref?: string | null;
  Autogiromall_Values?: TEDInputSYSAutogiroMallUpdateValues | null;
  Bank_Ref?: string | null;
  Bank_Values?: TEDInputSYSBankUpdateValues | null;
  Fakturaformedlare_Ref?: string | null;
  Fakturaformedlare_Values?: TEDInputSYSFakturaformedlareUpdateValues | null;
  FaktureringsLand_Ref?: string | null;
  FaktureringsLand_Values?: TEDInputSYSLandUpdateValues | null;
  FornyadFran_Ref?: string | null;
  FornyadFran_Values?: TEDInputKRKundUpdateValues | null;
  FornyadSom_Ref?: string | null;
  FornyadSom_Values?: TEDInputKRKundUpdateValues | null;
  Handelse_Add_Values?: TEDInputEKFakturahandelseAddValues[] | null;
  Handelse_Update_Values?: TEDInputEKFakturahandelseUpdateValues[] | null;
  Handelse_Delete_Values?: TEDInputEKFakturahandelseDeleteValues[] | null;
  Fakturor_Add_Values?: TEDInputKRFakturaAddValues[] | null;
  Fakturor_Update_Values?: TEDInputKRFakturaUpdateValues[] | null;
  Fakturor_Delete_Values?: TEDInputKRFakturaDeleteValues[] | null;
  Bokfhandelse_Add_Refs?: string[] | null;
  Bokfhandelse_Delete_Refs?: string[] | null;
  Licenser_Add_Values?: TEDInputKRLicenserAddValues[] | null;
  Licenser_Update_Values?: TEDInputKRLicenserUpdateValues[] | null;
  Licenser_Delete_Values?: TEDInputKRLicenserDeleteValues[] | null;
  Licenser_Undelete?: TEDInputKRLicenserDeleteValues[] | null;
  FindBetalningsansvarig_Add_Refs?: string[] | null;
  FindBetalningsansvarig_Delete_Refs?: string[] | null;
  GravKontakt_Add_Refs?: string[] | null;
  GravKontakt_Delete_Refs?: string[] | null;
  Medgivande_Add_Values?: TEDInputKRMedgivandeAddValues[] | null;
  Medgivande_Update_Values?: TEDInputKRMedgivandeUpdateValues[] | null;
  Medgivande_Delete_Values?: TEDInputKRMedgivandeDeleteValues[] | null;
  Extrakund_Add_Refs?: string[] | null;
  Extrakund_Delete_Refs?: string[] | null;
  PrisavtalKund_Add_Refs?: string[] | null;
  PrisavtalKund_Delete_Refs?: string[] | null;
  OrderEjFakt_Add_Refs?: string[] | null;
  OrderEjFakt_Delete_Refs?: string[] | null;
  Arbetsuppgift_Add_Refs?: string[] | null;
  Arbetsuppgift_Delete_Refs?: string[] | null;
  Anslutning_Add_Refs?: string[] | null;
  Anslutning_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av kund
 */
export interface TEDInputKRKundUpdateValues {
  id: string;
  _version: number;
  KUNDNR_KONTONR?: string | null;
  MALLKUND?: TEDKRKundMALLKUNDEnum | null;
  MOMS?: TEDKRKundMOMSEnum | null;
  REGDATUM?: any | null;
  KUNDRABATT?: number | null;
  SPARRDATUM?: any | null;
  AVSLUTDATUM?: any | null;
  FAKTURERINGSAVGIFT?: TEDKRKundFAKTURERINGSAVGIFTEnum | null;
  SAMFAKTURERAS?: boolean | null;
  KREDITGRANS?: any | null;
  DROJSMALSRANTEFAKT?: TEDKRKundDROJSMALSRANTEFAKTEnum | null;
  REFERENS?: string | null;
  BETALARE_ID?: number | null;
  LEVERANTORSNUMMER?: string | null;
  RANTEFAKTURERAS?: TEDKRKundRANTEFAKTURERASEnum | null;
  RANTEBERAKNAS?: boolean | null;
  UPPLAGGNINGS_DATUM?: any | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  AUTOGIRO_VAG?: TEDKRKundAUTOGIRO_VAGEnum | null;
  AUTOGIRO_STATUS?: TEDKRKundAUTOGIRO_STATUSEnum | null;
  AUTOGIRO_FROM_DATUM?: any | null;
  AUTOGIRO_CLEARINGNR?: string | null;
  AUTOGIRO_KONTONR?: string | null;
  AUTOGIRO_MAXBELOPP?: any | null;
  AUTOGIRO_ANTAL_DELBET?: number | null;
  AUTOGIRO_PERIODICITET?: TEDKRKundAUTOGIRO_PERIODICITETEnum | null;
  AUTOGIRO_BETALNINGSDAG?: TEDKRKundAUTOGIRO_BETALNINGSDAGEnum | null;
  AUTOGIRO_SLUTBETALAS?: TEDKRKundAUTOGIRO_SLUTBETALASEnum | null;
  AUTOGIRO_FOREG_CLEARINGNR?: string | null;
  AUTOGIRO_FOREG_KONTONR?: string | null;
  AUTOGIRO_BETMANAD_1?: TEDKRKundAUTOGIRO_BETMANAD_1Enum | null;
  AUTOGIRO_BETMANAD_2?: TEDKRKundAUTOGIRO_BETMANAD_2Enum | null;
  AUTOGIRO_BETMANAD_3?: TEDKRKundAUTOGIRO_BETMANAD_3Enum | null;
  AUTOGIRO_BETMANAD_4?: TEDKRKundAUTOGIRO_BETMANAD_4Enum | null;
  AUTOGIRO_BETMANAD_5?: TEDKRKundAUTOGIRO_BETMANAD_5Enum | null;
  AUTOGIRO_BETMANAD_6?: TEDKRKundAUTOGIRO_BETMANAD_6Enum | null;
  AUTOGIRO_BETMANAD_7?: TEDKRKundAUTOGIRO_BETMANAD_7Enum | null;
  AUTOGIRO_BETMANAD_8?: TEDKRKundAUTOGIRO_BETMANAD_8Enum | null;
  AUTOGIRO_BETMANAD_12?: TEDKRKundAUTOGIRO_BETMANAD_12Enum | null;
  AUTOGIRO_BETMANAD_9?: TEDKRKundAUTOGIRO_BETMANAD_9Enum | null;
  AUTOGIRO_BETMANAD_11?: TEDKRKundAUTOGIRO_BETMANAD_11Enum | null;
  AUTOGIRO_BETALARNR?: string | null;
  AUTOGIRO_FOREG_BETALARNR?: string | null;
  AUTOGIRO_BETMANAD_10?: TEDKRKundAUTOGIRO_BETMANAD_10Enum | null;
  FAKTUTSKRIFT_BANKKONTO?: TEDKRKundFAKTUTSKRIFT_BANKKONTOEnum | null;
  KREDITERA_TILLGODOH?: TEDKRKundKREDITERA_TILLGODOHEnum | null;
  BANKKONTONUMMER?: string | null;
  FAKTURERINGSSATT?: TEDKRKundFAKTURERINGSSATTEnum | null;
  AVTAL_FR?: any | null;
  AVTAL_TI?: any | null;
  AVTAL_MANADER?: number | null;
  URSPRUNGS_BELOPP?: any | null;
  MOMSPAKONTOFAKTURA?: TEDKRKundMOMSPAKONTOFAKTURAEnum | null;
  ADMINAVGIFTKONTOFAKTURA?: TEDKRKundADMINAVGIFTKONTOFAKTURAEnum | null;
  FAKTUTSKRIFT_KONTOFAKTURA?: TEDKRKundFAKTUTSKRIFT_KONTOFAKTURAEnum | null;
  AVTALSBELOPP?: any | null;
  FAKTNAMN?: string | null;
  FAKTADRESS?: string | null;
  FAKTCO?: string | null;
  FAKTPOSTNR?: string | null;
  FAKTORT?: string | null;
  REFERENS_KRAVS?: boolean | null;
  REFERENS_MEDDELANDE?: string | null;
  VANLEV?: string | null;
  GLNNR?: string | null;
  FORNYAD_DATUM?: any | null;
  FORNYAD_SIGN?: string | null;
  FORNYAD_MANUELLT?: boolean | null;
  ANVAND_EFAKT_FORETAG?: boolean | null;
  EFAKT_ID?: string | null;
  FAKTMOTTAG_BANK?: string | null;
  ANVAND_EFAKT_PRIVAT?: boolean | null;
  EFAKT_KUNDNR?: string | null;
  EFAKT_KONTROLLSIFFRA?: string | null;
  MOTPART?: string | null;
  EXTERNT_KUNDNR?: string | null;
  EFAKTMOTTAG_PERSNR?: string | null;
  BERAKNAT_BELOPP?: any | null;
  ANVAND_KUNDFAKTBUNT_XML?: boolean | null;
  EFAKT_ANMAL_DATUM?: any | null;
  PEPPOL?: boolean | null;
  KIVRA?: boolean | null;
  FAKTUROR_VIA_EPOST?: boolean | null;
  _Associations?: TEDInputKRKundUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kundfakturabunt
 */
export interface TEDInputKRKundfakturabuntAddAssociationValues {
  Faktureringsgrupp_Ref?: string | null;
  Faktureringsgrupp_Values?: TEDInputSYSGruppAddValues | null;
  fakturaformedlare_Ref?: string | null;
  fakturaformedlare_Values?: TEDInputSYSFakturaformedlareAddValues | null;
  fakturor_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av kundfakturabunt
 */
export interface TEDInputKRKundfakturabuntAddValues {
  DATUM?: any | null;
  LOPNR?: number | null;
  KLOCKSLAG?: any | null;
  FILNAMN?: string | null;
  STATUS?: TEDKRKundfakturabuntSTATUSEnum | null;
  FAKTURAFIL?: string | null;
  KVITTENSFIL?: string | null;
  STATUS_TEXT?: string | null;
  _Associations: TEDInputKRKundfakturabuntAddAssociationValues;
}

/**
 * Associerade värden vid ändring av kundfakturabunt
 */
export interface TEDInputKRKundfakturabuntUpdateAssociationValues {
  Faktureringsgrupp_Ref?: string | null;
  Faktureringsgrupp_Values?: TEDInputSYSGruppUpdateValues | null;
  fakturaformedlare_Ref?: string | null;
  fakturaformedlare_Values?: TEDInputSYSFakturaformedlareUpdateValues | null;
  fakturor_Add_Refs?: string[] | null;
  fakturor_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av kundfakturabunt
 */
export interface TEDInputKRKundfakturabuntUpdateValues {
  id: string;
  _version: number;
  DATUM?: any | null;
  LOPNR?: number | null;
  KLOCKSLAG?: any | null;
  FILNAMN?: string | null;
  STATUS?: TEDKRKundfakturabuntSTATUSEnum | null;
  FAKTURAFIL?: string | null;
  KVITTENSFIL?: string | null;
  STATUS_TEXT?: string | null;
  _Associations?: TEDInputKRKundfakturabuntUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kundkategorins faktureringsgrupp
 */
export interface TEDInputKRKundkatFaktGruppAddAssociationValues {
  Kundkategori_Ref?: string | null;
  Kundkategori_Values?: TEDInputKRKundkategoriAddValues | null;
  Faktureringsgrupp_Ref?: string | null;
  Faktureringsgrupp_Values?: TEDInputSYSGruppAddValues | null;
}

/**
 * Värden vid tillägg av kundkategorins faktureringsgrupp
 */
export interface TEDInputKRKundkatFaktGruppAddValues {
  STATUS: TEDKRKundkatFaktGruppSTATUSEnum;
  _Associations: TEDInputKRKundkatFaktGruppAddAssociationValues;
}

/**
 * Associerade värden vid ändring av kundkategorins faktureringsgrupp
 */
export interface TEDInputKRKundkatFaktGruppUpdateAssociationValues {
  Kundkategori_Ref?: string | null;
  Kundkategori_Values?: TEDInputKRKundkategoriUpdateValues | null;
  Faktureringsgrupp_Ref?: string | null;
  Faktureringsgrupp_Values?: TEDInputSYSGruppUpdateValues | null;
}

/**
 * Nya värden vid ändring av kundkategorins faktureringsgrupp
 */
export interface TEDInputKRKundkatFaktGruppUpdateValues {
  id: string;
  _version: number;
  STATUS?: TEDKRKundkatFaktGruppSTATUSEnum | null;
  _Associations?: TEDInputKRKundkatFaktGruppUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kundkategori
 */
export interface TEDInputKRKundkategoriAddAssociationValues {
  Moms_Ref?: string | null;
  Moms_Values?: TEDInputSYSMomsAddValues | null;
  Intaktskonto_Ref?: string | null;
  Intaktskonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Kundfordrkonto_Ref?: string | null;
  Kundfordrkonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Drojsmalintaktkonto_Ref?: string | null;
  Drojsmalintaktkonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  DiffInbetkonto_Ref?: string | null;
  DiffInbetkonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  KundSkuldkonto_Ref?: string | null;
  KundSkuldkonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  KundrantaKredit_Ref?: string | null;
  KundrantaKredit_Values?: TEDInputEKKonteringsvardeAddValues | null;
  KundrantaDebet_Ref?: string | null;
  KundrantaDebet_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Bank_Ref?: string | null;
  Bank_Values?: TEDInputSYSBankAddValues | null;
  RantetabellDrojsmal_Ref?: string | null;
  RantetabellDrojsmal_Values?: TEDInputSYSRanteTabellAddValues | null;
  Kundnrserie_Ref?: string | null;
  Kundnrserie_Values?: TEDInputSYSNummerserieAddValues | null;
  RantetabellDebitering_Ref?: string | null;
  RantetabellDebitering_Values?: TEDInputSYSRanteTabellAddValues | null;
  RantetabellKreditering_Ref?: string | null;
  RantetabellKreditering_Values?: TEDInputSYSRanteTabellAddValues | null;
  Kontouppr_Ref?: string | null;
  Kontouppr_Values?: TEDInputEKKonteringsvardeAddValues | null;
  NollaSaldo_Ref?: string | null;
  NollaSaldo_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Kund_Add_Refs?: string[] | null;
  KundkategoriFaktGrupp_Add_Refs?: string[] | null;
  GravAvtalArtiklar_Add_Values?: TEDInputKRKundkategoriGravAvtalArtikelAddValues[] | null;
  UtgSkotSparrArtiklar_Add_Values?: TEDInputKRKundkategoriUtgSkotSparrArtikelAddValues[] | null;
}

/**
 * Värden vid tillägg av kundkategori
 */
export interface TEDInputKRKundkategoriAddValues {
  _typ: TEDKRKundkategoriTypEnum;
  KUNDKAT_KOD?: string | null;
  INTERN?: TEDKRKundkategoriINTERNEnum | null;
  BENAMNING?: string | null;
  RANTEBERAKNMETOD?: TEDKRKundkategoriRANTEBERAKNMETODEnum | null;
  STANDARD: TEDKRKundkategoriSTANDARDEnum;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  UTGSKOT_KUNDKAT_KOD?: string | null;
  UTGSKOT_AVTALSLANGD?: number | null;
  UTGSKOT_PRISMETOD?: string | null;
  UTGSKOT_PRISMETOD_PARAM?: string | null;
  _Associations?: TEDInputKRKundkategoriAddAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av artikel
 */
export interface TEDInputKRKundkategoriGravAvtalArtikelAddAssociationValues {
  Kundkategori_Ref?: string | null;
  Kundkategori_Values?: TEDInputKRKundkategoriAddValues | null;
  Artikel_Ref?: string | null;
  Artikel_Values?: TEDInputLAArtikelAddValues | null;
}

/**
 * Värden vid tillägg av artikel
 */
export interface TEDInputKRKundkategoriGravAvtalArtikelAddValues {
  _Associations: TEDInputKRKundkategoriGravAvtalArtikelAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av artikel
 */
export interface TEDInputKRKundkategoriGravAvtalArtikelDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av artikel
 */
export interface TEDInputKRKundkategoriGravAvtalArtikelUpdateAssociationValues {
  Kundkategori_Ref?: string | null;
  Kundkategori_Values?: TEDInputKRKundkategoriUpdateValues | null;
  Artikel_Ref?: string | null;
  Artikel_Values?: TEDInputLAArtikelUpdateValues | null;
}

/**
 * Nya värden vid ändring av artikel
 */
export interface TEDInputKRKundkategoriGravAvtalArtikelUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputKRKundkategoriGravAvtalArtikelUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av kundkategori
 */
export interface TEDInputKRKundkategoriUpdateAssociationValues {
  Moms_Ref?: string | null;
  Moms_Values?: TEDInputSYSMomsUpdateValues | null;
  Intaktskonto_Ref?: string | null;
  Intaktskonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Kundfordrkonto_Ref?: string | null;
  Kundfordrkonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Drojsmalintaktkonto_Ref?: string | null;
  Drojsmalintaktkonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  DiffInbetkonto_Ref?: string | null;
  DiffInbetkonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  KundSkuldkonto_Ref?: string | null;
  KundSkuldkonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  KundrantaKredit_Ref?: string | null;
  KundrantaKredit_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  KundrantaDebet_Ref?: string | null;
  KundrantaDebet_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Bank_Ref?: string | null;
  Bank_Values?: TEDInputSYSBankUpdateValues | null;
  RantetabellDrojsmal_Ref?: string | null;
  RantetabellDrojsmal_Values?: TEDInputSYSRanteTabellUpdateValues | null;
  Kundnrserie_Ref?: string | null;
  Kundnrserie_Values?: TEDInputSYSNummerserieUpdateValues | null;
  RantetabellDebitering_Ref?: string | null;
  RantetabellDebitering_Values?: TEDInputSYSRanteTabellUpdateValues | null;
  RantetabellKreditering_Ref?: string | null;
  RantetabellKreditering_Values?: TEDInputSYSRanteTabellUpdateValues | null;
  Kontouppr_Ref?: string | null;
  Kontouppr_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  NollaSaldo_Ref?: string | null;
  NollaSaldo_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Kund_Add_Refs?: string[] | null;
  Kund_Delete_Refs?: string[] | null;
  KundkategoriFaktGrupp_Add_Refs?: string[] | null;
  KundkategoriFaktGrupp_Delete_Refs?: string[] | null;
  GravAvtalArtiklar_Add_Values?: TEDInputKRKundkategoriGravAvtalArtikelAddValues[] | null;
  GravAvtalArtiklar_Update_Values?: TEDInputKRKundkategoriGravAvtalArtikelUpdateValues[] | null;
  GravAvtalArtiklar_Delete_Values?: TEDInputKRKundkategoriGravAvtalArtikelDeleteValues[] | null;
  UtgSkotSparrArtiklar_Add_Values?: TEDInputKRKundkategoriUtgSkotSparrArtikelAddValues[] | null;
  UtgSkotSparrArtiklar_Update_Values?: TEDInputKRKundkategoriUtgSkotSparrArtikelUpdateValues[] | null;
  UtgSkotSparrArtiklar_Delete_Values?: TEDInputKRKundkategoriUtgSkotSparrArtikelDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av kundkategori
 */
export interface TEDInputKRKundkategoriUpdateValues {
  id: string;
  _version: number;
  KUNDKAT_KOD?: string | null;
  INTERN?: TEDKRKundkategoriINTERNEnum | null;
  BENAMNING?: string | null;
  RANTEBERAKNMETOD?: TEDKRKundkategoriRANTEBERAKNMETODEnum | null;
  STANDARD?: TEDKRKundkategoriSTANDARDEnum | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  UTGSKOT_KUNDKAT_KOD?: string | null;
  UTGSKOT_AVTALSLANGD?: number | null;
  UTGSKOT_PRISMETOD?: string | null;
  UTGSKOT_PRISMETOD_PARAM?: string | null;
  _Associations?: TEDInputKRKundkategoriUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av artikel
 */
export interface TEDInputKRKundkategoriUtgSkotSparrArtikelAddAssociationValues {
  Kundkategori_Ref?: string | null;
  Kundkategori_Values?: TEDInputKRKundkategoriAddValues | null;
  Artikel_Ref?: string | null;
  Artikel_Values?: TEDInputLAArtikelAddValues | null;
}

/**
 * Värden vid tillägg av artikel
 */
export interface TEDInputKRKundkategoriUtgSkotSparrArtikelAddValues {
  _Associations: TEDInputKRKundkategoriUtgSkotSparrArtikelAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av artikel
 */
export interface TEDInputKRKundkategoriUtgSkotSparrArtikelDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av artikel
 */
export interface TEDInputKRKundkategoriUtgSkotSparrArtikelUpdateAssociationValues {
  Kundkategori_Ref?: string | null;
  Kundkategori_Values?: TEDInputKRKundkategoriUpdateValues | null;
  Artikel_Ref?: string | null;
  Artikel_Values?: TEDInputLAArtikelUpdateValues | null;
}

/**
 * Nya värden vid ändring av artikel
 */
export interface TEDInputKRKundkategoriUtgSkotSparrArtikelUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputKRKundkategoriUtgSkotSparrArtikelUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av licens
 */
export interface TEDInputKRLicenserAddAssociationValues {
  Kund_Ref?: string | null;
  Kund_Values?: TEDInputKRKundAddValues | null;
  Artikel_Ref?: string | null;
  Artikel_Values?: TEDInputLAArtikelAddValues | null;
  Leverantor_Ref?: string | null;
  Leverantor_Values?: TEDInputLRLeverantorAddValues | null;
  LicensOrder_Add_Refs?: string[] | null;
  Andrahandskund_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av licens
 */
export interface TEDInputKRLicenserAddValues {
  _typ: TEDKRLicenserTypEnum;
  LICENSHAVARE?: string | null;
  DATUMLIMIT?: any | null;
  LICENS_ORDER_ID?: number | null;
  TEXT?: string | null;
  AKTIV?: string | null;
  STARTDATUM?: any | null;
  LICENSNUMMER?: string | null;
  DEMO?: string | null;
  BORTTAGEN: TEDKRLicenserBORTTAGENEnum;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  MAX_PALOGGADE?: number | null;
  MAXVERSION?: number | null;
  LICENSNYCKEL?: string | null;
  SENAST_UPPD_VERSION?: string | null;
  SENAST_UPPD_DATUM?: any | null;
  ANTAL_KLIENTER?: number | null;
  ANTAL_BEGRANSADE?: number | null;
  ANTAL_ANV?: number | null;
  LEVFAKTURA_ID?: number | null;
  MAXANVANDARE?: number | null;
  _Associations?: TEDInputKRLicenserAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av licens
 */
export interface TEDInputKRLicenserDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av licens
 */
export interface TEDInputKRLicenserUpdateAssociationValues {
  Kund_Ref?: string | null;
  Kund_Values?: TEDInputKRKundUpdateValues | null;
  Artikel_Ref?: string | null;
  Artikel_Values?: TEDInputLAArtikelUpdateValues | null;
  Leverantor_Ref?: string | null;
  Leverantor_Values?: TEDInputLRLeverantorUpdateValues | null;
  LicensOrder_Add_Refs?: string[] | null;
  LicensOrder_Delete_Refs?: string[] | null;
  Andrahandskund_Add_Refs?: string[] | null;
  Andrahandskund_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av licens
 */
export interface TEDInputKRLicenserUpdateValues {
  id: string;
  _version: number;
  LICENSHAVARE?: string | null;
  DATUMLIMIT?: any | null;
  LICENS_ORDER_ID?: number | null;
  TEXT?: string | null;
  AKTIV?: string | null;
  STARTDATUM?: any | null;
  LICENSNUMMER?: string | null;
  DEMO?: string | null;
  BORTTAGEN?: TEDKRLicenserBORTTAGENEnum | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  MAX_PALOGGADE?: number | null;
  MAXVERSION?: number | null;
  LICENSNYCKEL?: string | null;
  SENAST_UPPD_VERSION?: string | null;
  SENAST_UPPD_DATUM?: any | null;
  ANTAL_KLIENTER?: number | null;
  ANTAL_BEGRANSADE?: number | null;
  ANTAL_ANV?: number | null;
  LEVFAKTURA_ID?: number | null;
  MAXANVANDARE?: number | null;
  _Associations?: TEDInputKRLicenserUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av medgivande
 */
export interface TEDInputKRMedgivandeAddAssociationValues {
  Kund_Ref?: string | null;
  Kund_Values?: TEDInputKRKundAddValues | null;
}

/**
 * Värden vid tillägg av medgivande
 */
export interface TEDInputKRMedgivandeAddValues {
  AUTOGIRO_VAG: TEDKRMedgivandeAUTOGIRO_VAGEnum;
  MEDDELANDEKOD: TEDKRMedgivandeMEDDELANDEKODEnum;
  SKAPAD_DATUM?: any | null;
  SKICKAD_DATUM?: any | null;
  FELKOD?: string | null;
  MAXBELOPP?: any | null;
  AUTOGIRO_GILTIGT_FROM?: any | null;
  _Associations?: TEDInputKRMedgivandeAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av medgivande
 */
export interface TEDInputKRMedgivandeDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av medgivande
 */
export interface TEDInputKRMedgivandeUpdateAssociationValues {
  Kund_Ref?: string | null;
  Kund_Values?: TEDInputKRKundUpdateValues | null;
}

/**
 * Nya värden vid ändring av medgivande
 */
export interface TEDInputKRMedgivandeUpdateValues {
  id: string;
  _version: number;
  AUTOGIRO_VAG?: TEDKRMedgivandeAUTOGIRO_VAGEnum | null;
  MEDDELANDEKOD?: TEDKRMedgivandeMEDDELANDEKODEnum | null;
  SKAPAD_DATUM?: any | null;
  SKICKAD_DATUM?: any | null;
  FELKOD?: string | null;
  MAXBELOPP?: any | null;
  AUTOGIRO_GILTIGT_FROM?: any | null;
  _Associations?: TEDInputKRMedgivandeUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av artikelgrupp faktureringsgrupp
 */
export interface TEDInputLAArtGruppFaktgruppAddAssociationValues {
  Artikelgrupp_Ref?: string | null;
  Artikelgrupp_Values?: TEDInputLAArtikelgruppAddValues | null;
  Faktureringsgrupp_Ref?: string | null;
  Faktureringsgrupp_Values?: TEDInputSYSGruppAddValues | null;
}

/**
 * Värden vid tillägg av artikelgrupp faktureringsgrupp
 */
export interface TEDInputLAArtGruppFaktgruppAddValues {
  _Associations: TEDInputLAArtGruppFaktgruppAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av artikelgrupp faktureringsgrupp
 */
export interface TEDInputLAArtGruppFaktgruppDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av artikelgrupp faktureringsgrupp
 */
export interface TEDInputLAArtGruppFaktgruppUpdateAssociationValues {
  Artikelgrupp_Ref?: string | null;
  Artikelgrupp_Values?: TEDInputLAArtikelgruppUpdateValues | null;
  Faktureringsgrupp_Ref?: string | null;
  Faktureringsgrupp_Values?: TEDInputSYSGruppUpdateValues | null;
}

/**
 * Nya värden vid ändring av artikelgrupp faktureringsgrupp
 */
export interface TEDInputLAArtGruppFaktgruppUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputLAArtGruppFaktgruppUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av dokument
 */
export interface TEDInputLAArtikelActiveXAddAssociationValues {
  Artikel_Ref?: string | null;
  Artikel_Values?: TEDInputLAArtikelAddValues | null;
}

/**
 * Värden vid tillägg av dokument
 */
export interface TEDInputLAArtikelActiveXAddValues {
  BESKRIVNING?: string | null;
  DATA?: string | null;
  DATASIZE?: number | null;
  DATATYPE?: string | null;
  EXTENSION?: string | null;
  _Associations?: TEDInputLAArtikelActiveXAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av dokument
 */
export interface TEDInputLAArtikelActiveXDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av dokument
 */
export interface TEDInputLAArtikelActiveXUpdateAssociationValues {
  Artikel_Ref?: string | null;
  Artikel_Values?: TEDInputLAArtikelUpdateValues | null;
}

/**
 * Nya värden vid ändring av dokument
 */
export interface TEDInputLAArtikelActiveXUpdateValues {
  id: string;
  _version: number;
  BESKRIVNING?: string | null;
  DATA?: string | null;
  DATASIZE?: number | null;
  DATATYPE?: string | null;
  EXTENSION?: string | null;
  _Associations?: TEDInputLAArtikelActiveXUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av artikel
 */
export interface TEDInputLAArtikelAddAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputLAArtikelBlobAddValues | null;
  Artikelgrupp_Ref?: string | null;
  Artikelgrupp_Values?: TEDInputLAArtikelgruppAddValues | null;
  Moms_Ref?: string | null;
  Moms_Values?: TEDInputSYSMomsAddValues | null;
  Varlev1_Ref?: string | null;
  Varlev1_Values?: TEDInputLRLeverantorAddValues | null;
  Varlev2_Ref?: string | null;
  Varlev2_Values?: TEDInputLRLeverantorAddValues | null;
  Intaktskonto_Ref?: string | null;
  Intaktskonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Faktureringsgrupp_Ref?: string | null;
  Faktureringsgrupp_Values?: TEDInputSYSGruppAddValues | null;
  KOBArtikel_Ref?: string | null;
  KOBArtikel_Values?: TEDInputSYSKOBArtikelAddValues | null;
  Enhet_Ref?: string | null;
  Enhet_Values?: TEDInputLAEnhetAddValues | null;
  TempGASArtikelgrupp_Ref?: string | null;
  TempGASArtikelgrupp_Values?: TEDInputLAArtikelgruppAddValues | null;
  ArtikelgruppForeGAS_Ref?: string | null;
  ArtikelgruppForeGAS_Values?: TEDInputLAArtikelgruppAddValues | null;
  Priser_Add_Values?: TEDInputLAPriserAddValues[] | null;
  Dokument_Add_Values?: TEDInputLAArtikelActiveXAddValues[] | null;
  Orderrad_Add_Refs?: string[] | null;
  Skotsel_Add_Refs?: string[] | null;
  Paket_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av artikel
 */
export interface TEDInputLAArtikelAddValues {
  _typ?: TEDLAArtikelTypEnum | null;
  ARTIKELNR: string;
  BENAMNING?: string | null;
  RABATT?: number | null;
  SORTIMENT?: string | null;
  EJ_ORDERRABATT?: boolean | null;
  VARLEV1_ID?: number | null;
  LEVARTNR2?: string | null;
  FRSKMANAD?: number | null;
  TISKMANAD?: number | null;
  ANVPRISLISTA?: boolean | null;
  EJ_ARBETSUNDERLAG?: boolean | null;
  SKOTNOTFAKT?: boolean | null;
  PAKET?: boolean | null;
  PAKETSPECFAKT?: boolean | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  KOBARTIKEL?: boolean | null;
  LAGERPLATS?: string | null;
  LAGERANTAL?: number | null;
  BESTALLNINGSPKT?: number | null;
  BESTKVANT?: number | null;
  ENGANGSARTIKEL?: boolean | null;
  VANVARD?: boolean | null;
  EXT_BESKRIVNING?: string | null;
  BRYTDATUM?: number | null;
  BESTALLNINGSBAR_FR?: number | null;
  BESTALLNINGSBAR_TI?: number | null;
  BESTALLNINGSGRUPP?: string | null;
  LOVET_WEBGRAV?: boolean | null;
  _Associations: TEDInputLAArtikelAddAssociationValues;
}

/**
 * Värden vid tillägg av lAArtikelBlob
 */
export interface TEDInputLAArtikelBlobAddValues {
  SKOTNOT?: string | null;
  BILD?: string | null;
  BILDSIZE?: number | null;
  BILDSTRETCH?: string | null;
}

/**
 * Nya värden vid ändring av lAArtikelBlob
 */
export interface TEDInputLAArtikelBlobUpdateValues {
  id: string;
  _version: number;
  SKOTNOT?: string | null;
  BILD?: string | null;
  BILDSIZE?: number | null;
  BILDSTRETCH?: string | null;
}

/**
 * Associerade värden vid ändring av artikel
 */
export interface TEDInputLAArtikelUpdateAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputLAArtikelBlobUpdateValues | null;
  Artikelgrupp_Ref?: string | null;
  Artikelgrupp_Values?: TEDInputLAArtikelgruppUpdateValues | null;
  Moms_Ref?: string | null;
  Moms_Values?: TEDInputSYSMomsUpdateValues | null;
  Varlev1_Ref?: string | null;
  Varlev1_Values?: TEDInputLRLeverantorUpdateValues | null;
  Varlev2_Ref?: string | null;
  Varlev2_Values?: TEDInputLRLeverantorUpdateValues | null;
  Intaktskonto_Ref?: string | null;
  Intaktskonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Faktureringsgrupp_Ref?: string | null;
  Faktureringsgrupp_Values?: TEDInputSYSGruppUpdateValues | null;
  KOBArtikel_Ref?: string | null;
  KOBArtikel_Values?: TEDInputSYSKOBArtikelUpdateValues | null;
  Enhet_Ref?: string | null;
  Enhet_Values?: TEDInputLAEnhetUpdateValues | null;
  TempGASArtikelgrupp_Ref?: string | null;
  TempGASArtikelgrupp_Values?: TEDInputLAArtikelgruppUpdateValues | null;
  ArtikelgruppForeGAS_Ref?: string | null;
  ArtikelgruppForeGAS_Values?: TEDInputLAArtikelgruppUpdateValues | null;
  Priser_Add_Values?: TEDInputLAPriserAddValues[] | null;
  Priser_Update_Values?: TEDInputLAPriserUpdateValues[] | null;
  Priser_Delete_Values?: TEDInputLAPriserDeleteValues[] | null;
  Dokument_Add_Values?: TEDInputLAArtikelActiveXAddValues[] | null;
  Dokument_Update_Values?: TEDInputLAArtikelActiveXUpdateValues[] | null;
  Dokument_Delete_Values?: TEDInputLAArtikelActiveXDeleteValues[] | null;
  Orderrad_Add_Refs?: string[] | null;
  Orderrad_Delete_Refs?: string[] | null;
  Skotsel_Add_Refs?: string[] | null;
  Skotsel_Delete_Refs?: string[] | null;
  Paket_Add_Refs?: string[] | null;
  Paket_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av artikel
 */
export interface TEDInputLAArtikelUpdateValues {
  id: string;
  _version: number;
  ARTIKELNR?: string | null;
  BENAMNING?: string | null;
  RABATT?: number | null;
  SORTIMENT?: string | null;
  EJ_ORDERRABATT?: boolean | null;
  VARLEV1_ID?: number | null;
  LEVARTNR2?: string | null;
  FRSKMANAD?: number | null;
  TISKMANAD?: number | null;
  ANVPRISLISTA?: boolean | null;
  EJ_ARBETSUNDERLAG?: boolean | null;
  SKOTNOTFAKT?: boolean | null;
  PAKET?: boolean | null;
  PAKETSPECFAKT?: boolean | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  KOBARTIKEL?: boolean | null;
  LAGERPLATS?: string | null;
  LAGERANTAL?: number | null;
  BESTALLNINGSPKT?: number | null;
  BESTKVANT?: number | null;
  ENGANGSARTIKEL?: boolean | null;
  VANVARD?: boolean | null;
  EXT_BESKRIVNING?: string | null;
  BRYTDATUM?: number | null;
  BESTALLNINGSBAR_FR?: number | null;
  BESTALLNINGSBAR_TI?: number | null;
  BESTALLNINGSGRUPP?: string | null;
  LOVET_WEBGRAV?: boolean | null;
  _Associations?: TEDInputLAArtikelUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av artikelgrupp
 */
export interface TEDInputLAArtikelgruppAddAssociationValues {
  Intaktskonto_Ref?: string | null;
  Intaktskonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Artikel_Add_Refs?: string[] | null;
  Fakturatext_Add_Refs?: string[] | null;
  FaktGrupp_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av artikelgrupp
 */
export interface TEDInputLAArtikelgruppAddValues {
  ARTIKELGRUPP: string;
  BENAMNING: string;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  _Associations?: TEDInputLAArtikelgruppAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av artikelgrupp
 */
export interface TEDInputLAArtikelgruppUpdateAssociationValues {
  Intaktskonto_Ref?: string | null;
  Intaktskonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Artikel_Add_Refs?: string[] | null;
  Artikel_Delete_Refs?: string[] | null;
  Fakturatext_Add_Refs?: string[] | null;
  Fakturatext_Delete_Refs?: string[] | null;
  FaktGrupp_Add_Refs?: string[] | null;
  FaktGrupp_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av artikelgrupp
 */
export interface TEDInputLAArtikelgruppUpdateValues {
  id: string;
  _version: number;
  ARTIKELGRUPP?: string | null;
  BENAMNING?: string | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  _Associations?: TEDInputLAArtikelgruppUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av enhet
 */
export interface TEDInputLAEnhetAddAssociationValues {
  Artikel_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av enhet
 */
export interface TEDInputLAEnhetAddValues {
  ENHET: string;
  BENAMNING: string;
  ANTALDEC?: number | null;
  EK?: TEDLAEnhetEKEnum | null;
  LA?: TEDLAEnhetLAEnum | null;
  TI?: TEDLAEnhetTIEnum | null;
  TI_INTRED_TIM?: TEDLAEnhetTI_INTRED_TIMEnum | null;
  IMPORT_BENAMNING?: string | null;
  _Associations?: TEDInputLAEnhetAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av enhet
 */
export interface TEDInputLAEnhetUpdateAssociationValues {
  Artikel_Add_Refs?: string[] | null;
  Artikel_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av enhet
 */
export interface TEDInputLAEnhetUpdateValues {
  id: string;
  _version: number;
  ENHET?: string | null;
  BENAMNING?: string | null;
  ANTALDEC?: number | null;
  EK?: TEDLAEnhetEKEnum | null;
  LA?: TEDLAEnhetLAEnum | null;
  TI?: TEDLAEnhetTIEnum | null;
  TI_INTRED_TIM?: TEDLAEnhetTI_INTRED_TIMEnum | null;
  IMPORT_BENAMNING?: string | null;
  _Associations?: TEDInputLAEnhetUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av fakturatext
 */
export interface TEDInputLAFakturatextAddAssociationValues {
  Artikelgrupp_Ref?: string | null;
  Artikelgrupp_Values?: TEDInputLAArtikelgruppAddValues | null;
}

/**
 * Värden vid tillägg av fakturatext
 */
export interface TEDInputLAFakturatextAddValues {
  SORTKOD: string;
  BENAMNING?: string | null;
  _Associations: TEDInputLAFakturatextAddAssociationValues;
}

/**
 * Associerade värden vid ändring av fakturatext
 */
export interface TEDInputLAFakturatextUpdateAssociationValues {
  Artikelgrupp_Ref?: string | null;
  Artikelgrupp_Values?: TEDInputLAArtikelgruppUpdateValues | null;
}

/**
 * Nya värden vid ändring av fakturatext
 */
export interface TEDInputLAFakturatextUpdateValues {
  id: string;
  _version: number;
  SORTKOD?: string | null;
  BENAMNING?: string | null;
  _Associations?: TEDInputLAFakturatextUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av pris
 */
export interface TEDInputLAPriserAddAssociationValues {
  Prislista_Ref?: string | null;
  Prislista_Values?: TEDInputLAPrislistaAddValues | null;
  Artikel_Ref?: string | null;
  Artikel_Values?: TEDInputLAArtikelAddValues | null;
}

/**
 * Värden vid tillägg av pris
 */
export interface TEDInputLAPriserAddValues {
  FRANDATUM?: any | null;
  PRIS?: any | null;
  _Associations?: TEDInputLAPriserAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av pris
 */
export interface TEDInputLAPriserDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av pris
 */
export interface TEDInputLAPriserUpdateAssociationValues {
  Prislista_Ref?: string | null;
  Prislista_Values?: TEDInputLAPrislistaUpdateValues | null;
  Artikel_Ref?: string | null;
  Artikel_Values?: TEDInputLAArtikelUpdateValues | null;
}

/**
 * Nya värden vid ändring av pris
 */
export interface TEDInputLAPriserUpdateValues {
  id: string;
  _version: number;
  FRANDATUM?: any | null;
  PRIS?: any | null;
  _Associations?: TEDInputLAPriserUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av prislista
 */
export interface TEDInputLAPrislistaAddAssociationValues {
  Priser_Add_Values?: TEDInputLAPriserAddValues[] | null;
  Kund_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av prislista
 */
export interface TEDInputLAPrislistaAddValues {
  BENAMNING: string;
  KUNDLEVERANTOR: string;
  STANDARD: TEDLAPrislistaSTANDARDEnum;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  _Associations?: TEDInputLAPrislistaAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av prislista
 */
export interface TEDInputLAPrislistaUpdateAssociationValues {
  Priser_Add_Values?: TEDInputLAPriserAddValues[] | null;
  Priser_Update_Values?: TEDInputLAPriserUpdateValues[] | null;
  Priser_Delete_Values?: TEDInputLAPriserDeleteValues[] | null;
  Kund_Add_Refs?: string[] | null;
  Kund_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av prislista
 */
export interface TEDInputLAPrislistaUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  KUNDLEVERANTOR?: string | null;
  STANDARD?: TEDLAPrislistaSTANDARDEnum | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  _Associations?: TEDInputLAPrislistaUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av attestgrupp
 */
export interface TEDInputLRAttestGruppAddAssociationValues {
  StandardAttestratt_Ref?: string | null;
  StandardAttestratt_Values?: TEDInputLRAttestrattAddValues | null;
  StandardForenkladAttestratt_Ref?: string | null;
  StandardForenkladAttestratt_Values?: TEDInputLRAttestrattAddValues | null;
  StandardForenkladBAAttestratt_Ref?: string | null;
  StandardForenkladBAAttestratt_Values?: TEDInputLRAttestrattAddValues | null;
  Attestomrade_Add_Refs?: string[] | null;
  Administratorer_Add_Values?: TEDInputLRAttestGruppAdmAddValues[] | null;
  Bokfgrupp_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av attestgrupp
 */
export interface TEDInputLRAttestGruppAddValues {
  BENAMNING?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  DGR_TILL_FORFALLODATUM?: number | null;
  BOKF_GRUPP_ID?: number | null;
  ELEKTRONISK_ATTEST?: string | null;
  BEH_KONTROLL?: string | null;
  _Associations?: TEDInputLRAttestGruppAddAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av attestgruppsadministratör
 */
export interface TEDInputLRAttestGruppAdmAddAssociationValues {
  Attestgrupp_Ref?: string | null;
  Attestgrupp_Values?: TEDInputLRAttestGruppAddValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
}

/**
 * Värden vid tillägg av attestgruppsadministratör
 */
export interface TEDInputLRAttestGruppAdmAddValues {
  _Associations: TEDInputLRAttestGruppAdmAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av attestgruppsadministratör
 */
export interface TEDInputLRAttestGruppAdmDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av attestgruppsadministratör
 */
export interface TEDInputLRAttestGruppAdmUpdateAssociationValues {
  Attestgrupp_Ref?: string | null;
  Attestgrupp_Values?: TEDInputLRAttestGruppUpdateValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
}

/**
 * Nya värden vid ändring av attestgruppsadministratör
 */
export interface TEDInputLRAttestGruppAdmUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputLRAttestGruppAdmUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av attestgrupp
 */
export interface TEDInputLRAttestGruppUpdateAssociationValues {
  StandardAttestratt_Ref?: string | null;
  StandardAttestratt_Values?: TEDInputLRAttestrattUpdateValues | null;
  StandardForenkladAttestratt_Ref?: string | null;
  StandardForenkladAttestratt_Values?: TEDInputLRAttestrattUpdateValues | null;
  StandardForenkladBAAttestratt_Ref?: string | null;
  StandardForenkladBAAttestratt_Values?: TEDInputLRAttestrattUpdateValues | null;
  Attestomrade_Add_Refs?: string[] | null;
  Attestomrade_Delete_Refs?: string[] | null;
  Administratorer_Add_Values?: TEDInputLRAttestGruppAdmAddValues[] | null;
  Administratorer_Update_Values?: TEDInputLRAttestGruppAdmUpdateValues[] | null;
  Administratorer_Delete_Values?: TEDInputLRAttestGruppAdmDeleteValues[] | null;
  Bokfgrupp_Add_Refs?: string[] | null;
  Bokfgrupp_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av attestgrupp
 */
export interface TEDInputLRAttestGruppUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  DGR_TILL_FORFALLODATUM?: number | null;
  BOKF_GRUPP_ID?: number | null;
  ELEKTRONISK_ATTEST?: string | null;
  BEH_KONTROLL?: string | null;
  _Associations?: TEDInputLRAttestGruppUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av attestområde
 */
export interface TEDInputLRAttestOmradeAddAssociationValues {
  Attestgrupp_Ref?: string | null;
  Attestgrupp_Values?: TEDInputLRAttestGruppAddValues | null;
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalAddValues | null;
  Attestratt_Add_Values?: TEDInputLRAttestrattAddValues[] | null;
  Kontobegransning_Add_Values?: TEDInputLRAttestomradeKontobegrAddValues[] | null;
}

/**
 * Värden vid tillägg av attestområde
 */
export interface TEDInputLRAttestOmradeAddValues {
  KOD?: string | null;
  BENAMNING: string;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  ANVANDS_FROM?: any | null;
  ANVANDS_TOM?: any | null;
  _Associations: TEDInputLRAttestOmradeAddAssociationValues;
}

/**
 * Associerade värden vid ändring av attestområde
 */
export interface TEDInputLRAttestOmradeUpdateAssociationValues {
  Attestgrupp_Ref?: string | null;
  Attestgrupp_Values?: TEDInputLRAttestGruppUpdateValues | null;
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalUpdateValues | null;
  Attestratt_Add_Values?: TEDInputLRAttestrattAddValues[] | null;
  Attestratt_Update_Values?: TEDInputLRAttestrattUpdateValues[] | null;
  Attestratt_Delete_Values?: TEDInputLRAttestrattDeleteValues[] | null;
  Attestratt_Undelete?: TEDInputLRAttestrattDeleteValues[] | null;
  Kontobegransning_Add_Values?: TEDInputLRAttestomradeKontobegrAddValues[] | null;
  Kontobegransning_Update_Values?: TEDInputLRAttestomradeKontobegrUpdateValues[] | null;
  Kontobegransning_Delete_Values?: TEDInputLRAttestomradeKontobegrDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av attestområde
 */
export interface TEDInputLRAttestOmradeUpdateValues {
  id: string;
  _version: number;
  KOD?: string | null;
  BENAMNING?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  ANVANDS_FROM?: any | null;
  ANVANDS_TOM?: any | null;
  _Associations?: TEDInputLRAttestOmradeUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av attestant
 */
export interface TEDInputLRAttestantAddAssociationValues {
  Prelarkonto_Ref?: string | null;
  Prelarkonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalAddValues | null;
  Konteringsrecept_Add_Values?: TEDInputLRKonteringsreceptAddValues[] | null;
  Attestratt_Add_Refs?: string[] | null;
  Kontobegransning_Add_Values?: TEDInputLRAttestantKontobegrAddValues[] | null;
  Referenskoder_Add_Values?: TEDInputLRAttestantReferenskodAddValues[] | null;
  Reserver_Add_Values?: TEDInputLRAttestrattReservAddValues[] | null;
}

/**
 * Värden vid tillägg av attestant
 */
export interface TEDInputLRAttestantAddValues {
  SIGNATUR: string;
  BENAMNING?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  KONTOINT_TYP: TEDLRAttestantKONTOINT_TYPEnum;
  MAX_BELOPP?: any | null;
  FRANVARANDE?: TEDLRAttestantFRANVARANDEEnum | null;
  FRANVARANDE_FROM?: any | null;
  FRANVARANDE_TOM?: any | null;
  FRANVARANDE_NOTERING?: string | null;
  ELEKTRONISK_ATTEST: TEDLRAttestantELEKTRONISK_ATTESTEnum;
  _Associations?: TEDInputLRAttestantAddAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av attestantens kodbegränsning
 */
export interface TEDInputLRAttestantKontobegrAddAssociationValues {
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalAddValues | null;
  Attestant_Ref?: string | null;
  Attestant_Values?: TEDInputLRAttestantAddValues | null;
}

/**
 * Värden vid tillägg av attestantens kodbegränsning
 */
export interface TEDInputLRAttestantKontobegrAddValues {
  KPLAN_ID?: number | null;
  KONV_TO_VIEW_ID?: number | null;
  _Associations?: TEDInputLRAttestantKontobegrAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av attestantens kodbegränsning
 */
export interface TEDInputLRAttestantKontobegrDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av attestantens kodbegränsning
 */
export interface TEDInputLRAttestantKontobegrUpdateAssociationValues {
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalUpdateValues | null;
  Attestant_Ref?: string | null;
  Attestant_Values?: TEDInputLRAttestantUpdateValues | null;
}

/**
 * Nya värden vid ändring av attestantens kodbegränsning
 */
export interface TEDInputLRAttestantKontobegrUpdateValues {
  id: string;
  _version: number;
  KPLAN_ID?: number | null;
  KONV_TO_VIEW_ID?: number | null;
  _Associations?: TEDInputLRAttestantKontobegrUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av attestant, referenskod
 */
export interface TEDInputLRAttestantReferenskodAddAssociationValues {
  Attestant_Ref?: string | null;
  Attestant_Values?: TEDInputLRAttestantAddValues | null;
}

/**
 * Värden vid tillägg av attestant, referenskod
 */
export interface TEDInputLRAttestantReferenskodAddValues {
  LOPNR?: number | null;
  REFERENSKOD?: string | null;
  _Associations?: TEDInputLRAttestantReferenskodAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av attestant, referenskod
 */
export interface TEDInputLRAttestantReferenskodDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av attestant, referenskod
 */
export interface TEDInputLRAttestantReferenskodUpdateAssociationValues {
  Attestant_Ref?: string | null;
  Attestant_Values?: TEDInputLRAttestantUpdateValues | null;
}

/**
 * Nya värden vid ändring av attestant, referenskod
 */
export interface TEDInputLRAttestantReferenskodUpdateValues {
  id: string;
  _version: number;
  LOPNR?: number | null;
  REFERENSKOD?: string | null;
  _Associations?: TEDInputLRAttestantReferenskodUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av attestant
 */
export interface TEDInputLRAttestantUpdateAssociationValues {
  Prelarkonto_Ref?: string | null;
  Prelarkonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalUpdateValues | null;
  Konteringsrecept_Add_Values?: TEDInputLRKonteringsreceptAddValues[] | null;
  Konteringsrecept_Update_Values?: TEDInputLRKonteringsreceptUpdateValues[] | null;
  Konteringsrecept_Delete_Values?: TEDInputLRKonteringsreceptDeleteValues[] | null;
  Attestratt_Add_Refs?: string[] | null;
  Attestratt_Delete_Refs?: string[] | null;
  Kontobegransning_Add_Values?: TEDInputLRAttestantKontobegrAddValues[] | null;
  Kontobegransning_Update_Values?: TEDInputLRAttestantKontobegrUpdateValues[] | null;
  Kontobegransning_Delete_Values?: TEDInputLRAttestantKontobegrDeleteValues[] | null;
  Referenskoder_Add_Values?: TEDInputLRAttestantReferenskodAddValues[] | null;
  Referenskoder_Update_Values?: TEDInputLRAttestantReferenskodUpdateValues[] | null;
  Referenskoder_Delete_Values?: TEDInputLRAttestantReferenskodDeleteValues[] | null;
  Reserver_Add_Values?: TEDInputLRAttestrattReservAddValues[] | null;
  Reserver_Update_Values?: TEDInputLRAttestrattReservUpdateValues[] | null;
  Reserver_Delete_Values?: TEDInputLRAttestrattReservDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av attestant
 */
export interface TEDInputLRAttestantUpdateValues {
  id: string;
  _version: number;
  SIGNATUR?: string | null;
  BENAMNING?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  KONTOINT_TYP?: TEDLRAttestantKONTOINT_TYPEnum | null;
  MAX_BELOPP?: any | null;
  FRANVARANDE?: TEDLRAttestantFRANVARANDEEnum | null;
  FRANVARANDE_FROM?: any | null;
  FRANVARANDE_TOM?: any | null;
  FRANVARANDE_NOTERING?: string | null;
  ELEKTRONISK_ATTEST?: TEDLRAttestantELEKTRONISK_ATTESTEnum | null;
  _Associations?: TEDInputLRAttestantUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av leverantörsfakturareferens
 */
export interface TEDInputLRAttestforslagAddAssociationValues {
  Leverantor_Ref?: string | null;
  Leverantor_Values?: TEDInputLRLeverantorAddValues | null;
  Fakturakod_Ref?: string | null;
  Fakturakod_Values?: TEDInputSYSFakturakodAddValues | null;
  MottagandeEnhet_Ref?: string | null;
  MottagandeEnhet_Values?: TEDInputOPOrgPersLokAddValues | null;
  Fakturaradskod_Ref?: string | null;
  Fakturaradskod_Values?: TEDInputSYSFakturaradskodAddValues | null;
  Konteringar_Add_Values?: TEDInputLRAttestforslagKonteringAddValues[] | null;
  ForslagDel_Add_Values?: TEDInputLRAttestforslagDelAddValues[] | null;
}

/**
 * Värden vid tillägg av leverantörsfakturareferens
 */
export interface TEDInputLRAttestforslagAddValues {
  ATTESTTYP?: TEDLRAttestforslagATTESTTYPEnum | null;
  AKTIV?: boolean | null;
  REFERENS?: string | null;
  REFERENS_SOKTYP?: TEDLRAttestforslagREFERENS_SOKTYPEnum | null;
  ANVANDS_FOR?: TEDLRAttestforslagANVANDS_FOREnum | null;
  GILTIG_FOR: TEDLRAttestforslagGILTIG_FOREnum;
  NOTERING?: string | null;
  FAKTURARADSKOD?: string | null;
  _Associations?: TEDInputLRAttestforslagAddAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av attestdel
 */
export interface TEDInputLRAttestforslagDelAddAssociationValues {
  Attestforslag_Ref?: string | null;
  Attestforslag_Values?: TEDInputLRAttestforslagAddValues | null;
  ForslagDelAttestant_Add_Values?: TEDInputLRAttestforslagDelAttestantAddValues[] | null;
}

/**
 * Värden vid tillägg av attestdel
 */
export interface TEDInputLRAttestforslagDelAddValues {
  ORDNINGS_NR?: number | null;
  ATTESTGRUPP_ID?: number | null;
  _Associations?: TEDInputLRAttestforslagDelAddAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av attestant
 */
export interface TEDInputLRAttestforslagDelAttestantAddAssociationValues {
  ForslagDel_Ref?: string | null;
  ForslagDel_Values?: TEDInputLRAttestforslagDelAddValues | null;
  Attestratt_Ref?: string | null;
  Attestratt_Values?: TEDInputLRAttestrattAddValues | null;
}

/**
 * Värden vid tillägg av attestant
 */
export interface TEDInputLRAttestforslagDelAttestantAddValues {
  TYP: TEDLRAttestforslagDelAttestantTYPEnum;
  ORDNINGS_NR?: number | null;
  ATTESTOMRADE_ID?: number | null;
  ATTESTRATT_LOPNR?: number | null;
  _Associations?: TEDInputLRAttestforslagDelAttestantAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av attestant
 */
export interface TEDInputLRAttestforslagDelAttestantDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av attestant
 */
export interface TEDInputLRAttestforslagDelAttestantUpdateAssociationValues {
  ForslagDel_Ref?: string | null;
  ForslagDel_Values?: TEDInputLRAttestforslagDelUpdateValues | null;
  Attestratt_Ref?: string | null;
  Attestratt_Values?: TEDInputLRAttestrattUpdateValues | null;
}

/**
 * Nya värden vid ändring av attestant
 */
export interface TEDInputLRAttestforslagDelAttestantUpdateValues {
  id: string;
  _version: number;
  TYP?: TEDLRAttestforslagDelAttestantTYPEnum | null;
  ORDNINGS_NR?: number | null;
  ATTESTOMRADE_ID?: number | null;
  ATTESTRATT_LOPNR?: number | null;
  _Associations?: TEDInputLRAttestforslagDelAttestantUpdateAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av attestdel
 */
export interface TEDInputLRAttestforslagDelDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av attestdel
 */
export interface TEDInputLRAttestforslagDelUpdateAssociationValues {
  Attestforslag_Ref?: string | null;
  Attestforslag_Values?: TEDInputLRAttestforslagUpdateValues | null;
  ForslagDelAttestant_Add_Values?: TEDInputLRAttestforslagDelAttestantAddValues[] | null;
  ForslagDelAttestant_Update_Values?: TEDInputLRAttestforslagDelAttestantUpdateValues[] | null;
  ForslagDelAttestant_Delete_Values?: TEDInputLRAttestforslagDelAttestantDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av attestdel
 */
export interface TEDInputLRAttestforslagDelUpdateValues {
  id: string;
  _version: number;
  ORDNINGS_NR?: number | null;
  ATTESTGRUPP_ID?: number | null;
  _Associations?: TEDInputLRAttestforslagDelUpdateAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av leverantörsfakturareferens
 */
export interface TEDInputLRAttestforslagDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid tillägg av fakturastyrning, kontering
 */
export interface TEDInputLRAttestforslagKonteringAddAssociationValues {
  Kostnadskonto_Ref?: string | null;
  Kostnadskonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Attestforslag_Ref?: string | null;
  Attestforslag_Values?: TEDInputLRAttestforslagAddValues | null;
}

/**
 * Värden vid tillägg av fakturastyrning, kontering
 */
export interface TEDInputLRAttestforslagKonteringAddValues {
  LOPNR?: number | null;
  PROCENT?: number | null;
  _Associations?: TEDInputLRAttestforslagKonteringAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av fakturastyrning, kontering
 */
export interface TEDInputLRAttestforslagKonteringDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av fakturastyrning, kontering
 */
export interface TEDInputLRAttestforslagKonteringUpdateAssociationValues {
  Kostnadskonto_Ref?: string | null;
  Kostnadskonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Attestforslag_Ref?: string | null;
  Attestforslag_Values?: TEDInputLRAttestforslagUpdateValues | null;
}

/**
 * Nya värden vid ändring av fakturastyrning, kontering
 */
export interface TEDInputLRAttestforslagKonteringUpdateValues {
  id: string;
  _version: number;
  LOPNR?: number | null;
  PROCENT?: number | null;
  _Associations?: TEDInputLRAttestforslagKonteringUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av leverantörsfakturareferens
 */
export interface TEDInputLRAttestforslagUpdateAssociationValues {
  Leverantor_Ref?: string | null;
  Leverantor_Values?: TEDInputLRLeverantorUpdateValues | null;
  Fakturakod_Ref?: string | null;
  Fakturakod_Values?: TEDInputSYSFakturakodUpdateValues | null;
  MottagandeEnhet_Ref?: string | null;
  MottagandeEnhet_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Fakturaradskod_Ref?: string | null;
  Fakturaradskod_Values?: TEDInputSYSFakturaradskodUpdateValues | null;
  Konteringar_Add_Values?: TEDInputLRAttestforslagKonteringAddValues[] | null;
  Konteringar_Update_Values?: TEDInputLRAttestforslagKonteringUpdateValues[] | null;
  Konteringar_Delete_Values?: TEDInputLRAttestforslagKonteringDeleteValues[] | null;
  ForslagDel_Add_Values?: TEDInputLRAttestforslagDelAddValues[] | null;
  ForslagDel_Update_Values?: TEDInputLRAttestforslagDelUpdateValues[] | null;
  ForslagDel_Delete_Values?: TEDInputLRAttestforslagDelDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av leverantörsfakturareferens
 */
export interface TEDInputLRAttestforslagUpdateValues {
  id: string;
  _version: number;
  ATTESTTYP?: TEDLRAttestforslagATTESTTYPEnum | null;
  AKTIV?: boolean | null;
  REFERENS?: string | null;
  REFERENS_SOKTYP?: TEDLRAttestforslagREFERENS_SOKTYPEnum | null;
  ANVANDS_FOR?: TEDLRAttestforslagANVANDS_FOREnum | null;
  GILTIG_FOR?: TEDLRAttestforslagGILTIG_FOREnum | null;
  NOTERING?: string | null;
  FAKTURARADSKOD?: string | null;
  _Associations?: TEDInputLRAttestforslagUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kvittens
 */
export interface TEDInputLRAttestmedKvittensAddAssociationValues {
  Attestratt_Ref?: string | null;
  Attestratt_Values?: TEDInputLRAttestrattAddValues | null;
  ReservAttestratt_Ref?: string | null;
  ReservAttestratt_Values?: TEDInputLRAttestrattAddValues | null;
}

/**
 * Värden vid tillägg av kvittens
 */
export interface TEDInputLRAttestmedKvittensAddValues {
  DATUM?: any | null;
  ATTESTOMRADE_ID?: number | null;
  ATTESTRATT_LOPNR?: number | null;
  RESERV_ATTESTOMRADE_ID?: number | null;
  RESERV_ATTESTRATT_LOPNR?: number | null;
  _Associations?: TEDInputLRAttestmedKvittensAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kvittens
 */
export interface TEDInputLRAttestmedKvittensDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kvittens
 */
export interface TEDInputLRAttestmedKvittensUpdateAssociationValues {
  Attestratt_Ref?: string | null;
  Attestratt_Values?: TEDInputLRAttestrattUpdateValues | null;
  ReservAttestratt_Ref?: string | null;
  ReservAttestratt_Values?: TEDInputLRAttestrattUpdateValues | null;
}

/**
 * Nya värden vid ändring av kvittens
 */
export interface TEDInputLRAttestmedKvittensUpdateValues {
  id: string;
  _version: number;
  DATUM?: any | null;
  ATTESTOMRADE_ID?: number | null;
  ATTESTRATT_LOPNR?: number | null;
  RESERV_ATTESTOMRADE_ID?: number | null;
  RESERV_ATTESTRATT_LOPNR?: number | null;
  _Associations?: TEDInputLRAttestmedKvittensUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av attestmeddelande
 */
export interface TEDInputLRAttestmeddelandeAddAssociationValues {
  AvsandarAttestratt_Ref?: string | null;
  AvsandarAttestratt_Values?: TEDInputLRAttestrattAddValues | null;
  AvsandarAdminUser_Ref?: string | null;
  AvsandarAdminUser_Values?: TEDInputSYSUserAddValues | null;
  MottagarAttestratt_Ref?: string | null;
  MottagarAttestratt_Values?: TEDInputLRAttestrattAddValues | null;
  Kvittenser_Add_Values?: TEDInputLRAttestmedKvittensAddValues[] | null;
}

/**
 * Värden vid tillägg av attestmeddelande
 */
export interface TEDInputLRAttestmeddelandeAddValues {
  DATUM?: any | null;
  TID?: any | null;
  AVSANDAR_TYP: TEDLRAttestmeddelandeAVSANDAR_TYPEnum;
  MOTTAGAR_TYP: TEDLRAttestmeddelandeMOTTAGAR_TYPEnum;
  MEDDELANDE?: string | null;
  MEDDELANDE_KORT?: string | null;
  _Associations?: TEDInputLRAttestmeddelandeAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av attestmeddelande
 */
export interface TEDInputLRAttestmeddelandeDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av attestmeddelande
 */
export interface TEDInputLRAttestmeddelandeUpdateAssociationValues {
  AvsandarAttestratt_Ref?: string | null;
  AvsandarAttestratt_Values?: TEDInputLRAttestrattUpdateValues | null;
  AvsandarAdminUser_Ref?: string | null;
  AvsandarAdminUser_Values?: TEDInputSYSUserUpdateValues | null;
  MottagarAttestratt_Ref?: string | null;
  MottagarAttestratt_Values?: TEDInputLRAttestrattUpdateValues | null;
  Kvittenser_Add_Values?: TEDInputLRAttestmedKvittensAddValues[] | null;
  Kvittenser_Update_Values?: TEDInputLRAttestmedKvittensUpdateValues[] | null;
  Kvittenser_Delete_Values?: TEDInputLRAttestmedKvittensDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av attestmeddelande
 */
export interface TEDInputLRAttestmeddelandeUpdateValues {
  id: string;
  _version: number;
  DATUM?: any | null;
  TID?: any | null;
  AVSANDAR_TYP?: TEDLRAttestmeddelandeAVSANDAR_TYPEnum | null;
  MOTTAGAR_TYP?: TEDLRAttestmeddelandeMOTTAGAR_TYPEnum | null;
  MEDDELANDE?: string | null;
  MEDDELANDE_KORT?: string | null;
  _Associations?: TEDInputLRAttestmeddelandeUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av attestområdets kodbegränsning
 */
export interface TEDInputLRAttestomradeKontobegrAddAssociationValues {
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalAddValues | null;
  Attestomrade_Ref?: string | null;
  Attestomrade_Values?: TEDInputLRAttestOmradeAddValues | null;
}

/**
 * Värden vid tillägg av attestområdets kodbegränsning
 */
export interface TEDInputLRAttestomradeKontobegrAddValues {
  KPLAN_ID?: number | null;
  _Associations?: TEDInputLRAttestomradeKontobegrAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av attestområdets kodbegränsning
 */
export interface TEDInputLRAttestomradeKontobegrDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av attestområdets kodbegränsning
 */
export interface TEDInputLRAttestomradeKontobegrUpdateAssociationValues {
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalUpdateValues | null;
  Attestomrade_Ref?: string | null;
  Attestomrade_Values?: TEDInputLRAttestOmradeUpdateValues | null;
}

/**
 * Nya värden vid ändring av attestområdets kodbegränsning
 */
export interface TEDInputLRAttestomradeKontobegrUpdateValues {
  id: string;
  _version: number;
  KPLAN_ID?: number | null;
  _Associations?: TEDInputLRAttestomradeKontobegrUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av attesträtt
 */
export interface TEDInputLRAttestrattAddAssociationValues {
  Attestant_Ref?: string | null;
  Attestant_Values?: TEDInputLRAttestantAddValues | null;
  Attestomrade_Ref?: string | null;
  Attestomrade_Values?: TEDInputLRAttestOmradeAddValues | null;
  Kontrollattestratt_Ref?: string | null;
  Kontrollattestratt_Values?: TEDInputLRAttestrattAddValues | null;
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalAddValues | null;
  Reserver_Add_Values?: TEDInputLRAttestrattReservAddValues[] | null;
  Kontobegransning_Add_Values?: TEDInputLRAttestrattKontobegrAddValues[] | null;
  Attestbegransningar_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av attesträtt
 */
export interface TEDInputLRAttestrattAddValues {
  SORT_ORDNING?: number | null;
  TITEL?: string | null;
  AKTIV?: TEDLRAttestrattAKTIVEnum | null;
  ANSVARIG?: TEDLRAttestrattANSVARIGEnum | null;
  MOTTAGN_ATTEST?: TEDLRAttestrattMOTTAGN_ATTESTEnum | null;
  MOTTAGN_KONTERING?: TEDLRAttestrattMOTTAGN_KONTERINGEnum | null;
  BESLUT_ATTEST?: TEDLRAttestrattBESLUT_ATTESTEnum | null;
  KONTOINT_ENL_ATTESTANT?: TEDLRAttestrattKONTOINT_ENL_ATTESTANTEnum | null;
  BESLUT_MAXBELOPP?: any | null;
  KONTROLL_BELOPP?: any | null;
  MEDDELA_EPOST?: TEDLRAttestrattMEDDELA_EPOSTEnum | null;
  GRANSKNING_ATTEST?: TEDLRAttestrattGRANSKNING_ATTESTEnum | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  MOTTAGN_REFUSERA?: TEDLRAttestrattMOTTAGN_REFUSERAEnum | null;
  GRANSKA_FORANKLAD_DEFBOK?: boolean | null;
  _Associations?: TEDInputLRAttestrattAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av attesträtt
 */
export interface TEDInputLRAttestrattDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid tillägg av attesträttens kodbegränsning
 */
export interface TEDInputLRAttestrattKontobegrAddAssociationValues {
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalAddValues | null;
  Attestratt_Ref?: string | null;
  Attestratt_Values?: TEDInputLRAttestrattAddValues | null;
}

/**
 * Värden vid tillägg av attesträttens kodbegränsning
 */
export interface TEDInputLRAttestrattKontobegrAddValues {
  KPLAN_ID?: number | null;
  KONV_TO_VIEW_ID?: number | null;
  _Associations?: TEDInputLRAttestrattKontobegrAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av attesträttens kodbegränsning
 */
export interface TEDInputLRAttestrattKontobegrDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av attesträttens kodbegränsning
 */
export interface TEDInputLRAttestrattKontobegrUpdateAssociationValues {
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalUpdateValues | null;
  Attestratt_Ref?: string | null;
  Attestratt_Values?: TEDInputLRAttestrattUpdateValues | null;
}

/**
 * Nya värden vid ändring av attesträttens kodbegränsning
 */
export interface TEDInputLRAttestrattKontobegrUpdateValues {
  id: string;
  _version: number;
  KPLAN_ID?: number | null;
  KONV_TO_VIEW_ID?: number | null;
  _Associations?: TEDInputLRAttestrattKontobegrUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av attesträtt reserv
 */
export interface TEDInputLRAttestrattReservAddAssociationValues {
  Attestratt_Ref?: string | null;
  Attestratt_Values?: TEDInputLRAttestrattAddValues | null;
  Reserv_Ref?: string | null;
  Reserv_Values?: TEDInputLRAttestrattAddValues | null;
  AutoskapadFran_Ref?: string | null;
  AutoskapadFran_Values?: TEDInputLRAttestrattAddValues | null;
}

/**
 * Värden vid tillägg av attesträtt reserv
 */
export interface TEDInputLRAttestrattReservAddValues {
  DATUM_FROM?: any | null;
  DATUM_TOM?: any | null;
  NOTERING?: string | null;
  AUTOSKAPAD?: boolean | null;
  AUTOSKAPAD_ATTESTOMRADE_ID?: number | null;
  AUTOSKAPAD_ATTESTRATT_LOPNR?: number | null;
  AUTOSKAPAD_LEVEL?: number | null;
  DELEGERA_VIDARE?: boolean | null;
  _Associations: TEDInputLRAttestrattReservAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av attesträtt reserv
 */
export interface TEDInputLRAttestrattReservDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av attesträtt reserv
 */
export interface TEDInputLRAttestrattReservUpdateAssociationValues {
  Attestratt_Ref?: string | null;
  Attestratt_Values?: TEDInputLRAttestrattUpdateValues | null;
  Reserv_Ref?: string | null;
  Reserv_Values?: TEDInputLRAttestrattUpdateValues | null;
  AutoskapadFran_Ref?: string | null;
  AutoskapadFran_Values?: TEDInputLRAttestrattUpdateValues | null;
}

/**
 * Nya värden vid ändring av attesträtt reserv
 */
export interface TEDInputLRAttestrattReservUpdateValues {
  id: string;
  _version: number;
  DATUM_FROM?: any | null;
  DATUM_TOM?: any | null;
  NOTERING?: string | null;
  AUTOSKAPAD?: boolean | null;
  AUTOSKAPAD_ATTESTOMRADE_ID?: number | null;
  AUTOSKAPAD_ATTESTRATT_LOPNR?: number | null;
  AUTOSKAPAD_LEVEL?: number | null;
  DELEGERA_VIDARE?: boolean | null;
  _Associations?: TEDInputLRAttestrattReservUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av attesträtt
 */
export interface TEDInputLRAttestrattUpdateAssociationValues {
  Attestant_Ref?: string | null;
  Attestant_Values?: TEDInputLRAttestantUpdateValues | null;
  Attestomrade_Ref?: string | null;
  Attestomrade_Values?: TEDInputLRAttestOmradeUpdateValues | null;
  Kontrollattestratt_Ref?: string | null;
  Kontrollattestratt_Values?: TEDInputLRAttestrattUpdateValues | null;
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalUpdateValues | null;
  Reserver_Add_Values?: TEDInputLRAttestrattReservAddValues[] | null;
  Reserver_Update_Values?: TEDInputLRAttestrattReservUpdateValues[] | null;
  Reserver_Delete_Values?: TEDInputLRAttestrattReservDeleteValues[] | null;
  Kontobegransning_Add_Values?: TEDInputLRAttestrattKontobegrAddValues[] | null;
  Kontobegransning_Update_Values?: TEDInputLRAttestrattKontobegrUpdateValues[] | null;
  Kontobegransning_Delete_Values?: TEDInputLRAttestrattKontobegrDeleteValues[] | null;
  Attestbegransningar_Add_Refs?: string[] | null;
  Attestbegransningar_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av attesträtt
 */
export interface TEDInputLRAttestrattUpdateValues {
  id: string;
  _version: number;
  SORT_ORDNING?: number | null;
  TITEL?: string | null;
  AKTIV?: TEDLRAttestrattAKTIVEnum | null;
  ANSVARIG?: TEDLRAttestrattANSVARIGEnum | null;
  MOTTAGN_ATTEST?: TEDLRAttestrattMOTTAGN_ATTESTEnum | null;
  MOTTAGN_KONTERING?: TEDLRAttestrattMOTTAGN_KONTERINGEnum | null;
  BESLUT_ATTEST?: TEDLRAttestrattBESLUT_ATTESTEnum | null;
  KONTOINT_ENL_ATTESTANT?: TEDLRAttestrattKONTOINT_ENL_ATTESTANTEnum | null;
  BESLUT_MAXBELOPP?: any | null;
  KONTROLL_BELOPP?: any | null;
  MEDDELA_EPOST?: TEDLRAttestrattMEDDELA_EPOSTEnum | null;
  GRANSKNING_ATTEST?: TEDLRAttestrattGRANSKNING_ATTESTEnum | null;
  BORTTAGEN?: string | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  MOTTAGN_REFUSERA?: TEDLRAttestrattMOTTAGN_REFUSERAEnum | null;
  GRANSKA_FORANKLAD_DEFBOK?: boolean | null;
  _Associations?: TEDInputLRAttestrattUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av beloppsattest
 */
export interface TEDInputLRBeloppsattestAddAssociationValues {
  Fakturaattest_Ref?: string | null;
  Fakturaattest_Values?: TEDInputLRFakturaAttestAddValues | null;
}

/**
 * Värden vid tillägg av beloppsattest
 */
export interface TEDInputLRBeloppsattestAddValues {
  _Associations?: TEDInputLRBeloppsattestAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av beloppsattest
 */
export interface TEDInputLRBeloppsattestDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av beloppsattest
 */
export interface TEDInputLRBeloppsattestUpdateAssociationValues {
  Fakturaattest_Ref?: string | null;
  Fakturaattest_Values?: TEDInputLRFakturaAttestUpdateValues | null;
}

/**
 * Nya värden vid ändring av beloppsattest
 */
export interface TEDInputLRBeloppsattestUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputLRBeloppsattestUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av betalning
 */
export interface TEDInputLRBetalningAddAssociationValues {
  Betalningsuppdrag_Ref?: string | null;
  Betalningsuppdrag_Values?: TEDInputLRBetalningsuppdragAddValues | null;
  Faktura_Ref?: string | null;
  Faktura_Values?: TEDInputLRLeverantorfakturaAddValues | null;
  Utbetalningssatt_Ref?: string | null;
  Utbetalningssatt_Values?: TEDInputSYSUtbetalningssattAddValues | null;
  Bank_Ref?: string | null;
  Bank_Values?: TEDInputSYSBankAddValues | null;
}

/**
 * Värden vid tillägg av betalning
 */
export interface TEDInputLRBetalningAddValues {
  PLAN_UTBET_DATUM?: any | null;
  UTBET_DATUM?: any | null;
  BELOPP?: any | null;
  VALUTA_BELOPP: any;
  STATUS?: TEDLRBetalningSTATUSEnum | null;
  HANDELSE_BOKF_GRUPP_ID?: number | null;
  HANDELSE_ID?: number | null;
  OCR?: boolean | null;
  KONTO_NR?: string | null;
  UTB_EXPRESS?: TEDLRBetalningUTB_EXPRESSEnum | null;
  RIKSBANKSKOD?: string | null;
  VALUTA_FICKA?: string | null;
  MEDDELANDE_1?: string | null;
  MEDDELANDE_2?: string | null;
  MEDDELANDE_3?: string | null;
  MEDDELANDE_4?: string | null;
  MEDDELANDE_5?: string | null;
  MEDDELANDE_6?: string | null;
  MEDDELANDE_7?: string | null;
  MEDDELANDE_8?: string | null;
  MEDDELANDE_9?: string | null;
  BETALT_BELOPP?: any | null;
  BELASTNINGSKOD?: string | null;
  AVGIFTSKOD?: string | null;
  MATCHNINGS_KOD?: number | null;
  STATUS_ELEKTRONISK_BETALNING?: TEDLRBetalningSTATUS_ELEKTRONISK_BETALNINGEnum | null;
  FELTEXT?: string | null;
  UTBETBEKRAFTELSE_ID?: number | null;
  VARNING_IGNORERA?: boolean | null;
  VARNING_SIGNATUR?: string | null;
  VARNING_DATUM?: any | null;
  UTLAND_BETSATT_TYP?: TEDLRBetalningUTLAND_BETSATT_TYPEnum | null;
  AUTOGIRO?: boolean | null;
  _Associations?: TEDInputLRBetalningAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av betalning
 */
export interface TEDInputLRBetalningDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av betalning
 */
export interface TEDInputLRBetalningUpdateAssociationValues {
  Betalningsuppdrag_Ref?: string | null;
  Betalningsuppdrag_Values?: TEDInputLRBetalningsuppdragUpdateValues | null;
  Faktura_Ref?: string | null;
  Faktura_Values?: TEDInputLRLeverantorfakturaUpdateValues | null;
  Utbetalningssatt_Ref?: string | null;
  Utbetalningssatt_Values?: TEDInputSYSUtbetalningssattUpdateValues | null;
  Bank_Ref?: string | null;
  Bank_Values?: TEDInputSYSBankUpdateValues | null;
}

/**
 * Nya värden vid ändring av betalning
 */
export interface TEDInputLRBetalningUpdateValues {
  id: string;
  _version: number;
  PLAN_UTBET_DATUM?: any | null;
  UTBET_DATUM?: any | null;
  BELOPP?: any | null;
  VALUTA_BELOPP?: any | null;
  STATUS?: TEDLRBetalningSTATUSEnum | null;
  HANDELSE_BOKF_GRUPP_ID?: number | null;
  HANDELSE_ID?: number | null;
  OCR?: boolean | null;
  KONTO_NR?: string | null;
  UTB_EXPRESS?: TEDLRBetalningUTB_EXPRESSEnum | null;
  RIKSBANKSKOD?: string | null;
  VALUTA_FICKA?: string | null;
  MEDDELANDE_1?: string | null;
  MEDDELANDE_2?: string | null;
  MEDDELANDE_3?: string | null;
  MEDDELANDE_4?: string | null;
  MEDDELANDE_5?: string | null;
  MEDDELANDE_6?: string | null;
  MEDDELANDE_7?: string | null;
  MEDDELANDE_8?: string | null;
  MEDDELANDE_9?: string | null;
  BETALT_BELOPP?: any | null;
  BELASTNINGSKOD?: string | null;
  AVGIFTSKOD?: string | null;
  MATCHNINGS_KOD?: number | null;
  STATUS_ELEKTRONISK_BETALNING?: TEDLRBetalningSTATUS_ELEKTRONISK_BETALNINGEnum | null;
  FELTEXT?: string | null;
  UTBETBEKRAFTELSE_ID?: number | null;
  VARNING_IGNORERA?: boolean | null;
  VARNING_SIGNATUR?: string | null;
  VARNING_DATUM?: any | null;
  UTLAND_BETSATT_TYP?: TEDLRBetalningUTLAND_BETSATT_TYPEnum | null;
  AUTOGIRO?: boolean | null;
  _Associations?: TEDInputLRBetalningUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av utbetalningsorder
 */
export interface TEDInputLRBetalningsuppdragAddAssociationValues {
  Utbetalningsvag_Ref?: string | null;
  Utbetalningsvag_Values?: TEDInputSYSUtbetalningsvagAddValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
  Betalningar_Add_Refs?: string[] | null;
  Bokforder_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av utbetalningsorder
 */
export interface TEDInputLRBetalningsuppdragAddValues {
  REG_DATUM?: any | null;
  STATUS?: TEDLRBetalningsuppdragSTATUSEnum | null;
  FIL_LOPNUMMER?: number | null;
  FIL_PRODDATUM?: any | null;
  REDOVISA_PER_GRUPP: TEDLRBetalningsuppdragREDOVISA_PER_GRUPPEnum;
  ANGIVET_BETALNINGSDATUM?: any | null;
  VIEW_ID?: number | null;
  STATUS_ELEKTRONISK_BETALNING?: TEDLRBetalningsuppdragSTATUS_ELEKTRONISK_BETALNINGEnum | null;
  FELTEXT?: string | null;
  KVITTENSFIL?: string | null;
  _Associations: TEDInputLRBetalningsuppdragAddAssociationValues;
}

/**
 * Associerade värden vid ändring av utbetalningsorder
 */
export interface TEDInputLRBetalningsuppdragUpdateAssociationValues {
  Utbetalningsvag_Ref?: string | null;
  Utbetalningsvag_Values?: TEDInputSYSUtbetalningsvagUpdateValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
  Betalningar_Add_Refs?: string[] | null;
  Betalningar_Delete_Refs?: string[] | null;
  Bokforder_Add_Refs?: string[] | null;
  Bokforder_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av utbetalningsorder
 */
export interface TEDInputLRBetalningsuppdragUpdateValues {
  id: string;
  _version: number;
  REG_DATUM?: any | null;
  STATUS?: TEDLRBetalningsuppdragSTATUSEnum | null;
  FIL_LOPNUMMER?: number | null;
  FIL_PRODDATUM?: any | null;
  REDOVISA_PER_GRUPP?: TEDLRBetalningsuppdragREDOVISA_PER_GRUPPEnum | null;
  ANGIVET_BETALNINGSDATUM?: any | null;
  VIEW_ID?: number | null;
  STATUS_ELEKTRONISK_BETALNING?: TEDLRBetalningsuppdragSTATUS_ELEKTRONISK_BETALNINGEnum | null;
  FELTEXT?: string | null;
  KVITTENSFIL?: string | null;
  _Associations?: TEDInputLRBetalningsuppdragUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av faktura attest
 */
export interface TEDInputLRFakturaAttestAddAssociationValues {
  Reserv_Ref?: string | null;
  Reserv_Values?: TEDInputLRAttestrattAddValues | null;
  Fakturadel_Ref?: string | null;
  Fakturadel_Values?: TEDInputLRFakturaDelAddValues | null;
  Attestratt_Ref?: string | null;
  Attestratt_Values?: TEDInputLRAttestrattAddValues | null;
  Beloppsattest_Add_Values?: TEDInputLRBeloppsattestAddValues[] | null;
  Beloppsrader_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av faktura attest
 */
export interface TEDInputLRFakturaAttestAddValues {
  TYP: TEDLRFakturaAttestTYPEnum;
  ORDNINGS_NR?: number | null;
  RESERV_ID?: number | null;
  RESERV_LOPNR?: number | null;
  STATUS: TEDLRFakturaAttestSTATUSEnum;
  STATUS_DATUM?: any | null;
  PAMINNELSE_DATUM?: any | null;
  STATUS_TID?: any | null;
  KONTROLLATTEST?: boolean | null;
  _Associations?: TEDInputLRFakturaAttestAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av faktura attest
 */
export interface TEDInputLRFakturaAttestDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av faktura attest
 */
export interface TEDInputLRFakturaAttestUpdateAssociationValues {
  Reserv_Ref?: string | null;
  Reserv_Values?: TEDInputLRAttestrattUpdateValues | null;
  Fakturadel_Ref?: string | null;
  Fakturadel_Values?: TEDInputLRFakturaDelUpdateValues | null;
  Attestratt_Ref?: string | null;
  Attestratt_Values?: TEDInputLRAttestrattUpdateValues | null;
  Beloppsattest_Add_Values?: TEDInputLRBeloppsattestAddValues[] | null;
  Beloppsattest_Update_Values?: TEDInputLRBeloppsattestUpdateValues[] | null;
  Beloppsattest_Delete_Values?: TEDInputLRBeloppsattestDeleteValues[] | null;
  Beloppsrader_Add_Refs?: string[] | null;
  Beloppsrader_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av faktura attest
 */
export interface TEDInputLRFakturaAttestUpdateValues {
  id: string;
  _version: number;
  TYP?: TEDLRFakturaAttestTYPEnum | null;
  ORDNINGS_NR?: number | null;
  RESERV_ID?: number | null;
  RESERV_LOPNR?: number | null;
  STATUS?: TEDLRFakturaAttestSTATUSEnum | null;
  STATUS_DATUM?: any | null;
  PAMINNELSE_DATUM?: any | null;
  STATUS_TID?: any | null;
  KONTROLLATTEST?: boolean | null;
  _Associations?: TEDInputLRFakturaAttestUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av faktura
 */
export interface TEDInputLRFakturaDelAddAssociationValues {
  Faktura_Ref?: string | null;
  Faktura_Values?: TEDInputLRLeverantorfakturaAddValues | null;
  Attestgrupp_Ref?: string | null;
  Attestgrupp_Values?: TEDInputLRAttestGruppAddValues | null;
  UtredningAttest_Ref?: string | null;
  UtredningAttest_Values?: TEDInputLRFakturaAttestAddValues | null;
  Fakturaattest_Add_Values?: TEDInputLRFakturaAttestAddValues[] | null;
}

/**
 * Värden vid tillägg av faktura
 */
export interface TEDInputLRFakturaDelAddValues {
  ORDNINGS_NR?: number | null;
  ATTEST_STATUS: TEDLRFakturaDelATTEST_STATUSEnum;
  ATTEST_STATUS_SIGNATUR?: string | null;
  EXTRA_STATUS?: string | null;
  UTREDNING_ATTEST_LOPNR?: number | null;
  _Associations: TEDInputLRFakturaDelAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av faktura
 */
export interface TEDInputLRFakturaDelDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av faktura
 */
export interface TEDInputLRFakturaDelUpdateAssociationValues {
  Faktura_Ref?: string | null;
  Faktura_Values?: TEDInputLRLeverantorfakturaUpdateValues | null;
  Attestgrupp_Ref?: string | null;
  Attestgrupp_Values?: TEDInputLRAttestGruppUpdateValues | null;
  UtredningAttest_Ref?: string | null;
  UtredningAttest_Values?: TEDInputLRFakturaAttestUpdateValues | null;
  Fakturaattest_Add_Values?: TEDInputLRFakturaAttestAddValues[] | null;
  Fakturaattest_Update_Values?: TEDInputLRFakturaAttestUpdateValues[] | null;
  Fakturaattest_Delete_Values?: TEDInputLRFakturaAttestDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av faktura
 */
export interface TEDInputLRFakturaDelUpdateValues {
  id: string;
  _version: number;
  ORDNINGS_NR?: number | null;
  ATTEST_STATUS?: TEDLRFakturaDelATTEST_STATUSEnum | null;
  ATTEST_STATUS_SIGNATUR?: string | null;
  EXTRA_STATUS?: string | null;
  UTREDNING_ATTEST_LOPNR?: number | null;
  _Associations?: TEDInputLRFakturaDelUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av dokument
 */
export interface TEDInputLRFakturaDokAddAssociationValues {
  fakturabilagor_Ref?: string | null;
  fakturabilagor_Values?: TEDInputLRFakturabilagaAddValues | null;
}

/**
 * Värden vid tillägg av dokument
 */
export interface TEDInputLRFakturaDokAddValues {
  BESKRIVNING?: string | null;
  EXTENSION?: string | null;
  OLECLASSNAME?: string | null;
  BINARDATA?: string | null;
  BINARDATASIZE?: number | null;
  DATATYPE?: string | null;
  FILNAMN?: string | null;
  SENAST_ANDRAD?: any | null;
  SENAST_ANDRAD_SIGNATUR?: string | null;
  _Associations?: TEDInputLRFakturaDokAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av dokument
 */
export interface TEDInputLRFakturaDokDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av dokument
 */
export interface TEDInputLRFakturaDokUpdateAssociationValues {
  fakturabilagor_Ref?: string | null;
  fakturabilagor_Values?: TEDInputLRFakturabilagaUpdateValues | null;
}

/**
 * Nya värden vid ändring av dokument
 */
export interface TEDInputLRFakturaDokUpdateValues {
  id: string;
  _version: number;
  BESKRIVNING?: string | null;
  EXTENSION?: string | null;
  OLECLASSNAME?: string | null;
  BINARDATA?: string | null;
  BINARDATASIZE?: number | null;
  DATATYPE?: string | null;
  FILNAMN?: string | null;
  SENAST_ANDRAD?: any | null;
  SENAST_ANDRAD_SIGNATUR?: string | null;
  _Associations?: TEDInputLRFakturaDokUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av fakturarad
 */
export interface TEDInputLRFakturaRadAddAssociationValues {
  fakturabild_Ref?: string | null;
  fakturabild_Values?: TEDInputLRFakturabildAddValues | null;
  Kobartikel_Ref?: string | null;
  Kobartikel_Values?: TEDInputSYSKOBArtikelAddValues | null;
  Fakturaradskod_Ref?: string | null;
  Fakturaradskod_Values?: TEDInputSYSFakturaradskodAddValues | null;
}

/**
 * Värden vid tillägg av fakturarad
 */
export interface TEDInputLRFakturaRadAddValues {
  LOPNR?: number | null;
  ARTIKEL_NR?: string | null;
  KOB_ARTIKEL_NR?: string | null;
  BESKRIVNING?: string | null;
  BELOPP?: any | null;
  MOMS?: number | null;
  _Associations?: TEDInputLRFakturaRadAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av fakturarad
 */
export interface TEDInputLRFakturaRadDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av fakturarad
 */
export interface TEDInputLRFakturaRadUpdateAssociationValues {
  fakturabild_Ref?: string | null;
  fakturabild_Values?: TEDInputLRFakturabildUpdateValues | null;
  Kobartikel_Ref?: string | null;
  Kobartikel_Values?: TEDInputSYSKOBArtikelUpdateValues | null;
  Fakturaradskod_Ref?: string | null;
  Fakturaradskod_Values?: TEDInputSYSFakturaradskodUpdateValues | null;
}

/**
 * Nya värden vid ändring av fakturarad
 */
export interface TEDInputLRFakturaRadUpdateValues {
  id: string;
  _version: number;
  LOPNR?: number | null;
  ARTIKEL_NR?: string | null;
  KOB_ARTIKEL_NR?: string | null;
  BESKRIVNING?: string | null;
  BELOPP?: any | null;
  MOMS?: number | null;
  _Associations?: TEDInputLRFakturaRadUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av fakturabilaga
 */
export interface TEDInputLRFakturabilagaAddAssociationValues {
  Fakturabunt_Ref?: string | null;
  Fakturabunt_Values?: TEDInputLRFakturabuntAddValues | null;
}

/**
 * Värden vid tillägg av fakturabilaga
 */
export interface TEDInputLRFakturabilagaAddValues {
  BENAMNING?: string | null;
  URL?: string | null;
  _Associations?: TEDInputLRFakturabilagaAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av fakturabilaga
 */
export interface TEDInputLRFakturabilagaDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av fakturabilaga
 */
export interface TEDInputLRFakturabilagaUpdateAssociationValues {
  Fakturabunt_Ref?: string | null;
  Fakturabunt_Values?: TEDInputLRFakturabuntUpdateValues | null;
}

/**
 * Nya värden vid ändring av fakturabilaga
 */
export interface TEDInputLRFakturabilagaUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  URL?: string | null;
  _Associations?: TEDInputLRFakturabilagaUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av fakturabild
 */
export interface TEDInputLRFakturabildAddAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputLRFakturabildBlobAddValues | null;
  Faktura_Ref?: string | null;
  Faktura_Values?: TEDInputLRLeverantorfakturaAddValues | null;
  Fakturabunt_Ref?: string | null;
  Fakturabunt_Values?: TEDInputLRFakturabuntAddValues | null;
  Fakturakod_Ref?: string | null;
  Fakturakod_Values?: TEDInputSYSFakturakodAddValues | null;
  fakturarad_Add_Values?: TEDInputLRFakturaRadAddValues[] | null;
  Fakturabilaga_Add_Values?: TEDInputLRFakturabilagaAddValues[] | null;
}

/**
 * Värden vid tillägg av fakturabild
 */
export interface TEDInputLRFakturabildAddValues {
  LOPNR?: number | null;
  FIL_NAMN?: string | null;
  FIL_DATUM?: any | null;
  FIL_KLOCKSLAG?: any | null;
  SIDNR?: number | null;
  INVOICE_ID?: string | null;
  INVOICE_DATESTR?: string | null;
  INVOICE_TIMESTR?: string | null;
  INVOICE_DEBKRED: TEDLRFakturabildINVOICE_DEBKREDEnum;
  INVOICE_FAKTURADATUM?: any | null;
  INVOICE_FORFALLODATUM?: any | null;
  INVOICE_MOMSSATS?: string | null;
  INVOICE_MOMSBELOPP?: any | null;
  INVOICE_BRUTTOBELOPP?: any | null;
  INVOICE_VALUTA?: string | null;
  INVOICE_BANKGIRONR?: string | null;
  INVOICE_FAKTURANR?: string | null;
  INVOICE_PLUSGIRONR?: string | null;
  INVOICE_ER_REF?: string | null;
  INVOICE_KUNDNR?: string | null;
  LAGD_AT_SIDAN?: TEDLRFakturabildLAGD_AT_SIDANEnum | null;
  INVOICE_BUNTNR?: string | null;
  INVOICE_ANKOMSTDATUM?: any | null;
  FORMAT: TEDLRFakturabildFORMATEnum;
  ORG_NR?: string | null;
  INVOICE_MOTTAGANDE_ENHET?: string | null;
  ORGANISATIONSAR?: number | null;
  KOB_PERS_NR?: string | null;
  REFERENSER?: string | null;
  TILLGANGLIG_DATUM?: any | null;
  MAKULERAD_ELLER_BACKAD?: boolean | null;
  FA_FELMEDDELANDE?: string | null;
  INVOICE_BANKKONTONR?: string | null;
  _Associations?: TEDInputLRFakturabildAddAssociationValues | null;
}

/**
 * Värden vid tillägg av fakturabild, blob
 */
export interface TEDInputLRFakturabildBlobAddValues {
  BILD?: string | null;
  BILDSIZE?: number | null;
  BILDSTRETCH?: boolean | null;
  XML?: string | null;
}

/**
 * Nya värden vid ändring av fakturabild, blob
 */
export interface TEDInputLRFakturabildBlobUpdateValues {
  id: string;
  _version: number;
  BILD?: string | null;
  BILDSIZE?: number | null;
  BILDSTRETCH?: boolean | null;
  XML?: string | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av fakturabild
 */
export interface TEDInputLRFakturabildDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av fakturabild
 */
export interface TEDInputLRFakturabildUpdateAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputLRFakturabildBlobUpdateValues | null;
  Faktura_Ref?: string | null;
  Faktura_Values?: TEDInputLRLeverantorfakturaUpdateValues | null;
  Fakturabunt_Ref?: string | null;
  Fakturabunt_Values?: TEDInputLRFakturabuntUpdateValues | null;
  Fakturakod_Ref?: string | null;
  Fakturakod_Values?: TEDInputSYSFakturakodUpdateValues | null;
  fakturarad_Add_Values?: TEDInputLRFakturaRadAddValues[] | null;
  fakturarad_Update_Values?: TEDInputLRFakturaRadUpdateValues[] | null;
  fakturarad_Delete_Values?: TEDInputLRFakturaRadDeleteValues[] | null;
  Fakturabilaga_Add_Values?: TEDInputLRFakturabilagaAddValues[] | null;
  Fakturabilaga_Update_Values?: TEDInputLRFakturabilagaUpdateValues[] | null;
  Fakturabilaga_Delete_Values?: TEDInputLRFakturabilagaDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av fakturabild
 */
export interface TEDInputLRFakturabildUpdateValues {
  id: string;
  _version: number;
  LOPNR?: number | null;
  FIL_NAMN?: string | null;
  FIL_DATUM?: any | null;
  FIL_KLOCKSLAG?: any | null;
  SIDNR?: number | null;
  INVOICE_ID?: string | null;
  INVOICE_DATESTR?: string | null;
  INVOICE_TIMESTR?: string | null;
  INVOICE_DEBKRED?: TEDLRFakturabildINVOICE_DEBKREDEnum | null;
  INVOICE_FAKTURADATUM?: any | null;
  INVOICE_FORFALLODATUM?: any | null;
  INVOICE_MOMSSATS?: string | null;
  INVOICE_MOMSBELOPP?: any | null;
  INVOICE_BRUTTOBELOPP?: any | null;
  INVOICE_VALUTA?: string | null;
  INVOICE_BANKGIRONR?: string | null;
  INVOICE_FAKTURANR?: string | null;
  INVOICE_PLUSGIRONR?: string | null;
  INVOICE_ER_REF?: string | null;
  INVOICE_KUNDNR?: string | null;
  LAGD_AT_SIDAN?: TEDLRFakturabildLAGD_AT_SIDANEnum | null;
  INVOICE_BUNTNR?: string | null;
  INVOICE_ANKOMSTDATUM?: any | null;
  FORMAT?: TEDLRFakturabildFORMATEnum | null;
  ORG_NR?: string | null;
  INVOICE_MOTTAGANDE_ENHET?: string | null;
  ORGANISATIONSAR?: number | null;
  KOB_PERS_NR?: string | null;
  REFERENSER?: string | null;
  TILLGANGLIG_DATUM?: any | null;
  MAKULERAD_ELLER_BACKAD?: boolean | null;
  FA_FELMEDDELANDE?: string | null;
  INVOICE_BANKKONTONR?: string | null;
  _Associations?: TEDInputLRFakturabildUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av fakturabunt
 */
export interface TEDInputLRFakturabuntAddAssociationValues {
  BokfGrupp_Ref?: string | null;
  BokfGrupp_Values?: TEDInputSYSGruppAddValues | null;
  Fakturamottagningsvag_Ref?: string | null;
  Fakturamottagningsvag_Values?: TEDInputLRFakturamottagningsvagAddValues | null;
  Fakturabilder_Add_Values?: TEDInputLRFakturabildAddValues[] | null;
}

/**
 * Värden vid tillägg av fakturabunt
 */
export interface TEDInputLRFakturabuntAddValues {
  BUNTNR?: number | null;
  ANTAL_FAKTUROR?: number | null;
  BUNTSUMMA?: any | null;
  INLAST_DATUM?: any | null;
  INLAST_KLOCKSLAG?: any | null;
  INLAST_SIGNATUR?: string | null;
  IMPORTTYP: TEDLRFakturabuntIMPORTTYPEnum;
  XML?: string | null;
  _Associations: TEDInputLRFakturabuntAddAssociationValues;
}

/**
 * Associerade värden vid ändring av fakturabunt
 */
export interface TEDInputLRFakturabuntUpdateAssociationValues {
  BokfGrupp_Ref?: string | null;
  BokfGrupp_Values?: TEDInputSYSGruppUpdateValues | null;
  Fakturamottagningsvag_Ref?: string | null;
  Fakturamottagningsvag_Values?: TEDInputLRFakturamottagningsvagUpdateValues | null;
  Fakturabilder_Add_Values?: TEDInputLRFakturabildAddValues[] | null;
  Fakturabilder_Update_Values?: TEDInputLRFakturabildUpdateValues[] | null;
  Fakturabilder_Delete_Values?: TEDInputLRFakturabildDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av fakturabunt
 */
export interface TEDInputLRFakturabuntUpdateValues {
  id: string;
  _version: number;
  BUNTNR?: number | null;
  ANTAL_FAKTUROR?: number | null;
  BUNTSUMMA?: any | null;
  INLAST_DATUM?: any | null;
  INLAST_KLOCKSLAG?: any | null;
  INLAST_SIGNATUR?: string | null;
  IMPORTTYP?: TEDLRFakturabuntIMPORTTYPEnum | null;
  XML?: string | null;
  _Associations?: TEDInputLRFakturabuntUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av fakturamottagningsväg
 */
export interface TEDInputLRFakturamottagningsvagAddAssociationValues {
  utbetalningssatt_Ref?: string | null;
  utbetalningssatt_Values?: TEDInputSYSUtbetalningssattAddValues | null;
  bokforingsgrupp_Ref?: string | null;
  bokforingsgrupp_Values?: TEDInputSYSGruppAddValues | null;
}

/**
 * Värden vid tillägg av fakturamottagningsväg
 */
export interface TEDInputLRFakturamottagningsvagAddValues {
  BENAMNING: string;
  IMPORTTYP: TEDLRFakturamottagningsvagIMPORTTYPEnum;
  AKTIV?: TEDLRFakturamottagningsvagAKTIVEnum | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  IMPORTKATALOG?: string | null;
  XSL?: string | null;
  IDKOD?: string | null;
  _Associations?: TEDInputLRFakturamottagningsvagAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av fakturamottagningsväg
 */
export interface TEDInputLRFakturamottagningsvagUpdateAssociationValues {
  utbetalningssatt_Ref?: string | null;
  utbetalningssatt_Values?: TEDInputSYSUtbetalningssattUpdateValues | null;
  bokforingsgrupp_Ref?: string | null;
  bokforingsgrupp_Values?: TEDInputSYSGruppUpdateValues | null;
}

/**
 * Nya värden vid ändring av fakturamottagningsväg
 */
export interface TEDInputLRFakturamottagningsvagUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  IMPORTTYP?: TEDLRFakturamottagningsvagIMPORTTYPEnum | null;
  AKTIV?: TEDLRFakturamottagningsvagAKTIVEnum | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  IMPORTKATALOG?: string | null;
  XSL?: string | null;
  IDKOD?: string | null;
  _Associations?: TEDInputLRFakturamottagningsvagUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av konteringsförslag
 */
export interface TEDInputLRKonteringsForslagAddAssociationValues {
  Faktura_Ref?: string | null;
  Faktura_Values?: TEDInputLRLeverantorfakturaAddValues | null;
  Enhet_Ref?: string | null;
  Enhet_Values?: TEDInputLAEnhetAddValues | null;
  Tillgang_Ref?: string | null;
  Tillgang_Values?: TEDInputARTillgangAddValues | null;
  Kontodel1_Ref?: string | null;
  Kontodel1_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel2_Ref?: string | null;
  Kontodel2_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel3_Ref?: string | null;
  Kontodel3_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel4_Ref?: string | null;
  Kontodel4_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel5_Ref?: string | null;
  Kontodel5_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel6_Ref?: string | null;
  Kontodel6_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel7_Ref?: string | null;
  Kontodel7_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel8_Ref?: string | null;
  Kontodel8_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel9_Ref?: string | null;
  Kontodel9_Values?: TEDInputEKKontodelAddValues | null;
  Kontodel10_Ref?: string | null;
  Kontodel10_Values?: TEDInputEKKontodelAddValues | null;
  Fakturaattest_Ref?: string | null;
  Fakturaattest_Values?: TEDInputLRFakturaAttestAddValues | null;
  Komponenttyp_Ref?: string | null;
  Komponenttyp_Values?: TEDInputARKomponentAddValues | null;
  Omrade_Ref?: string | null;
  Omrade_Values?: TEDInputARPlatsAddValues | null;
  AvskrKontodel1_Ref?: string | null;
  AvskrKontodel1_Values?: TEDInputEKKontodelAddValues | null;
  AvskrKontodel2_Ref?: string | null;
  AvskrKontodel2_Values?: TEDInputEKKontodelAddValues | null;
  AvskrKontodel3_Ref?: string | null;
  AvskrKontodel3_Values?: TEDInputEKKontodelAddValues | null;
  AvskrKontodel4_Ref?: string | null;
  AvskrKontodel4_Values?: TEDInputEKKontodelAddValues | null;
  AvskrKontodel5_Ref?: string | null;
  AvskrKontodel5_Values?: TEDInputEKKontodelAddValues | null;
  AvskrKontodel6_Ref?: string | null;
  AvskrKontodel6_Values?: TEDInputEKKontodelAddValues | null;
  AvskrKontodel7_Ref?: string | null;
  AvskrKontodel7_Values?: TEDInputEKKontodelAddValues | null;
  AvskrKontodel8_Ref?: string | null;
  AvskrKontodel8_Values?: TEDInputEKKontodelAddValues | null;
  AvskrKontodel9_Ref?: string | null;
  AvskrKontodel9_Values?: TEDInputEKKontodelAddValues | null;
  AvskrKontodel10_Ref?: string | null;
  AvskrKontodel10_Values?: TEDInputEKKontodelAddValues | null;
  Bokfkontering_Ref?: string | null;
  Bokfkontering_Values?: TEDInputEKBokfkonteringAddValues | null;
  FITillgang_Ref?: string | null;
  FITillgang_Values?: TEDInputARTillgangAddValues | null;
  FIKategori_Ref?: string | null;
  FIKategori_Values?: TEDInputARAnlKatAddValues | null;
  FIOmrade_Ref?: string | null;
  FIOmrade_Values?: TEDInputARPlatsAddValues | null;
  FIByggnad_Ref?: string | null;
  FIByggnad_Values?: TEDInputARPlatsAddValues | null;
  FIInvrad_Ref?: string | null;
  FIInvrad_Values?: TEDInputARInvesteringsradAddValues | null;
  IngMoms_Ref?: string | null;
  IngMoms_Values?: TEDInputSYSMomsAddValues | null;
  UtlandsMomsMall_Ref?: string | null;
  UtlandsMomsMall_Values?: TEDInputEKAutomatkonteringarAddValues | null;
  Beloppsattest_Add_Values?: TEDInputLRBeloppsattestAddValues[] | null;
}

/**
 * Värden vid tillägg av konteringsförslag
 */
export interface TEDInputLRKonteringsForslagAddValues {
  KONTODEL_1?: string | null;
  KONTODEL_2?: string | null;
  KONTODEL_3?: string | null;
  KONTODEL_4?: string | null;
  KONTODEL_5?: string | null;
  KONTODEL_6?: string | null;
  KONTODEL_7?: string | null;
  KONTODEL_8?: string | null;
  KONTODEL_9?: string | null;
  KONTODEL_10?: string | null;
  PERIODISERAD?: boolean | null;
  PER_FROM_DATUM?: any | null;
  PER_TOM_DATUM?: any | null;
  MOMS?: TEDLRKonteringsForslagMOMSEnum | null;
  DEBET?: any | null;
  KREDIT?: any | null;
  KONT_BOKF_AR?: any | null;
  KONT_VER_NR?: number | null;
  KONT_LOPNR?: number | null;
  ANTAL?: number | null;
  TILLAGGSINFO_KOD?: string | null;
  AR_BENAMNING?: string | null;
  AR_AVSKR_TID?: number | null;
  AR_INV_DATUM?: any | null;
  AR_NY?: boolean | null;
  AR_TILLGANG_BEN?: string | null;
  AR_AVSKR_KDEL_1?: string | null;
  AR_AVSKR_KDEL_2?: string | null;
  AR_AVSKR_KDEL_3?: string | null;
  AR_AVSKR_KDEL_4?: string | null;
  AR_AVSKR_KDEL_5?: string | null;
  AR_AVSKR_KDEL_6?: string | null;
  AR_AVSKR_KDEL_7?: string | null;
  AR_AVSKR_KDEL_8?: string | null;
  AR_AVSKR_KDEL_9?: string | null;
  AR_AVSKR_KDEL_10?: string | null;
  AR_KOMMENTAR?: string | null;
  ORDNINGS_NR_1?: number | null;
  KONTOID_1?: number | null;
  ORDNINGS_NR_2?: number | null;
  KONTOID_2?: number | null;
  ORDNINGS_NR_3?: number | null;
  KONTOID_3?: number | null;
  ORDNINGS_NR_4?: number | null;
  KONTOID_4?: number | null;
  ORDNINGS_NR_5?: number | null;
  KONTOID_5?: number | null;
  ORDNINGS_NR_6?: number | null;
  KONTOID_6?: number | null;
  ORDNINGS_NR_7?: number | null;
  KONTOID_7?: number | null;
  ORDNINGS_NR_8?: number | null;
  KONTOID_8?: number | null;
  ORDNINGS_NR_9?: number | null;
  KONTOID_9?: number | null;
  ORDNINGS_NR_10?: number | null;
  KONTOID_10?: number | null;
  AR_FI_BENAMNING?: string | null;
  AR_FI_DATUM?: any | null;
  AR_FI_ANLKAT_ID?: number | null;
  AR_FI_OMRADE_ID?: number | null;
  AR_FI_BYGGNAD_ID?: number | null;
  AR_FI_KOMMENTAR?: string | null;
  FI_BORTTAGEN?: boolean | null;
  FI_BORTTAGEN_DATUM?: any | null;
  FI_BORTTAGEN_SIGNATUR?: string | null;
  FI_REGISTRERAS?: TEDLRKonteringsForslagFI_REGISTRERASEnum | null;
  SORTERINGS_NR?: number | null;
  RADTYP?: number | null;
  BELOPP_EXKL_MOMS?: any | null;
  BELOPP_INKL_MOMS?: any | null;
  ING_MOMS_MALL?: number | null;
  ING_MOMS_SATS?: number | null;
  VIKT?: number | null;
  UTL_MOMS_MALL?: number | null;
  UTL_MOMS_SATS?: number | null;
  UTL_MOMS?: any | null;
  UTL_MOMS_AVDRAG?: any | null;
  MOMSPLIKTIG?: boolean | null;
  ING_MOMS_BELOPP?: any | null;
  INGEN_MOMS?: boolean | null;
  _Associations: TEDInputLRKonteringsForslagAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av konteringsförslag
 */
export interface TEDInputLRKonteringsForslagDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av konteringsförslag
 */
export interface TEDInputLRKonteringsForslagUpdateAssociationValues {
  Faktura_Ref?: string | null;
  Faktura_Values?: TEDInputLRLeverantorfakturaUpdateValues | null;
  Enhet_Ref?: string | null;
  Enhet_Values?: TEDInputLAEnhetUpdateValues | null;
  Tillgang_Ref?: string | null;
  Tillgang_Values?: TEDInputARTillgangUpdateValues | null;
  Kontodel1_Ref?: string | null;
  Kontodel1_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel2_Ref?: string | null;
  Kontodel2_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel3_Ref?: string | null;
  Kontodel3_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel4_Ref?: string | null;
  Kontodel4_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel5_Ref?: string | null;
  Kontodel5_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel6_Ref?: string | null;
  Kontodel6_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel7_Ref?: string | null;
  Kontodel7_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel8_Ref?: string | null;
  Kontodel8_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel9_Ref?: string | null;
  Kontodel9_Values?: TEDInputEKKontodelUpdateValues | null;
  Kontodel10_Ref?: string | null;
  Kontodel10_Values?: TEDInputEKKontodelUpdateValues | null;
  Fakturaattest_Ref?: string | null;
  Fakturaattest_Values?: TEDInputLRFakturaAttestUpdateValues | null;
  Komponenttyp_Ref?: string | null;
  Komponenttyp_Values?: TEDInputARKomponentUpdateValues | null;
  Omrade_Ref?: string | null;
  Omrade_Values?: TEDInputARPlatsUpdateValues | null;
  AvskrKontodel1_Ref?: string | null;
  AvskrKontodel1_Values?: TEDInputEKKontodelUpdateValues | null;
  AvskrKontodel2_Ref?: string | null;
  AvskrKontodel2_Values?: TEDInputEKKontodelUpdateValues | null;
  AvskrKontodel3_Ref?: string | null;
  AvskrKontodel3_Values?: TEDInputEKKontodelUpdateValues | null;
  AvskrKontodel4_Ref?: string | null;
  AvskrKontodel4_Values?: TEDInputEKKontodelUpdateValues | null;
  AvskrKontodel5_Ref?: string | null;
  AvskrKontodel5_Values?: TEDInputEKKontodelUpdateValues | null;
  AvskrKontodel6_Ref?: string | null;
  AvskrKontodel6_Values?: TEDInputEKKontodelUpdateValues | null;
  AvskrKontodel7_Ref?: string | null;
  AvskrKontodel7_Values?: TEDInputEKKontodelUpdateValues | null;
  AvskrKontodel8_Ref?: string | null;
  AvskrKontodel8_Values?: TEDInputEKKontodelUpdateValues | null;
  AvskrKontodel9_Ref?: string | null;
  AvskrKontodel9_Values?: TEDInputEKKontodelUpdateValues | null;
  AvskrKontodel10_Ref?: string | null;
  AvskrKontodel10_Values?: TEDInputEKKontodelUpdateValues | null;
  Bokfkontering_Ref?: string | null;
  Bokfkontering_Values?: TEDInputEKBokfkonteringUpdateValues | null;
  FITillgang_Ref?: string | null;
  FITillgang_Values?: TEDInputARTillgangUpdateValues | null;
  FIKategori_Ref?: string | null;
  FIKategori_Values?: TEDInputARAnlKatUpdateValues | null;
  FIOmrade_Ref?: string | null;
  FIOmrade_Values?: TEDInputARPlatsUpdateValues | null;
  FIByggnad_Ref?: string | null;
  FIByggnad_Values?: TEDInputARPlatsUpdateValues | null;
  FIInvrad_Ref?: string | null;
  FIInvrad_Values?: TEDInputARInvesteringsradUpdateValues | null;
  IngMoms_Ref?: string | null;
  IngMoms_Values?: TEDInputSYSMomsUpdateValues | null;
  UtlandsMomsMall_Ref?: string | null;
  UtlandsMomsMall_Values?: TEDInputEKAutomatkonteringarUpdateValues | null;
  Beloppsattest_Add_Values?: TEDInputLRBeloppsattestAddValues[] | null;
  Beloppsattest_Update_Values?: TEDInputLRBeloppsattestUpdateValues[] | null;
  Beloppsattest_Delete_Values?: TEDInputLRBeloppsattestDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av konteringsförslag
 */
export interface TEDInputLRKonteringsForslagUpdateValues {
  id: string;
  _version: number;
  KONTODEL_1?: string | null;
  KONTODEL_2?: string | null;
  KONTODEL_3?: string | null;
  KONTODEL_4?: string | null;
  KONTODEL_5?: string | null;
  KONTODEL_6?: string | null;
  KONTODEL_7?: string | null;
  KONTODEL_8?: string | null;
  KONTODEL_9?: string | null;
  KONTODEL_10?: string | null;
  PERIODISERAD?: boolean | null;
  PER_FROM_DATUM?: any | null;
  PER_TOM_DATUM?: any | null;
  MOMS?: TEDLRKonteringsForslagMOMSEnum | null;
  DEBET?: any | null;
  KREDIT?: any | null;
  KONT_BOKF_AR?: any | null;
  KONT_VER_NR?: number | null;
  KONT_LOPNR?: number | null;
  ANTAL?: number | null;
  TILLAGGSINFO_KOD?: string | null;
  AR_BENAMNING?: string | null;
  AR_AVSKR_TID?: number | null;
  AR_INV_DATUM?: any | null;
  AR_NY?: boolean | null;
  AR_TILLGANG_BEN?: string | null;
  AR_AVSKR_KDEL_1?: string | null;
  AR_AVSKR_KDEL_2?: string | null;
  AR_AVSKR_KDEL_3?: string | null;
  AR_AVSKR_KDEL_4?: string | null;
  AR_AVSKR_KDEL_5?: string | null;
  AR_AVSKR_KDEL_6?: string | null;
  AR_AVSKR_KDEL_7?: string | null;
  AR_AVSKR_KDEL_8?: string | null;
  AR_AVSKR_KDEL_9?: string | null;
  AR_AVSKR_KDEL_10?: string | null;
  AR_KOMMENTAR?: string | null;
  ORDNINGS_NR_1?: number | null;
  KONTOID_1?: number | null;
  ORDNINGS_NR_2?: number | null;
  KONTOID_2?: number | null;
  ORDNINGS_NR_3?: number | null;
  KONTOID_3?: number | null;
  ORDNINGS_NR_4?: number | null;
  KONTOID_4?: number | null;
  ORDNINGS_NR_5?: number | null;
  KONTOID_5?: number | null;
  ORDNINGS_NR_6?: number | null;
  KONTOID_6?: number | null;
  ORDNINGS_NR_7?: number | null;
  KONTOID_7?: number | null;
  ORDNINGS_NR_8?: number | null;
  KONTOID_8?: number | null;
  ORDNINGS_NR_9?: number | null;
  KONTOID_9?: number | null;
  ORDNINGS_NR_10?: number | null;
  KONTOID_10?: number | null;
  AR_FI_BENAMNING?: string | null;
  AR_FI_DATUM?: any | null;
  AR_FI_ANLKAT_ID?: number | null;
  AR_FI_OMRADE_ID?: number | null;
  AR_FI_BYGGNAD_ID?: number | null;
  AR_FI_KOMMENTAR?: string | null;
  FI_BORTTAGEN?: boolean | null;
  FI_BORTTAGEN_DATUM?: any | null;
  FI_BORTTAGEN_SIGNATUR?: string | null;
  FI_REGISTRERAS?: TEDLRKonteringsForslagFI_REGISTRERASEnum | null;
  SORTERINGS_NR?: number | null;
  RADTYP?: number | null;
  BELOPP_EXKL_MOMS?: any | null;
  BELOPP_INKL_MOMS?: any | null;
  ING_MOMS_MALL?: number | null;
  ING_MOMS_SATS?: number | null;
  VIKT?: number | null;
  UTL_MOMS_MALL?: number | null;
  UTL_MOMS_SATS?: number | null;
  UTL_MOMS?: any | null;
  UTL_MOMS_AVDRAG?: any | null;
  MOMSPLIKTIG?: boolean | null;
  ING_MOMS_BELOPP?: any | null;
  INGEN_MOMS?: boolean | null;
  _Associations?: TEDInputLRKonteringsForslagUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av konteringsrecept
 */
export interface TEDInputLRKonteringsreceptAddAssociationValues {
  Attestant_Ref?: string | null;
  Attestant_Values?: TEDInputLRAttestantAddValues | null;
  Attestomrade_Ref?: string | null;
  Attestomrade_Values?: TEDInputLRAttestOmradeAddValues | null;
  Leverantor_Ref?: string | null;
  Leverantor_Values?: TEDInputLRLeverantorAddValues | null;
}

/**
 * Värden vid tillägg av konteringsrecept
 */
export interface TEDInputLRKonteringsreceptAddValues {
  BENAMNING?: string | null;
  KONTODEL_1?: string | null;
  KONTODEL_2?: string | null;
  KONTODEL_3?: string | null;
  KONTODEL_4?: string | null;
  KONTODEL_5?: string | null;
  KONTODEL_6?: string | null;
  KONTODEL_7?: string | null;
  KONTODEL_8?: string | null;
  KONTODEL_9?: string | null;
  KONTODEL_10?: string | null;
  _Associations?: TEDInputLRKonteringsreceptAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av konteringsrecept
 */
export interface TEDInputLRKonteringsreceptDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av konteringsrecept
 */
export interface TEDInputLRKonteringsreceptUpdateAssociationValues {
  Attestant_Ref?: string | null;
  Attestant_Values?: TEDInputLRAttestantUpdateValues | null;
  Attestomrade_Ref?: string | null;
  Attestomrade_Values?: TEDInputLRAttestOmradeUpdateValues | null;
  Leverantor_Ref?: string | null;
  Leverantor_Values?: TEDInputLRLeverantorUpdateValues | null;
}

/**
 * Nya värden vid ändring av konteringsrecept
 */
export interface TEDInputLRKonteringsreceptUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  KONTODEL_1?: string | null;
  KONTODEL_2?: string | null;
  KONTODEL_3?: string | null;
  KONTODEL_4?: string | null;
  KONTODEL_5?: string | null;
  KONTODEL_6?: string | null;
  KONTODEL_7?: string | null;
  KONTODEL_8?: string | null;
  KONTODEL_9?: string | null;
  KONTODEL_10?: string | null;
  _Associations?: TEDInputLRKonteringsreceptUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av leverantörens betalningssätt
 */
export interface TEDInputLRLevBetsattAddAssociationValues {
  Leverantor_Ref?: string | null;
  Leverantor_Values?: TEDInputLRLeverantorAddValues | null;
  Utbetalningssatt_Ref?: string | null;
  Utbetalningssatt_Values?: TEDInputSYSUtbetalningssattAddValues | null;
  Bank_Ref?: string | null;
  Bank_Values?: TEDInputSYSBankAddValues | null;
}

/**
 * Värden vid tillägg av leverantörens betalningssätt
 */
export interface TEDInputLRLevBetsattAddValues {
  PRIORITET?: number | null;
  KONTO_NR?: string | null;
  OCR?: TEDLRLevBetsattOCREnum | null;
  NUMERISKA_FAKTURANR: TEDLRLevBetsattNUMERISKA_FAKTURANREnum;
  UTLAND_BETSATT_TYP?: TEDLRLevBetsattUTLAND_BETSATT_TYPEnum | null;
  AUTOGIRO?: boolean | null;
  FACT_ORG_NR?: string | null;
  _Associations: TEDInputLRLevBetsattAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av leverantörens betalningssätt
 */
export interface TEDInputLRLevBetsattDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av leverantörens betalningssätt
 */
export interface TEDInputLRLevBetsattUpdateAssociationValues {
  Leverantor_Ref?: string | null;
  Leverantor_Values?: TEDInputLRLeverantorUpdateValues | null;
  Utbetalningssatt_Ref?: string | null;
  Utbetalningssatt_Values?: TEDInputSYSUtbetalningssattUpdateValues | null;
  Bank_Ref?: string | null;
  Bank_Values?: TEDInputSYSBankUpdateValues | null;
}

/**
 * Nya värden vid ändring av leverantörens betalningssätt
 */
export interface TEDInputLRLevBetsattUpdateValues {
  id: string;
  _version: number;
  PRIORITET?: number | null;
  KONTO_NR?: string | null;
  OCR?: TEDLRLevBetsattOCREnum | null;
  NUMERISKA_FAKTURANR?: TEDLRLevBetsattNUMERISKA_FAKTURANREnum | null;
  UTLAND_BETSATT_TYP?: TEDLRLevBetsattUTLAND_BETSATT_TYPEnum | null;
  AUTOGIRO?: boolean | null;
  FACT_ORG_NR?: string | null;
  _Associations?: TEDInputLRLevBetsattUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av leverantör
 */
export interface TEDInputLRLeverantorAddAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputLRLeverantorBlobAddValues | null;
  Leverantorskategori_Ref?: string | null;
  Leverantorskategori_Values?: TEDInputLRLeverantorkatAddValues | null;
  OrgPers_Ref?: string | null;
  OrgPers_Values?: TEDInputOPOrgPersLokAddValues | null;
  Valuta_Ref?: string | null;
  Valuta_Values?: TEDInputSYSValutaAddValues | null;
  Leveransvillkor_Ref?: string | null;
  Leveransvillkor_Values?: TEDInputSYSLeveransvillkorAddValues | null;
  Prislista_Ref?: string | null;
  Prislista_Values?: TEDInputLAPrislistaAddValues | null;
  Sprak_Ref?: string | null;
  Sprak_Values?: TEDInputSYSSprakAddValues | null;
  Betalningsvillkor_Ref?: string | null;
  Betalningsvillkor_Values?: TEDInputSYSBetalningsvillkorAddValues | null;
  Moms_Ref?: string | null;
  Moms_Values?: TEDInputSYSMomsAddValues | null;
  UtlandskMoms_Ref?: string | null;
  UtlandskMoms_Values?: TEDInputEKAutomatkonteringarAddValues | null;
  Fakturor_Add_Values?: TEDInputLRLeverantorfakturaAddValues[] | null;
  LevBetalningssatt_Add_Values?: TEDInputLRLevBetsattAddValues[] | null;
  Attestforslag_Add_Values?: TEDInputLRAttestforslagAddValues[] | null;
}

/**
 * Värden vid tillägg av leverantör
 */
export interface TEDInputLRLeverantorAddValues {
  LEVERANTORSNR?: string | null;
  STATUS?: TEDLRLeverantorSTATUSEnum | null;
  RABATT?: number | null;
  SPARRAD_FROM_DATUM?: any | null;
  RIKSBANKSKOD?: string | null;
  KUNDNR?: string | null;
  ANGE_KUNDNR_SOM_FAKTREF?: boolean | null;
  TILLGODOH_HOS_BG_PG?: TEDLRLeverantorTILLGODOH_HOS_BG_PGEnum | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  FSKATT_KONTROLLERAD_DATUM?: any | null;
  ORDINARIE_REFERENS_TYP?: TEDLRLeverantorORDINARIE_REFERENS_TYPEnum | null;
  KONTROLLERA_EJ_MOMS?: boolean | null;
  BERAKNA_EJ_MOMS?: boolean | null;
  GRANSKA_FORANKLAD_DEFBOK?: boolean | null;
  _Associations: TEDInputLRLeverantorAddAssociationValues;
}

/**
 * Associerade värden vid tillägg av leverantörsattest
 */
export interface TEDInputLRLeverantorAttestAddAssociationValues {
  Leverantor_Ref?: string | null;
  Leverantor_Values?: TEDInputLRLeverantorAddValues | null;
  AttestUser_Ref?: string | null;
  AttestUser_Values?: TEDInputSYSUserAddValues | null;
  AndraAttestUser_Ref?: string | null;
  AndraAttestUser_Values?: TEDInputSYSUserAddValues | null;
  Logg_Add_Values?: TEDInputLRLeverantorAttestLoggAddValues[] | null;
}

/**
 * Värden vid tillägg av leverantörsattest
 */
export interface TEDInputLRLeverantorAttestAddValues {
  ATTEST_TIMESTAMP?: any | null;
  ATTEST_USER_ID?: number | null;
  STATUS?: TEDLRLeverantorAttestSTATUSEnum | null;
  NOTERING?: string | null;
  ANDRA_ATTEST_USER_ID?: number | null;
  ANDRA_ATTEST_TIMESTAMP?: any | null;
  PAMINNELSE_DATUM?: any | null;
  PAMINNELSE_SKICKAT_TILL?: string | null;
  _Associations?: TEDInputLRLeverantorAttestAddAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av leverantörsattest, logg
 */
export interface TEDInputLRLeverantorAttestLoggAddAssociationValues {
  Utbetalningssatt_Ref?: string | null;
  Utbetalningssatt_Values?: TEDInputSYSUtbetalningssattAddValues | null;
  Leverantorsattest_Ref?: string | null;
  Leverantorsattest_Values?: TEDInputLRLeverantorAttestAddValues | null;
  Bank_Ref?: string | null;
  Bank_Values?: TEDInputSYSBankAddValues | null;
}

/**
 * Värden vid tillägg av leverantörsattest, logg
 */
export interface TEDInputLRLeverantorAttestLoggAddValues {
  UTBETSATT_LOPNR?: number | null;
  LOGGTYPE: TEDLRLeverantorAttestLoggLOGGTYPEEnum;
  LOGG_TEXT?: string | null;
  LOGG_TIMESTAMP?: any | null;
  LOGG_USER_SIGN?: string | null;
  LOGG_KONTO_NR?: string | null;
  LOGG_BETSATT_ID?: number | null;
  LOGG_AUTOGIRO?: string | null;
  LOGG_UTLAND_BETSATT_TYP?: string | null;
  LOGG_BANK_ID?: string | null;
  LOGG_FACT_ORG_NR?: string | null;
  _Associations?: TEDInputLRLeverantorAttestLoggAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av leverantörsattest, logg
 */
export interface TEDInputLRLeverantorAttestLoggDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av leverantörsattest, logg
 */
export interface TEDInputLRLeverantorAttestLoggUpdateAssociationValues {
  Utbetalningssatt_Ref?: string | null;
  Utbetalningssatt_Values?: TEDInputSYSUtbetalningssattUpdateValues | null;
  Leverantorsattest_Ref?: string | null;
  Leverantorsattest_Values?: TEDInputLRLeverantorAttestUpdateValues | null;
  Bank_Ref?: string | null;
  Bank_Values?: TEDInputSYSBankUpdateValues | null;
}

/**
 * Nya värden vid ändring av leverantörsattest, logg
 */
export interface TEDInputLRLeverantorAttestLoggUpdateValues {
  id: string;
  _version: number;
  UTBETSATT_LOPNR?: number | null;
  LOGGTYPE?: TEDLRLeverantorAttestLoggLOGGTYPEEnum | null;
  LOGG_TEXT?: string | null;
  LOGG_TIMESTAMP?: any | null;
  LOGG_USER_SIGN?: string | null;
  LOGG_KONTO_NR?: string | null;
  LOGG_BETSATT_ID?: number | null;
  LOGG_AUTOGIRO?: string | null;
  LOGG_UTLAND_BETSATT_TYP?: string | null;
  LOGG_BANK_ID?: string | null;
  LOGG_FACT_ORG_NR?: string | null;
  _Associations?: TEDInputLRLeverantorAttestLoggUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av leverantörsattest
 */
export interface TEDInputLRLeverantorAttestUpdateAssociationValues {
  Leverantor_Ref?: string | null;
  Leverantor_Values?: TEDInputLRLeverantorUpdateValues | null;
  AttestUser_Ref?: string | null;
  AttestUser_Values?: TEDInputSYSUserUpdateValues | null;
  AndraAttestUser_Ref?: string | null;
  AndraAttestUser_Values?: TEDInputSYSUserUpdateValues | null;
  Logg_Add_Values?: TEDInputLRLeverantorAttestLoggAddValues[] | null;
  Logg_Update_Values?: TEDInputLRLeverantorAttestLoggUpdateValues[] | null;
  Logg_Delete_Values?: TEDInputLRLeverantorAttestLoggDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av leverantörsattest
 */
export interface TEDInputLRLeverantorAttestUpdateValues {
  id: string;
  _version: number;
  ATTEST_TIMESTAMP?: any | null;
  ATTEST_USER_ID?: number | null;
  STATUS?: TEDLRLeverantorAttestSTATUSEnum | null;
  NOTERING?: string | null;
  ANDRA_ATTEST_USER_ID?: number | null;
  ANDRA_ATTEST_TIMESTAMP?: any | null;
  PAMINNELSE_DATUM?: any | null;
  PAMINNELSE_SKICKAT_TILL?: string | null;
  _Associations?: TEDInputLRLeverantorAttestUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av lRLeverantorBlob
 */
export interface TEDInputLRLeverantorBlobAddValues {
  BILD?: string | null;
  BILDSIZE?: number | null;
  BILDSTRETCH?: string | null;
}

/**
 * Nya värden vid ändring av lRLeverantorBlob
 */
export interface TEDInputLRLeverantorBlobUpdateValues {
  id: string;
  _version: number;
  BILD?: string | null;
  BILDSIZE?: number | null;
  BILDSTRETCH?: string | null;
}

/**
 * Associerade värden vid ändring av leverantör
 */
export interface TEDInputLRLeverantorUpdateAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputLRLeverantorBlobUpdateValues | null;
  Leverantorskategori_Ref?: string | null;
  Leverantorskategori_Values?: TEDInputLRLeverantorkatUpdateValues | null;
  OrgPers_Ref?: string | null;
  OrgPers_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Valuta_Ref?: string | null;
  Valuta_Values?: TEDInputSYSValutaUpdateValues | null;
  Leveransvillkor_Ref?: string | null;
  Leveransvillkor_Values?: TEDInputSYSLeveransvillkorUpdateValues | null;
  Prislista_Ref?: string | null;
  Prislista_Values?: TEDInputLAPrislistaUpdateValues | null;
  Sprak_Ref?: string | null;
  Sprak_Values?: TEDInputSYSSprakUpdateValues | null;
  Betalningsvillkor_Ref?: string | null;
  Betalningsvillkor_Values?: TEDInputSYSBetalningsvillkorUpdateValues | null;
  Moms_Ref?: string | null;
  Moms_Values?: TEDInputSYSMomsUpdateValues | null;
  UtlandskMoms_Ref?: string | null;
  UtlandskMoms_Values?: TEDInputEKAutomatkonteringarUpdateValues | null;
  Fakturor_Add_Values?: TEDInputLRLeverantorfakturaAddValues[] | null;
  Fakturor_Update_Values?: TEDInputLRLeverantorfakturaUpdateValues[] | null;
  Fakturor_Delete_Values?: TEDInputLRLeverantorfakturaDeleteValues[] | null;
  LevBetalningssatt_Add_Values?: TEDInputLRLevBetsattAddValues[] | null;
  LevBetalningssatt_Update_Values?: TEDInputLRLevBetsattUpdateValues[] | null;
  LevBetalningssatt_Delete_Values?: TEDInputLRLevBetsattDeleteValues[] | null;
  Attestforslag_Add_Values?: TEDInputLRAttestforslagAddValues[] | null;
  Attestforslag_Update_Values?: TEDInputLRAttestforslagUpdateValues[] | null;
  Attestforslag_Delete_Values?: TEDInputLRAttestforslagDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av leverantör
 */
export interface TEDInputLRLeverantorUpdateValues {
  id: string;
  _version: number;
  LEVERANTORSNR?: string | null;
  STATUS?: TEDLRLeverantorSTATUSEnum | null;
  RABATT?: number | null;
  SPARRAD_FROM_DATUM?: any | null;
  RIKSBANKSKOD?: string | null;
  KUNDNR?: string | null;
  ANGE_KUNDNR_SOM_FAKTREF?: boolean | null;
  TILLGODOH_HOS_BG_PG?: TEDLRLeverantorTILLGODOH_HOS_BG_PGEnum | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  FSKATT_KONTROLLERAD_DATUM?: any | null;
  ORDINARIE_REFERENS_TYP?: TEDLRLeverantorORDINARIE_REFERENS_TYPEnum | null;
  KONTROLLERA_EJ_MOMS?: boolean | null;
  BERAKNA_EJ_MOMS?: boolean | null;
  GRANSKA_FORANKLAD_DEFBOK?: boolean | null;
  _Associations?: TEDInputLRLeverantorUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av leverantörsfaktura
 */
export interface TEDInputLRLeverantorfakturaAddAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputLRLeverantorfakturaBlobAddValues | null;
  Leverantor_Ref?: string | null;
  Leverantor_Values?: TEDInputLRLeverantorAddValues | null;
  Bokfgrupp_Ref?: string | null;
  Bokfgrupp_Values?: TEDInputSYSGruppAddValues | null;
  Registrering_Ref?: string | null;
  Registrering_Values?: TEDInputEKFakturahandelseAddValues | null;
  HandelseBokfgrupp_Ref?: string | null;
  HandelseBokfgrupp_Values?: TEDInputSYSGruppAddValues | null;
  Ankomstregistrering_Ref?: string | null;
  Ankomstregistrering_Values?: TEDInputEKFakturahandelseAddValues | null;
  Moms_Ref?: string | null;
  Moms_Values?: TEDInputSYSMomsAddValues | null;
  ElektroniskFaktura_Ref?: string | null;
  ElektroniskFaktura_Values?: TEDInputLRFakturabildAddValues | null;
  ForeslagenFakturakod_Ref?: string | null;
  ForeslagenFakturakod_Values?: TEDInputSYSFakturakodAddValues | null;
  Definitivbokning_Ref?: string | null;
  Definitivbokning_Values?: TEDInputEKFakturahandelseAddValues | null;
  Attestanter_Add_Values?: TEDInputLRLevfaktAttestantAddValues[] | null;
  Fakturahandelser_Add_Values?: TEDInputEKFakturahandelseAddValues[] | null;
  Betalningar_Add_Values?: TEDInputLRBetalningAddValues[] | null;
  Fakturadel_Add_Values?: TEDInputLRFakturaDelAddValues[] | null;
  Konteringsforslag_Add_Values?: TEDInputLRKonteringsForslagAddValues[] | null;
  Fakturasidor_Add_Values?: TEDInputLRFakturabildAddValues[] | null;
  Dokument_Add_Values?: TEDInputLRFakturaDokAddValues[] | null;
  Attestmeddelande_Add_Values?: TEDInputLRAttestmeddelandeAddValues[] | null;
}

/**
 * Värden vid tillägg av leverantörsfaktura
 */
export interface TEDInputLRLeverantorfakturaAddValues {
  _typ?: TEDLRLeverantorfakturaTypEnum | null;
  FAKTURA_NR?: string | null;
  SLUTBETALD?: TEDLRLeverantorfakturaSLUTBETALDEnum | null;
  STATUS: TEDLRLeverantorfakturaSTATUSEnum;
  ANKREG_DATUM?: any | null;
  ANKREG_ANV_ID?: number | null;
  SPARRAD?: TEDLRLeverantorfakturaSPARRADEnum | null;
  BETALNINGSUPPDRAG_ID?: number | null;
  FAKTURADATUM?: any | null;
  FORFALLO_DATUM?: any | null;
  DEFBOK_BOKF_GRUPP_ID?: number | null;
  DEFBOK_ID?: number | null;
  SLUTBETALD_DATUM?: any | null;
  BESTALLNINGS_NR?: string | null;
  ELEKTRONISK_ATTEST: TEDLRLeverantorfakturaELEKTRONISK_ATTESTEnum;
  INVOICE_BUNTNR?: string | null;
  INVOICE_ID?: string | null;
  INVOICE_ER_REF?: string | null;
  MOTTAGANDE_ENHET_ID?: number | null;
  ANVANT_LEVFAKTREF_NR?: number | null;
  AUTO_ANKREG?: boolean | null;
  MOMSHANTERING?: TEDLRLeverantorfakturaMOMSHANTERINGEnum | null;
  DUBLETT_IGNORERAD?: boolean | null;
  GRANSKAD_DEFBOK?: boolean | null;
  GRANSKAD_DEFBOK_SIGN?: string | null;
  GRANSKAD_DEFBOK_DATUM?: any | null;
  _Associations: TEDInputLRLeverantorfakturaAddAssociationValues;
}

/**
 * Värden vid tillägg av leverantörsfaktura, blob
 */
export interface TEDInputLRLeverantorfakturaBlobAddValues {
  ATTESTMEDDELANDE?: string | null;
  MEDDELANDE_ANDRAT?: boolean | null;
}

/**
 * Nya värden vid ändring av leverantörsfaktura, blob
 */
export interface TEDInputLRLeverantorfakturaBlobUpdateValues {
  id: string;
  _version: number;
  ATTESTMEDDELANDE?: string | null;
  MEDDELANDE_ANDRAT?: boolean | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av leverantörsfaktura
 */
export interface TEDInputLRLeverantorfakturaDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av leverantörsfaktura
 */
export interface TEDInputLRLeverantorfakturaUpdateAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputLRLeverantorfakturaBlobUpdateValues | null;
  Leverantor_Ref?: string | null;
  Leverantor_Values?: TEDInputLRLeverantorUpdateValues | null;
  Bokfgrupp_Ref?: string | null;
  Bokfgrupp_Values?: TEDInputSYSGruppUpdateValues | null;
  Registrering_Ref?: string | null;
  Registrering_Values?: TEDInputEKFakturahandelseUpdateValues | null;
  HandelseBokfgrupp_Ref?: string | null;
  HandelseBokfgrupp_Values?: TEDInputSYSGruppUpdateValues | null;
  Ankomstregistrering_Ref?: string | null;
  Ankomstregistrering_Values?: TEDInputEKFakturahandelseUpdateValues | null;
  Moms_Ref?: string | null;
  Moms_Values?: TEDInputSYSMomsUpdateValues | null;
  ElektroniskFaktura_Ref?: string | null;
  ElektroniskFaktura_Values?: TEDInputLRFakturabildUpdateValues | null;
  ForeslagenFakturakod_Ref?: string | null;
  ForeslagenFakturakod_Values?: TEDInputSYSFakturakodUpdateValues | null;
  Definitivbokning_Ref?: string | null;
  Definitivbokning_Values?: TEDInputEKFakturahandelseUpdateValues | null;
  Attestanter_Add_Values?: TEDInputLRLevfaktAttestantAddValues[] | null;
  Attestanter_Update_Values?: TEDInputLRLevfaktAttestantUpdateValues[] | null;
  Attestanter_Delete_Values?: TEDInputLRLevfaktAttestantDeleteValues[] | null;
  Fakturahandelser_Add_Values?: TEDInputEKFakturahandelseAddValues[] | null;
  Fakturahandelser_Update_Values?: TEDInputEKFakturahandelseUpdateValues[] | null;
  Fakturahandelser_Delete_Values?: TEDInputEKFakturahandelseDeleteValues[] | null;
  Betalningar_Add_Values?: TEDInputLRBetalningAddValues[] | null;
  Betalningar_Update_Values?: TEDInputLRBetalningUpdateValues[] | null;
  Betalningar_Delete_Values?: TEDInputLRBetalningDeleteValues[] | null;
  Fakturadel_Add_Values?: TEDInputLRFakturaDelAddValues[] | null;
  Fakturadel_Update_Values?: TEDInputLRFakturaDelUpdateValues[] | null;
  Fakturadel_Delete_Values?: TEDInputLRFakturaDelDeleteValues[] | null;
  Konteringsforslag_Add_Values?: TEDInputLRKonteringsForslagAddValues[] | null;
  Konteringsforslag_Update_Values?: TEDInputLRKonteringsForslagUpdateValues[] | null;
  Konteringsforslag_Delete_Values?: TEDInputLRKonteringsForslagDeleteValues[] | null;
  Fakturasidor_Add_Values?: TEDInputLRFakturabildAddValues[] | null;
  Fakturasidor_Update_Values?: TEDInputLRFakturabildUpdateValues[] | null;
  Fakturasidor_Delete_Values?: TEDInputLRFakturabildDeleteValues[] | null;
  Dokument_Add_Values?: TEDInputLRFakturaDokAddValues[] | null;
  Dokument_Update_Values?: TEDInputLRFakturaDokUpdateValues[] | null;
  Dokument_Delete_Values?: TEDInputLRFakturaDokDeleteValues[] | null;
  Attestmeddelande_Add_Values?: TEDInputLRAttestmeddelandeAddValues[] | null;
  Attestmeddelande_Update_Values?: TEDInputLRAttestmeddelandeUpdateValues[] | null;
  Attestmeddelande_Delete_Values?: TEDInputLRAttestmeddelandeDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av leverantörsfaktura
 */
export interface TEDInputLRLeverantorfakturaUpdateValues {
  id: string;
  _version: number;
  FAKTURA_NR?: string | null;
  SLUTBETALD?: TEDLRLeverantorfakturaSLUTBETALDEnum | null;
  STATUS?: TEDLRLeverantorfakturaSTATUSEnum | null;
  ANKREG_DATUM?: any | null;
  ANKREG_ANV_ID?: number | null;
  SPARRAD?: TEDLRLeverantorfakturaSPARRADEnum | null;
  BETALNINGSUPPDRAG_ID?: number | null;
  FAKTURADATUM?: any | null;
  FORFALLO_DATUM?: any | null;
  DEFBOK_BOKF_GRUPP_ID?: number | null;
  DEFBOK_ID?: number | null;
  SLUTBETALD_DATUM?: any | null;
  BESTALLNINGS_NR?: string | null;
  ELEKTRONISK_ATTEST?: TEDLRLeverantorfakturaELEKTRONISK_ATTESTEnum | null;
  INVOICE_BUNTNR?: string | null;
  INVOICE_ID?: string | null;
  INVOICE_ER_REF?: string | null;
  MOTTAGANDE_ENHET_ID?: number | null;
  ANVANT_LEVFAKTREF_NR?: number | null;
  AUTO_ANKREG?: boolean | null;
  MOMSHANTERING?: TEDLRLeverantorfakturaMOMSHANTERINGEnum | null;
  DUBLETT_IGNORERAD?: boolean | null;
  GRANSKAD_DEFBOK?: boolean | null;
  GRANSKAD_DEFBOK_SIGN?: string | null;
  GRANSKAD_DEFBOK_DATUM?: any | null;
  _Associations?: TEDInputLRLeverantorfakturaUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av leverantörskategorin
 */
export interface TEDInputLRLeverantorkatAddAssociationValues {
  Kostnadskonto_Ref?: string | null;
  Kostnadskonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Levskuldkonto_Ref?: string | null;
  Levskuldkonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Levnrserie_Ref?: string | null;
  Levnrserie_Values?: TEDInputSYSNummerserieAddValues | null;
  Moms_Ref?: string | null;
  Moms_Values?: TEDInputSYSMomsAddValues | null;
  Leverantorer_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av leverantörskategorin
 */
export interface TEDInputLRLeverantorkatAddValues {
  BENAMNING: string;
  INTERN?: TEDLRLeverantorkatINTERNEnum | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  STANDARD_BETKAT?: number | null;
  _Associations?: TEDInputLRLeverantorkatAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av leverantörskategorin
 */
export interface TEDInputLRLeverantorkatUpdateAssociationValues {
  Kostnadskonto_Ref?: string | null;
  Kostnadskonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Levskuldkonto_Ref?: string | null;
  Levskuldkonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Levnrserie_Ref?: string | null;
  Levnrserie_Values?: TEDInputSYSNummerserieUpdateValues | null;
  Moms_Ref?: string | null;
  Moms_Values?: TEDInputSYSMomsUpdateValues | null;
  Leverantorer_Add_Refs?: string[] | null;
  Leverantorer_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av leverantörskategorin
 */
export interface TEDInputLRLeverantorkatUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  INTERN?: TEDLRLeverantorkatINTERNEnum | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  STANDARD_BETKAT?: number | null;
  _Associations?: TEDInputLRLeverantorkatUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av attestant för faktura
 */
export interface TEDInputLRLevfaktAttestantAddAssociationValues {
  Faktura_Ref?: string | null;
  Faktura_Values?: TEDInputLRLeverantorfakturaAddValues | null;
  Attestant_Ref?: string | null;
  Attestant_Values?: TEDInputLRAttestantAddValues | null;
}

/**
 * Värden vid tillägg av attestant för faktura
 */
export interface TEDInputLRLevfaktAttestantAddValues {
  _Associations?: TEDInputLRLevfaktAttestantAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av attestant för faktura
 */
export interface TEDInputLRLevfaktAttestantDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av attestant för faktura
 */
export interface TEDInputLRLevfaktAttestantUpdateAssociationValues {
  Faktura_Ref?: string | null;
  Faktura_Values?: TEDInputLRLeverantorfakturaUpdateValues | null;
  Attestant_Ref?: string | null;
  Attestant_Values?: TEDInputLRAttestantUpdateValues | null;
}

/**
 * Nya värden vid ändring av attestant för faktura
 */
export interface TEDInputLRLevfaktAttestantUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputLRLevfaktAttestantUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av storleksklass
 */
export interface TEDInputLROrgStorleksklassAddValues {
  NAMN?: string | null;
  STORLEKSKLASS_KOD?: string | null;
}

/**
 * Nya värden vid ändring av storleksklass
 */
export interface TEDInputLROrgStorleksklassUpdateValues {
  id: string;
  _version: number;
  NAMN?: string | null;
  STORLEKSKLASS_KOD?: string | null;
}

/**
 * Associerade värden vid tillägg av kontering
 */
export interface TEDInputOFArtradkonteringAddAssociationValues {
  Orderrad_Ref?: string | null;
  Orderrad_Values?: TEDInputOFOrderradAddValues | null;
}

/**
 * Värden vid tillägg av kontering
 */
export interface TEDInputOFArtradkonteringAddValues {
  KPLAN_ID?: number | null;
  ORDNINGS_NR_1?: number | null;
  KONTOID_1?: number | null;
  ORDNINGS_NR_2?: number | null;
  KONTOID_2?: number | null;
  ORDNINGS_NR_3?: number | null;
  KONTOID_3?: number | null;
  ORDNINGS_NR_4?: number | null;
  KONTOID_4?: number | null;
  ORDNINGS_NR_5?: number | null;
  KONTOID_5?: number | null;
  ORDNINGS_NR_6?: number | null;
  KONTOID_6?: number | null;
  ORDNINGS_NR_7?: number | null;
  KONTOID_7?: number | null;
  ORDNINGS_NR_8?: number | null;
  KONTOID_8?: number | null;
  ORDNINGS_NR_9?: number | null;
  KONTOID_9?: number | null;
  ORDNINGS_NR_10?: number | null;
  KONTOID_10?: number | null;
  PROCENT?: number | null;
  _Associations?: TEDInputOFArtradkonteringAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kontering
 */
export interface TEDInputOFArtradkonteringDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kontering
 */
export interface TEDInputOFArtradkonteringUpdateAssociationValues {
  Orderrad_Ref?: string | null;
  Orderrad_Values?: TEDInputOFOrderradUpdateValues | null;
}

/**
 * Nya värden vid ändring av kontering
 */
export interface TEDInputOFArtradkonteringUpdateValues {
  id: string;
  _version: number;
  KPLAN_ID?: number | null;
  ORDNINGS_NR_1?: number | null;
  KONTOID_1?: number | null;
  ORDNINGS_NR_2?: number | null;
  KONTOID_2?: number | null;
  ORDNINGS_NR_3?: number | null;
  KONTOID_3?: number | null;
  ORDNINGS_NR_4?: number | null;
  KONTOID_4?: number | null;
  ORDNINGS_NR_5?: number | null;
  KONTOID_5?: number | null;
  ORDNINGS_NR_6?: number | null;
  KONTOID_6?: number | null;
  ORDNINGS_NR_7?: number | null;
  KONTOID_7?: number | null;
  ORDNINGS_NR_8?: number | null;
  KONTOID_8?: number | null;
  ORDNINGS_NR_9?: number | null;
  KONTOID_9?: number | null;
  ORDNINGS_NR_10?: number | null;
  KONTOID_10?: number | null;
  PROCENT?: number | null;
  _Associations?: TEDInputOFArtradkonteringUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av order
 */
export interface TEDInputOFOrderAddAssociationValues {
  Valuta_Ref?: string | null;
  Valuta_Values?: TEDInputSYSValutaAddValues | null;
  Sprak_Ref?: string | null;
  Sprak_Values?: TEDInputSYSSprakAddValues | null;
  Kund_Ref?: string | null;
  Kund_Values?: TEDInputKRKundAddValues | null;
  Prislista_Ref?: string | null;
  Prislista_Values?: TEDInputLAPrislistaAddValues | null;
  Betalningsvillkor_Ref?: string | null;
  Betalningsvillkor_Values?: TEDInputSYSBetalningsvillkorAddValues | null;
  Leveransvillkor_Ref?: string | null;
  Leveransvillkor_Values?: TEDInputSYSLeveransvillkorAddValues | null;
  Saljare_Ref?: string | null;
  Saljare_Values?: TEDInputOFSaljareAddValues | null;
  KundBetalare_Ref?: string | null;
  KundBetalare_Values?: TEDInputKRKundAddValues | null;
  Grupp_Ref?: string | null;
  Grupp_Values?: TEDInputSYSGruppAddValues | null;
  Debetfaktura_Ref?: string | null;
  Debetfaktura_Values?: TEDInputKRFakturaAddValues | null;
  Kreditfaktura_Ref?: string | null;
  Kreditfaktura_Values?: TEDInputKRFakturaAddValues | null;
  Land_Ref?: string | null;
  Land_Values?: TEDInputSYSLandAddValues | null;
  LeverantorsLand_Ref?: string | null;
  LeverantorsLand_Values?: TEDInputSYSLandAddValues | null;
  Orderkategori_Ref?: string | null;
  Orderkategori_Values?: TEDInputOFOrderkategoriAddValues | null;
  Kremation_Ref?: string | null;
  Kremation_Values?: TEDInputKJTEDKJKremationOrderAddValues | null;
  FaktureringsLand_Ref?: string | null;
  FaktureringsLand_Values?: TEDInputSYSLandAddValues | null;
  Orderunderlag_Ref?: string | null;
  Orderunderlag_Values?: TEDInputOFOrderunderlagAddValues | null;
  Gravplats_Ref?: string | null;
  Gravplats_Values?: TEDInputGAGravAddValues | null;
  Bisattning_Ref?: string | null;
  Bisattning_Values?: TEDInputBOTEDBOBisattningOrderAddValues | null;
  RegistreratAv_Ref?: string | null;
  RegistreratAv_Values?: TEDInputSYSUserAddValues | null;
  Periodordermall_Ref?: string | null;
  Periodordermall_Values?: TEDInputOFOrderAddValues | null;
  KonvFranPeriodMall_Ref?: string | null;
  KonvFranPeriodMall_Values?: TEDInputOFOrderAddValues | null;
  Orderrader_Add_Values?: TEDInputOFOrderradAddValues[] | null;
  Fakturor_Add_Values?: TEDInputKRFakturaAddValues[] | null;
  Ordermoms_Add_Refs?: string[] | null;
  Bilagor_Add_Values?: TEDInputOFOrderBilagaAddValues[] | null;
  Periodordrar_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av order
 */
export interface TEDInputOFOrderAddValues {
  _typ?: TEDOFOrderTypEnum | null;
  ORDERNR?: string | null;
  ORDER_OMG?: number | null;
  ORDERDATUM?: any | null;
  STATUS?: TEDOFOrderSTATUSEnum | null;
  LEVERANSDATUM?: any | null;
  PLANLEVDATUM?: any | null;
  NAMN: string;
  CO?: string | null;
  ADRESS?: string | null;
  POSTNR?: string | null;
  ORT?: string | null;
  LEVNAMN?: string | null;
  LEVADRESS?: string | null;
  LEVCO?: string | null;
  LEVPOSTNR?: string | null;
  LEVORT?: string | null;
  KUNDREFERENS?: string | null;
  MOMS?: TEDOFOrderMOMSEnum | null;
  RABATT?: number | null;
  BESTALLNINGSNR?: string | null;
  RUBRIK?: string | null;
  KLARFAKT?: boolean | null;
  FAKTURERINGSSATT: TEDOFOrderFAKTURERINGSSATTEnum;
  VARREFERENS?: string | null;
  FORFALLODATUM?: any | null;
  INTERN?: TEDOFOrderINTERNEnum | null;
  ORDERERKANNANDE?: TEDOFOrderORDERERKANNANDEEnum | null;
  ORDERERKANNANDE_DATUM?: any | null;
  ORDERERKANNANDE_SIGN?: string | null;
  FAKTURATOTAL?: TEDOFOrderFAKTURATOTALEnum | null;
  SAMFAKTURERAS?: TEDOFOrderSAMFAKTURERASEnum | null;
  KREDITORDER?: TEDOFOrderKREDITORDEREnum | null;
  BETALA_FAKTURA?: boolean | null;
  AUTOGIRO_VAG?: TEDOFOrderAUTOGIRO_VAGEnum | null;
  AUTOGIRO_ANTAL_DELBET?: number | null;
  AUTOGIRO_PERIODICITET?: TEDOFOrderAUTOGIRO_PERIODICITETEnum | null;
  AUTOGIRO_BETALNINGSDAG?: TEDOFOrderAUTOGIRO_BETALNINGSDAGEnum | null;
  AUTOGIRO_SLUTBETALAS?: TEDOFOrderAUTOGIRO_SLUTBETALASEnum | null;
  AUTOGIRO_CLEARINGNR?: string | null;
  AUTOGIRO_KONTONR?: string | null;
  AUTOGIRO_BETMANAD_1?: TEDOFOrderAUTOGIRO_BETMANAD_1Enum | null;
  AUTOGIRO_BETMANAD_2?: TEDOFOrderAUTOGIRO_BETMANAD_2Enum | null;
  AUTOGIRO_BETMANAD_3?: TEDOFOrderAUTOGIRO_BETMANAD_3Enum | null;
  AUTOGIRO_BETMANAD_4?: TEDOFOrderAUTOGIRO_BETMANAD_4Enum | null;
  AUTOGIRO_BETMANAD_5?: TEDOFOrderAUTOGIRO_BETMANAD_5Enum | null;
  AUTOGIRO_BETMANAD_6?: TEDOFOrderAUTOGIRO_BETMANAD_6Enum | null;
  AUTOGIRO_BETMANAD_7?: TEDOFOrderAUTOGIRO_BETMANAD_7Enum | null;
  AUTOGIRO_BETMANAD_8?: TEDOFOrderAUTOGIRO_BETMANAD_8Enum | null;
  AUTOGIRO_BETMANAD_9?: TEDOFOrderAUTOGIRO_BETMANAD_9Enum | null;
  AUTOGIRO_BETMANAD_10?: TEDOFOrderAUTOGIRO_BETMANAD_10Enum | null;
  AUTOGIRO_BETMANAD_11?: TEDOFOrderAUTOGIRO_BETMANAD_11Enum | null;
  AUTOGIRO_BETMANAD_12?: TEDOFOrderAUTOGIRO_BETMANAD_12Enum | null;
  AUTOGIRO_BETALARNR?: string | null;
  FAKTURA_NR?: number | null;
  RANTEOMGANG_ID?: number | null;
  KOB_PERS_NR?: string | null;
  KOB_DATUM?: any | null;
  FORRATTNINGSTYP?: TEDOFOrderFORRATTNINGSTYPEnum | null;
  KOB_DODSDATUM?: string | null;
  KOB_HEMFORSAMLING?: string | null;
  KOB_PERSNAMN?: string | null;
  KOB_PERS_NR2?: string | null;
  KOB_PERSNAMN2?: string | null;
  ARBETSORDER?: boolean | null;
  ARBETSORDER_DATUM?: any | null;
  ARBETSORDER_SIGN?: string | null;
  AVTAL_AVRAKNAT_TOM?: any | null;
  PERIOD_SLUTDATUM?: any | null;
  PERIOD_ANTALMAN?: number | null;
  PERIOD_NASTADATUM?: any | null;
  KOB_ORGANISATIONSAR?: number | null;
  KOB_GRAVPLATSBETECKNING?: string | null;
  KOB_GRAVSATTNINGSDATUM?: any | null;
  FAKTNAMN?: string | null;
  FAKTADRESS?: string | null;
  FAKTCO?: string | null;
  FAKTPOSTNR?: string | null;
  FAKTORT?: string | null;
  IMPORT_IDENTIFIKATION?: number | null;
  IMPORT_XML?: string | null;
  IMPORT_ORGNR?: string | null;
  KREDITERAR_ORDERNR?: string | null;
  AVRUNDNINGS_BELOPP?: any | null;
  KREDIT_BETALINSTR?: TEDOFOrderKREDIT_BETALINSTREnum | null;
  KREDIT_SKICKA?: boolean | null;
  KOB_FOLKBOKFFORSAML?: string | null;
  IMPORT_KUNDNR?: string | null;
  FAKTURATEXT?: string | null;
  GALLRAD_KUNDUPPG?: boolean | null;
  GALLRAD_CLEARINGUPPG?: boolean | null;
  GALLRAD_KUNDUPPG_DATUM?: any | null;
  GALLRAD_CLEARINGUPPG_DATUM?: any | null;
  TILLGANGLIG_DATUM?: any | null;
  MANUELL_ORDER?: boolean | null;
  BEVAKA_FAKTURABETALNING?: boolean | null;
  AVSER_PERIOD_FRAN?: any | null;
  AVSER_PERIOD_TILL?: any | null;
  FRAN_PERIODORDER_ID?: number | null;
  PERIODMALL_AVSLUTAD?: boolean | null;
  PERIODMALL_AVSLUTAD_DATUM?: any | null;
  KONV_PERIODORDER_ID?: number | null;
  PERIODISERAD?: boolean | null;
  PERIODISERAD_PERIOD_FRAN?: any | null;
  PERIODISERAD_PERIOD_TILL?: any | null;
  PERIODMALL_UPPDATERA_PRISER?: boolean | null;
  BACKINFO_PERIOD_NASTADATUM?: any | null;
  _Associations: TEDInputOFOrderAddAssociationValues;
}

/**
 * Associerade värden vid tillägg av orderBilaga
 */
export interface TEDInputOFOrderBilagaAddAssociationValues {
  Order_Ref?: string | null;
  Order_Values?: TEDInputOFOrderAddValues | null;
  Bilaga_Ref?: string | null;
  Bilaga_Values?: TEDInputKRExternprintbliagaAddValues | null;
}

/**
 * Värden vid tillägg av orderBilaga
 */
export interface TEDInputOFOrderBilagaAddValues {
  ORDNINGS_NR?: number | null;
  KOPPLAD_I_RUTIN: TEDOFOrderBilagaKOPPLAD_I_RUTINEnum;
  _Associations: TEDInputOFOrderBilagaAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av orderBilaga
 */
export interface TEDInputOFOrderBilagaDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av orderBilaga
 */
export interface TEDInputOFOrderBilagaUpdateAssociationValues {
  Order_Ref?: string | null;
  Order_Values?: TEDInputOFOrderUpdateValues | null;
  Bilaga_Ref?: string | null;
  Bilaga_Values?: TEDInputKRExternprintbliagaUpdateValues | null;
}

/**
 * Nya värden vid ändring av orderBilaga
 */
export interface TEDInputOFOrderBilagaUpdateValues {
  id: string;
  _version: number;
  ORDNINGS_NR?: number | null;
  KOPPLAD_I_RUTIN?: TEDOFOrderBilagaKOPPLAD_I_RUTINEnum | null;
  _Associations?: TEDInputOFOrderBilagaUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av order
 */
export interface TEDInputOFOrderUpdateAssociationValues {
  Valuta_Ref?: string | null;
  Valuta_Values?: TEDInputSYSValutaUpdateValues | null;
  Sprak_Ref?: string | null;
  Sprak_Values?: TEDInputSYSSprakUpdateValues | null;
  Kund_Ref?: string | null;
  Kund_Values?: TEDInputKRKundUpdateValues | null;
  Prislista_Ref?: string | null;
  Prislista_Values?: TEDInputLAPrislistaUpdateValues | null;
  Betalningsvillkor_Ref?: string | null;
  Betalningsvillkor_Values?: TEDInputSYSBetalningsvillkorUpdateValues | null;
  Leveransvillkor_Ref?: string | null;
  Leveransvillkor_Values?: TEDInputSYSLeveransvillkorUpdateValues | null;
  Saljare_Ref?: string | null;
  Saljare_Values?: TEDInputOFSaljareUpdateValues | null;
  KundBetalare_Ref?: string | null;
  KundBetalare_Values?: TEDInputKRKundUpdateValues | null;
  Grupp_Ref?: string | null;
  Grupp_Values?: TEDInputSYSGruppUpdateValues | null;
  Debetfaktura_Ref?: string | null;
  Debetfaktura_Values?: TEDInputKRFakturaUpdateValues | null;
  Kreditfaktura_Ref?: string | null;
  Kreditfaktura_Values?: TEDInputKRFakturaUpdateValues | null;
  Land_Ref?: string | null;
  Land_Values?: TEDInputSYSLandUpdateValues | null;
  LeverantorsLand_Ref?: string | null;
  LeverantorsLand_Values?: TEDInputSYSLandUpdateValues | null;
  Orderkategori_Ref?: string | null;
  Orderkategori_Values?: TEDInputOFOrderkategoriUpdateValues | null;
  Kremation_Ref?: string | null;
  Kremation_Values?: TEDInputKJTEDKJKremationOrderUpdateValues | null;
  FaktureringsLand_Ref?: string | null;
  FaktureringsLand_Values?: TEDInputSYSLandUpdateValues | null;
  Orderunderlag_Ref?: string | null;
  Orderunderlag_Values?: TEDInputOFOrderunderlagUpdateValues | null;
  Gravplats_Ref?: string | null;
  Gravplats_Values?: TEDInputGAGravUpdateValues | null;
  Bisattning_Ref?: string | null;
  Bisattning_Values?: TEDInputBOTEDBOBisattningOrderUpdateValues | null;
  RegistreratAv_Ref?: string | null;
  RegistreratAv_Values?: TEDInputSYSUserUpdateValues | null;
  Periodordermall_Ref?: string | null;
  Periodordermall_Values?: TEDInputOFOrderUpdateValues | null;
  KonvFranPeriodMall_Ref?: string | null;
  KonvFranPeriodMall_Values?: TEDInputOFOrderUpdateValues | null;
  Orderrader_Add_Values?: TEDInputOFOrderradAddValues[] | null;
  Orderrader_Update_Values?: TEDInputOFOrderradUpdateValues[] | null;
  Orderrader_Delete_Values?: TEDInputOFOrderradDeleteValues[] | null;
  Fakturor_Add_Values?: TEDInputKRFakturaAddValues[] | null;
  Fakturor_Update_Values?: TEDInputKRFakturaUpdateValues[] | null;
  Fakturor_Delete_Values?: TEDInputKRFakturaDeleteValues[] | null;
  Ordermoms_Add_Refs?: string[] | null;
  Ordermoms_Delete_Refs?: string[] | null;
  Bilagor_Add_Values?: TEDInputOFOrderBilagaAddValues[] | null;
  Bilagor_Update_Values?: TEDInputOFOrderBilagaUpdateValues[] | null;
  Bilagor_Delete_Values?: TEDInputOFOrderBilagaDeleteValues[] | null;
  Periodordrar_Add_Refs?: string[] | null;
  Periodordrar_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av order
 */
export interface TEDInputOFOrderUpdateValues {
  id: string;
  _version: number;
  ORDERNR?: string | null;
  ORDER_OMG?: number | null;
  ORDERDATUM?: any | null;
  STATUS?: TEDOFOrderSTATUSEnum | null;
  LEVERANSDATUM?: any | null;
  PLANLEVDATUM?: any | null;
  NAMN?: string | null;
  CO?: string | null;
  ADRESS?: string | null;
  POSTNR?: string | null;
  ORT?: string | null;
  LEVNAMN?: string | null;
  LEVADRESS?: string | null;
  LEVCO?: string | null;
  LEVPOSTNR?: string | null;
  LEVORT?: string | null;
  KUNDREFERENS?: string | null;
  MOMS?: TEDOFOrderMOMSEnum | null;
  RABATT?: number | null;
  BESTALLNINGSNR?: string | null;
  RUBRIK?: string | null;
  KLARFAKT?: boolean | null;
  FAKTURERINGSSATT?: TEDOFOrderFAKTURERINGSSATTEnum | null;
  VARREFERENS?: string | null;
  FORFALLODATUM?: any | null;
  INTERN?: TEDOFOrderINTERNEnum | null;
  ORDERERKANNANDE?: TEDOFOrderORDERERKANNANDEEnum | null;
  ORDERERKANNANDE_DATUM?: any | null;
  ORDERERKANNANDE_SIGN?: string | null;
  FAKTURATOTAL?: TEDOFOrderFAKTURATOTALEnum | null;
  SAMFAKTURERAS?: TEDOFOrderSAMFAKTURERASEnum | null;
  KREDITORDER?: TEDOFOrderKREDITORDEREnum | null;
  BETALA_FAKTURA?: boolean | null;
  AUTOGIRO_VAG?: TEDOFOrderAUTOGIRO_VAGEnum | null;
  AUTOGIRO_ANTAL_DELBET?: number | null;
  AUTOGIRO_PERIODICITET?: TEDOFOrderAUTOGIRO_PERIODICITETEnum | null;
  AUTOGIRO_BETALNINGSDAG?: TEDOFOrderAUTOGIRO_BETALNINGSDAGEnum | null;
  AUTOGIRO_SLUTBETALAS?: TEDOFOrderAUTOGIRO_SLUTBETALASEnum | null;
  AUTOGIRO_CLEARINGNR?: string | null;
  AUTOGIRO_KONTONR?: string | null;
  AUTOGIRO_BETMANAD_1?: TEDOFOrderAUTOGIRO_BETMANAD_1Enum | null;
  AUTOGIRO_BETMANAD_2?: TEDOFOrderAUTOGIRO_BETMANAD_2Enum | null;
  AUTOGIRO_BETMANAD_3?: TEDOFOrderAUTOGIRO_BETMANAD_3Enum | null;
  AUTOGIRO_BETMANAD_4?: TEDOFOrderAUTOGIRO_BETMANAD_4Enum | null;
  AUTOGIRO_BETMANAD_5?: TEDOFOrderAUTOGIRO_BETMANAD_5Enum | null;
  AUTOGIRO_BETMANAD_6?: TEDOFOrderAUTOGIRO_BETMANAD_6Enum | null;
  AUTOGIRO_BETMANAD_7?: TEDOFOrderAUTOGIRO_BETMANAD_7Enum | null;
  AUTOGIRO_BETMANAD_8?: TEDOFOrderAUTOGIRO_BETMANAD_8Enum | null;
  AUTOGIRO_BETMANAD_9?: TEDOFOrderAUTOGIRO_BETMANAD_9Enum | null;
  AUTOGIRO_BETMANAD_10?: TEDOFOrderAUTOGIRO_BETMANAD_10Enum | null;
  AUTOGIRO_BETMANAD_11?: TEDOFOrderAUTOGIRO_BETMANAD_11Enum | null;
  AUTOGIRO_BETMANAD_12?: TEDOFOrderAUTOGIRO_BETMANAD_12Enum | null;
  AUTOGIRO_BETALARNR?: string | null;
  FAKTURA_NR?: number | null;
  RANTEOMGANG_ID?: number | null;
  KOB_PERS_NR?: string | null;
  KOB_DATUM?: any | null;
  FORRATTNINGSTYP?: TEDOFOrderFORRATTNINGSTYPEnum | null;
  KOB_DODSDATUM?: string | null;
  KOB_HEMFORSAMLING?: string | null;
  KOB_PERSNAMN?: string | null;
  KOB_PERS_NR2?: string | null;
  KOB_PERSNAMN2?: string | null;
  ARBETSORDER?: boolean | null;
  ARBETSORDER_DATUM?: any | null;
  ARBETSORDER_SIGN?: string | null;
  AVTAL_AVRAKNAT_TOM?: any | null;
  PERIOD_SLUTDATUM?: any | null;
  PERIOD_ANTALMAN?: number | null;
  PERIOD_NASTADATUM?: any | null;
  KOB_ORGANISATIONSAR?: number | null;
  KOB_GRAVPLATSBETECKNING?: string | null;
  KOB_GRAVSATTNINGSDATUM?: any | null;
  FAKTNAMN?: string | null;
  FAKTADRESS?: string | null;
  FAKTCO?: string | null;
  FAKTPOSTNR?: string | null;
  FAKTORT?: string | null;
  IMPORT_IDENTIFIKATION?: number | null;
  IMPORT_XML?: string | null;
  IMPORT_ORGNR?: string | null;
  KREDITERAR_ORDERNR?: string | null;
  AVRUNDNINGS_BELOPP?: any | null;
  KREDIT_BETALINSTR?: TEDOFOrderKREDIT_BETALINSTREnum | null;
  KREDIT_SKICKA?: boolean | null;
  KOB_FOLKBOKFFORSAML?: string | null;
  IMPORT_KUNDNR?: string | null;
  FAKTURATEXT?: string | null;
  GALLRAD_KUNDUPPG?: boolean | null;
  GALLRAD_CLEARINGUPPG?: boolean | null;
  GALLRAD_KUNDUPPG_DATUM?: any | null;
  GALLRAD_CLEARINGUPPG_DATUM?: any | null;
  TILLGANGLIG_DATUM?: any | null;
  MANUELL_ORDER?: boolean | null;
  BEVAKA_FAKTURABETALNING?: boolean | null;
  AVSER_PERIOD_FRAN?: any | null;
  AVSER_PERIOD_TILL?: any | null;
  FRAN_PERIODORDER_ID?: number | null;
  PERIODMALL_AVSLUTAD?: boolean | null;
  PERIODMALL_AVSLUTAD_DATUM?: any | null;
  KONV_PERIODORDER_ID?: number | null;
  PERIODISERAD?: boolean | null;
  PERIODISERAD_PERIOD_FRAN?: any | null;
  PERIODISERAD_PERIOD_TILL?: any | null;
  PERIODMALL_UPPDATERA_PRISER?: boolean | null;
  BACKINFO_PERIOD_NASTADATUM?: any | null;
  _Associations?: TEDInputOFOrderUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av orderkategori
 */
export interface TEDInputOFOrderkategoriAddAssociationValues {
  Intaktskonto_Ref?: string | null;
  Intaktskonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
}

/**
 * Värden vid tillägg av orderkategori
 */
export interface TEDInputOFOrderkategoriAddValues {
  BENAMNING: string;
  _Associations?: TEDInputOFOrderkategoriAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av orderkategori
 */
export interface TEDInputOFOrderkategoriUpdateAssociationValues {
  Intaktskonto_Ref?: string | null;
  Intaktskonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
}

/**
 * Nya värden vid ändring av orderkategori
 */
export interface TEDInputOFOrderkategoriUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  _Associations?: TEDInputOFOrderkategoriUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av orderrad
 */
export interface TEDInputOFOrderradAddAssociationValues {
  Ordern_Ref?: string | null;
  Ordern_Values?: TEDInputOFOrderAddValues | null;
  Fakturarad_Ref?: string | null;
  Fakturarad_Values?: TEDInputKRFakturaradAddValues | null;
  DrojRantafaktura_Ref?: string | null;
  DrojRantafaktura_Values?: TEDInputKRFakturaAddValues | null;
  Fakturatext_Ref?: string | null;
  Fakturatext_Values?: TEDInputLAFakturatextAddValues | null;
  Moms_Ref?: string | null;
  Moms_Values?: TEDInputSYSMomsAddValues | null;
  Artikel_Ref?: string | null;
  Artikel_Values?: TEDInputLAArtikelAddValues | null;
  Enhet_Ref?: string | null;
  Enhet_Values?: TEDInputLAEnhetAddValues | null;
  Kontering_Add_Values?: TEDInputOFArtradkonteringAddValues[] | null;
}

/**
 * Värden vid tillägg av orderrad
 */
export interface TEDInputOFOrderradAddValues {
  _typ: TEDOFOrderradTypEnum;
  BENAMNING?: string | null;
  ORDNINGSNR?: number | null;
  STATUS?: TEDOFOrderradSTATUSEnum | null;
  FD_STATUS?: TEDOFOrderradFD_STATUSEnum | null;
  FAKTURA?: boolean | null;
  ORDERBEKRAFTELSE?: boolean | null;
  ARBETSORDER?: boolean | null;
  SKRIVSTATUS?: TEDOFOrderradSKRIVSTATUSEnum | null;
  APRIS?: any | null;
  RABATT?: number | null;
  BESTANTAL?: number | null;
  LEVANTAL?: number | null;
  ANTAL_ATT_FAKT?: number | null;
  SLUTLEVERERAD?: boolean | null;
  ATTFAKTURERABELOPP?: any | null;
  BESTALLTBELOPP?: any | null;
  STARTDATUM?: any | null;
  NASTADATUM?: any | null;
  SLUTDATUM?: any | null;
  ANTAL_MAN?: number | null;
  FDAPRIS?: any | null;
  PRISUPPDATERING_DATUM?: any | null;
  EJ_MANAD?: boolean | null;
  AVR_JUSTERING?: any | null;
  DOLJ_BELOPP?: boolean | null;
  RANTEFAKT_GRUPP_ID?: number | null;
  RANTEFAKT_ID?: number | null;
  MOMS_BELOPP?: any | null;
  IMPORT_ARTIKELNR?: string | null;
  KOB_ARTIKELNR?: string | null;
  RABATT_I_KR?: any | null;
  PERIODMALL_RAD_AVSLUTAD?: boolean | null;
  PERIODISERAD?: boolean | null;
  PERIODISERAD_PERIOD_FRAN?: any | null;
  PERIODISERAD_PERIOD_TILL?: any | null;
  PERIODMALL_UPPDATERA_PRISER?: boolean | null;
  BACKINFO_STATUS?: string | null;
  BACKINFO_FD_STATUS?: string | null;
  BACKINFO_NASTADATUM?: any | null;
  BACKINFO_ORDERRADNR?: number | null;
  BACKINFO_ARTIKEL_ID?: number | null;
  _Associations?: TEDInputOFOrderradAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av orderrad
 */
export interface TEDInputOFOrderradDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av orderrad
 */
export interface TEDInputOFOrderradUpdateAssociationValues {
  Ordern_Ref?: string | null;
  Ordern_Values?: TEDInputOFOrderUpdateValues | null;
  Fakturarad_Ref?: string | null;
  Fakturarad_Values?: TEDInputKRFakturaradUpdateValues | null;
  DrojRantafaktura_Ref?: string | null;
  DrojRantafaktura_Values?: TEDInputKRFakturaUpdateValues | null;
  Fakturatext_Ref?: string | null;
  Fakturatext_Values?: TEDInputLAFakturatextUpdateValues | null;
  Moms_Ref?: string | null;
  Moms_Values?: TEDInputSYSMomsUpdateValues | null;
  Artikel_Ref?: string | null;
  Artikel_Values?: TEDInputLAArtikelUpdateValues | null;
  Enhet_Ref?: string | null;
  Enhet_Values?: TEDInputLAEnhetUpdateValues | null;
  Kontering_Add_Values?: TEDInputOFArtradkonteringAddValues[] | null;
  Kontering_Update_Values?: TEDInputOFArtradkonteringUpdateValues[] | null;
  Kontering_Delete_Values?: TEDInputOFArtradkonteringDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av orderrad
 */
export interface TEDInputOFOrderradUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  ORDNINGSNR?: number | null;
  STATUS?: TEDOFOrderradSTATUSEnum | null;
  FD_STATUS?: TEDOFOrderradFD_STATUSEnum | null;
  FAKTURA?: boolean | null;
  ORDERBEKRAFTELSE?: boolean | null;
  ARBETSORDER?: boolean | null;
  SKRIVSTATUS?: TEDOFOrderradSKRIVSTATUSEnum | null;
  APRIS?: any | null;
  RABATT?: number | null;
  BESTANTAL?: number | null;
  LEVANTAL?: number | null;
  ANTAL_ATT_FAKT?: number | null;
  SLUTLEVERERAD?: boolean | null;
  ATTFAKTURERABELOPP?: any | null;
  BESTALLTBELOPP?: any | null;
  STARTDATUM?: any | null;
  NASTADATUM?: any | null;
  SLUTDATUM?: any | null;
  ANTAL_MAN?: number | null;
  FDAPRIS?: any | null;
  PRISUPPDATERING_DATUM?: any | null;
  EJ_MANAD?: boolean | null;
  AVR_JUSTERING?: any | null;
  DOLJ_BELOPP?: boolean | null;
  RANTEFAKT_GRUPP_ID?: number | null;
  RANTEFAKT_ID?: number | null;
  MOMS_BELOPP?: any | null;
  IMPORT_ARTIKELNR?: string | null;
  KOB_ARTIKELNR?: string | null;
  RABATT_I_KR?: any | null;
  PERIODMALL_RAD_AVSLUTAD?: boolean | null;
  PERIODISERAD?: boolean | null;
  PERIODISERAD_PERIOD_FRAN?: any | null;
  PERIODISERAD_PERIOD_TILL?: any | null;
  PERIODMALL_UPPDATERA_PRISER?: boolean | null;
  BACKINFO_STATUS?: string | null;
  BACKINFO_FD_STATUS?: string | null;
  BACKINFO_NASTADATUM?: any | null;
  BACKINFO_ORDERRADNR?: number | null;
  BACKINFO_ARTIKEL_ID?: number | null;
  _Associations?: TEDInputOFOrderradUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av orderunderlag
 */
export interface TEDInputOFOrderunderlagAddAssociationValues {
  Ordermottagningsvag_Ref?: string | null;
  Ordermottagningsvag_Values?: TEDInputSYSOrdermottagningsvagAddValues | null;
  Ordrar_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av orderunderlag
 */
export interface TEDInputOFOrderunderlagAddValues {
  FIL_DATUM?: any | null;
  FIL_LOPNR?: number | null;
  FIL_NAMN?: string | null;
  STATUS: TEDOFOrderunderlagSTATUSEnum;
  DATUM_SKAPAD?: any | null;
  SIGN_SKAPAD?: string | null;
  DATUM_BACKAD?: any | null;
  SIGN_BACKAD?: string | null;
  IMPORTTYP?: TEDOFOrderunderlagIMPORTTYPEnum | null;
  XML?: string | null;
  ORDERMOTTAGNINGSVAG_ID?: number | null;
  FELLOGG?: string | null;
  _Associations?: TEDInputOFOrderunderlagAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av orderunderlag
 */
export interface TEDInputOFOrderunderlagUpdateAssociationValues {
  Ordermottagningsvag_Ref?: string | null;
  Ordermottagningsvag_Values?: TEDInputSYSOrdermottagningsvagUpdateValues | null;
  Ordrar_Add_Refs?: string[] | null;
  Ordrar_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av orderunderlag
 */
export interface TEDInputOFOrderunderlagUpdateValues {
  id: string;
  _version: number;
  FIL_DATUM?: any | null;
  FIL_LOPNR?: number | null;
  FIL_NAMN?: string | null;
  STATUS?: TEDOFOrderunderlagSTATUSEnum | null;
  DATUM_SKAPAD?: any | null;
  SIGN_SKAPAD?: string | null;
  DATUM_BACKAD?: any | null;
  SIGN_BACKAD?: string | null;
  IMPORTTYP?: TEDOFOrderunderlagIMPORTTYPEnum | null;
  XML?: string | null;
  ORDERMOTTAGNINGSVAG_ID?: number | null;
  FELLOGG?: string | null;
  _Associations?: TEDInputOFOrderunderlagUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av säljare
 */
export interface TEDInputOFSaljareAddAssociationValues {
  Order_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av säljare
 */
export interface TEDInputOFSaljareAddValues {
  NAMN: string;
  _Associations?: TEDInputOFSaljareAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av säljare
 */
export interface TEDInputOFSaljareUpdateAssociationValues {
  Order_Add_Refs?: string[] | null;
  Order_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av säljare
 */
export interface TEDInputOFSaljareUpdateValues {
  id: string;
  _version: number;
  NAMN?: string | null;
  _Associations?: TEDInputOFSaljareUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av adress
 */
export interface TEDInputOPAdressAddAssociationValues {
  Land_Ref?: string | null;
  Land_Values?: TEDInputSYSLandAddValues | null;
  OrgPersLok_Ref?: string | null;
  OrgPersLok_Values?: TEDInputOPOrgPersLokAddValues | null;
  Kontakter_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av adress
 */
export interface TEDInputOPAdressAddValues {
  CO?: string | null;
  ADRESS?: string | null;
  POSTNR?: string | null;
  ORT?: string | null;
  TELEFON1?: string | null;
  TELEFON2?: string | null;
  TELEFON_ARB?: string | null;
  TELEFON_MOBIL?: string | null;
  TELEFAX?: string | null;
  PERSONSOKARE?: string | null;
  SMTP1?: string | null;
  SMTP2?: string | null;
  SMTP3?: string | null;
  SMTP4?: string | null;
  URL1?: string | null;
  URL2?: string | null;
  URL3?: string | null;
  URL4?: string | null;
  FASTIGHETSBETECKNING?: string | null;
  ADRESS2?: string | null;
  ADRESS3?: string | null;
  ADRESS1?: string | null;
  CO_ADRESS?: string | null;
  HANTERAD?: boolean | null;
  HANTERAD_DATUM?: any | null;
  SENAST_TEL_DATUM?: any | null;
  SENAST_EPOST_DATUM?: any | null;
  _Associations?: TEDInputOPAdressAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av adress
 */
export interface TEDInputOPAdressUpdateAssociationValues {
  Land_Ref?: string | null;
  Land_Values?: TEDInputSYSLandUpdateValues | null;
  OrgPersLok_Ref?: string | null;
  OrgPersLok_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Kontakter_Add_Refs?: string[] | null;
  Kontakter_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av adress
 */
export interface TEDInputOPAdressUpdateValues {
  id: string;
  _version: number;
  CO?: string | null;
  ADRESS?: string | null;
  POSTNR?: string | null;
  ORT?: string | null;
  TELEFON1?: string | null;
  TELEFON2?: string | null;
  TELEFON_ARB?: string | null;
  TELEFON_MOBIL?: string | null;
  TELEFAX?: string | null;
  PERSONSOKARE?: string | null;
  SMTP1?: string | null;
  SMTP2?: string | null;
  SMTP3?: string | null;
  SMTP4?: string | null;
  URL1?: string | null;
  URL2?: string | null;
  URL3?: string | null;
  URL4?: string | null;
  FASTIGHETSBETECKNING?: string | null;
  ADRESS2?: string | null;
  ADRESS3?: string | null;
  ADRESS1?: string | null;
  CO_ADRESS?: string | null;
  HANTERAD?: boolean | null;
  HANTERAD_DATUM?: any | null;
  SENAST_TEL_DATUM?: any | null;
  SENAST_EPOST_DATUM?: any | null;
  _Associations?: TEDInputOPAdressUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av oPAvlidenActiveXSaml
 */
export interface TEDInputOPAvlidenActiveXSamlAddValues {
  BESKRIVNING?: string | null;
  FILNAMN?: string | null;
  SENAST_ANDRAD?: any | null;
  DATA?: string | null;
  DATASIZE?: number | null;
  DATATYPE?: string | null;
  EXTENSION?: string | null;
  SIGNATUR?: string | null;
  UPPLAGD?: any | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av oPAvlidenActiveXSaml
 */
export interface TEDInputOPAvlidenActiveXSamlDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av oPAvlidenActiveXSaml
 */
export interface TEDInputOPAvlidenActiveXSamlUpdateValues {
  id: string;
  _version: number;
  BESKRIVNING?: string | null;
  FILNAMN?: string | null;
  SENAST_ANDRAD?: any | null;
  DATA?: string | null;
  DATASIZE?: number | null;
  DATATYPE?: string | null;
  EXTENSION?: string | null;
  SIGNATUR?: string | null;
  UPPLAGD?: any | null;
}

/**
 * Associerade värden vid tillägg av avlidna
 */
export interface TEDInputOPAvlidenAddAssociationValues {
  Person_Ref?: string | null;
  Person_Values?: TEDInputOPOrgPersLokAddValues | null;
  Bisattning_Ref?: string | null;
  Bisattning_Values?: TEDInputBOBisattningAddValues | null;
  Tvist_Ref?: string | null;
  Tvist_Values?: TEDInputOPTvistAddValues | null;
  Gravsattning_Ref?: string | null;
  Gravsattning_Values?: TEDInputBOAktivitetAddValues | null;
  Kremation_Ref?: string | null;
  Kremation_Values?: TEDInputKJKremationAddValues | null;
  Gravsatt_Ref?: string | null;
  Gravsatt_Values?: TEDInputGAGravsattAddValues | null;
  Begravning_Ref?: string | null;
  Begravning_Values?: TEDInputBOAktivitetAddValues | null;
  Gravsattningsort_Ref?: string | null;
  Gravsattningsort_Values?: TEDInputOPOrgPersLokAddValues | null;
  KGard_Ref?: string | null;
  KGard_Values?: TEDInputGAKGardAddValues | null;
  Kvarter_Ref?: string | null;
  Kvarter_Values?: TEDInputGAKvarterAddValues | null;
  Avdelning_Ref?: string | null;
  Avdelning_Values?: TEDInputGAAvdelningAddValues | null;
  Dodsbo_Ref?: string | null;
  Dodsbo_Values?: TEDInputGAKontaktAddValues | null;
  Dokument_Add_Values?: TEDInputOPAvlidenActiveXSamlAddValues[] | null;
}

/**
 * Värden vid tillägg av avlidna
 */
export interface TEDInputOPAvlidenAddValues {
  ARENDE_NR?: string | null;
  AVLIDEN_DATUM?: string | null;
  BEGR_DATUM_TID?: string | null;
  INTYG_KREM_DATUM?: any | null;
  KREM_DATUM?: any | null;
  DIREKTKREM?: boolean | null;
  INTYG_DIREKTKREM_DATUM?: any | null;
  INTYG_GRAVS_DATUM?: any | null;
  MEDGIVANDE_GRAVOPPNING_DATUM?: any | null;
  MEDGIVANDE_ML_AL_DATUM?: any | null;
  GRAVS_DATUM_TID?: string | null;
  AKT_MED_URNA?: boolean | null;
  KREM_BEST_DATUM?: any | null;
  KREM_ANNAN_ORT?: boolean | null;
  KREMERING?: TEDOPAvlidenKREMERINGEnum | null;
  REG_DATUM?: any | null;
  FOSTERNUMMER?: string | null;
  KVARTER_KGARD_ID?: number | null;
  KVARTER_LOPNR?: number | null;
  AVDELNING_ID?: number | null;
  GRAVNUMMER?: string | null;
  GRAVTYP?: TEDOPAvlidenGRAVTYPEnum | null;
  GRAVSATTNINGSORT_ID?: number | null;
  BEGRAVNINGSPLATS?: string | null;
  GRAVSPLATS?: string | null;
  SKICKAT_GRAVSINTYG?: string | null;
  SKICKAT_KREMINTYG?: string | null;
  SKICKAT_KREMINTYG_MANUELLT?: boolean | null;
  SKICKAT_GRAVSINTYG_MANUELLT?: boolean | null;
  REDAN_GRAVSATT?: string | null;
  REDAN_KREMERAD?: string | null;
  _Associations: TEDInputOPAvlidenAddAssociationValues;
}

/**
 * Associerade värden vid ändring av avlidna
 */
export interface TEDInputOPAvlidenUpdateAssociationValues {
  Person_Ref?: string | null;
  Person_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Bisattning_Ref?: string | null;
  Bisattning_Values?: TEDInputBOBisattningUpdateValues | null;
  Tvist_Ref?: string | null;
  Tvist_Values?: TEDInputOPTvistUpdateValues | null;
  Gravsattning_Ref?: string | null;
  Gravsattning_Values?: TEDInputBOAktivitetUpdateValues | null;
  Kremation_Ref?: string | null;
  Kremation_Values?: TEDInputKJKremationUpdateValues | null;
  Gravsatt_Ref?: string | null;
  Gravsatt_Values?: TEDInputGAGravsattUpdateValues | null;
  Begravning_Ref?: string | null;
  Begravning_Values?: TEDInputBOAktivitetUpdateValues | null;
  Gravsattningsort_Ref?: string | null;
  Gravsattningsort_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  KGard_Ref?: string | null;
  KGard_Values?: TEDInputGAKGardUpdateValues | null;
  Kvarter_Ref?: string | null;
  Kvarter_Values?: TEDInputGAKvarterUpdateValues | null;
  Avdelning_Ref?: string | null;
  Avdelning_Values?: TEDInputGAAvdelningUpdateValues | null;
  Dodsbo_Ref?: string | null;
  Dodsbo_Values?: TEDInputGAKontaktUpdateValues | null;
  Dokument_Add_Values?: TEDInputOPAvlidenActiveXSamlAddValues[] | null;
  Dokument_Update_Values?: TEDInputOPAvlidenActiveXSamlUpdateValues[] | null;
  Dokument_Delete_Values?: TEDInputOPAvlidenActiveXSamlDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av avlidna
 */
export interface TEDInputOPAvlidenUpdateValues {
  id: string;
  _version: number;
  ARENDE_NR?: string | null;
  AVLIDEN_DATUM?: string | null;
  BEGR_DATUM_TID?: string | null;
  INTYG_KREM_DATUM?: any | null;
  KREM_DATUM?: any | null;
  DIREKTKREM?: boolean | null;
  INTYG_DIREKTKREM_DATUM?: any | null;
  INTYG_GRAVS_DATUM?: any | null;
  MEDGIVANDE_GRAVOPPNING_DATUM?: any | null;
  MEDGIVANDE_ML_AL_DATUM?: any | null;
  GRAVS_DATUM_TID?: string | null;
  AKT_MED_URNA?: boolean | null;
  KREM_BEST_DATUM?: any | null;
  KREM_ANNAN_ORT?: boolean | null;
  KREMERING?: TEDOPAvlidenKREMERINGEnum | null;
  REG_DATUM?: any | null;
  FOSTERNUMMER?: string | null;
  KVARTER_KGARD_ID?: number | null;
  KVARTER_LOPNR?: number | null;
  AVDELNING_ID?: number | null;
  GRAVNUMMER?: string | null;
  GRAVTYP?: TEDOPAvlidenGRAVTYPEnum | null;
  GRAVSATTNINGSORT_ID?: number | null;
  BEGRAVNINGSPLATS?: string | null;
  GRAVSPLATS?: string | null;
  SKICKAT_GRAVSINTYG?: string | null;
  SKICKAT_KREMINTYG?: string | null;
  SKICKAT_KREMINTYG_MANUELLT?: boolean | null;
  SKICKAT_GRAVSINTYG_MANUELLT?: boolean | null;
  REDAN_GRAVSATT?: string | null;
  REDAN_KREMERAD?: string | null;
  _Associations?: TEDInputOPAvlidenUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av adress
 */
export interface TEDInputOPExtraAdresserAddAssociationValues {
  OrgPers_Ref?: string | null;
  OrgPers_Values?: TEDInputOPOrgPersLokAddValues | null;
  Adress_Ref?: string | null;
  Adress_Values?: TEDInputOPAdressAddValues | null;
}

/**
 * Värden vid tillägg av adress
 */
export interface TEDInputOPExtraAdresserAddValues {
  INTERN_KOD?: number | null;
  _Associations: TEDInputOPExtraAdresserAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av adress
 */
export interface TEDInputOPExtraAdresserDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av adress
 */
export interface TEDInputOPExtraAdresserUpdateAssociationValues {
  OrgPers_Ref?: string | null;
  OrgPers_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Adress_Ref?: string | null;
  Adress_Values?: TEDInputOPAdressUpdateValues | null;
}

/**
 * Nya värden vid ändring av adress
 */
export interface TEDInputOPExtraAdresserUpdateValues {
  id: string;
  _version: number;
  INTERN_KOD?: number | null;
  _Associations?: TEDInputOPExtraAdresserUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kontaktperson
 */
export interface TEDInputOPKontaktAddAssociationValues {
  Adress_Ref?: string | null;
  Adress_Values?: TEDInputOPAdressAddValues | null;
  OrgPers_Ref?: string | null;
  OrgPers_Values?: TEDInputOPOrgPersLokAddValues | null;
  Kontaktkund_Ref?: string | null;
  Kontaktkund_Values?: TEDInputKRKundAddValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
  Titlar_Add_Values?: TEDInputOPKontaktTitelAddValues[] | null;
  KontaktLicens_Add_Refs?: string[] | null;
  AktKontakt_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av kontaktperson
 */
export interface TEDInputOPKontaktAddValues {
  NAMN: string;
  NOTERINGAR?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  AVDELNING?: string | null;
  PERS_NR?: string | null;
  _Associations: TEDInputOPKontaktAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kontaktperson
 */
export interface TEDInputOPKontaktDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid tillägg av titel
 */
export interface TEDInputOPKontaktTitelAddAssociationValues {
  Titel_Ref?: string | null;
  Titel_Values?: TEDInputSYSTitelAddValues | null;
  Kontakt_Ref?: string | null;
  Kontakt_Values?: TEDInputOPKontaktAddValues | null;
}

/**
 * Värden vid tillägg av titel
 */
export interface TEDInputOPKontaktTitelAddValues {
  _Associations: TEDInputOPKontaktTitelAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av titel
 */
export interface TEDInputOPKontaktTitelDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av titel
 */
export interface TEDInputOPKontaktTitelUpdateAssociationValues {
  Titel_Ref?: string | null;
  Titel_Values?: TEDInputSYSTitelUpdateValues | null;
  Kontakt_Ref?: string | null;
  Kontakt_Values?: TEDInputOPKontaktUpdateValues | null;
}

/**
 * Nya värden vid ändring av titel
 */
export interface TEDInputOPKontaktTitelUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputOPKontaktTitelUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av kontaktperson
 */
export interface TEDInputOPKontaktUpdateAssociationValues {
  Adress_Ref?: string | null;
  Adress_Values?: TEDInputOPAdressUpdateValues | null;
  OrgPers_Ref?: string | null;
  OrgPers_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Kontaktkund_Ref?: string | null;
  Kontaktkund_Values?: TEDInputKRKundUpdateValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
  Titlar_Add_Values?: TEDInputOPKontaktTitelAddValues[] | null;
  Titlar_Update_Values?: TEDInputOPKontaktTitelUpdateValues[] | null;
  Titlar_Delete_Values?: TEDInputOPKontaktTitelDeleteValues[] | null;
  KontaktLicens_Add_Refs?: string[] | null;
  KontaktLicens_Delete_Refs?: string[] | null;
  AktKontakt_Add_Refs?: string[] | null;
  AktKontakt_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av kontaktperson
 */
export interface TEDInputOPKontaktUpdateValues {
  id: string;
  _version: number;
  NAMN?: string | null;
  NOTERINGAR?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  AVDELNING?: string | null;
  PERS_NR?: string | null;
  _Associations?: TEDInputOPKontaktUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av adress/Lokal
 */
export interface TEDInputOPOrgPersLokAddAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputOPOrgPersLokBlobAddValues | null;
  Adress_Ref?: string | null;
  Adress_Values?: TEDInputOPAdressAddValues | null;
  OriginalOPL_Ref?: string | null;
  OriginalOPL_Values?: TEDInputOPOrgPersLokAddValues | null;
  Samfallighet_Ref?: string | null;
  Samfallighet_Values?: TEDInputOPOrgPersLokAddValues | null;
  Vardnadshavare1_Ref?: string | null;
  Vardnadshavare1_Values?: TEDInputOPOrgPersLokAddValues | null;
  Vardnadshavare2_Ref?: string | null;
  Vardnadshavare2_Values?: TEDInputOPOrgPersLokAddValues | null;
  Relationsperson_Ref?: string | null;
  Relationsperson_Values?: TEDInputOPOrgPersLokAddValues | null;
  Gruppmedlem_Ref?: string | null;
  Gruppmedlem_Values?: TEDInputBOTEDBOGruppmedlemOPAddValues | null;
  SorteringEnamn_Ref?: string | null;
  SorteringEnamn_Values?: TEDInputOPSorteringsnamnAddValues | null;
  SorteringMnamn_Ref?: string | null;
  SorteringMnamn_Values?: TEDInputOPSorteringsnamnAddValues | null;
  levkostKonto_Ref?: string | null;
  levkostKonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Tvist_Ref?: string | null;
  Tvist_Values?: TEDInputOPTvistAddValues | null;
  Adressanvandning_Ref?: string | null;
  Adressanvandning_Values?: TEDInputSYSAdressanvandningAddValues | null;
  Storleksklass_Ref?: string | null;
  Storleksklass_Values?: TEDInputLROrgStorleksklassAddValues | null;
  KremBest_Ref?: string | null;
  KremBest_Values?: TEDInputBOBisattningKremBestAddValues | null;
  KopiorOPL_Add_Refs?: string[] | null;
  ExtraAdresser_Add_Values?: TEDInputOPExtraAdresserAddValues[] | null;
  FindRelations_Add_Refs?: string[] | null;
  FindVardnadshavare1_Add_Refs?: string[] | null;
  FindVardnadshavare2_Add_Refs?: string[] | null;
  FindAktDelt_Add_Refs?: string[] | null;
  FindGruppMedlem_Add_Refs?: string[] | null;
  FindResurs_Add_Refs?: string[] | null;
  FindAvsMot_Add_Refs?: string[] | null;
  FindGodman_Add_Refs?: string[] | null;
  FindGravrattsinnehavare_Add_Refs?: string[] | null;
  FindKund_Add_Refs?: string[] | null;
  FindLeverantor_Add_Refs?: string[] | null;
  FindAvsandare_Add_Refs?: string[] | null;
  FindMottagare_Add_Refs?: string[] | null;
  FindAnvandare_Add_Refs?: string[] | null;
  FindAnstalld_Add_Refs?: string[] | null;
  Kontakter_Add_Values?: TEDInputOPKontaktAddValues[] | null;
  Forsamlingar_Add_Refs?: string[] | null;
  FindForsamling_Add_Refs?: string[] | null;
  Kursdeltagare_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av adress/Lokal
 */
export interface TEDInputOPOrgPersLokAddValues {
  _typ: TEDOPOrgPersLokTypEnum;
  SORTERINGSNAMN?: string | null;
  LOKALADR?: TEDOPOrgPersLokLOKALADREnum | null;
  LOKALADR_RUBRIK?: string | null;
  ANTECKNINGAR?: string | null;
  UPD_ID?: number | null;
  UPD_PERS_NR?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_ORSAK?: TEDOPOrgPersLokBORTTAGEN_ORSAKEnum | null;
  TRIGGER_DATUM?: any | null;
  SEN_ANDR_DATUM?: any | null;
  ANDRAD_AV_ANV_TIMESTAMP?: any | null;
  LAND_ID?: number | null;
  LKF?: string | null;
  KYRKOLKF?: string | null;
  LKF_BENAMNING?: string | null;
  KYRKOLKF_BENAMNING?: string | null;
  FORNAMN?: string | null;
  ORG_NR?: string | null;
  ORG_NAMN?: string | null;
  MOMSREG_NR?: string | null;
  KATEGORI?: TEDOPOrgPersLokKATEGORIEnum | null;
  EGEN_EKONOMI?: boolean | null;
  INVANARE_ANTAL?: number | null;
  MEDLEM_ANTAL?: number | null;
  SAMFKOD?: string | null;
  FAKTURERA_SAMFALLIGHET?: TEDOPOrgPersLokFAKTURERA_SAMFALLIGHETEnum | null;
  PERS_NR?: string | null;
  EFTERNAMN?: string | null;
  FULLST_FORNAMN?: string | null;
  MEDLEMSKOD?: TEDOPOrgPersLokMEDLEMSKODEnum | null;
  MEDLEMSDATUM?: any | null;
  DOPKOD?: TEDOPOrgPersLokDOPKODEnum | null;
  DOPDATUM?: any | null;
  KONF_KOD?: TEDOPOrgPersLokKONF_KODEnum | null;
  KONF_DATUM?: any | null;
  CIVILSTAND?: string | null;
  CIVIL_DATUM?: any | null;
  FORNAMN_1?: string | null;
  FORNAMN_2?: string | null;
  FORNAMN_3?: string | null;
  FORNAMN_4?: string | null;
  FORNAMN_5?: string | null;
  SORT_EFTERNAMN?: string | null;
  SORT_MELLANNAMN?: string | null;
  AUTO_ADRESS_UPDAT?: TEDOPOrgPersLokAUTO_ADRESS_UPDATEnum | null;
  KNAV_ADRESS_STATUS?: number | null;
  BENAMNING?: string | null;
  SKYDDAD?: string | null;
  ADRESS_SOURCE?: string | null;
  LKF2?: string | null;
  DODSDATUM?: string | null;
  ANVANDNING_ID?: number | null;
  AVVIKANDE?: boolean | null;
  RENSA_PA_BEGARAN?: number | null;
  GALLRAD?: string | null;
  REGEL?: TEDOPOrgPersLokREGELEnum | null;
  FORNAMN_FRAN_SKV?: boolean | null;
  AVLIDEN_STATUS?: string | null;
  HISTORISK?: string | null;
  GALLRAD_DATUM?: any | null;
  AVVIKANDE_DATUM?: any | null;
  AVVIKANDE_SIGN?: string | null;
  UPPL_DATUM?: any | null;
  ONLINE_DATUM?: any | null;
  BATCH_DATUM?: any | null;
  ANV_DATUM?: any | null;
  _Associations: TEDInputOPOrgPersLokAddAssociationValues;
}

/**
 * Värden vid tillägg av oPOrgPersLokBlob
 */
export interface TEDInputOPOrgPersLokBlobAddValues {
  BILD?: string | null;
  BILDSIZE?: number | null;
  BILDSTRETCH?: string | null;
}

/**
 * Nya värden vid ändring av oPOrgPersLokBlob
 */
export interface TEDInputOPOrgPersLokBlobUpdateValues {
  id: string;
  _version: number;
  BILD?: string | null;
  BILDSIZE?: number | null;
  BILDSTRETCH?: string | null;
}

/**
 * Associerade värden vid ändring av adress/Lokal
 */
export interface TEDInputOPOrgPersLokUpdateAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputOPOrgPersLokBlobUpdateValues | null;
  Adress_Ref?: string | null;
  Adress_Values?: TEDInputOPAdressUpdateValues | null;
  OriginalOPL_Ref?: string | null;
  OriginalOPL_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Samfallighet_Ref?: string | null;
  Samfallighet_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Vardnadshavare1_Ref?: string | null;
  Vardnadshavare1_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Vardnadshavare2_Ref?: string | null;
  Vardnadshavare2_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Relationsperson_Ref?: string | null;
  Relationsperson_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Gruppmedlem_Ref?: string | null;
  Gruppmedlem_Values?: TEDInputBOTEDBOGruppmedlemOPUpdateValues | null;
  SorteringEnamn_Ref?: string | null;
  SorteringEnamn_Values?: TEDInputOPSorteringsnamnUpdateValues | null;
  SorteringMnamn_Ref?: string | null;
  SorteringMnamn_Values?: TEDInputOPSorteringsnamnUpdateValues | null;
  levkostKonto_Ref?: string | null;
  levkostKonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Tvist_Ref?: string | null;
  Tvist_Values?: TEDInputOPTvistUpdateValues | null;
  Adressanvandning_Ref?: string | null;
  Adressanvandning_Values?: TEDInputSYSAdressanvandningUpdateValues | null;
  Storleksklass_Ref?: string | null;
  Storleksklass_Values?: TEDInputLROrgStorleksklassUpdateValues | null;
  KremBest_Ref?: string | null;
  KremBest_Values?: TEDInputBOBisattningKremBestUpdateValues | null;
  KopiorOPL_Add_Refs?: string[] | null;
  KopiorOPL_Delete_Refs?: string[] | null;
  ExtraAdresser_Add_Values?: TEDInputOPExtraAdresserAddValues[] | null;
  ExtraAdresser_Update_Values?: TEDInputOPExtraAdresserUpdateValues[] | null;
  ExtraAdresser_Delete_Values?: TEDInputOPExtraAdresserDeleteValues[] | null;
  FindRelations_Add_Refs?: string[] | null;
  FindRelations_Delete_Refs?: string[] | null;
  FindVardnadshavare1_Add_Refs?: string[] | null;
  FindVardnadshavare1_Delete_Refs?: string[] | null;
  FindVardnadshavare2_Add_Refs?: string[] | null;
  FindVardnadshavare2_Delete_Refs?: string[] | null;
  FindAktDelt_Add_Refs?: string[] | null;
  FindAktDelt_Delete_Refs?: string[] | null;
  FindGruppMedlem_Add_Refs?: string[] | null;
  FindGruppMedlem_Delete_Refs?: string[] | null;
  FindResurs_Add_Refs?: string[] | null;
  FindResurs_Delete_Refs?: string[] | null;
  FindAvsMot_Add_Refs?: string[] | null;
  FindAvsMot_Delete_Refs?: string[] | null;
  FindGodman_Add_Refs?: string[] | null;
  FindGodman_Delete_Refs?: string[] | null;
  FindGravrattsinnehavare_Add_Refs?: string[] | null;
  FindGravrattsinnehavare_Delete_Refs?: string[] | null;
  FindKund_Add_Refs?: string[] | null;
  FindKund_Delete_Refs?: string[] | null;
  FindLeverantor_Add_Refs?: string[] | null;
  FindLeverantor_Delete_Refs?: string[] | null;
  FindAvsandare_Add_Refs?: string[] | null;
  FindAvsandare_Delete_Refs?: string[] | null;
  FindMottagare_Add_Refs?: string[] | null;
  FindMottagare_Delete_Refs?: string[] | null;
  FindAnvandare_Add_Refs?: string[] | null;
  FindAnvandare_Delete_Refs?: string[] | null;
  FindAnstalld_Add_Refs?: string[] | null;
  FindAnstalld_Delete_Refs?: string[] | null;
  Kontakter_Add_Values?: TEDInputOPKontaktAddValues[] | null;
  Kontakter_Update_Values?: TEDInputOPKontaktUpdateValues[] | null;
  Kontakter_Delete_Values?: TEDInputOPKontaktDeleteValues[] | null;
  Kontakter_Undelete?: TEDInputOPKontaktDeleteValues[] | null;
  Forsamlingar_Add_Refs?: string[] | null;
  Forsamlingar_Delete_Refs?: string[] | null;
  FindForsamling_Add_Refs?: string[] | null;
  FindForsamling_Delete_Refs?: string[] | null;
  Kursdeltagare_Add_Refs?: string[] | null;
  Kursdeltagare_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av adress/Lokal
 */
export interface TEDInputOPOrgPersLokUpdateValues {
  id: string;
  _version: number;
  SORTERINGSNAMN?: string | null;
  LOKALADR?: TEDOPOrgPersLokLOKALADREnum | null;
  LOKALADR_RUBRIK?: string | null;
  ANTECKNINGAR?: string | null;
  UPD_ID?: number | null;
  UPD_PERS_NR?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_ORSAK?: TEDOPOrgPersLokBORTTAGEN_ORSAKEnum | null;
  TRIGGER_DATUM?: any | null;
  SEN_ANDR_DATUM?: any | null;
  ANDRAD_AV_ANV_TIMESTAMP?: any | null;
  LAND_ID?: number | null;
  LKF?: string | null;
  KYRKOLKF?: string | null;
  LKF_BENAMNING?: string | null;
  KYRKOLKF_BENAMNING?: string | null;
  FORNAMN?: string | null;
  ORG_NR?: string | null;
  ORG_NAMN?: string | null;
  MOMSREG_NR?: string | null;
  KATEGORI?: TEDOPOrgPersLokKATEGORIEnum | null;
  EGEN_EKONOMI?: boolean | null;
  INVANARE_ANTAL?: number | null;
  MEDLEM_ANTAL?: number | null;
  SAMFKOD?: string | null;
  FAKTURERA_SAMFALLIGHET?: TEDOPOrgPersLokFAKTURERA_SAMFALLIGHETEnum | null;
  PERS_NR?: string | null;
  EFTERNAMN?: string | null;
  FULLST_FORNAMN?: string | null;
  MEDLEMSKOD?: TEDOPOrgPersLokMEDLEMSKODEnum | null;
  MEDLEMSDATUM?: any | null;
  DOPKOD?: TEDOPOrgPersLokDOPKODEnum | null;
  DOPDATUM?: any | null;
  KONF_KOD?: TEDOPOrgPersLokKONF_KODEnum | null;
  KONF_DATUM?: any | null;
  CIVILSTAND?: string | null;
  CIVIL_DATUM?: any | null;
  FORNAMN_1?: string | null;
  FORNAMN_2?: string | null;
  FORNAMN_3?: string | null;
  FORNAMN_4?: string | null;
  FORNAMN_5?: string | null;
  SORT_EFTERNAMN?: string | null;
  SORT_MELLANNAMN?: string | null;
  AUTO_ADRESS_UPDAT?: TEDOPOrgPersLokAUTO_ADRESS_UPDATEnum | null;
  KNAV_ADRESS_STATUS?: number | null;
  BENAMNING?: string | null;
  SKYDDAD?: string | null;
  ADRESS_SOURCE?: string | null;
  LKF2?: string | null;
  DODSDATUM?: string | null;
  ANVANDNING_ID?: number | null;
  AVVIKANDE?: boolean | null;
  RENSA_PA_BEGARAN?: number | null;
  GALLRAD?: string | null;
  REGEL?: TEDOPOrgPersLokREGELEnum | null;
  FORNAMN_FRAN_SKV?: boolean | null;
  AVLIDEN_STATUS?: string | null;
  HISTORISK?: string | null;
  GALLRAD_DATUM?: any | null;
  AVVIKANDE_DATUM?: any | null;
  AVVIKANDE_SIGN?: string | null;
  UPPL_DATUM?: any | null;
  ONLINE_DATUM?: any | null;
  BATCH_DATUM?: any | null;
  ANV_DATUM?: any | null;
  _Associations?: TEDInputOPOrgPersLokUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av sorteringsnamn
 */
export interface TEDInputOPSorteringsnamnAddValues {
  SORTERINGSNAMN?: string | null;
}

/**
 * Nya värden vid ändring av sorteringsnamn
 */
export interface TEDInputOPSorteringsnamnUpdateValues {
  id: string;
  _version: number;
  SORTERINGSNAMN?: string | null;
}

/**
 * Associerade värden vid tillägg av tvist
 */
export interface TEDInputOPTvistAddAssociationValues {
  Avliden_Ref?: string | null;
  Avliden_Values?: TEDInputOPAvlidenAddValues | null;
  Historik_Add_Values?: TEDInputOPTvistHistAddValues[] | null;
}

/**
 * Värden vid tillägg av tvist
 */
export interface TEDInputOPTvistAddValues {
  PERS_NR?: string | null;
  TVIST_KREM?: boolean | null;
  TVIST_GRAVS?: boolean | null;
  OFFENTLIG_NOTERING?: string | null;
  INTERN_NOTERING?: string | null;
  NAMN?: string | null;
  FORBEHALL?: string | null;
  GUID?: string | null;
  _Associations?: TEDInputOPTvistAddAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av tvistehistorik
 */
export interface TEDInputOPTvistHistAddAssociationValues {
  Tvist_Ref?: string | null;
  Tvist_Values?: TEDInputOPTvistAddValues | null;
}

/**
 * Värden vid tillägg av tvistehistorik
 */
export interface TEDInputOPTvistHistAddValues {
  ANDRAD_DATUM?: any | null;
  ANDRAD_SIGNATUR?: string | null;
  AVSER: TEDOPTvistHistAVSEREnum;
  ORSAK: TEDOPTvistHistORSAKEnum;
  _Associations?: TEDInputOPTvistHistAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av tvistehistorik
 */
export interface TEDInputOPTvistHistDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av tvistehistorik
 */
export interface TEDInputOPTvistHistUpdateAssociationValues {
  Tvist_Ref?: string | null;
  Tvist_Values?: TEDInputOPTvistUpdateValues | null;
}

/**
 * Nya värden vid ändring av tvistehistorik
 */
export interface TEDInputOPTvistHistUpdateValues {
  id: string;
  _version: number;
  ANDRAD_DATUM?: any | null;
  ANDRAD_SIGNATUR?: string | null;
  AVSER?: TEDOPTvistHistAVSEREnum | null;
  ORSAK?: TEDOPTvistHistORSAKEnum | null;
  _Associations?: TEDInputOPTvistHistUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av tvist
 */
export interface TEDInputOPTvistUpdateAssociationValues {
  Avliden_Ref?: string | null;
  Avliden_Values?: TEDInputOPAvlidenUpdateValues | null;
  Historik_Add_Values?: TEDInputOPTvistHistAddValues[] | null;
  Historik_Update_Values?: TEDInputOPTvistHistUpdateValues[] | null;
  Historik_Delete_Values?: TEDInputOPTvistHistDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av tvist
 */
export interface TEDInputOPTvistUpdateValues {
  id: string;
  _version: number;
  PERS_NR?: string | null;
  TVIST_KREM?: boolean | null;
  TVIST_GRAVS?: boolean | null;
  OFFENTLIG_NOTERING?: string | null;
  INTERN_NOTERING?: string | null;
  NAMN?: string | null;
  FORBEHALL?: string | null;
  GUID?: string | null;
  _Associations?: TEDInputOPTvistUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av gallringslogg
 */
export interface TEDInputSYSAdranvGallrLoggAddAssociationValues {
  Adressanvandning_Ref?: string | null;
  Adressanvandning_Values?: TEDInputSYSAdressanvandningAddValues | null;
}

/**
 * Värden vid tillägg av gallringslogg
 */
export interface TEDInputSYSAdranvGallrLoggAddValues {
  STATUS?: TEDSYSAdranvGallrLoggSTATUSEnum | null;
  GALLRAT_ANTAL?: number | null;
  MEDDELANDE?: string | null;
  ANTAL_SEKUNDER?: number | null;
  _Associations?: TEDInputSYSAdranvGallrLoggAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av gallringslogg
 */
export interface TEDInputSYSAdranvGallrLoggDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av gallringslogg
 */
export interface TEDInputSYSAdranvGallrLoggUpdateAssociationValues {
  Adressanvandning_Ref?: string | null;
  Adressanvandning_Values?: TEDInputSYSAdressanvandningUpdateValues | null;
}

/**
 * Nya värden vid ändring av gallringslogg
 */
export interface TEDInputSYSAdranvGallrLoggUpdateValues {
  id: string;
  _version: number;
  STATUS?: TEDSYSAdranvGallrLoggSTATUSEnum | null;
  GALLRAT_ANTAL?: number | null;
  MEDDELANDE?: string | null;
  ANTAL_SEKUNDER?: number | null;
  _Associations?: TEDInputSYSAdranvGallrLoggUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av adressanvändning
 */
export interface TEDInputSYSAdressanvandningAddAssociationValues {
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
  Personkategori_Ref?: string | null;
  Personkategori_Values?: TEDInputSYSPersonkategoriAddValues | null;
  kategorier_Add_Values?: TEDInputSYSAdressanvandningKategoriAddValues[] | null;
  rutiner_Add_Values?: TEDInputSYSAdressanvandningrutinAddValues[] | null;
  Gallringslogg_Add_Values?: TEDInputSYSAdranvGallrLoggAddValues[] | null;
}

/**
 * Värden vid tillägg av adressanvändning
 */
export interface TEDInputSYSAdressanvandningAddValues {
  ID?: number | null;
  BENAMNING?: string | null;
  ANDAMAL?: string | null;
  REF_FRAN_TABELL?: string | null;
  SUBSYSTEMCODE: TEDSYSAdressanvandningSUBSYSTEMCODEEnum;
  LAGRINGSDIFFERENS_VARDE?: number | null;
  RENSNINGSTYP: TEDSYSAdressanvandningRENSNINGSTYPEnum;
  UPPDATERINGSTYP?: boolean | null;
  LAGLIG_GRUND: TEDSYSAdressanvandningLAGLIG_GRUNDEnum;
  LAGLIG_GRUND_MOTIVERING?: string | null;
  STATUS?: string | null;
  LAGRINGSDIFFERENS_VARDE_STD?: number | null;
  LAGLIG_GRUND_STD?: string | null;
  LAGLIG_GRUND_MOTIVERING_STD?: string | null;
  STATUS_DATUM?: any | null;
  MINSTA_LAGRING_TEXT?: string | null;
  LAGRINGSTYP: TEDSYSAdressanvandningLAGRINGSTYPEnum;
  GALLRINGSTYP?: TEDSYSAdressanvandningGALLRINGSTYPEnum | null;
  UTOKAD_LAGRING_MOTIVERING?: string | null;
  UTOKAD_LAGRING_TILLATEN?: boolean | null;
  _Associations?: TEDInputSYSAdressanvandningAddAssociationValues | null;
}

/**
 * Värden vid tillägg av adressanvändning kategori
 */
export interface TEDInputSYSAdressanvandningKategoriAddValues {
  ANVANDNING_ID?: number | null;
  LOPNR?: number | null;
  KATEGORI: TEDSYSAdressanvandningKategoriKATEGORIEnum;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av adressanvändning kategori
 */
export interface TEDInputSYSAdressanvandningKategoriDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av adressanvändning kategori
 */
export interface TEDInputSYSAdressanvandningKategoriUpdateValues {
  id: string;
  _version: number;
  ANVANDNING_ID?: number | null;
  LOPNR?: number | null;
  KATEGORI?: TEDSYSAdressanvandningKategoriKATEGORIEnum | null;
}

/**
 * Associerade värden vid ändring av adressanvändning
 */
export interface TEDInputSYSAdressanvandningUpdateAssociationValues {
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
  Personkategori_Ref?: string | null;
  Personkategori_Values?: TEDInputSYSPersonkategoriUpdateValues | null;
  kategorier_Add_Values?: TEDInputSYSAdressanvandningKategoriAddValues[] | null;
  kategorier_Update_Values?: TEDInputSYSAdressanvandningKategoriUpdateValues[] | null;
  kategorier_Delete_Values?: TEDInputSYSAdressanvandningKategoriDeleteValues[] | null;
  rutiner_Add_Values?: TEDInputSYSAdressanvandningrutinAddValues[] | null;
  rutiner_Update_Values?: TEDInputSYSAdressanvandningrutinUpdateValues[] | null;
  rutiner_Delete_Values?: TEDInputSYSAdressanvandningrutinDeleteValues[] | null;
  Gallringslogg_Add_Values?: TEDInputSYSAdranvGallrLoggAddValues[] | null;
  Gallringslogg_Update_Values?: TEDInputSYSAdranvGallrLoggUpdateValues[] | null;
  Gallringslogg_Delete_Values?: TEDInputSYSAdranvGallrLoggDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av adressanvändning
 */
export interface TEDInputSYSAdressanvandningUpdateValues {
  id: string;
  _version: number;
  ID?: number | null;
  BENAMNING?: string | null;
  ANDAMAL?: string | null;
  REF_FRAN_TABELL?: string | null;
  SUBSYSTEMCODE?: TEDSYSAdressanvandningSUBSYSTEMCODEEnum | null;
  LAGRINGSDIFFERENS_VARDE?: number | null;
  RENSNINGSTYP?: TEDSYSAdressanvandningRENSNINGSTYPEnum | null;
  UPPDATERINGSTYP?: boolean | null;
  LAGLIG_GRUND?: TEDSYSAdressanvandningLAGLIG_GRUNDEnum | null;
  LAGLIG_GRUND_MOTIVERING?: string | null;
  STATUS?: string | null;
  LAGRINGSDIFFERENS_VARDE_STD?: number | null;
  LAGLIG_GRUND_STD?: string | null;
  LAGLIG_GRUND_MOTIVERING_STD?: string | null;
  STATUS_DATUM?: any | null;
  MINSTA_LAGRING_TEXT?: string | null;
  LAGRINGSTYP?: TEDSYSAdressanvandningLAGRINGSTYPEnum | null;
  GALLRINGSTYP?: TEDSYSAdressanvandningGALLRINGSTYPEnum | null;
  UTOKAD_LAGRING_MOTIVERING?: string | null;
  UTOKAD_LAGRING_TILLATEN?: boolean | null;
  _Associations?: TEDInputSYSAdressanvandningUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av adressanvändning rutin
 */
export interface TEDInputSYSAdressanvandningrutinAddValues {
  ANVANDNING_ID?: number | null;
  LOPNR?: number | null;
  ROUTINE_ID?: number | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av adressanvändning rutin
 */
export interface TEDInputSYSAdressanvandningrutinDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av adressanvändning rutin
 */
export interface TEDInputSYSAdressanvandningrutinUpdateValues {
  id: string;
  _version: number;
  ANVANDNING_ID?: number | null;
  LOPNR?: number | null;
  ROUTINE_ID?: number | null;
}

/**
 * Associerade värden vid tillägg av användarens roll
 */
export interface TEDInputSYSAnvandarRollAddAssociationValues {
  Roll_Ref?: string | null;
  Roll_Values?: TEDInputSYSRollAddValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
}

/**
 * Värden vid tillägg av användarens roll
 */
export interface TEDInputSYSAnvandarRollAddValues {
  _Associations: TEDInputSYSAnvandarRollAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av användarens roll
 */
export interface TEDInputSYSAnvandarRollDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av användarens roll
 */
export interface TEDInputSYSAnvandarRollUpdateAssociationValues {
  Roll_Ref?: string | null;
  Roll_Values?: TEDInputSYSRollUpdateValues | null;
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
}

/**
 * Nya värden vid ändring av användarens roll
 */
export interface TEDInputSYSAnvandarRollUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputSYSAnvandarRollUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av arbetsställe
 */
export interface TEDInputSYSArbetsstalleAddAssociationValues {
  Kontobegransning_Add_Values?: TEDInputEKStalleKontourvalAddValues[] | null;
  Anvandare_Add_Values?: TEDInputSYSUserAddValues[] | null;
}

/**
 * Värden vid tillägg av arbetsställe
 */
export interface TEDInputSYSArbetsstalleAddValues {
  BENAMNING?: string | null;
  _Associations?: TEDInputSYSArbetsstalleAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av arbetsställe
 */
export interface TEDInputSYSArbetsstalleUpdateAssociationValues {
  Kontobegransning_Add_Values?: TEDInputEKStalleKontourvalAddValues[] | null;
  Kontobegransning_Update_Values?: TEDInputEKStalleKontourvalUpdateValues[] | null;
  Kontobegransning_Delete_Values?: TEDInputEKStalleKontourvalDeleteValues[] | null;
  Anvandare_Add_Values?: TEDInputSYSUserAddValues[] | null;
  Anvandare_Update_Values?: TEDInputSYSUserUpdateValues[] | null;
  Anvandare_Delete_Values?: TEDInputSYSUserDeleteValues[] | null;
  Anvandare_Undelete?: TEDInputSYSUserDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av arbetsställe
 */
export interface TEDInputSYSArbetsstalleUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  _Associations?: TEDInputSYSArbetsstalleUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av autogiromall
 */
export interface TEDInputSYSAutogiroMallAddValues {
  BENAMNING?: string | null;
  ANTAL_DELBET?: number | null;
  PERIODICITET: TEDSYSAutogiroMallPERIODICITETEnum;
  BETALNINGSDAG?: TEDSYSAutogiroMallBETALNINGSDAGEnum | null;
  SLUTBETALAS?: TEDSYSAutogiroMallSLUTBETALASEnum | null;
  BETMANAD_1?: TEDSYSAutogiroMallBETMANAD_1Enum | null;
  BETMANAD_2?: TEDSYSAutogiroMallBETMANAD_2Enum | null;
  BETMANAD_3?: TEDSYSAutogiroMallBETMANAD_3Enum | null;
  BETMANAD_4?: TEDSYSAutogiroMallBETMANAD_4Enum | null;
  BETMANAD_5?: TEDSYSAutogiroMallBETMANAD_5Enum | null;
  BETMANAD_6?: TEDSYSAutogiroMallBETMANAD_6Enum | null;
  BETMANAD_7?: TEDSYSAutogiroMallBETMANAD_7Enum | null;
  BETMANAD_8?: TEDSYSAutogiroMallBETMANAD_8Enum | null;
  BETMANAD_9?: TEDSYSAutogiroMallBETMANAD_9Enum | null;
  BETMANAD_10?: TEDSYSAutogiroMallBETMANAD_10Enum | null;
  BETMANAD_11?: TEDSYSAutogiroMallBETMANAD_11Enum | null;
  BETMANAD_12?: TEDSYSAutogiroMallBETMANAD_12Enum | null;
  IDKOD?: string | null;
}

/**
 * Nya värden vid ändring av autogiromall
 */
export interface TEDInputSYSAutogiroMallUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  ANTAL_DELBET?: number | null;
  PERIODICITET?: TEDSYSAutogiroMallPERIODICITETEnum | null;
  BETALNINGSDAG?: TEDSYSAutogiroMallBETALNINGSDAGEnum | null;
  SLUTBETALAS?: TEDSYSAutogiroMallSLUTBETALASEnum | null;
  BETMANAD_1?: TEDSYSAutogiroMallBETMANAD_1Enum | null;
  BETMANAD_2?: TEDSYSAutogiroMallBETMANAD_2Enum | null;
  BETMANAD_3?: TEDSYSAutogiroMallBETMANAD_3Enum | null;
  BETMANAD_4?: TEDSYSAutogiroMallBETMANAD_4Enum | null;
  BETMANAD_5?: TEDSYSAutogiroMallBETMANAD_5Enum | null;
  BETMANAD_6?: TEDSYSAutogiroMallBETMANAD_6Enum | null;
  BETMANAD_7?: TEDSYSAutogiroMallBETMANAD_7Enum | null;
  BETMANAD_8?: TEDSYSAutogiroMallBETMANAD_8Enum | null;
  BETMANAD_9?: TEDSYSAutogiroMallBETMANAD_9Enum | null;
  BETMANAD_10?: TEDSYSAutogiroMallBETMANAD_10Enum | null;
  BETMANAD_11?: TEDSYSAutogiroMallBETMANAD_11Enum | null;
  BETMANAD_12?: TEDSYSAutogiroMallBETMANAD_12Enum | null;
  IDKOD?: string | null;
}

/**
 * Associerade värden vid tillägg av bank
 */
export interface TEDInputSYSBankAddAssociationValues {
  Land_Ref?: string | null;
  Land_Values?: TEDInputSYSLandAddValues | null;
}

/**
 * Värden vid tillägg av bank
 */
export interface TEDInputSYSBankAddValues {
  CLEARINGNR?: string | null;
  NAMN: string;
  ADRESS?: string | null;
  POSTADRESS?: string | null;
  POSTNUMMER?: string | null;
  SWIFT_ADRESS?: string | null;
  SORTCODE?: string | null;
  NATIONAL_BANK_ID?: TEDSYSBankNATIONAL_BANK_IDEnum | null;
  _Associations?: TEDInputSYSBankAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av bank
 */
export interface TEDInputSYSBankUpdateAssociationValues {
  Land_Ref?: string | null;
  Land_Values?: TEDInputSYSLandUpdateValues | null;
}

/**
 * Nya värden vid ändring av bank
 */
export interface TEDInputSYSBankUpdateValues {
  id: string;
  _version: number;
  CLEARINGNR?: string | null;
  NAMN?: string | null;
  ADRESS?: string | null;
  POSTADRESS?: string | null;
  POSTNUMMER?: string | null;
  SWIFT_ADRESS?: string | null;
  SORTCODE?: string | null;
  NATIONAL_BANK_ID?: TEDSYSBankNATIONAL_BANK_IDEnum | null;
  _Associations?: TEDInputSYSBankUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av inbetalningssätt
 */
export interface TEDInputSYSBetalningssattAddAssociationValues {
  Bank_Ref?: string | null;
  Bank_Values?: TEDInputSYSBankAddValues | null;
  Likvidkonto_Ref?: string | null;
  Likvidkonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
}

/**
 * Värden vid tillägg av inbetalningssätt
 */
export interface TEDInputSYSBetalningssattAddValues {
  _typ: TEDSYSBetalningssattTypEnum;
  BETSATTKOD: string;
  BENAMNING?: string | null;
  KONTOTYP: TEDSYSBetalningssattKONTOTYPEnum;
  KONTONR?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  KATALOG?: string | null;
  EFAKTURA?: boolean | null;
  OCR_KONTROLL?: boolean | null;
  OCR_REFERENS_KONTROLL?: boolean | null;
  OCR_FAKTNR_KONTROLL?: boolean | null;
  IDKOD?: string | null;
  AKTIV?: boolean | null;
  MANUELL_KONTERING?: boolean | null;
  BANKAVTAL?: TEDSYSBetalningssattBANKAVTALEnum | null;
  PRIM_BETSATT?: boolean | null;
  EFAKTURA_KGF?: boolean | null;
  BANKKONTONR?: string | null;
  ISO_IBANBETSATT?: boolean | null;
  TILL_KIVRA?: boolean | null;
  TILL_KIVRA_KGF?: boolean | null;
  IBAN?: string | null;
  _Associations?: TEDInputSYSBetalningssattAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av inbetalningssätt
 */
export interface TEDInputSYSBetalningssattUpdateAssociationValues {
  Bank_Ref?: string | null;
  Bank_Values?: TEDInputSYSBankUpdateValues | null;
  Likvidkonto_Ref?: string | null;
  Likvidkonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
}

/**
 * Nya värden vid ändring av inbetalningssätt
 */
export interface TEDInputSYSBetalningssattUpdateValues {
  id: string;
  _version: number;
  BETSATTKOD?: string | null;
  BENAMNING?: string | null;
  KONTOTYP?: TEDSYSBetalningssattKONTOTYPEnum | null;
  KONTONR?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  KATALOG?: string | null;
  EFAKTURA?: boolean | null;
  OCR_KONTROLL?: boolean | null;
  OCR_REFERENS_KONTROLL?: boolean | null;
  OCR_FAKTNR_KONTROLL?: boolean | null;
  IDKOD?: string | null;
  AKTIV?: boolean | null;
  MANUELL_KONTERING?: boolean | null;
  BANKAVTAL?: TEDSYSBetalningssattBANKAVTALEnum | null;
  PRIM_BETSATT?: boolean | null;
  EFAKTURA_KGF?: boolean | null;
  BANKKONTONR?: string | null;
  ISO_IBANBETSATT?: boolean | null;
  TILL_KIVRA?: boolean | null;
  TILL_KIVRA_KGF?: boolean | null;
  IBAN?: string | null;
  _Associations?: TEDInputSYSBetalningssattUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av betalningsvillkor
 */
export interface TEDInputSYSBetalningsvillkorAddAssociationValues {
  Kravrutin_Ref?: string | null;
  Kravrutin_Values?: TEDInputSYSKravrutinAddValues | null;
}

/**
 * Värden vid tillägg av betalningsvillkor
 */
export interface TEDInputSYSBetalningsvillkorAddValues {
  BETALNINGSVILLKORKOD: string;
  BENAMNING?: string | null;
  TEXT?: string | null;
  ANTALDAGAR?: number | null;
  FRILEVMANAD?: TEDSYSBetalningsvillkorFRILEVMANADEnum | null;
  ANTALRANTEDAGAR?: number | null;
  RANTEFAKTURERAS?: TEDSYSBetalningsvillkorRANTEFAKTURERASEnum | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  AGRESSO_KRAVKOD?: string | null;
  _Associations?: TEDInputSYSBetalningsvillkorAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av betalningsvillkor
 */
export interface TEDInputSYSBetalningsvillkorUpdateAssociationValues {
  Kravrutin_Ref?: string | null;
  Kravrutin_Values?: TEDInputSYSKravrutinUpdateValues | null;
}

/**
 * Nya värden vid ändring av betalningsvillkor
 */
export interface TEDInputSYSBetalningsvillkorUpdateValues {
  id: string;
  _version: number;
  BETALNINGSVILLKORKOD?: string | null;
  BENAMNING?: string | null;
  TEXT?: string | null;
  ANTALDAGAR?: number | null;
  FRILEVMANAD?: TEDSYSBetalningsvillkorFRILEVMANADEnum | null;
  ANTALRANTEDAGAR?: number | null;
  RANTEFAKTURERAS?: TEDSYSBetalningsvillkorRANTEFAKTURERASEnum | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  AGRESSO_KRAVKOD?: string | null;
  _Associations?: TEDInputSYSBetalningsvillkorUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av bokföringsperiod
 */
export interface TEDInputSYSBokfPeriodAddAssociationValues {
  Bokfar_Ref?: string | null;
  Bokfar_Values?: TEDInputSYSBokfarAddValues | null;
}

/**
 * Värden vid tillägg av bokföringsperiod
 */
export interface TEDInputSYSBokfPeriodAddValues {
  BENAMNING: string;
  FORKORTNING: string;
  FRAN_DATUM?: any | null;
  TILL_DATUM?: any | null;
  LAST?: TEDSYSBokfPeriodLASTEnum | null;
  BOKSLUTSPERIOD?: TEDSYSBokfPeriodBOKSLUTSPERIODEnum | null;
  LAST_DATUM?: any | null;
  _Associations?: TEDInputSYSBokfPeriodAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av bokföringsperiod
 */
export interface TEDInputSYSBokfPeriodDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av bokföringsperiod
 */
export interface TEDInputSYSBokfPeriodUpdateAssociationValues {
  Bokfar_Ref?: string | null;
  Bokfar_Values?: TEDInputSYSBokfarUpdateValues | null;
}

/**
 * Nya värden vid ändring av bokföringsperiod
 */
export interface TEDInputSYSBokfPeriodUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  FORKORTNING?: string | null;
  FRAN_DATUM?: any | null;
  TILL_DATUM?: any | null;
  LAST?: TEDSYSBokfPeriodLASTEnum | null;
  BOKSLUTSPERIOD?: TEDSYSBokfPeriodBOKSLUTSPERIODEnum | null;
  LAST_DATUM?: any | null;
  _Associations?: TEDInputSYSBokfPeriodUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av bokföringsår
 */
export interface TEDInputSYSBokfarAddAssociationValues {
  Valuta_Ref?: string | null;
  Valuta_Values?: TEDInputSYSValutaAddValues | null;
  Bokfperiod_Add_Values?: TEDInputSYSBokfPeriodAddValues[] | null;
}

/**
 * Värden vid tillägg av bokföringsår
 */
export interface TEDInputSYSBokfarAddValues {
  FRAN_DATUM?: any | null;
  TILL_DATUM?: any | null;
  LAST?: TEDSYSBokfarLASTEnum | null;
  IB_LAST?: TEDSYSBokfarIB_LASTEnum | null;
  AKTUELLT_ORGNR?: string | null;
  AKTUELLT_ORGNAMN?: string | null;
  EK_ARKIV_SKICKAT_STATUS?: TEDSYSBokfarEK_ARKIV_SKICKAT_STATUSEnum | null;
  EK_ARKIV_SKICKAT_DATUM?: any | null;
  EK_ARKIV_SKICKAT_TID?: any | null;
  EK_ARKIV_SKICKAT_STORLEK?: number | null;
  EK_ARKIV_SKICKAT_SPEC_VERSION?: string | null;
  EK_ARKIV_KVITTENS_STATUS?: TEDSYSBokfarEK_ARKIV_KVITTENS_STATUSEnum | null;
  EK_ARKIV_KVITTENS_DATUM?: any | null;
  EK_ARKIV_KVITTENS_STORLEK?: number | null;
  ANTAGEN_DATUM?: any | null;
  ANTAGEN_TEXT?: string | null;
  LAST_DATUM?: any | null;
  EK_ARKIV_SKAPAT_DATUM?: any | null;
  SKV_LAST?: boolean | null;
  SKV_LAST_DATUM?: any | null;
  _Associations: TEDInputSYSBokfarAddAssociationValues;
}

/**
 * Associerade värden vid ändring av bokföringsår
 */
export interface TEDInputSYSBokfarUpdateAssociationValues {
  Valuta_Ref?: string | null;
  Valuta_Values?: TEDInputSYSValutaUpdateValues | null;
  Bokfperiod_Add_Values?: TEDInputSYSBokfPeriodAddValues[] | null;
  Bokfperiod_Update_Values?: TEDInputSYSBokfPeriodUpdateValues[] | null;
  Bokfperiod_Delete_Values?: TEDInputSYSBokfPeriodDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av bokföringsår
 */
export interface TEDInputSYSBokfarUpdateValues {
  id: string;
  _version: number;
  FRAN_DATUM?: any | null;
  TILL_DATUM?: any | null;
  LAST?: TEDSYSBokfarLASTEnum | null;
  IB_LAST?: TEDSYSBokfarIB_LASTEnum | null;
  AKTUELLT_ORGNR?: string | null;
  AKTUELLT_ORGNAMN?: string | null;
  EK_ARKIV_SKICKAT_STATUS?: TEDSYSBokfarEK_ARKIV_SKICKAT_STATUSEnum | null;
  EK_ARKIV_SKICKAT_DATUM?: any | null;
  EK_ARKIV_SKICKAT_TID?: any | null;
  EK_ARKIV_SKICKAT_STORLEK?: number | null;
  EK_ARKIV_SKICKAT_SPEC_VERSION?: string | null;
  EK_ARKIV_KVITTENS_STATUS?: TEDSYSBokfarEK_ARKIV_KVITTENS_STATUSEnum | null;
  EK_ARKIV_KVITTENS_DATUM?: any | null;
  EK_ARKIV_KVITTENS_STORLEK?: number | null;
  ANTAGEN_DATUM?: any | null;
  ANTAGEN_TEXT?: string | null;
  LAST_DATUM?: any | null;
  EK_ARKIV_SKAPAT_DATUM?: any | null;
  SKV_LAST?: boolean | null;
  SKV_LAST_DATUM?: any | null;
  _Associations?: TEDInputSYSBokfarUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av bokföringsgrupptyp
 */
export interface TEDInputSYSBokfgrupptypAddValues {
  ID?: number | null;
  BENAMNING?: string | null;
  GILTIG_FOR_TYP: TEDSYSBokfgrupptypGILTIG_FOR_TYPEnum;
  DUPLIKATA_GRUPPER?: boolean | null;
}

/**
 * Nya värden vid ändring av bokföringsgrupptyp
 */
export interface TEDInputSYSBokfgrupptypUpdateValues {
  id: string;
  _version: number;
  ID?: number | null;
  BENAMNING?: string | null;
  GILTIG_FOR_TYP?: TEDSYSBokfgrupptypGILTIG_FOR_TYPEnum | null;
  DUPLIKATA_GRUPPER?: boolean | null;
}

/**
 * Associerade värden vid tillägg av bokningsgrupp
 */
export interface TEDInputSYSBokngruppAddAssociationValues {
  Intaktskonto_Ref?: string | null;
  Intaktskonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  BoknGruppResurs_Add_Refs?: string[] | null;
  Aktivitet_Add_Refs?: string[] | null;
  AktTypResrubrik_Add_Refs?: string[] | null;
  AkttypBoknGrupp_Add_Refs?: string[] | null;
  VerksamhetstypBoknGrupp_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av bokningsgrupp
 */
export interface TEDInputSYSBokngruppAddValues {
  BENAMNING?: string | null;
  SKK_ORG_ID?: number | null;
  SKK_ORG_WSSURL?: string | null;
  SMTP_INTERN?: string | null;
  SKK_REGION_ID?: number | null;
  SPARR_FR?: any | null;
  SPARR_TO?: any | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  _Associations?: TEDInputSYSBokngruppAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av bokningsgrupp
 */
export interface TEDInputSYSBokngruppUpdateAssociationValues {
  Intaktskonto_Ref?: string | null;
  Intaktskonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  BoknGruppResurs_Add_Refs?: string[] | null;
  BoknGruppResurs_Delete_Refs?: string[] | null;
  Aktivitet_Add_Refs?: string[] | null;
  Aktivitet_Delete_Refs?: string[] | null;
  AktTypResrubrik_Add_Refs?: string[] | null;
  AktTypResrubrik_Delete_Refs?: string[] | null;
  AkttypBoknGrupp_Add_Refs?: string[] | null;
  AkttypBoknGrupp_Delete_Refs?: string[] | null;
  VerksamhetstypBoknGrupp_Add_Refs?: string[] | null;
  VerksamhetstypBoknGrupp_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av bokningsgrupp
 */
export interface TEDInputSYSBokngruppUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  SKK_ORG_ID?: number | null;
  SKK_ORG_WSSURL?: string | null;
  SMTP_INTERN?: string | null;
  SKK_REGION_ID?: number | null;
  SPARR_FR?: any | null;
  SPARR_TO?: any | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  _Associations?: TEDInputSYSBokngruppUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av delsystemansvar
 */
export interface TEDInputSYSDelsystemansvarAddValues {
  dummy?: number | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av delsystemansvar
 */
export interface TEDInputSYSDelsystemansvarDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av delsystemansvar
 */
export interface TEDInputSYSDelsystemansvarUpdateValues {
  id: string;
  _version: number;
  dummy?: number | null;
}

/**
 * Värden vid tillägg av fakturaförmedlare
 */
export interface TEDInputSYSFakturaformedlareAddValues {
  BENAMNING: string;
  FAKTURERINGSSATT?: string | null;
  LEVERANSKATALOG?: string | null;
  KVITTENSKATALOG?: string | null;
  IDKOD?: string | null;
  AKTIV?: boolean | null;
  INFOTEXT?: string | null;
  ANVAND_EFAKT_FORETAG?: boolean | null;
  ANVAND_EFAKT_PRIV?: boolean | null;
  ANVAND_FAKTURERING?: boolean | null;
  EFAKT_PREFIX?: string | null;
  FTP_HOST?: string | null;
  FTP_USERNAME?: string | null;
  FTP_PASSWORD?: string | null;
  FTP_PORT?: number | null;
  FTP_DIRECTORY?: string | null;
  FAKTUTSTALLARE_BANK?: string | null;
  LOGOTYPE_ID?: string | null;
  EPOST_MEDDELANDE?: string | null;
}

/**
 * Nya värden vid ändring av fakturaförmedlare
 */
export interface TEDInputSYSFakturaformedlareUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  FAKTURERINGSSATT?: string | null;
  LEVERANSKATALOG?: string | null;
  KVITTENSKATALOG?: string | null;
  IDKOD?: string | null;
  AKTIV?: boolean | null;
  INFOTEXT?: string | null;
  ANVAND_EFAKT_FORETAG?: boolean | null;
  ANVAND_EFAKT_PRIV?: boolean | null;
  ANVAND_FAKTURERING?: boolean | null;
  EFAKT_PREFIX?: string | null;
  FTP_HOST?: string | null;
  FTP_USERNAME?: string | null;
  FTP_PASSWORD?: string | null;
  FTP_PORT?: number | null;
  FTP_DIRECTORY?: string | null;
  FAKTUTSTALLARE_BANK?: string | null;
  LOGOTYPE_ID?: string | null;
  EPOST_MEDDELANDE?: string | null;
}

/**
 * Associerade värden vid tillägg av fakturakod
 */
export interface TEDInputSYSFakturakodAddAssociationValues {
  LevKostKonto_Ref?: string | null;
  LevKostKonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
}

/**
 * Värden vid tillägg av fakturakod
 */
export interface TEDInputSYSFakturakodAddValues {
  KOD: string;
  BENAMNING: string;
  SOKTYP?: TEDSYSFakturakodSOKTYPEnum | null;
  _Associations?: TEDInputSYSFakturakodAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av fakturakod
 */
export interface TEDInputSYSFakturakodUpdateAssociationValues {
  LevKostKonto_Ref?: string | null;
  LevKostKonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
}

/**
 * Nya värden vid ändring av fakturakod
 */
export interface TEDInputSYSFakturakodUpdateValues {
  id: string;
  _version: number;
  KOD?: string | null;
  BENAMNING?: string | null;
  SOKTYP?: TEDSYSFakturakodSOKTYPEnum | null;
  _Associations?: TEDInputSYSFakturakodUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av fakturaradskod
 */
export interface TEDInputSYSFakturaradskodAddAssociationValues {
  LevKostKonto_Ref?: string | null;
  LevKostKonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
}

/**
 * Värden vid tillägg av fakturaradskod
 */
export interface TEDInputSYSFakturaradskodAddValues {
  KOD: string;
  BENAMNING: string;
  _Associations?: TEDInputSYSFakturaradskodAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av fakturaradskod
 */
export interface TEDInputSYSFakturaradskodUpdateAssociationValues {
  LevKostKonto_Ref?: string | null;
  LevKostKonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
}

/**
 * Nya värden vid ändring av fakturaradskod
 */
export interface TEDInputSYSFakturaradskodUpdateValues {
  id: string;
  _version: number;
  KOD?: string | null;
  BENAMNING?: string | null;
  _Associations?: TEDInputSYSFakturaradskodUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av frånvaro
 */
export interface TEDInputSYSFranvaroAddAssociationValues {
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
  Reserv_Ref?: string | null;
  Reserv_Values?: TEDInputSYSUserAddValues | null;
  AutoskapadFran_Ref?: string | null;
  AutoskapadFran_Values?: TEDInputSYSUserAddValues | null;
}

/**
 * Värden vid tillägg av frånvaro
 */
export interface TEDInputSYSFranvaroAddValues {
  USER_ID?: number | null;
  RESERV_ID?: number | null;
  DATUM_FROM?: any | null;
  DATUM_TOM?: any | null;
  NOTERING?: string | null;
  FOR_BOKFORDER?: boolean | null;
  FOR_UTANORDNING?: boolean | null;
  AUTOSKAPAD?: boolean | null;
  AUTOSKAPAD_USER_ID?: number | null;
  AUTOSKAPAD_LEVEL?: number | null;
  _Associations?: TEDInputSYSFranvaroAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av frånvaro
 */
export interface TEDInputSYSFranvaroDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av frånvaro
 */
export interface TEDInputSYSFranvaroUpdateAssociationValues {
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
  Reserv_Ref?: string | null;
  Reserv_Values?: TEDInputSYSUserUpdateValues | null;
  AutoskapadFran_Ref?: string | null;
  AutoskapadFran_Values?: TEDInputSYSUserUpdateValues | null;
}

/**
 * Nya värden vid ändring av frånvaro
 */
export interface TEDInputSYSFranvaroUpdateValues {
  id: string;
  _version: number;
  USER_ID?: number | null;
  RESERV_ID?: number | null;
  DATUM_FROM?: any | null;
  DATUM_TOM?: any | null;
  NOTERING?: string | null;
  FOR_BOKFORDER?: boolean | null;
  FOR_UTANORDNING?: boolean | null;
  AUTOSKAPAD?: boolean | null;
  AUTOSKAPAD_USER_ID?: number | null;
  AUTOSKAPAD_LEVEL?: number | null;
  _Associations?: TEDInputSYSFranvaroUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av bokföringsgrupp
 */
export interface TEDInputSYSGruppAddAssociationValues {
  Konteringsvarde_Ref?: string | null;
  Konteringsvarde_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Kostnadskonto_Ref?: string | null;
  Kostnadskonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Levskuldkonto_Ref?: string | null;
  Levskuldkonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  PrelkontoAR_Ref?: string | null;
  PrelkontoAR_Values?: TEDInputEKKonteringsvardeAddValues | null;
  IngaendeMomsKonto_Ref?: string | null;
  IngaendeMomsKonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  InterimskontoKostnad_Ref?: string | null;
  InterimskontoKostnad_Values?: TEDInputEKKonteringsvardeAddValues | null;
  UtgaendeMomsKonto_Ref?: string | null;
  UtgaendeMomsKonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  InterimsKontoIntakt_Ref?: string | null;
  InterimsKontoIntakt_Values?: TEDInputEKKonteringsvardeAddValues | null;
  ForeslKundkategori_Ref?: string | null;
  ForeslKundkategori_Values?: TEDInputKRKundkategoriAddValues | null;
  Intaktskonto_Ref?: string | null;
  Intaktskonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Kundfordrkonto_Ref?: string | null;
  Kundfordrkonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Oresavrundkonto_Ref?: string | null;
  Oresavrundkonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  AdminAvgiftKonto_Ref?: string | null;
  AdminAvgiftKonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Avrakningsartikel_Ref?: string | null;
  Avrakningsartikel_Values?: TEDInputLAArtikelAddValues | null;
  Avrundningsartikel_Ref?: string | null;
  Avrundningsartikel_Values?: TEDInputLAArtikelAddValues | null;
  AdminArtikel_Ref?: string | null;
  AdminArtikel_Values?: TEDInputLAArtikelAddValues | null;
  Betalningsvillkor_Ref?: string | null;
  Betalningsvillkor_Values?: TEDInputSYSBetalningsvillkorAddValues | null;
  KundkategoriFaktgrupp_Ref?: string | null;
  KundkategoriFaktgrupp_Values?: TEDInputKRKundkatFaktGruppAddValues | null;
  TillgodohGrupp_Ref?: string | null;
  TillgodohGrupp_Values?: TEDInputSYSGruppAddValues | null;
  RantefaktGrupp_Ref?: string | null;
  RantefaktGrupp_Values?: TEDInputSYSGruppAddValues | null;
  Drojsmalsavgift_Ref?: string | null;
  Drojsmalsavgift_Values?: TEDInputLAArtikelAddValues | null;
  Grupptyp_Ref?: string | null;
  Grupptyp_Values?: TEDInputSYSBokfgrupptypAddValues | null;
  Verifikationskategorier_Add_Values?: TEDInputSYSGruppVerkatAddValues[] | null;
  Attestgrupp_Add_Values?: TEDInputSYSGruppAttestgruppAddValues[] | null;
  Fakturalayoutgrupp_Add_Refs?: string[] | null;
  ArtikelgruppGrupp_Add_Values?: TEDInputLAArtGruppFaktgruppAddValues[] | null;
}

/**
 * Värden vid tillägg av bokföringsgrupp
 */
export interface TEDInputSYSGruppAddValues {
  _typ: TEDSYSGruppTypEnum;
  BENAMNING: string;
  SERIE_ID_1?: number | null;
  SERIE_ID_2?: number | null;
  SERIE_ID_3?: number | null;
  SERIE_ID_4?: number | null;
  SERIE_ID_5?: number | null;
  SERIE_ID_6?: number | null;
  SERIE_ID_7?: number | null;
  SERIE_ID_8?: number | null;
  SERIE_ID_9?: number | null;
  SERIE_ID_10?: number | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  INTEGRATIONSTYP?: TEDSYSGruppINTEGRATIONSTYPEnum | null;
  AVSANDARKOD_PG?: string | null;
  AVSLUTA_SKOTSEL?: string | null;
  ORDINARIE_DETALJNIVA?: TEDSYSGruppORDINARIE_DETALJNIVAEnum | null;
  ELEKTRONISK_ATTEST?: TEDSYSGruppELEKTRONISK_ATTESTEnum | null;
  ORDERTYP?: TEDSYSGruppORDERTYPEnum | null;
  FAKTURERINGSAVGIFT?: any | null;
  ADMINAVGIFT_PROC?: number | null;
  FAKTURATEXT?: string | null;
  AVR_METOD?: TEDSYSGruppAVR_METODEnum | null;
  SAMFAKTURERAS?: TEDSYSGruppSAMFAKTURERASEnum | null;
  FAKTURERINGSSATT?: TEDSYSGruppFAKTURERINGSSATTEnum | null;
  AVRUNDNINGSVILLKOR?: TEDSYSGruppAVRUNDNINGSVILLKOREnum | null;
  SKOTSEL?: TEDSYSGruppSKOTSELEnum | null;
  UTSKRIFT_ARBUND?: TEDSYSGruppUTSKRIFT_ARBUNDEnum | null;
  UTLADR?: TEDSYSGruppUTLADREnum | null;
  ERBJ_TILLGODO_FROM?: any | null;
  ERBJ_TILLGODO_TOM?: any | null;
  MANUELLT_FAKTURANR_ORDER?: TEDSYSGruppMANUELLT_FAKTURANR_ORDEREnum | null;
  RANTEFAKTURERAS?: boolean | null;
  AKTIV?: boolean | null;
  IDKOD?: string | null;
  AVSER_KGF?: boolean | null;
  AVITYP?: TEDSYSGruppAVITYPEnum | null;
  EXTRA_FAKTURARAD?: string | null;
  ANV_FOR_ATTESTORDER?: boolean | null;
  KOB_TILLAT_MOMS?: boolean | null;
  POSTTYP_FAKTURA?: TEDSYSGruppPOSTTYP_FAKTURAEnum | null;
  POSTTYP_PAMINNELSE?: TEDSYSGruppPOSTTYP_PAMINNELSEEnum | null;
  PERIODORDER?: boolean | null;
  PERIODORDER_UPPDATERA_PRISER?: boolean | null;
  _Associations?: TEDInputSYSGruppAddAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av godkänd attestgrupp
 */
export interface TEDInputSYSGruppAttestgruppAddAssociationValues {
  Attestgrupp_Ref?: string | null;
  Attestgrupp_Values?: TEDInputLRAttestGruppAddValues | null;
  Bokfgrupp_Ref?: string | null;
  Bokfgrupp_Values?: TEDInputSYSGruppAddValues | null;
}

/**
 * Värden vid tillägg av godkänd attestgrupp
 */
export interface TEDInputSYSGruppAttestgruppAddValues {
  _Associations: TEDInputSYSGruppAttestgruppAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av godkänd attestgrupp
 */
export interface TEDInputSYSGruppAttestgruppDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av godkänd attestgrupp
 */
export interface TEDInputSYSGruppAttestgruppUpdateAssociationValues {
  Attestgrupp_Ref?: string | null;
  Attestgrupp_Values?: TEDInputLRAttestGruppUpdateValues | null;
  Bokfgrupp_Ref?: string | null;
  Bokfgrupp_Values?: TEDInputSYSGruppUpdateValues | null;
}

/**
 * Nya värden vid ändring av godkänd attestgrupp
 */
export interface TEDInputSYSGruppAttestgruppUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputSYSGruppAttestgruppUpdateAssociationValues | null;
}

/**
 * Associerade värden vid ändring av bokföringsgrupp
 */
export interface TEDInputSYSGruppUpdateAssociationValues {
  Konteringsvarde_Ref?: string | null;
  Konteringsvarde_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Kostnadskonto_Ref?: string | null;
  Kostnadskonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Levskuldkonto_Ref?: string | null;
  Levskuldkonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  PrelkontoAR_Ref?: string | null;
  PrelkontoAR_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  IngaendeMomsKonto_Ref?: string | null;
  IngaendeMomsKonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  InterimskontoKostnad_Ref?: string | null;
  InterimskontoKostnad_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  UtgaendeMomsKonto_Ref?: string | null;
  UtgaendeMomsKonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  InterimsKontoIntakt_Ref?: string | null;
  InterimsKontoIntakt_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  ForeslKundkategori_Ref?: string | null;
  ForeslKundkategori_Values?: TEDInputKRKundkategoriUpdateValues | null;
  Intaktskonto_Ref?: string | null;
  Intaktskonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Kundfordrkonto_Ref?: string | null;
  Kundfordrkonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Oresavrundkonto_Ref?: string | null;
  Oresavrundkonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  AdminAvgiftKonto_Ref?: string | null;
  AdminAvgiftKonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Avrakningsartikel_Ref?: string | null;
  Avrakningsartikel_Values?: TEDInputLAArtikelUpdateValues | null;
  Avrundningsartikel_Ref?: string | null;
  Avrundningsartikel_Values?: TEDInputLAArtikelUpdateValues | null;
  AdminArtikel_Ref?: string | null;
  AdminArtikel_Values?: TEDInputLAArtikelUpdateValues | null;
  Betalningsvillkor_Ref?: string | null;
  Betalningsvillkor_Values?: TEDInputSYSBetalningsvillkorUpdateValues | null;
  KundkategoriFaktgrupp_Ref?: string | null;
  KundkategoriFaktgrupp_Values?: TEDInputKRKundkatFaktGruppUpdateValues | null;
  TillgodohGrupp_Ref?: string | null;
  TillgodohGrupp_Values?: TEDInputSYSGruppUpdateValues | null;
  RantefaktGrupp_Ref?: string | null;
  RantefaktGrupp_Values?: TEDInputSYSGruppUpdateValues | null;
  Drojsmalsavgift_Ref?: string | null;
  Drojsmalsavgift_Values?: TEDInputLAArtikelUpdateValues | null;
  Grupptyp_Ref?: string | null;
  Grupptyp_Values?: TEDInputSYSBokfgrupptypUpdateValues | null;
  Verifikationskategorier_Add_Values?: TEDInputSYSGruppVerkatAddValues[] | null;
  Verifikationskategorier_Update_Values?: TEDInputSYSGruppVerkatUpdateValues[] | null;
  Verifikationskategorier_Delete_Values?: TEDInputSYSGruppVerkatDeleteValues[] | null;
  Attestgrupp_Add_Values?: TEDInputSYSGruppAttestgruppAddValues[] | null;
  Attestgrupp_Update_Values?: TEDInputSYSGruppAttestgruppUpdateValues[] | null;
  Attestgrupp_Delete_Values?: TEDInputSYSGruppAttestgruppDeleteValues[] | null;
  Fakturalayoutgrupp_Add_Refs?: string[] | null;
  Fakturalayoutgrupp_Delete_Refs?: string[] | null;
  ArtikelgruppGrupp_Add_Values?: TEDInputLAArtGruppFaktgruppAddValues[] | null;
  ArtikelgruppGrupp_Update_Values?: TEDInputLAArtGruppFaktgruppUpdateValues[] | null;
  ArtikelgruppGrupp_Delete_Values?: TEDInputLAArtGruppFaktgruppDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av bokföringsgrupp
 */
export interface TEDInputSYSGruppUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  SERIE_ID_1?: number | null;
  SERIE_ID_2?: number | null;
  SERIE_ID_3?: number | null;
  SERIE_ID_4?: number | null;
  SERIE_ID_5?: number | null;
  SERIE_ID_6?: number | null;
  SERIE_ID_7?: number | null;
  SERIE_ID_8?: number | null;
  SERIE_ID_9?: number | null;
  SERIE_ID_10?: number | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  INTEGRATIONSTYP?: TEDSYSGruppINTEGRATIONSTYPEnum | null;
  AVSANDARKOD_PG?: string | null;
  AVSLUTA_SKOTSEL?: string | null;
  ORDINARIE_DETALJNIVA?: TEDSYSGruppORDINARIE_DETALJNIVAEnum | null;
  ELEKTRONISK_ATTEST?: TEDSYSGruppELEKTRONISK_ATTESTEnum | null;
  ORDERTYP?: TEDSYSGruppORDERTYPEnum | null;
  FAKTURERINGSAVGIFT?: any | null;
  ADMINAVGIFT_PROC?: number | null;
  FAKTURATEXT?: string | null;
  AVR_METOD?: TEDSYSGruppAVR_METODEnum | null;
  SAMFAKTURERAS?: TEDSYSGruppSAMFAKTURERASEnum | null;
  FAKTURERINGSSATT?: TEDSYSGruppFAKTURERINGSSATTEnum | null;
  AVRUNDNINGSVILLKOR?: TEDSYSGruppAVRUNDNINGSVILLKOREnum | null;
  SKOTSEL?: TEDSYSGruppSKOTSELEnum | null;
  UTSKRIFT_ARBUND?: TEDSYSGruppUTSKRIFT_ARBUNDEnum | null;
  UTLADR?: TEDSYSGruppUTLADREnum | null;
  ERBJ_TILLGODO_FROM?: any | null;
  ERBJ_TILLGODO_TOM?: any | null;
  MANUELLT_FAKTURANR_ORDER?: TEDSYSGruppMANUELLT_FAKTURANR_ORDEREnum | null;
  RANTEFAKTURERAS?: boolean | null;
  AKTIV?: boolean | null;
  IDKOD?: string | null;
  AVSER_KGF?: boolean | null;
  AVITYP?: TEDSYSGruppAVITYPEnum | null;
  EXTRA_FAKTURARAD?: string | null;
  ANV_FOR_ATTESTORDER?: boolean | null;
  KOB_TILLAT_MOMS?: boolean | null;
  POSTTYP_FAKTURA?: TEDSYSGruppPOSTTYP_FAKTURAEnum | null;
  POSTTYP_PAMINNELSE?: TEDSYSGruppPOSTTYP_PAMINNELSEEnum | null;
  PERIODORDER?: boolean | null;
  PERIODORDER_UPPDATERA_PRISER?: boolean | null;
  _Associations?: TEDInputSYSGruppUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av bokföringsgrupp, rutin
 */
export interface TEDInputSYSGruppVerkatAddAssociationValues {
  Bokforingsgrupp_Ref?: string | null;
  Bokforingsgrupp_Values?: TEDInputSYSGruppAddValues | null;
}

/**
 * Värden vid tillägg av bokföringsgrupp, rutin
 */
export interface TEDInputSYSGruppVerkatAddValues {
  JOURNALHANTERING?: TEDSYSGruppVerkatJOURNALHANTERINGEnum | null;
  SENAST_ANDRAD?: string | null;
  SENAST_ANDRAD_SIGNATUR?: string | null;
  _Associations: TEDInputSYSGruppVerkatAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av bokföringsgrupp, rutin
 */
export interface TEDInputSYSGruppVerkatDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av bokföringsgrupp, rutin
 */
export interface TEDInputSYSGruppVerkatUpdateAssociationValues {
  Bokforingsgrupp_Ref?: string | null;
  Bokforingsgrupp_Values?: TEDInputSYSGruppUpdateValues | null;
}

/**
 * Nya värden vid ändring av bokföringsgrupp, rutin
 */
export interface TEDInputSYSGruppVerkatUpdateValues {
  id: string;
  _version: number;
  JOURNALHANTERING?: TEDSYSGruppVerkatJOURNALHANTERINGEnum | null;
  SENAST_ANDRAD?: string | null;
  SENAST_ANDRAD_SIGNATUR?: string | null;
  _Associations?: TEDInputSYSGruppVerkatUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kOB-clearingartikel
 */
export interface TEDInputSYSKOBArtikelAddAssociationValues {
  LevKostKonto_Ref?: string | null;
  LevKostKonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Fakturaradskod_Ref?: string | null;
  Fakturaradskod_Values?: TEDInputSYSFakturaradskodAddValues | null;
  KOBPris_Add_Values?: TEDInputSYSKOBPriserAddValues[] | null;
}

/**
 * Värden vid tillägg av kOB-clearingartikel
 */
export interface TEDInputSYSKOBArtikelAddValues {
  ARTIKELNR: string;
  BENAMNING: string;
  FORRATTNINGSTYP: TEDSYSKOBArtikelFORRATTNINGSTYPEnum;
  INVOICEFAMILYKEY: number;
  INVOICETYPEKEY: number;
  ARTICLEKEY: number;
  KAN_ANDRA_PRIS?: boolean | null;
  KAN_ANDRA_ANTAL?: boolean | null;
  TYP: TEDSYSKOBArtikelTYPEnum;
  TOM_DATUM?: any | null;
  _Associations?: TEDInputSYSKOBArtikelAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av kOB-clearingartikel
 */
export interface TEDInputSYSKOBArtikelUpdateAssociationValues {
  LevKostKonto_Ref?: string | null;
  LevKostKonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Fakturaradskod_Ref?: string | null;
  Fakturaradskod_Values?: TEDInputSYSFakturaradskodUpdateValues | null;
  KOBPris_Add_Values?: TEDInputSYSKOBPriserAddValues[] | null;
  KOBPris_Update_Values?: TEDInputSYSKOBPriserUpdateValues[] | null;
  KOBPris_Delete_Values?: TEDInputSYSKOBPriserDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av kOB-clearingartikel
 */
export interface TEDInputSYSKOBArtikelUpdateValues {
  id: string;
  _version: number;
  ARTIKELNR?: string | null;
  BENAMNING?: string | null;
  FORRATTNINGSTYP?: TEDSYSKOBArtikelFORRATTNINGSTYPEnum | null;
  INVOICEFAMILYKEY?: number | null;
  INVOICETYPEKEY?: number | null;
  ARTICLEKEY?: number | null;
  KAN_ANDRA_PRIS?: boolean | null;
  KAN_ANDRA_ANTAL?: boolean | null;
  TYP?: TEDSYSKOBArtikelTYPEnum | null;
  TOM_DATUM?: any | null;
  _Associations?: TEDInputSYSKOBArtikelUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kOB Pris
 */
export interface TEDInputSYSKOBPriserAddAssociationValues {
  KOBArtikel_Ref?: string | null;
  KOBArtikel_Values?: TEDInputSYSKOBArtikelAddValues | null;
}

/**
 * Värden vid tillägg av kOB Pris
 */
export interface TEDInputSYSKOBPriserAddValues {
  LOPNR?: number | null;
  FRANDATUM?: any | null;
  PRIS?: any | null;
  _Associations?: TEDInputSYSKOBPriserAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kOB Pris
 */
export interface TEDInputSYSKOBPriserDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kOB Pris
 */
export interface TEDInputSYSKOBPriserUpdateAssociationValues {
  KOBArtikel_Ref?: string | null;
  KOBArtikel_Values?: TEDInputSYSKOBArtikelUpdateValues | null;
}

/**
 * Nya värden vid ändring av kOB Pris
 */
export interface TEDInputSYSKOBPriserUpdateValues {
  id: string;
  _version: number;
  LOPNR?: number | null;
  FRANDATUM?: any | null;
  PRIS?: any | null;
  _Associations?: TEDInputSYSKOBPriserUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av konteringskod
 */
export interface TEDInputSYSKonteringskodAddValues {
  KOD?: string | null;
  BENAMNING?: string | null;
}

/**
 * Nya värden vid ändring av konteringskod
 */
export interface TEDInputSYSKonteringskodUpdateValues {
  id: string;
  _version: number;
  KOD?: string | null;
  BENAMNING?: string | null;
}

/**
 * Associerade värden vid tillägg av kravtext
 */
export interface TEDInputSYSKravTextAddAssociationValues {
  Sprak_Ref?: string | null;
  Sprak_Values?: TEDInputSYSSprakAddValues | null;
  Kravrutin_Ref?: string | null;
  Kravrutin_Values?: TEDInputSYSKravrutinAddValues | null;
}

/**
 * Värden vid tillägg av kravtext
 */
export interface TEDInputSYSKravTextAddValues {
  KRAVTEXT: string;
  INKASSOLISTA: TEDSYSKravTextINKASSOLISTAEnum;
  _Associations: TEDInputSYSKravTextAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kravtext
 */
export interface TEDInputSYSKravTextDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kravtext
 */
export interface TEDInputSYSKravTextUpdateAssociationValues {
  Sprak_Ref?: string | null;
  Sprak_Values?: TEDInputSYSSprakUpdateValues | null;
  Kravrutin_Ref?: string | null;
  Kravrutin_Values?: TEDInputSYSKravrutinUpdateValues | null;
}

/**
 * Nya värden vid ändring av kravtext
 */
export interface TEDInputSYSKravTextUpdateValues {
  id: string;
  _version: number;
  KRAVTEXT?: string | null;
  INKASSOLISTA?: TEDSYSKravTextINKASSOLISTAEnum | null;
  _Associations?: TEDInputSYSKravTextUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kravrutin
 */
export interface TEDInputSYSKravrutinAddAssociationValues {
  Drojsmalsranta_Ref?: string | null;
  Drojsmalsranta_Values?: TEDInputSYSRanteTabellAddValues | null;
  Drojsmalintaktkonto_Ref?: string | null;
  Drojsmalintaktkonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Kravtext_Add_Values?: TEDInputSYSKravTextAddValues[] | null;
  Betalningsvillkor_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av kravrutin
 */
export interface TEDInputSYSKravrutinAddValues {
  BENAMNING: string;
  REPETERASISTAKRAV?: TEDSYSKravrutinREPETERASISTAKRAVEnum | null;
  DAGARMELLANKRAV?: number | null;
  ANTAL_RANTEFRIA_DAGAR?: number | null;
  FAKTURERA_DROJSMALSRANTA?: boolean | null;
  MINSTA_RANTERADBELOPP?: any | null;
  MINSTA_RANTEFAKTBELOPP?: any | null;
  FAKTURERA_PAMINNELSEAVGIFT?: boolean | null;
  PAMINNELSEAVGIFT?: any | null;
  RANTEFAKTURA_TEXT?: string | null;
  FRAN_BETDATUM?: any | null;
  MIN_ANTAL_FORSDAGAR?: number | null;
  AVG_PER_PAMINNELSE?: boolean | null;
  MAX_ANTAL_PAMINNELSE?: number | null;
  IDKOD?: string | null;
  AGRESSO_KRAVKOD?: string | null;
  _Associations?: TEDInputSYSKravrutinAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av kravrutin
 */
export interface TEDInputSYSKravrutinUpdateAssociationValues {
  Drojsmalsranta_Ref?: string | null;
  Drojsmalsranta_Values?: TEDInputSYSRanteTabellUpdateValues | null;
  Drojsmalintaktkonto_Ref?: string | null;
  Drojsmalintaktkonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Kravtext_Add_Values?: TEDInputSYSKravTextAddValues[] | null;
  Kravtext_Update_Values?: TEDInputSYSKravTextUpdateValues[] | null;
  Kravtext_Delete_Values?: TEDInputSYSKravTextDeleteValues[] | null;
  Betalningsvillkor_Add_Refs?: string[] | null;
  Betalningsvillkor_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av kravrutin
 */
export interface TEDInputSYSKravrutinUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  REPETERASISTAKRAV?: TEDSYSKravrutinREPETERASISTAKRAVEnum | null;
  DAGARMELLANKRAV?: number | null;
  ANTAL_RANTEFRIA_DAGAR?: number | null;
  FAKTURERA_DROJSMALSRANTA?: boolean | null;
  MINSTA_RANTERADBELOPP?: any | null;
  MINSTA_RANTEFAKTBELOPP?: any | null;
  FAKTURERA_PAMINNELSEAVGIFT?: boolean | null;
  PAMINNELSEAVGIFT?: any | null;
  RANTEFAKTURA_TEXT?: string | null;
  FRAN_BETDATUM?: any | null;
  MIN_ANTAL_FORSDAGAR?: number | null;
  AVG_PER_PAMINNELSE?: boolean | null;
  MAX_ANTAL_PAMINNELSE?: number | null;
  IDKOD?: string | null;
  AGRESSO_KRAVKOD?: string | null;
  _Associations?: TEDInputSYSKravrutinUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av kurs
 */
export interface TEDInputSYSKursAddAssociationValues {
  Valuta_Ref?: string | null;
  Valuta_Values?: TEDInputSYSValutaAddValues | null;
}

/**
 * Värden vid tillägg av kurs
 */
export interface TEDInputSYSKursAddValues {
  TOM_DATUM?: any | null;
  KOPKURS?: number | null;
  SALJKURS?: number | null;
  _Associations: TEDInputSYSKursAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av kurs
 */
export interface TEDInputSYSKursDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av kurs
 */
export interface TEDInputSYSKursUpdateAssociationValues {
  Valuta_Ref?: string | null;
  Valuta_Values?: TEDInputSYSValutaUpdateValues | null;
}

/**
 * Nya värden vid ändring av kurs
 */
export interface TEDInputSYSKursUpdateValues {
  id: string;
  _version: number;
  TOM_DATUM?: any | null;
  KOPKURS?: number | null;
  SALJKURS?: number | null;
  _Associations?: TEDInputSYSKursUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av land
 */
export interface TEDInputSYSLandAddAssociationValues {
  Valuta_Ref?: string | null;
  Valuta_Values?: TEDInputSYSValutaAddValues | null;
  Sprak_Ref?: string | null;
  Sprak_Values?: TEDInputSYSSprakAddValues | null;
}

/**
 * Värden vid tillägg av land
 */
export interface TEDInputSYSLandAddValues {
  LANDKOD: string;
  BENAMNING: string;
  _Associations?: TEDInputSYSLandAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av land
 */
export interface TEDInputSYSLandUpdateAssociationValues {
  Valuta_Ref?: string | null;
  Valuta_Values?: TEDInputSYSValutaUpdateValues | null;
  Sprak_Ref?: string | null;
  Sprak_Values?: TEDInputSYSSprakUpdateValues | null;
}

/**
 * Nya värden vid ändring av land
 */
export interface TEDInputSYSLandUpdateValues {
  id: string;
  _version: number;
  LANDKOD?: string | null;
  BENAMNING?: string | null;
  _Associations?: TEDInputSYSLandUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av leveransvillkor
 */
export interface TEDInputSYSLeveransvillkorAddValues {
  LEVVILLKORKOD: string;
  BENAMNING?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
}

/**
 * Nya värden vid ändring av leveransvillkor
 */
export interface TEDInputSYSLeveransvillkorUpdateValues {
  id: string;
  _version: number;
  LEVVILLKORKOD?: string | null;
  BENAMNING?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
}

/**
 * Värden vid tillägg av losenordshistorik
 */
export interface TEDInputSYSLosenordshistorikAddValues {
  OLD_PWD: string;
  PWD_METHOD?: number | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av losenordshistorik
 */
export interface TEDInputSYSLosenordshistorikDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av losenordshistorik
 */
export interface TEDInputSYSLosenordshistorikUpdateValues {
  id: string;
  _version: number;
  OLD_PWD?: string | null;
  PWD_METHOD?: number | null;
}

/**
 * Värden vid tillägg av lösenordskrav
 */
export interface TEDInputSYSLosenordskravAddValues {
  PWD_CONSTR_ORDER: number;
  NAME: string;
  IS_DEFAULT_LEVEL?: TEDSYSLosenordskravIS_DEFAULT_LEVELEnum | null;
  REQ_LOWERCASE?: boolean | null;
  REQ_UPPERCASE?: boolean | null;
  REQ_DIGITS?: boolean | null;
  REQ_SPEC_CHAR?: boolean | null;
  MIN_PWD_LENGTH?: number | null;
  MAX_PWD_LENGTH?: number | null;
  NR_SAVED_HASHES?: number | null;
  CHECK_FORBIDDEN_WORDS?: boolean | null;
  ANSI_ONLY?: boolean | null;
  PWD_EXPIRE_TIME: number;
  PWD_MIN_CHANGE_INTERVAL?: number | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av lösenordskrav
 */
export interface TEDInputSYSLosenordskravDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av lösenordskrav
 */
export interface TEDInputSYSLosenordskravUpdateValues {
  id: string;
  _version: number;
  PWD_CONSTR_ORDER?: number | null;
  NAME?: string | null;
  IS_DEFAULT_LEVEL?: TEDSYSLosenordskravIS_DEFAULT_LEVELEnum | null;
  REQ_LOWERCASE?: boolean | null;
  REQ_UPPERCASE?: boolean | null;
  REQ_DIGITS?: boolean | null;
  REQ_SPEC_CHAR?: boolean | null;
  MIN_PWD_LENGTH?: number | null;
  MAX_PWD_LENGTH?: number | null;
  NR_SAVED_HASHES?: number | null;
  CHECK_FORBIDDEN_WORDS?: boolean | null;
  ANSI_ONLY?: boolean | null;
  PWD_EXPIRE_TIME?: number | null;
  PWD_MIN_CHANGE_INTERVAL?: number | null;
}

/**
 * Associerade värden vid tillägg av gBS-rollens grupptyper
 */
export interface TEDInputSYSMalluserGrupptypAddAssociationValues {
  Grupptyp_Ref?: string | null;
  Grupptyp_Values?: TEDInputSYSBokfgrupptypAddValues | null;
}

/**
 * Värden vid tillägg av gBS-rollens grupptyper
 */
export interface TEDInputSYSMalluserGrupptypAddValues {
  LOPNR?: number | null;
  _Associations?: TEDInputSYSMalluserGrupptypAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av gBS-rollens grupptyper
 */
export interface TEDInputSYSMalluserGrupptypDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av gBS-rollens grupptyper
 */
export interface TEDInputSYSMalluserGrupptypUpdateAssociationValues {
  Grupptyp_Ref?: string | null;
  Grupptyp_Values?: TEDInputSYSBokfgrupptypUpdateValues | null;
}

/**
 * Nya värden vid ändring av gBS-rollens grupptyper
 */
export interface TEDInputSYSMalluserGrupptypUpdateValues {
  id: string;
  _version: number;
  LOPNR?: number | null;
  _Associations?: TEDInputSYSMalluserGrupptypUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av moms
 */
export interface TEDInputSYSMomsAddAssociationValues {
  IngaendeMomsKonto_Ref?: string | null;
  IngaendeMomsKonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  UtgaendeMomsKonto_Ref?: string | null;
  UtgaendeMomsKonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
}

/**
 * Värden vid tillägg av moms
 */
export interface TEDInputSYSMomsAddValues {
  MOMSKOD?: string | null;
  BENAMNING: string;
  MOMS_SATS1?: number | null;
  MOMS_SATS2?: number | null;
  DATUMMOMSBYTE?: any | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  AGRESSO_MOMSKOD?: string | null;
  _Associations?: TEDInputSYSMomsAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av moms
 */
export interface TEDInputSYSMomsUpdateAssociationValues {
  IngaendeMomsKonto_Ref?: string | null;
  IngaendeMomsKonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  UtgaendeMomsKonto_Ref?: string | null;
  UtgaendeMomsKonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
}

/**
 * Nya värden vid ändring av moms
 */
export interface TEDInputSYSMomsUpdateValues {
  id: string;
  _version: number;
  MOMSKOD?: string | null;
  BENAMNING?: string | null;
  MOMS_SATS1?: number | null;
  MOMS_SATS2?: number | null;
  DATUMMOMSBYTE?: any | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  AGRESSO_MOMSKOD?: string | null;
  _Associations?: TEDInputSYSMomsUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av nummer
 */
export interface TEDInputSYSNummerAddAssociationValues {
  Nummerserie_Ref?: string | null;
  Nummerserie_Values?: TEDInputSYSNummerserieAddValues | null;
}

/**
 * Värden vid tillägg av nummer
 */
export interface TEDInputSYSNummerAddValues {
  MINVALUE?: number | null;
  LENGTHVALUE?: number | null;
  MAXVALUE?: number | null;
  NEXTVALUE?: number | null;
  LAST?: TEDSYSNummerLASTEnum | null;
  _Associations?: TEDInputSYSNummerAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av nummer
 */
export interface TEDInputSYSNummerDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av nummer
 */
export interface TEDInputSYSNummerUpdateAssociationValues {
  Nummerserie_Ref?: string | null;
  Nummerserie_Values?: TEDInputSYSNummerserieUpdateValues | null;
}

/**
 * Nya värden vid ändring av nummer
 */
export interface TEDInputSYSNummerUpdateValues {
  id: string;
  _version: number;
  MINVALUE?: number | null;
  LENGTHVALUE?: number | null;
  MAXVALUE?: number | null;
  NEXTVALUE?: number | null;
  LAST?: TEDSYSNummerLASTEnum | null;
  _Associations?: TEDInputSYSNummerUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av nummerserie
 */
export interface TEDInputSYSNummerserieAddAssociationValues {
  Serietyp_Ref?: string | null;
  Serietyp_Values?: TEDInputSYSSerietypAddValues | null;
  Nummer_Add_Values?: TEDInputSYSNummerAddValues[] | null;
}

/**
 * Värden vid tillägg av nummerserie
 */
export interface TEDInputSYSNummerserieAddValues {
  _typ: TEDSYSNummerserieTypEnum;
  BENAMNING?: string | null;
  PREFIX?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  IDKOD?: string | null;
  _Associations?: TEDInputSYSNummerserieAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av nummerserie
 */
export interface TEDInputSYSNummerserieDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av nummerserie
 */
export interface TEDInputSYSNummerserieUpdateAssociationValues {
  Serietyp_Ref?: string | null;
  Serietyp_Values?: TEDInputSYSSerietypUpdateValues | null;
  Nummer_Add_Values?: TEDInputSYSNummerAddValues[] | null;
  Nummer_Update_Values?: TEDInputSYSNummerUpdateValues[] | null;
  Nummer_Delete_Values?: TEDInputSYSNummerDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av nummerserie
 */
export interface TEDInputSYSNummerserieUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  PREFIX?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  IDKOD?: string | null;
  _Associations?: TEDInputSYSNummerserieUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av ordermottagningsväg
 */
export interface TEDInputSYSOrdermottagningsvagAddAssociationValues {
  Kundkategori_Ref?: string | null;
  Kundkategori_Values?: TEDInputKRKundkategoriAddValues | null;
  Faktureringsgrupper_Add_Values?: TEDInputSYSOrdmovagFaktgruppAddValues[] | null;
}

/**
 * Värden vid tillägg av ordermottagningsväg
 */
export interface TEDInputSYSOrdermottagningsvagAddValues {
  BENAMNING?: string | null;
  IMPORTTYP: TEDSYSOrdermottagningsvagIMPORTTYPEnum;
  AKTIV?: boolean | null;
  IMPORTKATALOG?: string | null;
  XSL?: string | null;
  BOKF_GRUPP_ID?: number | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  ARTIKEL_ID?: number | null;
  KVITTENSKATALOG?: string | null;
  BETALNINGSKATALOG?: string | null;
  IDKOD?: string | null;
  FORSYSTEM_TYP?: TEDSYSOrdermottagningsvagFORSYSTEM_TYPEnum | null;
  SKICKA_KVITTENSER?: boolean | null;
  SKICKA_BETALINFO?: boolean | null;
  KLARMARKERA_INNAN_FAKT?: boolean | null;
  _Associations: TEDInputSYSOrdermottagningsvagAddAssociationValues;
}

/**
 * Associerade värden vid ändring av ordermottagningsväg
 */
export interface TEDInputSYSOrdermottagningsvagUpdateAssociationValues {
  Kundkategori_Ref?: string | null;
  Kundkategori_Values?: TEDInputKRKundkategoriUpdateValues | null;
  Faktureringsgrupper_Add_Values?: TEDInputSYSOrdmovagFaktgruppAddValues[] | null;
  Faktureringsgrupper_Update_Values?: TEDInputSYSOrdmovagFaktgruppUpdateValues[] | null;
  Faktureringsgrupper_Delete_Values?: TEDInputSYSOrdmovagFaktgruppDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av ordermottagningsväg
 */
export interface TEDInputSYSOrdermottagningsvagUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  IMPORTTYP?: TEDSYSOrdermottagningsvagIMPORTTYPEnum | null;
  AKTIV?: boolean | null;
  IMPORTKATALOG?: string | null;
  XSL?: string | null;
  BOKF_GRUPP_ID?: number | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  ARTIKEL_ID?: number | null;
  KVITTENSKATALOG?: string | null;
  BETALNINGSKATALOG?: string | null;
  IDKOD?: string | null;
  FORSYSTEM_TYP?: TEDSYSOrdermottagningsvagFORSYSTEM_TYPEnum | null;
  SKICKA_KVITTENSER?: boolean | null;
  SKICKA_BETALINFO?: boolean | null;
  KLARMARKERA_INNAN_FAKT?: boolean | null;
  _Associations?: TEDInputSYSOrdermottagningsvagUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av ordermottagningsvägars faktureringsgrupp
 */
export interface TEDInputSYSOrdmovagFaktgruppAddAssociationValues {
  Faktureringsgrupp_Ref?: string | null;
  Faktureringsgrupp_Values?: TEDInputSYSGruppAddValues | null;
  Ordermottagninsgvag_Ref?: string | null;
  Ordermottagninsgvag_Values?: TEDInputSYSOrdermottagningsvagAddValues | null;
}

/**
 * Värden vid tillägg av ordermottagningsvägars faktureringsgrupp
 */
export interface TEDInputSYSOrdmovagFaktgruppAddValues {
  _Associations: TEDInputSYSOrdmovagFaktgruppAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av ordermottagningsvägars faktureringsgrupp
 */
export interface TEDInputSYSOrdmovagFaktgruppDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av ordermottagningsvägars faktureringsgrupp
 */
export interface TEDInputSYSOrdmovagFaktgruppUpdateAssociationValues {
  Faktureringsgrupp_Ref?: string | null;
  Faktureringsgrupp_Values?: TEDInputSYSGruppUpdateValues | null;
  Ordermottagninsgvag_Ref?: string | null;
  Ordermottagninsgvag_Values?: TEDInputSYSOrdermottagningsvagUpdateValues | null;
}

/**
 * Nya värden vid ändring av ordermottagningsvägars faktureringsgrupp
 */
export interface TEDInputSYSOrdmovagFaktgruppUpdateValues {
  id: string;
  _version: number;
  _Associations?: TEDInputSYSOrdmovagFaktgruppUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av personkategori
 */
export interface TEDInputSYSPersonkategoriAddAssociationValues {
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
  Adressanvandningar_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av personkategori
 */
export interface TEDInputSYSPersonkategoriAddValues {
  BENAMNING?: string | null;
  SUBSYSTEM?: string | null;
  GALLRING_AKTIV?: boolean | null;
  GALLRING_AKTIVERAD_DATUM?: any | null;
  PERS_SYFTE_KALLA?: TEDSYSPersonkategoriPERS_SYFTE_KALLAEnum | null;
  PERS_SYFTE_KUNDSVAR?: string | null;
  PERS_PERSONUPPGIFTER_KALLA?: TEDSYSPersonkategoriPERS_PERSONUPPGIFTER_KALLAEnum | null;
  PERS_PERSONUPPGIFTER_KUNDSVAR?: string | null;
  PERS_KANSLIGA_UPPGIFTER_JA_NEJ_KALLA?: TEDSYSPersonkategoriPERS_KANSLIGA_UPPGIFTER_JA_NEJ_KALLAEnum | null;
  PERS_KANSLIGA_UPPGIFTER_JA_NEJ_KUNDSVAR?: string | null;
  PERS_KANSLIGA_UPPGIFTER_KALLA?: TEDSYSPersonkategoriPERS_KANSLIGA_UPPGIFTER_KALLAEnum | null;
  PERS_KANSLIGA_UPPGIFTER_KUNDSVAR?: string | null;
  PERS_INHAMNTNING_REG_KALLA?: TEDSYSPersonkategoriPERS_INHAMNTNING_REG_KALLAEnum | null;
  PERS_INHAMNTNING_REG_KUNDSVAR?: string | null;
  PERS_INHAMNTNING_EJ_REG_KALLA?: TEDSYSPersonkategoriPERS_INHAMNTNING_EJ_REG_KALLAEnum | null;
  PERS_INHAMNTNING_EJ_REG_KUNDSVAR?: string | null;
  PERS_ANDAMAL_KALLA?: TEDSYSPersonkategoriPERS_ANDAMAL_KALLAEnum | null;
  PERS_ANDAMAL_KUNDSVAR?: string | null;
  PERS_EJ_ANDAMAL_KALLA?: TEDSYSPersonkategoriPERS_EJ_ANDAMAL_KALLAEnum | null;
  PERS_EJ_ANDAMAL_KUNDSVAR?: string | null;
  PERS_LAGLIG_GRUND_KALLA?: TEDSYSPersonkategoriPERS_LAGLIG_GRUND_KALLAEnum | null;
  PERS_LAGLIG_GRUND_KUNDSVAR?: string | null;
  PERS_EJ_LAGLIG_GRUND_KALLA?: TEDSYSPersonkategoriPERS_EJ_LAGLIG_GRUND_KALLAEnum | null;
  PERS_EJ_LAGLIG_GRUND_KUNDSVAR?: string | null;
  PERS_UTLAMNING_KALLA?: TEDSYSPersonkategoriPERS_UTLAMNING_KALLAEnum | null;
  PERS_UTLAMNING_KUNDSVAR?: string | null;
  PERS_UTLAMNING_PLANERING_KALLA?: TEDSYSPersonkategoriPERS_UTLAMNING_PLANERING_KALLAEnum | null;
  PERS_UTLAMNING_PLANERING_KUNDSVAR?: string | null;
  PERS_FRITEXTFALT_KALLA?: TEDSYSPersonkategoriPERS_FRITEXTFALT_KALLAEnum | null;
  PERS_FRITEXTFALT_KUNDSVAR?: string | null;
  PERS_FRITEXTFALT_SYFTE_KALLA?: TEDSYSPersonkategoriPERS_FRITEXTFALT_SYFTE_KALLAEnum | null;
  PERS_FRITEXTFALT_SYFTE_KUNDSVAR?: string | null;
  PERS_GALLRING_AUTOMATIK_KALLA?: TEDSYSPersonkategoriPERS_GALLRING_AUTOMATIK_KALLAEnum | null;
  PERS_GALLRING_AUTOMATIK_KUNDSVAR?: string | null;
  PERS_GALLRING_MANUELLT_KALLA?: TEDSYSPersonkategoriPERS_GALLRING_MANUELLT_KALLAEnum | null;
  PERS_GALLRING_MANUELLT_KUNDSVAR?: string | null;
  PERS_GALLRING_BESLUT_KALLA?: TEDSYSPersonkategoriPERS_GALLRING_BESLUT_KALLAEnum | null;
  PERS_GALLRING_BESLUT_KUNDSVAR?: string | null;
  STATUS?: TEDSYSPersonkategoriSTATUSEnum | null;
  GALLRING_ENABLED?: boolean | null;
  HANTERAS_ENL_STANDARD?: string | null;
  GALLRING_PASLAGEN?: boolean | null;
  PERS_SYFTE_VERDATUM?: any | null;
  PERS_PERSONUPPGIFTER_VERDATUM?: any | null;
  PERS_KANSLIGA_UPPGIFTER_JA_NEJ_VERDATUM?: any | null;
  PERS_KANSLIGA_UPPGIFTER_VERDATUM?: any | null;
  PERS_INHAMNTNING_REG_VERDATUM?: any | null;
  PERS_INHAMNTNING_EJ_REG_VERDATUM?: any | null;
  PERS_ANDAMAL_VERDATUM?: any | null;
  PERS_EJ_ANDAMAL_VERDATUM?: any | null;
  PERS_LAGLIG_GRUND_VERDATUM?: any | null;
  PERS_EJ_LAGLIG_GRUND_VERDATUM?: any | null;
  PERS_UTLAMNING_VERDATUM?: any | null;
  PERS_UTLAMNING_PLANERING_VERDATUM?: any | null;
  PERS_FRITEXTFALT_VERDATUM?: any | null;
  PERS_FRITEXTFALT_SYFTE_VERDATUM?: any | null;
  PERS_GALLRING_AUTOMATIK_VERDATUM?: any | null;
  PERS_GALLRING_MANUELLT_VERDATUM?: any | null;
  PERS_GALLRING_BESLUT_VERDATUM?: any | null;
  AKTIV?: boolean | null;
  _Associations?: TEDInputSYSPersonkategoriAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av personkategori
 */
export interface TEDInputSYSPersonkategoriUpdateAssociationValues {
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
  Adressanvandningar_Add_Refs?: string[] | null;
  Adressanvandningar_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av personkategori
 */
export interface TEDInputSYSPersonkategoriUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  SUBSYSTEM?: string | null;
  GALLRING_AKTIV?: boolean | null;
  GALLRING_AKTIVERAD_DATUM?: any | null;
  PERS_SYFTE_KALLA?: TEDSYSPersonkategoriPERS_SYFTE_KALLAEnum | null;
  PERS_SYFTE_KUNDSVAR?: string | null;
  PERS_PERSONUPPGIFTER_KALLA?: TEDSYSPersonkategoriPERS_PERSONUPPGIFTER_KALLAEnum | null;
  PERS_PERSONUPPGIFTER_KUNDSVAR?: string | null;
  PERS_KANSLIGA_UPPGIFTER_JA_NEJ_KALLA?: TEDSYSPersonkategoriPERS_KANSLIGA_UPPGIFTER_JA_NEJ_KALLAEnum | null;
  PERS_KANSLIGA_UPPGIFTER_JA_NEJ_KUNDSVAR?: string | null;
  PERS_KANSLIGA_UPPGIFTER_KALLA?: TEDSYSPersonkategoriPERS_KANSLIGA_UPPGIFTER_KALLAEnum | null;
  PERS_KANSLIGA_UPPGIFTER_KUNDSVAR?: string | null;
  PERS_INHAMNTNING_REG_KALLA?: TEDSYSPersonkategoriPERS_INHAMNTNING_REG_KALLAEnum | null;
  PERS_INHAMNTNING_REG_KUNDSVAR?: string | null;
  PERS_INHAMNTNING_EJ_REG_KALLA?: TEDSYSPersonkategoriPERS_INHAMNTNING_EJ_REG_KALLAEnum | null;
  PERS_INHAMNTNING_EJ_REG_KUNDSVAR?: string | null;
  PERS_ANDAMAL_KALLA?: TEDSYSPersonkategoriPERS_ANDAMAL_KALLAEnum | null;
  PERS_ANDAMAL_KUNDSVAR?: string | null;
  PERS_EJ_ANDAMAL_KALLA?: TEDSYSPersonkategoriPERS_EJ_ANDAMAL_KALLAEnum | null;
  PERS_EJ_ANDAMAL_KUNDSVAR?: string | null;
  PERS_LAGLIG_GRUND_KALLA?: TEDSYSPersonkategoriPERS_LAGLIG_GRUND_KALLAEnum | null;
  PERS_LAGLIG_GRUND_KUNDSVAR?: string | null;
  PERS_EJ_LAGLIG_GRUND_KALLA?: TEDSYSPersonkategoriPERS_EJ_LAGLIG_GRUND_KALLAEnum | null;
  PERS_EJ_LAGLIG_GRUND_KUNDSVAR?: string | null;
  PERS_UTLAMNING_KALLA?: TEDSYSPersonkategoriPERS_UTLAMNING_KALLAEnum | null;
  PERS_UTLAMNING_KUNDSVAR?: string | null;
  PERS_UTLAMNING_PLANERING_KALLA?: TEDSYSPersonkategoriPERS_UTLAMNING_PLANERING_KALLAEnum | null;
  PERS_UTLAMNING_PLANERING_KUNDSVAR?: string | null;
  PERS_FRITEXTFALT_KALLA?: TEDSYSPersonkategoriPERS_FRITEXTFALT_KALLAEnum | null;
  PERS_FRITEXTFALT_KUNDSVAR?: string | null;
  PERS_FRITEXTFALT_SYFTE_KALLA?: TEDSYSPersonkategoriPERS_FRITEXTFALT_SYFTE_KALLAEnum | null;
  PERS_FRITEXTFALT_SYFTE_KUNDSVAR?: string | null;
  PERS_GALLRING_AUTOMATIK_KALLA?: TEDSYSPersonkategoriPERS_GALLRING_AUTOMATIK_KALLAEnum | null;
  PERS_GALLRING_AUTOMATIK_KUNDSVAR?: string | null;
  PERS_GALLRING_MANUELLT_KALLA?: TEDSYSPersonkategoriPERS_GALLRING_MANUELLT_KALLAEnum | null;
  PERS_GALLRING_MANUELLT_KUNDSVAR?: string | null;
  PERS_GALLRING_BESLUT_KALLA?: TEDSYSPersonkategoriPERS_GALLRING_BESLUT_KALLAEnum | null;
  PERS_GALLRING_BESLUT_KUNDSVAR?: string | null;
  STATUS?: TEDSYSPersonkategoriSTATUSEnum | null;
  GALLRING_ENABLED?: boolean | null;
  HANTERAS_ENL_STANDARD?: string | null;
  GALLRING_PASLAGEN?: boolean | null;
  PERS_SYFTE_VERDATUM?: any | null;
  PERS_PERSONUPPGIFTER_VERDATUM?: any | null;
  PERS_KANSLIGA_UPPGIFTER_JA_NEJ_VERDATUM?: any | null;
  PERS_KANSLIGA_UPPGIFTER_VERDATUM?: any | null;
  PERS_INHAMNTNING_REG_VERDATUM?: any | null;
  PERS_INHAMNTNING_EJ_REG_VERDATUM?: any | null;
  PERS_ANDAMAL_VERDATUM?: any | null;
  PERS_EJ_ANDAMAL_VERDATUM?: any | null;
  PERS_LAGLIG_GRUND_VERDATUM?: any | null;
  PERS_EJ_LAGLIG_GRUND_VERDATUM?: any | null;
  PERS_UTLAMNING_VERDATUM?: any | null;
  PERS_UTLAMNING_PLANERING_VERDATUM?: any | null;
  PERS_FRITEXTFALT_VERDATUM?: any | null;
  PERS_FRITEXTFALT_SYFTE_VERDATUM?: any | null;
  PERS_GALLRING_AUTOMATIK_VERDATUM?: any | null;
  PERS_GALLRING_MANUELLT_VERDATUM?: any | null;
  PERS_GALLRING_BESLUT_VERDATUM?: any | null;
  AKTIV?: boolean | null;
  _Associations?: TEDInputSYSPersonkategoriUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av räntetabell
 */
export interface TEDInputSYSRanteTabellAddAssociationValues {
  BasranteTabell_Ref?: string | null;
  BasranteTabell_Values?: TEDInputSYSRanteTabellAddValues | null;
  Rantesats_Add_Values?: TEDInputSYSRantesatsAddValues[] | null;
  RelativRanteTabell_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av räntetabell
 */
export interface TEDInputSYSRanteTabellAddValues {
  _typ: TEDSYSRanteTabellTypEnum;
  RANTETABELLKOD?: string | null;
  BENAMNING: string;
  ANVANDSFOR?: TEDSYSRanteTabellANVANDSFOREnum | null;
  _Associations?: TEDInputSYSRanteTabellAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av räntetabell
 */
export interface TEDInputSYSRanteTabellUpdateAssociationValues {
  BasranteTabell_Ref?: string | null;
  BasranteTabell_Values?: TEDInputSYSRanteTabellUpdateValues | null;
  Rantesats_Add_Values?: TEDInputSYSRantesatsAddValues[] | null;
  Rantesats_Update_Values?: TEDInputSYSRantesatsUpdateValues[] | null;
  Rantesats_Delete_Values?: TEDInputSYSRantesatsDeleteValues[] | null;
  RelativRanteTabell_Add_Refs?: string[] | null;
  RelativRanteTabell_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av räntetabell
 */
export interface TEDInputSYSRanteTabellUpdateValues {
  id: string;
  _version: number;
  RANTETABELLKOD?: string | null;
  BENAMNING?: string | null;
  ANVANDSFOR?: TEDSYSRanteTabellANVANDSFOREnum | null;
  _Associations?: TEDInputSYSRanteTabellUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av räntesats
 */
export interface TEDInputSYSRantesatsAddAssociationValues {
  Rantetabell_Ref?: string | null;
  Rantetabell_Values?: TEDInputSYSRanteTabellAddValues | null;
}

/**
 * Värden vid tillägg av räntesats
 */
export interface TEDInputSYSRantesatsAddValues {
  RANTESATS: number;
  _Associations?: TEDInputSYSRantesatsAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av räntesats
 */
export interface TEDInputSYSRantesatsDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av räntesats
 */
export interface TEDInputSYSRantesatsUpdateAssociationValues {
  Rantetabell_Ref?: string | null;
  Rantetabell_Values?: TEDInputSYSRanteTabellUpdateValues | null;
}

/**
 * Nya värden vid ändring av räntesats
 */
export interface TEDInputSYSRantesatsUpdateValues {
  id: string;
  _version: number;
  RANTESATS?: number | null;
  _Associations?: TEDInputSYSRantesatsUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av rapport
 */
export interface TEDInputSYSReportNewAddAssociationValues {
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalAddValues | null;
  Agare_Ref?: string | null;
  Agare_Values?: TEDInputSYSUserAddValues | null;
  UtskickBevakningar_Add_Values?: TEDInputSYSReportNewBevakningAddValues[] | null;
  Params_Add_Values?: TEDInputSYSReportNewParamAddValues[] | null;
}

/**
 * Värden vid tillägg av rapport
 */
export interface TEDInputSYSReportNewAddValues {
  _typ: TEDSYSReportNewTypEnum;
  PROGRAMVERSION?: number | null;
  REPORTVERSION?: number | null;
  SUBSYSTEMCODE?: string | null;
  COLLECTION_NAME?: string | null;
  REPORTNAME: string;
  DESCRIPTION?: string | null;
  REPORTDEFXML?: string | null;
  WORD_TEMPLATE?: string | null;
  VISIBILITY?: TEDSYSReportNewVISIBILITYEnum | null;
  USES_LAYOUT?: boolean | null;
  LAYOUT_OPTIONS?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  ShortCollectionName?: string | null;
  KONV_FROM_ID?: number | null;
  BlankettID?: number | null;
  PageHeaderOption?: TEDSYSReportNewPageHeaderOptionEnum | null;
  PageFooterOption?: TEDSYSReportNewPageFooterOptionEnum | null;
  DigitalSignering?: TEDSYSReportNewDigitalSigneringEnum | null;
  USAGE_CODE?: string | null;
  PdfJson?: string | null;
  XmlDefinition?: string | null;
  _Associations?: TEDInputSYSReportNewAddAssociationValues | null;
}

/**
 * Värden vid tillägg av bevakning
 */
export interface TEDInputSYSReportNewBevakningAddValues {
  REPORT_ID?: number | null;
  LOPNR?: number | null;
  DAGAR?: number | null;
  RUBRIK: string;
  TEXT?: string | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av bevakning
 */
export interface TEDInputSYSReportNewBevakningDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av bevakning
 */
export interface TEDInputSYSReportNewBevakningUpdateValues {
  id: string;
  _version: number;
  REPORT_ID?: number | null;
  LOPNR?: number | null;
  DAGAR?: number | null;
  RUBRIK?: string | null;
  TEXT?: string | null;
}

/**
 * Värden vid tillägg av parameter
 */
export interface TEDInputSYSReportNewParamAddValues {
  NAMN?: string | null;
  TYP: TEDSYSReportNewParamTYPEnum;
  KRAVS?: boolean | null;
  PROPOSE_VALUES?: string | null;
  CALLBACK?: string | null;
  Spara?: boolean | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av parameter
 */
export interface TEDInputSYSReportNewParamDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av parameter
 */
export interface TEDInputSYSReportNewParamUpdateValues {
  id: string;
  _version: number;
  NAMN?: string | null;
  TYP?: TEDSYSReportNewParamTYPEnum | null;
  KRAVS?: boolean | null;
  PROPOSE_VALUES?: string | null;
  CALLBACK?: string | null;
  Spara?: boolean | null;
}

/**
 * Associerade värden vid ändring av rapport
 */
export interface TEDInputSYSReportNewUpdateAssociationValues {
  Urval_Ref?: string | null;
  Urval_Values?: TEDInputSYSUrvalUpdateValues | null;
  Agare_Ref?: string | null;
  Agare_Values?: TEDInputSYSUserUpdateValues | null;
  UtskickBevakningar_Add_Values?: TEDInputSYSReportNewBevakningAddValues[] | null;
  UtskickBevakningar_Update_Values?: TEDInputSYSReportNewBevakningUpdateValues[] | null;
  UtskickBevakningar_Delete_Values?: TEDInputSYSReportNewBevakningDeleteValues[] | null;
  Params_Add_Values?: TEDInputSYSReportNewParamAddValues[] | null;
  Params_Update_Values?: TEDInputSYSReportNewParamUpdateValues[] | null;
  Params_Delete_Values?: TEDInputSYSReportNewParamDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av rapport
 */
export interface TEDInputSYSReportNewUpdateValues {
  id: string;
  _version: number;
  PROGRAMVERSION?: number | null;
  REPORTVERSION?: number | null;
  SUBSYSTEMCODE?: string | null;
  COLLECTION_NAME?: string | null;
  REPORTNAME?: string | null;
  DESCRIPTION?: string | null;
  REPORTDEFXML?: string | null;
  WORD_TEMPLATE?: string | null;
  VISIBILITY?: TEDSYSReportNewVISIBILITYEnum | null;
  USES_LAYOUT?: boolean | null;
  LAYOUT_OPTIONS?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  ShortCollectionName?: string | null;
  KONV_FROM_ID?: number | null;
  BlankettID?: number | null;
  PageHeaderOption?: TEDSYSReportNewPageHeaderOptionEnum | null;
  PageFooterOption?: TEDSYSReportNewPageFooterOptionEnum | null;
  DigitalSignering?: TEDSYSReportNewDigitalSigneringEnum | null;
  USAGE_CODE?: string | null;
  PdfJson?: string | null;
  XmlDefinition?: string | null;
  _Associations?: TEDInputSYSReportNewUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av roll
 */
export interface TEDInputSYSRollAddAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputSYSRollBlobAddValues | null;
  Rutinbehorighet_Add_Values?: TEDInputSYSRutinBehorighetAddValues[] | null;
  Losenordskrav_Add_Values?: TEDInputSYSLosenordskravAddValues[] | null;
  AnvandarRoller_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av roll
 */
export interface TEDInputSYSRollAddValues {
  BENAMNING: string;
  FORDEFINIERAD?: string | null;
  PWD_CONSTR_ID?: number | null;
  IDKOD?: string | null;
  IDKOD_AVENY?: string | null;
  STDROLL_SUBSYSTEMS?: string | null;
  _Associations?: TEDInputSYSRollAddAssociationValues | null;
}

/**
 * Värden vid tillägg av sYSRollBlob
 */
export interface TEDInputSYSRollBlobAddValues {
  NOTERING?: string | null;
}

/**
 * Nya värden vid ändring av sYSRollBlob
 */
export interface TEDInputSYSRollBlobUpdateValues {
  id: string;
  _version: number;
  NOTERING?: string | null;
}

/**
 * Associerade värden vid ändring av roll
 */
export interface TEDInputSYSRollUpdateAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputSYSRollBlobUpdateValues | null;
  Rutinbehorighet_Add_Values?: TEDInputSYSRutinBehorighetAddValues[] | null;
  Rutinbehorighet_Update_Values?: TEDInputSYSRutinBehorighetUpdateValues[] | null;
  Rutinbehorighet_Delete_Values?: TEDInputSYSRutinBehorighetDeleteValues[] | null;
  Losenordskrav_Add_Values?: TEDInputSYSLosenordskravAddValues[] | null;
  Losenordskrav_Update_Values?: TEDInputSYSLosenordskravUpdateValues[] | null;
  Losenordskrav_Delete_Values?: TEDInputSYSLosenordskravDeleteValues[] | null;
  AnvandarRoller_Add_Refs?: string[] | null;
  AnvandarRoller_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av roll
 */
export interface TEDInputSYSRollUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  FORDEFINIERAD?: string | null;
  PWD_CONSTR_ID?: number | null;
  IDKOD?: string | null;
  IDKOD_AVENY?: string | null;
  STDROLL_SUBSYSTEMS?: string | null;
  _Associations?: TEDInputSYSRollUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av rutin
 */
export interface TEDInputSYSRutinAddAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputSYSRutinBlobAddValues | null;
  Delsystem_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av rutin
 */
export interface TEDInputSYSRutinAddValues {
  DATAMODULE_TYPE?: string | null;
  CAPTION?: string | null;
  NAME?: string | null;
  PARENT_ROUTINE_ID?: number | null;
  SPARR_TYP?: TEDSYSRutinSPARR_TYPEnum | null;
  SPARR_FRAN_DATUM?: any | null;
  _Associations?: TEDInputSYSRutinAddAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av rutinbehörighet
 */
export interface TEDInputSYSRutinBehorighetAddAssociationValues {
  Rutin_Ref?: string | null;
  Rutin_Values?: TEDInputSYSRutinAddValues | null;
  Roll_Ref?: string | null;
  Roll_Values?: TEDInputSYSRollAddValues | null;
}

/**
 * Värden vid tillägg av rutinbehörighet
 */
export interface TEDInputSYSRutinBehorighetAddValues {
  SECURITY_LEVEL: TEDSYSRutinBehorighetSECURITY_LEVELEnum;
  _Associations: TEDInputSYSRutinBehorighetAddAssociationValues;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av rutinbehörighet
 */
export interface TEDInputSYSRutinBehorighetDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av rutinbehörighet
 */
export interface TEDInputSYSRutinBehorighetUpdateAssociationValues {
  Rutin_Ref?: string | null;
  Rutin_Values?: TEDInputSYSRutinUpdateValues | null;
  Roll_Ref?: string | null;
  Roll_Values?: TEDInputSYSRollUpdateValues | null;
}

/**
 * Nya värden vid ändring av rutinbehörighet
 */
export interface TEDInputSYSRutinBehorighetUpdateValues {
  id: string;
  _version: number;
  SECURITY_LEVEL?: TEDSYSRutinBehorighetSECURITY_LEVELEnum | null;
  _Associations?: TEDInputSYSRutinBehorighetUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av sYSRutinBlob
 */
export interface TEDInputSYSRutinBlobAddValues {
  HINT?: string | null;
}

/**
 * Nya värden vid ändring av sYSRutinBlob
 */
export interface TEDInputSYSRutinBlobUpdateValues {
  id: string;
  _version: number;
  HINT?: string | null;
}

/**
 * Associerade värden vid ändring av rutin
 */
export interface TEDInputSYSRutinUpdateAssociationValues {
  Blob_Ref?: string | null;
  Blob_Values?: TEDInputSYSRutinBlobUpdateValues | null;
  Delsystem_Add_Refs?: string[] | null;
  Delsystem_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av rutin
 */
export interface TEDInputSYSRutinUpdateValues {
  id: string;
  _version: number;
  DATAMODULE_TYPE?: string | null;
  CAPTION?: string | null;
  NAME?: string | null;
  PARENT_ROUTINE_ID?: number | null;
  SPARR_TYP?: TEDSYSRutinSPARR_TYPEnum | null;
  SPARR_FRAN_DATUM?: any | null;
  _Associations?: TEDInputSYSRutinUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av nummerserietyp
 */
export interface TEDInputSYSSerietypAddAssociationValues {
  Nummerserier_Add_Values?: TEDInputSYSNummerserieAddValues[] | null;
}

/**
 * Värden vid tillägg av nummerserietyp
 */
export interface TEDInputSYSSerietypAddValues {
  BENAMNING?: string | null;
  ARS_BASERAD: TEDSYSSerietypARS_BASERADEnum;
  GILTIG_I_DELSYSTEM?: string | null;
  SERIE_TABELL?: string | null;
  ANVAND_PREFIX: TEDSYSSerietypANVAND_PREFIXEnum;
  SORT?: string | null;
  _Associations?: TEDInputSYSSerietypAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av nummerserietyp
 */
export interface TEDInputSYSSerietypUpdateAssociationValues {
  Nummerserier_Add_Values?: TEDInputSYSNummerserieAddValues[] | null;
  Nummerserier_Update_Values?: TEDInputSYSNummerserieUpdateValues[] | null;
  Nummerserier_Delete_Values?: TEDInputSYSNummerserieDeleteValues[] | null;
  Nummerserier_Undelete?: TEDInputSYSNummerserieDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av nummerserietyp
 */
export interface TEDInputSYSSerietypUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  ARS_BASERAD?: TEDSYSSerietypARS_BASERADEnum | null;
  GILTIG_I_DELSYSTEM?: string | null;
  SERIE_TABELL?: string | null;
  ANVAND_PREFIX?: TEDSYSSerietypANVAND_PREFIXEnum | null;
  SORT?: string | null;
  _Associations?: TEDInputSYSSerietypUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av språk
 */
export interface TEDInputSYSSprakAddAssociationValues {
  AndraSprak_Ref?: string | null;
  AndraSprak_Values?: TEDInputSYSSprakAddValues | null;
  Land_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av språk
 */
export interface TEDInputSYSSprakAddValues {
  BENAMNING: string;
  SYSTEMSPRAK?: TEDSYSSprakSYSTEMSPRAKEnum | null;
  _Associations?: TEDInputSYSSprakAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av språk
 */
export interface TEDInputSYSSprakUpdateAssociationValues {
  AndraSprak_Ref?: string | null;
  AndraSprak_Values?: TEDInputSYSSprakUpdateValues | null;
  Land_Add_Refs?: string[] | null;
  Land_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av språk
 */
export interface TEDInputSYSSprakUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  SYSTEMSPRAK?: TEDSYSSprakSYSTEMSPRAKEnum | null;
  _Associations?: TEDInputSYSSprakUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av sYSStatistikinstallningar
 */
export interface TEDInputSYSStatistikinstallningarAddAssociationValues {
  Forsamling_Ref?: string | null;
  Forsamling_Values?: TEDInputOPOrgPersLokAddValues | null;
}

/**
 * Värden vid tillägg av sYSStatistikinstallningar
 */
export interface TEDInputSYSStatistikinstallningarAddValues {
  ENHETSID?: number | null;
  _Associations: TEDInputSYSStatistikinstallningarAddAssociationValues;
}

/**
 * Associerade värden vid ändring av sYSStatistikinstallningar
 */
export interface TEDInputSYSStatistikinstallningarUpdateAssociationValues {
  Forsamling_Ref?: string | null;
  Forsamling_Values?: TEDInputOPOrgPersLokUpdateValues | null;
}

/**
 * Nya värden vid ändring av sYSStatistikinstallningar
 */
export interface TEDInputSYSStatistikinstallningarUpdateValues {
  id: string;
  _version: number;
  ENHETSID?: number | null;
  _Associations?: TEDInputSYSStatistikinstallningarUpdateAssociationValues | null;
}

/**
 * Värden vid tillägg av personlig inställning
 */
export interface TEDInputSYSTEDSYSAnvandarInstallningarAddValues {
  ORDNINGS_NR?: number | null;
  VARDE_1?: string | null;
  VARDE_2?: string | null;
  VARDE_3?: string | null;
  VARDE_4?: string | null;
  VARDE_5?: string | null;
  INSTALLNING?: string | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av personlig inställning
 */
export interface TEDInputSYSTEDSYSAnvandarInstallningarDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av personlig inställning
 */
export interface TEDInputSYSTEDSYSAnvandarInstallningarUpdateValues {
  id: string;
  _version: number;
  ORDNINGS_NR?: number | null;
  VARDE_1?: string | null;
  VARDE_2?: string | null;
  VARDE_3?: string | null;
  VARDE_4?: string | null;
  VARDE_5?: string | null;
  INSTALLNING?: string | null;
}

/**
 * Associerade värden vid tillägg av titel
 */
export interface TEDInputSYSTitelAddAssociationValues {
  Kontakttitlar_Ref?: string | null;
  Kontakttitlar_Values?: TEDInputOPKontaktTitelAddValues | null;
}

/**
 * Värden vid tillägg av titel
 */
export interface TEDInputSYSTitelAddValues {
  BENAMNING: string;
  KR_SORT?: number | null;
  LR_SORT?: number | null;
  _Associations: TEDInputSYSTitelAddAssociationValues;
}

/**
 * Associerade värden vid ändring av titel
 */
export interface TEDInputSYSTitelUpdateAssociationValues {
  Kontakttitlar_Ref?: string | null;
  Kontakttitlar_Values?: TEDInputOPKontaktTitelUpdateValues | null;
}

/**
 * Nya värden vid ändring av titel
 */
export interface TEDInputSYSTitelUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  KR_SORT?: number | null;
  LR_SORT?: number | null;
  _Associations?: TEDInputSYSTitelUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av urval
 */
export interface TEDInputSYSUrvalAddAssociationValues {
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserAddValues | null;
  RapportpaketU_Add_Refs?: string[] | null;
  RapportpaketB_Add_Refs?: string[] | null;
  AnvandareB_Add_Refs?: string[] | null;
  Arbetstalle_Add_Refs?: string[] | null;
  Attestomrade_Add_Refs?: string[] | null;
  Attestratt_Add_Refs?: string[] | null;
  Attestant_Add_Refs?: string[] | null;
  Analys_Add_Refs?: string[] | null;
  EkonomiRapportRad_Add_Refs?: string[] | null;
  Anlaggningsgrupp_Add_Refs?: string[] | null;
  Rubrik_Add_Refs?: string[] | null;
  Gavogrupp_Add_Refs?: string[] | null;
  AnvKontobegr_Add_Refs?: string[] | null;
  Inventeringsansvariga_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av urval
 */
export interface TEDInputSYSUrvalAddValues {
  NAME?: string | null;
  VISIBILITY?: string | null;
  SECURITY_GROUP?: string | null;
  SUBSYSTEMCODE?: string | null;
  COLLECTION_NAME?: string | null;
  DESCRIPTION_EXISTS?: string | null;
  PREDEF_SQL_EXISTS?: string | null;
  PREDEF_SQL_PARAMS_EXISTS?: string | null;
  USAGE_CODE: TEDSYSUrvalUSAGE_CODEEnum;
  PUBLISHED_TO?: number | null;
  ROUTINE_ID?: number | null;
  KPLAN_ID?: number | null;
  KPLAN_KONV?: boolean | null;
  KPLAN_KONV_SELECTION_ID?: number | null;
  PARAMS?: string | null;
  KODBEH_ANVANDS_FOR?: TEDSYSUrvalKODBEH_ANVANDS_FOREnum | null;
  IDKOD?: string | null;
  _Associations?: TEDInputSYSUrvalAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av urval
 */
export interface TEDInputSYSUrvalUpdateAssociationValues {
  Anvandare_Ref?: string | null;
  Anvandare_Values?: TEDInputSYSUserUpdateValues | null;
  RapportpaketU_Add_Refs?: string[] | null;
  RapportpaketU_Delete_Refs?: string[] | null;
  RapportpaketB_Add_Refs?: string[] | null;
  RapportpaketB_Delete_Refs?: string[] | null;
  AnvandareB_Add_Refs?: string[] | null;
  AnvandareB_Delete_Refs?: string[] | null;
  Arbetstalle_Add_Refs?: string[] | null;
  Arbetstalle_Delete_Refs?: string[] | null;
  Attestomrade_Add_Refs?: string[] | null;
  Attestomrade_Delete_Refs?: string[] | null;
  Attestratt_Add_Refs?: string[] | null;
  Attestratt_Delete_Refs?: string[] | null;
  Attestant_Add_Refs?: string[] | null;
  Attestant_Delete_Refs?: string[] | null;
  Analys_Add_Refs?: string[] | null;
  Analys_Delete_Refs?: string[] | null;
  EkonomiRapportRad_Add_Refs?: string[] | null;
  EkonomiRapportRad_Delete_Refs?: string[] | null;
  Anlaggningsgrupp_Add_Refs?: string[] | null;
  Anlaggningsgrupp_Delete_Refs?: string[] | null;
  Rubrik_Add_Refs?: string[] | null;
  Rubrik_Delete_Refs?: string[] | null;
  Gavogrupp_Add_Refs?: string[] | null;
  Gavogrupp_Delete_Refs?: string[] | null;
  AnvKontobegr_Add_Refs?: string[] | null;
  AnvKontobegr_Delete_Refs?: string[] | null;
  Inventeringsansvariga_Add_Refs?: string[] | null;
  Inventeringsansvariga_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av urval
 */
export interface TEDInputSYSUrvalUpdateValues {
  id: string;
  _version: number;
  NAME?: string | null;
  VISIBILITY?: string | null;
  SECURITY_GROUP?: string | null;
  SUBSYSTEMCODE?: string | null;
  COLLECTION_NAME?: string | null;
  DESCRIPTION_EXISTS?: string | null;
  PREDEF_SQL_EXISTS?: string | null;
  PREDEF_SQL_PARAMS_EXISTS?: string | null;
  USAGE_CODE?: TEDSYSUrvalUSAGE_CODEEnum | null;
  PUBLISHED_TO?: number | null;
  ROUTINE_ID?: number | null;
  KPLAN_ID?: number | null;
  KPLAN_KONV?: boolean | null;
  KPLAN_KONV_SELECTION_ID?: number | null;
  PARAMS?: string | null;
  KODBEH_ANVANDS_FOR?: TEDSYSUrvalKODBEH_ANVANDS_FOREnum | null;
  IDKOD?: string | null;
  _Associations?: TEDInputSYSUrvalUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av användare
 */
export interface TEDInputSYSUserAddAssociationValues {
  Arbetsstalle_Ref?: string | null;
  Arbetsstalle_Values?: TEDInputSYSArbetsstalleAddValues | null;
  DelarPlatsMed_Ref?: string | null;
  DelarPlatsMed_Values?: TEDInputSYSUserAddValues | null;
  OrgPers_Ref?: string | null;
  OrgPers_Values?: TEDInputOPOrgPersLokAddValues | null;
  Installningar_Add_Values?: TEDInputSYSTEDSYSAnvandarInstallningarAddValues[] | null;
  Roller_Add_Values?: TEDInputSYSAnvandarRollAddValues[] | null;
  Ekonomirapporter_Add_Values?: TEDInputEKTEDEKUtdeladRapportAnvAddValues[] | null;
  Kontobehorighet_Add_Values?: TEDInputEKAnvKontourvalAddValues[] | null;
  Delsystemansvar_Add_Values?: TEDInputSYSDelsystemansvarAddValues[] | null;
  Anvandarlicens_Add_Values?: TEDInputSYSUserLicenseAddValues[] | null;
  Bevakning_Add_Refs?: string[] | null;
  Losenordshistorik_Add_Values?: TEDInputSYSLosenordshistorikAddValues[] | null;
  Attestant_Add_Refs?: string[] | null;
  Mallusers_Add_Refs?: string[] | null;
  Kontobegransningar_Add_Values?: TEDInputEKAnvKontobegrAddValues[] | null;
  Grupptyper_Add_Values?: TEDInputSYSMalluserGrupptypAddValues[] | null;
  AnvViewRapport_Add_Refs?: string[] | null;
  Inventeringsansvariga_Add_Values?: TEDInputARInvAnsvarigaAddValues[] | null;
  Franvaro_Add_Values?: TEDInputSYSFranvaroAddValues[] | null;
}

/**
 * Värden vid tillägg av användare
 */
export interface TEDInputSYSUserAddValues {
  SIGNATURE?: string | null;
  FIRSTNAME?: string | null;
  LASTNAME?: string | null;
  PWD?: string | null;
  PHONE?: string | null;
  LOCATION?: string | null;
  EMAIL?: string | null;
  SYSADM?: TEDSYSUserSYSADMEnum | null;
  DB_SIGNATURE?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  KONTOBEGR_ENL_STALLE?: TEDSYSUserKONTOBEGR_ENL_STALLEEnum | null;
  SERVER?: string | null;
  SMTP_USER?: string | null;
  SMTP_PASS?: string | null;
  USEAUTH?: string | null;
  RESBEH_VIEW_ID?: number | null;
  PWD_METHOD?: number | null;
  PWD_SET_DATE?: any | null;
  PWD_FORCE_CHANGE?: TEDSYSUserPWD_FORCE_CHANGEEnum | null;
  PWD_CONSTRLEVEL_CHECK?: TEDSYSUserPWD_CONSTRLEVEL_CHECKEnum | null;
  STATISTIKRAPPORTERING?: boolean | null;
  MALLANVANDARE?: boolean | null;
  RESBEH_SEL_ID?: number | null;
  MALLANV_STYRN_INST_1?: TEDSYSUserMALLANV_STYRN_INST_1Enum | null;
  MALLANV_STYRN_INST_2?: TEDSYSUserMALLANV_STYRN_INST_2Enum | null;
  MALLANV_STYRN_INST_3?: TEDSYSUserMALLANV_STYRN_INST_3Enum | null;
  MALLANV_STYRN_INST_4?: TEDSYSUserMALLANV_STYRN_INST_4Enum | null;
  MALLANV_STYRN_INST_5?: TEDSYSUserMALLANV_STYRN_INST_5Enum | null;
  MALLANV_STYRN_INST_6?: TEDSYSUserMALLANV_STYRN_INST_6Enum | null;
  MALLANV_STYRN_INST_7?: TEDSYSUserMALLANV_STYRN_INST_7Enum | null;
  MALLANV_STYRN_INST_8?: TEDSYSUserMALLANV_STYRN_INST_8Enum | null;
  MALLANV_STYRN_INST_9?: TEDSYSUserMALLANV_STYRN_INST_9Enum | null;
  MAPP_GBS_SIGN?: string | null;
  PREV_AVENY_SIGN?: string | null;
  RESTJA_VIEW_ID?: number | null;
  BEGRAVNINGSBESTALLNINGAR?: boolean | null;
  TRANSPORTOR?: boolean | null;
  UTB_RUBRIK?: string | null;
  UTB_BESKRIVNING?: string | null;
  UTB_RUBRIK_GAS?: string | null;
  UTB_BESKRIVNING_GAS?: string | null;
  KORT_NR?: string | null;
  BO_BOKNBEST_BEH?: string | null;
  WEBBO_INFO?: boolean | null;
  WEBBO_ANDRA_AKT?: boolean | null;
  BESTALLARE_BOKFORDER?: boolean | null;
  BESTALLARE_UTANORDNING?: boolean | null;
  ID_TYPE: TEDSYSUserID_TYPEEnum;
  AVENYID?: string | null;
  LOKAL_SIGNATURE?: string | null;
  GBS_SIGNATURE?: string | null;
  NOTIFIERA_LEVERANTORSATTEST?: boolean | null;
  _Associations?: TEDInputSYSUserAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av användare
 */
export interface TEDInputSYSUserDeleteValues {
  id: string;
  _version: number;
}

/**
 * Värden vid tillägg av användarlicens
 */
export interface TEDInputSYSUserLicenseAddValues {
  LICENSTYP: TEDSYSUserLicenseLICENSTYPEnum;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av användarlicens
 */
export interface TEDInputSYSUserLicenseDeleteValues {
  id: string;
  _version: number;
}

/**
 * Nya värden vid ändring av användarlicens
 */
export interface TEDInputSYSUserLicenseUpdateValues {
  id: string;
  _version: number;
  LICENSTYP?: TEDSYSUserLicenseLICENSTYPEnum | null;
}

/**
 * Associerade värden vid ändring av användare
 */
export interface TEDInputSYSUserUpdateAssociationValues {
  Arbetsstalle_Ref?: string | null;
  Arbetsstalle_Values?: TEDInputSYSArbetsstalleUpdateValues | null;
  DelarPlatsMed_Ref?: string | null;
  DelarPlatsMed_Values?: TEDInputSYSUserUpdateValues | null;
  OrgPers_Ref?: string | null;
  OrgPers_Values?: TEDInputOPOrgPersLokUpdateValues | null;
  Installningar_Add_Values?: TEDInputSYSTEDSYSAnvandarInstallningarAddValues[] | null;
  Installningar_Update_Values?: TEDInputSYSTEDSYSAnvandarInstallningarUpdateValues[] | null;
  Installningar_Delete_Values?: TEDInputSYSTEDSYSAnvandarInstallningarDeleteValues[] | null;
  Roller_Add_Values?: TEDInputSYSAnvandarRollAddValues[] | null;
  Roller_Update_Values?: TEDInputSYSAnvandarRollUpdateValues[] | null;
  Roller_Delete_Values?: TEDInputSYSAnvandarRollDeleteValues[] | null;
  Ekonomirapporter_Add_Values?: TEDInputEKTEDEKUtdeladRapportAnvAddValues[] | null;
  Ekonomirapporter_Update_Values?: TEDInputEKTEDEKUtdeladRapportAnvUpdateValues[] | null;
  Ekonomirapporter_Delete_Values?: TEDInputEKTEDEKUtdeladRapportAnvDeleteValues[] | null;
  Kontobehorighet_Add_Values?: TEDInputEKAnvKontourvalAddValues[] | null;
  Kontobehorighet_Update_Values?: TEDInputEKAnvKontourvalUpdateValues[] | null;
  Kontobehorighet_Delete_Values?: TEDInputEKAnvKontourvalDeleteValues[] | null;
  Delsystemansvar_Add_Values?: TEDInputSYSDelsystemansvarAddValues[] | null;
  Delsystemansvar_Update_Values?: TEDInputSYSDelsystemansvarUpdateValues[] | null;
  Delsystemansvar_Delete_Values?: TEDInputSYSDelsystemansvarDeleteValues[] | null;
  Anvandarlicens_Add_Values?: TEDInputSYSUserLicenseAddValues[] | null;
  Anvandarlicens_Update_Values?: TEDInputSYSUserLicenseUpdateValues[] | null;
  Anvandarlicens_Delete_Values?: TEDInputSYSUserLicenseDeleteValues[] | null;
  Bevakning_Add_Refs?: string[] | null;
  Bevakning_Delete_Refs?: string[] | null;
  Losenordshistorik_Add_Values?: TEDInputSYSLosenordshistorikAddValues[] | null;
  Losenordshistorik_Update_Values?: TEDInputSYSLosenordshistorikUpdateValues[] | null;
  Losenordshistorik_Delete_Values?: TEDInputSYSLosenordshistorikDeleteValues[] | null;
  Attestant_Add_Refs?: string[] | null;
  Attestant_Delete_Refs?: string[] | null;
  Mallusers_Add_Refs?: string[] | null;
  Mallusers_Delete_Refs?: string[] | null;
  Kontobegransningar_Add_Values?: TEDInputEKAnvKontobegrAddValues[] | null;
  Kontobegransningar_Update_Values?: TEDInputEKAnvKontobegrUpdateValues[] | null;
  Kontobegransningar_Delete_Values?: TEDInputEKAnvKontobegrDeleteValues[] | null;
  Grupptyper_Add_Values?: TEDInputSYSMalluserGrupptypAddValues[] | null;
  Grupptyper_Update_Values?: TEDInputSYSMalluserGrupptypUpdateValues[] | null;
  Grupptyper_Delete_Values?: TEDInputSYSMalluserGrupptypDeleteValues[] | null;
  AnvViewRapport_Add_Refs?: string[] | null;
  AnvViewRapport_Delete_Refs?: string[] | null;
  Inventeringsansvariga_Add_Values?: TEDInputARInvAnsvarigaAddValues[] | null;
  Inventeringsansvariga_Update_Values?: TEDInputARInvAnsvarigaUpdateValues[] | null;
  Inventeringsansvariga_Delete_Values?: TEDInputARInvAnsvarigaDeleteValues[] | null;
  Franvaro_Add_Values?: TEDInputSYSFranvaroAddValues[] | null;
  Franvaro_Update_Values?: TEDInputSYSFranvaroUpdateValues[] | null;
  Franvaro_Delete_Values?: TEDInputSYSFranvaroDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av användare
 */
export interface TEDInputSYSUserUpdateValues {
  id: string;
  _version: number;
  SIGNATURE?: string | null;
  FIRSTNAME?: string | null;
  LASTNAME?: string | null;
  PWD?: string | null;
  PHONE?: string | null;
  LOCATION?: string | null;
  EMAIL?: string | null;
  SYSADM?: TEDSYSUserSYSADMEnum | null;
  DB_SIGNATURE?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  KONTOBEGR_ENL_STALLE?: TEDSYSUserKONTOBEGR_ENL_STALLEEnum | null;
  SERVER?: string | null;
  SMTP_USER?: string | null;
  SMTP_PASS?: string | null;
  USEAUTH?: string | null;
  RESBEH_VIEW_ID?: number | null;
  PWD_METHOD?: number | null;
  PWD_SET_DATE?: any | null;
  PWD_FORCE_CHANGE?: TEDSYSUserPWD_FORCE_CHANGEEnum | null;
  PWD_CONSTRLEVEL_CHECK?: TEDSYSUserPWD_CONSTRLEVEL_CHECKEnum | null;
  STATISTIKRAPPORTERING?: boolean | null;
  MALLANVANDARE?: boolean | null;
  RESBEH_SEL_ID?: number | null;
  MALLANV_STYRN_INST_1?: TEDSYSUserMALLANV_STYRN_INST_1Enum | null;
  MALLANV_STYRN_INST_2?: TEDSYSUserMALLANV_STYRN_INST_2Enum | null;
  MALLANV_STYRN_INST_3?: TEDSYSUserMALLANV_STYRN_INST_3Enum | null;
  MALLANV_STYRN_INST_4?: TEDSYSUserMALLANV_STYRN_INST_4Enum | null;
  MALLANV_STYRN_INST_5?: TEDSYSUserMALLANV_STYRN_INST_5Enum | null;
  MALLANV_STYRN_INST_6?: TEDSYSUserMALLANV_STYRN_INST_6Enum | null;
  MALLANV_STYRN_INST_7?: TEDSYSUserMALLANV_STYRN_INST_7Enum | null;
  MALLANV_STYRN_INST_8?: TEDSYSUserMALLANV_STYRN_INST_8Enum | null;
  MALLANV_STYRN_INST_9?: TEDSYSUserMALLANV_STYRN_INST_9Enum | null;
  MAPP_GBS_SIGN?: string | null;
  PREV_AVENY_SIGN?: string | null;
  RESTJA_VIEW_ID?: number | null;
  BEGRAVNINGSBESTALLNINGAR?: boolean | null;
  TRANSPORTOR?: boolean | null;
  UTB_RUBRIK?: string | null;
  UTB_BESKRIVNING?: string | null;
  UTB_RUBRIK_GAS?: string | null;
  UTB_BESKRIVNING_GAS?: string | null;
  KORT_NR?: string | null;
  BO_BOKNBEST_BEH?: string | null;
  WEBBO_INFO?: boolean | null;
  WEBBO_ANDRA_AKT?: boolean | null;
  BESTALLARE_BOKFORDER?: boolean | null;
  BESTALLARE_UTANORDNING?: boolean | null;
  ID_TYPE?: TEDSYSUserID_TYPEEnum | null;
  AVENYID?: string | null;
  LOKAL_SIGNATURE?: string | null;
  GBS_SIGNATURE?: string | null;
  NOTIFIERA_LEVERANTORSATTEST?: boolean | null;
  _Associations?: TEDInputSYSUserUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av utbetalningssätt
 */
export interface TEDInputSYSUtbetalningssattAddAssociationValues {
  Utbetalningsvag_Ref?: string | null;
  Utbetalningsvag_Values?: TEDInputSYSUtbetalningsvagAddValues | null;
  Likvidkonto_Ref?: string | null;
  Likvidkonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Betalningsvillkor_Ref?: string | null;
  Betalningsvillkor_Values?: TEDInputSYSBetalningsvillkorAddValues | null;
}

/**
 * Värden vid tillägg av utbetalningssätt
 */
export interface TEDInputSYSUtbetalningssattAddValues {
  BETSATTKOD: string;
  BENAMNING?: string | null;
  BETSATT: TEDSYSUtbetalningssattBETSATTEnum;
  KONTONR?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  REG_PA_LEV?: TEDSYSUtbetalningssattREG_PA_LEVEnum | null;
  _Associations?: TEDInputSYSUtbetalningssattAddAssociationValues | null;
}

/**
 * ID och versionssiffra vid borttag och ångra borttag av utbetalningssätt
 */
export interface TEDInputSYSUtbetalningssattDeleteValues {
  id: string;
  _version: number;
}

/**
 * Associerade värden vid ändring av utbetalningssätt
 */
export interface TEDInputSYSUtbetalningssattUpdateAssociationValues {
  Utbetalningsvag_Ref?: string | null;
  Utbetalningsvag_Values?: TEDInputSYSUtbetalningsvagUpdateValues | null;
  Likvidkonto_Ref?: string | null;
  Likvidkonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Betalningsvillkor_Ref?: string | null;
  Betalningsvillkor_Values?: TEDInputSYSBetalningsvillkorUpdateValues | null;
}

/**
 * Nya värden vid ändring av utbetalningssätt
 */
export interface TEDInputSYSUtbetalningssattUpdateValues {
  id: string;
  _version: number;
  BETSATTKOD?: string | null;
  BENAMNING?: string | null;
  BETSATT?: TEDSYSUtbetalningssattBETSATTEnum | null;
  KONTONR?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_DATUM?: any | null;
  BORTTAGEN_SIGNATUR?: string | null;
  REG_PA_LEV?: TEDSYSUtbetalningssattREG_PA_LEVEnum | null;
  _Associations?: TEDInputSYSUtbetalningssattUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av utbetalningsväg
 */
export interface TEDInputSYSUtbetalningsvagAddAssociationValues {
  Utbetalningssatt_Add_Values?: TEDInputSYSUtbetalningssattAddValues[] | null;
}

/**
 * Värden vid tillägg av utbetalningsväg
 */
export interface TEDInputSYSUtbetalningsvagAddValues {
  BENAMNING: string;
  MEDIATYP: TEDSYSUtbetalningsvagMEDIATYPEnum;
  KUNDNR?: string | null;
  PG_AVSANDARBETECKNING_1?: string | null;
  PG_AVSANDARBETECKNING_2?: string | null;
  BETALNING_AV_FAKTURA?: TEDSYSUtbetalningsvagBETALNING_AV_FAKTURAEnum | null;
  ANV_VALUTAFICKA?: TEDSYSUtbetalningsvagANV_VALUTAFICKAEnum | null;
  SAME_DAY_EXECUTION?: TEDSYSUtbetalningsvagSAME_DAY_EXECUTIONEnum | null;
  PG_AVSANDARBETECKNING_3?: string | null;
  PG_ORGNR?: string | null;
  BG_BANK?: TEDSYSUtbetalningsvagBG_BANKEnum | null;
  BG_AVS_NAMN?: string | null;
  BG_AVS_ADRESS?: string | null;
  NORMALUTBVAG?: string | null;
  BETALNING_KATALOG?: string | null;
  KVITTENS_KATALOG?: string | null;
  BETALNING_FRAN_KOB_KATALOG?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  ATERREDOVISNING_KATALOG?: string | null;
  BOKF_GRUPP_ID?: number | null;
  AKTIV?: boolean | null;
  ATERRED?: boolean | null;
  IDKOD?: string | null;
  TECKENKODNING?: TEDSYSUtbetalningsvagTECKENKODNINGEnum | null;
  KONTONR?: string | null;
  BIS_BANK?: TEDSYSUtbetalningsvagBIS_BANKEnum | null;
  BIS_AVTALSNR?: string | null;
  BIS_BBAN?: string | null;
  BIS_SIGNER_ID?: string | null;
  _Associations?: TEDInputSYSUtbetalningsvagAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av utbetalningsväg
 */
export interface TEDInputSYSUtbetalningsvagUpdateAssociationValues {
  Utbetalningssatt_Add_Values?: TEDInputSYSUtbetalningssattAddValues[] | null;
  Utbetalningssatt_Update_Values?: TEDInputSYSUtbetalningssattUpdateValues[] | null;
  Utbetalningssatt_Delete_Values?: TEDInputSYSUtbetalningssattDeleteValues[] | null;
  Utbetalningssatt_Undelete?: TEDInputSYSUtbetalningssattDeleteValues[] | null;
}

/**
 * Nya värden vid ändring av utbetalningsväg
 */
export interface TEDInputSYSUtbetalningsvagUpdateValues {
  id: string;
  _version: number;
  BENAMNING?: string | null;
  MEDIATYP?: TEDSYSUtbetalningsvagMEDIATYPEnum | null;
  KUNDNR?: string | null;
  PG_AVSANDARBETECKNING_1?: string | null;
  PG_AVSANDARBETECKNING_2?: string | null;
  BETALNING_AV_FAKTURA?: TEDSYSUtbetalningsvagBETALNING_AV_FAKTURAEnum | null;
  ANV_VALUTAFICKA?: TEDSYSUtbetalningsvagANV_VALUTAFICKAEnum | null;
  SAME_DAY_EXECUTION?: TEDSYSUtbetalningsvagSAME_DAY_EXECUTIONEnum | null;
  PG_AVSANDARBETECKNING_3?: string | null;
  PG_ORGNR?: string | null;
  BG_BANK?: TEDSYSUtbetalningsvagBG_BANKEnum | null;
  BG_AVS_NAMN?: string | null;
  BG_AVS_ADRESS?: string | null;
  NORMALUTBVAG?: string | null;
  BETALNING_KATALOG?: string | null;
  KVITTENS_KATALOG?: string | null;
  BETALNING_FRAN_KOB_KATALOG?: string | null;
  BORTTAGEN?: boolean | null;
  BORTTAGEN_SIGNATUR?: string | null;
  BORTTAGEN_DATUM?: any | null;
  ATERREDOVISNING_KATALOG?: string | null;
  BOKF_GRUPP_ID?: number | null;
  AKTIV?: boolean | null;
  ATERRED?: boolean | null;
  IDKOD?: string | null;
  TECKENKODNING?: TEDSYSUtbetalningsvagTECKENKODNINGEnum | null;
  KONTONR?: string | null;
  BIS_BANK?: TEDSYSUtbetalningsvagBIS_BANKEnum | null;
  BIS_AVTALSNR?: string | null;
  BIS_BBAN?: string | null;
  BIS_SIGNER_ID?: string | null;
  _Associations?: TEDInputSYSUtbetalningsvagUpdateAssociationValues | null;
}

/**
 * Associerade värden vid tillägg av valuta
 */
export interface TEDInputSYSValutaAddAssociationValues {
  ValutaDiffKonto_Ref?: string | null;
  ValutaDiffKonto_Values?: TEDInputEKKonteringsvardeAddValues | null;
  Kurs_Add_Values?: TEDInputSYSKursAddValues[] | null;
  Land_Add_Refs?: string[] | null;
  Leverantor_Add_Refs?: string[] | null;
}

/**
 * Värden vid tillägg av valuta
 */
export interface TEDInputSYSValutaAddValues {
  VALUTAKOD?: string | null;
  BENAMNING?: string | null;
  FASTKURS?: TEDSYSValutaFASTKURSEnum | null;
  KURSFAKTOR: number;
  SENAST_HAMTADE_KURSDATUM?: any | null;
  _Associations?: TEDInputSYSValutaAddAssociationValues | null;
}

/**
 * Associerade värden vid ändring av valuta
 */
export interface TEDInputSYSValutaUpdateAssociationValues {
  ValutaDiffKonto_Ref?: string | null;
  ValutaDiffKonto_Values?: TEDInputEKKonteringsvardeUpdateValues | null;
  Kurs_Add_Values?: TEDInputSYSKursAddValues[] | null;
  Kurs_Update_Values?: TEDInputSYSKursUpdateValues[] | null;
  Kurs_Delete_Values?: TEDInputSYSKursDeleteValues[] | null;
  Land_Add_Refs?: string[] | null;
  Land_Delete_Refs?: string[] | null;
  Leverantor_Add_Refs?: string[] | null;
  Leverantor_Delete_Refs?: string[] | null;
}

/**
 * Nya värden vid ändring av valuta
 */
export interface TEDInputSYSValutaUpdateValues {
  id: string;
  _version: number;
  VALUTAKOD?: string | null;
  BENAMNING?: string | null;
  FASTKURS?: TEDSYSValutaFASTKURSEnum | null;
  KURSFAKTOR?: number | null;
  SENAST_HAMTADE_KURSDATUM?: any | null;
  _Associations?: TEDInputSYSValutaUpdateAssociationValues | null;
}

/**
 * Avenyurval, definition
 */
export interface TEDInputSelection {
  namn: string;
  beskrivning?: string | null;
  rutinID?: number | null;
  kontoplanID?: string | null;
  usagecode?: string | null;
  collection: string;
  synlighet: TEDSelectionVisibility;
  synligAnvID?: string | null;
  synligGruppID?: string | null;
}

/**
 * Avenyurval, ja/nej-villkor
 */
export interface TEDInputSelectionBooleanCondition {
  no?: boolean | null;
  yes?: boolean | null;
}

/**
 * Avenyurval, villkor
 */
export interface TEDInputSelectionCondition {
  namn: string;
  ass?: string[] | null;
  typ: TEDSelectionConditionType;
  valueCondition?: TEDInputSelectionValueCondition | null;
  enumCondition?: TEDInputSelectionEnumCondition | null;
  booleanCondition?: TEDInputSelectionBooleanCondition | null;
  filterCondition?: TEDInputSelectionFilterCondition | null;
  extendedCondition?: TEDInputSelectionExtendedCondition | null;
}

/**
 * Avenyurval, flervalsvillkor
 */
export interface TEDInputSelectionEnumCondition {
  selected?: (string | null)[] | null;
}

/**
 * Avenyurval, utökat urval
 */
export interface TEDInputSelectionExtendedCondition {
  extop: TEDSelectionExtendedOperator;
  extconditions?: (TEDInputSelectionCondition[] | null)[] | null;
}

/**
 * Avenyurval, filter-villkor
 */
export interface TEDInputSelectionFilterCondition {
  active?: boolean | null;
}

/**
 * Avenyurval, sorteringsordning
 */
export interface TEDInputSelectionSortOrder {
  namn: string;
  ass?: string[] | null;
  desc?: boolean | null;
}

/**
 * Avenyurval, värdepar (intervall) för värde-villkor
 */
export interface TEDInputSelectionValue {
  value?: string | null;
  tovalue?: string | null;
}

/**
 * Avenyurval, värde-villkor
 */
export interface TEDInputSelectionValueCondition {
  op: TEDSelectionOperator;
  value?: TEDInputSelectionValue[] | null;
}

/**
 * En inställning i form av ett namn-värde-par
 */
export interface TEDInputSettingsWriteIdent {
  name?: string | null;
  asString?: string | null;
  asInt?: number | null;
  asBoolean?: boolean | null;
  asFloat?: number | null;
}

/**
 * En lista av inställningar i form av namn-värde-par
 */
export interface TEDInputSettingsWriteSection {
  name?: string | null;
  values?: TEDInputSettingsWriteIdent[] | null;
  clearsection?: boolean | null;
}

/**
 * Värden vid tillägg av händelse
 */
export interface TEDInputSysHandelseAddValues {
  ID?: number | null;
  DATUM?: any | null;
  SIGNATUR?: string | null;
  RUBRIK?: string | null;
  TEXT?: string | null;
  DATA?: string | null;
  DATA_NAMN?: string | null;
}

/**
 * Nya värden vid ändring av händelse
 */
export interface TEDInputSysHandelseUpdateValues {
  id: string;
  _version: number;
  ID?: number | null;
  DATUM?: any | null;
  SIGNATUR?: string | null;
  RUBRIK?: string | null;
  TEXT?: string | null;
  DATA?: string | null;
  DATA_NAMN?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
